(() => {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired295"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired295"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fjcCE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f1556ec7809d28dc$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $airo4 = parcelRequire("airo4");

var $6oXY4 = parcelRequire("6oXY4");

var $jYaiU = parcelRequire("jYaiU");

var $c2Sd1 = parcelRequire("c2Sd1");

var $hVbZl = parcelRequire("hVbZl");

var $7O2xm = parcelRequire("7O2xm");

var $gIe6R = parcelRequire("gIe6R");

var $gqFxE = parcelRequire("gqFxE");

var $huSKp = parcelRequire("huSKp");
var $f1556ec7809d28dc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "App",
    setup (__props, { expose: __expose }) {
        __expose();
        const categoryStore = (0, $7O2xm.useCategoryStore)();
        const { name: name } = (0, $gqFxE.storeToRefs)(categoryStore);
        const { description: description } = categoryStore;
        const { isMapOpen: isMapOpen } = (0, $gqFxE.storeToRefs)((0, $gIe6R.useMapStore)());
        const { total: total } = (0, $gqFxE.storeToRefs)((0, $huSKp.useProductStore)());
        const __returned__ = {
            categoryStore: categoryStore,
            name: name,
            description: description,
            isMapOpen: isMapOpen,
            total: total,
            get Products () {
                return 0, $airo4.default;
            },
            Search: $6oXY4.default,
            get Pagination () {
                return 0, $jYaiU.default;
            },
            get MobMapBtn () {
                return 0, $c2Sd1.default;
            },
            GoogleMap: $hVbZl.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("ey4ci", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("ani5R")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("ani5R")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("ani5R")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("ani5R")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("ani5R")).createElementVNode);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("ani5R")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("ani5R")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("ani5R")).createVNode);
$parcel$export(module.exports, "customRef", () => (parcelRequire("8bTPG")).customRef);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("ani5R")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("ani5R")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("ani5R")).getCurrentInstance);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("8bTPG")).getCurrentScope);
$parcel$export(module.exports, "h", () => (parcelRequire("ani5R")).h);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("ani5R")).hasInjectionContext);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("ani5R")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("ani5R")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("8bTPG")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("8bTPG")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("8bTPG")).markRaw);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("ani5R")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("X5A94")).normalizeClass);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("ani5R")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("ani5R")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("ani5R")).onBeforeUpdate);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("ani5R")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("ani5R")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("ani5R")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("ani5R")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("ani5R")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("8bTPG")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("ani5R")).renderList);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("8bTPG")).shallowReactive);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("8bTPG")).toRaw);
$parcel$export(module.exports, "version", () => (parcelRequire("ani5R")).version);
$parcel$export(module.exports, "watch", () => (parcelRequire("ani5R")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("ani5R")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("ani5R")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("ani5R")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("dDLnc")).createApp);
$parcel$export(module.exports, "Transition", () => (parcelRequire("dDLnc")).Transition);
$parcel$export(module.exports, "TransitionGroup", () => (parcelRequire("dDLnc")).TransitionGroup);
$parcel$export(module.exports, "vModelSelect", () => (parcelRequire("dDLnc")).vModelSelect);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("dDLnc")).vModelText);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("8bTPG")).effectScope);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("8bTPG")).isReadonly);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("8bTPG")).onScopeDispose);
$parcel$export(module.exports, "readonly", () => (parcelRequire("8bTPG")).readonly);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("8bTPG")).shallowRef);
$parcel$export(module.exports, "toRef", () => (parcelRequire("8bTPG")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("8bTPG")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("8bTPG")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("X5A94")).toDisplayString);
/**
* vue v3.4.23
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $ani5R = parcelRequire("ani5R");parcelRequire("dDLnc");parcelRequire("8bTPG");parcelRequire("X5A94");
function $a9777f2bcb9d7de1$var$initDev() {
    (0, $ani5R.initCustomFormatter)();
}
const $a9777f2bcb9d7de1$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("ani5R", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $78da16583ad93b9f$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $78da16583ad93b9f$export$bdd553fddd433dcb);
$parcel$export(module.exports, "Fragment", () => $78da16583ad93b9f$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $78da16583ad93b9f$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $78da16583ad93b9f$export$694b237e827a3d23);
$parcel$export(module.exports, "createVNode", () => $78da16583ad93b9f$export$bf5c4cf060303d58);
$parcel$export(module.exports, "openBlock", () => $78da16583ad93b9f$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "inject", () => $78da16583ad93b9f$export$a976684a0efeb93f);
$parcel$export(module.exports, "watchEffect", () => $78da16583ad93b9f$export$ede35fc0e5500309);
$parcel$export(module.exports, "watchPostEffect", () => $78da16583ad93b9f$export$b7f27ea67102d543);
$parcel$export(module.exports, "watch", () => $78da16583ad93b9f$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "withDirectives", () => $78da16583ad93b9f$export$49729353e7c1e6c5);
$parcel$export(module.exports, "useTransitionState", () => $78da16583ad93b9f$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $78da16583ad93b9f$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $78da16583ad93b9f$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $78da16583ad93b9f$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $78da16583ad93b9f$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $78da16583ad93b9f$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $78da16583ad93b9f$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $78da16583ad93b9f$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $78da16583ad93b9f$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $78da16583ad93b9f$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "onUpdated", () => $78da16583ad93b9f$export$5876c47052fb88b1);
$parcel$export(module.exports, "onUnmounted", () => $78da16583ad93b9f$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeMount", () => $78da16583ad93b9f$export$23b7aeb0d671f804);
$parcel$export(module.exports, "onBeforeUpdate", () => $78da16583ad93b9f$export$ab91988a13872e4c);
$parcel$export(module.exports, "renderList", () => $78da16583ad93b9f$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "createBlock", () => $78da16583ad93b9f$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "computed", () => $78da16583ad93b9f$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "provide", () => $78da16583ad93b9f$export$abe1e183e22e10ad);
$parcel$export(module.exports, "version", () => $78da16583ad93b9f$export$83d89fbfd8236492);
$parcel$export(module.exports, "hasInjectionContext", () => $78da16583ad93b9f$export$caf6761f24fc571a);
$parcel$export(module.exports, "createTextVNode", () => $78da16583ad93b9f$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "createRenderer", () => $78da16583ad93b9f$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $78da16583ad93b9f$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $78da16583ad93b9f$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $78da16583ad93b9f$export$42098e0eaa15c48e);
$parcel$export(module.exports, "createStaticVNode", () => $78da16583ad93b9f$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "createCommentVNode", () => $78da16583ad93b9f$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $78da16583ad93b9f$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $78da16583ad93b9f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $78da16583ad93b9f$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $78da16583ad93b9f$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "customRef", () => (parcelRequire("8bTPG")).customRef);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("8bTPG")).getCurrentScope);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("8bTPG")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("8bTPG")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("8bTPG")).markRaw);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("8bTPG")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("8bTPG")).shallowReactive);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("8bTPG")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("X5A94")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("X5A94")).normalizeClass);
/**
* @vue/runtime-core v3.4.23
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8bTPG = parcelRequire("8bTPG");

var $X5A94 = parcelRequire("X5A94");
const $78da16583ad93b9f$var$stack = [];
function $78da16583ad93b9f$var$pushWarningContext(vnode) {
    $78da16583ad93b9f$var$stack.push(vnode);
}
function $78da16583ad93b9f$var$popWarningContext() {
    $78da16583ad93b9f$var$stack.pop();
}
function $78da16583ad93b9f$var$warn$1(msg, ...args) {
    (0, $8bTPG.pauseTracking)();
    const instance = $78da16583ad93b9f$var$stack.length ? $78da16583ad93b9f$var$stack[$78da16583ad93b9f$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $78da16583ad93b9f$var$getComponentTrace();
    if (appWarnHandler) $78da16583ad93b9f$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$78da16583ad93b9f$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$78da16583ad93b9f$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $8bTPG.resetTracking)();
}
function $78da16583ad93b9f$var$getComponentTrace() {
    let currentVNode = $78da16583ad93b9f$var$stack[$78da16583ad93b9f$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $78da16583ad93b9f$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$78da16583ad93b9f$var$formatTraceEntry(entry));
    });
    return logs;
}
function $78da16583ad93b9f$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$78da16583ad93b9f$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$78da16583ad93b9f$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $78da16583ad93b9f$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$78da16583ad93b9f$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $78da16583ad93b9f$var$formatProp(key, value, raw) {
    if ((0, $X5A94.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $8bTPG.isRef)(value)) {
        value = $78da16583ad93b9f$var$formatProp(key, (0, $8bTPG.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $X5A94.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $8bTPG.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $78da16583ad93b9f$export$dfbcecb440255e4a(val, type) {
    return;
}
const $78da16583ad93b9f$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER"
};
const $78da16583ad93b9f$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://github.com/vuejs/core ."
};
function $78da16583ad93b9f$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $78da16583ad93b9f$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $X5A94.isFunction)(fn)) {
        const res = $78da16583ad93b9f$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $X5A94.isPromise)(res)) res.catch((err)=>{
            $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $X5A94.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($78da16583ad93b9f$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            (0, $8bTPG.pauseTracking)();
            $78da16583ad93b9f$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $8bTPG.resetTracking)();
            return;
        }
    }
    $78da16583ad93b9f$var$logError(err, type, contextVNode, throwInDev);
}
function $78da16583ad93b9f$var$logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let $78da16583ad93b9f$var$isFlushing = false;
let $78da16583ad93b9f$var$isFlushPending = false;
const $78da16583ad93b9f$var$queue = [];
let $78da16583ad93b9f$var$flushIndex = 0;
const $78da16583ad93b9f$var$pendingPostFlushCbs = [];
let $78da16583ad93b9f$var$activePostFlushCbs = null;
let $78da16583ad93b9f$var$postFlushIndex = 0;
const $78da16583ad93b9f$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $78da16583ad93b9f$var$currentFlushPromise = null;
const $78da16583ad93b9f$var$RECURSION_LIMIT = 100;
function $78da16583ad93b9f$export$bdd553fddd433dcb(fn) {
    const p = $78da16583ad93b9f$var$currentFlushPromise || $78da16583ad93b9f$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $78da16583ad93b9f$var$findInsertionIndex(id) {
    let start = $78da16583ad93b9f$var$flushIndex + 1;
    let end = $78da16583ad93b9f$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $78da16583ad93b9f$var$queue[middle];
        const middleJobId = $78da16583ad93b9f$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.pre) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $78da16583ad93b9f$var$queueJob(job) {
    if (!$78da16583ad93b9f$var$queue.length || !$78da16583ad93b9f$var$queue.includes(job, $78da16583ad93b9f$var$isFlushing && job.allowRecurse ? $78da16583ad93b9f$var$flushIndex + 1 : $78da16583ad93b9f$var$flushIndex)) {
        if (job.id == null) $78da16583ad93b9f$var$queue.push(job);
        else $78da16583ad93b9f$var$queue.splice($78da16583ad93b9f$var$findInsertionIndex(job.id), 0, job);
        $78da16583ad93b9f$var$queueFlush();
    }
}
function $78da16583ad93b9f$var$queueFlush() {
    if (!$78da16583ad93b9f$var$isFlushing && !$78da16583ad93b9f$var$isFlushPending) {
        $78da16583ad93b9f$var$isFlushPending = true;
        $78da16583ad93b9f$var$currentFlushPromise = $78da16583ad93b9f$var$resolvedPromise.then($78da16583ad93b9f$var$flushJobs);
    }
}
function $78da16583ad93b9f$var$invalidateJob(job) {
    const i = $78da16583ad93b9f$var$queue.indexOf(job);
    if (i > $78da16583ad93b9f$var$flushIndex) $78da16583ad93b9f$var$queue.splice(i, 1);
}
function $78da16583ad93b9f$export$59536a0199721cab(cb) {
    if (!(0, $X5A94.isArray)(cb)) {
        if (!$78da16583ad93b9f$var$activePostFlushCbs || !$78da16583ad93b9f$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $78da16583ad93b9f$var$postFlushIndex + 1 : $78da16583ad93b9f$var$postFlushIndex)) $78da16583ad93b9f$var$pendingPostFlushCbs.push(cb);
    } else $78da16583ad93b9f$var$pendingPostFlushCbs.push(...cb);
    $78da16583ad93b9f$var$queueFlush();
}
function $78da16583ad93b9f$var$flushPreFlushCbs(instance, seen, i = $78da16583ad93b9f$var$isFlushing ? $78da16583ad93b9f$var$flushIndex + 1 : 0) {
    for(; i < $78da16583ad93b9f$var$queue.length; i++){
        const cb = $78da16583ad93b9f$var$queue[i];
        if (cb && cb.pre) {
            if (instance && cb.id !== instance.uid) continue;
            $78da16583ad93b9f$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $78da16583ad93b9f$var$flushPostFlushCbs(seen) {
    if ($78da16583ad93b9f$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($78da16583ad93b9f$var$pendingPostFlushCbs)
        ].sort((a, b)=>$78da16583ad93b9f$var$getId(a) - $78da16583ad93b9f$var$getId(b));
        $78da16583ad93b9f$var$pendingPostFlushCbs.length = 0;
        if ($78da16583ad93b9f$var$activePostFlushCbs) {
            $78da16583ad93b9f$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $78da16583ad93b9f$var$activePostFlushCbs = deduped;
        for($78da16583ad93b9f$var$postFlushIndex = 0; $78da16583ad93b9f$var$postFlushIndex < $78da16583ad93b9f$var$activePostFlushCbs.length; $78da16583ad93b9f$var$postFlushIndex++)$78da16583ad93b9f$var$activePostFlushCbs[$78da16583ad93b9f$var$postFlushIndex]();
        $78da16583ad93b9f$var$activePostFlushCbs = null;
        $78da16583ad93b9f$var$postFlushIndex = 0;
    }
}
const $78da16583ad93b9f$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $78da16583ad93b9f$var$comparator = (a, b)=>{
    const diff = $78da16583ad93b9f$var$getId(a) - $78da16583ad93b9f$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $78da16583ad93b9f$var$flushJobs(seen) {
    $78da16583ad93b9f$var$isFlushPending = false;
    $78da16583ad93b9f$var$isFlushing = true;
    $78da16583ad93b9f$var$queue.sort($78da16583ad93b9f$var$comparator);
    const check = (0, $X5A94.NOOP);
    try {
        for($78da16583ad93b9f$var$flushIndex = 0; $78da16583ad93b9f$var$flushIndex < $78da16583ad93b9f$var$queue.length; $78da16583ad93b9f$var$flushIndex++){
            const job = $78da16583ad93b9f$var$queue[$78da16583ad93b9f$var$flushIndex];
            if (job && job.active !== false) $78da16583ad93b9f$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $78da16583ad93b9f$var$flushIndex = 0;
        $78da16583ad93b9f$var$queue.length = 0;
        $78da16583ad93b9f$var$flushPostFlushCbs(seen);
        $78da16583ad93b9f$var$isFlushing = false;
        $78da16583ad93b9f$var$currentFlushPromise = null;
        if ($78da16583ad93b9f$var$queue.length || $78da16583ad93b9f$var$pendingPostFlushCbs.length) $78da16583ad93b9f$var$flushJobs(seen);
    }
}
function $78da16583ad93b9f$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $78da16583ad93b9f$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $78da16583ad93b9f$var$getComponentName(instance.type);
            $78da16583ad93b9f$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $78da16583ad93b9f$var$isHmrUpdating = false;
const $78da16583ad93b9f$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
const $78da16583ad93b9f$var$map = /* @__PURE__ */ new Map();
function $78da16583ad93b9f$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $78da16583ad93b9f$var$map.get(id);
    if (!record) {
        $78da16583ad93b9f$var$createRecord(id, instance.type);
        record = $78da16583ad93b9f$var$map.get(id);
    }
    record.instances.add(instance);
}
function $78da16583ad93b9f$var$unregisterHMR(instance) {
    $78da16583ad93b9f$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $78da16583ad93b9f$var$createRecord(id, initialDef) {
    if ($78da16583ad93b9f$var$map.has(id)) return false;
    $78da16583ad93b9f$var$map.set(id, {
        initialDef: $78da16583ad93b9f$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $78da16583ad93b9f$var$normalizeClassComponent(component) {
    return $78da16583ad93b9f$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $78da16583ad93b9f$var$rerender(id, newRender) {
    const record = $78da16583ad93b9f$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $78da16583ad93b9f$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $78da16583ad93b9f$var$isHmrUpdating = true;
        instance.effect.dirty = true;
        instance.update();
        $78da16583ad93b9f$var$isHmrUpdating = false;
    });
}
function $78da16583ad93b9f$var$reload(id, newComp) {
    const record = $78da16583ad93b9f$var$map.get(id);
    if (!record) return;
    newComp = $78da16583ad93b9f$var$normalizeClassComponent(newComp);
    $78da16583ad93b9f$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $78da16583ad93b9f$var$normalizeClassComponent(instance.type);
        if (!$78da16583ad93b9f$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $78da16583ad93b9f$var$updateComponentDef(oldComp, newComp);
            $78da16583ad93b9f$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $78da16583ad93b9f$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $78da16583ad93b9f$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) {
            instance.parent.effect.dirty = true;
            $78da16583ad93b9f$var$queueJob(instance.parent.update);
        } else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $78da16583ad93b9f$export$59536a0199721cab(()=>{
        for (const instance of instances)$78da16583ad93b9f$var$hmrDirtyComponents.delete($78da16583ad93b9f$var$normalizeClassComponent(instance.type));
    });
}
function $78da16583ad93b9f$var$updateComponentDef(oldComp, newComp) {
    (0, $X5A94.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $78da16583ad93b9f$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $78da16583ad93b9f$var$devtools$1;
let $78da16583ad93b9f$var$buffer = [];
let $78da16583ad93b9f$var$devtoolsNotInstalled = false;
function $78da16583ad93b9f$var$emit$1(event, ...args) {
    if ($78da16583ad93b9f$var$devtools$1) $78da16583ad93b9f$var$devtools$1.emit(event, ...args);
    else if (!$78da16583ad93b9f$var$devtoolsNotInstalled) $78da16583ad93b9f$var$buffer.push({
        event: event,
        args: args
    });
}
function $78da16583ad93b9f$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $78da16583ad93b9f$var$devtools$1 = hook;
    if ($78da16583ad93b9f$var$devtools$1) {
        $78da16583ad93b9f$var$devtools$1.enabled = true;
        $78da16583ad93b9f$var$buffer.forEach(({ event: event, args: args })=>$78da16583ad93b9f$var$devtools$1.emit(event, ...args));
        $78da16583ad93b9f$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $78da16583ad93b9f$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$78da16583ad93b9f$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $78da16583ad93b9f$var$devtoolsNotInstalled = true;
                $78da16583ad93b9f$var$buffer = [];
            }
        }, 3e3);
    } else {
        $78da16583ad93b9f$var$devtoolsNotInstalled = true;
        $78da16583ad93b9f$var$buffer = [];
    }
}
function $78da16583ad93b9f$var$devtoolsInitApp(app, version) {
    $78da16583ad93b9f$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $78da16583ad93b9f$export$ffb0004e005737fa,
        Text: $78da16583ad93b9f$export$5f1af8db9871e1d6,
        Comment: $78da16583ad93b9f$export$4d299b491347818a,
        Static: $78da16583ad93b9f$export$c1b9a1d3af45b7b6
    });
}
function $78da16583ad93b9f$var$devtoolsUnmountApp(app) {
    $78da16583ad93b9f$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $78da16583ad93b9f$var$devtoolsComponentAdded = /* @__PURE__ */ $78da16583ad93b9f$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $78da16583ad93b9f$var$devtoolsComponentUpdated = /* @__PURE__ */ $78da16583ad93b9f$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $78da16583ad93b9f$var$_devtoolsComponentRemoved = /* @__PURE__ */ $78da16583ad93b9f$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $78da16583ad93b9f$var$devtoolsComponentRemoved = (component)=>{
    if ($78da16583ad93b9f$var$devtools$1 && typeof $78da16583ad93b9f$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$78da16583ad93b9f$var$devtools$1.cleanupBuffer(component)) $78da16583ad93b9f$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $78da16583ad93b9f$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $78da16583ad93b9f$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $78da16583ad93b9f$var$devtoolsPerfStart = /* @__PURE__ */ $78da16583ad93b9f$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $78da16583ad93b9f$var$devtoolsPerfEnd = /* @__PURE__ */ $78da16583ad93b9f$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $78da16583ad93b9f$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $78da16583ad93b9f$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $78da16583ad93b9f$var$devtoolsComponentEmit(component, event, params) {
    $78da16583ad93b9f$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $78da16583ad93b9f$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $X5A94.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $X5A94.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $X5A94.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $X5A94.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $X5A94.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $X5A94.toHandlerKey)((0, $X5A94.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $X5A94.toHandlerKey)((0, $X5A94.hyphenate)(event))];
    if (handler) $78da16583ad93b9f$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $78da16583ad93b9f$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $78da16583ad93b9f$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $X5A94.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $78da16583ad93b9f$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $X5A94.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $X5A94.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $X5A94.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $X5A94.extend)(normalized, raw);
    if ((0, $X5A94.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $78da16583ad93b9f$var$isEmitListener(options, key) {
    if (!options || !(0, $X5A94.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $X5A94.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $X5A94.hasOwn)(options, (0, $X5A94.hyphenate)(key)) || (0, $X5A94.hasOwn)(options, key);
}
let $78da16583ad93b9f$var$currentRenderingInstance = null;
let $78da16583ad93b9f$var$currentScopeId = null;
function $78da16583ad93b9f$var$setCurrentRenderingInstance(instance) {
    const prev = $78da16583ad93b9f$var$currentRenderingInstance;
    $78da16583ad93b9f$var$currentRenderingInstance = instance;
    $78da16583ad93b9f$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $78da16583ad93b9f$export$ac020265ca2cc4cd(id) {
    $78da16583ad93b9f$var$currentScopeId = id;
}
function $78da16583ad93b9f$export$f2dc6805dc11834e() {
    $78da16583ad93b9f$var$currentScopeId = null;
}
const $78da16583ad93b9f$export$15ba313e13f3dd04 = (_id)=>$78da16583ad93b9f$export$694b237e827a3d23;
function $78da16583ad93b9f$export$694b237e827a3d23(fn, ctx = $78da16583ad93b9f$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $78da16583ad93b9f$export$c20bee82f26f1e27(-1);
        const prevInstance = $78da16583ad93b9f$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $78da16583ad93b9f$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $78da16583ad93b9f$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $78da16583ad93b9f$var$accessedAttrs = false;
function $78da16583ad93b9f$var$markAttrsAccessed() {
    $78da16583ad93b9f$var$accessedAttrs = true;
}
function $78da16583ad93b9f$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, props: props, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev = $78da16583ad93b9f$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $78da16583ad93b9f$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $78da16583ad93b9f$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $78da16583ad93b9f$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $78da16583ad93b9f$var$blockStack.length = 0;
        $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, 1);
        result = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $X5A94.isModelListener))) fallthroughAttrs = $78da16583ad93b9f$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    if (vnode.dirs) {
        root = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $78da16583ad93b9f$var$setCurrentRenderingInstance(prev);
    return result;
}
const $78da16583ad93b9f$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $78da16583ad93b9f$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $78da16583ad93b9f$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $78da16583ad93b9f$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($78da16583ad93b9f$export$3868d13f8734ae81(child)) {
            if (child.type !== $78da16583ad93b9f$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $78da16583ad93b9f$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $X5A94.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $78da16583ad93b9f$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $X5A94.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $78da16583ad93b9f$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $78da16583ad93b9f$export$4d299b491347818a;
};
function $78da16583ad93b9f$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $78da16583ad93b9f$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$78da16583ad93b9f$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $78da16583ad93b9f$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $78da16583ad93b9f$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$78da16583ad93b9f$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $78da16583ad93b9f$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $78da16583ad93b9f$var$COMPONENTS = "components";
const $78da16583ad93b9f$var$DIRECTIVES = "directives";
function $78da16583ad93b9f$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $78da16583ad93b9f$var$resolveAsset($78da16583ad93b9f$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $78da16583ad93b9f$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $78da16583ad93b9f$export$b44c564a05ca975(component) {
    if ((0, $X5A94.isString)(component)) return $78da16583ad93b9f$var$resolveAsset($78da16583ad93b9f$var$COMPONENTS, component, false) || component;
    else return component || $78da16583ad93b9f$var$NULL_DYNAMIC_COMPONENT;
}
function $78da16583ad93b9f$export$a1989e995cd481be(name) {
    return $78da16583ad93b9f$var$resolveAsset($78da16583ad93b9f$var$DIRECTIVES, name);
}
function $78da16583ad93b9f$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $78da16583ad93b9f$var$currentRenderingInstance || $78da16583ad93b9f$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $78da16583ad93b9f$var$COMPONENTS) {
            const selfName = $78da16583ad93b9f$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $X5A94.camelize)(name) || selfName === (0, $X5A94.capitalize)((0, $X5A94.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $78da16583ad93b9f$var$resolve(instance[type] || Component[type], name) || // global registration
        $78da16583ad93b9f$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $78da16583ad93b9f$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $X5A94.camelize)(name)] || registry[(0, $X5A94.capitalize)((0, $X5A94.camelize)(name))]);
}
const $78da16583ad93b9f$var$isSuspense = (type)=>type.__isSuspense;
let $78da16583ad93b9f$var$suspenseId = 0;
const $78da16583ad93b9f$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $78da16583ad93b9f$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $78da16583ad93b9f$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $78da16583ad93b9f$var$hydrateSuspense,
    create: $78da16583ad93b9f$var$createSuspenseBoundary,
    normalize: $78da16583ad93b9f$var$normalizeSuspenseChildren
};
const $78da16583ad93b9f$export$74bf444e3cd11ea5 = $78da16583ad93b9f$var$SuspenseImpl;
function $78da16583ad93b9f$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $X5A94.isFunction)(eventListener)) eventListener();
}
function $78da16583ad93b9f$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $78da16583ad93b9f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $78da16583ad93b9f$var$triggerEvent(vnode, "onPending");
        $78da16583ad93b9f$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $78da16583ad93b9f$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $78da16583ad93b9f$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($78da16583ad93b9f$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $78da16583ad93b9f$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $78da16583ad93b9f$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $78da16583ad93b9f$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $78da16583ad93b9f$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $78da16583ad93b9f$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $78da16583ad93b9f$var$setActiveBranch(suspense, newBranch);
    } else {
        $78da16583ad93b9f$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $78da16583ad93b9f$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $78da16583ad93b9f$var$hasWarned = false;
function $78da16583ad93b9f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $78da16583ad93b9f$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense == null ? void 0 : parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $X5A94.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $78da16583ad93b9f$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $78da16583ad93b9f$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) !== suspense.hiddenContainer) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $78da16583ad93b9f$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $78da16583ad93b9f$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $78da16583ad93b9f$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $78da16583ad93b9f$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $78da16583ad93b9f$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $78da16583ad93b9f$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized);
                if (placeholder) remove(placeholder);
                $78da16583ad93b9f$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $78da16583ad93b9f$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $78da16583ad93b9f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $78da16583ad93b9f$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $78da16583ad93b9f$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $78da16583ad93b9f$var$normalizeSuspenseSlot(children.fallback) : $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
}
function $78da16583ad93b9f$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $X5A94.isFunction)(s)) {
        const trackBlock = $78da16583ad93b9f$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $78da16583ad93b9f$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $78da16583ad93b9f$var$currentBlock;
            $78da16583ad93b9f$var$closeBlock();
        }
    }
    if ((0, $X5A94.isArray)(s)) {
        const singleChild = $78da16583ad93b9f$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $78da16583ad93b9f$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $78da16583ad93b9f$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $X5A94.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $78da16583ad93b9f$export$59536a0199721cab(fn);
}
function $78da16583ad93b9f$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $78da16583ad93b9f$var$updateHOCHostEl(parentComponent, el);
    }
}
function $78da16583ad93b9f$var$isVNodeSuspensible(vnode) {
    var _a;
    return ((_a = vnode.props) == null ? void 0 : _a.suspensible) != null && vnode.props.suspensible !== false;
}
const $78da16583ad93b9f$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $78da16583ad93b9f$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $78da16583ad93b9f$export$a976684a0efeb93f($78da16583ad93b9f$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $78da16583ad93b9f$export$ede35fc0e5500309(effect, options) {
    return $78da16583ad93b9f$var$doWatch(effect, null, options);
}
function $78da16583ad93b9f$export$b7f27ea67102d543(effect, options) {
    return $78da16583ad93b9f$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $78da16583ad93b9f$export$2035654f31b0e555(effect, options) {
    return $78da16583ad93b9f$var$doWatch(effect, null, {
        flush: "sync"
    });
}
const $78da16583ad93b9f$var$INITIAL_WATCHER_VALUE = {};
function $78da16583ad93b9f$export$3db5d71bdb2d5499(source, cb, options) {
    return $78da16583ad93b9f$var$doWatch(source, cb, options);
}
function $78da16583ad93b9f$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, once: once, onTrack: onTrack, onTrigger: onTrigger } = (0, $X5A94.EMPTY_OBJ)) {
    if (cb && once) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            unwatch();
        };
    }
    const warnInvalidSource = (s)=>{
        $78da16583ad93b9f$var$warn$1(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = $78da16583ad93b9f$var$currentInstance;
    const reactiveGetter = (source2)=>deep === true ? source2 : // for deep: false, only traverse root-level properties
        $78da16583ad93b9f$var$traverse(source2, deep === false ? 1 : void 0);
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $8bTPG.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $8bTPG.isShallow)(source);
    } else if ((0, $8bTPG.isReactive)(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $X5A94.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $8bTPG.isReactive)(s) || (0, $8bTPG.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $8bTPG.isRef)(s)) return s.value;
                else if ((0, $8bTPG.isReactive)(s)) return reactiveGetter(s);
                else if ((0, $X5A94.isFunction)(s)) return $78da16583ad93b9f$export$b22fcaf88446e9bf(s, instance, 2);
            });
    } else if ((0, $X5A94.isFunction)(source)) {
        if (cb) getter = ()=>$78da16583ad93b9f$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (cleanup) cleanup();
            return $78da16583ad93b9f$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $X5A94.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$78da16583ad93b9f$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $78da16583ad93b9f$export$b22fcaf88446e9bf(fn, instance, 4);
            cleanup = effect.onStop = void 0;
        };
    };
    let ssrCleanup;
    if ($78da16583ad93b9f$var$isInSSRComponentSetup) {
        onCleanup = (0, $X5A94.NOOP);
        if (!cb) getter();
        else if (immediate) $78da16583ad93b9f$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $78da16583ad93b9f$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $X5A94.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($78da16583ad93b9f$var$INITIAL_WATCHER_VALUE) : $78da16583ad93b9f$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active || !effect.dirty) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $X5A94.hasChanged)(v1, oldValue[i])) : (0, $X5A94.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $78da16583ad93b9f$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $78da16583ad93b9f$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $78da16583ad93b9f$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$78da16583ad93b9f$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$78da16583ad93b9f$var$queueJob(job);
    }
    const effect = new (0, $8bTPG.ReactiveEffect)(getter, (0, $X5A94.NOOP), scheduler);
    const scope = (0, $8bTPG.getCurrentScope)();
    const unwatch = ()=>{
        effect.stop();
        if (scope) (0, $X5A94.remove)(scope.effects, effect);
    };
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $78da16583ad93b9f$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $78da16583ad93b9f$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $X5A94.isString)(source) ? source.includes(".") ? $78da16583ad93b9f$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $X5A94.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $78da16583ad93b9f$var$setCurrentInstance(this);
    const res = $78da16583ad93b9f$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $78da16583ad93b9f$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $78da16583ad93b9f$var$traverse(value, depth, currentDepth = 0, seen) {
    if (!(0, $X5A94.isObject)(value) || value["__v_skip"]) return value;
    if (depth && depth > 0) {
        if (currentDepth >= depth) return value;
        currentDepth++;
    }
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    if ((0, $8bTPG.isRef)(value)) $78da16583ad93b9f$var$traverse(value.value, depth, currentDepth, seen);
    else if ((0, $X5A94.isArray)(value)) for(let i = 0; i < value.length; i++)$78da16583ad93b9f$var$traverse(value[i], depth, currentDepth, seen);
    else if ((0, $X5A94.isSet)(value) || (0, $X5A94.isMap)(value)) value.forEach((v1)=>{
        $78da16583ad93b9f$var$traverse(v1, depth, currentDepth, seen);
    });
    else if ((0, $X5A94.isPlainObject)(value)) for(const key in value)$78da16583ad93b9f$var$traverse(value[key], depth, currentDepth, seen);
    return value;
}
function $78da16583ad93b9f$var$validateDirectiveName(name) {
    if ((0, $X5A94.isBuiltInDirective)(name)) $78da16583ad93b9f$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $78da16583ad93b9f$export$49729353e7c1e6c5(vnode, directives) {
    if ($78da16583ad93b9f$var$currentRenderingInstance === null) return vnode;
    const instance = $78da16583ad93b9f$var$getExposeProxy($78da16583ad93b9f$var$currentRenderingInstance) || $78da16583ad93b9f$var$currentRenderingInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $X5A94.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $X5A94.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $78da16583ad93b9f$var$traverse(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $78da16583ad93b9f$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $8bTPG.pauseTracking)();
            $78da16583ad93b9f$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $8bTPG.resetTracking)();
        }
    }
}
const $78da16583ad93b9f$var$leaveCbKey = Symbol("_leaveCb");
const $78da16583ad93b9f$var$enterCbKey = Symbol("_enterCb");
function $78da16583ad93b9f$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $78da16583ad93b9f$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $78da16583ad93b9f$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $78da16583ad93b9f$var$TransitionHookValidator = [
    Function,
    Array
];
const $78da16583ad93b9f$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $78da16583ad93b9f$var$TransitionHookValidator,
    onEnter: $78da16583ad93b9f$var$TransitionHookValidator,
    onAfterEnter: $78da16583ad93b9f$var$TransitionHookValidator,
    onEnterCancelled: $78da16583ad93b9f$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $78da16583ad93b9f$var$TransitionHookValidator,
    onLeave: $78da16583ad93b9f$var$TransitionHookValidator,
    onAfterLeave: $78da16583ad93b9f$var$TransitionHookValidator,
    onLeaveCancelled: $78da16583ad93b9f$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $78da16583ad93b9f$var$TransitionHookValidator,
    onAppear: $78da16583ad93b9f$var$TransitionHookValidator,
    onAfterAppear: $78da16583ad93b9f$var$TransitionHookValidator,
    onAppearCancelled: $78da16583ad93b9f$var$TransitionHookValidator
};
const $78da16583ad93b9f$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $78da16583ad93b9f$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $78da16583ad93b9f$export$f13e630aa3915748();
        const state = $78da16583ad93b9f$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $78da16583ad93b9f$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $78da16583ad93b9f$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, $8bTPG.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $78da16583ad93b9f$var$emptyPlaceholder(child);
            const innerChild = $78da16583ad93b9f$var$getKeepAliveChild(child);
            if (!innerChild) return $78da16583ad93b9f$var$emptyPlaceholder(child);
            const enterHooks = $78da16583ad93b9f$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $78da16583ad93b9f$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $78da16583ad93b9f$var$getKeepAliveChild(oldChild);
            if (oldInnerChild && oldInnerChild.type !== $78da16583ad93b9f$export$4d299b491347818a && !$78da16583ad93b9f$var$isSameVNodeType(innerChild, oldInnerChild)) {
                const leavingHooks = $78da16583ad93b9f$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $78da16583ad93b9f$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in") {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) {
                            instance.effect.dirty = true;
                            instance.update();
                        }
                    };
                    return $78da16583ad93b9f$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $78da16583ad93b9f$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $78da16583ad93b9f$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$78da16583ad93b9f$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$78da16583ad93b9f$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $78da16583ad93b9f$export$abd95b5f5e8a8837 = $78da16583ad93b9f$var$BaseTransitionImpl;
function $78da16583ad93b9f$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $78da16583ad93b9f$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $78da16583ad93b9f$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $78da16583ad93b9f$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $X5A94.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$78da16583ad93b9f$var$leaveCbKey]) el[$78da16583ad93b9f$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $78da16583ad93b9f$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$78da16583ad93b9f$var$leaveCbKey]) leavingVNode.el[$78da16583ad93b9f$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$78da16583ad93b9f$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$78da16583ad93b9f$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$78da16583ad93b9f$var$enterCbKey]) el[$78da16583ad93b9f$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$78da16583ad93b9f$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$78da16583ad93b9f$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            return $78da16583ad93b9f$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $78da16583ad93b9f$var$emptyPlaceholder(vnode) {
    if ($78da16583ad93b9f$var$isKeepAlive(vnode)) {
        vnode = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $78da16583ad93b9f$var$getKeepAliveChild(vnode) {
    return $78da16583ad93b9f$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : void 0 : vnode;
}
function $78da16583ad93b9f$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $78da16583ad93b9f$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $78da16583ad93b9f$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $78da16583ad93b9f$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($78da16583ad93b9f$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $78da16583ad93b9f$export$4d299b491347818a) ret.push(key != null ? $78da16583ad93b9f$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $78da16583ad93b9f$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $X5A94.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $X5A94.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $78da16583ad93b9f$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $78da16583ad93b9f$export$d75d499b4c16cf21(source) {
    if ((0, $X5A94.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $78da16583ad93b9f$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $78da16583ad93b9f$var$currentInstance;
            if (resolvedComp) return ()=>$78da16583ad93b9f$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $78da16583ad93b9f$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$78da16583ad93b9f$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $78da16583ad93b9f$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $8bTPG.ref)(false);
            const error = (0, $8bTPG.ref)();
            const delayed = (0, $8bTPG.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $78da16583ad93b9f$var$isKeepAlive(instance.parent.vnode)) {
                    instance.parent.effect.dirty = true;
                    $78da16583ad93b9f$var$queueJob(instance.parent.update);
                }
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $78da16583ad93b9f$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $78da16583ad93b9f$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $78da16583ad93b9f$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $78da16583ad93b9f$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $78da16583ad93b9f$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $78da16583ad93b9f$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $78da16583ad93b9f$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $78da16583ad93b9f$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $X5A94.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $X5A94.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $78da16583ad93b9f$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $78da16583ad93b9f$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$78da16583ad93b9f$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $78da16583ad93b9f$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $78da16583ad93b9f$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$78da16583ad93b9f$var$matches(include, name));
            exclude && pruneCache((name)=>!$78da16583ad93b9f$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $78da16583ad93b9f$var$getInnerChild(instance.subTree));
        };
        $78da16583ad93b9f$export$6d1641039221b5cb(cacheSubtree);
        $78da16583ad93b9f$export$5876c47052fb88b1(cacheSubtree);
        $78da16583ad93b9f$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $78da16583ad93b9f$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $78da16583ad93b9f$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $78da16583ad93b9f$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$78da16583ad93b9f$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $78da16583ad93b9f$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $78da16583ad93b9f$var$getComponentName($78da16583ad93b9f$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$78da16583ad93b9f$var$matches(include, name)) || exclude && name && $78da16583ad93b9f$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $78da16583ad93b9f$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $78da16583ad93b9f$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $78da16583ad93b9f$export$70eb8a58709972df = $78da16583ad93b9f$var$KeepAliveImpl;
function $78da16583ad93b9f$var$matches(pattern, name) {
    if ((0, $X5A94.isArray)(pattern)) return pattern.some((p)=>$78da16583ad93b9f$var$matches(p, name));
    else if ((0, $X5A94.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $X5A94.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $78da16583ad93b9f$export$ba52d824b95a2154(hook, target) {
    $78da16583ad93b9f$var$registerKeepAliveHook(hook, "a", target);
}
function $78da16583ad93b9f$export$bf1440eeaf5fa709(hook, target) {
    $78da16583ad93b9f$var$registerKeepAliveHook(hook, "da", target);
}
function $78da16583ad93b9f$var$registerKeepAliveHook(hook, type, target = $78da16583ad93b9f$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $78da16583ad93b9f$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($78da16583ad93b9f$var$isKeepAlive(current.parent.vnode)) $78da16583ad93b9f$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $78da16583ad93b9f$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $78da16583ad93b9f$var$injectHook(type, hook, keepAliveRoot, true);
    $78da16583ad93b9f$export$13348a43ccacfe58(()=>{
        (0, $X5A94.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $78da16583ad93b9f$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $78da16583ad93b9f$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $78da16583ad93b9f$var$injectHook(type, hook, target = $78da16583ad93b9f$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            (0, $8bTPG.pauseTracking)();
            const reset = $78da16583ad93b9f$var$setCurrentInstance(target);
            const res = $78da16583ad93b9f$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $8bTPG.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $78da16583ad93b9f$var$createHook = (lifecycle)=>(hook, target = $78da16583ad93b9f$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$78da16583ad93b9f$var$isInSSRComponentSetup || lifecycle === "sp") && $78da16583ad93b9f$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $78da16583ad93b9f$export$23b7aeb0d671f804 = $78da16583ad93b9f$var$createHook("bm");
const $78da16583ad93b9f$export$6d1641039221b5cb = $78da16583ad93b9f$var$createHook("m");
const $78da16583ad93b9f$export$ab91988a13872e4c = $78da16583ad93b9f$var$createHook("bu");
const $78da16583ad93b9f$export$5876c47052fb88b1 = $78da16583ad93b9f$var$createHook("u");
const $78da16583ad93b9f$export$40c420df62d2614 = $78da16583ad93b9f$var$createHook("bum");
const $78da16583ad93b9f$export$13348a43ccacfe58 = $78da16583ad93b9f$var$createHook("um");
const $78da16583ad93b9f$export$ebf0c601f267bceb = $78da16583ad93b9f$var$createHook("sp");
const $78da16583ad93b9f$export$898295a813d662eb = $78da16583ad93b9f$var$createHook("rtg");
const $78da16583ad93b9f$export$2b41f4235363e921 = $78da16583ad93b9f$var$createHook("rtc");
function $78da16583ad93b9f$export$6a3a15856e50ad19(hook, target = $78da16583ad93b9f$var$currentInstance) {
    $78da16583ad93b9f$var$injectHook("ec", hook, target);
}
function $78da16583ad93b9f$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $X5A94.isArray)(source) || (0, $X5A94.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $X5A94.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $78da16583ad93b9f$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $X5A94.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $78da16583ad93b9f$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($78da16583ad93b9f$var$currentRenderingInstance.isCE || $78da16583ad93b9f$var$currentRenderingInstance.parent && $78da16583ad93b9f$var$isAsyncWrapper($78da16583ad93b9f$var$currentRenderingInstance.parent) && $78da16583ad93b9f$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $78da16583ad93b9f$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $78da16583ad93b9f$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $78da16583ad93b9f$var$ensureValidVNode(slot(props));
    const rendered = $78da16583ad93b9f$export$9f2dfe8048dfb22b($78da16583ad93b9f$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $78da16583ad93b9f$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$78da16583ad93b9f$export$3868d13f8734ae81(child)) return true;
        if (child.type === $78da16583ad93b9f$export$4d299b491347818a) return false;
        if (child.type === $78da16583ad93b9f$export$ffb0004e005737fa && !$78da16583ad93b9f$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $78da16583ad93b9f$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $X5A94.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $78da16583ad93b9f$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($78da16583ad93b9f$var$isStatefulComponent(i)) return $78da16583ad93b9f$var$getExposeProxy(i) || i.proxy;
    return $78da16583ad93b9f$var$getPublicInstance(i.parent);
};
const $78da16583ad93b9f$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $X5A94.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$78da16583ad93b9f$var$getPublicInstance(i.parent),
    $root: (i)=>$78da16583ad93b9f$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $78da16583ad93b9f$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            i.effect.dirty = true;
            $78da16583ad93b9f$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $78da16583ad93b9f$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $78da16583ad93b9f$var$instanceWatch.bind(i) : (0, $X5A94.NOOP)
});
const $78da16583ad93b9f$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $78da16583ad93b9f$var$hasSetupBinding = (state, key)=>state !== (0, $X5A94.EMPTY_OBJ) && !state.__isScriptSetup && (0, $X5A94.hasOwn)(state, key);
const $78da16583ad93b9f$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($78da16583ad93b9f$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $X5A94.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $78da16583ad93b9f$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $78da16583ad93b9f$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $8bTPG.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $X5A94.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($78da16583ad93b9f$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $X5A94.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasOwn)(data, key) || $78da16583ad93b9f$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $X5A94.hasOwn)(normalizedProps, key) || (0, $X5A94.hasOwn)(ctx, key) || (0, $X5A94.hasOwn)($78da16583ad93b9f$var$publicPropertiesMap, key) || (0, $X5A94.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $X5A94.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $78da16583ad93b9f$var$target;
const $78da16583ad93b9f$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $X5A94.extend)({}, $78da16583ad93b9f$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $78da16583ad93b9f$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $X5A94.isGloballyAllowed)(key);
        return has;
    }
});
function $78da16583ad93b9f$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($78da16583ad93b9f$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$78da16583ad93b9f$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $X5A94.NOOP)
        });
    });
    return target;
}
function $78da16583ad93b9f$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $X5A94.NOOP)
        });
    });
}
function $78da16583ad93b9f$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $8bTPG.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($78da16583ad93b9f$var$isReservedPrefix(key[0])) {
                $78da16583ad93b9f$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $X5A94.NOOP)
            });
        }
    });
}
const $78da16583ad93b9f$var$warnRuntimeUsage = (method)=>$78da16583ad93b9f$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $78da16583ad93b9f$export$80b33eababae110e() {
    return null;
}
function $78da16583ad93b9f$export$51ecece22fc17ddc() {
    return null;
}
function $78da16583ad93b9f$export$da25b65ca24b518a(exposed) {}
function $78da16583ad93b9f$export$77e79129327f3d0d(options) {}
function $78da16583ad93b9f$export$1b3acd4bb805b712() {
    return null;
}
function $78da16583ad93b9f$export$acd55aa037e791bb() {}
function $78da16583ad93b9f$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $78da16583ad93b9f$export$9203a8e84125433c() {
    return $78da16583ad93b9f$var$getContext().slots;
}
function $78da16583ad93b9f$export$75e29435042cd2ea() {
    return $78da16583ad93b9f$var$getContext().attrs;
}
function $78da16583ad93b9f$var$getContext() {
    const i = $78da16583ad93b9f$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $78da16583ad93b9f$var$createSetupContext(i));
}
function $78da16583ad93b9f$var$normalizePropsOrEmits(props) {
    return (0, $X5A94.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $78da16583ad93b9f$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $78da16583ad93b9f$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $X5A94.isArray)(opt) || (0, $X5A94.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $78da16583ad93b9f$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $X5A94.isArray)(a) && (0, $X5A94.isArray)(b)) return a.concat(b);
    return (0, $X5A94.extend)({}, $78da16583ad93b9f$var$normalizePropsOrEmits(a), $78da16583ad93b9f$var$normalizePropsOrEmits(b));
}
function $78da16583ad93b9f$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $78da16583ad93b9f$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $78da16583ad93b9f$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $78da16583ad93b9f$var$unsetCurrentInstance();
    if ((0, $X5A94.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $78da16583ad93b9f$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$78da16583ad93b9f$var$setCurrentInstance(ctx)
    ];
}
function $78da16583ad93b9f$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $78da16583ad93b9f$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $78da16583ad93b9f$var$shouldCacheAccess = true;
function $78da16583ad93b9f$var$applyOptions(instance) {
    const options = $78da16583ad93b9f$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $78da16583ad93b9f$var$shouldCacheAccess = false;
    if (options.beforeCreate) $78da16583ad93b9f$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $78da16583ad93b9f$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $X5A94.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $X5A94.isObject)(data)) ;
        else instance.data = (0, $8bTPG.reactive)(data);
    }
    $78da16583ad93b9f$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $X5A94.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $X5A94.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $X5A94.NOOP);
        const set = !(0, $X5A94.isFunction)(opt) && (0, $X5A94.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $X5A94.NOOP);
        const c = $78da16583ad93b9f$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$78da16583ad93b9f$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $X5A94.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $78da16583ad93b9f$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $78da16583ad93b9f$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $X5A94.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($78da16583ad93b9f$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($78da16583ad93b9f$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($78da16583ad93b9f$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($78da16583ad93b9f$export$5876c47052fb88b1, updated);
    registerLifecycleHook($78da16583ad93b9f$export$ba52d824b95a2154, activated);
    registerLifecycleHook($78da16583ad93b9f$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($78da16583ad93b9f$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($78da16583ad93b9f$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($78da16583ad93b9f$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($78da16583ad93b9f$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($78da16583ad93b9f$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($78da16583ad93b9f$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $X5A94.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $X5A94.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $78da16583ad93b9f$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $X5A94.NOOP)) {
    if ((0, $X5A94.isArray)(injectOptions)) injectOptions = $78da16583ad93b9f$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $X5A94.isObject)(opt)) {
            if ("default" in opt) injected = $78da16583ad93b9f$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $78da16583ad93b9f$export$a976684a0efeb93f(opt.from || key);
        } else injected = $78da16583ad93b9f$export$a976684a0efeb93f(opt);
        if ((0, $8bTPG.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $78da16583ad93b9f$var$callHook(hook, instance, type) {
    $78da16583ad93b9f$export$dae85862a8d94378((0, $X5A94.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $78da16583ad93b9f$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $78da16583ad93b9f$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $X5A94.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $X5A94.isFunction)(handler)) $78da16583ad93b9f$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $X5A94.isFunction)(raw)) $78da16583ad93b9f$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $X5A94.isObject)(raw)) {
        if ((0, $X5A94.isArray)(raw)) raw.forEach((r)=>$78da16583ad93b9f$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $X5A94.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $X5A94.isFunction)(handler)) $78da16583ad93b9f$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $78da16583ad93b9f$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$78da16583ad93b9f$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $78da16583ad93b9f$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $X5A94.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $78da16583ad93b9f$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $78da16583ad93b9f$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$78da16583ad93b9f$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $78da16583ad93b9f$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $78da16583ad93b9f$var$internalOptionMergeStrats = {
    data: $78da16583ad93b9f$var$mergeDataFn,
    props: $78da16583ad93b9f$var$mergeEmitsOrPropsOptions,
    emits: $78da16583ad93b9f$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $78da16583ad93b9f$var$mergeObjectOptions,
    computed: $78da16583ad93b9f$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $78da16583ad93b9f$var$mergeAsArray,
    created: $78da16583ad93b9f$var$mergeAsArray,
    beforeMount: $78da16583ad93b9f$var$mergeAsArray,
    mounted: $78da16583ad93b9f$var$mergeAsArray,
    beforeUpdate: $78da16583ad93b9f$var$mergeAsArray,
    updated: $78da16583ad93b9f$var$mergeAsArray,
    beforeDestroy: $78da16583ad93b9f$var$mergeAsArray,
    beforeUnmount: $78da16583ad93b9f$var$mergeAsArray,
    destroyed: $78da16583ad93b9f$var$mergeAsArray,
    unmounted: $78da16583ad93b9f$var$mergeAsArray,
    activated: $78da16583ad93b9f$var$mergeAsArray,
    deactivated: $78da16583ad93b9f$var$mergeAsArray,
    errorCaptured: $78da16583ad93b9f$var$mergeAsArray,
    serverPrefetch: $78da16583ad93b9f$var$mergeAsArray,
    // assets
    components: $78da16583ad93b9f$var$mergeObjectOptions,
    directives: $78da16583ad93b9f$var$mergeObjectOptions,
    // watch
    watch: $78da16583ad93b9f$var$mergeWatchOptions,
    // provide / inject
    provide: $78da16583ad93b9f$var$mergeDataFn,
    inject: $78da16583ad93b9f$var$mergeInject
};
function $78da16583ad93b9f$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $X5A94.extend)((0, $X5A94.isFunction)(to) ? to.call(this, this) : to, (0, $X5A94.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $78da16583ad93b9f$var$mergeInject(to, from) {
    return $78da16583ad93b9f$var$mergeObjectOptions($78da16583ad93b9f$var$normalizeInject(to), $78da16583ad93b9f$var$normalizeInject(from));
}
function $78da16583ad93b9f$var$normalizeInject(raw) {
    if ((0, $X5A94.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $78da16583ad93b9f$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $78da16583ad93b9f$var$mergeObjectOptions(to, from) {
    return to ? (0, $X5A94.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $78da16583ad93b9f$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $X5A94.isArray)(to) && (0, $X5A94.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $X5A94.extend)(/* @__PURE__ */ Object.create(null), $78da16583ad93b9f$var$normalizePropsOrEmits(to), $78da16583ad93b9f$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $78da16583ad93b9f$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $X5A94.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $78da16583ad93b9f$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $78da16583ad93b9f$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $X5A94.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $78da16583ad93b9f$var$uid$1 = 0;
function $78da16583ad93b9f$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $X5A94.isFunction)(rootComponent)) rootComponent = (0, $X5A94.extend)({}, rootComponent);
        if (rootProps != null && !(0, $X5A94.isObject)(rootProps)) rootProps = null;
        const context = $78da16583ad93b9f$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        let isMounted = false;
        const app = context.app = {
            _uid: $78da16583ad93b9f$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $78da16583ad93b9f$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $X5A94.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $X5A94.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = $78da16583ad93b9f$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $78da16583ad93b9f$var$devtoolsInitApp(app, $78da16583ad93b9f$export$83d89fbfd8236492);
                    }
                    return $78da16583ad93b9f$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $78da16583ad93b9f$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $78da16583ad93b9f$var$currentApp;
                $78da16583ad93b9f$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $78da16583ad93b9f$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $78da16583ad93b9f$var$currentApp = null;
function $78da16583ad93b9f$export$abe1e183e22e10ad(key, value) {
    if (!$78da16583ad93b9f$var$currentInstance) ;
    else {
        let provides = $78da16583ad93b9f$var$currentInstance.provides;
        const parentProvides = $78da16583ad93b9f$var$currentInstance.parent && $78da16583ad93b9f$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $78da16583ad93b9f$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $78da16583ad93b9f$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $78da16583ad93b9f$var$currentInstance || $78da16583ad93b9f$var$currentRenderingInstance;
    if (instance || $78da16583ad93b9f$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $78da16583ad93b9f$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $X5A94.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $78da16583ad93b9f$export$caf6761f24fc571a() {
    return !!($78da16583ad93b9f$var$currentInstance || $78da16583ad93b9f$var$currentRenderingInstance || $78da16583ad93b9f$var$currentApp);
}
const $78da16583ad93b9f$var$internalObjectProto = /* @__PURE__ */ Object.create(null);
const $78da16583ad93b9f$var$createInternalObject = ()=>Object.create($78da16583ad93b9f$var$internalObjectProto);
const $78da16583ad93b9f$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $78da16583ad93b9f$var$internalObjectProto;
function $78da16583ad93b9f$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $78da16583ad93b9f$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $78da16583ad93b9f$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $8bTPG.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $78da16583ad93b9f$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $78da16583ad93b9f$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $8bTPG.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($78da16583ad93b9f$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $X5A94.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $X5A94.camelize)(key);
                        props[camelizedKey] = $78da16583ad93b9f$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($78da16583ad93b9f$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $X5A94.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $X5A94.hyphenate)(key)) === key || !(0, $X5A94.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $78da16583ad93b9f$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $X5A94.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $8bTPG.trigger)(instance.attrs, "set", "");
}
function $78da16583ad93b9f$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $X5A94.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $X5A94.hasOwn)(options, camelKey = (0, $X5A94.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$78da16583ad93b9f$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $8bTPG.toRaw)(props);
        const castValues = rawCastValues || (0, $X5A94.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $78da16583ad93b9f$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $X5A94.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $78da16583ad93b9f$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $X5A94.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $X5A94.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $78da16583ad93b9f$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $X5A94.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $78da16583ad93b9f$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $X5A94.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $78da16583ad93b9f$var$normalizePropsOptions(raw2, appContext, true);
            (0, $X5A94.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $X5A94.isObject)(comp)) cache.set(comp, (0, $X5A94.EMPTY_ARR));
        return 0, $X5A94.EMPTY_ARR;
    }
    if ((0, $X5A94.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $X5A94.camelize)(raw[i]);
        if ($78da16583ad93b9f$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $X5A94.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $X5A94.camelize)(key);
        if ($78da16583ad93b9f$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $X5A94.isArray)(opt) || (0, $X5A94.isFunction)(opt) ? {
                type: opt
            } : (0, $X5A94.extend)({}, opt);
            if (prop) {
                const booleanIndex = $78da16583ad93b9f$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $78da16583ad93b9f$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $X5A94.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $X5A94.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $78da16583ad93b9f$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $X5A94.isReservedProp)(key)) return true;
    return false;
}
function $78da16583ad93b9f$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $78da16583ad93b9f$var$isSameType(a, b) {
    return $78da16583ad93b9f$var$getType(a) === $78da16583ad93b9f$var$getType(b);
}
function $78da16583ad93b9f$var$getTypeIndex(type, expectedTypes) {
    if ((0, $X5A94.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$78da16583ad93b9f$var$isSameType(t, type));
    else if ((0, $X5A94.isFunction)(expectedTypes)) return $78da16583ad93b9f$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $78da16583ad93b9f$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $8bTPG.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $78da16583ad93b9f$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !(0, $X5A94.hasOwn)(rawProps, key) && !(0, $X5A94.hasOwn)(rawProps, (0, $X5A94.hyphenate)(key)));
    }
}
function $78da16583ad93b9f$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $78da16583ad93b9f$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $X5A94.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $78da16583ad93b9f$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $78da16583ad93b9f$var$warn$1($78da16583ad93b9f$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $78da16583ad93b9f$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $78da16583ad93b9f$var$isSimpleType = /* @__PURE__ */ (0, $X5A94.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $78da16583ad93b9f$var$assertType(value, type) {
    let valid;
    const expectedType = $78da16583ad93b9f$var$getType(type);
    if ($78da16583ad93b9f$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $X5A94.isObject)(value);
    else if (expectedType === "Array") valid = (0, $X5A94.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $78da16583ad93b9f$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $X5A94.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $X5A94.toRawType)(value);
    const expectedValue = $78da16583ad93b9f$var$styleValue(value, expectedType);
    const receivedValue = $78da16583ad93b9f$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $78da16583ad93b9f$var$isExplicable(expectedType) && !$78da16583ad93b9f$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($78da16583ad93b9f$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $78da16583ad93b9f$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $78da16583ad93b9f$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $78da16583ad93b9f$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $78da16583ad93b9f$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $78da16583ad93b9f$var$normalizeSlotValue = (value)=>(0, $X5A94.isArray)(value) ? value.map($78da16583ad93b9f$var$normalizeVNode) : [
        $78da16583ad93b9f$var$normalizeVNode(value)
    ];
const $78da16583ad93b9f$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $78da16583ad93b9f$export$694b237e827a3d23((...args)=>{
        return $78da16583ad93b9f$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $78da16583ad93b9f$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($78da16583ad93b9f$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $X5A94.isFunction)(value)) slots[key] = $78da16583ad93b9f$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $78da16583ad93b9f$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $78da16583ad93b9f$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $78da16583ad93b9f$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $78da16583ad93b9f$var$initSlots = (instance, children)=>{
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            instance.slots = (0, $8bTPG.toRaw)(children);
            (0, $X5A94.def)(instance.slots, "_", type);
        } else $78da16583ad93b9f$var$normalizeObjectSlots(children, instance.slots = $78da16583ad93b9f$var$createInternalObject());
    } else {
        instance.slots = $78da16583ad93b9f$var$createInternalObject();
        if (children) $78da16583ad93b9f$var$normalizeVNodeSlots(instance, children);
    }
};
const $78da16583ad93b9f$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $X5A94.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $X5A94.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $78da16583ad93b9f$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $78da16583ad93b9f$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$78da16583ad93b9f$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
function $78da16583ad93b9f$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $X5A94.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$78da16583ad93b9f$var$setRef(r, oldRawRef && ((0, $X5A94.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($78da16583ad93b9f$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $78da16583ad93b9f$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $X5A94.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $X5A94.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $X5A94.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $8bTPG.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $X5A94.isFunction)(ref)) $78da16583ad93b9f$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $X5A94.isString)(ref);
        const _isRef = (0, $8bTPG.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $X5A94.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $X5A94.isArray)(existing) && (0, $X5A94.remove)(existing, refValue);
                    else {
                        if (!(0, $X5A94.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $X5A94.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, $X5A94.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $78da16583ad93b9f$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $78da16583ad93b9f$var$hasMismatch = false;
const $78da16583ad93b9f$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $78da16583ad93b9f$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $78da16583ad93b9f$var$getContainerType = (container)=>{
    if ($78da16583ad93b9f$var$isSVGContainer(container)) return "svg";
    if ($78da16583ad93b9f$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $78da16583ad93b9f$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $78da16583ad93b9f$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $78da16583ad93b9f$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $78da16583ad93b9f$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $78da16583ad93b9f$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $78da16583ad93b9f$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($78da16583ad93b9f$var$hasMismatch && true) console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $78da16583ad93b9f$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            if (!("__vnode" in node)) Object.defineProperty(node, "__vnode", {
                value: vnode,
                enumerable: false
            });
            if (!("__vueParentComponent" in node)) Object.defineProperty(node, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $78da16583ad93b9f$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $78da16583ad93b9f$var$hasMismatch = true;
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $78da16583ad93b9f$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $78da16583ad93b9f$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $78da16583ad93b9f$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $78da16583ad93b9f$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($78da16583ad93b9f$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $78da16583ad93b9f$var$getContainerType(container), optimized);
                    if ($78da16583ad93b9f$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $78da16583ad93b9f$export$22f9b5ffd89dac9("") : $78da16583ad93b9f$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $78da16583ad93b9f$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $78da16583ad93b9f$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $78da16583ad93b9f$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $78da16583ad93b9f$var$needTransition(parentSuspense, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $78da16583ad93b9f$var$hasMismatch = true;
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $78da16583ad93b9f$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $78da16583ad93b9f$var$hasMismatch = true;
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $78da16583ad93b9f$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) for(const key in props){
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $78da16583ad93b9f$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $78da16583ad93b9f$var$hasMismatch = true;
                    if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $X5A94.isOn)(key) && !(0, $X5A94.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                    key[0] === ".") patchProp(el, key, null, props[key], void 0, void 0, parentComponent);
                }
                else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $78da16583ad93b9f$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $78da16583ad93b9f$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $78da16583ad93b9f$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $78da16583ad93b9f$var$hasMismatch = true;
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                    $78da16583ad93b9f$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                    hasWarned = true;
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $78da16583ad93b9f$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $78da16583ad93b9f$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $78da16583ad93b9f$var$hasMismatch = true;
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $78da16583ad93b9f$var$hasMismatch = true;
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $78da16583ad93b9f$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 /* TEXT */  ? `(text)` : $78da16583ad93b9f$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $78da16583ad93b9f$var$getContainerType(container), slotScopeIds);
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $78da16583ad93b9f$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 /* ELEMENT */  && node.tagName.toLowerCase() === "template";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $78da16583ad93b9f$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    var _a;
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $X5A94.normalizeClass)(clientValue);
        if (!$78da16583ad93b9f$var$isSetEqual($78da16583ad93b9f$var$toClassSet(actual || ""), $78da16583ad93b9f$var$toClassSet(expected))) mismatchType = mismatchKey = `class`;
    } else if (key === "style") {
        actual = el.getAttribute("style");
        expected = (0, $X5A94.isString)(clientValue) ? clientValue : (0, $X5A94.stringifyStyle)((0, $X5A94.normalizeStyle)(clientValue));
        const actualMap = $78da16583ad93b9f$var$toStyleMap(actual);
        const expectedMap = $78da16583ad93b9f$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        const root = instance == null ? void 0 : instance.subTree;
        if (vnode === root || (root == null ? void 0 : root.type) === $78da16583ad93b9f$export$ffb0004e005737fa && root.children.includes(vnode)) {
            const cssVars = (_a = instance == null ? void 0 : instance.getCssVars) == null ? void 0 : _a.call(instance);
            for(const key2 in cssVars)expectedMap.set(`--${key2}`, String(cssVars[key2]));
        }
        if (!$78da16583ad93b9f$var$isMapEqual(actualMap, expectedMap)) mismatchType = mismatchKey = "style";
    } else if (el instanceof SVGElement && (0, $X5A94.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $X5A94.isBooleanAttr)(key) || (0, $X5A94.isKnownHtmlAttr)(key))) {
        if ((0, $X5A94.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $X5A94.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $X5A94.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = `attribute`;
            mismatchKey = key;
        }
    }
    if (mismatchType) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${mismatchType} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $78da16583ad93b9f$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $78da16583ad93b9f$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $78da16583ad93b9f$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $78da16583ad93b9f$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key == null ? void 0 : key.trim();
        value = value == null ? void 0 : value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $78da16583ad93b9f$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
let $78da16583ad93b9f$var$supported;
let $78da16583ad93b9f$var$perf;
function $78da16583ad93b9f$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $78da16583ad93b9f$var$isSupported()) $78da16583ad93b9f$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsPerfStart(instance, type, $78da16583ad93b9f$var$isSupported() ? $78da16583ad93b9f$var$perf.now() : Date.now());
}
function $78da16583ad93b9f$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $78da16583ad93b9f$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $78da16583ad93b9f$var$perf.mark(endTag);
        $78da16583ad93b9f$var$perf.measure(`<${$78da16583ad93b9f$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $78da16583ad93b9f$var$perf.clearMarks(startTag);
        $78da16583ad93b9f$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsPerfEnd(instance, type, $78da16583ad93b9f$var$isSupported() ? $78da16583ad93b9f$var$perf.now() : Date.now());
}
function $78da16583ad93b9f$var$isSupported() {
    if ($78da16583ad93b9f$var$supported !== void 0) return $78da16583ad93b9f$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $78da16583ad93b9f$var$supported = true;
        $78da16583ad93b9f$var$perf = window.performance;
    } else $78da16583ad93b9f$var$supported = false;
    return $78da16583ad93b9f$var$supported;
}
function $78da16583ad93b9f$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $X5A94.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $X5A94.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $X5A94.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $78da16583ad93b9f$var$queuePostRenderEffect = $78da16583ad93b9f$var$queueEffectWithSuspense;
function $78da16583ad93b9f$export$53ae2f996c64e9a(options) {
    return $78da16583ad93b9f$var$baseCreateRenderer(options);
}
function $78da16583ad93b9f$export$200524cf0d997ff0(options) {
    return $78da16583ad93b9f$var$baseCreateRenderer(options, $78da16583ad93b9f$var$createHydrationFunctions);
}
function $78da16583ad93b9f$var$baseCreateRenderer(options, createHydrationFns) {
    $78da16583ad93b9f$var$initFeatureFlags();
    const target = (0, $X5A94.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $X5A94.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$78da16583ad93b9f$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $78da16583ad93b9f$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $78da16583ad93b9f$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $78da16583ad93b9f$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $78da16583ad93b9f$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $78da16583ad93b9f$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $78da16583ad93b9f$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $X5A94.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $78da16583ad93b9f$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            vnodeHook && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(children[i]) : $78da16583ad93b9f$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $X5A94.EMPTY_OBJ);
        const newProps = n2.props || (0, $X5A94.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $78da16583ad93b9f$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $78da16583ad93b9f$var$toggleRecurse(parentComponent, true);
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $78da16583ad93b9f$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $78da16583ad93b9f$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            vnodeHook && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $78da16583ad93b9f$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $78da16583ad93b9f$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$78da16583ad93b9f$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $X5A94.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $X5A94.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $X5A94.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $78da16583ad93b9f$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $78da16583ad93b9f$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($78da16583ad93b9f$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $78da16583ad93b9f$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($78da16583ad93b9f$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $78da16583ad93b9f$var$invalidateJob(instance.update);
                instance.effect.dirty = true;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $78da16583ad93b9f$var$isAsyncWrapper(initialVNode);
                $78da16583ad93b9f$var$toggleRecurse(instance, false);
                if (bm) (0, $X5A94.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $78da16583ad93b9f$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $78da16583ad93b9f$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $78da16583ad93b9f$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $78da16583ad93b9f$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $78da16583ad93b9f$var$queuePostRenderEffect(()=>$78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $78da16583ad93b9f$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $78da16583ad93b9f$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $78da16583ad93b9f$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $78da16583ad93b9f$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $X5A94.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $78da16583ad93b9f$var$toggleRecurse(instance, true);
                const nextTree = $78da16583ad93b9f$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $78da16583ad93b9f$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $78da16583ad93b9f$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $78da16583ad93b9f$var$queuePostRenderEffect(()=>$78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, $8bTPG.ReactiveEffect)(componentUpdateFn, (0, $X5A94.NOOP), ()=>$78da16583ad93b9f$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>{
            if (effect.dirty) effect.run();
        };
        update.id = instance.uid;
        $78da16583ad93b9f$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $78da16583ad93b9f$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $78da16583ad93b9f$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $8bTPG.pauseTracking)();
        $78da16583ad93b9f$var$flushPreFlushCbs(instance);
        (0, $8bTPG.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $X5A94.EMPTY_ARR);
        c2 = c2 || (0, $X5A94.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]);
            if ($78da16583ad93b9f$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[e2]) : $78da16583ad93b9f$var$normalizeVNode(c2[e2]);
            if ($78da16583ad93b9f$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $78da16583ad93b9f$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $78da16583ad93b9f$var$getSequence(newIndexToOldIndexMap) : (0, $X5A94.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $78da16583ad93b9f$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $78da16583ad93b9f$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $78da16583ad93b9f$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (ref != null) $78da16583ad93b9f$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$78da16583ad93b9f$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $78da16583ad93b9f$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $78da16583ad93b9f$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            vnodeHook && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $78da16583ad93b9f$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $78da16583ad93b9f$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        if (bum) (0, $X5A94.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $78da16583ad93b9f$var$queuePostRenderEffect(um, parentSuspense);
        $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        if (!isFlushing) {
            isFlushing = true;
            $78da16583ad93b9f$var$flushPreFlushCbs();
            $78da16583ad93b9f$var$flushPostFlushCbs();
            isFlushing = false;
        }
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $78da16583ad93b9f$var$createAppAPI(render, hydrate)
    };
}
function $78da16583ad93b9f$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $78da16583ad93b9f$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $78da16583ad93b9f$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $78da16583ad93b9f$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $X5A94.isArray)(ch1) && (0, $X5A94.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $78da16583ad93b9f$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $78da16583ad93b9f$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $78da16583ad93b9f$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $78da16583ad93b9f$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $78da16583ad93b9f$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $78da16583ad93b9f$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
const $78da16583ad93b9f$var$isTeleport = (type)=>type.__isTeleport;
const $78da16583ad93b9f$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $78da16583ad93b9f$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $78da16583ad93b9f$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $78da16583ad93b9f$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $X5A94.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $78da16583ad93b9f$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $78da16583ad93b9f$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $78da16583ad93b9f$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                if (namespace === "svg" || $78da16583ad93b9f$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace === "mathml" || $78da16583ad93b9f$var$isTargetMathML(target)) namespace = "mathml";
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $78da16583ad93b9f$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $78da16583ad93b9f$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $78da16583ad93b9f$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $78da16583ad93b9f$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $78da16583ad93b9f$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $78da16583ad93b9f$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $78da16583ad93b9f$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $78da16583ad93b9f$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $78da16583ad93b9f$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$78da16583ad93b9f$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $78da16583ad93b9f$var$moveTeleport,
    hydrate: $78da16583ad93b9f$var$hydrateTeleport
};
function $78da16583ad93b9f$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $78da16583ad93b9f$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $78da16583ad93b9f$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $78da16583ad93b9f$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($78da16583ad93b9f$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $78da16583ad93b9f$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $78da16583ad93b9f$export$76d55a0304a371f4 = $78da16583ad93b9f$var$TeleportImpl;
function $78da16583ad93b9f$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node && node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $78da16583ad93b9f$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $78da16583ad93b9f$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $78da16583ad93b9f$export$4d299b491347818a = Symbol.for("v-cmt");
const $78da16583ad93b9f$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $78da16583ad93b9f$var$blockStack = [];
let $78da16583ad93b9f$var$currentBlock = null;
function $78da16583ad93b9f$export$e7eaa45e502fe5cc(disableTracking = false) {
    $78da16583ad93b9f$var$blockStack.push($78da16583ad93b9f$var$currentBlock = disableTracking ? null : []);
}
function $78da16583ad93b9f$var$closeBlock() {
    $78da16583ad93b9f$var$blockStack.pop();
    $78da16583ad93b9f$var$currentBlock = $78da16583ad93b9f$var$blockStack[$78da16583ad93b9f$var$blockStack.length - 1] || null;
}
let $78da16583ad93b9f$var$isBlockTreeEnabled = 1;
function $78da16583ad93b9f$export$c20bee82f26f1e27(value) {
    $78da16583ad93b9f$var$isBlockTreeEnabled += value;
}
function $78da16583ad93b9f$var$setupBlock(vnode) {
    vnode.dynamicChildren = $78da16583ad93b9f$var$isBlockTreeEnabled > 0 ? $78da16583ad93b9f$var$currentBlock || (0, $X5A94.EMPTY_ARR) : null;
    $78da16583ad93b9f$var$closeBlock();
    if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && $78da16583ad93b9f$var$currentBlock) $78da16583ad93b9f$var$currentBlock.push(vnode);
    return vnode;
}
function $78da16583ad93b9f$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $78da16583ad93b9f$var$setupBlock($78da16583ad93b9f$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $78da16583ad93b9f$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $78da16583ad93b9f$var$setupBlock($78da16583ad93b9f$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $78da16583ad93b9f$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $78da16583ad93b9f$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $78da16583ad93b9f$var$vnodeArgsTransformer;
function $78da16583ad93b9f$export$83beccd3afeeb809(transformer) {
    $78da16583ad93b9f$var$vnodeArgsTransformer = transformer;
}
const $78da16583ad93b9f$var$createVNodeWithArgsTransform = (...args)=>{
    return $78da16583ad93b9f$var$_createVNode(...$78da16583ad93b9f$var$vnodeArgsTransformer ? $78da16583ad93b9f$var$vnodeArgsTransformer(args, $78da16583ad93b9f$var$currentRenderingInstance) : args);
};
const $78da16583ad93b9f$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $78da16583ad93b9f$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $X5A94.isString)(ref) || (0, $8bTPG.isRef)(ref) || (0, $X5A94.isFunction)(ref) ? {
        i: $78da16583ad93b9f$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $78da16583ad93b9f$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $78da16583ad93b9f$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $78da16583ad93b9f$var$normalizeKey(props),
        ref: props && $78da16583ad93b9f$var$normalizeRef(props),
        scopeId: $78da16583ad93b9f$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $78da16583ad93b9f$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $78da16583ad93b9f$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $X5A94.isString)(children) ? 8 : 16;
    if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $78da16583ad93b9f$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $78da16583ad93b9f$var$currentBlock.push(vnode);
    return vnode;
}
const $78da16583ad93b9f$export$bf5c4cf060303d58 = $78da16583ad93b9f$var$_createVNode;
function $78da16583ad93b9f$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $78da16583ad93b9f$var$NULL_DYNAMIC_COMPONENT) type = $78da16583ad93b9f$export$4d299b491347818a;
    if ($78da16583ad93b9f$export$3868d13f8734ae81(type)) {
        const cloned = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $78da16583ad93b9f$var$normalizeChildren(cloned, children);
        if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && !isBlockNode && $78da16583ad93b9f$var$currentBlock) {
            if (cloned.shapeFlag & 6) $78da16583ad93b9f$var$currentBlock[$78da16583ad93b9f$var$currentBlock.indexOf(type)] = cloned;
            else $78da16583ad93b9f$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($78da16583ad93b9f$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $78da16583ad93b9f$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $X5A94.isString)(klass)) props.class = (0, $X5A94.normalizeClass)(klass);
        if ((0, $X5A94.isObject)(style)) {
            if ((0, $8bTPG.isProxy)(style) && !(0, $X5A94.isArray)(style)) style = (0, $X5A94.extend)({}, style);
            props.style = (0, $X5A94.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $X5A94.isString)(type) ? 1 : $78da16583ad93b9f$var$isSuspense(type) ? 128 : $78da16583ad93b9f$var$isTeleport(type) ? 64 : (0, $X5A94.isObject)(type) ? 4 : (0, $X5A94.isFunction)(type) ? 2 : 0;
    return $78da16583ad93b9f$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $78da16583ad93b9f$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $8bTPG.isProxy)(props) || $78da16583ad93b9f$var$isInternalObject(props) ? (0, $X5A94.extend)({}, props) : props;
}
function $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children } = vnode;
    const mergedProps = extraProps ? $78da16583ad93b9f$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $78da16583ad93b9f$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $X5A94.isArray)(ref) ? ref.concat($78da16583ad93b9f$var$normalizeRef(extraProps)) : [
            ref,
            $78da16583ad93b9f$var$normalizeRef(extraProps)
        ] : $78da16583ad93b9f$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $78da16583ad93b9f$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    return cloned;
}
function $78da16583ad93b9f$var$deepCloneVNode(vnode) {
    const cloned = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $X5A94.isArray)(vnode.children)) cloned.children = vnode.children.map($78da16583ad93b9f$var$deepCloneVNode);
    return cloned;
}
function $78da16583ad93b9f$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$5f1af8db9871e1d6, null, text, flag);
}
function $78da16583ad93b9f$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $78da16583ad93b9f$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($78da16583ad93b9f$export$e7eaa45e502fe5cc(), $78da16583ad93b9f$export$9f2dfe8048dfb22b($78da16583ad93b9f$export$4d299b491347818a, null, text)) : $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a, null, text);
}
function $78da16583ad93b9f$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
    else if ((0, $X5A94.isArray)(child)) return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $78da16583ad93b9f$var$cloneIfMounted(child);
    else return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$5f1af8db9871e1d6, null, String(child));
}
function $78da16583ad93b9f$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $78da16583ad93b9f$export$ee4f9e12c0a92a1a(child);
}
function $78da16583ad93b9f$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $X5A94.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $78da16583ad93b9f$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$78da16583ad93b9f$var$isInternalObject(children)) children._ctx = $78da16583ad93b9f$var$currentRenderingInstance;
            else if (slotFlag === 3 && $78da16583ad93b9f$var$currentRenderingInstance) {
                if ($78da16583ad93b9f$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $X5A94.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $78da16583ad93b9f$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $78da16583ad93b9f$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $78da16583ad93b9f$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $X5A94.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $X5A94.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $X5A94.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $X5A94.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $78da16583ad93b9f$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $78da16583ad93b9f$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $78da16583ad93b9f$var$emptyAppContext = $78da16583ad93b9f$var$createAppContext();
let $78da16583ad93b9f$var$uid = 0;
function $78da16583ad93b9f$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $78da16583ad93b9f$var$emptyAppContext;
    const instance = {
        uid: $78da16583ad93b9f$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $8bTPG.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $78da16583ad93b9f$var$normalizePropsOptions(type, appContext),
        emitsOptions: $78da16583ad93b9f$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $X5A94.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $X5A94.EMPTY_OBJ),
        data: (0, $X5A94.EMPTY_OBJ),
        props: (0, $X5A94.EMPTY_OBJ),
        attrs: (0, $X5A94.EMPTY_OBJ),
        slots: (0, $X5A94.EMPTY_OBJ),
        refs: (0, $X5A94.EMPTY_OBJ),
        setupState: (0, $X5A94.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $78da16583ad93b9f$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $78da16583ad93b9f$var$currentInstance = null;
const $78da16583ad93b9f$export$f13e630aa3915748 = ()=>$78da16583ad93b9f$var$currentInstance || $78da16583ad93b9f$var$currentRenderingInstance;
let $78da16583ad93b9f$var$internalSetCurrentInstance;
let $78da16583ad93b9f$var$setInSSRSetupState;
{
    const g = (0, $X5A94.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $78da16583ad93b9f$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$78da16583ad93b9f$var$currentInstance = v1);
    $78da16583ad93b9f$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$78da16583ad93b9f$var$isInSSRComponentSetup = v1);
}const $78da16583ad93b9f$var$setCurrentInstance = (instance)=>{
    const prev = $78da16583ad93b9f$var$currentInstance;
    $78da16583ad93b9f$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $78da16583ad93b9f$var$internalSetCurrentInstance(prev);
    };
};
const $78da16583ad93b9f$var$unsetCurrentInstance = ()=>{
    $78da16583ad93b9f$var$currentInstance && $78da16583ad93b9f$var$currentInstance.scope.off();
    $78da16583ad93b9f$var$internalSetCurrentInstance(null);
};
const $78da16583ad93b9f$var$isBuiltInTag = /* @__PURE__ */ (0, $X5A94.makeMap)("slot,component");
function $78da16583ad93b9f$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($78da16583ad93b9f$var$isBuiltInTag(name) || isNativeTag(name)) $78da16583ad93b9f$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $78da16583ad93b9f$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $78da16583ad93b9f$var$isInSSRComponentSetup = false;
function $78da16583ad93b9f$var$setupComponent(instance, isSSR = false) {
    isSSR && $78da16583ad93b9f$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $78da16583ad93b9f$var$isStatefulComponent(instance);
    $78da16583ad93b9f$var$initProps(instance, props, isStateful, isSSR);
    $78da16583ad93b9f$var$initSlots(instance, children);
    const setupResult = isStateful ? $78da16583ad93b9f$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $78da16583ad93b9f$var$setInSSRSetupState(false);
    return setupResult;
}
function $78da16583ad93b9f$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $78da16583ad93b9f$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $78da16583ad93b9f$var$createSetupContext(instance) : null;
        const reset = $78da16583ad93b9f$var$setCurrentInstance(instance);
        (0, $8bTPG.pauseTracking)();
        const setupResult = $78da16583ad93b9f$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $8bTPG.resetTracking)();
        reset();
        if ((0, $X5A94.isPromise)(setupResult)) {
            setupResult.then($78da16583ad93b9f$var$unsetCurrentInstance, $78da16583ad93b9f$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $78da16583ad93b9f$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $78da16583ad93b9f$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $78da16583ad93b9f$var$handleSetupResult(instance, setupResult, isSSR);
    } else $78da16583ad93b9f$var$finishComponentSetup(instance, isSSR);
}
function $78da16583ad93b9f$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $X5A94.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $X5A94.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $8bTPG.proxyRefs)(setupResult);
    }
    $78da16583ad93b9f$var$finishComponentSetup(instance, isSSR);
}
let $78da16583ad93b9f$var$compile;
let $78da16583ad93b9f$var$installWithProxy;
function $78da16583ad93b9f$export$667bb5a67822b941(_compile) {
    $78da16583ad93b9f$var$compile = _compile;
    $78da16583ad93b9f$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $78da16583ad93b9f$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $78da16583ad93b9f$export$c93a9c496c5211fa = ()=>!$78da16583ad93b9f$var$compile;
function $78da16583ad93b9f$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $78da16583ad93b9f$var$compile && !Component.render) {
            const template = Component.template || $78da16583ad93b9f$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $X5A94.extend)((0, $X5A94.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $78da16583ad93b9f$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $X5A94.NOOP);
        if ($78da16583ad93b9f$var$installWithProxy) $78da16583ad93b9f$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $78da16583ad93b9f$var$setCurrentInstance(instance);
        (0, $8bTPG.pauseTracking)();
        try {
            $78da16583ad93b9f$var$applyOptions(instance);
        } finally{
            (0, $8bTPG.resetTracking)();
            reset();
        }
    }
}
const $78da16583ad93b9f$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $8bTPG.track)(target, "get", "");
        return target[key];
    }
};
function $78da16583ad93b9f$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $8bTPG.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $78da16583ad93b9f$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $78da16583ad93b9f$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $78da16583ad93b9f$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $8bTPG.proxyRefs)((0, $8bTPG.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $78da16583ad93b9f$var$publicPropertiesMap) return $78da16583ad93b9f$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $78da16583ad93b9f$var$publicPropertiesMap;
        }
    }));
}
const $78da16583ad93b9f$var$classifyRE = /(?:^|[-_])(\w)/g;
const $78da16583ad93b9f$var$classify = (str)=>str.replace($78da16583ad93b9f$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $78da16583ad93b9f$var$getComponentName(Component, includeInferred = true) {
    return (0, $X5A94.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $78da16583ad93b9f$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $78da16583ad93b9f$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $78da16583ad93b9f$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $78da16583ad93b9f$var$isClassComponent(value) {
    return (0, $X5A94.isFunction)(value) && "__vccOpts" in value;
}
const $78da16583ad93b9f$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $8bTPG.computed)(getterOrOptions, debugOptions, $78da16583ad93b9f$var$isInSSRComponentSetup);
    return c;
};
function $78da16583ad93b9f$export$fb78bd113157f1a1(props, name, options = (0, $X5A94.EMPTY_OBJ)) {
    const i = $78da16583ad93b9f$export$f13e630aa3915748();
    const camelizedName = (0, $X5A94.camelize)(name);
    const hyphenatedName = (0, $X5A94.hyphenate)(name);
    const res = (0, $8bTPG.customRef)((track, trigger)=>{
        let localValue;
        $78da16583ad93b9f$export$2035654f31b0e555(()=>{
            const propValue = props[name];
            if ((0, $X5A94.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps)) && (0, $X5A94.hasChanged)(value, localValue)) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, options.set ? options.set(value) : value);
            }
        };
    });
    const modifierKey = name === "modelValue" ? "modelModifiers" : `${name}Modifiers`;
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? props[modifierKey] || {} : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
function $78da16583ad93b9f$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $X5A94.isObject)(propsOrChildren) && !(0, $X5A94.isArray)(propsOrChildren)) {
            if ($78da16583ad93b9f$export$3868d13f8734ae81(propsOrChildren)) return $78da16583ad93b9f$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $78da16583ad93b9f$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $78da16583ad93b9f$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $78da16583ad93b9f$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $78da16583ad93b9f$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $78da16583ad93b9f$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $8bTPG.toRaw)(instance.props)));
        if (instance.setupState !== (0, $X5A94.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $X5A94.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $8bTPG.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $X5A94.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $X5A94.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $8bTPG.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $X5A94.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $X5A94.isArray)(opts) && opts.includes(key) || (0, $X5A94.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $8bTPG.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $78da16583ad93b9f$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $78da16583ad93b9f$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $78da16583ad93b9f$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $X5A94.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && $78da16583ad93b9f$var$currentBlock) $78da16583ad93b9f$var$currentBlock.push(cached);
    return true;
}
const $78da16583ad93b9f$export$83d89fbfd8236492 = "3.4.23";
const $78da16583ad93b9f$export$c106dd0671a0fc2d = (0, $X5A94.NOOP);
const $78da16583ad93b9f$export$795e0ad4a0e2ed30 = $78da16583ad93b9f$var$ErrorTypeStrings$1;
const $78da16583ad93b9f$export$6922d3b3a607469e = $78da16583ad93b9f$var$devtools$1;
const $78da16583ad93b9f$export$b0c258b32c26c785 = $78da16583ad93b9f$var$setDevtoolsHook$1;
const $78da16583ad93b9f$var$_ssrUtils = {
    createComponentInstance: $78da16583ad93b9f$var$createComponentInstance,
    setupComponent: $78da16583ad93b9f$var$setupComponent,
    renderComponentRoot: $78da16583ad93b9f$var$renderComponentRoot,
    setCurrentRenderingInstance: $78da16583ad93b9f$var$setCurrentRenderingInstance,
    isVNode: $78da16583ad93b9f$export$3868d13f8734ae81,
    normalizeVNode: $78da16583ad93b9f$var$normalizeVNode
};
const $78da16583ad93b9f$export$a9679033567b336d = $78da16583ad93b9f$var$_ssrUtils;
const $78da16583ad93b9f$export$83cf26e06ea620e1 = null;
const $78da16583ad93b9f$export$dc678eddf276286e = null;
const $78da16583ad93b9f$export$22072a82865312f6 = null;

});
parcelRegister("8bTPG", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $5f6aa8fade9cc028$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $5f6aa8fade9cc028$export$7056603ea81600be);
$parcel$export(module.exports, "getCurrentScope", () => $5f6aa8fade9cc028$export$c7be4b0125a10cba);
$parcel$export(module.exports, "onScopeDispose", () => $5f6aa8fade9cc028$export$a780418acd4762da);
$parcel$export(module.exports, "ReactiveEffect", () => $5f6aa8fade9cc028$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $5f6aa8fade9cc028$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $5f6aa8fade9cc028$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $5f6aa8fade9cc028$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $5f6aa8fade9cc028$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $5f6aa8fade9cc028$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isRef", () => $5f6aa8fade9cc028$export$4f9f5282de18fc69);
$parcel$export(module.exports, "readonly", () => $5f6aa8fade9cc028$export$6ec456bd5b7b3c51);
$parcel$export(module.exports, "reactive", () => $5f6aa8fade9cc028$export$90a44edba14e47be);
$parcel$export(module.exports, "isReadonly", () => $5f6aa8fade9cc028$export$92d09b48637741e7);
$parcel$export(module.exports, "isShallow", () => $5f6aa8fade9cc028$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "shallowReactive", () => $5f6aa8fade9cc028$export$8d81cefd22d22260);
$parcel$export(module.exports, "isReactive", () => $5f6aa8fade9cc028$export$352205f445242f02);
$parcel$export(module.exports, "isProxy", () => $5f6aa8fade9cc028$export$5f3ca29d057519b3);
$parcel$export(module.exports, "markRaw", () => $5f6aa8fade9cc028$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "computed", () => $5f6aa8fade9cc028$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "ref", () => $5f6aa8fade9cc028$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $5f6aa8fade9cc028$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $5f6aa8fade9cc028$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $5f6aa8fade9cc028$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $5f6aa8fade9cc028$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $5f6aa8fade9cc028$export$2e9533675e5e70e0);
$parcel$export(module.exports, "toRef", () => $5f6aa8fade9cc028$export$1f60508e4f47b4b7);
/**
* @vue/reactivity v3.4.23
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $X5A94 = parcelRequire("X5A94");
function $5f6aa8fade9cc028$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $5f6aa8fade9cc028$var$activeEffectScope;
class $5f6aa8fade9cc028$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $5f6aa8fade9cc028$var$activeEffectScope;
        if (!detached && $5f6aa8fade9cc028$var$activeEffectScope) this.index = ($5f6aa8fade9cc028$var$activeEffectScope.scopes || ($5f6aa8fade9cc028$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $5f6aa8fade9cc028$var$activeEffectScope;
            try {
                $5f6aa8fade9cc028$var$activeEffectScope = this;
                return fn();
            } finally{
                $5f6aa8fade9cc028$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $5f6aa8fade9cc028$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $5f6aa8fade9cc028$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function $5f6aa8fade9cc028$export$7056603ea81600be(detached) {
    return new $5f6aa8fade9cc028$export$1168ed9dbc71ddbd(detached);
}
function $5f6aa8fade9cc028$var$recordEffectScope(effect, scope = $5f6aa8fade9cc028$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $5f6aa8fade9cc028$export$c7be4b0125a10cba() {
    return $5f6aa8fade9cc028$var$activeEffectScope;
}
function $5f6aa8fade9cc028$export$a780418acd4762da(fn) {
    if ($5f6aa8fade9cc028$var$activeEffectScope) $5f6aa8fade9cc028$var$activeEffectScope.cleanups.push(fn);
}
let $5f6aa8fade9cc028$var$activeEffect;
class $5f6aa8fade9cc028$export$28352bb4dd362521 {
    constructor(fn, trigger, scheduler, scope){
        this.fn = fn;
        this.trigger = trigger;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        /**
     * @internal
     */ this._dirtyLevel = 4;
        /**
     * @internal
     */ this._trackId = 0;
        /**
     * @internal
     */ this._runnings = 0;
        /**
     * @internal
     */ this._shouldSchedule = false;
        /**
     * @internal
     */ this._depsLength = 0;
        $5f6aa8fade9cc028$var$recordEffectScope(this, scope);
    }
    get dirty() {
        if (this._dirtyLevel === 2 || this._dirtyLevel === 3) {
            this._dirtyLevel = 1;
            $5f6aa8fade9cc028$export$938a971395fef855();
            for(let i = 0; i < this._depsLength; i++){
                const dep = this.deps[i];
                if (dep.computed) {
                    $5f6aa8fade9cc028$var$triggerComputed(dep.computed);
                    if (this._dirtyLevel >= 4) break;
                }
            }
            if (this._dirtyLevel === 1) this._dirtyLevel = 0;
            $5f6aa8fade9cc028$export$c39176b1babaa8b8();
        }
        return this._dirtyLevel >= 4;
    }
    set dirty(v) {
        this._dirtyLevel = v ? 4 : 0;
    }
    run() {
        this._dirtyLevel = 0;
        if (!this.active) return this.fn();
        let lastShouldTrack = $5f6aa8fade9cc028$var$shouldTrack;
        let lastEffect = $5f6aa8fade9cc028$var$activeEffect;
        try {
            $5f6aa8fade9cc028$var$shouldTrack = true;
            $5f6aa8fade9cc028$var$activeEffect = this;
            this._runnings++;
            $5f6aa8fade9cc028$var$preCleanupEffect(this);
            return this.fn();
        } finally{
            $5f6aa8fade9cc028$var$postCleanupEffect(this);
            this._runnings--;
            $5f6aa8fade9cc028$var$activeEffect = lastEffect;
            $5f6aa8fade9cc028$var$shouldTrack = lastShouldTrack;
        }
    }
    stop() {
        var _a;
        if (this.active) {
            $5f6aa8fade9cc028$var$preCleanupEffect(this);
            $5f6aa8fade9cc028$var$postCleanupEffect(this);
            (_a = this.onStop) == null || _a.call(this);
            this.active = false;
        }
    }
}
function $5f6aa8fade9cc028$var$triggerComputed(computed) {
    return computed.value;
}
function $5f6aa8fade9cc028$var$preCleanupEffect(effect2) {
    effect2._trackId++;
    effect2._depsLength = 0;
}
function $5f6aa8fade9cc028$var$postCleanupEffect(effect2) {
    if (effect2.deps.length > effect2._depsLength) {
        for(let i = effect2._depsLength; i < effect2.deps.length; i++)$5f6aa8fade9cc028$var$cleanupDepEffect(effect2.deps[i], effect2);
        effect2.deps.length = effect2._depsLength;
    }
}
function $5f6aa8fade9cc028$var$cleanupDepEffect(dep, effect2) {
    const trackId = dep.get(effect2);
    if (trackId !== void 0 && effect2._trackId !== trackId) {
        dep.delete(effect2);
        if (dep.size === 0) dep.cleanup();
    }
}
function $5f6aa8fade9cc028$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $5f6aa8fade9cc028$export$28352bb4dd362521) fn = fn.effect.fn;
    const _effect = new $5f6aa8fade9cc028$export$28352bb4dd362521(fn, (0, $X5A94.NOOP), ()=>{
        if (_effect.dirty) _effect.run();
    });
    if (options) {
        (0, $X5A94.extend)(_effect, options);
        if (options.scope) $5f6aa8fade9cc028$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $5f6aa8fade9cc028$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $5f6aa8fade9cc028$var$shouldTrack = true;
let $5f6aa8fade9cc028$var$pauseScheduleStack = 0;
const $5f6aa8fade9cc028$var$trackStack = [];
function $5f6aa8fade9cc028$export$938a971395fef855() {
    $5f6aa8fade9cc028$var$trackStack.push($5f6aa8fade9cc028$var$shouldTrack);
    $5f6aa8fade9cc028$var$shouldTrack = false;
}
function $5f6aa8fade9cc028$export$1f8ffc6fd33b1d16() {
    $5f6aa8fade9cc028$var$trackStack.push($5f6aa8fade9cc028$var$shouldTrack);
    $5f6aa8fade9cc028$var$shouldTrack = true;
}
function $5f6aa8fade9cc028$export$c39176b1babaa8b8() {
    const last = $5f6aa8fade9cc028$var$trackStack.pop();
    $5f6aa8fade9cc028$var$shouldTrack = last === void 0 ? true : last;
}
function $5f6aa8fade9cc028$export$262a949f95482a17() {
    $5f6aa8fade9cc028$var$pauseScheduleStack++;
}
function $5f6aa8fade9cc028$export$3539fa10306ef581() {
    $5f6aa8fade9cc028$var$pauseScheduleStack--;
    while(!$5f6aa8fade9cc028$var$pauseScheduleStack && $5f6aa8fade9cc028$var$queueEffectSchedulers.length)$5f6aa8fade9cc028$var$queueEffectSchedulers.shift()();
}
function $5f6aa8fade9cc028$var$trackEffect(effect2, dep, debuggerEventExtraInfo) {
    var _a;
    if (dep.get(effect2) !== effect2._trackId) {
        dep.set(effect2, effect2._trackId);
        const oldDep = effect2.deps[effect2._depsLength];
        if (oldDep !== dep) {
            if (oldDep) $5f6aa8fade9cc028$var$cleanupDepEffect(oldDep, effect2);
            effect2.deps[effect2._depsLength++] = dep;
        } else effect2._depsLength++;
    }
}
const $5f6aa8fade9cc028$var$queueEffectSchedulers = [];
function $5f6aa8fade9cc028$var$triggerEffects(dep, dirtyLevel, debuggerEventExtraInfo) {
    var _a;
    $5f6aa8fade9cc028$export$262a949f95482a17();
    for (const effect2 of dep.keys()){
        let tracking;
        if (effect2._dirtyLevel < dirtyLevel && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2._shouldSchedule || (effect2._shouldSchedule = effect2._dirtyLevel === 0);
            effect2._dirtyLevel = dirtyLevel;
        }
        if (effect2._shouldSchedule && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2.trigger();
            if ((!effect2._runnings || effect2.allowRecurse) && effect2._dirtyLevel !== 2) {
                effect2._shouldSchedule = false;
                if (effect2.scheduler) $5f6aa8fade9cc028$var$queueEffectSchedulers.push(effect2.scheduler);
            }
        }
    }
    $5f6aa8fade9cc028$export$3539fa10306ef581();
}
const $5f6aa8fade9cc028$var$createDep = (cleanup, computed)=>{
    const dep = /* @__PURE__ */ new Map();
    dep.cleanup = cleanup;
    dep.computed = computed;
    return dep;
};
const $5f6aa8fade9cc028$var$targetMap = /* @__PURE__ */ new WeakMap();
const $5f6aa8fade9cc028$export$3c41b1a4e06acc14 = Symbol("");
const $5f6aa8fade9cc028$var$MAP_KEY_ITERATE_KEY = Symbol("");
function $5f6aa8fade9cc028$export$6b2a7d5132615086(target, type, key) {
    if ($5f6aa8fade9cc028$var$shouldTrack && $5f6aa8fade9cc028$var$activeEffect) {
        let depsMap = $5f6aa8fade9cc028$var$targetMap.get(target);
        if (!depsMap) $5f6aa8fade9cc028$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $5f6aa8fade9cc028$var$createDep(()=>depsMap.delete(key)));
        $5f6aa8fade9cc028$var$trackEffect($5f6aa8fade9cc028$var$activeEffect, dep, void 0);
    }
}
function $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $5f6aa8fade9cc028$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $X5A94.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || !(0, $X5A94.isSymbol)(key2) && key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $X5A94.isArray)(target)) {
                    deps.push(depsMap.get($5f6aa8fade9cc028$export$3c41b1a4e06acc14));
                    if ((0, $X5A94.isMap)(target)) deps.push(depsMap.get($5f6aa8fade9cc028$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $X5A94.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $X5A94.isArray)(target)) {
                    deps.push(depsMap.get($5f6aa8fade9cc028$export$3c41b1a4e06acc14));
                    if ((0, $X5A94.isMap)(target)) deps.push(depsMap.get($5f6aa8fade9cc028$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $X5A94.isMap)(target)) deps.push(depsMap.get($5f6aa8fade9cc028$export$3c41b1a4e06acc14));
                break;
        }
    }
    $5f6aa8fade9cc028$export$262a949f95482a17();
    for (const dep of deps)if (dep) $5f6aa8fade9cc028$var$triggerEffects(dep, 4, void 0);
    $5f6aa8fade9cc028$export$3539fa10306ef581();
}
function $5f6aa8fade9cc028$var$getDepFromReactive(object, key) {
    var _a;
    return (_a = $5f6aa8fade9cc028$var$targetMap.get(object)) == null ? void 0 : _a.get(key);
}
const $5f6aa8fade9cc028$var$isNonTrackableKeys = /* @__PURE__ */ (0, $X5A94.makeMap)(`__proto__,__v_isRef,__isVue`);
const $5f6aa8fade9cc028$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $X5A94.isSymbol)));
const $5f6aa8fade9cc028$var$arrayInstrumentations = /* @__PURE__ */ $5f6aa8fade9cc028$var$createArrayInstrumentations();
function $5f6aa8fade9cc028$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$5f6aa8fade9cc028$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($5f6aa8fade9cc028$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $5f6aa8fade9cc028$export$938a971395fef855();
            $5f6aa8fade9cc028$export$262a949f95482a17();
            const res = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $5f6aa8fade9cc028$export$3539fa10306ef581();
            $5f6aa8fade9cc028$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $5f6aa8fade9cc028$var$hasOwnProperty(key) {
    if (!(0, $X5A94.isSymbol)(key)) key = String(key);
    const obj = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
    $5f6aa8fade9cc028$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $5f6aa8fade9cc028$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $5f6aa8fade9cc028$var$shallowReadonlyMap : $5f6aa8fade9cc028$var$readonlyMap : isShallow2 ? $5f6aa8fade9cc028$var$shallowReactiveMap : $5f6aa8fade9cc028$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the reciever is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $X5A94.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $X5A94.hasOwn)($5f6aa8fade9cc028$var$arrayInstrumentations, key)) return Reflect.get($5f6aa8fade9cc028$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $5f6aa8fade9cc028$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $X5A94.isSymbol)(key) ? $5f6aa8fade9cc028$var$builtInSymbols.has(key) : $5f6aa8fade9cc028$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $5f6aa8fade9cc028$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $X5A94.isIntegerKey)(key) ? res : res.value;
        if ((0, $X5A94.isObject)(res)) return isReadonly2 ? $5f6aa8fade9cc028$export$6ec456bd5b7b3c51(res) : $5f6aa8fade9cc028$export$90a44edba14e47be(res);
        return res;
    }
}
class $5f6aa8fade9cc028$var$MutableReactiveHandler extends $5f6aa8fade9cc028$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $5f6aa8fade9cc028$export$92d09b48637741e7(oldValue);
            if (!$5f6aa8fade9cc028$export$7f3fe6025abfa26e(value) && !$5f6aa8fade9cc028$export$92d09b48637741e7(value)) {
                oldValue = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(oldValue);
                value = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $X5A94.isArray)(target) && $5f6aa8fade9cc028$export$4f9f5282de18fc69(oldValue) && !$5f6aa8fade9cc028$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $X5A94.isArray)(target) && (0, $X5A94.isIntegerKey)(key) ? Number(key) < target.length : (0, $X5A94.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $5f6aa8fade9cc028$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $X5A94.hasChanged)(value, oldValue)) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $X5A94.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $X5A94.isSymbol)(key) || !$5f6aa8fade9cc028$var$builtInSymbols.has(key)) $5f6aa8fade9cc028$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $5f6aa8fade9cc028$export$6b2a7d5132615086(target, "iterate", (0, $X5A94.isArray)(target) ? "length" : $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $5f6aa8fade9cc028$var$ReadonlyReactiveHandler extends $5f6aa8fade9cc028$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $5f6aa8fade9cc028$var$mutableHandlers = /* @__PURE__ */ new $5f6aa8fade9cc028$var$MutableReactiveHandler();
const $5f6aa8fade9cc028$var$readonlyHandlers = /* @__PURE__ */ new $5f6aa8fade9cc028$var$ReadonlyReactiveHandler();
const $5f6aa8fade9cc028$var$shallowReactiveHandlers = /* @__PURE__ */ new $5f6aa8fade9cc028$var$MutableReactiveHandler(true);
const $5f6aa8fade9cc028$var$shallowReadonlyHandlers = /* @__PURE__ */ new $5f6aa8fade9cc028$var$ReadonlyReactiveHandler(true);
const $5f6aa8fade9cc028$var$toShallow = (value)=>value;
const $5f6aa8fade9cc028$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $5f6aa8fade9cc028$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
    const rawKey = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $X5A94.hasChanged)(key, rawKey)) $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "get", key);
        $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $5f6aa8fade9cc028$var$getProto(rawTarget);
    const wrap = isShallow ? $5f6aa8fade9cc028$var$toShallow : isReadonly ? $5f6aa8fade9cc028$var$toReadonly : $5f6aa8fade9cc028$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $5f6aa8fade9cc028$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
    const rawKey = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $X5A94.hasChanged)(key, rawKey)) $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "has", key);
        $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $5f6aa8fade9cc028$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $5f6aa8fade9cc028$export$6b2a7d5132615086($5f6aa8fade9cc028$export$ab18938b9fc5f28e(target), "iterate", $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $5f6aa8fade9cc028$var$add(value) {
    value = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
    const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
    const proto = $5f6aa8fade9cc028$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $5f6aa8fade9cc028$var$set(key, value) {
    value = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
    const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $5f6aa8fade9cc028$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $X5A94.hasChanged)(value, oldValue)) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $5f6aa8fade9cc028$var$deleteEntry(key) {
    const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $5f6aa8fade9cc028$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $5f6aa8fade9cc028$var$clear() {
    const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $5f6aa8fade9cc028$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $5f6aa8fade9cc028$var$toShallow : isReadonly ? $5f6aa8fade9cc028$var$toReadonly : $5f6aa8fade9cc028$var$toReactive;
        !isReadonly && $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "iterate", $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $5f6aa8fade9cc028$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $X5A94.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $5f6aa8fade9cc028$var$toShallow : isReadonly ? $5f6aa8fade9cc028$var$toReadonly : $5f6aa8fade9cc028$var$toReactive;
        !isReadonly && $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $5f6aa8fade9cc028$var$MAP_KEY_ITERATE_KEY : $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $5f6aa8fade9cc028$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $5f6aa8fade9cc028$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $5f6aa8fade9cc028$var$get(this, key);
        },
        get size () {
            return $5f6aa8fade9cc028$var$size(this);
        },
        has: $5f6aa8fade9cc028$var$has,
        add: $5f6aa8fade9cc028$var$add,
        set: $5f6aa8fade9cc028$var$set,
        delete: $5f6aa8fade9cc028$var$deleteEntry,
        clear: $5f6aa8fade9cc028$var$clear,
        forEach: $5f6aa8fade9cc028$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $5f6aa8fade9cc028$var$get(this, key, false, true);
        },
        get size () {
            return $5f6aa8fade9cc028$var$size(this);
        },
        has: $5f6aa8fade9cc028$var$has,
        add: $5f6aa8fade9cc028$var$add,
        set: $5f6aa8fade9cc028$var$set,
        delete: $5f6aa8fade9cc028$var$deleteEntry,
        clear: $5f6aa8fade9cc028$var$clear,
        forEach: $5f6aa8fade9cc028$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $5f6aa8fade9cc028$var$get(this, key, true);
        },
        get size () {
            return $5f6aa8fade9cc028$var$size(this, true);
        },
        has (key) {
            return $5f6aa8fade9cc028$var$has.call(this, key, true);
        },
        add: $5f6aa8fade9cc028$var$createReadonlyMethod("add"),
        set: $5f6aa8fade9cc028$var$createReadonlyMethod("set"),
        delete: $5f6aa8fade9cc028$var$createReadonlyMethod("delete"),
        clear: $5f6aa8fade9cc028$var$createReadonlyMethod("clear"),
        forEach: $5f6aa8fade9cc028$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $5f6aa8fade9cc028$var$get(this, key, true, true);
        },
        get size () {
            return $5f6aa8fade9cc028$var$size(this, true);
        },
        has (key) {
            return $5f6aa8fade9cc028$var$has.call(this, key, true);
        },
        add: $5f6aa8fade9cc028$var$createReadonlyMethod("add"),
        set: $5f6aa8fade9cc028$var$createReadonlyMethod("set"),
        delete: $5f6aa8fade9cc028$var$createReadonlyMethod("delete"),
        clear: $5f6aa8fade9cc028$var$createReadonlyMethod("clear"),
        forEach: $5f6aa8fade9cc028$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $5f6aa8fade9cc028$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $5f6aa8fade9cc028$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $5f6aa8fade9cc028$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $5f6aa8fade9cc028$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$5f6aa8fade9cc028$var$mutableInstrumentations, $5f6aa8fade9cc028$var$readonlyInstrumentations, $5f6aa8fade9cc028$var$shallowInstrumentations, $5f6aa8fade9cc028$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $5f6aa8fade9cc028$var$createInstrumentations();
function $5f6aa8fade9cc028$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $5f6aa8fade9cc028$var$shallowReadonlyInstrumentations : $5f6aa8fade9cc028$var$shallowInstrumentations : isReadonly ? $5f6aa8fade9cc028$var$readonlyInstrumentations : $5f6aa8fade9cc028$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $X5A94.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $5f6aa8fade9cc028$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $5f6aa8fade9cc028$var$createInstrumentationGetter(false, false)
};
const $5f6aa8fade9cc028$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $5f6aa8fade9cc028$var$createInstrumentationGetter(false, true)
};
const $5f6aa8fade9cc028$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $5f6aa8fade9cc028$var$createInstrumentationGetter(true, false)
};
const $5f6aa8fade9cc028$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $5f6aa8fade9cc028$var$createInstrumentationGetter(true, true)
};
function $5f6aa8fade9cc028$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $X5A94.toRawType)(target);
        $5f6aa8fade9cc028$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $5f6aa8fade9cc028$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $5f6aa8fade9cc028$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $5f6aa8fade9cc028$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $5f6aa8fade9cc028$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $5f6aa8fade9cc028$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $5f6aa8fade9cc028$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $5f6aa8fade9cc028$var$targetTypeMap((0, $X5A94.toRawType)(value));
}
function $5f6aa8fade9cc028$export$90a44edba14e47be(target) {
    if ($5f6aa8fade9cc028$export$92d09b48637741e7(target)) return target;
    return $5f6aa8fade9cc028$var$createReactiveObject(target, false, $5f6aa8fade9cc028$var$mutableHandlers, $5f6aa8fade9cc028$var$mutableCollectionHandlers, $5f6aa8fade9cc028$var$reactiveMap);
}
function $5f6aa8fade9cc028$export$8d81cefd22d22260(target) {
    return $5f6aa8fade9cc028$var$createReactiveObject(target, false, $5f6aa8fade9cc028$var$shallowReactiveHandlers, $5f6aa8fade9cc028$var$shallowCollectionHandlers, $5f6aa8fade9cc028$var$shallowReactiveMap);
}
function $5f6aa8fade9cc028$export$6ec456bd5b7b3c51(target) {
    return $5f6aa8fade9cc028$var$createReactiveObject(target, true, $5f6aa8fade9cc028$var$readonlyHandlers, $5f6aa8fade9cc028$var$readonlyCollectionHandlers, $5f6aa8fade9cc028$var$readonlyMap);
}
function $5f6aa8fade9cc028$export$7c4b5f2b50f09f6b(target) {
    return $5f6aa8fade9cc028$var$createReactiveObject(target, true, $5f6aa8fade9cc028$var$shallowReadonlyHandlers, $5f6aa8fade9cc028$var$shallowReadonlyCollectionHandlers, $5f6aa8fade9cc028$var$shallowReadonlyMap);
}
function $5f6aa8fade9cc028$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $X5A94.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $5f6aa8fade9cc028$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $5f6aa8fade9cc028$export$352205f445242f02(value) {
    if ($5f6aa8fade9cc028$export$92d09b48637741e7(value)) return $5f6aa8fade9cc028$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $5f6aa8fade9cc028$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $5f6aa8fade9cc028$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $5f6aa8fade9cc028$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $5f6aa8fade9cc028$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $5f6aa8fade9cc028$export$ab18938b9fc5f28e(raw) : observed;
}
function $5f6aa8fade9cc028$export$995ab8b13ad7a9d0(value) {
    if (Object.isExtensible(value)) (0, $X5A94.def)(value, "__v_skip", true);
    return value;
}
const $5f6aa8fade9cc028$var$toReactive = (value)=>(0, $X5A94.isObject)(value) ? $5f6aa8fade9cc028$export$90a44edba14e47be(value) : value;
const $5f6aa8fade9cc028$var$toReadonly = (value)=>(0, $X5A94.isObject)(value) ? $5f6aa8fade9cc028$export$6ec456bd5b7b3c51(value) : value;
const $5f6aa8fade9cc028$var$COMPUTED_SIDE_EFFECT_WARN = `Computed is still dirty after getter evaluation, likely because a computed is mutating its own dependency in its getter. State mutations in computed getters should be avoided.  Check the docs for more details: https://vuejs.org/guide/essentials/computed.html#getters-should-be-side-effect-free`;
class $5f6aa8fade9cc028$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this.getter = getter;
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this.effect = new $5f6aa8fade9cc028$export$28352bb4dd362521(()=>getter(this._value), ()=>$5f6aa8fade9cc028$var$triggerRefValue(this, this.effect._dirtyLevel === 2 ? 2 : 3));
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    get value() {
        const self = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
        if ((!self._cacheable || self.effect.dirty) && (0, $X5A94.hasChanged)(self._value, self._value = self.effect.run())) $5f6aa8fade9cc028$var$triggerRefValue(self, 4);
        $5f6aa8fade9cc028$var$trackRefValue(self);
        if (self.effect._dirtyLevel >= 2) $5f6aa8fade9cc028$var$triggerRefValue(self, 2);
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
    // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
    get _dirty() {
        return this.effect.dirty;
    }
    set _dirty(v) {
        this.effect.dirty = v;
    }
}
function $5f6aa8fade9cc028$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $X5A94.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $X5A94.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $5f6aa8fade9cc028$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
function $5f6aa8fade9cc028$var$trackRefValue(ref2) {
    var _a;
    if ($5f6aa8fade9cc028$var$shouldTrack && $5f6aa8fade9cc028$var$activeEffect) {
        ref2 = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(ref2);
        $5f6aa8fade9cc028$var$trackEffect($5f6aa8fade9cc028$var$activeEffect, (_a = ref2.dep) != null ? _a : ref2.dep = $5f6aa8fade9cc028$var$createDep(()=>ref2.dep = void 0, ref2 instanceof $5f6aa8fade9cc028$var$ComputedRefImpl ? ref2 : void 0), void 0);
    }
}
function $5f6aa8fade9cc028$var$triggerRefValue(ref2, dirtyLevel = 4, newVal) {
    ref2 = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $5f6aa8fade9cc028$var$triggerEffects(dep, dirtyLevel, void 0);
}
function $5f6aa8fade9cc028$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $5f6aa8fade9cc028$export$eff4d24c3ff7876e(value) {
    return $5f6aa8fade9cc028$var$createRef(value, false);
}
function $5f6aa8fade9cc028$export$9b7bc5fe3b17c8b3(value) {
    return $5f6aa8fade9cc028$var$createRef(value, true);
}
function $5f6aa8fade9cc028$var$createRef(rawValue, shallow) {
    if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $5f6aa8fade9cc028$var$RefImpl(rawValue, shallow);
}
class $5f6aa8fade9cc028$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $5f6aa8fade9cc028$var$toReactive(value);
    }
    get value() {
        $5f6aa8fade9cc028$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $5f6aa8fade9cc028$export$7f3fe6025abfa26e(newVal) || $5f6aa8fade9cc028$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $5f6aa8fade9cc028$export$ab18938b9fc5f28e(newVal);
        if ((0, $X5A94.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $5f6aa8fade9cc028$var$toReactive(newVal);
            $5f6aa8fade9cc028$var$triggerRefValue(this, 4, newVal);
        }
    }
}
function $5f6aa8fade9cc028$export$f402f86588575ccc(ref2) {
    $5f6aa8fade9cc028$var$triggerRefValue(ref2, 4, void 0);
}
function $5f6aa8fade9cc028$export$a239a76781616204(ref2) {
    return $5f6aa8fade9cc028$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $5f6aa8fade9cc028$export$30bdcc2218aa9458(source) {
    return (0, $X5A94.isFunction)(source) ? source() : $5f6aa8fade9cc028$export$a239a76781616204(source);
}
const $5f6aa8fade9cc028$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$5f6aa8fade9cc028$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(oldValue) && !$5f6aa8fade9cc028$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $5f6aa8fade9cc028$export$f353fd1b97db3fa0(objectWithRefs) {
    return $5f6aa8fade9cc028$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $5f6aa8fade9cc028$var$shallowUnwrapHandlers);
}
class $5f6aa8fade9cc028$var$CustomRefImpl {
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$5f6aa8fade9cc028$var$trackRefValue(this), ()=>$5f6aa8fade9cc028$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $5f6aa8fade9cc028$export$a20c2dd6199824cb(factory) {
    return new $5f6aa8fade9cc028$var$CustomRefImpl(factory);
}
function $5f6aa8fade9cc028$export$2e9533675e5e70e0(object) {
    const ret = (0, $X5A94.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $5f6aa8fade9cc028$var$propertyToRef(object, key);
    return ret;
}
class $5f6aa8fade9cc028$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $5f6aa8fade9cc028$var$getDepFromReactive($5f6aa8fade9cc028$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $5f6aa8fade9cc028$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    get value() {
        return this._getter();
    }
}
function $5f6aa8fade9cc028$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $X5A94.isFunction)(source)) return new $5f6aa8fade9cc028$var$GetterRefImpl(source);
    else if ((0, $X5A94.isObject)(source) && arguments.length > 1) return $5f6aa8fade9cc028$var$propertyToRef(source, key, defaultValue);
    else return $5f6aa8fade9cc028$export$eff4d24c3ff7876e(source);
}
function $5f6aa8fade9cc028$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $5f6aa8fade9cc028$export$4f9f5282de18fc69(val) ? val : new $5f6aa8fade9cc028$var$ObjectRefImpl(source, key, defaultValue);
}
const $5f6aa8fade9cc028$export$483264c4ec4c46ce = $5f6aa8fade9cc028$export$2983e091f1a1e8e2;
const $5f6aa8fade9cc028$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $5f6aa8fade9cc028$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $5f6aa8fade9cc028$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw"
};

});
parcelRegister("X5A94", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $0b19d744f65e59ab$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $0b19d744f65e59ab$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $0b19d744f65e59ab$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $0b19d744f65e59ab$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $0b19d744f65e59ab$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $0b19d744f65e59ab$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $0b19d744f65e59ab$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $0b19d744f65e59ab$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $0b19d744f65e59ab$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $0b19d744f65e59ab$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $0b19d744f65e59ab$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $0b19d744f65e59ab$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $0b19d744f65e59ab$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $0b19d744f65e59ab$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $0b19d744f65e59ab$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $0b19d744f65e59ab$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $0b19d744f65e59ab$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $0b19d744f65e59ab$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $0b19d744f65e59ab$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $0b19d744f65e59ab$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $0b19d744f65e59ab$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $0b19d744f65e59ab$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $0b19d744f65e59ab$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $0b19d744f65e59ab$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $0b19d744f65e59ab$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $0b19d744f65e59ab$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $0b19d744f65e59ab$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $0b19d744f65e59ab$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $0b19d744f65e59ab$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $0b19d744f65e59ab$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $0b19d744f65e59ab$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $0b19d744f65e59ab$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $0b19d744f65e59ab$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $0b19d744f65e59ab$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $0b19d744f65e59ab$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $0b19d744f65e59ab$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $0b19d744f65e59ab$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $0b19d744f65e59ab$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $0b19d744f65e59ab$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $0b19d744f65e59ab$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $0b19d744f65e59ab$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $0b19d744f65e59ab$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $0b19d744f65e59ab$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $0b19d744f65e59ab$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $0b19d744f65e59ab$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $0b19d744f65e59ab$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $0b19d744f65e59ab$export$921dd2acf0d386a3);
$parcel$export(module.exports, "looseEqual", () => $0b19d744f65e59ab$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $0b19d744f65e59ab$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $0b19d744f65e59ab$export$b5b1545233b45293);
/**
* @vue/shared v3.4.23
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0b19d744f65e59ab$export$b41394a5437791c8(str, expectsLowerCase) {
    const set = new Set(str.split(","));
    return expectsLowerCase ? (val)=>set.has(val.toLowerCase()) : (val)=>set.has(val);
}
const $0b19d744f65e59ab$export$cf583d23ab39677c = {};
const $0b19d744f65e59ab$export$6bd8558f433f1cc1 = [];
const $0b19d744f65e59ab$export$5702a91a6f42969f = ()=>{};
const $0b19d744f65e59ab$export$c01351c0af048e39 = ()=>false;
const $0b19d744f65e59ab$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $0b19d744f65e59ab$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $0b19d744f65e59ab$export$8b58be045bf06082 = Object.assign;
const $0b19d744f65e59ab$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $0b19d744f65e59ab$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $0b19d744f65e59ab$export$b5a638e9b3fff9f3 = (val, key)=>$0b19d744f65e59ab$var$hasOwnProperty.call(val, key);
const $0b19d744f65e59ab$export$43bee75e5e14138e = Array.isArray;
const $0b19d744f65e59ab$export$5c90113a285f2241 = (val)=>$0b19d744f65e59ab$export$1dccc787cc36538b(val) === "[object Map]";
const $0b19d744f65e59ab$export$6750766a7c7ec627 = (val)=>$0b19d744f65e59ab$export$1dccc787cc36538b(val) === "[object Set]";
const $0b19d744f65e59ab$export$871608497c498473 = (val)=>$0b19d744f65e59ab$export$1dccc787cc36538b(val) === "[object Date]";
const $0b19d744f65e59ab$export$49841c62b9eff15 = (val)=>$0b19d744f65e59ab$export$1dccc787cc36538b(val) === "[object RegExp]";
const $0b19d744f65e59ab$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $0b19d744f65e59ab$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $0b19d744f65e59ab$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $0b19d744f65e59ab$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $0b19d744f65e59ab$export$4369c812aac99591 = (val)=>{
    return ($0b19d744f65e59ab$export$a6cdc56e425d0d0a(val) || $0b19d744f65e59ab$export$f6e2535fb5126e54(val)) && $0b19d744f65e59ab$export$f6e2535fb5126e54(val.then) && $0b19d744f65e59ab$export$f6e2535fb5126e54(val.catch);
};
const $0b19d744f65e59ab$export$830c053460e5ddf6 = Object.prototype.toString;
const $0b19d744f65e59ab$export$1dccc787cc36538b = (value)=>$0b19d744f65e59ab$export$830c053460e5ddf6.call(value);
const $0b19d744f65e59ab$export$5ad0a3c360b8fbb5 = (value)=>{
    return $0b19d744f65e59ab$export$1dccc787cc36538b(value).slice(8, -1);
};
const $0b19d744f65e59ab$export$53b83ca8eaab0383 = (val)=>$0b19d744f65e59ab$export$1dccc787cc36538b(val) === "[object Object]";
const $0b19d744f65e59ab$export$e2a2b93446ec9fe = (key)=>$0b19d744f65e59ab$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $0b19d744f65e59ab$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $0b19d744f65e59ab$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $0b19d744f65e59ab$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $0b19d744f65e59ab$var$camelizeRE = /-(\w)/g;
const $0b19d744f65e59ab$export$161d051f5dd25de7 = $0b19d744f65e59ab$var$cacheStringFunction((str)=>{
    return str.replace($0b19d744f65e59ab$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $0b19d744f65e59ab$var$hyphenateRE = /\B([A-Z])/g;
const $0b19d744f65e59ab$export$6e6a0a3676c4b8bb = $0b19d744f65e59ab$var$cacheStringFunction((str)=>str.replace($0b19d744f65e59ab$var$hyphenateRE, "-$1").toLowerCase());
const $0b19d744f65e59ab$export$9a00dee1beb8f576 = $0b19d744f65e59ab$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $0b19d744f65e59ab$export$8c022799eeaaefcd = $0b19d744f65e59ab$var$cacheStringFunction((str)=>{
    const s = str ? `on${$0b19d744f65e59ab$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $0b19d744f65e59ab$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $0b19d744f65e59ab$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $0b19d744f65e59ab$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $0b19d744f65e59ab$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $0b19d744f65e59ab$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $0b19d744f65e59ab$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $0b19d744f65e59ab$var$_globalThis;
const $0b19d744f65e59ab$export$ff5f2eeb11fc7e14 = ()=>{
    return $0b19d744f65e59ab$var$_globalThis || ($0b19d744f65e59ab$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $0b19d744f65e59ab$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $0b19d744f65e59ab$export$53d5e12f9a1d3cde(name) {
    return $0b19d744f65e59ab$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $0b19d744f65e59ab$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "HOISTED": -1,
    "-1": "HOISTED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $0b19d744f65e59ab$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $0b19d744f65e59ab$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $0b19d744f65e59ab$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $0b19d744f65e59ab$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $0b19d744f65e59ab$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error";
const $0b19d744f65e59ab$export$f73b8c13b7f97ebf = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$GLOBALS_ALLOWED);
const $0b19d744f65e59ab$export$d6571a1911e4f27e = $0b19d744f65e59ab$export$f73b8c13b7f97ebf;
const $0b19d744f65e59ab$var$range = 2;
function $0b19d744f65e59ab$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $0b19d744f65e59ab$var$range; j <= i + $0b19d744f65e59ab$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $0b19d744f65e59ab$export$8756898546458274(value) {
    if ($0b19d744f65e59ab$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $0b19d744f65e59ab$export$844ec244b1367d54(item) ? $0b19d744f65e59ab$export$76a205ce979d066a(item) : $0b19d744f65e59ab$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($0b19d744f65e59ab$export$844ec244b1367d54(value) || $0b19d744f65e59ab$export$a6cdc56e425d0d0a(value)) return value;
}
const $0b19d744f65e59ab$var$listDelimiterRE = /;(?![^(]*\))/g;
const $0b19d744f65e59ab$var$propertyDelimiterRE = /:([^]+)/;
const $0b19d744f65e59ab$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $0b19d744f65e59ab$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($0b19d744f65e59ab$var$styleCommentRE, "").split($0b19d744f65e59ab$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($0b19d744f65e59ab$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $0b19d744f65e59ab$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $0b19d744f65e59ab$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $0b19d744f65e59ab$export$6e6a0a3676c4b8bb(key);
        if ($0b19d744f65e59ab$export$844ec244b1367d54(value) || typeof value === "number") ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $0b19d744f65e59ab$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($0b19d744f65e59ab$export$844ec244b1367d54(value)) res = value;
    else if ($0b19d744f65e59ab$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $0b19d744f65e59ab$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($0b19d744f65e59ab$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $0b19d744f65e59ab$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$0b19d744f65e59ab$export$844ec244b1367d54(klass)) props.class = $0b19d744f65e59ab$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $0b19d744f65e59ab$export$8756898546458274(style);
    return props;
}
const $0b19d744f65e59ab$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $0b19d744f65e59ab$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $0b19d744f65e59ab$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $0b19d744f65e59ab$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $0b19d744f65e59ab$export$1ccf854a0984f890 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$HTML_TAGS);
const $0b19d744f65e59ab$export$6328ce7565ea1049 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$SVG_TAGS);
const $0b19d744f65e59ab$export$4a46ca4c5be17b20 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$MATH_TAGS);
const $0b19d744f65e59ab$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$VOID_TAGS);
const $0b19d744f65e59ab$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $0b19d744f65e59ab$export$d186f5eb2e810715 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$specialBooleanAttrs);
const $0b19d744f65e59ab$export$f763ba3b84e9cd8c = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $0b19d744f65e59ab$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $0b19d744f65e59ab$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $0b19d744f65e59ab$var$attrValidationCache = {};
function $0b19d744f65e59ab$export$d55ef77660f30d12(name) {
    if ($0b19d744f65e59ab$var$attrValidationCache.hasOwnProperty(name)) return $0b19d744f65e59ab$var$attrValidationCache[name];
    const isUnsafe = $0b19d744f65e59ab$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $0b19d744f65e59ab$var$attrValidationCache[name] = !isUnsafe;
}
const $0b19d744f65e59ab$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $0b19d744f65e59ab$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $0b19d744f65e59ab$export$80da416f43933831 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $0b19d744f65e59ab$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $0b19d744f65e59ab$var$escapeRE = /["'&<>]/;
function $0b19d744f65e59ab$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $0b19d744f65e59ab$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $0b19d744f65e59ab$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $0b19d744f65e59ab$export$7b105034a53bde5f(src) {
    return src.replace($0b19d744f65e59ab$var$commentStripRE, "");
}
function $0b19d744f65e59ab$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $0b19d744f65e59ab$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $0b19d744f65e59ab$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $0b19d744f65e59ab$export$871608497c498473(a);
    let bValidType = $0b19d744f65e59ab$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $0b19d744f65e59ab$export$a244864fd9645c7f(a);
    bValidType = $0b19d744f65e59ab$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $0b19d744f65e59ab$export$43bee75e5e14138e(a);
    bValidType = $0b19d744f65e59ab$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $0b19d744f65e59ab$var$looseCompareArrays(a, b) : false;
    aValidType = $0b19d744f65e59ab$export$a6cdc56e425d0d0a(a);
    bValidType = $0b19d744f65e59ab$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$0b19d744f65e59ab$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $0b19d744f65e59ab$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$0b19d744f65e59ab$export$ae8015769846262c(item, val));
}
const $0b19d744f65e59ab$export$b5b1545233b45293 = (val)=>{
    return $0b19d744f65e59ab$export$844ec244b1367d54(val) ? val : val == null ? "" : $0b19d744f65e59ab$export$43bee75e5e14138e(val) || $0b19d744f65e59ab$export$a6cdc56e425d0d0a(val) && (val.toString === $0b19d744f65e59ab$export$830c053460e5ddf6 || !$0b19d744f65e59ab$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $0b19d744f65e59ab$var$replacer, 2) : String(val);
};
const $0b19d744f65e59ab$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $0b19d744f65e59ab$var$replacer(_key, val.value);
    else if ($0b19d744f65e59ab$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$0b19d744f65e59ab$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($0b19d744f65e59ab$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$0b19d744f65e59ab$var$stringifySymbol(v))
    };
    else if ($0b19d744f65e59ab$export$a244864fd9645c7f(val)) return $0b19d744f65e59ab$var$stringifySymbol(val);
    else if ($0b19d744f65e59ab$export$a6cdc56e425d0d0a(val) && !$0b19d744f65e59ab$export$43bee75e5e14138e(val) && !$0b19d744f65e59ab$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $0b19d744f65e59ab$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $0b19d744f65e59ab$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});



parcelRegister("dDLnc", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("ani5R")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("ani5R")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("ani5R")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("X5A94")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("ani5R")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("ani5R")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("ani5R")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("ani5R")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("ani5R")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("ani5R")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("ani5R")).createRenderer);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("ani5R")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("ani5R")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("ani5R")).createVNode);
$parcel$export(module.exports, "customRef", () => (parcelRequire("8bTPG")).customRef);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("ani5R")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("ani5R")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("ani5R")).getCurrentInstance);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("8bTPG")).getCurrentScope);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("ani5R")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("ani5R")).h);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("ani5R")).hasInjectionContext);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("ani5R")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("ani5R")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("8bTPG")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("8bTPG")).isRef);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("ani5R")).isRuntimeOnly);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("8bTPG")).markRaw);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("ani5R")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("X5A94")).normalizeClass);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("ani5R")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("ani5R")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("ani5R")).onBeforeUpdate);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("ani5R")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("ani5R")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("ani5R")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("ani5R")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("ani5R")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("8bTPG")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("ani5R")).renderList);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("ani5R")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("ani5R")).setTransitionHooks);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("8bTPG")).shallowReactive);
$parcel$export(module.exports, "Static", () => (parcelRequire("ani5R")).Static);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("8bTPG")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("ani5R")).useTransitionState);
$parcel$export(module.exports, "version", () => (parcelRequire("ani5R")).version);
$parcel$export(module.exports, "warn", () => (parcelRequire("ani5R")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("ani5R")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("ani5R")).watchEffect);
$parcel$export(module.exports, "watchPostEffect", () => (parcelRequire("ani5R")).watchPostEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("ani5R")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("ani5R")).withDirectives);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("8bTPG")).effectScope);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("8bTPG")).isReadonly);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("8bTPG")).onScopeDispose);
$parcel$export(module.exports, "readonly", () => (parcelRequire("8bTPG")).readonly);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("8bTPG")).shallowRef);
$parcel$export(module.exports, "toRef", () => (parcelRequire("8bTPG")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("8bTPG")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("8bTPG")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("X5A94")).toDisplayString);

$parcel$export(module.exports, "Transition", () => $9ee3aa3420ae2c81$export$be58926105124dd4);
$parcel$export(module.exports, "TransitionGroup", () => $9ee3aa3420ae2c81$export$19ffa8f511f7bc2e);
$parcel$export(module.exports, "vModelText", () => $9ee3aa3420ae2c81$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelSelect", () => $9ee3aa3420ae2c81$export$87d227567b51ca39);
$parcel$export(module.exports, "createApp", () => $9ee3aa3420ae2c81$export$4e373c34abfa8c68);
/**
* @vue/runtime-dom v3.4.23
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $8bTPG = parcelRequire("8bTPG");parcelRequire("8bTPG");parcelRequire("X5A94");

var $X5A94 = parcelRequire("X5A94");
const $9ee3aa3420ae2c81$var$svgNS = "http://www.w3.org/2000/svg";
const $9ee3aa3420ae2c81$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $9ee3aa3420ae2c81$var$doc = typeof document !== "undefined" ? document : null;
const $9ee3aa3420ae2c81$var$templateContainer = $9ee3aa3420ae2c81$var$doc && /* @__PURE__ */ $9ee3aa3420ae2c81$var$doc.createElement("template");
const $9ee3aa3420ae2c81$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $9ee3aa3420ae2c81$var$doc.createElementNS($9ee3aa3420ae2c81$var$svgNS, tag) : namespace === "mathml" ? $9ee3aa3420ae2c81$var$doc.createElementNS($9ee3aa3420ae2c81$var$mathmlNS, tag) : $9ee3aa3420ae2c81$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$9ee3aa3420ae2c81$var$doc.createTextNode(text),
    createComment: (text)=>$9ee3aa3420ae2c81$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$9ee3aa3420ae2c81$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $9ee3aa3420ae2c81$var$templateContainer.innerHTML = namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content;
            const template = $9ee3aa3420ae2c81$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $9ee3aa3420ae2c81$var$TRANSITION = "transition";
const $9ee3aa3420ae2c81$var$ANIMATION = "animation";
const $9ee3aa3420ae2c81$var$vtcKey = Symbol("_vtc");
const $9ee3aa3420ae2c81$export$be58926105124dd4 = (props, { slots: slots })=>(0, $ani5R.h)((0, $ani5R.BaseTransition), $9ee3aa3420ae2c81$var$resolveTransitionProps(props), slots);
$9ee3aa3420ae2c81$export$be58926105124dd4.displayName = "Transition";
const $9ee3aa3420ae2c81$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $9ee3aa3420ae2c81$var$TransitionPropsValidators = $9ee3aa3420ae2c81$export$be58926105124dd4.props = /* @__PURE__ */ (0, $X5A94.extend)({}, (0, $ani5R.BaseTransitionPropsValidators), $9ee3aa3420ae2c81$var$DOMTransitionPropsValidators);
const $9ee3aa3420ae2c81$var$callHook = (hook, args = [])=>{
    if ((0, $X5A94.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $9ee3aa3420ae2c81$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $X5A94.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $9ee3aa3420ae2c81$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $9ee3aa3420ae2c81$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $9ee3aa3420ae2c81$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveFromClass);
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveToClass);
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $9ee3aa3420ae2c81$var$callHook(hook, [
                el,
                resolve
            ]);
            $9ee3aa3420ae2c81$var$nextFrame(()=>{
                $9ee3aa3420ae2c81$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $9ee3aa3420ae2c81$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$9ee3aa3420ae2c81$var$hasExplicitCallback(hook)) $9ee3aa3420ae2c81$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $X5A94.extend)(baseProps, {
        onBeforeEnter (el) {
            $9ee3aa3420ae2c81$var$callHook(onBeforeEnter, [
                el
            ]);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, enterFromClass);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $9ee3aa3420ae2c81$var$callHook(onBeforeAppear, [
                el
            ]);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, appearFromClass);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, leaveFromClass);
            $9ee3aa3420ae2c81$var$forceReflow();
            $9ee3aa3420ae2c81$var$addTransitionClass(el, leaveActiveClass);
            $9ee3aa3420ae2c81$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveFromClass);
                $9ee3aa3420ae2c81$var$addTransitionClass(el, leaveToClass);
                if (!$9ee3aa3420ae2c81$var$hasExplicitCallback(onLeave)) $9ee3aa3420ae2c81$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $9ee3aa3420ae2c81$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $9ee3aa3420ae2c81$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $9ee3aa3420ae2c81$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $9ee3aa3420ae2c81$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $9ee3aa3420ae2c81$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $X5A94.isObject)(duration)) return [
        $9ee3aa3420ae2c81$var$NumberOf(duration.enter),
        $9ee3aa3420ae2c81$var$NumberOf(duration.leave)
    ];
    else {
        const n = $9ee3aa3420ae2c81$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $9ee3aa3420ae2c81$var$NumberOf(val) {
    const res = (0, $X5A94.toNumber)(val);
    return res;
}
function $9ee3aa3420ae2c81$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$9ee3aa3420ae2c81$var$vtcKey] || (el[$9ee3aa3420ae2c81$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $9ee3aa3420ae2c81$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$9ee3aa3420ae2c81$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$9ee3aa3420ae2c81$var$vtcKey] = void 0;
    }
}
function $9ee3aa3420ae2c81$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $9ee3aa3420ae2c81$var$endId = 0;
function $9ee3aa3420ae2c81$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$9ee3aa3420ae2c81$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $9ee3aa3420ae2c81$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $9ee3aa3420ae2c81$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$9ee3aa3420ae2c81$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$9ee3aa3420ae2c81$var$TRANSITION}Duration`);
    const transitionTimeout = $9ee3aa3420ae2c81$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$9ee3aa3420ae2c81$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$9ee3aa3420ae2c81$var$ANIMATION}Duration`);
    const animationTimeout = $9ee3aa3420ae2c81$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $9ee3aa3420ae2c81$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $9ee3aa3420ae2c81$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $9ee3aa3420ae2c81$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $9ee3aa3420ae2c81$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $9ee3aa3420ae2c81$var$TRANSITION : $9ee3aa3420ae2c81$var$ANIMATION : null;
        propCount = type ? type === $9ee3aa3420ae2c81$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $9ee3aa3420ae2c81$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$9ee3aa3420ae2c81$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $9ee3aa3420ae2c81$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$9ee3aa3420ae2c81$var$toMs(d) + $9ee3aa3420ae2c81$var$toMs(delays[i])));
}
function $9ee3aa3420ae2c81$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $9ee3aa3420ae2c81$var$forceReflow() {
    return document.body.offsetHeight;
}
function $9ee3aa3420ae2c81$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$9ee3aa3420ae2c81$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $9ee3aa3420ae2c81$var$vShowOriginalDisplay = Symbol("_vod");
const $9ee3aa3420ae2c81$var$vShowHidden = Symbol("_vsh");
const $9ee3aa3420ae2c81$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$9ee3aa3420ae2c81$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $9ee3aa3420ae2c81$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $9ee3aa3420ae2c81$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $9ee3aa3420ae2c81$var$setDisplay(el, false);
            });
        } else $9ee3aa3420ae2c81$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $9ee3aa3420ae2c81$var$setDisplay(el, value);
    }
};
function $9ee3aa3420ae2c81$var$setDisplay(el, value) {
    el.style.display = value ? el[$9ee3aa3420ae2c81$var$vShowOriginalDisplay] : "none";
    el[$9ee3aa3420ae2c81$var$vShowHidden] = !value;
}
function $9ee3aa3420ae2c81$var$initVShowForSSR() {
    $9ee3aa3420ae2c81$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $9ee3aa3420ae2c81$var$CSS_VAR_TEXT = Symbol("");
function $9ee3aa3420ae2c81$export$ef28b76f07940108(getter) {
    const instance = (0, $ani5R.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$9ee3aa3420ae2c81$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $9ee3aa3420ae2c81$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $ani5R.onMounted)(()=>{
        (0, $ani5R.watchPostEffect)(setVars);
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $ani5R.onUnmounted)(()=>ob.disconnect());
    });
}
function $9ee3aa3420ae2c81$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $9ee3aa3420ae2c81$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $9ee3aa3420ae2c81$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $ani5R.Fragment)) vnode.children.forEach((c)=>$9ee3aa3420ae2c81$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $ani5R.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $9ee3aa3420ae2c81$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $9ee3aa3420ae2c81$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$9ee3aa3420ae2c81$var$CSS_VAR_TEXT] = cssText;
    }
}
const $9ee3aa3420ae2c81$var$displayRE = /(^|;)\s*display\s*:/;
function $9ee3aa3420ae2c81$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $X5A94.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $X5A94.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $9ee3aa3420ae2c81$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $9ee3aa3420ae2c81$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $9ee3aa3420ae2c81$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$9ee3aa3420ae2c81$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $9ee3aa3420ae2c81$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($9ee3aa3420ae2c81$var$vShowOriginalDisplay in el) {
        el[$9ee3aa3420ae2c81$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$9ee3aa3420ae2c81$var$vShowHidden]) style.display = "none";
    }
}
const $9ee3aa3420ae2c81$var$semicolonRE = /[^\\];\s*$/;
const $9ee3aa3420ae2c81$var$importantRE = /\s*!important$/;
function $9ee3aa3420ae2c81$var$setStyle(style, name, val) {
    if ((0, $X5A94.isArray)(val)) val.forEach((v)=>$9ee3aa3420ae2c81$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $9ee3aa3420ae2c81$var$autoPrefix(style, name);
            if ($9ee3aa3420ae2c81$var$importantRE.test(val)) style.setProperty((0, $X5A94.hyphenate)(prefixed), val.replace($9ee3aa3420ae2c81$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $9ee3aa3420ae2c81$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $9ee3aa3420ae2c81$var$prefixCache = {};
function $9ee3aa3420ae2c81$var$autoPrefix(style, rawName) {
    const cached = $9ee3aa3420ae2c81$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $X5A94.camelize)(rawName);
    if (name !== "filter" && name in style) return $9ee3aa3420ae2c81$var$prefixCache[rawName] = name;
    name = (0, $X5A94.capitalize)(name);
    for(let i = 0; i < $9ee3aa3420ae2c81$var$prefixes.length; i++){
        const prefixed = $9ee3aa3420ae2c81$var$prefixes[i] + name;
        if (prefixed in style) return $9ee3aa3420ae2c81$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $9ee3aa3420ae2c81$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $9ee3aa3420ae2c81$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($9ee3aa3420ae2c81$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($9ee3aa3420ae2c81$var$xlinkNS, key, value);
    } else {
        const isBoolean = (0, $X5A94.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $X5A94.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $9ee3aa3420ae2c81$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? "" : value;
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $X5A94.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $9ee3aa3420ae2c81$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $9ee3aa3420ae2c81$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $9ee3aa3420ae2c81$var$veiKey = Symbol("_vei");
function $9ee3aa3420ae2c81$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$9ee3aa3420ae2c81$var$veiKey] || (el[$9ee3aa3420ae2c81$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $9ee3aa3420ae2c81$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $9ee3aa3420ae2c81$var$createInvoker(nextValue, instance);
            $9ee3aa3420ae2c81$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $9ee3aa3420ae2c81$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $9ee3aa3420ae2c81$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $9ee3aa3420ae2c81$var$parseName(name) {
    let options;
    if ($9ee3aa3420ae2c81$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($9ee3aa3420ae2c81$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $X5A94.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $9ee3aa3420ae2c81$var$cachedNow = 0;
const $9ee3aa3420ae2c81$var$p = /* @__PURE__ */ Promise.resolve();
const $9ee3aa3420ae2c81$var$getNow = ()=>$9ee3aa3420ae2c81$var$cachedNow || ($9ee3aa3420ae2c81$var$p.then(()=>$9ee3aa3420ae2c81$var$cachedNow = 0), $9ee3aa3420ae2c81$var$cachedNow = Date.now());
function $9ee3aa3420ae2c81$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $ani5R.callWithAsyncErrorHandling)($9ee3aa3420ae2c81$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $9ee3aa3420ae2c81$var$getNow();
    return invoker;
}
function $9ee3aa3420ae2c81$var$sanitizeEventValue(value, propName) {
    if ((0, $X5A94.isFunction)(value) || (0, $X5A94.isArray)(value)) return value;
    (0, $ani5R.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $X5A94.NOOP;
}
function $9ee3aa3420ae2c81$var$patchStopImmediatePropagation(e, value) {
    if ((0, $X5A94.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $9ee3aa3420ae2c81$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $9ee3aa3420ae2c81$var$patchProp = (el, key, prevValue, nextValue, namespace, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $9ee3aa3420ae2c81$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $9ee3aa3420ae2c81$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $X5A94.isOn)(key)) {
        if (!(0, $X5A94.isModelListener)(key)) $9ee3aa3420ae2c81$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $9ee3aa3420ae2c81$var$shouldSetAsProp(el, key, nextValue, isSVG)) $9ee3aa3420ae2c81$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $9ee3aa3420ae2c81$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $9ee3aa3420ae2c81$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $9ee3aa3420ae2c81$var$isNativeOn(key) && (0, $X5A94.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($9ee3aa3420ae2c81$var$isNativeOn(key) && (0, $X5A94.isString)(value)) return false;
    return key in el;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $9ee3aa3420ae2c81$export$a00e2346eabbdbef(options, hydrate2) {
    const Comp = (0, $ani5R.defineComponent)(options);
    class VueCustomElement extends $9ee3aa3420ae2c81$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $9ee3aa3420ae2c81$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options)=>{
    return /* @__PURE__ */ $9ee3aa3420ae2c81$export$a00e2346eabbdbef(options, $9ee3aa3420ae2c81$export$fa8d919ba61d84db);
};
const $9ee3aa3420ae2c81$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $9ee3aa3420ae2c81$export$b337c1a55163dbe3 extends $9ee3aa3420ae2c81$var$BaseClass {
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._ob = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        if (this._ob) {
            this._ob.disconnect();
            this._ob = null;
        }
        (0, $ani5R.nextTick)(()=>{
            if (!this._connected) {
                $9ee3aa3420ae2c81$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $X5A94.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $X5A94.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $X5A94.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $X5A94.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $X5A94.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.hasAttribute(key) ? this.getAttribute(key) : void 0;
        const camelKey = (0, $X5A94.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $X5A94.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $X5A94.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $X5A94.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $X5A94.hyphenate)(key));
            }
        }
    }
    _update() {
        $9ee3aa3420ae2c81$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $ani5R.createVNode)(this._def, (0, $X5A94.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $X5A94.hyphenate)(event) !== event) dispatch((0, $X5A94.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $9ee3aa3420ae2c81$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $9ee3aa3420ae2c81$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $ani5R.getCurrentInstance)();
        if (!instance) return 0, $X5A94.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $X5A94.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $X5A94.EMPTY_OBJ;
        return mod;
    }
}
const $9ee3aa3420ae2c81$var$positionMap = /* @__PURE__ */ new WeakMap();
const $9ee3aa3420ae2c81$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $9ee3aa3420ae2c81$var$moveCbKey = Symbol("_moveCb");
const $9ee3aa3420ae2c81$var$enterCbKey = Symbol("_enterCb");
const $9ee3aa3420ae2c81$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $X5A94.extend)({}, $9ee3aa3420ae2c81$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $ani5R.getCurrentInstance)();
        const state = (0, $ani5R.useTransitionState)();
        let prevChildren;
        let children;
        (0, $ani5R.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$9ee3aa3420ae2c81$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($9ee3aa3420ae2c81$var$callPendingCbs);
            prevChildren.forEach($9ee3aa3420ae2c81$var$recordPosition);
            const movedChildren = prevChildren.filter($9ee3aa3420ae2c81$var$applyTranslation);
            $9ee3aa3420ae2c81$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $9ee3aa3420ae2c81$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$9ee3aa3420ae2c81$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$9ee3aa3420ae2c81$var$moveCbKey] = null;
                        $9ee3aa3420ae2c81$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $8bTPG.toRaw)(props);
            const cssTransitionProps = $9ee3aa3420ae2c81$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $ani5R.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $ani5R.setTransitionHooks)(child, (0, $ani5R.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $9ee3aa3420ae2c81$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $ani5R.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $ani5R.setTransitionHooks)(child, (0, $ani5R.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $ani5R.createVNode)(tag, null, children);
        };
    }
};
const $9ee3aa3420ae2c81$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $9ee3aa3420ae2c81$var$removeMode($9ee3aa3420ae2c81$var$TransitionGroupImpl.props);
const $9ee3aa3420ae2c81$export$19ffa8f511f7bc2e = $9ee3aa3420ae2c81$var$TransitionGroupImpl;
function $9ee3aa3420ae2c81$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$9ee3aa3420ae2c81$var$moveCbKey]) el[$9ee3aa3420ae2c81$var$moveCbKey]();
    if (el[$9ee3aa3420ae2c81$var$enterCbKey]) el[$9ee3aa3420ae2c81$var$enterCbKey]();
}
function $9ee3aa3420ae2c81$var$recordPosition(c) {
    $9ee3aa3420ae2c81$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $9ee3aa3420ae2c81$var$applyTranslation(c) {
    const oldPos = $9ee3aa3420ae2c81$var$positionMap.get(c);
    const newPos = $9ee3aa3420ae2c81$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $9ee3aa3420ae2c81$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$9ee3aa3420ae2c81$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $9ee3aa3420ae2c81$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $9ee3aa3420ae2c81$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $X5A94.isArray)(fn) ? (value)=>(0, $X5A94.invokeArrayFns)(fn, value) : fn;
};
function $9ee3aa3420ae2c81$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $9ee3aa3420ae2c81$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $9ee3aa3420ae2c81$var$assignKey = Symbol("_assign");
const $9ee3aa3420ae2c81$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $9ee3aa3420ae2c81$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $X5A94.looseToNumber)(domValue);
            el[$9ee3aa3420ae2c81$var$assignKey](domValue);
        });
        if (trim) $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $9ee3aa3420ae2c81$var$addEventListener(el, "compositionstart", $9ee3aa3420ae2c81$var$onCompositionStart);
            $9ee3aa3420ae2c81$var$addEventListener(el, "compositionend", $9ee3aa3420ae2c81$var$onCompositionEnd);
            $9ee3aa3420ae2c81$var$addEventListener(el, "change", $9ee3aa3420ae2c81$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $X5A94.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $9ee3aa3420ae2c81$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $9ee3aa3420ae2c81$var$getValue(el);
            const checked = el.checked;
            const assign = el[$9ee3aa3420ae2c81$var$assignKey];
            if ((0, $X5A94.isArray)(modelValue)) {
                const index = (0, $X5A94.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $X5A94.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($9ee3aa3420ae2c81$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $9ee3aa3420ae2c81$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        $9ee3aa3420ae2c81$var$setChecked(el, binding, vnode);
    }
};
function $9ee3aa3420ae2c81$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $X5A94.isArray)(value)) el.checked = (0, $X5A94.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $X5A94.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $X5A94.looseEqual)(value, $9ee3aa3420ae2c81$var$getCheckboxValue(el, true));
}
const $9ee3aa3420ae2c81$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $X5A94.looseEqual)(value, vnode.props.value);
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            el[$9ee3aa3420ae2c81$var$assignKey]($9ee3aa3420ae2c81$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $X5A94.looseEqual)(value, vnode.props.value);
    }
};
const $9ee3aa3420ae2c81$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $X5A94.isSet)(value);
        $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $X5A94.looseToNumber)($9ee3aa3420ae2c81$var$getValue(o)) : $9ee3aa3420ae2c81$var$getValue(o));
            el[$9ee3aa3420ae2c81$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $ani5R.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value, modifiers: { number: number } }) {
        $9ee3aa3420ae2c81$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
    },
    updated (el, { value: value, modifiers: { number: number } }) {
        if (!el._assigning) $9ee3aa3420ae2c81$var$setSelected(el, value);
    }
};
function $9ee3aa3420ae2c81$var$setSelected(el, value, number) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $X5A94.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $X5A94.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $9ee3aa3420ae2c81$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $X5A94.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $X5A94.looseEqual)($9ee3aa3420ae2c81$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $9ee3aa3420ae2c81$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $9ee3aa3420ae2c81$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $9ee3aa3420ae2c81$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $9ee3aa3420ae2c81$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $9ee3aa3420ae2c81$export$87d227567b51ca39;
        case "TEXTAREA":
            return $9ee3aa3420ae2c81$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $9ee3aa3420ae2c81$export$8847c2e532b35714;
                case "radio":
                    return $9ee3aa3420ae2c81$export$b4356c59b38b7aa9;
                default:
                    return $9ee3aa3420ae2c81$export$f1f88689f5728478;
            }
    }
}
function $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $9ee3aa3420ae2c81$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $9ee3aa3420ae2c81$var$initVModelForSSR() {
    $9ee3aa3420ae2c81$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $9ee3aa3420ae2c81$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $X5A94.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $9ee3aa3420ae2c81$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $X5A94.isArray)(value)) {
            if (vnode.props && (0, $X5A94.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $X5A94.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $9ee3aa3420ae2c81$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $9ee3aa3420ae2c81$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $9ee3aa3420ae2c81$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $9ee3aa3420ae2c81$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$9ee3aa3420ae2c81$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $9ee3aa3420ae2c81$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $9ee3aa3420ae2c81$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $9ee3aa3420ae2c81$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $9ee3aa3420ae2c81$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $X5A94.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $9ee3aa3420ae2c81$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $9ee3aa3420ae2c81$var$rendererOptions = /* @__PURE__ */ (0, $X5A94.extend)({
    patchProp: $9ee3aa3420ae2c81$var$patchProp
}, $9ee3aa3420ae2c81$var$nodeOps);
let $9ee3aa3420ae2c81$var$renderer;
let $9ee3aa3420ae2c81$var$enabledHydration = false;
function $9ee3aa3420ae2c81$var$ensureRenderer() {
    return $9ee3aa3420ae2c81$var$renderer || ($9ee3aa3420ae2c81$var$renderer = (0, $ani5R.createRenderer)($9ee3aa3420ae2c81$var$rendererOptions));
}
function $9ee3aa3420ae2c81$var$ensureHydrationRenderer() {
    $9ee3aa3420ae2c81$var$renderer = $9ee3aa3420ae2c81$var$enabledHydration ? $9ee3aa3420ae2c81$var$renderer : (0, $ani5R.createHydrationRenderer)($9ee3aa3420ae2c81$var$rendererOptions);
    $9ee3aa3420ae2c81$var$enabledHydration = true;
    return $9ee3aa3420ae2c81$var$renderer;
}
const $9ee3aa3420ae2c81$export$b3890eb0ae9dca99 = (...args)=>{
    $9ee3aa3420ae2c81$var$ensureRenderer().render(...args);
};
const $9ee3aa3420ae2c81$export$fa8d919ba61d84db = (...args)=>{
    $9ee3aa3420ae2c81$var$ensureHydrationRenderer().hydrate(...args);
};
const $9ee3aa3420ae2c81$export$4e373c34abfa8c68 = (...args)=>{
    const app = $9ee3aa3420ae2c81$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $9ee3aa3420ae2c81$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $X5A94.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, $9ee3aa3420ae2c81$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $9ee3aa3420ae2c81$export$35800275c0037383 = (...args)=>{
    const app = $9ee3aa3420ae2c81$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $9ee3aa3420ae2c81$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $9ee3aa3420ae2c81$var$resolveRootNamespace(container));
    };
    return app;
};
function $9ee3aa3420ae2c81$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $9ee3aa3420ae2c81$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $X5A94.isHTMLTag)(tag) || (0, $X5A94.isSVGTag)(tag) || (0, $X5A94.isMathMLTag)(tag),
        writable: false
    });
}
function $9ee3aa3420ae2c81$var$injectCompilerOptionsCheck(app) {
    if ((0, $ani5R.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $ani5R.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $ani5R.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $ani5R.warn)(msg);
            }
        });
    }
}
function $9ee3aa3420ae2c81$var$normalizeContainer(container) {
    if ((0, $X5A94.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $9ee3aa3420ae2c81$var$ssrDirectiveInitialized = false;
const $9ee3aa3420ae2c81$export$800b28255aa678d9 = ()=>{
    if (!$9ee3aa3420ae2c81$var$ssrDirectiveInitialized) {
        $9ee3aa3420ae2c81$var$ssrDirectiveInitialized = true;
        $9ee3aa3420ae2c81$var$initVModelForSSR();
        $9ee3aa3420ae2c81$var$initVShowForSSR();
    }
};

});


parcelRegister("airo4", function(module, exports) {

$parcel$export(module.exports, "default", () => $77f0d4553bc6808f$export$2e2bcd8739ae039);
let $77f0d4553bc6808f$var$script;



let $77f0d4553bc6808f$var$initialize = ()=>{
    $77f0d4553bc6808f$var$script = (parcelRequire("9QE65"));
    if ($77f0d4553bc6808f$var$script.__esModule) $77f0d4553bc6808f$var$script = $77f0d4553bc6808f$var$script.default;
    $77f0d4553bc6808f$var$script.render = (parcelRequire("j9eqk")).render;
    (parcelRequire("2YPjX")).default($77f0d4553bc6808f$var$script);
    $77f0d4553bc6808f$var$script.__scopeId = "data-v-5cf43c";
    $77f0d4553bc6808f$var$script.__file = "Products.vue";
};
$77f0d4553bc6808f$var$initialize();
var $77f0d4553bc6808f$export$2e2bcd8739ae039 = $77f0d4553bc6808f$var$script;

});
parcelRegister("9QE65", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $400c32ed0bb5df2d$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $dCDr1 = parcelRequire("dCDr1");

var $huSKp = parcelRequire("huSKp");

var $gqFxE = parcelRequire("gqFxE");

var $3XmQy = parcelRequire("3XmQy");

var $2HVhb = parcelRequire("2HVhb");

var $7O2xm = parcelRequire("7O2xm");
var $400c32ed0bb5df2d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "Products",
    setup (__props, { expose: __expose }) {
        __expose();
        const productStore = (0, $huSKp.useProductStore)();
        const { getProducts: getProducts } = productStore;
        const { products: products, gridClass: gridClass, isLoading: isLoading, prodRequest: prodRequest } = (0, $gqFxE.storeToRefs)(productStore);
        const { setName: setName } = (0, $7O2xm.useCategoryStore)();
        function setTittle() {
            const currentUrl = window.location.href;
            const url = new URL(currentUrl);
            const params = url.searchParams;
            const searchQuery = params.get("searchQuery");
            if (searchQuery) setName(decodeURI(searchQuery).replaceAll(",", ", "));
        }
        (0, $ani5R.onMounted)(()=>{
            getProducts();
            setTittle();
        });
        const __returned__ = {
            productStore: productStore,
            getProducts: getProducts,
            products: products,
            gridClass: gridClass,
            isLoading: isLoading,
            prodRequest: prodRequest,
            setName: setName,
            setTittle: setTittle,
            SingleProduct: $dCDr1.default,
            LoaderComponent: $3XmQy.default,
            NoProducts: $2HVhb.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("dCDr1", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ead69edf6520c3f$export$2e2bcd8739ae039);
let $9ead69edf6520c3f$var$script;



let $9ead69edf6520c3f$var$initialize = ()=>{
    $9ead69edf6520c3f$var$script = (parcelRequire("2Au9h"));
    if ($9ead69edf6520c3f$var$script.__esModule) $9ead69edf6520c3f$var$script = $9ead69edf6520c3f$var$script.default;
    $9ead69edf6520c3f$var$script.render = (parcelRequire("5NnmD")).render;
    (parcelRequire("6nN3E")).default($9ead69edf6520c3f$var$script);
    $9ead69edf6520c3f$var$script.__scopeId = "data-v-743751";
    $9ead69edf6520c3f$var$script.__file = "SingleProduct.vue";
};
$9ead69edf6520c3f$var$initialize();
var $9ead69edf6520c3f$export$2e2bcd8739ae039 = $9ead69edf6520c3f$var$script;

});
parcelRegister("2Au9h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e471bfedfdb22dda$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $6g6T7 = parcelRequire("6g6T7");

var $75Z6s = parcelRequire("75Z6s");

var $iFgIS = parcelRequire("iFgIS");
var $e471bfedfdb22dda$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "SingleProduct",
    props: {
        product: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            get Media () {
                return 0, $6g6T7.Media;
            },
            SingleProductImage: $75Z6s.default,
            SingleProductVideo: $iFgIS.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("6g6T7", function(module, exports) {

$parcel$export(module.exports, "ProdSpecific", () => $b553d33032dacd19$export$ec2039dfa7c32c7);
$parcel$export(module.exports, "Filter", () => $b553d33032dacd19$export$ec91da630f36d5ea);
$parcel$export(module.exports, "Media", () => $b553d33032dacd19$export$7fc53215244aec38);
$parcel$export(module.exports, "Altitude", () => $b553d33032dacd19$export$7c22c22b4ff910b0);
$parcel$export(module.exports, "SortField", () => $b553d33032dacd19$export$c4fb72ec5ef10400);
$parcel$export(module.exports, "SortDirection", () => $b553d33032dacd19$export$79e2d9500680dd96);
$parcel$export(module.exports, "CategoryRequestStatus", () => $b553d33032dacd19$export$304f779d478a92db);
$parcel$export(module.exports, "GridClass", () => $b553d33032dacd19$export$5d3abd3299fde6c7);
var $b553d33032dacd19$export$ec2039dfa7c32c7;
(function(ProdSpecific) {
    ProdSpecific["SUNRISE"] = "Sunrise";
    ProdSpecific["NIGHT_TIME"] = "Night Time";
    ProdSpecific["HIGH_ALTITUDE"] = "High Altitude";
    ProdSpecific["PANORAMIC"] = "Panoramic";
    ProdSpecific["ARCHIVE"] = "Archive";
    ProdSpecific["SUNSET"] = "Sunset";
})($b553d33032dacd19$export$ec2039dfa7c32c7 || ($b553d33032dacd19$export$ec2039dfa7c32c7 = {}));
var $b553d33032dacd19$export$ec91da630f36d5ea;
(function(Filter) {
    Filter["YEAR"] = "Year";
    Filter["ALTITUDE"] = "Altitude";
    Filter["MEDIA"] = "Media";
    Filter["SPECIFIC"] = "Category";
})($b553d33032dacd19$export$ec91da630f36d5ea || ($b553d33032dacd19$export$ec91da630f36d5ea = {}));
var $b553d33032dacd19$export$7fc53215244aec38;
(function(Media) {
    Media["IMAGE"] = "image";
    Media["VIDEO"] = "video";
    Media["ALL"] = "all";
})($b553d33032dacd19$export$7fc53215244aec38 || ($b553d33032dacd19$export$7fc53215244aec38 = {}));
var $b553d33032dacd19$export$7c22c22b4ff910b0;
(function(Altitude) {
    Altitude["M0"] = "0-250m";
    Altitude["M250"] = "250-500m";
    Altitude["M500"] = "500-1000m";
    Altitude["M1000"] = "1000-2000m";
    Altitude["M2000"] = "Over 2000m";
})($b553d33032dacd19$export$7c22c22b4ff910b0 || ($b553d33032dacd19$export$7c22c22b4ff910b0 = {}));
var $b553d33032dacd19$export$c4fb72ec5ef10400;
(function(SortField) {
    SortField["ID"] = "id";
    SortField["NETO_ID"] = "netoId";
    SortField["NAME"] = "name";
    SortField["SKU"] = "sku";
    SortField["YEAR"] = "year";
    SortField["MEDIA"] = "media";
    SortField["IS_PREMIUM"] = "isPremium";
    SortField["DISTANCE"] = "distance";
    SortField["ALTITUDE"] = "altitude";
    SortField["CREATED_AT"] = "createdAt";
    SortField["UPDATED_AT"] = "updatedAt";
})($b553d33032dacd19$export$c4fb72ec5ef10400 || ($b553d33032dacd19$export$c4fb72ec5ef10400 = {}));
var $b553d33032dacd19$export$79e2d9500680dd96;
(function(SortDirection) {
    SortDirection["ASC"] = "asc";
    SortDirection["DESC"] = "desc";
})($b553d33032dacd19$export$79e2d9500680dd96 || ($b553d33032dacd19$export$79e2d9500680dd96 = {}));
var $b553d33032dacd19$export$304f779d478a92db;
(function(CategoryRequestStatus) {
    CategoryRequestStatus["SUCCESS"] = "Success";
})($b553d33032dacd19$export$304f779d478a92db || ($b553d33032dacd19$export$304f779d478a92db = {}));
var $b553d33032dacd19$export$5d3abd3299fde6c7;
(function(GridClass) {
    GridClass["LIST"] = "";
    GridClass["CARDS"] = "cards";
})($b553d33032dacd19$export$5d3abd3299fde6c7 || ($b553d33032dacd19$export$5d3abd3299fde6c7 = {}));

});

parcelRegister("75Z6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $52a865dc14902f70$export$2e2bcd8739ae039);
let $52a865dc14902f70$var$script;



let $52a865dc14902f70$var$initialize = ()=>{
    $52a865dc14902f70$var$script = (parcelRequire("7tu6e"));
    if ($52a865dc14902f70$var$script.__esModule) $52a865dc14902f70$var$script = $52a865dc14902f70$var$script.default;
    $52a865dc14902f70$var$script.render = (parcelRequire("g98Ta")).render;
    (parcelRequire("ky89O")).default($52a865dc14902f70$var$script);
    $52a865dc14902f70$var$script.__scopeId = "data-v-ef0cb6";
    $52a865dc14902f70$var$script.__file = "SingleProductImage.vue";
};
$52a865dc14902f70$var$initialize();
var $52a865dc14902f70$export$2e2bcd8739ae039 = $52a865dc14902f70$var$script;

});
parcelRegister("7tu6e", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9d09afcfee699858$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");
var $9d09afcfee699858$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "SingleProductImage",
    props: {
        product: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const sku = (0, $8bTPG.computed)(()=>{
            return props.product.sku ? props.product.sku.split("-").slice(1).join("-") : "";
        });
        const __returned__ = {
            props: props,
            sku: sku
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("g98Ta", function(module, exports) {

$parcel$export(module.exports, "render", () => $bc1461c11cfbbe0a$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $bc1461c11cfbbe0a$var$_hoisted_1 = {
    class: "prod-box__wrap"
};
const $bc1461c11cfbbe0a$var$_hoisted_2 = {
    class: "prod-box__figure"
};
const $bc1461c11cfbbe0a$var$_hoisted_3 = [
    "href",
    "data-title"
];
const $bc1461c11cfbbe0a$var$_hoisted_4 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", {
    "data-v-54a3f4": ""
}, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
        "xlink:href": "#icon-search-light"
    })
], -1);
const $bc1461c11cfbbe0a$var$_hoisted_5 = [
    $bc1461c11cfbbe0a$var$_hoisted_4
];
const $bc1461c11cfbbe0a$var$_hoisted_6 = [
    "src",
    "alt"
];
const $bc1461c11cfbbe0a$var$_hoisted_7 = {
    class: "premium-icon__wrap"
};
const $bc1461c11cfbbe0a$var$_hoisted_8 = {
    key: 0,
    class: "premium-icon"
};
const $bc1461c11cfbbe0a$var$_hoisted_9 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", {
    class: "premium-icon__icon"
}, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
        "xlink:href": "#icon-gem-solid"
    })
], -1);
const $bc1461c11cfbbe0a$var$_hoisted_10 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("p", {
    class: "premium-icon__text"
}, "Premium", -1);
const $bc1461c11cfbbe0a$var$_hoisted_11 = [
    $bc1461c11cfbbe0a$var$_hoisted_9,
    $bc1461c11cfbbe0a$var$_hoisted_10
];
const $bc1461c11cfbbe0a$var$_hoisted_12 = {
    key: 1,
    class: "premium-icon"
};
const $bc1461c11cfbbe0a$var$_hoisted_13 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", {
    class: "premium-icon__icon"
}, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
        "xlink:href": "#icon-folder-open-regular"
    })
], -1);
const $bc1461c11cfbbe0a$var$_hoisted_14 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("p", {
    class: "premium-icon__text"
}, "From The Archive", -1);
const $bc1461c11cfbbe0a$var$_hoisted_15 = [
    $bc1461c11cfbbe0a$var$_hoisted_13,
    $bc1461c11cfbbe0a$var$_hoisted_14
];
const $bc1461c11cfbbe0a$var$_hoisted_16 = [
    "href"
];
const $bc1461c11cfbbe0a$var$_hoisted_17 = {
    class: "prod-box__overlay"
};
const $bc1461c11cfbbe0a$var$_hoisted_18 = {
    class: "prod-box__text-wrap"
};
const $bc1461c11cfbbe0a$var$_hoisted_19 = {
    class: "prod-box__title"
};
const $bc1461c11cfbbe0a$var$_hoisted_20 = {
    class: "prod-box__subtitle"
};
function $bc1461c11cfbbe0a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $bc1461c11cfbbe0a$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("figure", $bc1461c11cfbbe0a$var$_hoisted_2, [
            (0, $ani5R.createElementVNode)("a", {
                class: "prod-box__zoom",
                href: $props.product.imageUrl,
                "max-width": "1182px",
                "data-lightbox": "product-lightbox",
                "data-title": `${$props.product.name} ${$setup.sku}`,
                rel: "product_images"
            }, $bc1461c11cfbbe0a$var$_hoisted_5, 8, $bc1461c11cfbbe0a$var$_hoisted_3),
            (0, $ani5R.createElementVNode)("img", {
                class: "prod-box__img",
                src: $props.product.thumbnailUrl,
                alt: $props.product.name
            }, null, 8, $bc1461c11cfbbe0a$var$_hoisted_6),
            (0, $ani5R.createElementVNode)("div", $bc1461c11cfbbe0a$var$_hoisted_7, [
                $props.product.isPremium ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $bc1461c11cfbbe0a$var$_hoisted_8, $bc1461c11cfbbe0a$var$_hoisted_11)) : (0, $ani5R.createCommentVNode)("", true),
                $props.product.isHistoricImage ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $bc1461c11cfbbe0a$var$_hoisted_12, $bc1461c11cfbbe0a$var$_hoisted_15)) : (0, $ani5R.createCommentVNode)("", true)
            ])
        ]),
        (0, $ani5R.createElementVNode)("a", {
            href: $props.product.productUrl
        }, [
            (0, $ani5R.createElementVNode)("div", $bc1461c11cfbbe0a$var$_hoisted_17, [
                (0, $ani5R.createElementVNode)("div", $bc1461c11cfbbe0a$var$_hoisted_18, [
                    (0, $ani5R.createElementVNode)("h2", $bc1461c11cfbbe0a$var$_hoisted_19, (0, $X5A94.toDisplayString)($props.product.name), 1),
                    (0, $ani5R.createElementVNode)("p", $bc1461c11cfbbe0a$var$_hoisted_20, (0, $X5A94.toDisplayString)($setup.sku), 1)
                ])
            ])
        ], 8, $bc1461c11cfbbe0a$var$_hoisted_16)
    ]);
}

});

parcelRegister("ky89O", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef5d4f7cd543b29e$export$2e2bcd8739ae039);
let $ef5d4f7cd543b29e$var$NOOP = ()=>{};
var $ef5d4f7cd543b29e$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("iFgIS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9690720d08ab148$export$2e2bcd8739ae039);
let $d9690720d08ab148$var$script;



let $d9690720d08ab148$var$initialize = ()=>{
    $d9690720d08ab148$var$script = (parcelRequire("6ABjg"));
    if ($d9690720d08ab148$var$script.__esModule) $d9690720d08ab148$var$script = $d9690720d08ab148$var$script.default;
    $d9690720d08ab148$var$script.render = (parcelRequire("j4m3h")).render;
    (parcelRequire("dny7y")).default($d9690720d08ab148$var$script);
    $d9690720d08ab148$var$script.__scopeId = "data-v-b82242";
    $d9690720d08ab148$var$script.__file = "SingleProductVideo.vue";
};
$d9690720d08ab148$var$initialize();
var $d9690720d08ab148$export$2e2bcd8739ae039 = $d9690720d08ab148$var$script;

});
parcelRegister("6ABjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a7e5dd2fb263bc6d$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");

var $ai6nR = parcelRequire("ai6nR");

var $iuc9x = parcelRequire("iuc9x");
var $a7e5dd2fb263bc6d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "SingleProductVideo",
    props: {
        product: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const player = (0, $8bTPG.ref)(null);
        const video = (0, $8bTPG.ref)(null);
        const button = (0, $8bTPG.ref)(null);
        const container = (0, $8bTPG.ref)(null);
        async function initVideo() {
            if (!video.value) return;
            player.value = await new (0, (/*@__PURE__*/$parcel$interopDefault($ai6nR)))(video.value);
            if (!player.value) return;
            button.value = player.value.elements.buttons.play ? player.value.elements.buttons.play[0] : null;
        }
        const sku = (0, $8bTPG.computed)(()=>{
            return props.product.sku ? props.product.sku.split("-").slice(1).join("-") : "";
        });
        (0, $iuc9x.onClickOutside)(container, ()=>{
            pauseVideo();
        });
        function handleButtonClick() {
            player.value?.play();
        }
        function pauseVideo() {
            if (!player.value) return;
            player.value.pause();
        }
        (0, $ani5R.onMounted)(async ()=>{
            await initVideo();
            button.value?.addEventListener("click", handleButtonClick);
        });
        (0, $ani5R.onBeforeUnmount)(()=>{
            button.value?.removeEventListener("click", handleButtonClick);
        });
        const __returned__ = {
            props: props,
            player: player,
            video: video,
            button: button,
            container: container,
            initVideo: initVideo,
            sku: sku,
            handleButtonClick: handleButtonClick,
            pauseVideo: pauseVideo
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("ai6nR", function(module, exports) {
"object" == typeof navigator && function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    function e(e, t, i) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" != typeof e || null === e) return e;
                var i = e[Symbol.toPrimitive];
                if (void 0 !== i) {
                    var s = i.call(e, t || "default");
                    if ("object" != typeof s) return s;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === t ? String : Number)(e);
            }(e, "string");
            return "symbol" == typeof t ? t : String(t);
        }(t)) in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i, e;
    }
    function t(e, t) {
        for(var i = 0; i < t.length; i++){
            var s = t[i];
            s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
        }
    }
    function i(e, t, i) {
        return t in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i, e;
    }
    function s(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(e);
            t && (s = s.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), i.push.apply(i, s);
        }
        return i;
    }
    function n(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? s(Object(n), !0).forEach(function(t) {
                i(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
        }
        return e;
    }
    var a = {
        addCSS: !0,
        thumbWidth: 15,
        watch: !0
    };
    var l = function(e) {
        return null != e ? e.constructor : null;
    }, r = function(e, t) {
        return !!(e && t && e instanceof t);
    }, o = function(e) {
        return null == e;
    }, c = function(e) {
        return l(e) === Object;
    }, u = function(e) {
        return l(e) === String;
    }, h = function(e) {
        return Array.isArray(e);
    }, d = function(e) {
        return r(e, NodeList);
    }, m = {
        nullOrUndefined: o,
        object: c,
        number: function(e) {
            return l(e) === Number && !Number.isNaN(e);
        },
        string: u,
        boolean: function(e) {
            return l(e) === Boolean;
        },
        function: function(e) {
            return l(e) === Function;
        },
        array: h,
        nodeList: d,
        element: function(e) {
            return r(e, Element);
        },
        event: function(e) {
            return r(e, Event);
        },
        empty: function(e) {
            return o(e) || (u(e) || h(e) || d(e)) && !e.length || c(e) && !Object.keys(e).length;
        }
    };
    function p(e, t) {
        if (1 > t) {
            var i = function(e) {
                var t = "".concat(e).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                return t ? Math.max(0, (t[1] ? t[1].length : 0) - (t[2] ? +t[2] : 0)) : 0;
            }(t);
            return parseFloat(e.toFixed(i));
        }
        return Math.round(e / t) * t;
    }
    var g = function() {
        function e(t, i) {
            (function(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            })(this, e), m.element(t) ? this.element = t : m.string(t) && (this.element = document.querySelector(t)), m.element(this.element) && m.empty(this.element.rangeTouch) && (this.config = n({}, a, {}, i), this.init());
        }
        return function(e, i, s) {
            i && t(e.prototype, i), s && t(e, s);
        }(e, [
            {
                key: "init",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(!0), this.element.rangeTouch = this);
                }
            },
            {
                key: "destroy",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(!1), this.element.rangeTouch = null);
                }
            },
            {
                key: "listeners",
                value: function(e) {
                    var t = this, i = e ? "addEventListener" : "removeEventListener";
                    [
                        "touchstart",
                        "touchmove",
                        "touchend"
                    ].forEach(function(e) {
                        t.element[i](e, function(e) {
                            return t.set(e);
                        }, !1);
                    });
                }
            },
            {
                key: "get",
                value: function(t) {
                    if (!e.enabled || !m.event(t)) return null;
                    var i, s = t.target, n = t.changedTouches[0], a = parseFloat(s.getAttribute("min")) || 0, l = parseFloat(s.getAttribute("max")) || 100, r = parseFloat(s.getAttribute("step")) || 1, o = s.getBoundingClientRect(), c = 100 / o.width * (this.config.thumbWidth / 2) / 100;
                    return 0 > (i = 100 / o.width * (n.clientX - o.left)) ? i = 0 : 100 < i && (i = 100), 50 > i ? i -= (100 - 2 * i) * c : 50 < i && (i += 2 * (i - 50) * c), a + p(i / 100 * (l - a), r);
                }
            },
            {
                key: "set",
                value: function(t) {
                    e.enabled && m.event(t) && !t.target.disabled && (t.preventDefault(), t.target.value = this.get(t), function(e, t) {
                        if (e && t) {
                            var i = new Event(t, {
                                bubbles: !0
                            });
                            e.dispatchEvent(i);
                        }
                    }(t.target, "touchend" === t.type ? "change" : "input"));
                }
            }
        ], [
            {
                key: "setup",
                value: function(t) {
                    var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, s = null;
                    if (m.empty(t) || m.string(t) ? s = Array.from(document.querySelectorAll(m.string(t) ? t : 'input[type="range"]')) : m.element(t) ? s = [
                        t
                    ] : m.nodeList(t) ? s = Array.from(t) : m.array(t) && (s = t.filter(m.element)), m.empty(s)) return null;
                    var l = n({}, a, {}, i);
                    if (m.string(t) && l.watch) {
                        var r = new MutationObserver(function(i) {
                            Array.from(i).forEach(function(i) {
                                Array.from(i.addedNodes).forEach(function(i) {
                                    m.element(i) && function(e, t) {
                                        return (function() {
                                            return Array.from(document.querySelectorAll(t)).includes(this);
                                        }).call(e, t);
                                    }(i, t) && new e(i, l);
                                });
                            });
                        });
                        r.observe(document.body, {
                            childList: !0,
                            subtree: !0
                        });
                    }
                    return s.map(function(t) {
                        return new e(t, i);
                    });
                }
            },
            {
                key: "enabled",
                get: function() {
                    return "ontouchstart" in document.documentElement;
                }
            }
        ]), e;
    }();
    const f = (e)=>null != e ? e.constructor : null, y = (e, t)=>Boolean(e && t && e instanceof t), b = (e)=>null == e, v = (e)=>f(e) === Object, w = (e)=>f(e) === String, T = (e)=>"function" == typeof e, k = (e)=>Array.isArray(e), C = (e)=>y(e, NodeList), A = (e)=>b(e) || (w(e) || k(e) || C(e)) && !e.length || v(e) && !Object.keys(e).length;
    var S = {
        nullOrUndefined: b,
        object: v,
        number: (e)=>f(e) === Number && !Number.isNaN(e),
        string: w,
        boolean: (e)=>f(e) === Boolean,
        function: T,
        array: k,
        weakMap: (e)=>y(e, WeakMap),
        nodeList: C,
        element: (e)=>null !== e && "object" == typeof e && 1 === e.nodeType && "object" == typeof e.style && "object" == typeof e.ownerDocument,
        textNode: (e)=>f(e) === Text,
        event: (e)=>y(e, Event),
        keyboardEvent: (e)=>y(e, KeyboardEvent),
        cue: (e)=>y(e, window.TextTrackCue) || y(e, window.VTTCue),
        track: (e)=>y(e, TextTrack) || !b(e) && w(e.kind),
        promise: (e)=>y(e, Promise) && T(e.then),
        url: (e)=>{
            if (y(e, window.URL)) return !0;
            if (!w(e)) return !1;
            let t = e;
            e.startsWith("http://") && e.startsWith("https://") || (t = `http://${e}`);
            try {
                return !A(new URL(t).hostname);
            } catch (e) {
                return !1;
            }
        },
        empty: A
    };
    const E = (()=>{
        const e = document.createElement("span"), t = {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd otransitionend",
            transition: "transitionend"
        }, i = Object.keys(t).find((t)=>void 0 !== e.style[t]);
        return !!S.string(i) && t[i];
    })();
    function P(e, t) {
        setTimeout(()=>{
            try {
                e.hidden = !0, e.offsetHeight, e.hidden = !1;
            } catch (e) {}
        }, t);
    }
    var M = {
        isIE: Boolean(window.document.documentMode),
        isEdge: /Edge/g.test(navigator.userAgent),
        isWebKit: "WebkitAppearance" in document.documentElement.style && !/Edge/g.test(navigator.userAgent),
        isIPhone: /iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1,
        isIPadOS: "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1,
        isIos: /iPad|iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1
    };
    function N(e, t) {
        return t.split(".").reduce((e, t)=>e && e[t], e);
    }
    function x(e = {}, ...t) {
        if (!t.length) return e;
        const i = t.shift();
        return S.object(i) ? (Object.keys(i).forEach((t)=>{
            S.object(i[t]) ? (Object.keys(e).includes(t) || Object.assign(e, {
                [t]: {}
            }), x(e[t], i[t])) : Object.assign(e, {
                [t]: i[t]
            });
        }), x(e, ...t)) : e;
    }
    function L(e, t) {
        const i = e.length ? e : [
            e
        ];
        Array.from(i).reverse().forEach((e, i)=>{
            const s = i > 0 ? t.cloneNode(!0) : t, n = e.parentNode, a = e.nextSibling;
            s.appendChild(e), a ? n.insertBefore(s, a) : n.appendChild(s);
        });
    }
    function I(e, t) {
        S.element(e) && !S.empty(t) && Object.entries(t).filter(([, e])=>!S.nullOrUndefined(e)).forEach(([t, i])=>e.setAttribute(t, i));
    }
    function $(e, t, i) {
        const s = document.createElement(e);
        return S.object(t) && I(s, t), S.string(i) && (s.innerText = i), s;
    }
    function _(e, t, i, s) {
        S.element(t) && t.appendChild($(e, i, s));
    }
    function O(e) {
        S.nodeList(e) || S.array(e) ? Array.from(e).forEach(O) : S.element(e) && S.element(e.parentNode) && e.parentNode.removeChild(e);
    }
    function j(e) {
        if (!S.element(e)) return;
        let { length: t } = e.childNodes;
        for(; t > 0;)e.removeChild(e.lastChild), t -= 1;
    }
    function q(e, t) {
        return S.element(t) && S.element(t.parentNode) && S.element(e) ? (t.parentNode.replaceChild(e, t), e) : null;
    }
    function D(e, t) {
        if (!S.string(e) || S.empty(e)) return {};
        const i = {}, s = x({}, t);
        return e.split(",").forEach((e)=>{
            const t = e.trim(), n = t.replace(".", ""), a = t.replace(/[[\]]/g, "").split("="), [l] = a, r = a.length > 1 ? a[1].replace(/["']/g, "") : "";
            switch(t.charAt(0)){
                case ".":
                    S.string(s.class) ? i.class = `${s.class} ${n}` : i.class = n;
                    break;
                case "#":
                    i.id = t.replace("#", "");
                    break;
                case "[":
                    i[l] = r;
            }
        }), x(s, i);
    }
    function H(e, t) {
        if (!S.element(e)) return;
        let i = t;
        S.boolean(i) || (i = !e.hidden), e.hidden = i;
    }
    function R(e, t, i) {
        if (S.nodeList(e)) return Array.from(e).map((e)=>R(e, t, i));
        if (S.element(e)) {
            let s = "toggle";
            return void 0 !== i && (s = i ? "add" : "remove"), e.classList[s](t), e.classList.contains(t);
        }
        return !1;
    }
    function F(e, t) {
        return S.element(e) && e.classList.contains(t);
    }
    function V(e, t) {
        const { prototype: i } = Element;
        return (i.matches || i.webkitMatchesSelector || i.mozMatchesSelector || i.msMatchesSelector || function() {
            return Array.from(document.querySelectorAll(t)).includes(this);
        }).call(e, t);
    }
    function U(e) {
        return this.elements.container.querySelectorAll(e);
    }
    function B(e) {
        return this.elements.container.querySelector(e);
    }
    function W(e = null, t = !1) {
        S.element(e) && e.focus({
            preventScroll: !0,
            focusVisible: t
        });
    }
    const z = {
        "audio/ogg": "vorbis",
        "audio/wav": "1",
        "video/webm": "vp8, vorbis",
        "video/mp4": "avc1.42E01E, mp4a.40.2",
        "video/ogg": "theora"
    }, K = {
        audio: "canPlayType" in document.createElement("audio"),
        video: "canPlayType" in document.createElement("video"),
        check (e, t) {
            const i = K[e] || "html5" !== t;
            return {
                api: i,
                ui: i && K.rangeInput
            };
        },
        pip: !(M.isIPhone || !S.function($("video").webkitSetPresentationMode) && (!document.pictureInPictureEnabled || $("video").disablePictureInPicture)),
        airplay: S.function(window.WebKitPlaybackTargetAvailabilityEvent),
        playsinline: "playsInline" in document.createElement("video"),
        mime (e) {
            if (S.empty(e)) return !1;
            const [t] = e.split("/");
            let i = e;
            if (!this.isHTML5 || t !== this.type) return !1;
            Object.keys(z).includes(i) && (i += `; codecs="${z[e]}"`);
            try {
                return Boolean(i && this.media.canPlayType(i).replace(/no/, ""));
            } catch (e) {
                return !1;
            }
        },
        textTracks: "textTracks" in document.createElement("video"),
        rangeInput: (()=>{
            const e = document.createElement("input");
            return e.type = "range", "range" === e.type;
        })(),
        touch: "ontouchstart" in document.documentElement,
        transitions: !1 !== E,
        reducedMotion: "matchMedia" in window && window.matchMedia("(prefers-reduced-motion)").matches
    }, Y = (()=>{
        let e = !1;
        try {
            const t = Object.defineProperty({}, "passive", {
                get: ()=>(e = !0, null)
            });
            window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
        } catch (e) {}
        return e;
    })();
    function Q(e, t, i, s = !1, n = !0, a = !1) {
        if (!e || !("addEventListener" in e) || S.empty(t) || !S.function(i)) return;
        const l = t.split(" ");
        let r = a;
        Y && (r = {
            passive: n,
            capture: a
        }), l.forEach((t)=>{
            this && this.eventListeners && s && this.eventListeners.push({
                element: e,
                type: t,
                callback: i,
                options: r
            }), e[s ? "addEventListener" : "removeEventListener"](t, i, r);
        });
    }
    function X(e, t = "", i, s = !0, n = !1) {
        Q.call(this, e, t, i, !0, s, n);
    }
    function J(e, t = "", i, s = !0, n = !1) {
        Q.call(this, e, t, i, !1, s, n);
    }
    function G(e, t = "", i, s = !0, n = !1) {
        const a = (...l)=>{
            J(e, t, a, s, n), i.apply(this, l);
        };
        Q.call(this, e, t, a, !0, s, n);
    }
    function Z(e, t = "", i = !1, s = {}) {
        if (!S.element(e) || S.empty(t)) return;
        const n = new CustomEvent(t, {
            bubbles: i,
            detail: {
                ...s,
                plyr: this
            }
        });
        e.dispatchEvent(n);
    }
    function ee() {
        this && this.eventListeners && (this.eventListeners.forEach((e)=>{
            const { element: t, type: i, callback: s, options: n } = e;
            t.removeEventListener(i, s, n);
        }), this.eventListeners = []);
    }
    function te() {
        return new Promise((e)=>this.ready ? setTimeout(e, 0) : X.call(this, this.elements.container, "ready", e)).then(()=>{});
    }
    function ie(e) {
        S.promise(e) && e.then(null, ()=>{});
    }
    function se(e) {
        return S.array(e) ? e.filter((t, i)=>e.indexOf(t) === i) : e;
    }
    function ne(e, t) {
        return S.array(e) && e.length ? e.reduce((e, i)=>Math.abs(i - t) < Math.abs(e - t) ? i : e) : null;
    }
    function ae(e) {
        return !(!window || !window.CSS) && window.CSS.supports(e);
    }
    const le = [
        [
            1,
            1
        ],
        [
            4,
            3
        ],
        [
            3,
            4
        ],
        [
            5,
            4
        ],
        [
            4,
            5
        ],
        [
            3,
            2
        ],
        [
            2,
            3
        ],
        [
            16,
            10
        ],
        [
            10,
            16
        ],
        [
            16,
            9
        ],
        [
            9,
            16
        ],
        [
            21,
            9
        ],
        [
            9,
            21
        ],
        [
            32,
            9
        ],
        [
            9,
            32
        ]
    ].reduce((e, [t, i])=>({
            ...e,
            [t / i]: [
                t,
                i
            ]
        }), {});
    function re(e) {
        if (!(S.array(e) || S.string(e) && e.includes(":"))) return !1;
        return (S.array(e) ? e : e.split(":")).map(Number).every(S.number);
    }
    function oe(e) {
        if (!S.array(e) || !e.every(S.number)) return null;
        const [t, i] = e, s = (e, t)=>0 === t ? e : s(t, e % t), n = s(t, i);
        return [
            t / n,
            i / n
        ];
    }
    function ce(e) {
        const t = (e)=>re(e) ? e.split(":").map(Number) : null;
        let i = t(e);
        if (null === i && (i = t(this.config.ratio)), null === i && !S.empty(this.embed) && S.array(this.embed.ratio) && ({ ratio: i } = this.embed), null === i && this.isHTML5) {
            const { videoWidth: e, videoHeight: t } = this.media;
            i = [
                e,
                t
            ];
        }
        return oe(i);
    }
    function ue(e) {
        if (!this.isVideo) return {};
        const { wrapper: t } = this.elements, i = ce.call(this, e);
        if (!S.array(i)) return {};
        const [s, n] = oe(i), a = 100 / s * n;
        if (ae(`aspect-ratio: ${s}/${n}`) ? t.style.aspectRatio = `${s}/${n}` : t.style.paddingBottom = `${a}%`, this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
            const e = 100 / this.media.offsetWidth * parseInt(window.getComputedStyle(this.media).paddingBottom, 10), i = (e - a) / (e / 50);
            this.fullscreen.active ? t.style.paddingBottom = null : this.media.style.transform = `translateY(-${i}%)`;
        } else this.isHTML5 && t.classList.add(this.config.classNames.videoFixedRatio);
        return {
            padding: a,
            ratio: i
        };
    }
    function he(e, t, i = .05) {
        const s = e / t, n = ne(Object.keys(le), s);
        return Math.abs(n - s) <= i ? le[n] : [
            e,
            t
        ];
    }
    const de = {
        getSources () {
            if (!this.isHTML5) return [];
            return Array.from(this.media.querySelectorAll("source")).filter((e)=>{
                const t = e.getAttribute("type");
                return !!S.empty(t) || K.mime.call(this, t);
            });
        },
        getQualityOptions () {
            return this.config.quality.forced ? this.config.quality.options : de.getSources.call(this).map((e)=>Number(e.getAttribute("size"))).filter(Boolean);
        },
        setup () {
            if (!this.isHTML5) return;
            const e = this;
            e.options.speed = e.config.speed.options, S.empty(this.config.ratio) || ue.call(e), Object.defineProperty(e.media, "quality", {
                get () {
                    const t = de.getSources.call(e).find((t)=>t.getAttribute("src") === e.source);
                    return t && Number(t.getAttribute("size"));
                },
                set (t) {
                    if (e.quality !== t) {
                        if (e.config.quality.forced && S.function(e.config.quality.onChange)) e.config.quality.onChange(t);
                        else {
                            const i = de.getSources.call(e).find((e)=>Number(e.getAttribute("size")) === t);
                            if (!i) return;
                            const { currentTime: s, paused: n, preload: a, readyState: l, playbackRate: r } = e.media;
                            e.media.src = i.getAttribute("src"), ("none" !== a || l) && (e.once("loadedmetadata", ()=>{
                                e.speed = r, e.currentTime = s, n || ie(e.play());
                            }), e.media.load());
                        }
                        Z.call(e, e.media, "qualitychange", !1, {
                            quality: t
                        });
                    }
                }
            });
        },
        cancelRequests () {
            this.isHTML5 && (O(de.getSources.call(this)), this.media.setAttribute("src", this.config.blankVideo), this.media.load(), this.debug.log("Cancelled network requests"));
        }
    };
    function me(e, ...t) {
        return S.empty(e) ? e : e.toString().replace(/{(\d+)}/g, (e, i)=>t[i].toString());
    }
    const pe = (e = "", t = "", i = "")=>e.replace(new RegExp(t.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"), "g"), i.toString()), ge = (e = "")=>e.toString().replace(/\w\S*/g, (e)=>e.charAt(0).toUpperCase() + e.slice(1).toLowerCase());
    function fe(e = "") {
        let t = e.toString();
        return t = function(e = "") {
            let t = e.toString();
            return t = pe(t, "-", " "), t = pe(t, "_", " "), t = ge(t), pe(t, " ", "");
        }(t), t.charAt(0).toLowerCase() + t.slice(1);
    }
    function ye(e) {
        const t = document.createElement("div");
        return t.appendChild(e), t.innerHTML;
    }
    const be = {
        pip: "PIP",
        airplay: "AirPlay",
        html5: "HTML5",
        vimeo: "Vimeo",
        youtube: "YouTube"
    }, ve = {
        get (e = "", t = {}) {
            if (S.empty(e) || S.empty(t)) return "";
            let i = N(t.i18n, e);
            if (S.empty(i)) return Object.keys(be).includes(e) ? be[e] : "";
            const s = {
                "{seektime}": t.seekTime,
                "{title}": t.title
            };
            return Object.entries(s).forEach(([e, t])=>{
                i = pe(i, e, t);
            }), i;
        }
    };
    class we {
        constructor(t){
            e(this, "get", (e)=>{
                if (!we.supported || !this.enabled) return null;
                const t = window.localStorage.getItem(this.key);
                if (S.empty(t)) return null;
                const i = JSON.parse(t);
                return S.string(e) && e.length ? i[e] : i;
            }), e(this, "set", (e)=>{
                if (!we.supported || !this.enabled) return;
                if (!S.object(e)) return;
                let t = this.get();
                S.empty(t) && (t = {}), x(t, e);
                try {
                    window.localStorage.setItem(this.key, JSON.stringify(t));
                } catch (e) {}
            }), this.enabled = t.config.storage.enabled, this.key = t.config.storage.key;
        }
        static get supported() {
            try {
                if (!("localStorage" in window)) return !1;
                const e = "___test";
                return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
            } catch (e) {
                return !1;
            }
        }
    }
    function Te(e, t = "text") {
        return new Promise((i, s)=>{
            try {
                const s = new XMLHttpRequest;
                if (!("withCredentials" in s)) return;
                s.addEventListener("load", ()=>{
                    if ("text" === t) try {
                        i(JSON.parse(s.responseText));
                    } catch (e) {
                        i(s.responseText);
                    }
                    else i(s.response);
                }), s.addEventListener("error", ()=>{
                    throw new Error(s.status);
                }), s.open("GET", e, !0), s.responseType = t, s.send();
            } catch (e) {
                s(e);
            }
        });
    }
    function ke(e, t) {
        if (!S.string(e)) return;
        const i = "cache", s = S.string(t);
        let n = !1;
        const a = ()=>null !== document.getElementById(t), l = (e, t)=>{
            e.innerHTML = t, s && a() || document.body.insertAdjacentElement("afterbegin", e);
        };
        if (!s || !a()) {
            const a = we.supported, r = document.createElement("div");
            if (r.setAttribute("hidden", ""), s && r.setAttribute("id", t), a) {
                const e = window.localStorage.getItem(`${i}-${t}`);
                if (n = null !== e, n) {
                    const t = JSON.parse(e);
                    l(r, t.content);
                }
            }
            Te(e).then((e)=>{
                if (!S.empty(e)) {
                    if (a) try {
                        window.localStorage.setItem(`${i}-${t}`, JSON.stringify({
                            content: e
                        }));
                    } catch (e) {}
                    l(r, e);
                }
            }).catch(()=>{});
        }
    }
    const Ce = (e)=>Math.trunc(e / 60 / 60 % 60, 10), Ae = (e)=>Math.trunc(e / 60 % 60, 10), Se = (e)=>Math.trunc(e % 60, 10);
    function Ee(e = 0, t = !1, i = !1) {
        if (!S.number(e)) return Ee(void 0, t, i);
        const s = (e)=>`0${e}`.slice(-2);
        let n = Ce(e);
        const a = Ae(e), l = Se(e);
        return n = t || n > 0 ? `${n}:` : "", `${i && e > 0 ? "-" : ""}${n}${s(a)}:${s(l)}`;
    }
    const Pe = {
        getIconUrl () {
            const e = new URL(this.config.iconUrl, window.location), t = window.location.host ? window.location.host : window.top.location.host, i = e.host !== t || M.isIE && !window.svg4everybody;
            return {
                url: this.config.iconUrl,
                cors: i
            };
        },
        findElements () {
            try {
                return this.elements.controls = B.call(this, this.config.selectors.controls.wrapper), this.elements.buttons = {
                    play: U.call(this, this.config.selectors.buttons.play),
                    pause: B.call(this, this.config.selectors.buttons.pause),
                    restart: B.call(this, this.config.selectors.buttons.restart),
                    rewind: B.call(this, this.config.selectors.buttons.rewind),
                    fastForward: B.call(this, this.config.selectors.buttons.fastForward),
                    mute: B.call(this, this.config.selectors.buttons.mute),
                    pip: B.call(this, this.config.selectors.buttons.pip),
                    airplay: B.call(this, this.config.selectors.buttons.airplay),
                    settings: B.call(this, this.config.selectors.buttons.settings),
                    captions: B.call(this, this.config.selectors.buttons.captions),
                    fullscreen: B.call(this, this.config.selectors.buttons.fullscreen)
                }, this.elements.progress = B.call(this, this.config.selectors.progress), this.elements.inputs = {
                    seek: B.call(this, this.config.selectors.inputs.seek),
                    volume: B.call(this, this.config.selectors.inputs.volume)
                }, this.elements.display = {
                    buffer: B.call(this, this.config.selectors.display.buffer),
                    currentTime: B.call(this, this.config.selectors.display.currentTime),
                    duration: B.call(this, this.config.selectors.display.duration)
                }, S.element(this.elements.progress) && (this.elements.display.seekTooltip = this.elements.progress.querySelector(`.${this.config.classNames.tooltip}`)), !0;
            } catch (e) {
                return this.debug.warn("It looks like there is a problem with your custom controls HTML", e), this.toggleNativeControls(!0), !1;
            }
        },
        createIcon (e, t) {
            const i = "http://www.w3.org/2000/svg", s = Pe.getIconUrl.call(this), n = `${s.cors ? "" : s.url}#${this.config.iconPrefix}`, a = document.createElementNS(i, "svg");
            I(a, x(t, {
                "aria-hidden": "true",
                focusable: "false"
            }));
            const l = document.createElementNS(i, "use"), r = `${n}-${e}`;
            return "href" in l && l.setAttributeNS("http://www.w3.org/1999/xlink", "href", r), l.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", r), a.appendChild(l), a;
        },
        createLabel (e, t = {}) {
            const i = ve.get(e, this.config);
            return $("span", {
                ...t,
                class: [
                    t.class,
                    this.config.classNames.hidden
                ].filter(Boolean).join(" ")
            }, i);
        },
        createBadge (e) {
            if (S.empty(e)) return null;
            const t = $("span", {
                class: this.config.classNames.menu.value
            });
            return t.appendChild($("span", {
                class: this.config.classNames.menu.badge
            }, e)), t;
        },
        createButton (e, t) {
            const i = x({}, t);
            let s = fe(e);
            const n = {
                element: "button",
                toggle: !1,
                label: null,
                icon: null,
                labelPressed: null,
                iconPressed: null
            };
            switch([
                "element",
                "icon",
                "label"
            ].forEach((e)=>{
                Object.keys(i).includes(e) && (n[e] = i[e], delete i[e]);
            }), "button" !== n.element || Object.keys(i).includes("type") || (i.type = "button"), Object.keys(i).includes("class") ? i.class.split(" ").some((e)=>e === this.config.classNames.control) || x(i, {
                class: `${i.class} ${this.config.classNames.control}`
            }) : i.class = this.config.classNames.control, e){
                case "play":
                    n.toggle = !0, n.label = "play", n.labelPressed = "pause", n.icon = "play", n.iconPressed = "pause";
                    break;
                case "mute":
                    n.toggle = !0, n.label = "mute", n.labelPressed = "unmute", n.icon = "volume", n.iconPressed = "muted";
                    break;
                case "captions":
                    n.toggle = !0, n.label = "enableCaptions", n.labelPressed = "disableCaptions", n.icon = "captions-off", n.iconPressed = "captions-on";
                    break;
                case "fullscreen":
                    n.toggle = !0, n.label = "enterFullscreen", n.labelPressed = "exitFullscreen", n.icon = "enter-fullscreen", n.iconPressed = "exit-fullscreen";
                    break;
                case "play-large":
                    i.class += ` ${this.config.classNames.control}--overlaid`, s = "play", n.label = "play", n.icon = "play";
                    break;
                default:
                    S.empty(n.label) && (n.label = s), S.empty(n.icon) && (n.icon = e);
            }
            const a = $(n.element);
            return n.toggle ? (a.appendChild(Pe.createIcon.call(this, n.iconPressed, {
                class: "icon--pressed"
            })), a.appendChild(Pe.createIcon.call(this, n.icon, {
                class: "icon--not-pressed"
            })), a.appendChild(Pe.createLabel.call(this, n.labelPressed, {
                class: "label--pressed"
            })), a.appendChild(Pe.createLabel.call(this, n.label, {
                class: "label--not-pressed"
            }))) : (a.appendChild(Pe.createIcon.call(this, n.icon)), a.appendChild(Pe.createLabel.call(this, n.label))), x(i, D(this.config.selectors.buttons[s], i)), I(a, i), "play" === s ? (S.array(this.elements.buttons[s]) || (this.elements.buttons[s] = []), this.elements.buttons[s].push(a)) : this.elements.buttons[s] = a, a;
        },
        createRange (e, t) {
            const i = $("input", x(D(this.config.selectors.inputs[e]), {
                type: "range",
                min: 0,
                max: 100,
                step: .01,
                value: 0,
                autocomplete: "off",
                role: "slider",
                "aria-label": ve.get(e, this.config),
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": 0
            }, t));
            return this.elements.inputs[e] = i, Pe.updateRangeFill.call(this, i), g.setup(i), i;
        },
        createProgress (e, t) {
            const i = $("progress", x(D(this.config.selectors.display[e]), {
                min: 0,
                max: 100,
                value: 0,
                role: "progressbar",
                "aria-hidden": !0
            }, t));
            if ("volume" !== e) {
                i.appendChild($("span", null, "0"));
                const t = {
                    played: "played",
                    buffer: "buffered"
                }[e], s = t ? ve.get(t, this.config) : "";
                i.innerText = `% ${s.toLowerCase()}`;
            }
            return this.elements.display[e] = i, i;
        },
        createTime (e, t) {
            const i = D(this.config.selectors.display[e], t), s = $("div", x(i, {
                class: `${i.class ? i.class : ""} ${this.config.classNames.display.time} `.trim(),
                "aria-label": ve.get(e, this.config),
                role: "timer"
            }), "00:00");
            return this.elements.display[e] = s, s;
        },
        bindMenuItemShortcuts (e, t) {
            X.call(this, e, "keydown keyup", (i)=>{
                if (![
                    " ",
                    "ArrowUp",
                    "ArrowDown",
                    "ArrowRight"
                ].includes(i.key)) return;
                if (i.preventDefault(), i.stopPropagation(), "keydown" === i.type) return;
                const s = V(e, '[role="menuitemradio"]');
                if (!s && [
                    " ",
                    "ArrowRight"
                ].includes(i.key)) Pe.showMenuPanel.call(this, t, !0);
                else {
                    let t;
                    " " !== i.key && ("ArrowDown" === i.key || s && "ArrowRight" === i.key ? (t = e.nextElementSibling, S.element(t) || (t = e.parentNode.firstElementChild)) : (t = e.previousElementSibling, S.element(t) || (t = e.parentNode.lastElementChild)), W.call(this, t, !0));
                }
            }, !1), X.call(this, e, "keyup", (e)=>{
                "Return" === e.key && Pe.focusFirstMenuItem.call(this, null, !0);
            });
        },
        createMenuItem ({ value: e, list: t, type: i, title: s, badge: n = null, checked: a = !1 }) {
            const l = D(this.config.selectors.inputs[i]), r = $("button", x(l, {
                type: "button",
                role: "menuitemradio",
                class: `${this.config.classNames.control} ${l.class ? l.class : ""}`.trim(),
                "aria-checked": a,
                value: e
            })), o = $("span");
            o.innerHTML = s, S.element(n) && o.appendChild(n), r.appendChild(o), Object.defineProperty(r, "checked", {
                enumerable: !0,
                get: ()=>"true" === r.getAttribute("aria-checked"),
                set (e) {
                    e && Array.from(r.parentNode.children).filter((e)=>V(e, '[role="menuitemradio"]')).forEach((e)=>e.setAttribute("aria-checked", "false")), r.setAttribute("aria-checked", e ? "true" : "false");
                }
            }), this.listeners.bind(r, "click keyup", (t)=>{
                if (!S.keyboardEvent(t) || " " === t.key) {
                    switch(t.preventDefault(), t.stopPropagation(), r.checked = !0, i){
                        case "language":
                            this.currentTrack = Number(e);
                            break;
                        case "quality":
                            this.quality = e;
                            break;
                        case "speed":
                            this.speed = parseFloat(e);
                    }
                    Pe.showMenuPanel.call(this, "home", S.keyboardEvent(t));
                }
            }, i, !1), Pe.bindMenuItemShortcuts.call(this, r, i), t.appendChild(r);
        },
        formatTime (e = 0, t = !1) {
            if (!S.number(e)) return e;
            return Ee(e, Ce(this.duration) > 0, t);
        },
        updateTimeDisplay (e = null, t = 0, i = !1) {
            S.element(e) && S.number(t) && (e.innerText = Pe.formatTime(t, i));
        },
        updateVolume () {
            this.supported.ui && (S.element(this.elements.inputs.volume) && Pe.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume), S.element(this.elements.buttons.mute) && (this.elements.buttons.mute.pressed = this.muted || 0 === this.volume));
        },
        setRange (e, t = 0) {
            S.element(e) && (e.value = t, Pe.updateRangeFill.call(this, e));
        },
        updateProgress (e) {
            if (!this.supported.ui || !S.event(e)) return;
            let t = 0;
            const i = (e, t)=>{
                const i = S.number(t) ? t : 0, s = S.element(e) ? e : this.elements.display.buffer;
                if (S.element(s)) {
                    s.value = i;
                    const e = s.getElementsByTagName("span")[0];
                    S.element(e) && (e.childNodes[0].nodeValue = i);
                }
            };
            if (e) switch(e.type){
                case "timeupdate":
                case "seeking":
                case "seeked":
                    s = this.currentTime, n = this.duration, t = 0 === s || 0 === n || Number.isNaN(s) || Number.isNaN(n) ? 0 : (s / n * 100).toFixed(2), "timeupdate" === e.type && Pe.setRange.call(this, this.elements.inputs.seek, t);
                    break;
                case "playing":
                case "progress":
                    i(this.elements.display.buffer, 100 * this.buffered);
            }
            var s, n;
        },
        updateRangeFill (e) {
            const t = S.event(e) ? e.target : e;
            if (S.element(t) && "range" === t.getAttribute("type")) {
                if (V(t, this.config.selectors.inputs.seek)) {
                    t.setAttribute("aria-valuenow", this.currentTime);
                    const e = Pe.formatTime(this.currentTime), i = Pe.formatTime(this.duration), s = ve.get("seekLabel", this.config);
                    t.setAttribute("aria-valuetext", s.replace("{currentTime}", e).replace("{duration}", i));
                } else if (V(t, this.config.selectors.inputs.volume)) {
                    const e = 100 * t.value;
                    t.setAttribute("aria-valuenow", e), t.setAttribute("aria-valuetext", `${e.toFixed(1)}%`);
                } else t.setAttribute("aria-valuenow", t.value);
                (M.isWebKit || M.isIPadOS) && t.style.setProperty("--value", t.value / t.max * 100 + "%");
            }
        },
        updateSeekTooltip (e) {
            var t, i;
            if (!this.config.tooltips.seek || !S.element(this.elements.inputs.seek) || !S.element(this.elements.display.seekTooltip) || 0 === this.duration) return;
            const s = this.elements.display.seekTooltip, n = `${this.config.classNames.tooltip}--visible`, a = (e)=>R(s, n, e);
            if (this.touch) return void a(!1);
            let l = 0;
            const r = this.elements.progress.getBoundingClientRect();
            if (S.event(e)) l = 100 / r.width * (e.pageX - r.left);
            else {
                if (!F(s, n)) return;
                l = parseFloat(s.style.left, 10);
            }
            l < 0 ? l = 0 : l > 100 && (l = 100);
            const o = this.duration / 100 * l;
            s.innerText = Pe.formatTime(o);
            const c = null === (t = this.config.markers) || void 0 === t || null === (i = t.points) || void 0 === i ? void 0 : i.find(({ time: e })=>e === Math.round(o));
            c && s.insertAdjacentHTML("afterbegin", `${c.label}<br>`), s.style.left = `${l}%`, S.event(e) && [
                "mouseenter",
                "mouseleave"
            ].includes(e.type) && a("mouseenter" === e.type);
        },
        timeUpdate (e) {
            const t = !S.element(this.elements.display.duration) && this.config.invertTime;
            Pe.updateTimeDisplay.call(this, this.elements.display.currentTime, t ? this.duration - this.currentTime : this.currentTime, t), e && "timeupdate" === e.type && this.media.seeking || Pe.updateProgress.call(this, e);
        },
        durationUpdate () {
            if (!this.supported.ui || !this.config.invertTime && this.currentTime) return;
            if (this.duration >= 2 ** 32) return H(this.elements.display.currentTime, !0), void H(this.elements.progress, !0);
            S.element(this.elements.inputs.seek) && this.elements.inputs.seek.setAttribute("aria-valuemax", this.duration);
            const e = S.element(this.elements.display.duration);
            !e && this.config.displayDuration && this.paused && Pe.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration), e && Pe.updateTimeDisplay.call(this, this.elements.display.duration, this.duration), this.config.markers.enabled && Pe.setMarkers.call(this), Pe.updateSeekTooltip.call(this);
        },
        toggleMenuButton (e, t) {
            H(this.elements.settings.buttons[e], !t);
        },
        updateSetting (e, t, i) {
            const s = this.elements.settings.panels[e];
            let n = null, a = t;
            if ("captions" === e) n = this.currentTrack;
            else {
                if (n = S.empty(i) ? this[e] : i, S.empty(n) && (n = this.config[e].default), !S.empty(this.options[e]) && !this.options[e].includes(n)) return void this.debug.warn(`Unsupported value of '${n}' for ${e}`);
                if (!this.config[e].options.includes(n)) return void this.debug.warn(`Disabled value of '${n}' for ${e}`);
            }
            if (S.element(a) || (a = s && s.querySelector('[role="menu"]')), !S.element(a)) return;
            this.elements.settings.buttons[e].querySelector(`.${this.config.classNames.menu.value}`).innerHTML = Pe.getLabel.call(this, e, n);
            const l = a && a.querySelector(`[value="${n}"]`);
            S.element(l) && (l.checked = !0);
        },
        getLabel (e, t) {
            switch(e){
                case "speed":
                    return 1 === t ? ve.get("normal", this.config) : `${t}&times;`;
                case "quality":
                    if (S.number(t)) {
                        const e = ve.get(`qualityLabel.${t}`, this.config);
                        return e.length ? e : `${t}p`;
                    }
                    return ge(t);
                case "captions":
                    return xe.getLabel.call(this);
                default:
                    return null;
            }
        },
        setQualityMenu (e) {
            if (!S.element(this.elements.settings.panels.quality)) return;
            const t = "quality", i = this.elements.settings.panels.quality.querySelector('[role="menu"]');
            S.array(e) && (this.options.quality = se(e).filter((e)=>this.config.quality.options.includes(e)));
            const s = !S.empty(this.options.quality) && this.options.quality.length > 1;
            if (Pe.toggleMenuButton.call(this, t, s), j(i), Pe.checkMenu.call(this), !s) return;
            const n = (e)=>{
                const t = ve.get(`qualityBadge.${e}`, this.config);
                return t.length ? Pe.createBadge.call(this, t) : null;
            };
            this.options.quality.sort((e, t)=>{
                const i = this.config.quality.options;
                return i.indexOf(e) > i.indexOf(t) ? 1 : -1;
            }).forEach((e)=>{
                Pe.createMenuItem.call(this, {
                    value: e,
                    list: i,
                    type: t,
                    title: Pe.getLabel.call(this, "quality", e),
                    badge: n(e)
                });
            }), Pe.updateSetting.call(this, t, i);
        },
        setCaptionsMenu () {
            if (!S.element(this.elements.settings.panels.captions)) return;
            const e = "captions", t = this.elements.settings.panels.captions.querySelector('[role="menu"]'), i = xe.getTracks.call(this), s = Boolean(i.length);
            if (Pe.toggleMenuButton.call(this, e, s), j(t), Pe.checkMenu.call(this), !s) return;
            const n = i.map((e, i)=>({
                    value: i,
                    checked: this.captions.toggled && this.currentTrack === i,
                    title: xe.getLabel.call(this, e),
                    badge: e.language && Pe.createBadge.call(this, e.language.toUpperCase()),
                    list: t,
                    type: "language"
                }));
            n.unshift({
                value: -1,
                checked: !this.captions.toggled,
                title: ve.get("disabled", this.config),
                list: t,
                type: "language"
            }), n.forEach(Pe.createMenuItem.bind(this)), Pe.updateSetting.call(this, e, t);
        },
        setSpeedMenu () {
            if (!S.element(this.elements.settings.panels.speed)) return;
            const e = "speed", t = this.elements.settings.panels.speed.querySelector('[role="menu"]');
            this.options.speed = this.options.speed.filter((e)=>e >= this.minimumSpeed && e <= this.maximumSpeed);
            const i = !S.empty(this.options.speed) && this.options.speed.length > 1;
            Pe.toggleMenuButton.call(this, e, i), j(t), Pe.checkMenu.call(this), i && (this.options.speed.forEach((i)=>{
                Pe.createMenuItem.call(this, {
                    value: i,
                    list: t,
                    type: e,
                    title: Pe.getLabel.call(this, "speed", i)
                });
            }), Pe.updateSetting.call(this, e, t));
        },
        checkMenu () {
            const { buttons: e } = this.elements.settings, t = !S.empty(e) && Object.values(e).some((e)=>!e.hidden);
            H(this.elements.settings.menu, !t);
        },
        focusFirstMenuItem (e, t = !1) {
            if (this.elements.settings.popup.hidden) return;
            let i = e;
            S.element(i) || (i = Object.values(this.elements.settings.panels).find((e)=>!e.hidden));
            const s = i.querySelector('[role^="menuitem"]');
            W.call(this, s, t);
        },
        toggleMenu (e) {
            const { popup: t } = this.elements.settings, i = this.elements.buttons.settings;
            if (!S.element(t) || !S.element(i)) return;
            const { hidden: s } = t;
            let n = s;
            if (S.boolean(e)) n = e;
            else if (S.keyboardEvent(e) && "Escape" === e.key) n = !1;
            else if (S.event(e)) {
                const s = S.function(e.composedPath) ? e.composedPath()[0] : e.target, a = t.contains(s);
                if (a || !a && e.target !== i && n) return;
            }
            i.setAttribute("aria-expanded", n), H(t, !n), R(this.elements.container, this.config.classNames.menu.open, n), n && S.keyboardEvent(e) ? Pe.focusFirstMenuItem.call(this, null, !0) : n || s || W.call(this, i, S.keyboardEvent(e));
        },
        getMenuSize (e) {
            const t = e.cloneNode(!0);
            t.style.position = "absolute", t.style.opacity = 0, t.removeAttribute("hidden"), e.parentNode.appendChild(t);
            const i = t.scrollWidth, s = t.scrollHeight;
            return O(t), {
                width: i,
                height: s
            };
        },
        showMenuPanel (e = "", t = !1) {
            const i = this.elements.container.querySelector(`#plyr-settings-${this.id}-${e}`);
            if (!S.element(i)) return;
            const s = i.parentNode, n = Array.from(s.children).find((e)=>!e.hidden);
            if (K.transitions && !K.reducedMotion) {
                s.style.width = `${n.scrollWidth}px`, s.style.height = `${n.scrollHeight}px`;
                const e = Pe.getMenuSize.call(this, i), t = (e)=>{
                    e.target === s && [
                        "width",
                        "height"
                    ].includes(e.propertyName) && (s.style.width = "", s.style.height = "", J.call(this, s, E, t));
                };
                X.call(this, s, E, t), s.style.width = `${e.width}px`, s.style.height = `${e.height}px`;
            }
            H(n, !0), H(i, !1), Pe.focusFirstMenuItem.call(this, i, t);
        },
        setDownloadUrl () {
            const e = this.elements.buttons.download;
            S.element(e) && e.setAttribute("href", this.download);
        },
        create (e) {
            const { bindMenuItemShortcuts: t, createButton: i, createProgress: s, createRange: n, createTime: a, setQualityMenu: l, setSpeedMenu: r, showMenuPanel: o } = Pe;
            this.elements.controls = null, S.array(this.config.controls) && this.config.controls.includes("play-large") && this.elements.container.appendChild(i.call(this, "play-large"));
            const c = $("div", D(this.config.selectors.controls.wrapper));
            this.elements.controls = c;
            const u = {
                class: "plyr__controls__item"
            };
            return se(S.array(this.config.controls) ? this.config.controls : []).forEach((l)=>{
                if ("restart" === l && c.appendChild(i.call(this, "restart", u)), "rewind" === l && c.appendChild(i.call(this, "rewind", u)), "play" === l && c.appendChild(i.call(this, "play", u)), "fast-forward" === l && c.appendChild(i.call(this, "fast-forward", u)), "progress" === l) {
                    const t = $("div", {
                        class: `${u.class} plyr__progress__container`
                    }), i = $("div", D(this.config.selectors.progress));
                    if (i.appendChild(n.call(this, "seek", {
                        id: `plyr-seek-${e.id}`
                    })), i.appendChild(s.call(this, "buffer")), this.config.tooltips.seek) {
                        const e = $("span", {
                            class: this.config.classNames.tooltip
                        }, "00:00");
                        i.appendChild(e), this.elements.display.seekTooltip = e;
                    }
                    this.elements.progress = i, t.appendChild(this.elements.progress), c.appendChild(t);
                }
                if ("current-time" === l && c.appendChild(a.call(this, "currentTime", u)), "duration" === l && c.appendChild(a.call(this, "duration", u)), "mute" === l || "volume" === l) {
                    let { volume: t } = this.elements;
                    if (S.element(t) && c.contains(t) || (t = $("div", x({}, u, {
                        class: `${u.class} plyr__volume`.trim()
                    })), this.elements.volume = t, c.appendChild(t)), "mute" === l && t.appendChild(i.call(this, "mute")), "volume" === l && !M.isIos && !M.isIPadOS) {
                        const i = {
                            max: 1,
                            step: .05,
                            value: this.config.volume
                        };
                        t.appendChild(n.call(this, "volume", x(i, {
                            id: `plyr-volume-${e.id}`
                        })));
                    }
                }
                if ("captions" === l && c.appendChild(i.call(this, "captions", u)), "settings" === l && !S.empty(this.config.settings)) {
                    const s = $("div", x({}, u, {
                        class: `${u.class} plyr__menu`.trim(),
                        hidden: ""
                    }));
                    s.appendChild(i.call(this, "settings", {
                        "aria-haspopup": !0,
                        "aria-controls": `plyr-settings-${e.id}`,
                        "aria-expanded": !1
                    }));
                    const n = $("div", {
                        class: "plyr__menu__container",
                        id: `plyr-settings-${e.id}`,
                        hidden: ""
                    }), a = $("div"), l = $("div", {
                        id: `plyr-settings-${e.id}-home`
                    }), r = $("div", {
                        role: "menu"
                    });
                    l.appendChild(r), a.appendChild(l), this.elements.settings.panels.home = l, this.config.settings.forEach((i)=>{
                        const s = $("button", x(D(this.config.selectors.buttons.settings), {
                            type: "button",
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--forward`,
                            role: "menuitem",
                            "aria-haspopup": !0,
                            hidden: ""
                        }));
                        t.call(this, s, i), X.call(this, s, "click", ()=>{
                            o.call(this, i, !1);
                        });
                        const n = $("span", null, ve.get(i, this.config)), l = $("span", {
                            class: this.config.classNames.menu.value
                        });
                        l.innerHTML = e[i], n.appendChild(l), s.appendChild(n), r.appendChild(s);
                        const c = $("div", {
                            id: `plyr-settings-${e.id}-${i}`,
                            hidden: ""
                        }), u = $("button", {
                            type: "button",
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--back`
                        });
                        u.appendChild($("span", {
                            "aria-hidden": !0
                        }, ve.get(i, this.config))), u.appendChild($("span", {
                            class: this.config.classNames.hidden
                        }, ve.get("menuBack", this.config))), X.call(this, c, "keydown", (e)=>{
                            "ArrowLeft" === e.key && (e.preventDefault(), e.stopPropagation(), o.call(this, "home", !0));
                        }, !1), X.call(this, u, "click", ()=>{
                            o.call(this, "home", !1);
                        }), c.appendChild(u), c.appendChild($("div", {
                            role: "menu"
                        })), a.appendChild(c), this.elements.settings.buttons[i] = s, this.elements.settings.panels[i] = c;
                    }), n.appendChild(a), s.appendChild(n), c.appendChild(s), this.elements.settings.popup = n, this.elements.settings.menu = s;
                }
                if ("pip" === l && K.pip && c.appendChild(i.call(this, "pip", u)), "airplay" === l && K.airplay && c.appendChild(i.call(this, "airplay", u)), "download" === l) {
                    const e = x({}, u, {
                        element: "a",
                        href: this.download,
                        target: "_blank"
                    });
                    this.isHTML5 && (e.download = "");
                    const { download: t } = this.config.urls;
                    !S.url(t) && this.isEmbed && x(e, {
                        icon: `logo-${this.provider}`,
                        label: this.provider
                    }), c.appendChild(i.call(this, "download", e));
                }
                "fullscreen" === l && c.appendChild(i.call(this, "fullscreen", u));
            }), this.isHTML5 && l.call(this, de.getQualityOptions.call(this)), r.call(this), c;
        },
        inject () {
            if (this.config.loadSprite) {
                const e = Pe.getIconUrl.call(this);
                e.cors && ke(e.url, "sprite-plyr");
            }
            this.id = Math.floor(1e4 * Math.random());
            let e = null;
            this.elements.controls = null;
            const t = {
                id: this.id,
                seektime: this.config.seekTime,
                title: this.config.title
            };
            let i = !0;
            S.function(this.config.controls) && (this.config.controls = this.config.controls.call(this, t)), this.config.controls || (this.config.controls = []), S.element(this.config.controls) || S.string(this.config.controls) ? e = this.config.controls : (e = Pe.create.call(this, {
                id: this.id,
                seektime: this.config.seekTime,
                speed: this.speed,
                quality: this.quality,
                captions: xe.getLabel.call(this)
            }), i = !1);
            let s;
            i && S.string(this.config.controls) && (e = ((e)=>{
                let i = e;
                return Object.entries(t).forEach(([e, t])=>{
                    i = pe(i, `{${e}}`, t);
                }), i;
            })(e)), S.string(this.config.selectors.controls.container) && (s = document.querySelector(this.config.selectors.controls.container)), S.element(s) || (s = this.elements.container);
            if (s[S.element(e) ? "insertAdjacentElement" : "insertAdjacentHTML"]("afterbegin", e), S.element(this.elements.controls) || Pe.findElements.call(this), !S.empty(this.elements.buttons)) {
                const e = (e)=>{
                    const t = this.config.classNames.controlPressed;
                    e.setAttribute("aria-pressed", "false"), Object.defineProperty(e, "pressed", {
                        configurable: !0,
                        enumerable: !0,
                        get: ()=>F(e, t),
                        set (i = !1) {
                            R(e, t, i), e.setAttribute("aria-pressed", i ? "true" : "false");
                        }
                    });
                };
                Object.values(this.elements.buttons).filter(Boolean).forEach((t)=>{
                    S.array(t) || S.nodeList(t) ? Array.from(t).filter(Boolean).forEach(e) : e(t);
                });
            }
            if (M.isEdge && P(s), this.config.tooltips.controls) {
                const { classNames: e, selectors: t } = this.config, i = `${t.controls.wrapper} ${t.labels} .${e.hidden}`, s = U.call(this, i);
                Array.from(s).forEach((e)=>{
                    R(e, this.config.classNames.hidden, !1), R(e, this.config.classNames.tooltip, !0);
                });
            }
        },
        setMediaMetadata () {
            try {
                "mediaSession" in navigator && (navigator.mediaSession.metadata = new window.MediaMetadata({
                    title: this.config.mediaMetadata.title,
                    artist: this.config.mediaMetadata.artist,
                    album: this.config.mediaMetadata.album,
                    artwork: this.config.mediaMetadata.artwork
                }));
            } catch (e) {}
        },
        setMarkers () {
            var e, t;
            if (!this.duration || this.elements.markers) return;
            const i = null === (e = this.config.markers) || void 0 === e || null === (t = e.points) || void 0 === t ? void 0 : t.filter(({ time: e })=>e > 0 && e < this.duration);
            if (null == i || !i.length) return;
            const s = document.createDocumentFragment(), n = document.createDocumentFragment();
            let a = null;
            const l = `${this.config.classNames.tooltip}--visible`, r = (e)=>R(a, l, e);
            i.forEach((e)=>{
                const t = $("span", {
                    class: this.config.classNames.marker
                }, ""), i = e.time / this.duration * 100 + "%";
                a && (t.addEventListener("mouseenter", ()=>{
                    e.label || (a.style.left = i, a.innerHTML = e.label, r(!0));
                }), t.addEventListener("mouseleave", ()=>{
                    r(!1);
                })), t.addEventListener("click", ()=>{
                    this.currentTime = e.time;
                }), t.style.left = i, n.appendChild(t);
            }), s.appendChild(n), this.config.tooltips.seek || (a = $("span", {
                class: this.config.classNames.tooltip
            }, ""), s.appendChild(a)), this.elements.markers = {
                points: n,
                tip: a
            }, this.elements.progress.appendChild(s);
        }
    };
    function Me(e, t = !0) {
        let i = e;
        if (t) {
            const e = document.createElement("a");
            e.href = i, i = e.href;
        }
        try {
            return new URL(i);
        } catch (e) {
            return null;
        }
    }
    function Ne(e) {
        const t = new URLSearchParams;
        return S.object(e) && Object.entries(e).forEach(([e, i])=>{
            t.set(e, i);
        }), t;
    }
    const xe = {
        setup () {
            if (!this.supported.ui) return;
            if (!this.isVideo || this.isYouTube || this.isHTML5 && !K.textTracks) return void (S.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && Pe.setCaptionsMenu.call(this));
            var e, t;
            if (S.element(this.elements.captions) || (this.elements.captions = $("div", D(this.config.selectors.captions)), this.elements.captions.setAttribute("dir", "auto"), e = this.elements.captions, t = this.elements.wrapper, S.element(e) && S.element(t) && t.parentNode.insertBefore(e, t.nextSibling)), M.isIE && window.URL) {
                const e = this.media.querySelectorAll("track");
                Array.from(e).forEach((e)=>{
                    const t = e.getAttribute("src"), i = Me(t);
                    null !== i && i.hostname !== window.location.href.hostname && [
                        "http:",
                        "https:"
                    ].includes(i.protocol) && Te(t, "blob").then((t)=>{
                        e.setAttribute("src", window.URL.createObjectURL(t));
                    }).catch(()=>{
                        O(e);
                    });
                });
            }
            const i = se((navigator.languages || [
                navigator.language || navigator.userLanguage || "en"
            ]).map((e)=>e.split("-")[0]));
            let s = (this.storage.get("language") || this.config.captions.language || "auto").toLowerCase();
            "auto" === s && ([s] = i);
            let n = this.storage.get("captions");
            if (S.boolean(n) || ({ active: n } = this.config.captions), Object.assign(this.captions, {
                toggled: !1,
                active: n,
                language: s,
                languages: i
            }), this.isHTML5) {
                const e = this.config.captions.update ? "addtrack removetrack" : "removetrack";
                X.call(this, this.media.textTracks, e, xe.update.bind(this));
            }
            setTimeout(xe.update.bind(this), 0);
        },
        update () {
            const e = xe.getTracks.call(this, !0), { active: t, language: i, meta: s, currentTrackNode: n } = this.captions, a = Boolean(e.find((e)=>e.language === i));
            this.isHTML5 && this.isVideo && e.filter((e)=>!s.get(e)).forEach((e)=>{
                this.debug.log("Track added", e), s.set(e, {
                    default: "showing" === e.mode
                }), "showing" === e.mode && (e.mode = "hidden"), X.call(this, e, "cuechange", ()=>xe.updateCues.call(this));
            }), (a && this.language !== i || !e.includes(n)) && (xe.setLanguage.call(this, i), xe.toggle.call(this, t && a)), this.elements && R(this.elements.container, this.config.classNames.captions.enabled, !S.empty(e)), S.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && Pe.setCaptionsMenu.call(this);
        },
        toggle (e, t = !0) {
            if (!this.supported.ui) return;
            const { toggled: i } = this.captions, s = this.config.classNames.captions.active, n = S.nullOrUndefined(e) ? !i : e;
            if (n !== i) {
                if (t || (this.captions.active = n, this.storage.set({
                    captions: n
                })), !this.language && n && !t) {
                    const e = xe.getTracks.call(this), t = xe.findTrack.call(this, [
                        this.captions.language,
                        ...this.captions.languages
                    ], !0);
                    return this.captions.language = t.language, void xe.set.call(this, e.indexOf(t));
                }
                this.elements.buttons.captions && (this.elements.buttons.captions.pressed = n), R(this.elements.container, s, n), this.captions.toggled = n, Pe.updateSetting.call(this, "captions"), Z.call(this, this.media, n ? "captionsenabled" : "captionsdisabled");
            }
            setTimeout(()=>{
                n && this.captions.toggled && (this.captions.currentTrackNode.mode = "hidden");
            });
        },
        set (e, t = !0) {
            const i = xe.getTracks.call(this);
            if (-1 !== e) {
                if (S.number(e)) {
                    if (e in i) {
                        if (this.captions.currentTrack !== e) {
                            this.captions.currentTrack = e;
                            const s = i[e], { language: n } = s || {};
                            this.captions.currentTrackNode = s, Pe.updateSetting.call(this, "captions"), t || (this.captions.language = n, this.storage.set({
                                language: n
                            })), this.isVimeo && this.embed.enableTextTrack(n), Z.call(this, this.media, "languagechange");
                        }
                        xe.toggle.call(this, !0, t), this.isHTML5 && this.isVideo && xe.updateCues.call(this);
                    } else this.debug.warn("Track not found", e);
                } else this.debug.warn("Invalid caption argument", e);
            } else xe.toggle.call(this, !1, t);
        },
        setLanguage (e, t = !0) {
            if (!S.string(e)) return void this.debug.warn("Invalid language argument", e);
            const i = e.toLowerCase();
            this.captions.language = i;
            const s = xe.getTracks.call(this), n = xe.findTrack.call(this, [
                i
            ]);
            xe.set.call(this, s.indexOf(n), t);
        },
        getTracks (e = !1) {
            return Array.from((this.media || {}).textTracks || []).filter((t)=>!this.isHTML5 || e || this.captions.meta.has(t)).filter((e)=>[
                    "captions",
                    "subtitles"
                ].includes(e.kind));
        },
        findTrack (e, t = !1) {
            const i = xe.getTracks.call(this), s = (e)=>Number((this.captions.meta.get(e) || {}).default), n = Array.from(i).sort((e, t)=>s(t) - s(e));
            let a;
            return e.every((e)=>(a = n.find((t)=>t.language === e), !a)), a || (t ? n[0] : void 0);
        },
        getCurrentTrack () {
            return xe.getTracks.call(this)[this.currentTrack];
        },
        getLabel (e) {
            let t = e;
            return !S.track(t) && K.textTracks && this.captions.toggled && (t = xe.getCurrentTrack.call(this)), S.track(t) ? S.empty(t.label) ? S.empty(t.language) ? ve.get("enabled", this.config) : e.language.toUpperCase() : t.label : ve.get("disabled", this.config);
        },
        updateCues (e) {
            if (!this.supported.ui) return;
            if (!S.element(this.elements.captions)) return void this.debug.warn("No captions element to render to");
            if (!S.nullOrUndefined(e) && !Array.isArray(e)) return void this.debug.warn("updateCues: Invalid input", e);
            let t = e;
            if (!t) {
                const e = xe.getCurrentTrack.call(this);
                t = Array.from((e || {}).activeCues || []).map((e)=>e.getCueAsHTML()).map(ye);
            }
            const i = t.map((e)=>e.trim()).join("\n");
            if (i !== this.elements.captions.innerHTML) {
                j(this.elements.captions);
                const e = $("span", D(this.config.selectors.caption));
                e.innerHTML = i, this.elements.captions.appendChild(e), Z.call(this, this.media, "cuechange");
            }
        }
    }, Le = {
        enabled: !0,
        title: "",
        debug: !1,
        autoplay: !1,
        autopause: !0,
        playsinline: !0,
        seekTime: 10,
        volume: 1,
        muted: !1,
        duration: null,
        displayDuration: !0,
        invertTime: !0,
        toggleInvert: !0,
        ratio: null,
        clickToPlay: !0,
        hideControls: !0,
        resetOnEnd: !1,
        disableContextMenu: !0,
        loadSprite: !0,
        iconPrefix: "plyr",
        iconUrl: "https://cdn.plyr.io/3.7.8/plyr.svg",
        blankVideo: "https://cdn.plyr.io/static/blank.mp4",
        quality: {
            default: 576,
            options: [
                4320,
                2880,
                2160,
                1440,
                1080,
                720,
                576,
                480,
                360,
                240
            ],
            forced: !1,
            onChange: null
        },
        loop: {
            active: !1
        },
        speed: {
            selected: 1,
            options: [
                .5,
                .75,
                1,
                1.25,
                1.5,
                1.75,
                2,
                4
            ]
        },
        keyboard: {
            focused: !0,
            global: !1
        },
        tooltips: {
            controls: !1,
            seek: !0
        },
        captions: {
            active: !1,
            language: "auto",
            update: !1
        },
        fullscreen: {
            enabled: !0,
            fallback: !0,
            iosNative: !1
        },
        storage: {
            enabled: !0,
            key: "plyr"
        },
        controls: [
            "play-large",
            "play",
            "progress",
            "current-time",
            "mute",
            "volume",
            "captions",
            "settings",
            "pip",
            "airplay",
            "fullscreen"
        ],
        settings: [
            "captions",
            "quality",
            "speed"
        ],
        i18n: {
            restart: "Restart",
            rewind: "Rewind {seektime}s",
            play: "Play",
            pause: "Pause",
            fastForward: "Forward {seektime}s",
            seek: "Seek",
            seekLabel: "{currentTime} of {duration}",
            played: "Played",
            buffered: "Buffered",
            currentTime: "Current time",
            duration: "Duration",
            volume: "Volume",
            mute: "Mute",
            unmute: "Unmute",
            enableCaptions: "Enable captions",
            disableCaptions: "Disable captions",
            download: "Download",
            enterFullscreen: "Enter fullscreen",
            exitFullscreen: "Exit fullscreen",
            frameTitle: "Player for {title}",
            captions: "Captions",
            settings: "Settings",
            pip: "PIP",
            menuBack: "Go back to previous menu",
            speed: "Speed",
            normal: "Normal",
            quality: "Quality",
            loop: "Loop",
            start: "Start",
            end: "End",
            all: "All",
            reset: "Reset",
            disabled: "Disabled",
            enabled: "Enabled",
            advertisement: "Ad",
            qualityBadge: {
                2160: "4K",
                1440: "HD",
                1080: "HD",
                720: "HD",
                576: "SD",
                480: "SD"
            }
        },
        urls: {
            download: null,
            vimeo: {
                sdk: "https://player.vimeo.com/api/player.js",
                iframe: "https://player.vimeo.com/video/{0}?{1}",
                api: "https://vimeo.com/api/oembed.json?url={0}"
            },
            youtube: {
                sdk: "https://www.youtube.com/iframe_api",
                api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}"
            },
            googleIMA: {
                sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js"
            }
        },
        listeners: {
            seek: null,
            play: null,
            pause: null,
            restart: null,
            rewind: null,
            fastForward: null,
            mute: null,
            volume: null,
            captions: null,
            download: null,
            fullscreen: null,
            pip: null,
            airplay: null,
            speed: null,
            quality: null,
            loop: null,
            language: null
        },
        events: [
            "ended",
            "progress",
            "stalled",
            "playing",
            "waiting",
            "canplay",
            "canplaythrough",
            "loadstart",
            "loadeddata",
            "loadedmetadata",
            "timeupdate",
            "volumechange",
            "play",
            "pause",
            "error",
            "seeking",
            "seeked",
            "emptied",
            "ratechange",
            "cuechange",
            "download",
            "enterfullscreen",
            "exitfullscreen",
            "captionsenabled",
            "captionsdisabled",
            "languagechange",
            "controlshidden",
            "controlsshown",
            "ready",
            "statechange",
            "qualitychange",
            "adsloaded",
            "adscontentpause",
            "adscontentresume",
            "adstarted",
            "adsmidpoint",
            "adscomplete",
            "adsallcomplete",
            "adsimpression",
            "adsclick"
        ],
        selectors: {
            editable: "input, textarea, select, [contenteditable]",
            container: ".plyr",
            controls: {
                container: null,
                wrapper: ".plyr__controls"
            },
            labels: "[data-plyr]",
            buttons: {
                play: '[data-plyr="play"]',
                pause: '[data-plyr="pause"]',
                restart: '[data-plyr="restart"]',
                rewind: '[data-plyr="rewind"]',
                fastForward: '[data-plyr="fast-forward"]',
                mute: '[data-plyr="mute"]',
                captions: '[data-plyr="captions"]',
                download: '[data-plyr="download"]',
                fullscreen: '[data-plyr="fullscreen"]',
                pip: '[data-plyr="pip"]',
                airplay: '[data-plyr="airplay"]',
                settings: '[data-plyr="settings"]',
                loop: '[data-plyr="loop"]'
            },
            inputs: {
                seek: '[data-plyr="seek"]',
                volume: '[data-plyr="volume"]',
                speed: '[data-plyr="speed"]',
                language: '[data-plyr="language"]',
                quality: '[data-plyr="quality"]'
            },
            display: {
                currentTime: ".plyr__time--current",
                duration: ".plyr__time--duration",
                buffer: ".plyr__progress__buffer",
                loop: ".plyr__progress__loop",
                volume: ".plyr__volume--display"
            },
            progress: ".plyr__progress",
            captions: ".plyr__captions",
            caption: ".plyr__caption"
        },
        classNames: {
            type: "plyr--{0}",
            provider: "plyr--{0}",
            video: "plyr__video-wrapper",
            embed: "plyr__video-embed",
            videoFixedRatio: "plyr__video-wrapper--fixed-ratio",
            embedContainer: "plyr__video-embed__container",
            poster: "plyr__poster",
            posterEnabled: "plyr__poster-enabled",
            ads: "plyr__ads",
            control: "plyr__control",
            controlPressed: "plyr__control--pressed",
            playing: "plyr--playing",
            paused: "plyr--paused",
            stopped: "plyr--stopped",
            loading: "plyr--loading",
            hover: "plyr--hover",
            tooltip: "plyr__tooltip",
            cues: "plyr__cues",
            marker: "plyr__progress__marker",
            hidden: "plyr__sr-only",
            hideControls: "plyr--hide-controls",
            isTouch: "plyr--is-touch",
            uiSupported: "plyr--full-ui",
            noTransition: "plyr--no-transition",
            display: {
                time: "plyr__time"
            },
            menu: {
                value: "plyr__menu__value",
                badge: "plyr__badge",
                open: "plyr--menu-open"
            },
            captions: {
                enabled: "plyr--captions-enabled",
                active: "plyr--captions-active"
            },
            fullscreen: {
                enabled: "plyr--fullscreen-enabled",
                fallback: "plyr--fullscreen-fallback"
            },
            pip: {
                supported: "plyr--pip-supported",
                active: "plyr--pip-active"
            },
            airplay: {
                supported: "plyr--airplay-supported",
                active: "plyr--airplay-active"
            },
            previewThumbnails: {
                thumbContainer: "plyr__preview-thumb",
                thumbContainerShown: "plyr__preview-thumb--is-shown",
                imageContainer: "plyr__preview-thumb__image-container",
                timeContainer: "plyr__preview-thumb__time-container",
                scrubbingContainer: "plyr__preview-scrubbing",
                scrubbingContainerShown: "plyr__preview-scrubbing--is-shown"
            }
        },
        attributes: {
            embed: {
                provider: "data-plyr-provider",
                id: "data-plyr-embed-id",
                hash: "data-plyr-embed-hash"
            }
        },
        ads: {
            enabled: !1,
            publisherId: "",
            tagUrl: ""
        },
        previewThumbnails: {
            enabled: !1,
            src: ""
        },
        vimeo: {
            byline: !1,
            portrait: !1,
            title: !1,
            speed: !0,
            transparent: !1,
            customControls: !0,
            referrerPolicy: null,
            premium: !1
        },
        youtube: {
            rel: 0,
            showinfo: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            customControls: !0,
            noCookie: !1
        },
        mediaMetadata: {
            title: "",
            artist: "",
            album: "",
            artwork: []
        },
        markers: {
            enabled: !1,
            points: []
        }
    }, Ie = "picture-in-picture", $e = "inline", _e = {
        html5: "html5",
        youtube: "youtube",
        vimeo: "vimeo"
    }, Oe = "audio", je = "video";
    const qe = ()=>{};
    class De {
        constructor(e = !1){
            this.enabled = window.console && e, this.enabled && this.log("Debugging enabled");
        }
        get log() {
            return this.enabled ? Function.prototype.bind.call(console.log, console) : qe;
        }
        get warn() {
            return this.enabled ? Function.prototype.bind.call(console.warn, console) : qe;
        }
        get error() {
            return this.enabled ? Function.prototype.bind.call(console.error, console) : qe;
        }
    }
    class He {
        constructor(t){
            e(this, "onChange", ()=>{
                if (!this.supported) return;
                const e = this.player.elements.buttons.fullscreen;
                S.element(e) && (e.pressed = this.active);
                const t = this.target === this.player.media ? this.target : this.player.elements.container;
                Z.call(this.player, t, this.active ? "enterfullscreen" : "exitfullscreen", !0);
            }), e(this, "toggleFallback", (e = !1)=>{
                if (e ? this.scrollPosition = {
                    x: window.scrollX ?? 0,
                    y: window.scrollY ?? 0
                } : window.scrollTo(this.scrollPosition.x, this.scrollPosition.y), document.body.style.overflow = e ? "hidden" : "", R(this.target, this.player.config.classNames.fullscreen.fallback, e), M.isIos) {
                    let t = document.head.querySelector('meta[name="viewport"]');
                    const i = "viewport-fit=cover";
                    t || (t = document.createElement("meta"), t.setAttribute("name", "viewport"));
                    const s = S.string(t.content) && t.content.includes(i);
                    e ? (this.cleanupViewport = !s, s || (t.content += `,${i}`)) : this.cleanupViewport && (t.content = t.content.split(",").filter((e)=>e.trim() !== i).join(","));
                }
                this.onChange();
            }), e(this, "trapFocus", (e)=>{
                if (M.isIos || M.isIPadOS || !this.active || "Tab" !== e.key) return;
                const t = document.activeElement, i = U.call(this.player, "a[href], button:not(:disabled), input:not(:disabled), [tabindex]"), [s] = i, n = i[i.length - 1];
                t !== n || e.shiftKey ? t === s && e.shiftKey && (n.focus(), e.preventDefault()) : (s.focus(), e.preventDefault());
            }), e(this, "update", ()=>{
                if (this.supported) {
                    let e;
                    e = this.forceFallback ? "Fallback (forced)" : He.nativeSupported ? "Native" : "Fallback", this.player.debug.log(`${e} fullscreen enabled`);
                } else this.player.debug.log("Fullscreen not supported and fallback disabled");
                R(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.supported);
            }), e(this, "enter", ()=>{
                this.supported && (M.isIos && this.player.config.fullscreen.iosNative ? this.player.isVimeo ? this.player.embed.requestFullscreen() : this.target.webkitEnterFullscreen() : !He.nativeSupported || this.forceFallback ? this.toggleFallback(!0) : this.prefix ? S.empty(this.prefix) || this.target[`${this.prefix}Request${this.property}`]() : this.target.requestFullscreen({
                    navigationUI: "hide"
                }));
            }), e(this, "exit", ()=>{
                if (this.supported) {
                    if (M.isIos && this.player.config.fullscreen.iosNative) this.player.isVimeo ? this.player.embed.exitFullscreen() : this.target.webkitEnterFullscreen(), ie(this.player.play());
                    else if (!He.nativeSupported || this.forceFallback) this.toggleFallback(!1);
                    else if (this.prefix) {
                        if (!S.empty(this.prefix)) {
                            const e = "moz" === this.prefix ? "Cancel" : "Exit";
                            document[`${this.prefix}${e}${this.property}`]();
                        }
                    } else (document.cancelFullScreen || document.exitFullscreen).call(document);
                }
            }), e(this, "toggle", ()=>{
                this.active ? this.exit() : this.enter();
            }), this.player = t, this.prefix = He.prefix, this.property = He.property, this.scrollPosition = {
                x: 0,
                y: 0
            }, this.forceFallback = "force" === t.config.fullscreen.fallback, this.player.elements.fullscreen = t.config.fullscreen.container && function(e, t) {
                const { prototype: i } = Element;
                return (i.closest || function() {
                    let e = this;
                    do {
                        if (V.matches(e, t)) return e;
                        e = e.parentElement || e.parentNode;
                    }while (null !== e && 1 === e.nodeType);
                    return null;
                }).call(e, t);
            }(this.player.elements.container, t.config.fullscreen.container), X.call(this.player, document, "ms" === this.prefix ? "MSFullscreenChange" : `${this.prefix}fullscreenchange`, ()=>{
                this.onChange();
            }), X.call(this.player, this.player.elements.container, "dblclick", (e)=>{
                S.element(this.player.elements.controls) && this.player.elements.controls.contains(e.target) || this.player.listeners.proxy(e, this.toggle, "fullscreen");
            }), X.call(this, this.player.elements.container, "keydown", (e)=>this.trapFocus(e)), this.update();
        }
        static get nativeSupported() {
            return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
        }
        get useNative() {
            return He.nativeSupported && !this.forceFallback;
        }
        static get prefix() {
            if (S.function(document.exitFullscreen)) return "";
            let e = "";
            return [
                "webkit",
                "moz",
                "ms"
            ].some((t)=>!(!S.function(document[`${t}ExitFullscreen`]) && !S.function(document[`${t}CancelFullScreen`])) && (e = t, !0)), e;
        }
        static get property() {
            return "moz" === this.prefix ? "FullScreen" : "Fullscreen";
        }
        get supported() {
            return [
                this.player.config.fullscreen.enabled,
                this.player.isVideo,
                He.nativeSupported || this.player.config.fullscreen.fallback,
                !this.player.isYouTube || He.nativeSupported || !M.isIos || this.player.config.playsinline && !this.player.config.fullscreen.iosNative
            ].every(Boolean);
        }
        get active() {
            if (!this.supported) return !1;
            if (!He.nativeSupported || this.forceFallback) return F(this.target, this.player.config.classNames.fullscreen.fallback);
            const e = this.prefix ? this.target.getRootNode()[`${this.prefix}${this.property}Element`] : this.target.getRootNode().fullscreenElement;
            return e && e.shadowRoot ? e === this.target.getRootNode().host : e === this.target;
        }
        get target() {
            return M.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.fullscreen ?? this.player.elements.container;
        }
    }
    function Re(e, t = 1) {
        return new Promise((i, s)=>{
            const n = new Image, a = ()=>{
                delete n.onload, delete n.onerror, (n.naturalWidth >= t ? i : s)(n);
            };
            Object.assign(n, {
                onload: a,
                onerror: a,
                src: e
            });
        });
    }
    const Fe = {
        addStyleHook () {
            R(this.elements.container, this.config.selectors.container.replace(".", ""), !0), R(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
        },
        toggleNativeControls (e = !1) {
            e && this.isHTML5 ? this.media.setAttribute("controls", "") : this.media.removeAttribute("controls");
        },
        build () {
            if (this.listeners.media(), !this.supported.ui) return this.debug.warn(`Basic support only for ${this.provider} ${this.type}`), void Fe.toggleNativeControls.call(this, !0);
            S.element(this.elements.controls) || (Pe.inject.call(this), this.listeners.controls()), Fe.toggleNativeControls.call(this), this.isHTML5 && xe.setup.call(this), this.volume = null, this.muted = null, this.loop = null, this.quality = null, this.speed = null, Pe.updateVolume.call(this), Pe.timeUpdate.call(this), Pe.durationUpdate.call(this), Fe.checkPlaying.call(this), R(this.elements.container, this.config.classNames.pip.supported, K.pip && this.isHTML5 && this.isVideo), R(this.elements.container, this.config.classNames.airplay.supported, K.airplay && this.isHTML5), R(this.elements.container, this.config.classNames.isTouch, this.touch), this.ready = !0, setTimeout(()=>{
                Z.call(this, this.media, "ready");
            }, 0), Fe.setTitle.call(this), this.poster && Fe.setPoster.call(this, this.poster, !1).catch(()=>{}), this.config.duration && Pe.durationUpdate.call(this), this.config.mediaMetadata && Pe.setMediaMetadata.call(this);
        },
        setTitle () {
            let e = ve.get("play", this.config);
            if (S.string(this.config.title) && !S.empty(this.config.title) && (e += `, ${this.config.title}`), Array.from(this.elements.buttons.play || []).forEach((t)=>{
                t.setAttribute("aria-label", e);
            }), this.isEmbed) {
                const e = B.call(this, "iframe");
                if (!S.element(e)) return;
                const t = S.empty(this.config.title) ? "video" : this.config.title, i = ve.get("frameTitle", this.config);
                e.setAttribute("title", i.replace("{title}", t));
            }
        },
        togglePoster (e) {
            R(this.elements.container, this.config.classNames.posterEnabled, e);
        },
        setPoster (e, t = !0) {
            return t && this.poster ? Promise.reject(new Error("Poster already set")) : (this.media.setAttribute("data-poster", e), this.elements.poster.removeAttribute("hidden"), te.call(this).then(()=>Re(e)).catch((t)=>{
                throw e === this.poster && Fe.togglePoster.call(this, !1), t;
            }).then(()=>{
                if (e !== this.poster) throw new Error("setPoster cancelled by later call to setPoster");
            }).then(()=>(Object.assign(this.elements.poster.style, {
                    backgroundImage: `url('${e}')`,
                    backgroundSize: ""
                }), Fe.togglePoster.call(this, !0), e)));
        },
        checkPlaying (e) {
            R(this.elements.container, this.config.classNames.playing, this.playing), R(this.elements.container, this.config.classNames.paused, this.paused), R(this.elements.container, this.config.classNames.stopped, this.stopped), Array.from(this.elements.buttons.play || []).forEach((e)=>{
                Object.assign(e, {
                    pressed: this.playing
                }), e.setAttribute("aria-label", ve.get(this.playing ? "pause" : "play", this.config));
            }), S.event(e) && "timeupdate" === e.type || Fe.toggleControls.call(this);
        },
        checkLoading (e) {
            this.loading = [
                "stalled",
                "waiting"
            ].includes(e.type), clearTimeout(this.timers.loading), this.timers.loading = setTimeout(()=>{
                R(this.elements.container, this.config.classNames.loading, this.loading), Fe.toggleControls.call(this);
            }, this.loading ? 250 : 0);
        },
        toggleControls (e) {
            const { controls: t } = this.elements;
            if (t && this.config.hideControls) {
                const i = this.touch && this.lastSeekTime + 2e3 > Date.now();
                this.toggleControls(Boolean(e || this.loading || this.paused || t.pressed || t.hover || i));
            }
        },
        migrateStyles () {
            Object.values({
                ...this.media.style
            }).filter((e)=>!S.empty(e) && S.string(e) && e.startsWith("--plyr")).forEach((e)=>{
                this.elements.container.style.setProperty(e, this.media.style.getPropertyValue(e)), this.media.style.removeProperty(e);
            }), S.empty(this.media.style) && this.media.removeAttribute("style");
        }
    };
    class Ve {
        constructor(t){
            e(this, "firstTouch", ()=>{
                const { player: e } = this, { elements: t } = e;
                e.touch = !0, R(t.container, e.config.classNames.isTouch, !0);
            }), e(this, "global", (e = !0)=>{
                const { player: t } = this;
                t.config.keyboard.global && Q.call(t, window, "keydown keyup", this.handleKey, e, !1), Q.call(t, document.body, "click", this.toggleMenu, e), G.call(t, document.body, "touchstart", this.firstTouch);
            }), e(this, "container", ()=>{
                const { player: e } = this, { config: t, elements: i, timers: s } = e;
                !t.keyboard.global && t.keyboard.focused && X.call(e, i.container, "keydown keyup", this.handleKey, !1), X.call(e, i.container, "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen", (t)=>{
                    const { controls: n } = i;
                    n && "enterfullscreen" === t.type && (n.pressed = !1, n.hover = !1);
                    let a = 0;
                    [
                        "touchstart",
                        "touchmove",
                        "mousemove"
                    ].includes(t.type) && (Fe.toggleControls.call(e, !0), a = e.touch ? 3e3 : 2e3), clearTimeout(s.controls), s.controls = setTimeout(()=>Fe.toggleControls.call(e, !1), a);
                });
                const n = ()=>{
                    if (!e.isVimeo || e.config.vimeo.premium) return;
                    const t = i.wrapper, { active: s } = e.fullscreen, [n, a] = ce.call(e), l = ae(`aspect-ratio: ${n} / ${a}`);
                    if (!s) return void (l ? (t.style.width = null, t.style.height = null) : (t.style.maxWidth = null, t.style.margin = null));
                    const [r, o] = [
                        Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
                        Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
                    ], c = r / o > n / a;
                    l ? (t.style.width = c ? "auto" : "100%", t.style.height = c ? "100%" : "auto") : (t.style.maxWidth = c ? o / a * n + "px" : null, t.style.margin = c ? "0 auto" : null);
                }, a = ()=>{
                    clearTimeout(s.resized), s.resized = setTimeout(n, 50);
                };
                X.call(e, i.container, "enterfullscreen exitfullscreen", (t)=>{
                    const { target: s } = e.fullscreen;
                    if (s !== i.container) return;
                    if (!e.isEmbed && S.empty(e.config.ratio)) return;
                    n();
                    ("enterfullscreen" === t.type ? X : J).call(e, window, "resize", a);
                });
            }), e(this, "media", ()=>{
                const { player: e } = this, { elements: t } = e;
                if (X.call(e, e.media, "timeupdate seeking seeked", (t)=>Pe.timeUpdate.call(e, t)), X.call(e, e.media, "durationchange loadeddata loadedmetadata", (t)=>Pe.durationUpdate.call(e, t)), X.call(e, e.media, "ended", ()=>{
                    e.isHTML5 && e.isVideo && e.config.resetOnEnd && (e.restart(), e.pause());
                }), X.call(e, e.media, "progress playing seeking seeked", (t)=>Pe.updateProgress.call(e, t)), X.call(e, e.media, "volumechange", (t)=>Pe.updateVolume.call(e, t)), X.call(e, e.media, "playing play pause ended emptied timeupdate", (t)=>Fe.checkPlaying.call(e, t)), X.call(e, e.media, "waiting canplay seeked playing", (t)=>Fe.checkLoading.call(e, t)), e.supported.ui && e.config.clickToPlay && !e.isAudio) {
                    const i = B.call(e, `.${e.config.classNames.video}`);
                    if (!S.element(i)) return;
                    X.call(e, t.container, "click", (s)=>{
                        ([
                            t.container,
                            i
                        ].includes(s.target) || i.contains(s.target)) && (e.touch && e.config.hideControls || (e.ended ? (this.proxy(s, e.restart, "restart"), this.proxy(s, ()=>{
                            ie(e.play());
                        }, "play")) : this.proxy(s, ()=>{
                            ie(e.togglePlay());
                        }, "play")));
                    });
                }
                e.supported.ui && e.config.disableContextMenu && X.call(e, t.wrapper, "contextmenu", (e)=>{
                    e.preventDefault();
                }, !1), X.call(e, e.media, "volumechange", ()=>{
                    e.storage.set({
                        volume: e.volume,
                        muted: e.muted
                    });
                }), X.call(e, e.media, "ratechange", ()=>{
                    Pe.updateSetting.call(e, "speed"), e.storage.set({
                        speed: e.speed
                    });
                }), X.call(e, e.media, "qualitychange", (t)=>{
                    Pe.updateSetting.call(e, "quality", null, t.detail.quality);
                }), X.call(e, e.media, "ready qualitychange", ()=>{
                    Pe.setDownloadUrl.call(e);
                });
                const i = e.config.events.concat([
                    "keyup",
                    "keydown"
                ]).join(" ");
                X.call(e, e.media, i, (i)=>{
                    let { detail: s = {} } = i;
                    "error" === i.type && (s = e.media.error), Z.call(e, t.container, i.type, !0, s);
                });
            }), e(this, "proxy", (e, t, i)=>{
                const { player: s } = this, n = s.config.listeners[i];
                let a = !0;
                S.function(n) && (a = n.call(s, e)), !1 !== a && S.function(t) && t.call(s, e);
            }), e(this, "bind", (e, t, i, s, n = !0)=>{
                const { player: a } = this, l = a.config.listeners[s], r = S.function(l);
                X.call(a, e, t, (e)=>this.proxy(e, i, s), n && !r);
            }), e(this, "controls", ()=>{
                const { player: e } = this, { elements: t } = e, i = M.isIE ? "change" : "input";
                if (t.buttons.play && Array.from(t.buttons.play).forEach((t)=>{
                    this.bind(t, "click", ()=>{
                        ie(e.togglePlay());
                    }, "play");
                }), this.bind(t.buttons.restart, "click", e.restart, "restart"), this.bind(t.buttons.rewind, "click", ()=>{
                    e.lastSeekTime = Date.now(), e.rewind();
                }, "rewind"), this.bind(t.buttons.fastForward, "click", ()=>{
                    e.lastSeekTime = Date.now(), e.forward();
                }, "fastForward"), this.bind(t.buttons.mute, "click", ()=>{
                    e.muted = !e.muted;
                }, "mute"), this.bind(t.buttons.captions, "click", ()=>e.toggleCaptions()), this.bind(t.buttons.download, "click", ()=>{
                    Z.call(e, e.media, "download");
                }, "download"), this.bind(t.buttons.fullscreen, "click", ()=>{
                    e.fullscreen.toggle();
                }, "fullscreen"), this.bind(t.buttons.pip, "click", ()=>{
                    e.pip = "toggle";
                }, "pip"), this.bind(t.buttons.airplay, "click", e.airplay, "airplay"), this.bind(t.buttons.settings, "click", (t)=>{
                    t.stopPropagation(), t.preventDefault(), Pe.toggleMenu.call(e, t);
                }, null, !1), this.bind(t.buttons.settings, "keyup", (t)=>{
                    [
                        " ",
                        "Enter"
                    ].includes(t.key) && ("Enter" !== t.key ? (t.preventDefault(), t.stopPropagation(), Pe.toggleMenu.call(e, t)) : Pe.focusFirstMenuItem.call(e, null, !0));
                }, null, !1), this.bind(t.settings.menu, "keydown", (t)=>{
                    "Escape" === t.key && Pe.toggleMenu.call(e, t);
                }), this.bind(t.inputs.seek, "mousedown mousemove", (e)=>{
                    const i = t.progress.getBoundingClientRect(), s = 100 / i.width * (e.pageX - i.left);
                    e.currentTarget.setAttribute("seek-value", s);
                }), this.bind(t.inputs.seek, "mousedown mouseup keydown keyup touchstart touchend", (t)=>{
                    const i = t.currentTarget, s = "play-on-seeked";
                    if (S.keyboardEvent(t) && ![
                        "ArrowLeft",
                        "ArrowRight"
                    ].includes(t.key)) return;
                    e.lastSeekTime = Date.now();
                    const n = i.hasAttribute(s), a = [
                        "mouseup",
                        "touchend",
                        "keyup"
                    ].includes(t.type);
                    n && a ? (i.removeAttribute(s), ie(e.play())) : !a && e.playing && (i.setAttribute(s, ""), e.pause());
                }), M.isIos) {
                    const t = U.call(e, 'input[type="range"]');
                    Array.from(t).forEach((e)=>this.bind(e, i, (e)=>P(e.target)));
                }
                this.bind(t.inputs.seek, i, (t)=>{
                    const i = t.currentTarget;
                    let s = i.getAttribute("seek-value");
                    S.empty(s) && (s = i.value), i.removeAttribute("seek-value"), e.currentTime = s / i.max * e.duration;
                }, "seek"), this.bind(t.progress, "mouseenter mouseleave mousemove", (t)=>Pe.updateSeekTooltip.call(e, t)), this.bind(t.progress, "mousemove touchmove", (t)=>{
                    const { previewThumbnails: i } = e;
                    i && i.loaded && i.startMove(t);
                }), this.bind(t.progress, "mouseleave touchend click", ()=>{
                    const { previewThumbnails: t } = e;
                    t && t.loaded && t.endMove(!1, !0);
                }), this.bind(t.progress, "mousedown touchstart", (t)=>{
                    const { previewThumbnails: i } = e;
                    i && i.loaded && i.startScrubbing(t);
                }), this.bind(t.progress, "mouseup touchend", (t)=>{
                    const { previewThumbnails: i } = e;
                    i && i.loaded && i.endScrubbing(t);
                }), M.isWebKit && Array.from(U.call(e, 'input[type="range"]')).forEach((t)=>{
                    this.bind(t, "input", (t)=>Pe.updateRangeFill.call(e, t.target));
                }), e.config.toggleInvert && !S.element(t.display.duration) && this.bind(t.display.currentTime, "click", ()=>{
                    0 !== e.currentTime && (e.config.invertTime = !e.config.invertTime, Pe.timeUpdate.call(e));
                }), this.bind(t.inputs.volume, i, (t)=>{
                    e.volume = t.target.value;
                }, "volume"), this.bind(t.controls, "mouseenter mouseleave", (i)=>{
                    t.controls.hover = !e.touch && "mouseenter" === i.type;
                }), t.fullscreen && Array.from(t.fullscreen.children).filter((e)=>!e.contains(t.container)).forEach((i)=>{
                    this.bind(i, "mouseenter mouseleave", (i)=>{
                        t.controls && (t.controls.hover = !e.touch && "mouseenter" === i.type);
                    });
                }), this.bind(t.controls, "mousedown mouseup touchstart touchend touchcancel", (e)=>{
                    t.controls.pressed = [
                        "mousedown",
                        "touchstart"
                    ].includes(e.type);
                }), this.bind(t.controls, "focusin", ()=>{
                    const { config: i, timers: s } = e;
                    R(t.controls, i.classNames.noTransition, !0), Fe.toggleControls.call(e, !0), setTimeout(()=>{
                        R(t.controls, i.classNames.noTransition, !1);
                    }, 0);
                    const n = this.touch ? 3e3 : 4e3;
                    clearTimeout(s.controls), s.controls = setTimeout(()=>Fe.toggleControls.call(e, !1), n);
                }), this.bind(t.inputs.volume, "wheel", (t)=>{
                    const i = t.webkitDirectionInvertedFromDevice, [s, n] = [
                        t.deltaX,
                        -t.deltaY
                    ].map((e)=>i ? -e : e), a = Math.sign(Math.abs(s) > Math.abs(n) ? s : n);
                    e.increaseVolume(a / 50);
                    const { volume: l } = e.media;
                    (1 === a && l < 1 || -1 === a && l > 0) && t.preventDefault();
                }, "volume", !1);
            }), this.player = t, this.lastKey = null, this.focusTimer = null, this.lastKeyDown = null, this.handleKey = this.handleKey.bind(this), this.toggleMenu = this.toggleMenu.bind(this), this.firstTouch = this.firstTouch.bind(this);
        }
        handleKey(e) {
            const { player: t } = this, { elements: i } = t, { key: s, type: n, altKey: a, ctrlKey: l, metaKey: r, shiftKey: o } = e, c = "keydown" === n, u = c && s === this.lastKey;
            if (a || l || r || o) return;
            if (!s) return;
            if (c) {
                const n = document.activeElement;
                if (S.element(n)) {
                    const { editable: s } = t.config.selectors, { seek: a } = i.inputs;
                    if (n !== a && V(n, s)) return;
                    if (" " === e.key && V(n, 'button, [role^="menuitem"]')) return;
                }
                switch([
                    " ",
                    "ArrowLeft",
                    "ArrowUp",
                    "ArrowRight",
                    "ArrowDown",
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "c",
                    "f",
                    "k",
                    "l",
                    "m"
                ].includes(s) && (e.preventDefault(), e.stopPropagation()), s){
                    case "0":
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                        u || (h = parseInt(s, 10), t.currentTime = t.duration / 10 * h);
                        break;
                    case " ":
                    case "k":
                        u || ie(t.togglePlay());
                        break;
                    case "ArrowUp":
                        t.increaseVolume(.1);
                        break;
                    case "ArrowDown":
                        t.decreaseVolume(.1);
                        break;
                    case "m":
                        u || (t.muted = !t.muted);
                        break;
                    case "ArrowRight":
                        t.forward();
                        break;
                    case "ArrowLeft":
                        t.rewind();
                        break;
                    case "f":
                        t.fullscreen.toggle();
                        break;
                    case "c":
                        u || t.toggleCaptions();
                        break;
                    case "l":
                        t.loop = !t.loop;
                }
                "Escape" === s && !t.fullscreen.usingNative && t.fullscreen.active && t.fullscreen.toggle(), this.lastKey = s;
            } else this.lastKey = null;
            var h;
        }
        toggleMenu(e) {
            Pe.toggleMenu.call(this.player, e);
        }
    }
    "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self && self;
    var Ue = function(e, t) {
        return e(t = {
            exports: {}
        }, t.exports), t.exports;
    }(function(e, t) {
        e.exports = function() {
            var e = function() {}, t = {}, i = {}, s = {};
            function n(e, t) {
                e = e.push ? e : [
                    e
                ];
                var n, a, l, r = [], o = e.length, c = o;
                for(n = function(e, i) {
                    i.length && r.push(e), --c || t(r);
                }; o--;)a = e[o], (l = i[a]) ? n(a, l) : (s[a] = s[a] || []).push(n);
            }
            function a(e, t) {
                if (e) {
                    var n = s[e];
                    if (i[e] = t, n) for(; n.length;)n[0](e, t), n.splice(0, 1);
                }
            }
            function l(t, i) {
                t.call && (t = {
                    success: t
                }), i.length ? (t.error || e)(i) : (t.success || e)(t);
            }
            function r(t, i, s, n) {
                var a, l, o = document, c = s.async, u = (s.numRetries || 0) + 1, h = s.before || e, d = t.replace(/[\?|#].*$/, ""), m = t.replace(/^(css|img)!/, "");
                n = n || 0, /(^css!|\.css$)/.test(d) ? ((l = o.createElement("link")).rel = "stylesheet", l.href = m, (a = "hideFocus" in l) && l.relList && (a = 0, l.rel = "preload", l.as = "style")) : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(d) ? (l = o.createElement("img")).src = m : ((l = o.createElement("script")).src = t, l.async = void 0 === c || c), l.onload = l.onerror = l.onbeforeload = function(e) {
                    var o = e.type[0];
                    if (a) try {
                        l.sheet.cssText.length || (o = "e");
                    } catch (e) {
                        18 != e.code && (o = "e");
                    }
                    if ("e" == o) {
                        if ((n += 1) < u) return r(t, i, s, n);
                    } else if ("preload" == l.rel && "style" == l.as) return l.rel = "stylesheet";
                    i(t, o, e.defaultPrevented);
                }, !1 !== h(t, l) && o.head.appendChild(l);
            }
            function o(e, t, i) {
                var s, n, a = (e = e.push ? e : [
                    e
                ]).length, l = a, o = [];
                for(s = function(e, i, s) {
                    if ("e" == i && o.push(e), "b" == i) {
                        if (!s) return;
                        o.push(e);
                    }
                    --a || t(o);
                }, n = 0; n < l; n++)r(e[n], s, i);
            }
            function c(e, i, s) {
                var n, r;
                if (i && i.trim && (n = i), r = (n ? s : i) || {}, n) {
                    if (n in t) throw "LoadJS";
                    t[n] = !0;
                }
                function c(t, i) {
                    o(e, function(e) {
                        l(r, e), t && l({
                            success: t,
                            error: i
                        }, e), a(n, e);
                    }, r);
                }
                if (r.returnPromise) return new Promise(c);
                c();
            }
            return c.ready = function(e, t) {
                return n(e, function(e) {
                    l(t, e);
                }), c;
            }, c.done = function(e) {
                a(e, []);
            }, c.reset = function() {
                t = {}, i = {}, s = {};
            }, c.isDefined = function(e) {
                return e in t;
            }, c;
        }();
    });
    function Be(e) {
        return new Promise((t, i)=>{
            Ue(e, {
                success: t,
                error: i
            });
        });
    }
    function We(e) {
        e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && (this.media.paused = !e, Z.call(this, this.media, e ? "play" : "pause"));
    }
    const ze = {
        setup () {
            const e = this;
            R(e.elements.wrapper, e.config.classNames.embed, !0), e.options.speed = e.config.speed.options, ue.call(e), S.object(window.Vimeo) ? ze.ready.call(e) : Be(e.config.urls.vimeo.sdk).then(()=>{
                ze.ready.call(e);
            }).catch((t)=>{
                e.debug.warn("Vimeo SDK (player.js) failed to load", t);
            });
        },
        ready () {
            const e = this, t = e.config.vimeo, { premium: i, referrerPolicy: s, ...n } = t;
            let a = e.media.getAttribute("src"), l = "";
            S.empty(a) ? (a = e.media.getAttribute(e.config.attributes.embed.id), l = e.media.getAttribute(e.config.attributes.embed.hash)) : l = function(e) {
                const t = e.match(/^.*(vimeo.com\/|video\/)(\d+)(\?.*&*h=|\/)+([\d,a-f]+)/);
                return t && 5 === t.length ? t[4] : null;
            }(a);
            const r = l ? {
                h: l
            } : {};
            i && Object.assign(n, {
                controls: !1,
                sidedock: !1
            });
            const o = Ne({
                loop: e.config.loop.active,
                autoplay: e.autoplay,
                muted: e.muted,
                gesture: "media",
                playsinline: e.config.playsinline,
                ...r,
                ...n
            }), c = (u = a, S.empty(u) ? null : S.number(Number(u)) ? u : u.match(/^.*(vimeo.com\/|video\/)(\d+).*/) ? RegExp.$2 : u);
            var u;
            const h = $("iframe"), d = me(e.config.urls.vimeo.iframe, c, o);
            if (h.setAttribute("src", d), h.setAttribute("allowfullscreen", ""), h.setAttribute("allow", [
                "autoplay",
                "fullscreen",
                "picture-in-picture",
                "encrypted-media",
                "accelerometer",
                "gyroscope"
            ].join("; ")), S.empty(s) || h.setAttribute("referrerPolicy", s), i || !t.customControls) h.setAttribute("data-poster", e.poster), e.media = q(h, e.media);
            else {
                const t = $("div", {
                    class: e.config.classNames.embedContainer,
                    "data-poster": e.poster
                });
                t.appendChild(h), e.media = q(t, e.media);
            }
            t.customControls || Te(me(e.config.urls.vimeo.api, d)).then((t)=>{
                !S.empty(t) && t.thumbnail_url && Fe.setPoster.call(e, t.thumbnail_url).catch(()=>{});
            }), e.embed = new window.Vimeo.Player(h, {
                autopause: e.config.autopause,
                muted: e.muted
            }), e.media.paused = !0, e.media.currentTime = 0, e.supported.ui && e.embed.disableTextTrack(), e.media.play = ()=>(We.call(e, !0), e.embed.play()), e.media.pause = ()=>(We.call(e, !1), e.embed.pause()), e.media.stop = ()=>{
                e.pause(), e.currentTime = 0;
            };
            let { currentTime: m } = e.media;
            Object.defineProperty(e.media, "currentTime", {
                get: ()=>m,
                set (t) {
                    const { embed: i, media: s, paused: n, volume: a } = e, l = n && !i.hasPlayed;
                    s.seeking = !0, Z.call(e, s, "seeking"), Promise.resolve(l && i.setVolume(0)).then(()=>i.setCurrentTime(t)).then(()=>l && i.pause()).then(()=>l && i.setVolume(a)).catch(()=>{});
                }
            });
            let p = e.config.speed.selected;
            Object.defineProperty(e.media, "playbackRate", {
                get: ()=>p,
                set (t) {
                    e.embed.setPlaybackRate(t).then(()=>{
                        p = t, Z.call(e, e.media, "ratechange");
                    }).catch(()=>{
                        e.options.speed = [
                            1
                        ];
                    });
                }
            });
            let { volume: g } = e.config;
            Object.defineProperty(e.media, "volume", {
                get: ()=>g,
                set (t) {
                    e.embed.setVolume(t).then(()=>{
                        g = t, Z.call(e, e.media, "volumechange");
                    });
                }
            });
            let { muted: f } = e.config;
            Object.defineProperty(e.media, "muted", {
                get: ()=>f,
                set (t) {
                    const i = !!S.boolean(t) && t;
                    e.embed.setMuted(!!i || e.config.muted).then(()=>{
                        f = i, Z.call(e, e.media, "volumechange");
                    });
                }
            });
            let y, { loop: b } = e.config;
            Object.defineProperty(e.media, "loop", {
                get: ()=>b,
                set (t) {
                    const i = S.boolean(t) ? t : e.config.loop.active;
                    e.embed.setLoop(i).then(()=>{
                        b = i;
                    });
                }
            }), e.embed.getVideoUrl().then((t)=>{
                y = t, Pe.setDownloadUrl.call(e);
            }).catch((e)=>{
                this.debug.warn(e);
            }), Object.defineProperty(e.media, "currentSrc", {
                get: ()=>y
            }), Object.defineProperty(e.media, "ended", {
                get: ()=>e.currentTime === e.duration
            }), Promise.all([
                e.embed.getVideoWidth(),
                e.embed.getVideoHeight()
            ]).then((t)=>{
                const [i, s] = t;
                e.embed.ratio = he(i, s), ue.call(this);
            }), e.embed.setAutopause(e.config.autopause).then((t)=>{
                e.config.autopause = t;
            }), e.embed.getVideoTitle().then((t)=>{
                e.config.title = t, Fe.setTitle.call(this);
            }), e.embed.getCurrentTime().then((t)=>{
                m = t, Z.call(e, e.media, "timeupdate");
            }), e.embed.getDuration().then((t)=>{
                e.media.duration = t, Z.call(e, e.media, "durationchange");
            }), e.embed.getTextTracks().then((t)=>{
                e.media.textTracks = t, xe.setup.call(e);
            }), e.embed.on("cuechange", ({ cues: t = [] })=>{
                const i = t.map((e)=>(function(e) {
                        const t = document.createDocumentFragment(), i = document.createElement("div");
                        return t.appendChild(i), i.innerHTML = e, t.firstChild.innerText;
                    })(e.text));
                xe.updateCues.call(e, i);
            }), e.embed.on("loaded", ()=>{
                if (e.embed.getPaused().then((t)=>{
                    We.call(e, !t), t || Z.call(e, e.media, "playing");
                }), S.element(e.embed.element) && e.supported.ui) e.embed.element.setAttribute("tabindex", -1);
            }), e.embed.on("bufferstart", ()=>{
                Z.call(e, e.media, "waiting");
            }), e.embed.on("bufferend", ()=>{
                Z.call(e, e.media, "playing");
            }), e.embed.on("play", ()=>{
                We.call(e, !0), Z.call(e, e.media, "playing");
            }), e.embed.on("pause", ()=>{
                We.call(e, !1);
            }), e.embed.on("timeupdate", (t)=>{
                e.media.seeking = !1, m = t.seconds, Z.call(e, e.media, "timeupdate");
            }), e.embed.on("progress", (t)=>{
                e.media.buffered = t.percent, Z.call(e, e.media, "progress"), 1 === parseInt(t.percent, 10) && Z.call(e, e.media, "canplaythrough"), e.embed.getDuration().then((t)=>{
                    t !== e.media.duration && (e.media.duration = t, Z.call(e, e.media, "durationchange"));
                });
            }), e.embed.on("seeked", ()=>{
                e.media.seeking = !1, Z.call(e, e.media, "seeked");
            }), e.embed.on("ended", ()=>{
                e.media.paused = !0, Z.call(e, e.media, "ended");
            }), e.embed.on("error", (t)=>{
                e.media.error = t, Z.call(e, e.media, "error");
            }), t.customControls && setTimeout(()=>Fe.build.call(e), 0);
        }
    };
    function Ke(e) {
        e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && (this.media.paused = !e, Z.call(this, this.media, e ? "play" : "pause"));
    }
    function Ye(e) {
        return e.noCookie ? "https://www.youtube-nocookie.com" : "http:" === window.location.protocol ? "http://www.youtube.com" : void 0;
    }
    const Qe = {
        setup () {
            if (R(this.elements.wrapper, this.config.classNames.embed, !0), S.object(window.YT) && S.function(window.YT.Player)) Qe.ready.call(this);
            else {
                const e = window.onYouTubeIframeAPIReady;
                window.onYouTubeIframeAPIReady = ()=>{
                    S.function(e) && e(), Qe.ready.call(this);
                }, Be(this.config.urls.youtube.sdk).catch((e)=>{
                    this.debug.warn("YouTube API failed to load", e);
                });
            }
        },
        getTitle (e) {
            Te(me(this.config.urls.youtube.api, e)).then((e)=>{
                if (S.object(e)) {
                    const { title: t, height: i, width: s } = e;
                    this.config.title = t, Fe.setTitle.call(this), this.embed.ratio = he(s, i);
                }
                ue.call(this);
            }).catch(()=>{
                ue.call(this);
            });
        },
        ready () {
            const e = this, t = e.config.youtube, i = e.media && e.media.getAttribute("id");
            if (!S.empty(i) && i.startsWith("youtube-")) return;
            let s = e.media.getAttribute("src");
            S.empty(s) && (s = e.media.getAttribute(this.config.attributes.embed.id));
            const n = (a = s, S.empty(a) ? null : a.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/) ? RegExp.$2 : a);
            var a;
            const l = $("div", {
                id: `${e.provider}-${Math.floor(1e4 * Math.random())}`,
                "data-poster": t.customControls ? e.poster : void 0
            });
            if (e.media = q(l, e.media), t.customControls) {
                const t = (e)=>`https://i.ytimg.com/vi/${n}/${e}default.jpg`;
                Re(t("maxres"), 121).catch(()=>Re(t("sd"), 121)).catch(()=>Re(t("hq"))).then((t)=>Fe.setPoster.call(e, t.src)).then((t)=>{
                    t.includes("maxres") || (e.elements.poster.style.backgroundSize = "cover");
                }).catch(()=>{});
            }
            e.embed = new window.YT.Player(e.media, {
                videoId: n,
                host: Ye(t),
                playerVars: x({}, {
                    autoplay: e.config.autoplay ? 1 : 0,
                    hl: e.config.hl,
                    controls: e.supported.ui && t.customControls ? 0 : 1,
                    disablekb: 1,
                    playsinline: e.config.playsinline && !e.config.fullscreen.iosNative ? 1 : 0,
                    cc_load_policy: e.captions.active ? 1 : 0,
                    cc_lang_pref: e.config.captions.language,
                    widget_referrer: window ? window.location.href : null
                }, t),
                events: {
                    onError (t) {
                        if (!e.media.error) {
                            const i = t.data, s = {
                                2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",
                                5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",
                                100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",
                                101: "The owner of the requested video does not allow it to be played in embedded players.",
                                150: "The owner of the requested video does not allow it to be played in embedded players."
                            }[i] || "An unknown error occurred";
                            e.media.error = {
                                code: i,
                                message: s
                            }, Z.call(e, e.media, "error");
                        }
                    },
                    onPlaybackRateChange (t) {
                        const i = t.target;
                        e.media.playbackRate = i.getPlaybackRate(), Z.call(e, e.media, "ratechange");
                    },
                    onReady (i) {
                        if (S.function(e.media.play)) return;
                        const s = i.target;
                        Qe.getTitle.call(e, n), e.media.play = ()=>{
                            Ke.call(e, !0), s.playVideo();
                        }, e.media.pause = ()=>{
                            Ke.call(e, !1), s.pauseVideo();
                        }, e.media.stop = ()=>{
                            s.stopVideo();
                        }, e.media.duration = s.getDuration(), e.media.paused = !0, e.media.currentTime = 0, Object.defineProperty(e.media, "currentTime", {
                            get: ()=>Number(s.getCurrentTime()),
                            set (t) {
                                e.paused && !e.embed.hasPlayed && e.embed.mute(), e.media.seeking = !0, Z.call(e, e.media, "seeking"), s.seekTo(t);
                            }
                        }), Object.defineProperty(e.media, "playbackRate", {
                            get: ()=>s.getPlaybackRate(),
                            set (e) {
                                s.setPlaybackRate(e);
                            }
                        });
                        let { volume: a } = e.config;
                        Object.defineProperty(e.media, "volume", {
                            get: ()=>a,
                            set (t) {
                                a = t, s.setVolume(100 * a), Z.call(e, e.media, "volumechange");
                            }
                        });
                        let { muted: l } = e.config;
                        Object.defineProperty(e.media, "muted", {
                            get: ()=>l,
                            set (t) {
                                const i = S.boolean(t) ? t : l;
                                l = i, s[i ? "mute" : "unMute"](), s.setVolume(100 * a), Z.call(e, e.media, "volumechange");
                            }
                        }), Object.defineProperty(e.media, "currentSrc", {
                            get: ()=>s.getVideoUrl()
                        }), Object.defineProperty(e.media, "ended", {
                            get: ()=>e.currentTime === e.duration
                        });
                        const r = s.getAvailablePlaybackRates();
                        e.options.speed = r.filter((t)=>e.config.speed.options.includes(t)), e.supported.ui && t.customControls && e.media.setAttribute("tabindex", -1), Z.call(e, e.media, "timeupdate"), Z.call(e, e.media, "durationchange"), clearInterval(e.timers.buffering), e.timers.buffering = setInterval(()=>{
                            e.media.buffered = s.getVideoLoadedFraction(), (null === e.media.lastBuffered || e.media.lastBuffered < e.media.buffered) && Z.call(e, e.media, "progress"), e.media.lastBuffered = e.media.buffered, 1 === e.media.buffered && (clearInterval(e.timers.buffering), Z.call(e, e.media, "canplaythrough"));
                        }, 200), t.customControls && setTimeout(()=>Fe.build.call(e), 50);
                    },
                    onStateChange (i) {
                        const s = i.target;
                        clearInterval(e.timers.playing);
                        switch(e.media.seeking && [
                            1,
                            2
                        ].includes(i.data) && (e.media.seeking = !1, Z.call(e, e.media, "seeked")), i.data){
                            case -1:
                                Z.call(e, e.media, "timeupdate"), e.media.buffered = s.getVideoLoadedFraction(), Z.call(e, e.media, "progress");
                                break;
                            case 0:
                                Ke.call(e, !1), e.media.loop ? (s.stopVideo(), s.playVideo()) : Z.call(e, e.media, "ended");
                                break;
                            case 1:
                                t.customControls && !e.config.autoplay && e.media.paused && !e.embed.hasPlayed ? e.media.pause() : (Ke.call(e, !0), Z.call(e, e.media, "playing"), e.timers.playing = setInterval(()=>{
                                    Z.call(e, e.media, "timeupdate");
                                }, 50), e.media.duration !== s.getDuration() && (e.media.duration = s.getDuration(), Z.call(e, e.media, "durationchange")));
                                break;
                            case 2:
                                e.muted || e.embed.unMute(), Ke.call(e, !1);
                                break;
                            case 3:
                                Z.call(e, e.media, "waiting");
                        }
                        Z.call(e, e.elements.container, "statechange", !1, {
                            code: i.data
                        });
                    }
                }
            });
        }
    }, Xe = {
        setup () {
            this.media ? (R(this.elements.container, this.config.classNames.type.replace("{0}", this.type), !0), R(this.elements.container, this.config.classNames.provider.replace("{0}", this.provider), !0), this.isEmbed && R(this.elements.container, this.config.classNames.type.replace("{0}", "video"), !0), this.isVideo && (this.elements.wrapper = $("div", {
                class: this.config.classNames.video
            }), L(this.media, this.elements.wrapper), this.elements.poster = $("div", {
                class: this.config.classNames.poster
            }), this.elements.wrapper.appendChild(this.elements.poster)), this.isHTML5 ? de.setup.call(this) : this.isYouTube ? Qe.setup.call(this) : this.isVimeo && ze.setup.call(this)) : this.debug.warn("No media element found!");
        }
    };
    class Je {
        constructor(t){
            e(this, "load", ()=>{
                this.enabled && (S.object(window.google) && S.object(window.google.ima) ? this.ready() : Be(this.player.config.urls.googleIMA.sdk).then(()=>{
                    this.ready();
                }).catch(()=>{
                    this.trigger("error", new Error("Google IMA SDK failed to load"));
                }));
            }), e(this, "ready", ()=>{
                var e;
                this.enabled || ((e = this).manager && e.manager.destroy(), e.elements.displayContainer && e.elements.displayContainer.destroy(), e.elements.container.remove()), this.startSafetyTimer(12e3, "ready()"), this.managerPromise.then(()=>{
                    this.clearSafetyTimer("onAdsManagerLoaded()");
                }), this.listeners(), this.setupIMA();
            }), e(this, "setupIMA", ()=>{
                this.elements.container = $("div", {
                    class: this.player.config.classNames.ads
                }), this.player.elements.container.appendChild(this.elements.container), google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED), google.ima.settings.setLocale(this.player.config.ads.language), google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline), this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container, this.player.media), this.loader = new google.ima.AdsLoader(this.elements.displayContainer), this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, (e)=>this.onAdsManagerLoaded(e), !1), this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e)=>this.onAdError(e), !1), this.requestAds();
            }), e(this, "requestAds", ()=>{
                const { container: e } = this.player.elements;
                try {
                    const t = new google.ima.AdsRequest;
                    t.adTagUrl = this.tagUrl, t.linearAdSlotWidth = e.offsetWidth, t.linearAdSlotHeight = e.offsetHeight, t.nonLinearAdSlotWidth = e.offsetWidth, t.nonLinearAdSlotHeight = e.offsetHeight, t.forceNonLinearFullSlot = !1, t.setAdWillPlayMuted(!this.player.muted), this.loader.requestAds(t);
                } catch (e) {
                    this.onAdError(e);
                }
            }), e(this, "pollCountdown", (e = !1)=>{
                if (!e) return clearInterval(this.countdownTimer), void this.elements.container.removeAttribute("data-badge-text");
                this.countdownTimer = setInterval(()=>{
                    const e = Ee(Math.max(this.manager.getRemainingTime(), 0)), t = `${ve.get("advertisement", this.player.config)} - ${e}`;
                    this.elements.container.setAttribute("data-badge-text", t);
                }, 100);
            }), e(this, "onAdsManagerLoaded", (e)=>{
                if (!this.enabled) return;
                const t = new google.ima.AdsRenderingSettings;
                t.restoreCustomPlaybackStateOnAdBreakComplete = !0, t.enablePreloading = !0, this.manager = e.getAdsManager(this.player, t), this.cuePoints = this.manager.getCuePoints(), this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e)=>this.onAdError(e)), Object.keys(google.ima.AdEvent.Type).forEach((e)=>{
                    this.manager.addEventListener(google.ima.AdEvent.Type[e], (e)=>this.onAdEvent(e));
                }), this.trigger("loaded");
            }), e(this, "addCuePoints", ()=>{
                S.empty(this.cuePoints) || this.cuePoints.forEach((e)=>{
                    if (0 !== e && -1 !== e && e < this.player.duration) {
                        const t = this.player.elements.progress;
                        if (S.element(t)) {
                            const i = 100 / this.player.duration * e, s = $("span", {
                                class: this.player.config.classNames.cues
                            });
                            s.style.left = `${i.toString()}%`, t.appendChild(s);
                        }
                    }
                });
            }), e(this, "onAdEvent", (e)=>{
                const { container: t } = this.player.elements, i = e.getAd(), s = e.getAdData();
                switch(((e)=>{
                    Z.call(this.player, this.player.media, `ads${e.replace(/_/g, "").toLowerCase()}`);
                })(e.type), e.type){
                    case google.ima.AdEvent.Type.LOADED:
                        this.trigger("loaded"), this.pollCountdown(!0), i.isLinear() || (i.width = t.offsetWidth, i.height = t.offsetHeight);
                        break;
                    case google.ima.AdEvent.Type.STARTED:
                        this.manager.setVolume(this.player.volume);
                        break;
                    case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                        this.player.ended ? this.loadAds() : this.loader.contentComplete();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                        this.pauseContent();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                        this.pollCountdown(), this.resumeContent();
                        break;
                    case google.ima.AdEvent.Type.LOG:
                        s.adError && this.player.debug.warn(`Non-fatal ad error: ${s.adError.getMessage()}`);
                }
            }), e(this, "onAdError", (e)=>{
                this.cancel(), this.player.debug.warn("Ads error", e);
            }), e(this, "listeners", ()=>{
                const { container: e } = this.player.elements;
                let t;
                this.player.on("canplay", ()=>{
                    this.addCuePoints();
                }), this.player.on("ended", ()=>{
                    this.loader.contentComplete();
                }), this.player.on("timeupdate", ()=>{
                    t = this.player.currentTime;
                }), this.player.on("seeked", ()=>{
                    const e = this.player.currentTime;
                    S.empty(this.cuePoints) || this.cuePoints.forEach((i, s)=>{
                        t < i && i < e && (this.manager.discardAdBreak(), this.cuePoints.splice(s, 1));
                    });
                }), window.addEventListener("resize", ()=>{
                    this.manager && this.manager.resize(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL);
                });
            }), e(this, "play", ()=>{
                const { container: e } = this.player.elements;
                this.managerPromise || this.resumeContent(), this.managerPromise.then(()=>{
                    this.manager.setVolume(this.player.volume), this.elements.displayContainer.initialize();
                    try {
                        this.initialized || (this.manager.init(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL), this.manager.start()), this.initialized = !0;
                    } catch (e) {
                        this.onAdError(e);
                    }
                }).catch(()=>{});
            }), e(this, "resumeContent", ()=>{
                this.elements.container.style.zIndex = "", this.playing = !1, ie(this.player.media.play());
            }), e(this, "pauseContent", ()=>{
                this.elements.container.style.zIndex = 3, this.playing = !0, this.player.media.pause();
            }), e(this, "cancel", ()=>{
                this.initialized && this.resumeContent(), this.trigger("error"), this.loadAds();
            }), e(this, "loadAds", ()=>{
                this.managerPromise.then(()=>{
                    this.manager && this.manager.destroy(), this.managerPromise = new Promise((e)=>{
                        this.on("loaded", e), this.player.debug.log(this.manager);
                    }), this.initialized = !1, this.requestAds();
                }).catch(()=>{});
            }), e(this, "trigger", (e, ...t)=>{
                const i = this.events[e];
                S.array(i) && i.forEach((e)=>{
                    S.function(e) && e.apply(this, t);
                });
            }), e(this, "on", (e, t)=>(S.array(this.events[e]) || (this.events[e] = []), this.events[e].push(t), this)), e(this, "startSafetyTimer", (e, t)=>{
                this.player.debug.log(`Safety timer invoked from: ${t}`), this.safetyTimer = setTimeout(()=>{
                    this.cancel(), this.clearSafetyTimer("startSafetyTimer()");
                }, e);
            }), e(this, "clearSafetyTimer", (e)=>{
                S.nullOrUndefined(this.safetyTimer) || (this.player.debug.log(`Safety timer cleared from: ${e}`), clearTimeout(this.safetyTimer), this.safetyTimer = null);
            }), this.player = t, this.config = t.config.ads, this.playing = !1, this.initialized = !1, this.elements = {
                container: null,
                displayContainer: null
            }, this.manager = null, this.loader = null, this.cuePoints = null, this.events = {}, this.safetyTimer = null, this.countdownTimer = null, this.managerPromise = new Promise((e, t)=>{
                this.on("loaded", e), this.on("error", t);
            }), this.load();
        }
        get enabled() {
            const { config: e } = this;
            return this.player.isHTML5 && this.player.isVideo && e.enabled && (!S.empty(e.publisherId) || S.url(e.tagUrl));
        }
        get tagUrl() {
            const { config: e } = this;
            if (S.url(e.tagUrl)) return e.tagUrl;
            return `https://go.aniview.com/api/adserver6/vast/?${Ne({
                AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
                AV_CHANNELID: "5a0458dc28a06145e4519d21",
                AV_URL: window.location.hostname,
                cb: Date.now(),
                AV_WIDTH: 640,
                AV_HEIGHT: 480,
                AV_CDIM2: e.publisherId
            })}`;
        }
    }
    function Ge(e = 0, t = 0, i = 255) {
        return Math.min(Math.max(e, t), i);
    }
    const Ze = (e)=>{
        const t = [];
        return e.split(/\r\n\r\n|\n\n|\r\r/).forEach((e)=>{
            const i = {};
            e.split(/\r\n|\n|\r/).forEach((e)=>{
                if (S.number(i.startTime)) {
                    if (!S.empty(e.trim()) && S.empty(i.text)) {
                        const t = e.trim().split("#xywh=");
                        [i.text] = t, t[1] && ([i.x, i.y, i.w, i.h] = t[1].split(","));
                    }
                } else {
                    const t = e.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);
                    t && (i.startTime = 60 * Number(t[1] || 0) * 60 + 60 * Number(t[2]) + Number(t[3]) + Number(`0.${t[4]}`), i.endTime = 60 * Number(t[6] || 0) * 60 + 60 * Number(t[7]) + Number(t[8]) + Number(`0.${t[9]}`));
                }
            }), i.text && t.push(i);
        }), t;
    }, et = (e, t)=>{
        const i = {};
        return e > t.width / t.height ? (i.width = t.width, i.height = 1 / e * t.width) : (i.height = t.height, i.width = e * t.height), i;
    };
    class tt {
        constructor(t){
            e(this, "load", ()=>{
                this.player.elements.display.seekTooltip && (this.player.elements.display.seekTooltip.hidden = this.enabled), this.enabled && this.getThumbnails().then(()=>{
                    this.enabled && (this.render(), this.determineContainerAutoSizing(), this.listeners(), this.loaded = !0);
                });
            }), e(this, "getThumbnails", ()=>new Promise((e)=>{
                    const { src: t } = this.player.config.previewThumbnails;
                    if (S.empty(t)) throw new Error("Missing previewThumbnails.src config attribute");
                    const i = ()=>{
                        this.thumbnails.sort((e, t)=>e.height - t.height), this.player.debug.log("Preview thumbnails", this.thumbnails), e();
                    };
                    if (S.function(t)) t((e)=>{
                        this.thumbnails = e, i();
                    });
                    else {
                        const e = (S.string(t) ? [
                            t
                        ] : t).map((e)=>this.getThumbnail(e));
                        Promise.all(e).then(i);
                    }
                })), e(this, "getThumbnail", (e)=>new Promise((t)=>{
                    Te(e).then((i)=>{
                        const s = {
                            frames: Ze(i),
                            height: null,
                            urlPrefix: ""
                        };
                        s.frames[0].text.startsWith("/") || s.frames[0].text.startsWith("http://") || s.frames[0].text.startsWith("https://") || (s.urlPrefix = e.substring(0, e.lastIndexOf("/") + 1));
                        const n = new Image;
                        n.onload = ()=>{
                            s.height = n.naturalHeight, s.width = n.naturalWidth, this.thumbnails.push(s), t();
                        }, n.src = s.urlPrefix + s.frames[0].text;
                    });
                })), e(this, "startMove", (e)=>{
                if (this.loaded && S.event(e) && [
                    "touchmove",
                    "mousemove"
                ].includes(e.type) && this.player.media.duration) {
                    if ("touchmove" === e.type) this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);
                    else {
                        var t, i;
                        const s = this.player.elements.progress.getBoundingClientRect(), n = 100 / s.width * (e.pageX - s.left);
                        this.seekTime = this.player.media.duration * (n / 100), this.seekTime < 0 && (this.seekTime = 0), this.seekTime > this.player.media.duration - 1 && (this.seekTime = this.player.media.duration - 1), this.mousePosX = e.pageX, this.elements.thumb.time.innerText = Ee(this.seekTime);
                        const a = null === (t = this.player.config.markers) || void 0 === t || null === (i = t.points) || void 0 === i ? void 0 : i.find(({ time: e })=>e === Math.round(this.seekTime));
                        a && this.elements.thumb.time.insertAdjacentHTML("afterbegin", `${a.label}<br>`);
                    }
                    this.showImageAtCurrentTime();
                }
            }), e(this, "endMove", ()=>{
                this.toggleThumbContainer(!1, !0);
            }), e(this, "startScrubbing", (e)=>{
                (S.nullOrUndefined(e.button) || !1 === e.button || 0 === e.button) && (this.mouseDown = !0, this.player.media.duration && (this.toggleScrubbingContainer(!0), this.toggleThumbContainer(!1, !0), this.showImageAtCurrentTime()));
            }), e(this, "endScrubbing", ()=>{
                this.mouseDown = !1, Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime) ? this.toggleScrubbingContainer(!1) : G.call(this.player, this.player.media, "timeupdate", ()=>{
                    this.mouseDown || this.toggleScrubbingContainer(!1);
                });
            }), e(this, "listeners", ()=>{
                this.player.on("play", ()=>{
                    this.toggleThumbContainer(!1, !0);
                }), this.player.on("seeked", ()=>{
                    this.toggleThumbContainer(!1);
                }), this.player.on("timeupdate", ()=>{
                    this.lastTime = this.player.media.currentTime;
                });
            }), e(this, "render", ()=>{
                this.elements.thumb.container = $("div", {
                    class: this.player.config.classNames.previewThumbnails.thumbContainer
                }), this.elements.thumb.imageContainer = $("div", {
                    class: this.player.config.classNames.previewThumbnails.imageContainer
                }), this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);
                const e = $("div", {
                    class: this.player.config.classNames.previewThumbnails.timeContainer
                });
                this.elements.thumb.time = $("span", {}, "00:00"), e.appendChild(this.elements.thumb.time), this.elements.thumb.imageContainer.appendChild(e), S.element(this.player.elements.progress) && this.player.elements.progress.appendChild(this.elements.thumb.container), this.elements.scrubbing.container = $("div", {
                    class: this.player.config.classNames.previewThumbnails.scrubbingContainer
                }), this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
            }), e(this, "destroy", ()=>{
                this.elements.thumb.container && this.elements.thumb.container.remove(), this.elements.scrubbing.container && this.elements.scrubbing.container.remove();
            }), e(this, "showImageAtCurrentTime", ()=>{
                this.mouseDown ? this.setScrubbingContainerSize() : this.setThumbContainerSizeAndPos();
                const e = this.thumbnails[0].frames.findIndex((e)=>this.seekTime >= e.startTime && this.seekTime <= e.endTime), t = e >= 0;
                let i = 0;
                this.mouseDown || this.toggleThumbContainer(t), t && (this.thumbnails.forEach((t, s)=>{
                    this.loadedImages.includes(t.frames[e].text) && (i = s);
                }), e !== this.showingThumb && (this.showingThumb = e, this.loadImage(i)));
            }), e(this, "loadImage", (e = 0)=>{
                const t = this.showingThumb, i = this.thumbnails[e], { urlPrefix: s } = i, n = i.frames[t], a = i.frames[t].text, l = s + a;
                if (this.currentImageElement && this.currentImageElement.dataset.filename === a) this.showImage(this.currentImageElement, n, e, t, a, !1), this.currentImageElement.dataset.index = t, this.removeOldImages(this.currentImageElement);
                else {
                    this.loadingImage && this.usingSprites && (this.loadingImage.onload = null);
                    const i = new Image;
                    i.src = l, i.dataset.index = t, i.dataset.filename = a, this.showingThumbFilename = a, this.player.debug.log(`Loading image: ${l}`), i.onload = ()=>this.showImage(i, n, e, t, a, !0), this.loadingImage = i, this.removeOldImages(i);
                }
            }), e(this, "showImage", (e, t, i, s, n, a = !0)=>{
                this.player.debug.log(`Showing thumb: ${n}. num: ${s}. qual: ${i}. newimg: ${a}`), this.setImageSizeAndOffset(e, t), a && (this.currentImageContainer.appendChild(e), this.currentImageElement = e, this.loadedImages.includes(n) || this.loadedImages.push(n)), this.preloadNearby(s, !0).then(this.preloadNearby(s, !1)).then(this.getHigherQuality(i, e, t, n));
            }), e(this, "removeOldImages", (e)=>{
                Array.from(this.currentImageContainer.children).forEach((t)=>{
                    if ("img" !== t.tagName.toLowerCase()) return;
                    const i = this.usingSprites ? 500 : 1e3;
                    if (t.dataset.index !== e.dataset.index && !t.dataset.deleting) {
                        t.dataset.deleting = !0;
                        const { currentImageContainer: e } = this;
                        setTimeout(()=>{
                            e.removeChild(t), this.player.debug.log(`Removing thumb: ${t.dataset.filename}`);
                        }, i);
                    }
                });
            }), e(this, "preloadNearby", (e, t = !0)=>new Promise((i)=>{
                    setTimeout(()=>{
                        const s = this.thumbnails[0].frames[e].text;
                        if (this.showingThumbFilename === s) {
                            let n;
                            n = t ? this.thumbnails[0].frames.slice(e) : this.thumbnails[0].frames.slice(0, e).reverse();
                            let a = !1;
                            n.forEach((e)=>{
                                const t = e.text;
                                if (t !== s && !this.loadedImages.includes(t)) {
                                    a = !0, this.player.debug.log(`Preloading thumb filename: ${t}`);
                                    const { urlPrefix: e } = this.thumbnails[0], s = e + t, n = new Image;
                                    n.src = s, n.onload = ()=>{
                                        this.player.debug.log(`Preloaded thumb filename: ${t}`), this.loadedImages.includes(t) || this.loadedImages.push(t), i();
                                    };
                                }
                            }), a || i();
                        }
                    }, 300);
                })), e(this, "getHigherQuality", (e, t, i, s)=>{
                if (e < this.thumbnails.length - 1) {
                    let n = t.naturalHeight;
                    this.usingSprites && (n = i.h), n < this.thumbContainerHeight && setTimeout(()=>{
                        this.showingThumbFilename === s && (this.player.debug.log(`Showing higher quality thumb for: ${s}`), this.loadImage(e + 1));
                    }, 300);
                }
            }), e(this, "toggleThumbContainer", (e = !1, t = !1)=>{
                const i = this.player.config.classNames.previewThumbnails.thumbContainerShown;
                this.elements.thumb.container.classList.toggle(i, e), !e && t && (this.showingThumb = null, this.showingThumbFilename = null);
            }), e(this, "toggleScrubbingContainer", (e = !1)=>{
                const t = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
                this.elements.scrubbing.container.classList.toggle(t, e), e || (this.showingThumb = null, this.showingThumbFilename = null);
            }), e(this, "determineContainerAutoSizing", ()=>{
                (this.elements.thumb.imageContainer.clientHeight > 20 || this.elements.thumb.imageContainer.clientWidth > 20) && (this.sizeSpecifiedInCSS = !0);
            }), e(this, "setThumbContainerSizeAndPos", ()=>{
                const { imageContainer: e } = this.elements.thumb;
                if (this.sizeSpecifiedInCSS) {
                    if (e.clientHeight > 20 && e.clientWidth < 20) {
                        const t = Math.floor(e.clientHeight * this.thumbAspectRatio);
                        e.style.width = `${t}px`;
                    } else if (e.clientHeight < 20 && e.clientWidth > 20) {
                        const t = Math.floor(e.clientWidth / this.thumbAspectRatio);
                        e.style.height = `${t}px`;
                    }
                } else {
                    const t = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
                    e.style.height = `${this.thumbContainerHeight}px`, e.style.width = `${t}px`;
                }
                this.setThumbContainerPos();
            }), e(this, "setThumbContainerPos", ()=>{
                const e = this.player.elements.progress.getBoundingClientRect(), t = this.player.elements.container.getBoundingClientRect(), { container: i } = this.elements.thumb, s = t.left - e.left + 10, n = t.right - e.left - i.clientWidth - 10, a = this.mousePosX - e.left - i.clientWidth / 2, l = Ge(a, s, n);
                i.style.left = `${l}px`, i.style.setProperty("--preview-arrow-offset", a - l + "px");
            }), e(this, "setScrubbingContainerSize", ()=>{
                const { width: e, height: t } = et(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                this.elements.scrubbing.container.style.width = `${e}px`, this.elements.scrubbing.container.style.height = `${t}px`;
            }), e(this, "setImageSizeAndOffset", (e, t)=>{
                if (!this.usingSprites) return;
                const i = this.thumbContainerHeight / t.h;
                e.style.height = e.naturalHeight * i + "px", e.style.width = e.naturalWidth * i + "px", e.style.left = `-${t.x * i}px`, e.style.top = `-${t.y * i}px`;
            }), this.player = t, this.thumbnails = [], this.loaded = !1, this.lastMouseMoveTime = Date.now(), this.mouseDown = !1, this.loadedImages = [], this.elements = {
                thumb: {},
                scrubbing: {}
            }, this.load();
        }
        get enabled() {
            return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
        }
        get currentImageContainer() {
            return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
        }
        get usingSprites() {
            return Object.keys(this.thumbnails[0].frames[0]).includes("w");
        }
        get thumbAspectRatio() {
            return this.usingSprites ? this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h : this.thumbnails[0].width / this.thumbnails[0].height;
        }
        get thumbContainerHeight() {
            if (this.mouseDown) {
                const { height: e } = et(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                return e;
            }
            return this.sizeSpecifiedInCSS ? this.elements.thumb.imageContainer.clientHeight : Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
        }
        get currentImageElement() {
            return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
        }
        set currentImageElement(e) {
            this.mouseDown ? this.currentScrubbingImageElement = e : this.currentThumbnailImageElement = e;
        }
    }
    const it = {
        insertElements (e, t) {
            S.string(t) ? _(e, this.media, {
                src: t
            }) : S.array(t) && t.forEach((t)=>{
                _(e, this.media, t);
            });
        },
        change (e) {
            N(e, "sources.length") ? (de.cancelRequests.call(this), this.destroy.call(this, ()=>{
                this.options.quality = [], O(this.media), this.media = null, S.element(this.elements.container) && this.elements.container.removeAttribute("class");
                const { sources: t, type: i } = e, [{ provider: s = _e.html5, src: n }] = t, a = "html5" === s ? i : "div", l = "html5" === s ? {} : {
                    src: n
                };
                Object.assign(this, {
                    provider: s,
                    type: i,
                    supported: K.check(i, s, this.config.playsinline),
                    media: $(a, l)
                }), this.elements.container.appendChild(this.media), S.boolean(e.autoplay) && (this.config.autoplay = e.autoplay), this.isHTML5 && (this.config.crossorigin && this.media.setAttribute("crossorigin", ""), this.config.autoplay && this.media.setAttribute("autoplay", ""), S.empty(e.poster) || (this.poster = e.poster), this.config.loop.active && this.media.setAttribute("loop", ""), this.config.muted && this.media.setAttribute("muted", ""), this.config.playsinline && this.media.setAttribute("playsinline", "")), Fe.addStyleHook.call(this), this.isHTML5 && it.insertElements.call(this, "source", t), this.config.title = e.title, Xe.setup.call(this), this.isHTML5 && Object.keys(e).includes("tracks") && it.insertElements.call(this, "track", e.tracks), (this.isHTML5 || this.isEmbed && !this.supported.ui) && Fe.build.call(this), this.isHTML5 && this.media.load(), S.empty(e.previewThumbnails) || (Object.assign(this.config.previewThumbnails, e.previewThumbnails), this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this))), this.fullscreen.update();
            }, !0)) : this.debug.warn("Invalid source format");
        }
    };
    class st {
        constructor(t, i){
            if (e(this, "play", ()=>S.function(this.media.play) ? (this.ads && this.ads.enabled && this.ads.managerPromise.then(()=>this.ads.play()).catch(()=>ie(this.media.play())), this.media.play()) : null), e(this, "pause", ()=>this.playing && S.function(this.media.pause) ? this.media.pause() : null), e(this, "togglePlay", (e)=>(S.boolean(e) ? e : !this.playing) ? this.play() : this.pause()), e(this, "stop", ()=>{
                this.isHTML5 ? (this.pause(), this.restart()) : S.function(this.media.stop) && this.media.stop();
            }), e(this, "restart", ()=>{
                this.currentTime = 0;
            }), e(this, "rewind", (e)=>{
                this.currentTime -= S.number(e) ? e : this.config.seekTime;
            }), e(this, "forward", (e)=>{
                this.currentTime += S.number(e) ? e : this.config.seekTime;
            }), e(this, "increaseVolume", (e)=>{
                const t = this.media.muted ? 0 : this.volume;
                this.volume = t + (S.number(e) ? e : 0);
            }), e(this, "decreaseVolume", (e)=>{
                this.increaseVolume(-e);
            }), e(this, "airplay", ()=>{
                K.airplay && this.media.webkitShowPlaybackTargetPicker();
            }), e(this, "toggleControls", (e)=>{
                if (this.supported.ui && !this.isAudio) {
                    const t = F(this.elements.container, this.config.classNames.hideControls), i = void 0 === e ? void 0 : !e, s = R(this.elements.container, this.config.classNames.hideControls, i);
                    if (s && S.array(this.config.controls) && this.config.controls.includes("settings") && !S.empty(this.config.settings) && Pe.toggleMenu.call(this, !1), s !== t) {
                        const e = s ? "controlshidden" : "controlsshown";
                        Z.call(this, this.media, e);
                    }
                    return !s;
                }
                return !1;
            }), e(this, "on", (e, t)=>{
                X.call(this, this.elements.container, e, t);
            }), e(this, "once", (e, t)=>{
                G.call(this, this.elements.container, e, t);
            }), e(this, "off", (e, t)=>{
                J(this.elements.container, e, t);
            }), e(this, "destroy", (e, t = !1)=>{
                if (!this.ready) return;
                const i = ()=>{
                    document.body.style.overflow = "", this.embed = null, t ? (Object.keys(this.elements).length && (O(this.elements.buttons.play), O(this.elements.captions), O(this.elements.controls), O(this.elements.wrapper), this.elements.buttons.play = null, this.elements.captions = null, this.elements.controls = null, this.elements.wrapper = null), S.function(e) && e()) : (ee.call(this), de.cancelRequests.call(this), q(this.elements.original, this.elements.container), Z.call(this, this.elements.original, "destroyed", !0), S.function(e) && e.call(this.elements.original), this.ready = !1, setTimeout(()=>{
                        this.elements = null, this.media = null;
                    }, 200));
                };
                this.stop(), clearTimeout(this.timers.loading), clearTimeout(this.timers.controls), clearTimeout(this.timers.resized), this.isHTML5 ? (Fe.toggleNativeControls.call(this, !0), i()) : this.isYouTube ? (clearInterval(this.timers.buffering), clearInterval(this.timers.playing), null !== this.embed && S.function(this.embed.destroy) && this.embed.destroy(), i()) : this.isVimeo && (null !== this.embed && this.embed.unload().then(i), setTimeout(i, 200));
            }), e(this, "supports", (e)=>K.mime.call(this, e)), this.timers = {}, this.ready = !1, this.loading = !1, this.failed = !1, this.touch = K.touch, this.media = t, S.string(this.media) && (this.media = document.querySelectorAll(this.media)), (window.jQuery && this.media instanceof jQuery || S.nodeList(this.media) || S.array(this.media)) && (this.media = this.media[0]), this.config = x({}, Le, st.defaults, i || {}, (()=>{
                try {
                    return JSON.parse(this.media.getAttribute("data-plyr-config"));
                } catch (e) {
                    return {};
                }
            })()), this.elements = {
                container: null,
                fullscreen: null,
                captions: null,
                buttons: {},
                display: {},
                progress: {},
                inputs: {},
                settings: {
                    popup: null,
                    menu: null,
                    panels: {},
                    buttons: {}
                }
            }, this.captions = {
                active: null,
                currentTrack: -1,
                meta: new WeakMap
            }, this.fullscreen = {
                active: !1
            }, this.options = {
                speed: [],
                quality: []
            }, this.debug = new De(this.config.debug), this.debug.log("Config", this.config), this.debug.log("Support", K), S.nullOrUndefined(this.media) || !S.element(this.media)) return void this.debug.error("Setup failed: no suitable element passed");
            if (this.media.plyr) return void this.debug.warn("Target already setup");
            if (!this.config.enabled) return void this.debug.error("Setup failed: disabled by config");
            if (!K.check().api) return void this.debug.error("Setup failed: no support");
            const s = this.media.cloneNode(!0);
            s.autoplay = !1, this.elements.original = s;
            const n = this.media.tagName.toLowerCase();
            let a = null, l = null;
            switch(n){
                case "div":
                    if (a = this.media.querySelector("iframe"), S.element(a)) {
                        if (l = Me(a.getAttribute("src")), this.provider = function(e) {
                            return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e) ? _e.youtube : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e) ? _e.vimeo : null;
                        }(l.toString()), this.elements.container = this.media, this.media = a, this.elements.container.className = "", l.search.length) {
                            const e = [
                                "1",
                                "true"
                            ];
                            e.includes(l.searchParams.get("autoplay")) && (this.config.autoplay = !0), e.includes(l.searchParams.get("loop")) && (this.config.loop.active = !0), this.isYouTube ? (this.config.playsinline = e.includes(l.searchParams.get("playsinline")), this.config.youtube.hl = l.searchParams.get("hl")) : this.config.playsinline = !0;
                        }
                    } else this.provider = this.media.getAttribute(this.config.attributes.embed.provider), this.media.removeAttribute(this.config.attributes.embed.provider);
                    if (S.empty(this.provider) || !Object.values(_e).includes(this.provider)) return void this.debug.error("Setup failed: Invalid provider");
                    this.type = je;
                    break;
                case "video":
                case "audio":
                    this.type = n, this.provider = _e.html5, this.media.hasAttribute("crossorigin") && (this.config.crossorigin = !0), this.media.hasAttribute("autoplay") && (this.config.autoplay = !0), (this.media.hasAttribute("playsinline") || this.media.hasAttribute("webkit-playsinline")) && (this.config.playsinline = !0), this.media.hasAttribute("muted") && (this.config.muted = !0), this.media.hasAttribute("loop") && (this.config.loop.active = !0);
                    break;
                default:
                    return void this.debug.error("Setup failed: unsupported type");
            }
            this.supported = K.check(this.type, this.provider), this.supported.api ? (this.eventListeners = [], this.listeners = new Ve(this), this.storage = new we(this), this.media.plyr = this, S.element(this.elements.container) || (this.elements.container = $("div"), L(this.media, this.elements.container)), Fe.migrateStyles.call(this), Fe.addStyleHook.call(this), Xe.setup.call(this), this.config.debug && X.call(this, this.elements.container, this.config.events.join(" "), (e)=>{
                this.debug.log(`event: ${e.type}`);
            }), this.fullscreen = new He(this), (this.isHTML5 || this.isEmbed && !this.supported.ui) && Fe.build.call(this), this.listeners.container(), this.listeners.global(), this.config.ads.enabled && (this.ads = new Je(this)), this.isHTML5 && this.config.autoplay && this.once("canplay", ()=>ie(this.play())), this.lastSeekTime = 0, this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this))) : this.debug.error("Setup failed: no support");
        }
        get isHTML5() {
            return this.provider === _e.html5;
        }
        get isEmbed() {
            return this.isYouTube || this.isVimeo;
        }
        get isYouTube() {
            return this.provider === _e.youtube;
        }
        get isVimeo() {
            return this.provider === _e.vimeo;
        }
        get isVideo() {
            return this.type === je;
        }
        get isAudio() {
            return this.type === Oe;
        }
        get playing() {
            return Boolean(this.ready && !this.paused && !this.ended);
        }
        get paused() {
            return Boolean(this.media.paused);
        }
        get stopped() {
            return Boolean(this.paused && 0 === this.currentTime);
        }
        get ended() {
            return Boolean(this.media.ended);
        }
        set currentTime(e) {
            if (!this.duration) return;
            const t = S.number(e) && e > 0;
            this.media.currentTime = t ? Math.min(e, this.duration) : 0, this.debug.log(`Seeking to ${this.currentTime} seconds`);
        }
        get currentTime() {
            return Number(this.media.currentTime);
        }
        get buffered() {
            const { buffered: e } = this.media;
            return S.number(e) ? e : e && e.length && this.duration > 0 ? e.end(0) / this.duration : 0;
        }
        get seeking() {
            return Boolean(this.media.seeking);
        }
        get duration() {
            const e = parseFloat(this.config.duration), t = (this.media || {}).duration, i = S.number(t) && t !== 1 / 0 ? t : 0;
            return e || i;
        }
        set volume(e) {
            let t = e;
            S.string(t) && (t = Number(t)), S.number(t) || (t = this.storage.get("volume")), S.number(t) || ({ volume: t } = this.config), t > 1 && (t = 1), t < 0 && (t = 0), this.config.volume = t, this.media.volume = t, !S.empty(e) && this.muted && t > 0 && (this.muted = !1);
        }
        get volume() {
            return Number(this.media.volume);
        }
        set muted(e) {
            let t = e;
            S.boolean(t) || (t = this.storage.get("muted")), S.boolean(t) || (t = this.config.muted), this.config.muted = t, this.media.muted = t;
        }
        get muted() {
            return Boolean(this.media.muted);
        }
        get hasAudio() {
            return !this.isHTML5 || !!this.isAudio || Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length);
        }
        set speed(e) {
            let t = null;
            S.number(e) && (t = e), S.number(t) || (t = this.storage.get("speed")), S.number(t) || (t = this.config.speed.selected);
            const { minimumSpeed: i, maximumSpeed: s } = this;
            t = Ge(t, i, s), this.config.speed.selected = t, setTimeout(()=>{
                this.media && (this.media.playbackRate = t);
            }, 0);
        }
        get speed() {
            return Number(this.media.playbackRate);
        }
        get minimumSpeed() {
            return this.isYouTube ? Math.min(...this.options.speed) : this.isVimeo ? .5 : .0625;
        }
        get maximumSpeed() {
            return this.isYouTube ? Math.max(...this.options.speed) : this.isVimeo ? 2 : 16;
        }
        set quality(e) {
            const t = this.config.quality, i = this.options.quality;
            if (!i.length) return;
            let s = [
                !S.empty(e) && Number(e),
                this.storage.get("quality"),
                t.selected,
                t.default
            ].find(S.number), n = !0;
            if (!i.includes(s)) {
                const e = ne(i, s);
                this.debug.warn(`Unsupported quality option: ${s}, using ${e} instead`), s = e, n = !1;
            }
            t.selected = s, this.media.quality = s, n && this.storage.set({
                quality: s
            });
        }
        get quality() {
            return this.media.quality;
        }
        set loop(e) {
            const t = S.boolean(e) ? e : this.config.loop.active;
            this.config.loop.active = t, this.media.loop = t;
        }
        get loop() {
            return Boolean(this.media.loop);
        }
        set source(e) {
            it.change.call(this, e);
        }
        get source() {
            return this.media.currentSrc;
        }
        get download() {
            const { download: e } = this.config.urls;
            return S.url(e) ? e : this.source;
        }
        set download(e) {
            S.url(e) && (this.config.urls.download = e, Pe.setDownloadUrl.call(this));
        }
        set poster(e) {
            this.isVideo ? Fe.setPoster.call(this, e, !1).catch(()=>{}) : this.debug.warn("Poster can only be set for video");
        }
        get poster() {
            return this.isVideo ? this.media.getAttribute("poster") || this.media.getAttribute("data-poster") : null;
        }
        get ratio() {
            if (!this.isVideo) return null;
            const e = oe(ce.call(this));
            return S.array(e) ? e.join(":") : e;
        }
        set ratio(e) {
            this.isVideo ? S.string(e) && re(e) ? (this.config.ratio = oe(e), ue.call(this)) : this.debug.error(`Invalid aspect ratio specified (${e})`) : this.debug.warn("Aspect ratio can only be set for video");
        }
        set autoplay(e) {
            this.config.autoplay = S.boolean(e) ? e : this.config.autoplay;
        }
        get autoplay() {
            return Boolean(this.config.autoplay);
        }
        toggleCaptions(e) {
            xe.toggle.call(this, e, !1);
        }
        set currentTrack(e) {
            xe.set.call(this, e, !1), xe.setup.call(this);
        }
        get currentTrack() {
            const { toggled: e, currentTrack: t } = this.captions;
            return e ? t : -1;
        }
        set language(e) {
            xe.setLanguage.call(this, e, !1);
        }
        get language() {
            return (xe.getCurrentTrack.call(this) || {}).language;
        }
        set pip(e) {
            if (!K.pip) return;
            const t = S.boolean(e) ? e : !this.pip;
            S.function(this.media.webkitSetPresentationMode) && this.media.webkitSetPresentationMode(t ? Ie : $e), S.function(this.media.requestPictureInPicture) && (!this.pip && t ? this.media.requestPictureInPicture() : this.pip && !t && document.exitPictureInPicture());
        }
        get pip() {
            return K.pip ? S.empty(this.media.webkitPresentationMode) ? this.media === document.pictureInPictureElement : this.media.webkitPresentationMode === Ie : null;
        }
        setPreviewThumbnails(e) {
            this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), Object.assign(this.config.previewThumbnails, e), this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this));
        }
        static supported(e, t) {
            return K.check(e, t);
        }
        static loadSprite(e, t) {
            return ke(e, t);
        }
        static setup(e, t = {}) {
            let i = null;
            return S.string(e) ? i = Array.from(document.querySelectorAll(e)) : S.nodeList(e) ? i = Array.from(e) : S.array(e) && (i = e.filter(S.element)), S.empty(i) ? null : i.map((e)=>new st(e, t));
        }
    }
    var nt;
    return st.defaults = (nt = Le, JSON.parse(JSON.stringify(nt))), st;
});

});

parcelRegister("iuc9x", function(module, exports) {

$parcel$export(module.exports, "onClickOutside", () => $cbe5e41a05e7dda8$export$806d9a98fb0e6fd0);

var $ef9Nn = parcelRequire("ef9Nn");
parcelRequire("j40Rs");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");
var $j40Rs = parcelRequire("j40Rs");
var $dDLnc = parcelRequire("dDLnc");
function $cbe5e41a05e7dda8$export$dcbb7025f4e5281b(evaluationCallback, initialState, optionsOrRef) {
    let options;
    if ((0, $8bTPG.isRef)(optionsOrRef)) options = {
        evaluating: optionsOrRef
    };
    else options = optionsOrRef || {};
    const { lazy: lazy = false, evaluating: evaluating, shallow: shallow = true, onError: onError = (0, $ef9Nn.noop) } = options;
    const started = (0, $8bTPG.ref)(!lazy);
    const current = shallow ? (0, $8bTPG.shallowRef)(initialState) : (0, $8bTPG.ref)(initialState);
    let counter = 0;
    (0, $ani5R.watchEffect)(async (onInvalidate)=>{
        if (!started.value) return;
        counter++;
        const counterAtBeginning = counter;
        let hasFinished = false;
        if (evaluating) Promise.resolve().then(()=>{
            evaluating.value = true;
        });
        try {
            const result = await evaluationCallback((cancelCallback)=>{
                onInvalidate(()=>{
                    if (evaluating) evaluating.value = false;
                    if (!hasFinished) cancelCallback();
                });
            });
            if (counterAtBeginning === counter) current.value = result;
        } catch (e) {
            onError(e);
        } finally{
            if (evaluating && counterAtBeginning === counter) evaluating.value = false;
            hasFinished = true;
        }
    });
    if (lazy) return (0, $8bTPG.computed)(()=>{
        started.value = true;
        return current.value;
    });
    else return current;
}
function $cbe5e41a05e7dda8$export$dc0885167ecf1257(key, options, defaultSource, treatDefaultAsFactory) {
    let source = (0, $ani5R.inject)(key);
    if (defaultSource) source = (0, $ani5R.inject)(key, defaultSource);
    if (treatDefaultAsFactory) source = (0, $ani5R.inject)(key, defaultSource, treatDefaultAsFactory);
    if (typeof options === "function") return (0, $8bTPG.computed)((ctx)=>options(source, ctx));
    else return (0, $8bTPG.computed)({
        get: (ctx)=>options.get(source, ctx),
        set: options.set
    });
}
function $cbe5e41a05e7dda8$export$7ef9f841998c60db(options = {}) {
    if (!(0, $j40Rs.isVue3) && !(0, $ani5R.version).startsWith("2.7.")) return;
    const { inheritAttrs: inheritAttrs = true } = options;
    const render = (0, $8bTPG.shallowRef)();
    const define = /* #__PURE__ */ (0, $ani5R.defineComponent)({
        setup (_, { slots: slots }) {
            return ()=>{
                render.value = slots.default;
            };
        }
    });
    const reuse = /* #__PURE__ */ (0, $ani5R.defineComponent)({
        inheritAttrs: inheritAttrs,
        setup (_, { attrs: attrs, slots: slots }) {
            return ()=>{
                var _a;
                render.value;
                const vnode = (_a = render.value) == null ? void 0 : _a.call(render, {
                    ...$cbe5e41a05e7dda8$var$keysToCamelKebabCase(attrs),
                    $slots: slots
                });
                return inheritAttrs && (vnode == null ? void 0 : vnode.length) === 1 ? vnode[0] : vnode;
            };
        }
    });
    return (0, $ef9Nn.makeDestructurable)({
        define: define,
        reuse: reuse
    }, [
        define,
        reuse
    ]);
}
function $cbe5e41a05e7dda8$var$keysToCamelKebabCase(obj) {
    const newObj = {};
    for(const key in obj)newObj[(0, $ef9Nn.camelize)(key)] = obj[key];
    return newObj;
}
function $cbe5e41a05e7dda8$export$cf238338337c58d1(options = {}) {
    if (!(0, $j40Rs.isVue3)) return;
    let index = 0;
    const instances = (0, $8bTPG.ref)([]);
    function create(...args) {
        const props = (0, $8bTPG.shallowReactive)({
            key: index++,
            args: args,
            promise: void 0,
            resolve: ()=>{},
            reject: ()=>{},
            isResolving: false,
            options: options
        });
        instances.value.push(props);
        props.promise = new Promise((_resolve, _reject)=>{
            props.resolve = (v)=>{
                props.isResolving = true;
                return _resolve(v);
            };
            props.reject = _reject;
        }).finally(()=>{
            props.promise = void 0;
            const index2 = instances.value.indexOf(props);
            if (index2 !== -1) instances.value.splice(index2, 1);
        });
        return props.promise;
    }
    function start(...args) {
        if (options.singleton && instances.value.length > 0) return instances.value[0].promise;
        return create(...args);
    }
    const component = /* #__PURE__ */ (0, $ani5R.defineComponent)((_, { slots: slots })=>{
        const renderList = ()=>instances.value.map((props)=>{
                var _a;
                return (0, $ani5R.h)((0, $ani5R.Fragment), {
                    key: props.key
                }, (_a = slots.default) == null ? void 0 : _a.call(slots, props));
            });
        if (options.transition) return ()=>(0, $ani5R.h)((0, $dDLnc.TransitionGroup), options.transition, renderList);
        return renderList;
    });
    component.start = start;
    return component;
}
function $cbe5e41a05e7dda8$export$4ebd6dd2d9c62e4b(fn) {
    return function(...args) {
        return fn.apply(this, args.map((i)=>(0, $ef9Nn.toValue)(i)));
    };
}
function $cbe5e41a05e7dda8$export$c61124d3cf5adbae(elRef) {
    var _a;
    const plain = (0, $ef9Nn.toValue)(elRef);
    return (_a = plain == null ? void 0 : plain.$el) != null ? _a : plain;
}
const $cbe5e41a05e7dda8$export$16f8ba610718ae4a = (0, $ef9Nn.isClient) ? window : void 0;
const $cbe5e41a05e7dda8$export$37990bd438d16af3 = (0, $ef9Nn.isClient) ? window.document : void 0;
const $cbe5e41a05e7dda8$export$eade61489f57e3fc = (0, $ef9Nn.isClient) ? window.navigator : void 0;
const $cbe5e41a05e7dda8$export$66494ae16bad8985 = (0, $ef9Nn.isClient) ? window.location : void 0;
function $cbe5e41a05e7dda8$export$7080b3e976bc91ab(...args) {
    let target;
    let events;
    let listeners;
    let options;
    if (typeof args[0] === "string" || Array.isArray(args[0])) {
        [events, listeners, options] = args;
        target = $cbe5e41a05e7dda8$export$16f8ba610718ae4a;
    } else [target, events, listeners, options] = args;
    if (!target) return 0, $ef9Nn.noop;
    if (!Array.isArray(events)) events = [
        events
    ];
    if (!Array.isArray(listeners)) listeners = [
        listeners
    ];
    const cleanups = [];
    const cleanup = ()=>{
        cleanups.forEach((fn)=>fn());
        cleanups.length = 0;
    };
    const register = (el, event, listener, options2)=>{
        el.addEventListener(event, listener, options2);
        return ()=>el.removeEventListener(event, listener, options2);
    };
    const stopWatch = (0, $ani5R.watch)(()=>[
            $cbe5e41a05e7dda8$export$c61124d3cf5adbae(target),
            (0, $ef9Nn.toValue)(options)
        ], ([el, options2])=>{
        cleanup();
        if (!el) return;
        const optionsClone = (0, $ef9Nn.isObject)(options2) ? {
            ...options2
        } : options2;
        cleanups.push(...events.flatMap((event)=>{
            return listeners.map((listener)=>register(el, event, listener, optionsClone));
        }));
    }, {
        immediate: true,
        flush: "post"
    });
    const stop = ()=>{
        stopWatch();
        cleanup();
    };
    (0, $ef9Nn.tryOnScopeDispose)(stop);
    return stop;
}
let $cbe5e41a05e7dda8$var$_iOSWorkaround = false;
function $cbe5e41a05e7dda8$export$806d9a98fb0e6fd0(target, handler, options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, ignore: ignore = [], capture: capture = true, detectIframe: detectIframe = false } = options;
    if (!window1) return 0, $ef9Nn.noop;
    if ((0, $ef9Nn.isIOS) && !$cbe5e41a05e7dda8$var$_iOSWorkaround) {
        $cbe5e41a05e7dda8$var$_iOSWorkaround = true;
        Array.from(window1.document.body.children).forEach((el)=>el.addEventListener("click", (0, $ef9Nn.noop)));
        window1.document.documentElement.addEventListener("click", (0, $ef9Nn.noop));
    }
    let shouldListen = true;
    const shouldIgnore = (event)=>{
        return ignore.some((target2)=>{
            if (typeof target2 === "string") return Array.from(window1.document.querySelectorAll(target2)).some((el)=>el === event.target || event.composedPath().includes(el));
            else {
                const el = $cbe5e41a05e7dda8$export$c61124d3cf5adbae(target2);
                return el && (event.target === el || event.composedPath().includes(el));
            }
        });
    };
    const listener = (event)=>{
        const el = $cbe5e41a05e7dda8$export$c61124d3cf5adbae(target);
        if (!el || el === event.target || event.composedPath().includes(el)) return;
        if (event.detail === 0) shouldListen = !shouldIgnore(event);
        if (!shouldListen) {
            shouldListen = true;
            return;
        }
        handler(event);
    };
    const cleanup = [
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "click", listener, {
            passive: true,
            capture: capture
        }),
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "pointerdown", (e)=>{
            const el = $cbe5e41a05e7dda8$export$c61124d3cf5adbae(target);
            shouldListen = !shouldIgnore(e) && !!(el && !e.composedPath().includes(el));
        }, {
            passive: true
        }),
        detectIframe && $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "blur", (event)=>{
            setTimeout(()=>{
                var _a;
                const el = $cbe5e41a05e7dda8$export$c61124d3cf5adbae(target);
                if (((_a = window1.document.activeElement) == null ? void 0 : _a.tagName) === "IFRAME" && !(el == null ? void 0 : el.contains(window1.document.activeElement))) handler(event);
            }, 0);
        })
    ].filter(Boolean);
    const stop = ()=>cleanup.forEach((fn)=>fn());
    return stop;
}
function $cbe5e41a05e7dda8$var$createKeyPredicate(keyFilter) {
    if (typeof keyFilter === "function") return keyFilter;
    else if (typeof keyFilter === "string") return (event)=>event.key === keyFilter;
    else if (Array.isArray(keyFilter)) return (event)=>keyFilter.includes(event.key);
    return ()=>true;
}
function $cbe5e41a05e7dda8$export$70ca9878161d161b(...args) {
    let key;
    let handler;
    let options = {};
    if (args.length === 3) {
        key = args[0];
        handler = args[1];
        options = args[2];
    } else if (args.length === 2) {
        if (typeof args[1] === "object") {
            key = true;
            handler = args[0];
            options = args[1];
        } else {
            key = args[0];
            handler = args[1];
        }
    } else {
        key = true;
        handler = args[0];
    }
    const { target: target = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, eventName: eventName = "keydown", passive: passive = false, dedupe: dedupe = false } = options;
    const predicate = $cbe5e41a05e7dda8$var$createKeyPredicate(key);
    const listener = (e)=>{
        if (e.repeat && (0, $ef9Nn.toValue)(dedupe)) return;
        if (predicate(e)) handler(e);
    };
    return $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, eventName, listener, passive);
}
function $cbe5e41a05e7dda8$export$de8e1b1372cdb41b(key, handler, options = {}) {
    return $cbe5e41a05e7dda8$export$70ca9878161d161b(key, handler, {
        ...options,
        eventName: "keydown"
    });
}
function $cbe5e41a05e7dda8$export$33ead148203888dd(key, handler, options = {}) {
    return $cbe5e41a05e7dda8$export$70ca9878161d161b(key, handler, {
        ...options,
        eventName: "keypress"
    });
}
function $cbe5e41a05e7dda8$export$f144bbb6e186b14b(key, handler, options = {}) {
    return $cbe5e41a05e7dda8$export$70ca9878161d161b(key, handler, {
        ...options,
        eventName: "keyup"
    });
}
const $cbe5e41a05e7dda8$var$DEFAULT_DELAY = 500;
const $cbe5e41a05e7dda8$var$DEFAULT_THRESHOLD = 10;
function $cbe5e41a05e7dda8$export$d0dd9c8bca391fcb(target, handler, options) {
    var _a, _b;
    const elementRef = (0, $8bTPG.computed)(()=>$cbe5e41a05e7dda8$export$c61124d3cf5adbae(target));
    let timeout;
    let posStart;
    let startTimestamp;
    let hasLongPressed = false;
    function clear() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = void 0;
        }
        posStart = void 0;
        startTimestamp = void 0;
        hasLongPressed = false;
    }
    function onRelease(ev) {
        var _a2, _b2, _c;
        const [_startTimestamp, _posStart, _hasLongPressed] = [
            startTimestamp,
            posStart,
            hasLongPressed
        ];
        clear();
        if (!(options == null ? void 0 : options.onMouseUp) || !_posStart || !_startTimestamp) return;
        if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value) return;
        if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent) ev.preventDefault();
        if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop) ev.stopPropagation();
        const dx = ev.x - _posStart.x;
        const dy = ev.y - _posStart.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        options.onMouseUp(ev.timeStamp - _startTimestamp, distance, _hasLongPressed);
    }
    function onDown(ev) {
        var _a2, _b2, _c, _d;
        if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value) return;
        clear();
        if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent) ev.preventDefault();
        if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop) ev.stopPropagation();
        posStart = {
            x: ev.x,
            y: ev.y
        };
        startTimestamp = ev.timeStamp;
        timeout = setTimeout(()=>{
            hasLongPressed = true;
            handler(ev);
        }, (_d = options == null ? void 0 : options.delay) != null ? _d : $cbe5e41a05e7dda8$var$DEFAULT_DELAY);
    }
    function onMove(ev) {
        var _a2, _b2, _c, _d;
        if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value) return;
        if (!posStart || (options == null ? void 0 : options.distanceThreshold) === false) return;
        if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent) ev.preventDefault();
        if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop) ev.stopPropagation();
        const dx = ev.x - posStart.x;
        const dy = ev.y - posStart.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (distance >= ((_d = options == null ? void 0 : options.distanceThreshold) != null ? _d : $cbe5e41a05e7dda8$var$DEFAULT_THRESHOLD)) clear();
    }
    const listenerOptions = {
        capture: (_a = options == null ? void 0 : options.modifiers) == null ? void 0 : _a.capture,
        once: (_b = options == null ? void 0 : options.modifiers) == null ? void 0 : _b.once
    };
    const cleanup = [
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(elementRef, "pointerdown", onDown, listenerOptions),
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(elementRef, "pointermove", onMove, listenerOptions),
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(elementRef, [
            "pointerup",
            "pointerleave"
        ], onRelease, listenerOptions)
    ];
    const stop = ()=>cleanup.forEach((fn)=>fn());
    return stop;
}
function $cbe5e41a05e7dda8$var$isFocusedElementEditable() {
    const { activeElement: activeElement, body: body } = document;
    if (!activeElement) return false;
    if (activeElement === body) return false;
    switch(activeElement.tagName){
        case "INPUT":
        case "TEXTAREA":
            return true;
    }
    return activeElement.hasAttribute("contenteditable");
}
function $cbe5e41a05e7dda8$var$isTypedCharValid({ keyCode: keyCode, metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey }) {
    if (metaKey || ctrlKey || altKey) return false;
    if (keyCode >= 48 && keyCode <= 57) return true;
    if (keyCode >= 65 && keyCode <= 90) return true;
    if (keyCode >= 97 && keyCode <= 122) return true;
    return false;
}
function $cbe5e41a05e7dda8$export$cd54fc233e2f4a5d(callback, options = {}) {
    const { document: document2 = $cbe5e41a05e7dda8$export$37990bd438d16af3 } = options;
    const keydown = (event)=>{
        !$cbe5e41a05e7dda8$var$isFocusedElementEditable() && $cbe5e41a05e7dda8$var$isTypedCharValid(event) && callback(event);
    };
    if (document2) $cbe5e41a05e7dda8$export$7080b3e976bc91ab(document2, "keydown", keydown, {
        passive: true
    });
}
function $cbe5e41a05e7dda8$export$fc38e812d383221(key, initialValue = null) {
    const instance = (0, $ani5R.getCurrentInstance)();
    let _trigger = ()=>{};
    const element = (0, $8bTPG.customRef)((track, trigger)=>{
        _trigger = trigger;
        return {
            get () {
                var _a, _b;
                track();
                return (_b = (_a = instance == null ? void 0 : instance.proxy) == null ? void 0 : _a.$refs[key]) != null ? _b : initialValue;
            },
            set () {}
        };
    });
    (0, $ef9Nn.tryOnMounted)(_trigger);
    (0, $ani5R.onUpdated)(_trigger);
    return element;
}
function $cbe5e41a05e7dda8$export$bce3bfec9f56c837() {
    const isMounted = (0, $8bTPG.ref)(false);
    const instance = (0, $ani5R.getCurrentInstance)();
    if (instance) (0, $ani5R.onMounted)(()=>{
        isMounted.value = true;
    }, (0, $j40Rs.isVue2) ? void 0 : instance);
    return isMounted;
}
function $cbe5e41a05e7dda8$export$85904d4478b9c8a4(callback) {
    const isMounted = $cbe5e41a05e7dda8$export$bce3bfec9f56c837();
    return (0, $8bTPG.computed)(()=>{
        isMounted.value;
        return Boolean(callback());
    });
}
function $cbe5e41a05e7dda8$export$8ecdcf3bb089e9cd(target, callback, options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, ...mutationOptions } = options;
    let observer;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>window1 && "MutationObserver" in window1);
    const cleanup = ()=>{
        if (observer) {
            observer.disconnect();
            observer = void 0;
        }
    };
    const targets = (0, $8bTPG.computed)(()=>{
        const value = (0, $ef9Nn.toValue)(target);
        const items = (Array.isArray(value) ? value : [
            value
        ]).map($cbe5e41a05e7dda8$export$c61124d3cf5adbae).filter((0, $ef9Nn.notNullish));
        return new Set(items);
    });
    const stopWatch = (0, $ani5R.watch)(()=>targets.value, (targets2)=>{
        cleanup();
        if (isSupported.value && targets2.size) {
            observer = new MutationObserver(callback);
            targets2.forEach((el)=>observer.observe(el, mutationOptions));
        }
    }, {
        immediate: true,
        flush: "post"
    });
    const takeRecords = ()=>{
        return observer == null ? void 0 : observer.takeRecords();
    };
    const stop = ()=>{
        cleanup();
        stopWatch();
    };
    (0, $ef9Nn.tryOnScopeDispose)(stop);
    return {
        isSupported: isSupported,
        stop: stop,
        takeRecords: takeRecords
    };
}
function $cbe5e41a05e7dda8$export$4e1875a4b2b1434f(options = {}) {
    var _a;
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, deep: deep = true, triggerOnRemoval: triggerOnRemoval = false } = options;
    const document1 = (_a = options.document) != null ? _a : window1 == null ? void 0 : window1.document;
    const getDeepActiveElement = ()=>{
        var _a2;
        let element = document1 == null ? void 0 : document1.activeElement;
        if (deep) while(element == null ? void 0 : element.shadowRoot)element = (_a2 = element == null ? void 0 : element.shadowRoot) == null ? void 0 : _a2.activeElement;
        return element;
    };
    const activeElement = (0, $8bTPG.ref)();
    const trigger = ()=>{
        activeElement.value = getDeepActiveElement();
    };
    if (window1) {
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "blur", (event)=>{
            if (event.relatedTarget !== null) return;
            trigger();
        }, true);
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "focus", trigger, true);
    }
    if (triggerOnRemoval) $cbe5e41a05e7dda8$export$8ecdcf3bb089e9cd(document1, (mutations)=>{
        mutations.filter((m)=>m.removedNodes.length).map((n)=>Array.from(n.removedNodes)).flat().forEach((node)=>{
            if (node === activeElement.value) trigger();
        });
    }, {
        childList: true,
        subtree: true
    });
    trigger();
    return activeElement;
}
function $cbe5e41a05e7dda8$export$13251e0fc79284e(fn, options = {}) {
    const { immediate: immediate = true, fpsLimit: fpsLimit, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const isActive = (0, $8bTPG.ref)(false);
    const intervalLimit = fpsLimit ? 1e3 / fpsLimit : null;
    let previousFrameTimestamp = 0;
    let rafId = null;
    function loop(timestamp) {
        if (!isActive.value || !window1) return;
        if (!previousFrameTimestamp) previousFrameTimestamp = timestamp;
        const delta = timestamp - previousFrameTimestamp;
        if (intervalLimit && delta < intervalLimit) {
            rafId = window1.requestAnimationFrame(loop);
            return;
        }
        previousFrameTimestamp = timestamp;
        fn({
            delta: delta,
            timestamp: timestamp
        });
        rafId = window1.requestAnimationFrame(loop);
    }
    function resume() {
        if (!isActive.value && window1) {
            isActive.value = true;
            previousFrameTimestamp = 0;
            rafId = window1.requestAnimationFrame(loop);
        }
    }
    function pause() {
        isActive.value = false;
        if (rafId != null && window1) {
            window1.cancelAnimationFrame(rafId);
            rafId = null;
        }
    }
    if (immediate) resume();
    (0, $ef9Nn.tryOnScopeDispose)(pause);
    return {
        isActive: (0, $8bTPG.readonly)(isActive),
        pause: pause,
        resume: resume
    };
}
function $cbe5e41a05e7dda8$export$9f387b98a73b1511(target, keyframes, options) {
    let config;
    let animateOptions;
    if ((0, $ef9Nn.isObject)(options)) {
        config = options;
        animateOptions = (0, $ef9Nn.objectOmit)(options, [
            "window",
            "immediate",
            "commitStyles",
            "persist",
            "onReady",
            "onError"
        ]);
    } else {
        config = {
            duration: options
        };
        animateOptions = options;
    }
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, immediate: immediate = true, commitStyles: commitStyles, persist: persist, playbackRate: _playbackRate = 1, onReady: onReady, onError: onError = (e)=>{
        console.error(e);
    } } = config;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>window1 && HTMLElement && "animate" in HTMLElement.prototype);
    const animate = (0, $8bTPG.shallowRef)(void 0);
    const store = (0, $8bTPG.shallowReactive)({
        startTime: null,
        currentTime: null,
        timeline: null,
        playbackRate: _playbackRate,
        pending: false,
        playState: immediate ? "idle" : "paused",
        replaceState: "active"
    });
    const pending = (0, $8bTPG.computed)(()=>store.pending);
    const playState = (0, $8bTPG.computed)(()=>store.playState);
    const replaceState = (0, $8bTPG.computed)(()=>store.replaceState);
    const startTime = (0, $8bTPG.computed)({
        get () {
            return store.startTime;
        },
        set (value) {
            store.startTime = value;
            if (animate.value) animate.value.startTime = value;
        }
    });
    const currentTime = (0, $8bTPG.computed)({
        get () {
            return store.currentTime;
        },
        set (value) {
            store.currentTime = value;
            if (animate.value) {
                animate.value.currentTime = value;
                syncResume();
            }
        }
    });
    const timeline = (0, $8bTPG.computed)({
        get () {
            return store.timeline;
        },
        set (value) {
            store.timeline = value;
            if (animate.value) animate.value.timeline = value;
        }
    });
    const playbackRate = (0, $8bTPG.computed)({
        get () {
            return store.playbackRate;
        },
        set (value) {
            store.playbackRate = value;
            if (animate.value) animate.value.playbackRate = value;
        }
    });
    const play = ()=>{
        if (animate.value) try {
            animate.value.play();
            syncResume();
        } catch (e) {
            syncPause();
            onError(e);
        }
        else update();
    };
    const pause = ()=>{
        var _a;
        try {
            (_a = animate.value) == null || _a.pause();
            syncPause();
        } catch (e) {
            onError(e);
        }
    };
    const reverse = ()=>{
        var _a;
        !animate.value && update();
        try {
            (_a = animate.value) == null || _a.reverse();
            syncResume();
        } catch (e) {
            syncPause();
            onError(e);
        }
    };
    const finish = ()=>{
        var _a;
        try {
            (_a = animate.value) == null || _a.finish();
            syncPause();
        } catch (e) {
            onError(e);
        }
    };
    const cancel = ()=>{
        var _a;
        try {
            (_a = animate.value) == null || _a.cancel();
            syncPause();
        } catch (e) {
            onError(e);
        }
    };
    (0, $ani5R.watch)(()=>$cbe5e41a05e7dda8$export$c61124d3cf5adbae(target), (el)=>{
        el && update();
    });
    (0, $ani5R.watch)(()=>keyframes, (value)=>{
        !animate.value && update();
        if (!$cbe5e41a05e7dda8$export$c61124d3cf5adbae(target) && animate.value) animate.value.effect = new KeyframeEffect($cbe5e41a05e7dda8$export$c61124d3cf5adbae(target), (0, $ef9Nn.toValue)(value), animateOptions);
    }, {
        deep: true
    });
    (0, $ef9Nn.tryOnMounted)(()=>{
        (0, $ani5R.nextTick)(()=>update(true));
    });
    (0, $ef9Nn.tryOnScopeDispose)(cancel);
    function update(init) {
        const el = $cbe5e41a05e7dda8$export$c61124d3cf5adbae(target);
        if (!isSupported.value || !el) return;
        if (!animate.value) animate.value = el.animate((0, $ef9Nn.toValue)(keyframes), animateOptions);
        if (persist) animate.value.persist();
        if (_playbackRate !== 1) animate.value.playbackRate = _playbackRate;
        if (init && !immediate) animate.value.pause();
        else syncResume();
        onReady == null || onReady(animate.value);
    }
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(animate, [
        "cancel",
        "finish",
        "remove"
    ], syncPause);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(animate, "finish", ()=>{
        var _a;
        if (commitStyles) (_a = animate.value) == null || _a.commitStyles();
    });
    const { resume: resumeRef, pause: pauseRef } = $cbe5e41a05e7dda8$export$13251e0fc79284e(()=>{
        if (!animate.value) return;
        store.pending = animate.value.pending;
        store.playState = animate.value.playState;
        store.replaceState = animate.value.replaceState;
        store.startTime = animate.value.startTime;
        store.currentTime = animate.value.currentTime;
        store.timeline = animate.value.timeline;
        store.playbackRate = animate.value.playbackRate;
    }, {
        immediate: false
    });
    function syncResume() {
        if (isSupported.value) resumeRef();
    }
    function syncPause() {
        if (isSupported.value && window1) window1.requestAnimationFrame(pauseRef);
    }
    return {
        isSupported: isSupported,
        animate: animate,
        play: // actions
        play,
        pause: pause,
        reverse: reverse,
        finish: finish,
        cancel: cancel,
        pending: // state
        pending,
        playState: playState,
        replaceState: replaceState,
        startTime: startTime,
        currentTime: currentTime,
        timeline: timeline,
        playbackRate: playbackRate
    };
}
function $cbe5e41a05e7dda8$export$15048550d0df8459(tasks, options) {
    const { interrupt: interrupt = true, onError: onError = (0, $ef9Nn.noop), onFinished: onFinished = (0, $ef9Nn.noop), signal: signal } = options || {};
    const promiseState = {
        aborted: "aborted",
        fulfilled: "fulfilled",
        pending: "pending",
        rejected: "rejected"
    };
    const initialResult = Array.from(Array.from({
        length: tasks.length
    }), ()=>({
            state: promiseState.pending,
            data: null
        }));
    const result = (0, $8bTPG.reactive)(initialResult);
    const activeIndex = (0, $8bTPG.ref)(-1);
    if (!tasks || tasks.length === 0) {
        onFinished();
        return {
            activeIndex: activeIndex,
            result: result
        };
    }
    function updateResult(state, res) {
        activeIndex.value++;
        result[activeIndex.value].data = res;
        result[activeIndex.value].state = state;
    }
    tasks.reduce((prev, curr)=>{
        return prev.then((prevRes)=>{
            var _a;
            if (signal == null ? void 0 : signal.aborted) {
                updateResult(promiseState.aborted, new Error("aborted"));
                return;
            }
            if (((_a = result[activeIndex.value]) == null ? void 0 : _a.state) === promiseState.rejected && interrupt) {
                onFinished();
                return;
            }
            const done = curr(prevRes).then((currentRes)=>{
                updateResult(promiseState.fulfilled, currentRes);
                activeIndex.value === tasks.length - 1 && onFinished();
                return currentRes;
            });
            if (!signal) return done;
            return Promise.race([
                done,
                $cbe5e41a05e7dda8$var$whenAborted(signal)
            ]);
        }).catch((e)=>{
            if (signal == null ? void 0 : signal.aborted) {
                updateResult(promiseState.aborted, e);
                return e;
            }
            updateResult(promiseState.rejected, e);
            onError();
            return e;
        });
    }, Promise.resolve());
    return {
        activeIndex: activeIndex,
        result: result
    };
}
function $cbe5e41a05e7dda8$var$whenAborted(signal) {
    return new Promise((resolve, reject)=>{
        const error = new Error("aborted");
        if (signal.aborted) reject(error);
        else signal.addEventListener("abort", ()=>reject(error), {
            once: true
        });
    });
}
function $cbe5e41a05e7dda8$export$d94717ae0e8aa8b(promise, initialState, options) {
    const { immediate: immediate = true, delay: delay = 0, onError: onError = (0, $ef9Nn.noop), onSuccess: onSuccess = (0, $ef9Nn.noop), resetOnExecute: resetOnExecute = true, shallow: shallow = true, throwError: throwError } = options != null ? options : {};
    const state = shallow ? (0, $8bTPG.shallowRef)(initialState) : (0, $8bTPG.ref)(initialState);
    const isReady = (0, $8bTPG.ref)(false);
    const isLoading = (0, $8bTPG.ref)(false);
    const error = (0, $8bTPG.shallowRef)(void 0);
    async function execute(delay2 = 0, ...args) {
        if (resetOnExecute) state.value = initialState;
        error.value = void 0;
        isReady.value = false;
        isLoading.value = true;
        if (delay2 > 0) await (0, $ef9Nn.promiseTimeout)(delay2);
        const _promise = typeof promise === "function" ? promise(...args) : promise;
        try {
            const data = await _promise;
            state.value = data;
            isReady.value = true;
            onSuccess(data);
        } catch (e) {
            error.value = e;
            onError(e);
            if (throwError) throw e;
        } finally{
            isLoading.value = false;
        }
        return state.value;
    }
    if (immediate) execute(delay);
    const shell = {
        state: state,
        isReady: isReady,
        isLoading: isLoading,
        error: error,
        execute: execute
    };
    function waitUntilIsLoaded() {
        return new Promise((resolve, reject)=>{
            (0, $ef9Nn.until)(isLoading).toBe(false).then(()=>resolve(shell)).catch(reject);
        });
    }
    return {
        ...shell,
        then (onFulfilled, onRejected) {
            return waitUntilIsLoaded().then(onFulfilled, onRejected);
        }
    };
}
const $cbe5e41a05e7dda8$var$defaults = {
    array: (v)=>JSON.stringify(v),
    object: (v)=>JSON.stringify(v),
    set: (v)=>JSON.stringify(Array.from(v)),
    map: (v)=>JSON.stringify(Object.fromEntries(v)),
    null: ()=>""
};
function $cbe5e41a05e7dda8$var$getDefaultSerialization(target) {
    if (!target) return $cbe5e41a05e7dda8$var$defaults.null;
    if (target instanceof Map) return $cbe5e41a05e7dda8$var$defaults.map;
    else if (target instanceof Set) return $cbe5e41a05e7dda8$var$defaults.set;
    else if (Array.isArray(target)) return $cbe5e41a05e7dda8$var$defaults.array;
    else return $cbe5e41a05e7dda8$var$defaults.object;
}
function $cbe5e41a05e7dda8$export$a1fce3538bfe26db(target, options) {
    const base64 = (0, $8bTPG.ref)("");
    const promise = (0, $8bTPG.ref)();
    function execute() {
        if (!(0, $ef9Nn.isClient)) return;
        promise.value = new Promise((resolve, reject)=>{
            try {
                const _target = (0, $ef9Nn.toValue)(target);
                if (_target == null) resolve("");
                else if (typeof _target === "string") resolve($cbe5e41a05e7dda8$var$blobToBase64(new Blob([
                    _target
                ], {
                    type: "text/plain"
                })));
                else if (_target instanceof Blob) resolve($cbe5e41a05e7dda8$var$blobToBase64(_target));
                else if (_target instanceof ArrayBuffer) resolve(window.btoa(String.fromCharCode(...new Uint8Array(_target))));
                else if (_target instanceof HTMLCanvasElement) resolve(_target.toDataURL(options == null ? void 0 : options.type, options == null ? void 0 : options.quality));
                else if (_target instanceof HTMLImageElement) {
                    const img = _target.cloneNode(false);
                    img.crossOrigin = "Anonymous";
                    $cbe5e41a05e7dda8$var$imgLoaded(img).then(()=>{
                        const canvas = document.createElement("canvas");
                        const ctx = canvas.getContext("2d");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                        resolve(canvas.toDataURL(options == null ? void 0 : options.type, options == null ? void 0 : options.quality));
                    }).catch(reject);
                } else if (typeof _target === "object") {
                    const _serializeFn = (options == null ? void 0 : options.serializer) || $cbe5e41a05e7dda8$var$getDefaultSerialization(_target);
                    const serialized = _serializeFn(_target);
                    return resolve($cbe5e41a05e7dda8$var$blobToBase64(new Blob([
                        serialized
                    ], {
                        type: "application/json"
                    })));
                } else reject(new Error("target is unsupported types"));
            } catch (error) {
                reject(error);
            }
        });
        promise.value.then((res)=>base64.value = res);
        return promise.value;
    }
    if ((0, $8bTPG.isRef)(target) || typeof target === "function") (0, $ani5R.watch)(target, execute, {
        immediate: true
    });
    else execute();
    return {
        base64: base64,
        promise: promise,
        execute: execute
    };
}
function $cbe5e41a05e7dda8$var$imgLoaded(img) {
    return new Promise((resolve, reject)=>{
        if (!img.complete) {
            img.onload = ()=>{
                resolve();
            };
            img.onerror = reject;
        } else resolve();
    });
}
function $cbe5e41a05e7dda8$var$blobToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const fr = new FileReader();
        fr.onload = (e)=>{
            resolve(e.target.result);
        };
        fr.onerror = reject;
        fr.readAsDataURL(blob);
    });
}
function $cbe5e41a05e7dda8$export$2a2cdda660e4b159(options = {}) {
    const { navigator: navigator = $cbe5e41a05e7dda8$export$eade61489f57e3fc } = options;
    const events = [
        "chargingchange",
        "chargingtimechange",
        "dischargingtimechange",
        "levelchange"
    ];
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>navigator && "getBattery" in navigator && typeof navigator.getBattery === "function");
    const charging = (0, $8bTPG.ref)(false);
    const chargingTime = (0, $8bTPG.ref)(0);
    const dischargingTime = (0, $8bTPG.ref)(0);
    const level = (0, $8bTPG.ref)(1);
    let battery;
    function updateBatteryInfo() {
        charging.value = this.charging;
        chargingTime.value = this.chargingTime || 0;
        dischargingTime.value = this.dischargingTime || 0;
        level.value = this.level;
    }
    if (isSupported.value) navigator.getBattery().then((_battery)=>{
        battery = _battery;
        updateBatteryInfo.call(battery);
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(battery, events, updateBatteryInfo, {
            passive: true
        });
    });
    return {
        isSupported: isSupported,
        charging: charging,
        chargingTime: chargingTime,
        dischargingTime: dischargingTime,
        level: level
    };
}
function $cbe5e41a05e7dda8$export$4fa034be92e08f89(options) {
    let { acceptAllDevices: acceptAllDevices = false } = options || {};
    const { filters: filters, optionalServices: optionalServices, navigator: navigator = $cbe5e41a05e7dda8$export$eade61489f57e3fc } = options || {};
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>navigator && "bluetooth" in navigator);
    const device = (0, $8bTPG.shallowRef)(void 0);
    const error = (0, $8bTPG.shallowRef)(null);
    (0, $ani5R.watch)(device, ()=>{
        connectToBluetoothGATTServer();
    });
    async function requestDevice() {
        if (!isSupported.value) return;
        error.value = null;
        if (filters && filters.length > 0) acceptAllDevices = false;
        try {
            device.value = await (navigator == null ? void 0 : navigator.bluetooth.requestDevice({
                acceptAllDevices: acceptAllDevices,
                filters: filters,
                optionalServices: optionalServices
            }));
        } catch (err) {
            error.value = err;
        }
    }
    const server = (0, $8bTPG.ref)();
    const isConnected = (0, $8bTPG.computed)(()=>{
        var _a;
        return ((_a = server.value) == null ? void 0 : _a.connected) || false;
    });
    async function connectToBluetoothGATTServer() {
        error.value = null;
        if (device.value && device.value.gatt) {
            device.value.addEventListener("gattserverdisconnected", ()=>{});
            try {
                server.value = await device.value.gatt.connect();
            } catch (err) {
                error.value = err;
            }
        }
    }
    (0, $ef9Nn.tryOnMounted)(()=>{
        var _a;
        if (device.value) (_a = device.value.gatt) == null || _a.connect();
    });
    (0, $ef9Nn.tryOnScopeDispose)(()=>{
        var _a;
        if (device.value) (_a = device.value.gatt) == null || _a.disconnect();
    });
    return {
        isSupported: isSupported,
        isConnected: isConnected,
        device: // Device:
        device,
        requestDevice: requestDevice,
        server: // Server:
        server,
        error: // Errors:
        error
    };
}
function $cbe5e41a05e7dda8$export$32d5543ab307c01(query, options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>window1 && "matchMedia" in window1 && typeof window1.matchMedia === "function");
    let mediaQuery;
    const matches = (0, $8bTPG.ref)(false);
    const handler = (event)=>{
        matches.value = event.matches;
    };
    const cleanup = ()=>{
        if (!mediaQuery) return;
        if ("removeEventListener" in mediaQuery) mediaQuery.removeEventListener("change", handler);
        else mediaQuery.removeListener(handler);
    };
    const stopWatch = (0, $ani5R.watchEffect)(()=>{
        if (!isSupported.value) return;
        cleanup();
        mediaQuery = window1.matchMedia((0, $ef9Nn.toValue)(query));
        if ("addEventListener" in mediaQuery) mediaQuery.addEventListener("change", handler);
        else mediaQuery.addListener(handler);
        matches.value = mediaQuery.matches;
    });
    (0, $ef9Nn.tryOnScopeDispose)(()=>{
        stopWatch();
        cleanup();
        mediaQuery = void 0;
    });
    return matches;
}
const $cbe5e41a05e7dda8$export$1e7f3da0afb51c4 = {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
};
const $cbe5e41a05e7dda8$export$ab05426c509559f5 = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
};
const $cbe5e41a05e7dda8$export$59a8910ce37234c0 = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1264,
    xl: 1904
};
const $cbe5e41a05e7dda8$export$f7fcbbae4606fa86 = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
    xxl: 2560
};
const $cbe5e41a05e7dda8$export$e826524d50707be3 = $cbe5e41a05e7dda8$export$59a8910ce37234c0;
const $cbe5e41a05e7dda8$export$913d30ac358ba918 = {
    xs: 480,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600
};
const $cbe5e41a05e7dda8$export$6ed1cd5183566ff7 = {
    xs: 0,
    sm: 600,
    md: 1024,
    lg: 1440,
    xl: 1920
};
const $cbe5e41a05e7dda8$export$b4376e330fd9cda3 = {
    mobileS: 320,
    mobileM: 375,
    mobileL: 425,
    tablet: 768,
    laptop: 1024,
    laptopL: 1440,
    desktop4K: 2560
};
const $cbe5e41a05e7dda8$export$dba9946743c0ab98 = {
    "3xs": 360,
    "2xs": 480,
    "xs": 600,
    "sm": 768,
    "md": 1024,
    "lg": 1280,
    "xl": 1440,
    "2xl": 1600,
    "3xl": 1920,
    "4xl": 2560
};
const $cbe5e41a05e7dda8$export$71df204985f11b6 = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
};
function $cbe5e41a05e7dda8$export$e818ed21e924bde4(breakpoints, options = {}) {
    function getValue(k, delta) {
        let v = (0, $ef9Nn.toValue)(breakpoints[(0, $ef9Nn.toValue)(k)]);
        if (delta != null) v = (0, $ef9Nn.increaseWithUnit)(v, delta);
        if (typeof v === "number") v = `${v}px`;
        return v;
    }
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, strategy: strategy = "min-width" } = options;
    function match(query) {
        if (!window1) return false;
        return window1.matchMedia(query).matches;
    }
    const greaterOrEqual = (k)=>{
        return $cbe5e41a05e7dda8$export$32d5543ab307c01(()=>`(min-width: ${getValue(k)})`, options);
    };
    const smallerOrEqual = (k)=>{
        return $cbe5e41a05e7dda8$export$32d5543ab307c01(()=>`(max-width: ${getValue(k)})`, options);
    };
    const shortcutMethods = Object.keys(breakpoints).reduce((shortcuts, k)=>{
        Object.defineProperty(shortcuts, k, {
            get: ()=>strategy === "min-width" ? greaterOrEqual(k) : smallerOrEqual(k),
            enumerable: true,
            configurable: true
        });
        return shortcuts;
    }, {});
    function current() {
        const points = Object.keys(breakpoints).map((i)=>[
                i,
                greaterOrEqual(i)
            ]);
        return (0, $8bTPG.computed)(()=>points.filter(([, v])=>v.value).map(([k])=>k));
    }
    return Object.assign(shortcutMethods, {
        greaterOrEqual: greaterOrEqual,
        smallerOrEqual: smallerOrEqual,
        greater (k) {
            return $cbe5e41a05e7dda8$export$32d5543ab307c01(()=>`(min-width: ${getValue(k, 0.1)})`, options);
        },
        smaller (k) {
            return $cbe5e41a05e7dda8$export$32d5543ab307c01(()=>`(max-width: ${getValue(k, -0.1)})`, options);
        },
        between (a, b) {
            return $cbe5e41a05e7dda8$export$32d5543ab307c01(()=>`(min-width: ${getValue(a)}) and (max-width: ${getValue(b, -0.1)})`, options);
        },
        isGreater (k) {
            return match(`(min-width: ${getValue(k, 0.1)})`);
        },
        isGreaterOrEqual (k) {
            return match(`(min-width: ${getValue(k)})`);
        },
        isSmaller (k) {
            return match(`(max-width: ${getValue(k, -0.1)})`);
        },
        isSmallerOrEqual (k) {
            return match(`(max-width: ${getValue(k)})`);
        },
        isInBetween (a, b) {
            return match(`(min-width: ${getValue(a)}) and (max-width: ${getValue(b, -0.1)})`);
        },
        current: current,
        active () {
            const bps = current();
            return (0, $8bTPG.computed)(()=>bps.value.length === 0 ? "" : bps.value.at(-1));
        }
    });
}
function $cbe5e41a05e7dda8$export$e38c76da774a8077(options) {
    const { name: name, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>window1 && "BroadcastChannel" in window1);
    const isClosed = (0, $8bTPG.ref)(false);
    const channel = (0, $8bTPG.ref)();
    const data = (0, $8bTPG.ref)();
    const error = (0, $8bTPG.shallowRef)(null);
    const post = (data2)=>{
        if (channel.value) channel.value.postMessage(data2);
    };
    const close = ()=>{
        if (channel.value) channel.value.close();
        isClosed.value = true;
    };
    if (isSupported.value) (0, $ef9Nn.tryOnMounted)(()=>{
        error.value = null;
        channel.value = new BroadcastChannel(name);
        channel.value.addEventListener("message", (e)=>{
            data.value = e.data;
        }, {
            passive: true
        });
        channel.value.addEventListener("messageerror", (e)=>{
            error.value = e;
        }, {
            passive: true
        });
        channel.value.addEventListener("close", ()=>{
            isClosed.value = true;
        });
    });
    (0, $ef9Nn.tryOnScopeDispose)(()=>{
        close();
    });
    return {
        isSupported: isSupported,
        channel: channel,
        data: data,
        post: post,
        close: close,
        error: error,
        isClosed: isClosed
    };
}
const $cbe5e41a05e7dda8$var$WRITABLE_PROPERTIES = [
    "hash",
    "host",
    "hostname",
    "href",
    "pathname",
    "port",
    "protocol",
    "search"
];
function $cbe5e41a05e7dda8$export$29c60f5332583(options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const refs = Object.fromEntries($cbe5e41a05e7dda8$var$WRITABLE_PROPERTIES.map((key)=>[
            key,
            (0, $8bTPG.ref)()
        ]));
    for (const [key, ref2] of (0, $ef9Nn.objectEntries)(refs))(0, $ani5R.watch)(ref2, (value)=>{
        if (!(window1 == null ? void 0 : window1.location) || window1.location[key] === value) return;
        window1.location[key] = value;
    });
    const buildState = (trigger)=>{
        var _a;
        const { state: state2, length: length } = (window1 == null ? void 0 : window1.history) || {};
        const { origin: origin } = (window1 == null ? void 0 : window1.location) || {};
        for (const key of $cbe5e41a05e7dda8$var$WRITABLE_PROPERTIES)refs[key].value = (_a = window1 == null ? void 0 : window1.location) == null ? void 0 : _a[key];
        return (0, $8bTPG.reactive)({
            trigger: trigger,
            state: state2,
            length: length,
            origin: origin,
            ...refs
        });
    };
    const state = (0, $8bTPG.ref)(buildState("load"));
    if (window1) {
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "popstate", ()=>state.value = buildState("popstate"), {
            passive: true
        });
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "hashchange", ()=>state.value = buildState("hashchange"), {
            passive: true
        });
    }
    return state;
}
function $cbe5e41a05e7dda8$export$738959f2b29daa01(refValue, comparator = (a, b)=>a === b, watchOptions) {
    const cachedValue = (0, $8bTPG.ref)(refValue.value);
    (0, $ani5R.watch)(()=>refValue.value, (value)=>{
        if (!comparator(value, cachedValue.value)) cachedValue.value = value;
    }, watchOptions);
    return cachedValue;
}
function $cbe5e41a05e7dda8$export$d7376454a3cf5ab4(permissionDesc, options = {}) {
    const { controls: controls = false, navigator: navigator = $cbe5e41a05e7dda8$export$eade61489f57e3fc } = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>navigator && "permissions" in navigator);
    let permissionStatus;
    const desc = typeof permissionDesc === "string" ? {
        name: permissionDesc
    } : permissionDesc;
    const state = (0, $8bTPG.ref)();
    const onChange = ()=>{
        if (permissionStatus) state.value = permissionStatus.state;
    };
    const query = (0, $ef9Nn.createSingletonPromise)(async ()=>{
        if (!isSupported.value) return;
        if (!permissionStatus) try {
            permissionStatus = await navigator.permissions.query(desc);
            $cbe5e41a05e7dda8$export$7080b3e976bc91ab(permissionStatus, "change", onChange);
            onChange();
        } catch (e) {
            state.value = "prompt";
        }
        return permissionStatus;
    });
    query();
    if (controls) return {
        state: state,
        isSupported: isSupported,
        query: query
    };
    else return state;
}
function $cbe5e41a05e7dda8$export$2314ca2a3e892862(options = {}) {
    const { navigator: navigator = $cbe5e41a05e7dda8$export$eade61489f57e3fc, read: read = false, source: source, copiedDuring: copiedDuring = 1500, legacy: legacy = false } = options;
    const isClipboardApiSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>navigator && "clipboard" in navigator);
    const permissionRead = $cbe5e41a05e7dda8$export$d7376454a3cf5ab4("clipboard-read");
    const permissionWrite = $cbe5e41a05e7dda8$export$d7376454a3cf5ab4("clipboard-write");
    const isSupported = (0, $8bTPG.computed)(()=>isClipboardApiSupported.value || legacy);
    const text = (0, $8bTPG.ref)("");
    const copied = (0, $8bTPG.ref)(false);
    const timeout = (0, $ef9Nn.useTimeoutFn)(()=>copied.value = false, copiedDuring);
    function updateText() {
        if (isClipboardApiSupported.value && isAllowed(permissionRead.value)) navigator.clipboard.readText().then((value)=>{
            text.value = value;
        });
        else text.value = legacyRead();
    }
    if (isSupported.value && read) $cbe5e41a05e7dda8$export$7080b3e976bc91ab([
        "copy",
        "cut"
    ], updateText);
    async function copy(value = (0, $ef9Nn.toValue)(source)) {
        if (isSupported.value && value != null) {
            if (isClipboardApiSupported.value && isAllowed(permissionWrite.value)) await navigator.clipboard.writeText(value);
            else legacyCopy(value);
            text.value = value;
            copied.value = true;
            timeout.start();
        }
    }
    function legacyCopy(value) {
        const ta = document.createElement("textarea");
        ta.value = value != null ? value : "";
        ta.style.position = "absolute";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        ta.remove();
    }
    function legacyRead() {
        var _a, _b, _c;
        return (_c = (_b = (_a = document == null ? void 0 : document.getSelection) == null ? void 0 : _a.call(document)) == null ? void 0 : _b.toString()) != null ? _c : "";
    }
    function isAllowed(status) {
        return status === "granted" || status === "prompt";
    }
    return {
        isSupported: isSupported,
        text: text,
        copied: copied,
        copy: copy
    };
}
function $cbe5e41a05e7dda8$export$ada6005637a1689d(options = {}) {
    const { navigator: navigator = $cbe5e41a05e7dda8$export$eade61489f57e3fc, read: read = false, source: source, copiedDuring: copiedDuring = 1500 } = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>navigator && "clipboard" in navigator);
    const content = (0, $8bTPG.ref)([]);
    const copied = (0, $8bTPG.ref)(false);
    const timeout = (0, $ef9Nn.useTimeoutFn)(()=>copied.value = false, copiedDuring);
    function updateContent() {
        if (isSupported.value) navigator.clipboard.read().then((items)=>{
            content.value = items;
        });
    }
    if (isSupported.value && read) $cbe5e41a05e7dda8$export$7080b3e976bc91ab([
        "copy",
        "cut"
    ], updateContent);
    async function copy(value = (0, $ef9Nn.toValue)(source)) {
        if (isSupported.value && value != null) {
            await navigator.clipboard.write(value);
            content.value = value;
            copied.value = true;
            timeout.start();
        }
    }
    return {
        isSupported: isSupported,
        content: content,
        copied: copied,
        copy: copy
    };
}
function $cbe5e41a05e7dda8$export$9e72043f8ff3a3df(source) {
    return JSON.parse(JSON.stringify(source));
}
function $cbe5e41a05e7dda8$export$1d793528ac2b824a(source, options = {}) {
    const cloned = (0, $8bTPG.ref)({});
    const { manual: manual, clone: clone = $cbe5e41a05e7dda8$export$9e72043f8ff3a3df, deep: // watch options
    deep = true, immediate: immediate = true } = options;
    function sync() {
        cloned.value = clone((0, $ef9Nn.toValue)(source));
    }
    if (!manual && ((0, $8bTPG.isRef)(source) || typeof source === "function")) (0, $ani5R.watch)(source, sync, {
        ...options,
        deep: deep,
        immediate: immediate
    });
    else sync();
    return {
        cloned: cloned,
        sync: sync
    };
}
const $cbe5e41a05e7dda8$var$_global = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
const $cbe5e41a05e7dda8$var$globalKey = "__vueuse_ssr_handlers__";
const $cbe5e41a05e7dda8$var$handlers = /* @__PURE__ */ $cbe5e41a05e7dda8$var$getHandlers();
function $cbe5e41a05e7dda8$var$getHandlers() {
    if (!($cbe5e41a05e7dda8$var$globalKey in $cbe5e41a05e7dda8$var$_global)) $cbe5e41a05e7dda8$var$_global[$cbe5e41a05e7dda8$var$globalKey] = $cbe5e41a05e7dda8$var$_global[$cbe5e41a05e7dda8$var$globalKey] || {};
    return $cbe5e41a05e7dda8$var$_global[$cbe5e41a05e7dda8$var$globalKey];
}
function $cbe5e41a05e7dda8$export$b0cf1ae5a98eb83b(key, fallback) {
    return $cbe5e41a05e7dda8$var$handlers[key] || fallback;
}
function $cbe5e41a05e7dda8$export$4094cfc0512bc950(key, fn) {
    $cbe5e41a05e7dda8$var$handlers[key] = fn;
}
function $cbe5e41a05e7dda8$var$guessSerializerType(rawInit) {
    return rawInit == null ? "any" : rawInit instanceof Set ? "set" : rawInit instanceof Map ? "map" : rawInit instanceof Date ? "date" : typeof rawInit === "boolean" ? "boolean" : typeof rawInit === "string" ? "string" : typeof rawInit === "object" ? "object" : !Number.isNaN(rawInit) ? "number" : "any";
}
const $cbe5e41a05e7dda8$export$8111877b006f9b0b = {
    boolean: {
        read: (v)=>v === "true",
        write: (v)=>String(v)
    },
    object: {
        read: (v)=>JSON.parse(v),
        write: (v)=>JSON.stringify(v)
    },
    number: {
        read: (v)=>Number.parseFloat(v),
        write: (v)=>String(v)
    },
    any: {
        read: (v)=>v,
        write: (v)=>String(v)
    },
    string: {
        read: (v)=>v,
        write: (v)=>String(v)
    },
    map: {
        read: (v)=>new Map(JSON.parse(v)),
        write: (v)=>JSON.stringify(Array.from(v.entries()))
    },
    set: {
        read: (v)=>new Set(JSON.parse(v)),
        write: (v)=>JSON.stringify(Array.from(v))
    },
    date: {
        read: (v)=>new Date(v),
        write: (v)=>v.toISOString()
    }
};
const $cbe5e41a05e7dda8$export$5962b94d93010632 = "vueuse-storage";
function $cbe5e41a05e7dda8$export$95809329f49ea9f9(key, defaults, storage, options = {}) {
    var _a;
    const { flush: flush = "pre", deep: deep = true, listenToStorageChanges: listenToStorageChanges = true, writeDefaults: writeDefaults = true, mergeDefaults: mergeDefaults = false, shallow: shallow, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, eventFilter: eventFilter, onError: onError = (e)=>{
        console.error(e);
    }, initOnMounted: initOnMounted } = options;
    const data = (shallow ? (0, $8bTPG.shallowRef) : (0, $8bTPG.ref))(typeof defaults === "function" ? defaults() : defaults);
    if (!storage) try {
        storage = $cbe5e41a05e7dda8$export$b0cf1ae5a98eb83b("getDefaultStorage", ()=>{
            var _a2;
            return (_a2 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a) == null ? void 0 : _a2.localStorage;
        })();
    } catch (e) {
        onError(e);
    }
    if (!storage) return data;
    const rawInit = (0, $ef9Nn.toValue)(defaults);
    const type = $cbe5e41a05e7dda8$var$guessSerializerType(rawInit);
    const serializer = (_a = options.serializer) != null ? _a : $cbe5e41a05e7dda8$export$8111877b006f9b0b[type];
    const { pause: pauseWatch, resume: resumeWatch } = (0, $ef9Nn.pausableWatch)(data, ()=>write(data.value), {
        flush: flush,
        deep: deep,
        eventFilter: eventFilter
    });
    if (window1 && listenToStorageChanges) (0, $ef9Nn.tryOnMounted)(()=>{
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "storage", update);
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, $cbe5e41a05e7dda8$export$5962b94d93010632, updateFromCustomEvent);
        if (initOnMounted) update();
    });
    if (!initOnMounted) update();
    function dispatchWriteEvent(oldValue, newValue) {
        if (window1) window1.dispatchEvent(new CustomEvent($cbe5e41a05e7dda8$export$5962b94d93010632, {
            detail: {
                key: key,
                oldValue: oldValue,
                newValue: newValue,
                storageArea: storage
            }
        }));
    }
    function write(v) {
        try {
            const oldValue = storage.getItem(key);
            if (v == null) {
                dispatchWriteEvent(oldValue, null);
                storage.removeItem(key);
            } else {
                const serialized = serializer.write(v);
                if (oldValue !== serialized) {
                    storage.setItem(key, serialized);
                    dispatchWriteEvent(oldValue, serialized);
                }
            }
        } catch (e) {
            onError(e);
        }
    }
    function read(event) {
        const rawValue = event ? event.newValue : storage.getItem(key);
        if (rawValue == null) {
            if (writeDefaults && rawInit != null) storage.setItem(key, serializer.write(rawInit));
            return rawInit;
        } else if (!event && mergeDefaults) {
            const value = serializer.read(rawValue);
            if (typeof mergeDefaults === "function") return mergeDefaults(value, rawInit);
            else if (type === "object" && !Array.isArray(value)) return {
                ...rawInit,
                ...value
            };
            return value;
        } else if (typeof rawValue !== "string") return rawValue;
        else return serializer.read(rawValue);
    }
    function update(event) {
        if (event && event.storageArea !== storage) return;
        if (event && event.key == null) {
            data.value = rawInit;
            return;
        }
        if (event && event.key !== key) return;
        pauseWatch();
        try {
            if ((event == null ? void 0 : event.newValue) !== serializer.write(data.value)) data.value = read(event);
        } catch (e) {
            onError(e);
        } finally{
            if (event) (0, $ani5R.nextTick)(resumeWatch);
            else resumeWatch();
        }
    }
    function updateFromCustomEvent(event) {
        update(event.detail);
    }
    return data;
}
function $cbe5e41a05e7dda8$export$a9fe667866660cd5(options) {
    return $cbe5e41a05e7dda8$export$32d5543ab307c01("(prefers-color-scheme: dark)", options);
}
function $cbe5e41a05e7dda8$export$20f3076712c8dfa(options = {}) {
    const { selector: selector = "html", attribute: attribute = "class", initialValue: initialValue = "auto", window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, storage: storage, storageKey: storageKey = "vueuse-color-scheme", listenToStorageChanges: listenToStorageChanges = true, storageRef: storageRef, emitAuto: emitAuto, disableTransition: disableTransition = true } = options;
    const modes = {
        auto: "",
        light: "light",
        dark: "dark",
        ...options.modes || {}
    };
    const preferredDark = $cbe5e41a05e7dda8$export$a9fe667866660cd5({
        window: window1
    });
    const system = (0, $8bTPG.computed)(()=>preferredDark.value ? "dark" : "light");
    const store = storageRef || (storageKey == null ? (0, $ef9Nn.toRef)(initialValue) : $cbe5e41a05e7dda8$export$95809329f49ea9f9(storageKey, initialValue, storage, {
        window: window1,
        listenToStorageChanges: listenToStorageChanges
    }));
    const state = (0, $8bTPG.computed)(()=>store.value === "auto" ? system.value : store.value);
    const updateHTMLAttrs = $cbe5e41a05e7dda8$export$b0cf1ae5a98eb83b("updateHTMLAttrs", (selector2, attribute2, value)=>{
        const el = typeof selector2 === "string" ? window1 == null ? void 0 : window1.document.querySelector(selector2) : $cbe5e41a05e7dda8$export$c61124d3cf5adbae(selector2);
        if (!el) return;
        let style;
        if (disableTransition) {
            style = window1.document.createElement("style");
            const styleString = "*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
            style.appendChild(document.createTextNode(styleString));
            window1.document.head.appendChild(style);
        }
        if (attribute2 === "class") {
            const current = value.split(/\s/g);
            Object.values(modes).flatMap((i)=>(i || "").split(/\s/g)).filter(Boolean).forEach((v)=>{
                if (current.includes(v)) el.classList.add(v);
                else el.classList.remove(v);
            });
        } else el.setAttribute(attribute2, value);
        if (disableTransition) {
            window1.getComputedStyle(style).opacity;
            document.head.removeChild(style);
        }
    });
    function defaultOnChanged(mode) {
        var _a;
        updateHTMLAttrs(selector, attribute, (_a = modes[mode]) != null ? _a : mode);
    }
    function onChanged(mode) {
        if (options.onChanged) options.onChanged(mode, defaultOnChanged);
        else defaultOnChanged(mode);
    }
    (0, $ani5R.watch)(state, onChanged, {
        flush: "post",
        immediate: true
    });
    (0, $ef9Nn.tryOnMounted)(()=>onChanged(state.value));
    const auto = (0, $8bTPG.computed)({
        get () {
            return emitAuto ? store.value : state.value;
        },
        set (v) {
            store.value = v;
        }
    });
    try {
        return Object.assign(auto, {
            store: store,
            system: system,
            state: state
        });
    } catch (e) {
        return auto;
    }
}
function $cbe5e41a05e7dda8$export$93c95fc6177ab5cd(revealed = (0, $8bTPG.ref)(false)) {
    const confirmHook = (0, $ef9Nn.createEventHook)();
    const cancelHook = (0, $ef9Nn.createEventHook)();
    const revealHook = (0, $ef9Nn.createEventHook)();
    let _resolve = (0, $ef9Nn.noop);
    const reveal = (data)=>{
        revealHook.trigger(data);
        revealed.value = true;
        return new Promise((resolve)=>{
            _resolve = resolve;
        });
    };
    const confirm = (data)=>{
        revealed.value = false;
        confirmHook.trigger(data);
        _resolve({
            data: data,
            isCanceled: false
        });
    };
    const cancel = (data)=>{
        revealed.value = false;
        cancelHook.trigger(data);
        _resolve({
            data: data,
            isCanceled: true
        });
    };
    return {
        isRevealed: (0, $8bTPG.computed)(()=>revealed.value),
        reveal: reveal,
        confirm: confirm,
        cancel: cancel,
        onReveal: revealHook.on,
        onConfirm: confirmHook.on,
        onCancel: cancelHook.on
    };
}
function $cbe5e41a05e7dda8$export$811e58a9be6ff112(prop, target, options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, initialValue: initialValue = "", observe: observe = false } = options;
    const variable = (0, $8bTPG.ref)(initialValue);
    const elRef = (0, $8bTPG.computed)(()=>{
        var _a;
        return $cbe5e41a05e7dda8$export$c61124d3cf5adbae(target) || ((_a = window1 == null ? void 0 : window1.document) == null ? void 0 : _a.documentElement);
    });
    function updateCssVar() {
        var _a;
        const key = (0, $ef9Nn.toValue)(prop);
        const el = (0, $ef9Nn.toValue)(elRef);
        if (el && window1) {
            const value = (_a = window1.getComputedStyle(el).getPropertyValue(key)) == null ? void 0 : _a.trim();
            variable.value = value || initialValue;
        }
    }
    if (observe) $cbe5e41a05e7dda8$export$8ecdcf3bb089e9cd(elRef, updateCssVar, {
        attributeFilter: [
            "style",
            "class"
        ],
        window: window1
    });
    (0, $ani5R.watch)([
        elRef,
        ()=>(0, $ef9Nn.toValue)(prop)
    ], updateCssVar, {
        immediate: true
    });
    (0, $ani5R.watch)(variable, (val)=>{
        var _a;
        if ((_a = elRef.value) == null ? void 0 : _a.style) elRef.value.style.setProperty((0, $ef9Nn.toValue)(prop), val);
    });
    return variable;
}
function $cbe5e41a05e7dda8$export$8d937a32bc2b31dd(rootComponent) {
    const vm = (0, $ani5R.getCurrentInstance)();
    const currentElement = (0, $ef9Nn.computedWithControl)(()=>null, ()=>rootComponent ? $cbe5e41a05e7dda8$export$c61124d3cf5adbae(rootComponent) : vm.proxy.$el);
    (0, $ani5R.onUpdated)(currentElement.trigger);
    (0, $ani5R.onMounted)(currentElement.trigger);
    return currentElement;
}
function $cbe5e41a05e7dda8$export$a43ea948f6bdcecc(list, options) {
    const state = (0, $8bTPG.shallowRef)(getInitialValue());
    const listRef = (0, $ef9Nn.toRef)(list);
    const index = (0, $8bTPG.computed)({
        get () {
            var _a;
            const targetList = listRef.value;
            let index2 = (options == null ? void 0 : options.getIndexOf) ? options.getIndexOf(state.value, targetList) : targetList.indexOf(state.value);
            if (index2 < 0) index2 = (_a = options == null ? void 0 : options.fallbackIndex) != null ? _a : 0;
            return index2;
        },
        set (v) {
            set(v);
        }
    });
    function set(i) {
        const targetList = listRef.value;
        const length = targetList.length;
        const index2 = (i % length + length) % length;
        const value = targetList[index2];
        state.value = value;
        return value;
    }
    function shift(delta = 1) {
        return set(index.value + delta);
    }
    function next(n = 1) {
        return shift(n);
    }
    function prev(n = 1) {
        return shift(-n);
    }
    function getInitialValue() {
        var _a, _b;
        return (_b = (0, $ef9Nn.toValue)((_a = options == null ? void 0 : options.initialValue) != null ? _a : (0, $ef9Nn.toValue)(list)[0])) != null ? _b : void 0;
    }
    (0, $ani5R.watch)(listRef, ()=>set(index.value));
    return {
        state: state,
        index: index,
        next: next,
        prev: prev,
        go: set
    };
}
function $cbe5e41a05e7dda8$export$b067746439a7c60(options = {}) {
    const { valueDark: valueDark = "dark", valueLight: valueLight = "", window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const mode = $cbe5e41a05e7dda8$export$20f3076712c8dfa({
        ...options,
        onChanged: (mode2, defaultHandler)=>{
            var _a;
            if (options.onChanged) (_a = options.onChanged) == null || _a.call(options, mode2 === "dark", defaultHandler, mode2);
            else defaultHandler(mode2);
        },
        modes: {
            dark: valueDark,
            light: valueLight
        }
    });
    const system = (0, $8bTPG.computed)(()=>{
        if (mode.system) return mode.system.value;
        else {
            const preferredDark = $cbe5e41a05e7dda8$export$a9fe667866660cd5({
                window: window1
            });
            return preferredDark.value ? "dark" : "light";
        }
    });
    const isDark = (0, $8bTPG.computed)({
        get () {
            return mode.value === "dark";
        },
        set (v) {
            const modeVal = v ? "dark" : "light";
            if (system.value === modeVal) mode.value = "auto";
            else mode.value = modeVal;
        }
    });
    return isDark;
}
function $cbe5e41a05e7dda8$var$fnBypass(v) {
    return v;
}
function $cbe5e41a05e7dda8$var$fnSetSource(source, value) {
    return source.value = value;
}
function $cbe5e41a05e7dda8$var$defaultDump(clone) {
    return clone ? typeof clone === "function" ? clone : $cbe5e41a05e7dda8$export$9e72043f8ff3a3df : $cbe5e41a05e7dda8$var$fnBypass;
}
function $cbe5e41a05e7dda8$var$defaultParse(clone) {
    return clone ? typeof clone === "function" ? clone : $cbe5e41a05e7dda8$export$9e72043f8ff3a3df : $cbe5e41a05e7dda8$var$fnBypass;
}
function $cbe5e41a05e7dda8$export$614531ad6f0c8fd(source, options = {}) {
    const { clone: clone = false, dump: dump = $cbe5e41a05e7dda8$var$defaultDump(clone), parse: parse = $cbe5e41a05e7dda8$var$defaultParse(clone), setSource: setSource = $cbe5e41a05e7dda8$var$fnSetSource } = options;
    function _createHistoryRecord() {
        return (0, $8bTPG.markRaw)({
            snapshot: dump(source.value),
            timestamp: (0, $ef9Nn.timestamp)()
        });
    }
    const last = (0, $8bTPG.ref)(_createHistoryRecord());
    const undoStack = (0, $8bTPG.ref)([]);
    const redoStack = (0, $8bTPG.ref)([]);
    const _setSource = (record)=>{
        setSource(source, parse(record.snapshot));
        last.value = record;
    };
    const commit = ()=>{
        undoStack.value.unshift(last.value);
        last.value = _createHistoryRecord();
        if (options.capacity && undoStack.value.length > options.capacity) undoStack.value.splice(options.capacity, Number.POSITIVE_INFINITY);
        if (redoStack.value.length) redoStack.value.splice(0, redoStack.value.length);
    };
    const clear = ()=>{
        undoStack.value.splice(0, undoStack.value.length);
        redoStack.value.splice(0, redoStack.value.length);
    };
    const undo = ()=>{
        const state = undoStack.value.shift();
        if (state) {
            redoStack.value.unshift(last.value);
            _setSource(state);
        }
    };
    const redo = ()=>{
        const state = redoStack.value.shift();
        if (state) {
            undoStack.value.unshift(last.value);
            _setSource(state);
        }
    };
    const reset = ()=>{
        _setSource(last.value);
    };
    const history = (0, $8bTPG.computed)(()=>[
            last.value,
            ...undoStack.value
        ]);
    const canUndo = (0, $8bTPG.computed)(()=>undoStack.value.length > 0);
    const canRedo = (0, $8bTPG.computed)(()=>redoStack.value.length > 0);
    return {
        source: source,
        undoStack: undoStack,
        redoStack: redoStack,
        last: last,
        history: history,
        canUndo: canUndo,
        canRedo: canRedo,
        clear: clear,
        commit: commit,
        reset: reset,
        undo: undo,
        redo: redo
    };
}
function $cbe5e41a05e7dda8$export$de889b39e422efc4(source, options = {}) {
    const { deep: deep = false, flush: flush = "pre", eventFilter: eventFilter } = options;
    const { eventFilter: composedFilter, pause: pause, resume: resumeTracking, isActive: isTracking } = (0, $ef9Nn.pausableFilter)(eventFilter);
    const { ignoreUpdates: ignoreUpdates, ignorePrevAsyncUpdates: ignorePrevAsyncUpdates, stop: stop } = (0, $ef9Nn.watchIgnorable)(source, commit, {
        deep: deep,
        flush: flush,
        eventFilter: composedFilter
    });
    function setSource(source2, value) {
        ignorePrevAsyncUpdates();
        ignoreUpdates(()=>{
            source2.value = value;
        });
    }
    const manualHistory = $cbe5e41a05e7dda8$export$614531ad6f0c8fd(source, {
        ...options,
        clone: options.clone || deep,
        setSource: setSource
    });
    const { clear: clear, commit: manualCommit } = manualHistory;
    function commit() {
        ignorePrevAsyncUpdates();
        manualCommit();
    }
    function resume(commitNow) {
        resumeTracking();
        if (commitNow) commit();
    }
    function batch(fn) {
        let canceled = false;
        const cancel = ()=>canceled = true;
        ignoreUpdates(()=>{
            fn(cancel);
        });
        if (!canceled) commit();
    }
    function dispose() {
        stop();
        clear();
    }
    return {
        ...manualHistory,
        isTracking: isTracking,
        pause: pause,
        resume: resume,
        commit: commit,
        batch: batch,
        dispose: dispose
    };
}
function $cbe5e41a05e7dda8$export$3b9372c83f595b14(source, options = {}) {
    const filter = options.debounce ? (0, $ef9Nn.debounceFilter)(options.debounce) : void 0;
    const history = $cbe5e41a05e7dda8$export$de889b39e422efc4(source, {
        ...options,
        eventFilter: filter
    });
    return {
        ...history
    };
}
function $cbe5e41a05e7dda8$export$45ef0ca3d803202d(options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, eventFilter: eventFilter = (0, $ef9Nn.bypassFilter) } = options;
    const acceleration = (0, $8bTPG.ref)({
        x: null,
        y: null,
        z: null
    });
    const rotationRate = (0, $8bTPG.ref)({
        alpha: null,
        beta: null,
        gamma: null
    });
    const interval = (0, $8bTPG.ref)(0);
    const accelerationIncludingGravity = (0, $8bTPG.ref)({
        x: null,
        y: null,
        z: null
    });
    if (window1) {
        const onDeviceMotion = (0, $ef9Nn.createFilterWrapper)(eventFilter, (event)=>{
            acceleration.value = event.acceleration;
            accelerationIncludingGravity.value = event.accelerationIncludingGravity;
            rotationRate.value = event.rotationRate;
            interval.value = event.interval;
        });
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "devicemotion", onDeviceMotion);
    }
    return {
        acceleration: acceleration,
        accelerationIncludingGravity: accelerationIncludingGravity,
        rotationRate: rotationRate,
        interval: interval
    };
}
function $cbe5e41a05e7dda8$export$9bafe4f626b63a33(options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>window1 && "DeviceOrientationEvent" in window1);
    const isAbsolute = (0, $8bTPG.ref)(false);
    const alpha = (0, $8bTPG.ref)(null);
    const beta = (0, $8bTPG.ref)(null);
    const gamma = (0, $8bTPG.ref)(null);
    if (window1 && isSupported.value) $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "deviceorientation", (event)=>{
        isAbsolute.value = event.absolute;
        alpha.value = event.alpha;
        beta.value = event.beta;
        gamma.value = event.gamma;
    });
    return {
        isSupported: isSupported,
        isAbsolute: isAbsolute,
        alpha: alpha,
        beta: beta,
        gamma: gamma
    };
}
function $cbe5e41a05e7dda8$export$9619f0fa9e7879c6(options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const pixelRatio = (0, $8bTPG.ref)(1);
    if (window1) {
        let observe2 = function() {
            pixelRatio.value = window1.devicePixelRatio;
            cleanup2();
            media = window1.matchMedia(`(resolution: ${pixelRatio.value}dppx)`);
            media.addEventListener("change", observe2, {
                once: true
            });
        }, cleanup2 = function() {
            media == null || media.removeEventListener("change", observe2);
        };
        let media;
        observe2();
        (0, $ef9Nn.tryOnScopeDispose)(cleanup2);
    }
    return {
        pixelRatio: pixelRatio
    };
}
function $cbe5e41a05e7dda8$export$c860eb59c2f56cac(options = {}) {
    const { navigator: navigator = $cbe5e41a05e7dda8$export$eade61489f57e3fc, requestPermissions: requestPermissions = false, constraints: constraints = {
        audio: true,
        video: true
    }, onUpdated: onUpdated } = options;
    const devices = (0, $8bTPG.ref)([]);
    const videoInputs = (0, $8bTPG.computed)(()=>devices.value.filter((i)=>i.kind === "videoinput"));
    const audioInputs = (0, $8bTPG.computed)(()=>devices.value.filter((i)=>i.kind === "audioinput"));
    const audioOutputs = (0, $8bTPG.computed)(()=>devices.value.filter((i)=>i.kind === "audiooutput"));
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>navigator && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices);
    const permissionGranted = (0, $8bTPG.ref)(false);
    let stream;
    async function update() {
        if (!isSupported.value) return;
        devices.value = await navigator.mediaDevices.enumerateDevices();
        onUpdated == null || onUpdated(devices.value);
        if (stream) {
            stream.getTracks().forEach((t)=>t.stop());
            stream = null;
        }
    }
    async function ensurePermissions() {
        if (!isSupported.value) return false;
        if (permissionGranted.value) return true;
        const { state: state, query: query } = $cbe5e41a05e7dda8$export$d7376454a3cf5ab4("camera", {
            controls: true
        });
        await query();
        if (state.value !== "granted") {
            stream = await navigator.mediaDevices.getUserMedia(constraints);
            update();
            permissionGranted.value = true;
        } else permissionGranted.value = true;
        return permissionGranted.value;
    }
    if (isSupported.value) {
        if (requestPermissions) ensurePermissions();
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(navigator.mediaDevices, "devicechange", update);
        update();
    }
    return {
        devices: devices,
        ensurePermissions: ensurePermissions,
        permissionGranted: permissionGranted,
        videoInputs: videoInputs,
        audioInputs: audioInputs,
        audioOutputs: audioOutputs,
        isSupported: isSupported
    };
}
function $cbe5e41a05e7dda8$export$f2d17e22a8e6ddfc(options = {}) {
    var _a;
    const enabled = (0, $8bTPG.ref)((_a = options.enabled) != null ? _a : false);
    const video = options.video;
    const audio = options.audio;
    const { navigator: navigator = $cbe5e41a05e7dda8$export$eade61489f57e3fc } = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>{
        var _a2;
        return (_a2 = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : _a2.getDisplayMedia;
    });
    const constraint = {
        audio: audio,
        video: video
    };
    const stream = (0, $8bTPG.shallowRef)();
    async function _start() {
        var _a2;
        if (!isSupported.value || stream.value) return;
        stream.value = await navigator.mediaDevices.getDisplayMedia(constraint);
        (_a2 = stream.value) == null || _a2.getTracks().forEach((t)=>t.addEventListener("ended", stop));
        return stream.value;
    }
    async function _stop() {
        var _a2;
        (_a2 = stream.value) == null || _a2.getTracks().forEach((t)=>t.stop());
        stream.value = void 0;
    }
    function stop() {
        _stop();
        enabled.value = false;
    }
    async function start() {
        await _start();
        if (stream.value) enabled.value = true;
        return stream.value;
    }
    (0, $ani5R.watch)(enabled, (v)=>{
        if (v) _start();
        else _stop();
    }, {
        immediate: true
    });
    return {
        isSupported: isSupported,
        stream: stream,
        start: start,
        stop: stop,
        enabled: enabled
    };
}
function $cbe5e41a05e7dda8$export$87a87a3d299ece7c(options = {}) {
    const { document: document1 = $cbe5e41a05e7dda8$export$37990bd438d16af3 } = options;
    if (!document1) return (0, $8bTPG.ref)("visible");
    const visibility = (0, $8bTPG.ref)(document1.visibilityState);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(document1, "visibilitychange", ()=>{
        visibility.value = document1.visibilityState;
    });
    return visibility;
}
function $cbe5e41a05e7dda8$export$df30c81f5aa01ff7(target, options = {}) {
    var _a, _b;
    const { pointerTypes: pointerTypes, preventDefault: preventDefault, stopPropagation: stopPropagation, exact: exact, onMove: onMove, onEnd: onEnd, onStart: onStart, initialValue: initialValue, axis: axis = "both", draggingElement: draggingElement = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, containerElement: containerElement, handle: draggingHandle = target } = options;
    const position = (0, $8bTPG.ref)((_a = (0, $ef9Nn.toValue)(initialValue)) != null ? _a : {
        x: 0,
        y: 0
    });
    const pressedDelta = (0, $8bTPG.ref)();
    const filterEvent = (e)=>{
        if (pointerTypes) return pointerTypes.includes(e.pointerType);
        return true;
    };
    const handleEvent = (e)=>{
        if ((0, $ef9Nn.toValue)(preventDefault)) e.preventDefault();
        if ((0, $ef9Nn.toValue)(stopPropagation)) e.stopPropagation();
    };
    const start = (e)=>{
        var _a2;
        if (e.button !== 0) return;
        if ((0, $ef9Nn.toValue)(options.disabled) || !filterEvent(e)) return;
        if ((0, $ef9Nn.toValue)(exact) && e.target !== (0, $ef9Nn.toValue)(target)) return;
        const container = (0, $ef9Nn.toValue)(containerElement);
        const containerRect = (_a2 = container == null ? void 0 : container.getBoundingClientRect) == null ? void 0 : _a2.call(container);
        const targetRect = (0, $ef9Nn.toValue)(target).getBoundingClientRect();
        const pos = {
            x: e.clientX - (container ? targetRect.left - containerRect.left + container.scrollLeft : targetRect.left),
            y: e.clientY - (container ? targetRect.top - containerRect.top + container.scrollTop : targetRect.top)
        };
        if ((onStart == null ? void 0 : onStart(pos, e)) === false) return;
        pressedDelta.value = pos;
        handleEvent(e);
    };
    const move = (e)=>{
        if ((0, $ef9Nn.toValue)(options.disabled) || !filterEvent(e)) return;
        if (!pressedDelta.value) return;
        const container = (0, $ef9Nn.toValue)(containerElement);
        const targetRect = (0, $ef9Nn.toValue)(target).getBoundingClientRect();
        let { x: x, y: y } = position.value;
        if (axis === "x" || axis === "both") {
            x = e.clientX - pressedDelta.value.x;
            if (container) x = Math.min(Math.max(0, x), container.scrollWidth - targetRect.width);
        }
        if (axis === "y" || axis === "both") {
            y = e.clientY - pressedDelta.value.y;
            if (container) y = Math.min(Math.max(0, y), container.scrollHeight - targetRect.height);
        }
        position.value = {
            x: x,
            y: y
        };
        onMove == null || onMove(position.value, e);
        handleEvent(e);
    };
    const end = (e)=>{
        if ((0, $ef9Nn.toValue)(options.disabled) || !filterEvent(e)) return;
        if (!pressedDelta.value) return;
        pressedDelta.value = void 0;
        onEnd == null || onEnd(position.value, e);
        handleEvent(e);
    };
    if (0, $ef9Nn.isClient) {
        const config = {
            capture: (_b = options.capture) != null ? _b : true
        };
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(draggingHandle, "pointerdown", start, config);
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(draggingElement, "pointermove", move, config);
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(draggingElement, "pointerup", end, config);
    }
    return {
        ...(0, $ef9Nn.toRefs)(position),
        position: position,
        isDragging: (0, $8bTPG.computed)(()=>!!pressedDelta.value),
        style: (0, $8bTPG.computed)(()=>`left:${position.value.x}px;top:${position.value.y}px;`)
    };
}
function $cbe5e41a05e7dda8$export$ff33ba24b8f2a683(target, options = {}) {
    const isOverDropZone = (0, $8bTPG.ref)(false);
    const files = (0, $8bTPG.shallowRef)(null);
    let counter = 0;
    let isDataTypeIncluded = true;
    if (0, $ef9Nn.isClient) {
        const _options = typeof options === "function" ? {
            onDrop: options
        } : options;
        const getFiles = (event)=>{
            var _a, _b;
            const list = Array.from((_b = (_a = event.dataTransfer) == null ? void 0 : _a.files) != null ? _b : []);
            return files.value = list.length === 0 ? null : list;
        };
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "dragenter", (event)=>{
            var _a, _b;
            const types = Array.from(((_a = event == null ? void 0 : event.dataTransfer) == null ? void 0 : _a.items) || []).map((i)=>i.kind === "file" ? i.type : null).filter((0, $ef9Nn.notNullish));
            if (_options.dataTypes && event.dataTransfer) {
                const dataTypes = (0, $8bTPG.unref)(_options.dataTypes);
                isDataTypeIncluded = typeof dataTypes === "function" ? dataTypes(types) : dataTypes ? dataTypes.some((item)=>types.includes(item)) : true;
                if (!isDataTypeIncluded) return;
            }
            event.preventDefault();
            counter += 1;
            isOverDropZone.value = true;
            (_b = _options.onEnter) == null || _b.call(_options, getFiles(event), event);
        });
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "dragover", (event)=>{
            var _a;
            if (!isDataTypeIncluded) return;
            event.preventDefault();
            (_a = _options.onOver) == null || _a.call(_options, getFiles(event), event);
        });
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "dragleave", (event)=>{
            var _a;
            if (!isDataTypeIncluded) return;
            event.preventDefault();
            counter -= 1;
            if (counter === 0) isOverDropZone.value = false;
            (_a = _options.onLeave) == null || _a.call(_options, getFiles(event), event);
        });
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "drop", (event)=>{
            var _a;
            event.preventDefault();
            counter = 0;
            isOverDropZone.value = false;
            (_a = _options.onDrop) == null || _a.call(_options, getFiles(event), event);
        });
    }
    return {
        files: files,
        isOverDropZone: isOverDropZone
    };
}
function $cbe5e41a05e7dda8$export$683480f191c0e3ea(target, callback, options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, ...observerOptions } = options;
    let observer;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>window1 && "ResizeObserver" in window1);
    const cleanup = ()=>{
        if (observer) {
            observer.disconnect();
            observer = void 0;
        }
    };
    const targets = (0, $8bTPG.computed)(()=>Array.isArray(target) ? target.map((el)=>$cbe5e41a05e7dda8$export$c61124d3cf5adbae(el)) : [
            $cbe5e41a05e7dda8$export$c61124d3cf5adbae(target)
        ]);
    const stopWatch = (0, $ani5R.watch)(targets, (els)=>{
        cleanup();
        if (isSupported.value && window1) {
            observer = new ResizeObserver(callback);
            for (const _el of els)_el && observer.observe(_el, observerOptions);
        }
    }, {
        immediate: true,
        flush: "post"
    });
    const stop = ()=>{
        cleanup();
        stopWatch();
    };
    (0, $ef9Nn.tryOnScopeDispose)(stop);
    return {
        isSupported: isSupported,
        stop: stop
    };
}
function $cbe5e41a05e7dda8$export$f623e6fca765c371(target, options = {}) {
    const { reset: reset = true, windowResize: windowResize = true, windowScroll: windowScroll = true, immediate: immediate = true } = options;
    const height = (0, $8bTPG.ref)(0);
    const bottom = (0, $8bTPG.ref)(0);
    const left = (0, $8bTPG.ref)(0);
    const right = (0, $8bTPG.ref)(0);
    const top = (0, $8bTPG.ref)(0);
    const width = (0, $8bTPG.ref)(0);
    const x = (0, $8bTPG.ref)(0);
    const y = (0, $8bTPG.ref)(0);
    function update() {
        const el = $cbe5e41a05e7dda8$export$c61124d3cf5adbae(target);
        if (!el) {
            if (reset) {
                height.value = 0;
                bottom.value = 0;
                left.value = 0;
                right.value = 0;
                top.value = 0;
                width.value = 0;
                x.value = 0;
                y.value = 0;
            }
            return;
        }
        const rect = el.getBoundingClientRect();
        height.value = rect.height;
        bottom.value = rect.bottom;
        left.value = rect.left;
        right.value = rect.right;
        top.value = rect.top;
        width.value = rect.width;
        x.value = rect.x;
        y.value = rect.y;
    }
    $cbe5e41a05e7dda8$export$683480f191c0e3ea(target, update);
    (0, $ani5R.watch)(()=>$cbe5e41a05e7dda8$export$c61124d3cf5adbae(target), (ele)=>!ele && update());
    $cbe5e41a05e7dda8$export$8ecdcf3bb089e9cd(target, update, {
        attributeFilter: [
            "style",
            "class"
        ]
    });
    if (windowScroll) $cbe5e41a05e7dda8$export$7080b3e976bc91ab("scroll", update, {
        capture: true,
        passive: true
    });
    if (windowResize) $cbe5e41a05e7dda8$export$7080b3e976bc91ab("resize", update, {
        passive: true
    });
    (0, $ef9Nn.tryOnMounted)(()=>{
        if (immediate) update();
    });
    return {
        height: height,
        bottom: bottom,
        left: left,
        right: right,
        top: top,
        width: width,
        x: x,
        y: y,
        update: update
    };
}
function $cbe5e41a05e7dda8$export$f6b6f8dd6f68aad2(options) {
    const { x: x, y: y, document: document1 = $cbe5e41a05e7dda8$export$37990bd438d16af3, multiple: multiple, interval: interval = "requestAnimationFrame", immediate: immediate = true } = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>{
        if ((0, $ef9Nn.toValue)(multiple)) return document1 && "elementsFromPoint" in document1;
        return document1 && "elementFromPoint" in document1;
    });
    const element = (0, $8bTPG.ref)(null);
    const cb = ()=>{
        var _a, _b;
        element.value = (0, $ef9Nn.toValue)(multiple) ? (_a = document1 == null ? void 0 : document1.elementsFromPoint((0, $ef9Nn.toValue)(x), (0, $ef9Nn.toValue)(y))) != null ? _a : [] : (_b = document1 == null ? void 0 : document1.elementFromPoint((0, $ef9Nn.toValue)(x), (0, $ef9Nn.toValue)(y))) != null ? _b : null;
    };
    const controls = interval === "requestAnimationFrame" ? $cbe5e41a05e7dda8$export$13251e0fc79284e(cb, {
        immediate: immediate
    }) : (0, $ef9Nn.useIntervalFn)(cb, interval, {
        immediate: immediate
    });
    return {
        isSupported: isSupported,
        element: element,
        ...controls
    };
}
function $cbe5e41a05e7dda8$export$6e95f3a294e6b04d(el, options = {}) {
    const { delayEnter: delayEnter = 0, delayLeave: delayLeave = 0, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const isHovered = (0, $8bTPG.ref)(false);
    let timer;
    const toggle = (entering)=>{
        const delay = entering ? delayEnter : delayLeave;
        if (timer) {
            clearTimeout(timer);
            timer = void 0;
        }
        if (delay) timer = setTimeout(()=>isHovered.value = entering, delay);
        else isHovered.value = entering;
    };
    if (!window1) return isHovered;
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(el, "mouseenter", ()=>toggle(true), {
        passive: true
    });
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(el, "mouseleave", ()=>toggle(false), {
        passive: true
    });
    return isHovered;
}
function $cbe5e41a05e7dda8$export$2b86bedf890eab8(target, initialSize = {
    width: 0,
    height: 0
}, options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, box: box = "content-box" } = options;
    const isSVG = (0, $8bTPG.computed)(()=>{
        var _a, _b;
        return (_b = (_a = $cbe5e41a05e7dda8$export$c61124d3cf5adbae(target)) == null ? void 0 : _a.namespaceURI) == null ? void 0 : _b.includes("svg");
    });
    const width = (0, $8bTPG.ref)(initialSize.width);
    const height = (0, $8bTPG.ref)(initialSize.height);
    const { stop: stop1 } = $cbe5e41a05e7dda8$export$683480f191c0e3ea(target, ([entry])=>{
        const boxSize = box === "border-box" ? entry.borderBoxSize : box === "content-box" ? entry.contentBoxSize : entry.devicePixelContentBoxSize;
        if (window1 && isSVG.value) {
            const $elem = $cbe5e41a05e7dda8$export$c61124d3cf5adbae(target);
            if ($elem) {
                const rect = $elem.getBoundingClientRect();
                width.value = rect.width;
                height.value = rect.height;
            }
        } else if (boxSize) {
            const formatBoxSize = Array.isArray(boxSize) ? boxSize : [
                boxSize
            ];
            width.value = formatBoxSize.reduce((acc, { inlineSize: inlineSize })=>acc + inlineSize, 0);
            height.value = formatBoxSize.reduce((acc, { blockSize: blockSize })=>acc + blockSize, 0);
        } else {
            width.value = entry.contentRect.width;
            height.value = entry.contentRect.height;
        }
    }, options);
    (0, $ef9Nn.tryOnMounted)(()=>{
        const ele = $cbe5e41a05e7dda8$export$c61124d3cf5adbae(target);
        if (ele) {
            width.value = "offsetWidth" in ele ? ele.offsetWidth : initialSize.width;
            height.value = "offsetHeight" in ele ? ele.offsetHeight : initialSize.height;
        }
    });
    const stop2 = (0, $ani5R.watch)(()=>$cbe5e41a05e7dda8$export$c61124d3cf5adbae(target), (ele)=>{
        width.value = ele ? initialSize.width : 0;
        height.value = ele ? initialSize.height : 0;
    });
    function stop() {
        stop1();
        stop2();
    }
    return {
        width: width,
        height: height,
        stop: stop
    };
}
function $cbe5e41a05e7dda8$export$a7395f9832c00176(target, callback, options = {}) {
    const { root: root, rootMargin: rootMargin = "0px", threshold: threshold = 0.1, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, immediate: immediate = true } = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>window1 && "IntersectionObserver" in window1);
    const targets = (0, $8bTPG.computed)(()=>{
        const _target = (0, $ef9Nn.toValue)(target);
        return (Array.isArray(_target) ? _target : [
            _target
        ]).map($cbe5e41a05e7dda8$export$c61124d3cf5adbae).filter((0, $ef9Nn.notNullish));
    });
    let cleanup = (0, $ef9Nn.noop);
    const isActive = (0, $8bTPG.ref)(immediate);
    const stopWatch = isSupported.value ? (0, $ani5R.watch)(()=>[
            targets.value,
            $cbe5e41a05e7dda8$export$c61124d3cf5adbae(root),
            isActive.value
        ], ([targets2, root2])=>{
        cleanup();
        if (!isActive.value) return;
        if (!targets2.length) return;
        const observer = new IntersectionObserver(callback, {
            root: $cbe5e41a05e7dda8$export$c61124d3cf5adbae(root2),
            rootMargin: rootMargin,
            threshold: threshold
        });
        targets2.forEach((el)=>el && observer.observe(el));
        cleanup = ()=>{
            observer.disconnect();
            cleanup = (0, $ef9Nn.noop);
        };
    }, {
        immediate: immediate,
        flush: "post"
    }) : (0, $ef9Nn.noop);
    const stop = ()=>{
        cleanup();
        stopWatch();
        isActive.value = false;
    };
    (0, $ef9Nn.tryOnScopeDispose)(stop);
    return {
        isSupported: isSupported,
        isActive: isActive,
        pause () {
            cleanup();
            isActive.value = false;
        },
        resume () {
            isActive.value = true;
        },
        stop: stop
    };
}
function $cbe5e41a05e7dda8$export$6aadc312a449609d(element, options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, scrollTarget: scrollTarget, threshold: threshold = 0 } = options;
    const elementIsVisible = (0, $8bTPG.ref)(false);
    $cbe5e41a05e7dda8$export$a7395f9832c00176(element, (intersectionObserverEntries)=>{
        let isIntersecting = elementIsVisible.value;
        let latestTime = 0;
        for (const entry of intersectionObserverEntries)if (entry.time >= latestTime) {
            latestTime = entry.time;
            isIntersecting = entry.isIntersecting;
        }
        elementIsVisible.value = isIntersecting;
    }, {
        root: scrollTarget,
        window: window1,
        threshold: threshold
    });
    return elementIsVisible;
}
const $cbe5e41a05e7dda8$var$events = /* @__PURE__ */ new Map();
function $cbe5e41a05e7dda8$export$965c4f095bc7d646(key) {
    const scope = (0, $8bTPG.getCurrentScope)();
    function on(listener) {
        var _a;
        const listeners = $cbe5e41a05e7dda8$var$events.get(key) || /* @__PURE__ */ new Set();
        listeners.add(listener);
        $cbe5e41a05e7dda8$var$events.set(key, listeners);
        const _off = ()=>off(listener);
        (_a = scope == null ? void 0 : scope.cleanups) == null || _a.push(_off);
        return _off;
    }
    function once(listener) {
        function _listener(...args) {
            off(_listener);
            listener(...args);
        }
        return on(_listener);
    }
    function off(listener) {
        const listeners = $cbe5e41a05e7dda8$var$events.get(key);
        if (!listeners) return;
        listeners.delete(listener);
        if (!listeners.size) reset();
    }
    function reset() {
        $cbe5e41a05e7dda8$var$events.delete(key);
    }
    function emit(event, payload) {
        var _a;
        (_a = $cbe5e41a05e7dda8$var$events.get(key)) == null || _a.forEach((v)=>v(event, payload));
    }
    return {
        on: on,
        once: once,
        off: off,
        emit: emit,
        reset: reset
    };
}
function $cbe5e41a05e7dda8$var$resolveNestedOptions$1(options) {
    if (options === true) return {};
    return options;
}
function $cbe5e41a05e7dda8$export$1492e5081ec8f8b5(url, events = [], options = {}) {
    const event = (0, $8bTPG.ref)(null);
    const data = (0, $8bTPG.ref)(null);
    const status = (0, $8bTPG.ref)("CONNECTING");
    const eventSource = (0, $8bTPG.ref)(null);
    const error = (0, $8bTPG.shallowRef)(null);
    const urlRef = (0, $ef9Nn.toRef)(url);
    const lastEventId = (0, $8bTPG.shallowRef)(null);
    let explicitlyClosed = false;
    let retried = 0;
    const { withCredentials: withCredentials = false, immediate: immediate = true } = options;
    const close = ()=>{
        if ((0, $ef9Nn.isClient) && eventSource.value) {
            eventSource.value.close();
            eventSource.value = null;
            status.value = "CLOSED";
            explicitlyClosed = true;
        }
    };
    const _init = ()=>{
        if (explicitlyClosed || typeof urlRef.value === "undefined") return;
        const es = new EventSource(urlRef.value, {
            withCredentials: withCredentials
        });
        status.value = "CONNECTING";
        eventSource.value = es;
        es.onopen = ()=>{
            status.value = "OPEN";
            error.value = null;
        };
        es.onerror = (e)=>{
            status.value = "CLOSED";
            error.value = e;
            if (es.readyState === 2 && !explicitlyClosed && options.autoReconnect) {
                es.close();
                const { retries: retries = -1, delay: delay = 1e3, onFailed: onFailed } = $cbe5e41a05e7dda8$var$resolveNestedOptions$1(options.autoReconnect);
                retried += 1;
                if (typeof retries === "number" && (retries < 0 || retried < retries)) setTimeout(_init, delay);
                else if (typeof retries === "function" && retries()) setTimeout(_init, delay);
                else onFailed == null || onFailed();
            }
        };
        es.onmessage = (e)=>{
            event.value = null;
            data.value = e.data;
            lastEventId.value = e.lastEventId;
        };
        for (const event_name of events)$cbe5e41a05e7dda8$export$7080b3e976bc91ab(es, event_name, (e)=>{
            event.value = event_name;
            data.value = e.data || null;
        });
    };
    const open = ()=>{
        if (!(0, $ef9Nn.isClient)) return;
        close();
        explicitlyClosed = false;
        retried = 0;
        _init();
    };
    if (immediate) (0, $ani5R.watch)(urlRef, open, {
        immediate: true
    });
    (0, $ef9Nn.tryOnScopeDispose)(close);
    return {
        eventSource: eventSource,
        event: event,
        data: data,
        status: status,
        error: error,
        open: open,
        close: close,
        lastEventId: lastEventId
    };
}
function $cbe5e41a05e7dda8$export$b649d244384df275(options = {}) {
    const { initialValue: initialValue = "" } = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>typeof window !== "undefined" && "EyeDropper" in window);
    const sRGBHex = (0, $8bTPG.ref)(initialValue);
    async function open(openOptions) {
        if (!isSupported.value) return;
        const eyeDropper = new window.EyeDropper();
        const result = await eyeDropper.open(openOptions);
        sRGBHex.value = result.sRGBHex;
        return result;
    }
    return {
        isSupported: isSupported,
        sRGBHex: sRGBHex,
        open: open
    };
}
function $cbe5e41a05e7dda8$export$1252d0179ae6292b(newIcon = null, options = {}) {
    const { baseUrl: baseUrl = "", rel: rel = "icon", document: document1 = $cbe5e41a05e7dda8$export$37990bd438d16af3 } = options;
    const favicon = (0, $ef9Nn.toRef)(newIcon);
    const applyIcon = (icon)=>{
        const elements = document1 == null ? void 0 : document1.head.querySelectorAll(`link[rel*="${rel}"]`);
        if (!elements || elements.length === 0) {
            const link = document1 == null ? void 0 : document1.createElement("link");
            if (link) {
                link.rel = rel;
                link.href = `${baseUrl}${icon}`;
                link.type = `image/${icon.split(".").pop()}`;
                document1 == null || document1.head.append(link);
            }
            return;
        }
        elements == null || elements.forEach((el)=>el.href = `${baseUrl}${icon}`);
    };
    (0, $ani5R.watch)(favicon, (i, o)=>{
        if (typeof i === "string" && i !== o) applyIcon(i);
    }, {
        immediate: true
    });
    return favicon;
}
const $cbe5e41a05e7dda8$var$payloadMapping = {
    json: "application/json",
    text: "text/plain"
};
function $cbe5e41a05e7dda8$var$isFetchOptions(obj) {
    return obj && (0, $ef9Nn.containsProp)(obj, "immediate", "refetch", "initialData", "timeout", "beforeFetch", "afterFetch", "onFetchError", "fetch", "updateDataOnError");
}
const $cbe5e41a05e7dda8$var$reAbsolute = /^(?:[a-z][a-z\d+\-.]*:)?\/\//i;
function $cbe5e41a05e7dda8$var$isAbsoluteURL(url) {
    return $cbe5e41a05e7dda8$var$reAbsolute.test(url);
}
function $cbe5e41a05e7dda8$var$headersToObject(headers) {
    if (typeof Headers !== "undefined" && headers instanceof Headers) return Object.fromEntries(headers.entries());
    return headers;
}
function $cbe5e41a05e7dda8$var$combineCallbacks(combination, ...callbacks) {
    if (combination === "overwrite") return async (ctx)=>{
        const callback = callbacks[callbacks.length - 1];
        if (callback) return {
            ...ctx,
            ...await callback(ctx)
        };
        return ctx;
    };
    else return async (ctx)=>{
        for (const callback of callbacks)if (callback) ctx = {
            ...ctx,
            ...await callback(ctx)
        };
        return ctx;
    };
}
function $cbe5e41a05e7dda8$export$3d173a42d8c9a48a(config = {}) {
    const _combination = config.combination || "chain";
    const _options = config.options || {};
    const _fetchOptions = config.fetchOptions || {};
    function useFactoryFetch(url, ...args) {
        const computedUrl = (0, $8bTPG.computed)(()=>{
            const baseUrl = (0, $ef9Nn.toValue)(config.baseUrl);
            const targetUrl = (0, $ef9Nn.toValue)(url);
            return baseUrl && !$cbe5e41a05e7dda8$var$isAbsoluteURL(targetUrl) ? $cbe5e41a05e7dda8$var$joinPaths(baseUrl, targetUrl) : targetUrl;
        });
        let options = _options;
        let fetchOptions = _fetchOptions;
        if (args.length > 0) {
            if ($cbe5e41a05e7dda8$var$isFetchOptions(args[0])) options = {
                ...options,
                ...args[0],
                beforeFetch: $cbe5e41a05e7dda8$var$combineCallbacks(_combination, _options.beforeFetch, args[0].beforeFetch),
                afterFetch: $cbe5e41a05e7dda8$var$combineCallbacks(_combination, _options.afterFetch, args[0].afterFetch),
                onFetchError: $cbe5e41a05e7dda8$var$combineCallbacks(_combination, _options.onFetchError, args[0].onFetchError)
            };
            else fetchOptions = {
                ...fetchOptions,
                ...args[0],
                headers: {
                    ...$cbe5e41a05e7dda8$var$headersToObject(fetchOptions.headers) || {},
                    ...$cbe5e41a05e7dda8$var$headersToObject(args[0].headers) || {}
                }
            };
        }
        if (args.length > 1 && $cbe5e41a05e7dda8$var$isFetchOptions(args[1])) options = {
            ...options,
            ...args[1],
            beforeFetch: $cbe5e41a05e7dda8$var$combineCallbacks(_combination, _options.beforeFetch, args[1].beforeFetch),
            afterFetch: $cbe5e41a05e7dda8$var$combineCallbacks(_combination, _options.afterFetch, args[1].afterFetch),
            onFetchError: $cbe5e41a05e7dda8$var$combineCallbacks(_combination, _options.onFetchError, args[1].onFetchError)
        };
        return $cbe5e41a05e7dda8$export$d852f5f778460fa4(computedUrl, fetchOptions, options);
    }
    return useFactoryFetch;
}
function $cbe5e41a05e7dda8$export$d852f5f778460fa4(url, ...args) {
    var _a;
    const supportsAbort = typeof AbortController === "function";
    let fetchOptions = {};
    let options = {
        immediate: true,
        refetch: false,
        timeout: 0,
        updateDataOnError: false
    };
    const config = {
        method: "GET",
        type: "text",
        payload: void 0
    };
    if (args.length > 0) {
        if ($cbe5e41a05e7dda8$var$isFetchOptions(args[0])) options = {
            ...options,
            ...args[0]
        };
        else fetchOptions = args[0];
    }
    if (args.length > 1) {
        if ($cbe5e41a05e7dda8$var$isFetchOptions(args[1])) options = {
            ...options,
            ...args[1]
        };
    }
    const { fetch: fetch = (_a = $cbe5e41a05e7dda8$export$16f8ba610718ae4a) == null ? void 0 : _a.fetch, initialData: initialData, timeout: timeout } = options;
    const responseEvent = (0, $ef9Nn.createEventHook)();
    const errorEvent = (0, $ef9Nn.createEventHook)();
    const finallyEvent = (0, $ef9Nn.createEventHook)();
    const isFinished = (0, $8bTPG.ref)(false);
    const isFetching = (0, $8bTPG.ref)(false);
    const aborted = (0, $8bTPG.ref)(false);
    const statusCode = (0, $8bTPG.ref)(null);
    const response = (0, $8bTPG.shallowRef)(null);
    const error = (0, $8bTPG.shallowRef)(null);
    const data = (0, $8bTPG.shallowRef)(initialData || null);
    const canAbort = (0, $8bTPG.computed)(()=>supportsAbort && isFetching.value);
    let controller;
    let timer;
    const abort = ()=>{
        if (supportsAbort) {
            controller == null || controller.abort();
            controller = new AbortController();
            controller.signal.onabort = ()=>aborted.value = true;
            fetchOptions = {
                ...fetchOptions,
                signal: controller.signal
            };
        }
    };
    const loading = (isLoading)=>{
        isFetching.value = isLoading;
        isFinished.value = !isLoading;
    };
    if (timeout) timer = (0, $ef9Nn.useTimeoutFn)(abort, timeout, {
        immediate: false
    });
    let executeCounter = 0;
    const execute = async (throwOnFailed = false)=>{
        var _a2, _b;
        abort();
        loading(true);
        error.value = null;
        statusCode.value = null;
        aborted.value = false;
        executeCounter += 1;
        const currentExecuteCounter = executeCounter;
        const defaultFetchOptions = {
            method: config.method,
            headers: {}
        };
        if (config.payload) {
            const headers = $cbe5e41a05e7dda8$var$headersToObject(defaultFetchOptions.headers);
            const payload = (0, $ef9Nn.toValue)(config.payload);
            if (!config.payloadType && payload && Object.getPrototypeOf(payload) === Object.prototype && !(payload instanceof FormData)) config.payloadType = "json";
            if (config.payloadType) headers["Content-Type"] = (_a2 = $cbe5e41a05e7dda8$var$payloadMapping[config.payloadType]) != null ? _a2 : config.payloadType;
            defaultFetchOptions.body = config.payloadType === "json" ? JSON.stringify(payload) : payload;
        }
        let isCanceled = false;
        const context = {
            url: (0, $ef9Nn.toValue)(url),
            options: {
                ...defaultFetchOptions,
                ...fetchOptions
            },
            cancel: ()=>{
                isCanceled = true;
            }
        };
        if (options.beforeFetch) Object.assign(context, await options.beforeFetch(context));
        if (isCanceled || !fetch) {
            loading(false);
            return Promise.resolve(null);
        }
        let responseData = null;
        if (timer) timer.start();
        return fetch(context.url, {
            ...defaultFetchOptions,
            ...context.options,
            headers: {
                ...$cbe5e41a05e7dda8$var$headersToObject(defaultFetchOptions.headers),
                ...$cbe5e41a05e7dda8$var$headersToObject((_b = context.options) == null ? void 0 : _b.headers)
            }
        }).then(async (fetchResponse)=>{
            response.value = fetchResponse;
            statusCode.value = fetchResponse.status;
            responseData = await fetchResponse.clone()[config.type]();
            if (!fetchResponse.ok) {
                data.value = initialData || null;
                throw new Error(fetchResponse.statusText);
            }
            if (options.afterFetch) ({ data: responseData } = await options.afterFetch({
                data: responseData,
                response: fetchResponse
            }));
            data.value = responseData;
            responseEvent.trigger(fetchResponse);
            return fetchResponse;
        }).catch(async (fetchError)=>{
            let errorData = fetchError.message || fetchError.name;
            if (options.onFetchError) ({ error: errorData, data: responseData } = await options.onFetchError({
                data: responseData,
                error: fetchError,
                response: response.value
            }));
            error.value = errorData;
            if (options.updateDataOnError) data.value = responseData;
            errorEvent.trigger(fetchError);
            if (throwOnFailed) throw fetchError;
            return null;
        }).finally(()=>{
            if (currentExecuteCounter === executeCounter) loading(false);
            if (timer) timer.stop();
            finallyEvent.trigger(null);
        });
    };
    const refetch = (0, $ef9Nn.toRef)(options.refetch);
    (0, $ani5R.watch)([
        refetch,
        (0, $ef9Nn.toRef)(url)
    ], ([refetch2])=>refetch2 && execute(), {
        deep: true
    });
    const shell = {
        isFinished: (0, $8bTPG.readonly)(isFinished),
        isFetching: (0, $8bTPG.readonly)(isFetching),
        statusCode: statusCode,
        response: response,
        error: error,
        data: data,
        canAbort: canAbort,
        aborted: aborted,
        abort: abort,
        execute: execute,
        onFetchResponse: responseEvent.on,
        onFetchError: errorEvent.on,
        onFetchFinally: finallyEvent.on,
        // method
        get: setMethod("GET"),
        put: setMethod("PUT"),
        post: setMethod("POST"),
        delete: setMethod("DELETE"),
        patch: setMethod("PATCH"),
        head: setMethod("HEAD"),
        options: setMethod("OPTIONS"),
        // type
        json: setType("json"),
        text: setType("text"),
        blob: setType("blob"),
        arrayBuffer: setType("arrayBuffer"),
        formData: setType("formData")
    };
    function setMethod(method) {
        return (payload, payloadType)=>{
            if (!isFetching.value) {
                config.method = method;
                config.payload = payload;
                config.payloadType = payloadType;
                if ((0, $8bTPG.isRef)(config.payload)) (0, $ani5R.watch)([
                    refetch,
                    (0, $ef9Nn.toRef)(config.payload)
                ], ([refetch2])=>refetch2 && execute(), {
                    deep: true
                });
                return {
                    ...shell,
                    then (onFulfilled, onRejected) {
                        return waitUntilFinished().then(onFulfilled, onRejected);
                    }
                };
            }
            return void 0;
        };
    }
    function waitUntilFinished() {
        return new Promise((resolve, reject)=>{
            (0, $ef9Nn.until)(isFinished).toBe(true).then(()=>resolve(shell)).catch((error2)=>reject(error2));
        });
    }
    function setType(type) {
        return ()=>{
            if (!isFetching.value) {
                config.type = type;
                return {
                    ...shell,
                    then (onFulfilled, onRejected) {
                        return waitUntilFinished().then(onFulfilled, onRejected);
                    }
                };
            }
            return void 0;
        };
    }
    if (options.immediate) Promise.resolve().then(()=>execute());
    return {
        ...shell,
        then (onFulfilled, onRejected) {
            return waitUntilFinished().then(onFulfilled, onRejected);
        }
    };
}
function $cbe5e41a05e7dda8$var$joinPaths(start, end) {
    if (!start.endsWith("/") && !end.startsWith("/")) return `${start}/${end}`;
    return `${start}${end}`;
}
const $cbe5e41a05e7dda8$var$DEFAULT_OPTIONS = {
    multiple: true,
    accept: "*",
    reset: false,
    directory: false
};
function $cbe5e41a05e7dda8$export$46ab9fa3f3719597(options = {}) {
    const { document: document1 = $cbe5e41a05e7dda8$export$37990bd438d16af3 } = options;
    const files = (0, $8bTPG.ref)(null);
    const { on: onChange, trigger: trigger } = (0, $ef9Nn.createEventHook)();
    let input;
    if (document1) {
        input = document1.createElement("input");
        input.type = "file";
        input.onchange = (event)=>{
            const result = event.target;
            files.value = result.files;
            trigger(files.value);
        };
    }
    const reset = ()=>{
        files.value = null;
        if (input && input.value) {
            input.value = "";
            trigger(null);
        }
    };
    const open = (localOptions)=>{
        if (!input) return;
        const _options = {
            ...$cbe5e41a05e7dda8$var$DEFAULT_OPTIONS,
            ...options,
            ...localOptions
        };
        input.multiple = _options.multiple;
        input.accept = _options.accept;
        input.webkitdirectory = _options.directory;
        if ((0, $ef9Nn.hasOwn)(_options, "capture")) input.capture = _options.capture;
        if (_options.reset) reset();
        input.click();
    };
    return {
        files: (0, $8bTPG.readonly)(files),
        open: open,
        reset: reset,
        onChange: onChange
    };
}
function $cbe5e41a05e7dda8$export$2af170812ec5e71(options = {}) {
    const { window: _window = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, dataType: dataType = "Text" } = options;
    const window1 = _window;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>window1 && "showSaveFilePicker" in window1 && "showOpenFilePicker" in window1);
    const fileHandle = (0, $8bTPG.ref)();
    const data = (0, $8bTPG.ref)();
    const file = (0, $8bTPG.ref)();
    const fileName = (0, $8bTPG.computed)(()=>{
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.name) != null ? _b : "";
    });
    const fileMIME = (0, $8bTPG.computed)(()=>{
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.type) != null ? _b : "";
    });
    const fileSize = (0, $8bTPG.computed)(()=>{
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.size) != null ? _b : 0;
    });
    const fileLastModified = (0, $8bTPG.computed)(()=>{
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.lastModified) != null ? _b : 0;
    });
    async function open(_options = {}) {
        if (!isSupported.value) return;
        const [handle] = await window1.showOpenFilePicker({
            ...(0, $ef9Nn.toValue)(options),
            ..._options
        });
        fileHandle.value = handle;
        await updateData();
    }
    async function create(_options = {}) {
        if (!isSupported.value) return;
        fileHandle.value = await window1.showSaveFilePicker({
            ...options,
            ..._options
        });
        data.value = void 0;
        await updateData();
    }
    async function save(_options = {}) {
        if (!isSupported.value) return;
        if (!fileHandle.value) return saveAs(_options);
        if (data.value) {
            const writableStream = await fileHandle.value.createWritable();
            await writableStream.write(data.value);
            await writableStream.close();
        }
        await updateFile();
    }
    async function saveAs(_options = {}) {
        if (!isSupported.value) return;
        fileHandle.value = await window1.showSaveFilePicker({
            ...options,
            ..._options
        });
        if (data.value) {
            const writableStream = await fileHandle.value.createWritable();
            await writableStream.write(data.value);
            await writableStream.close();
        }
        await updateFile();
    }
    async function updateFile() {
        var _a;
        file.value = await ((_a = fileHandle.value) == null ? void 0 : _a.getFile());
    }
    async function updateData() {
        var _a, _b;
        await updateFile();
        const type = (0, $ef9Nn.toValue)(dataType);
        if (type === "Text") data.value = await ((_a = file.value) == null ? void 0 : _a.text());
        else if (type === "ArrayBuffer") data.value = await ((_b = file.value) == null ? void 0 : _b.arrayBuffer());
        else if (type === "Blob") data.value = file.value;
    }
    (0, $ani5R.watch)(()=>(0, $ef9Nn.toValue)(dataType), updateData);
    return {
        isSupported: isSupported,
        data: data,
        file: file,
        fileName: fileName,
        fileMIME: fileMIME,
        fileSize: fileSize,
        fileLastModified: fileLastModified,
        open: open,
        create: create,
        save: save,
        saveAs: saveAs,
        updateData: updateData
    };
}
function $cbe5e41a05e7dda8$export$f8168d8dd8fd66e6(target, options = {}) {
    const { initialValue: initialValue = false, focusVisible: focusVisible = false, preventScroll: preventScroll = false } = options;
    const innerFocused = (0, $8bTPG.ref)(false);
    const targetElement = (0, $8bTPG.computed)(()=>$cbe5e41a05e7dda8$export$c61124d3cf5adbae(target));
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(targetElement, "focus", (event)=>{
        var _a, _b;
        if (!focusVisible || ((_b = (_a = event.target).matches) == null ? void 0 : _b.call(_a, ":focus-visible"))) innerFocused.value = true;
    });
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(targetElement, "blur", ()=>innerFocused.value = false);
    const focused = (0, $8bTPG.computed)({
        get: ()=>innerFocused.value,
        set (value) {
            var _a, _b;
            if (!value && innerFocused.value) (_a = targetElement.value) == null || _a.blur();
            else if (value && !innerFocused.value) (_b = targetElement.value) == null || _b.focus({
                preventScroll: preventScroll
            });
        }
    });
    (0, $ani5R.watch)(targetElement, ()=>{
        focused.value = initialValue;
    }, {
        immediate: true,
        flush: "post"
    });
    return {
        focused: focused
    };
}
function $cbe5e41a05e7dda8$export$420e68273165f4ec(target, options = {}) {
    const activeElement = $cbe5e41a05e7dda8$export$4e1875a4b2b1434f(options);
    const targetElement = (0, $8bTPG.computed)(()=>$cbe5e41a05e7dda8$export$c61124d3cf5adbae(target));
    const focused = (0, $8bTPG.computed)(()=>targetElement.value && activeElement.value ? targetElement.value.contains(activeElement.value) : false);
    return {
        focused: focused
    };
}
function $cbe5e41a05e7dda8$export$ab5229fe4b5ea5d0(options) {
    var _a;
    const fps = (0, $8bTPG.ref)(0);
    if (typeof performance === "undefined") return fps;
    const every = (_a = options == null ? void 0 : options.every) != null ? _a : 10;
    let last = performance.now();
    let ticks = 0;
    $cbe5e41a05e7dda8$export$13251e0fc79284e(()=>{
        ticks += 1;
        if (ticks >= every) {
            const now = performance.now();
            const diff = now - last;
            fps.value = Math.round(1e3 / (diff / ticks));
            last = now;
            ticks = 0;
        }
    });
    return fps;
}
const $cbe5e41a05e7dda8$var$eventHandlers = [
    "fullscreenchange",
    "webkitfullscreenchange",
    "webkitendfullscreen",
    "mozfullscreenchange",
    "MSFullscreenChange"
];
function $cbe5e41a05e7dda8$export$873ff9d3a24fe223(target, options = {}) {
    const { document: document1 = $cbe5e41a05e7dda8$export$37990bd438d16af3, autoExit: autoExit = false } = options;
    const targetRef = (0, $8bTPG.computed)(()=>{
        var _a;
        return (_a = $cbe5e41a05e7dda8$export$c61124d3cf5adbae(target)) != null ? _a : document1 == null ? void 0 : document1.querySelector("html");
    });
    const isFullscreen = (0, $8bTPG.ref)(false);
    const requestMethod = (0, $8bTPG.computed)(()=>{
        return [
            "requestFullscreen",
            "webkitRequestFullscreen",
            "webkitEnterFullscreen",
            "webkitEnterFullScreen",
            "webkitRequestFullScreen",
            "mozRequestFullScreen",
            "msRequestFullscreen"
        ].find((m)=>document1 && m in document1 || targetRef.value && m in targetRef.value);
    });
    const exitMethod = (0, $8bTPG.computed)(()=>{
        return [
            "exitFullscreen",
            "webkitExitFullscreen",
            "webkitExitFullScreen",
            "webkitCancelFullScreen",
            "mozCancelFullScreen",
            "msExitFullscreen"
        ].find((m)=>document1 && m in document1 || targetRef.value && m in targetRef.value);
    });
    const fullscreenEnabled = (0, $8bTPG.computed)(()=>{
        return [
            "fullScreen",
            "webkitIsFullScreen",
            "webkitDisplayingFullscreen",
            "mozFullScreen",
            "msFullscreenElement"
        ].find((m)=>document1 && m in document1 || targetRef.value && m in targetRef.value);
    });
    const fullscreenElementMethod = [
        "fullscreenElement",
        "webkitFullscreenElement",
        "mozFullScreenElement",
        "msFullscreenElement"
    ].find((m)=>document1 && m in document1);
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>targetRef.value && document1 && requestMethod.value !== void 0 && exitMethod.value !== void 0 && fullscreenEnabled.value !== void 0);
    const isCurrentElementFullScreen = ()=>{
        if (fullscreenElementMethod) return (document1 == null ? void 0 : document1[fullscreenElementMethod]) === targetRef.value;
        return false;
    };
    const isElementFullScreen = ()=>{
        if (fullscreenEnabled.value) {
            if (document1 && document1[fullscreenEnabled.value] != null) return document1[fullscreenEnabled.value];
            else {
                const target2 = targetRef.value;
                if ((target2 == null ? void 0 : target2[fullscreenEnabled.value]) != null) return Boolean(target2[fullscreenEnabled.value]);
            }
        }
        return false;
    };
    async function exit() {
        if (!isSupported.value || !isFullscreen.value) return;
        if (exitMethod.value) {
            if ((document1 == null ? void 0 : document1[exitMethod.value]) != null) await document1[exitMethod.value]();
            else {
                const target2 = targetRef.value;
                if ((target2 == null ? void 0 : target2[exitMethod.value]) != null) await target2[exitMethod.value]();
            }
        }
        isFullscreen.value = false;
    }
    async function enter() {
        if (!isSupported.value || isFullscreen.value) return;
        if (isElementFullScreen()) await exit();
        const target2 = targetRef.value;
        if (requestMethod.value && (target2 == null ? void 0 : target2[requestMethod.value]) != null) {
            await target2[requestMethod.value]();
            isFullscreen.value = true;
        }
    }
    async function toggle() {
        await (isFullscreen.value ? exit() : enter());
    }
    const handlerCallback = ()=>{
        const isElementFullScreenValue = isElementFullScreen();
        if (!isElementFullScreenValue || isElementFullScreenValue && isCurrentElementFullScreen()) isFullscreen.value = isElementFullScreenValue;
    };
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(document1, $cbe5e41a05e7dda8$var$eventHandlers, handlerCallback, false);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(()=>$cbe5e41a05e7dda8$export$c61124d3cf5adbae(targetRef), $cbe5e41a05e7dda8$var$eventHandlers, handlerCallback, false);
    if (autoExit) (0, $ef9Nn.tryOnScopeDispose)(exit);
    return {
        isSupported: isSupported,
        isFullscreen: isFullscreen,
        enter: enter,
        exit: exit,
        toggle: toggle
    };
}
function $cbe5e41a05e7dda8$export$9688e62b453d9aed(gamepad) {
    return (0, $8bTPG.computed)(()=>{
        if (gamepad.value) return {
            buttons: {
                a: gamepad.value.buttons[0],
                b: gamepad.value.buttons[1],
                x: gamepad.value.buttons[2],
                y: gamepad.value.buttons[3]
            },
            bumper: {
                left: gamepad.value.buttons[4],
                right: gamepad.value.buttons[5]
            },
            triggers: {
                left: gamepad.value.buttons[6],
                right: gamepad.value.buttons[7]
            },
            stick: {
                left: {
                    horizontal: gamepad.value.axes[0],
                    vertical: gamepad.value.axes[1],
                    button: gamepad.value.buttons[10]
                },
                right: {
                    horizontal: gamepad.value.axes[2],
                    vertical: gamepad.value.axes[3],
                    button: gamepad.value.buttons[11]
                }
            },
            dpad: {
                up: gamepad.value.buttons[12],
                down: gamepad.value.buttons[13],
                left: gamepad.value.buttons[14],
                right: gamepad.value.buttons[15]
            },
            back: gamepad.value.buttons[8],
            start: gamepad.value.buttons[9]
        };
        return null;
    });
}
function $cbe5e41a05e7dda8$export$467a9d70edd1fd69(options = {}) {
    const { navigator: navigator = $cbe5e41a05e7dda8$export$eade61489f57e3fc } = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>navigator && "getGamepads" in navigator);
    const gamepads = (0, $8bTPG.ref)([]);
    const onConnectedHook = (0, $ef9Nn.createEventHook)();
    const onDisconnectedHook = (0, $ef9Nn.createEventHook)();
    const stateFromGamepad = (gamepad)=>{
        const hapticActuators = [];
        const vibrationActuator = "vibrationActuator" in gamepad ? gamepad.vibrationActuator : null;
        if (vibrationActuator) hapticActuators.push(vibrationActuator);
        if (gamepad.hapticActuators) hapticActuators.push(...gamepad.hapticActuators);
        return {
            id: gamepad.id,
            index: gamepad.index,
            connected: gamepad.connected,
            mapping: gamepad.mapping,
            timestamp: gamepad.timestamp,
            vibrationActuator: gamepad.vibrationActuator,
            hapticActuators: hapticActuators,
            axes: gamepad.axes.map((axes)=>axes),
            buttons: gamepad.buttons.map((button)=>({
                    pressed: button.pressed,
                    touched: button.touched,
                    value: button.value
                }))
        };
    };
    const updateGamepadState = ()=>{
        const _gamepads = (navigator == null ? void 0 : navigator.getGamepads()) || [];
        for (const gamepad of _gamepads)if (gamepad && gamepads.value[gamepad.index]) gamepads.value[gamepad.index] = stateFromGamepad(gamepad);
    };
    const { isActive: isActive, pause: pause, resume: resume } = $cbe5e41a05e7dda8$export$13251e0fc79284e(updateGamepadState);
    const onGamepadConnected = (gamepad)=>{
        if (!gamepads.value.some(({ index: index })=>index === gamepad.index)) {
            gamepads.value.push(stateFromGamepad(gamepad));
            onConnectedHook.trigger(gamepad.index);
        }
        resume();
    };
    const onGamepadDisconnected = (gamepad)=>{
        gamepads.value = gamepads.value.filter((x)=>x.index !== gamepad.index);
        onDisconnectedHook.trigger(gamepad.index);
    };
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab("gamepadconnected", (e)=>onGamepadConnected(e.gamepad));
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab("gamepaddisconnected", (e)=>onGamepadDisconnected(e.gamepad));
    (0, $ef9Nn.tryOnMounted)(()=>{
        const _gamepads = (navigator == null ? void 0 : navigator.getGamepads()) || [];
        for (const gamepad of _gamepads)if (gamepad && gamepads.value[gamepad.index]) onGamepadConnected(gamepad);
    });
    pause();
    return {
        isSupported: isSupported,
        onConnected: onConnectedHook.on,
        onDisconnected: onDisconnectedHook.on,
        gamepads: gamepads,
        pause: pause,
        resume: resume,
        isActive: isActive
    };
}
function $cbe5e41a05e7dda8$export$8c959c84e890409a(options = {}) {
    const { enableHighAccuracy: enableHighAccuracy = true, maximumAge: maximumAge = 3e4, timeout: timeout = 27e3, navigator: navigator = $cbe5e41a05e7dda8$export$eade61489f57e3fc, immediate: immediate = true } = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>navigator && "geolocation" in navigator);
    const locatedAt = (0, $8bTPG.ref)(null);
    const error = (0, $8bTPG.shallowRef)(null);
    const coords = (0, $8bTPG.ref)({
        accuracy: 0,
        latitude: Number.POSITIVE_INFINITY,
        longitude: Number.POSITIVE_INFINITY,
        altitude: null,
        altitudeAccuracy: null,
        heading: null,
        speed: null
    });
    function updatePosition(position) {
        locatedAt.value = position.timestamp;
        coords.value = position.coords;
        error.value = null;
    }
    let watcher;
    function resume() {
        if (isSupported.value) watcher = navigator.geolocation.watchPosition(updatePosition, (err)=>error.value = err, {
            enableHighAccuracy: enableHighAccuracy,
            maximumAge: maximumAge,
            timeout: timeout
        });
    }
    if (immediate) resume();
    function pause() {
        if (watcher && navigator) navigator.geolocation.clearWatch(watcher);
    }
    (0, $ef9Nn.tryOnScopeDispose)(()=>{
        pause();
    });
    return {
        isSupported: isSupported,
        coords: coords,
        locatedAt: locatedAt,
        error: error,
        resume: resume,
        pause: pause
    };
}
const $cbe5e41a05e7dda8$var$defaultEvents$1 = [
    "mousemove",
    "mousedown",
    "resize",
    "keydown",
    "touchstart",
    "wheel"
];
const $cbe5e41a05e7dda8$var$oneMinute = 6e4;
function $cbe5e41a05e7dda8$export$4fed27c116de10cb(timeout = $cbe5e41a05e7dda8$var$oneMinute, options = {}) {
    const { initialState: initialState = false, listenForVisibilityChange: listenForVisibilityChange = true, events: events = $cbe5e41a05e7dda8$var$defaultEvents$1, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, eventFilter: eventFilter = (0, $ef9Nn.throttleFilter)(50) } = options;
    const idle = (0, $8bTPG.ref)(initialState);
    const lastActive = (0, $8bTPG.ref)((0, $ef9Nn.timestamp)());
    let timer;
    const reset = ()=>{
        idle.value = false;
        clearTimeout(timer);
        timer = setTimeout(()=>idle.value = true, timeout);
    };
    const onEvent = (0, $ef9Nn.createFilterWrapper)(eventFilter, ()=>{
        lastActive.value = (0, $ef9Nn.timestamp)();
        reset();
    });
    if (window1) {
        const document1 = window1.document;
        for (const event of events)$cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, event, onEvent, {
            passive: true
        });
        if (listenForVisibilityChange) $cbe5e41a05e7dda8$export$7080b3e976bc91ab(document1, "visibilitychange", ()=>{
            if (!document1.hidden) onEvent();
        });
        reset();
    }
    return {
        idle: idle,
        lastActive: lastActive,
        reset: reset
    };
}
async function $cbe5e41a05e7dda8$var$loadImage(options) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        const { src: src, srcset: srcset, sizes: sizes, class: clazz, loading: loading, crossorigin: crossorigin, referrerPolicy: referrerPolicy } = options;
        img.src = src;
        if (srcset) img.srcset = srcset;
        if (sizes) img.sizes = sizes;
        if (clazz) img.className = clazz;
        if (loading) img.loading = loading;
        if (crossorigin) img.crossOrigin = crossorigin;
        if (referrerPolicy) img.referrerPolicy = referrerPolicy;
        img.onload = ()=>resolve(img);
        img.onerror = reject;
    });
}
function $cbe5e41a05e7dda8$export$e4da99f09da8b739(options, asyncStateOptions = {}) {
    const state = $cbe5e41a05e7dda8$export$d94717ae0e8aa8b(()=>$cbe5e41a05e7dda8$var$loadImage((0, $ef9Nn.toValue)(options)), void 0, {
        resetOnExecute: true,
        ...asyncStateOptions
    });
    (0, $ani5R.watch)(()=>(0, $ef9Nn.toValue)(options), ()=>state.execute(asyncStateOptions.delay), {
        deep: true
    });
    return state;
}
const $cbe5e41a05e7dda8$var$ARRIVED_STATE_THRESHOLD_PIXELS = 1;
function $cbe5e41a05e7dda8$export$d928051c8cd740b(element, options = {}) {
    const { throttle: throttle = 0, idle: idle = 200, onStop: onStop = (0, $ef9Nn.noop), onScroll: onScroll = (0, $ef9Nn.noop), offset: offset = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    }, eventListenerOptions: eventListenerOptions = {
        capture: false,
        passive: true
    }, behavior: behavior = "auto", window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, onError: onError = (e)=>{
        console.error(e);
    } } = options;
    const internalX = (0, $8bTPG.ref)(0);
    const internalY = (0, $8bTPG.ref)(0);
    const x = (0, $8bTPG.computed)({
        get () {
            return internalX.value;
        },
        set (x2) {
            scrollTo1(x2, void 0);
        }
    });
    const y = (0, $8bTPG.computed)({
        get () {
            return internalY.value;
        },
        set (y2) {
            scrollTo1(void 0, y2);
        }
    });
    function scrollTo1(_x, _y) {
        var _a, _b, _c, _d;
        if (!window1) return;
        const _element = (0, $ef9Nn.toValue)(element);
        if (!_element) return;
        (_c = _element instanceof Document ? window1.document.body : _element) == null || _c.scrollTo({
            top: (_a = (0, $ef9Nn.toValue)(_y)) != null ? _a : y.value,
            left: (_b = (0, $ef9Nn.toValue)(_x)) != null ? _b : x.value,
            behavior: (0, $ef9Nn.toValue)(behavior)
        });
        const scrollContainer = ((_d = _element == null ? void 0 : _element.document) == null ? void 0 : _d.documentElement) || (_element == null ? void 0 : _element.documentElement) || _element;
        if (x != null) internalX.value = scrollContainer.scrollLeft;
        if (y != null) internalY.value = scrollContainer.scrollTop;
    }
    const isScrolling = (0, $8bTPG.ref)(false);
    const arrivedState = (0, $8bTPG.reactive)({
        left: true,
        right: false,
        top: true,
        bottom: false
    });
    const directions = (0, $8bTPG.reactive)({
        left: false,
        right: false,
        top: false,
        bottom: false
    });
    const onScrollEnd = (e)=>{
        if (!isScrolling.value) return;
        isScrolling.value = false;
        directions.left = false;
        directions.right = false;
        directions.top = false;
        directions.bottom = false;
        onStop(e);
    };
    const onScrollEndDebounced = (0, $ef9Nn.useDebounceFn)(onScrollEnd, throttle + idle);
    const setArrivedState = (target)=>{
        var _a;
        if (!window1) return;
        const el = ((_a = target == null ? void 0 : target.document) == null ? void 0 : _a.documentElement) || (target == null ? void 0 : target.documentElement) || $cbe5e41a05e7dda8$export$c61124d3cf5adbae(target);
        const { display: display, flexDirection: flexDirection } = getComputedStyle(el);
        const scrollLeft = el.scrollLeft;
        directions.left = scrollLeft < internalX.value;
        directions.right = scrollLeft > internalX.value;
        const left = Math.abs(scrollLeft) <= (offset.left || 0);
        const right = Math.abs(scrollLeft) + el.clientWidth >= el.scrollWidth - (offset.right || 0) - $cbe5e41a05e7dda8$var$ARRIVED_STATE_THRESHOLD_PIXELS;
        if (display === "flex" && flexDirection === "row-reverse") {
            arrivedState.left = right;
            arrivedState.right = left;
        } else {
            arrivedState.left = left;
            arrivedState.right = right;
        }
        internalX.value = scrollLeft;
        let scrollTop = el.scrollTop;
        if (target === window1.document && !scrollTop) scrollTop = window1.document.body.scrollTop;
        directions.top = scrollTop < internalY.value;
        directions.bottom = scrollTop > internalY.value;
        const top = Math.abs(scrollTop) <= (offset.top || 0);
        const bottom = Math.abs(scrollTop) + el.clientHeight >= el.scrollHeight - (offset.bottom || 0) - $cbe5e41a05e7dda8$var$ARRIVED_STATE_THRESHOLD_PIXELS;
        if (display === "flex" && flexDirection === "column-reverse") {
            arrivedState.top = bottom;
            arrivedState.bottom = top;
        } else {
            arrivedState.top = top;
            arrivedState.bottom = bottom;
        }
        internalY.value = scrollTop;
    };
    const onScrollHandler = (e)=>{
        var _a;
        if (!window1) return;
        const eventTarget = (_a = e.target.documentElement) != null ? _a : e.target;
        setArrivedState(eventTarget);
        isScrolling.value = true;
        onScrollEndDebounced(e);
        onScroll(e);
    };
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(element, "scroll", throttle ? (0, $ef9Nn.useThrottleFn)(onScrollHandler, throttle, true, false) : onScrollHandler, eventListenerOptions);
    (0, $ef9Nn.tryOnMounted)(()=>{
        try {
            const _element = (0, $ef9Nn.toValue)(element);
            if (!_element) return;
            setArrivedState(_element);
        } catch (e) {
            onError(e);
        }
    });
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(element, "scrollend", onScrollEnd, eventListenerOptions);
    return {
        x: x,
        y: y,
        isScrolling: isScrolling,
        arrivedState: arrivedState,
        directions: directions,
        measure () {
            const _element = (0, $ef9Nn.toValue)(element);
            if (window1 && _element) setArrivedState(_element);
        }
    };
}
function $cbe5e41a05e7dda8$var$resolveElement(el) {
    if (typeof Window !== "undefined" && el instanceof Window) return el.document.documentElement;
    if (typeof Document !== "undefined" && el instanceof Document) return el.documentElement;
    return el;
}
function $cbe5e41a05e7dda8$export$a973cef5093a8d22(element, onLoadMore, options = {}) {
    var _a;
    const { direction: direction = "bottom", interval: interval = 100, canLoadMore: canLoadMore = ()=>true } = options;
    const state = (0, $8bTPG.reactive)($cbe5e41a05e7dda8$export$d928051c8cd740b(element, {
        ...options,
        offset: {
            [direction]: (_a = options.distance) != null ? _a : 0,
            ...options.offset
        }
    }));
    const promise = (0, $8bTPG.ref)();
    const isLoading = (0, $8bTPG.computed)(()=>!!promise.value);
    const observedElement = (0, $8bTPG.computed)(()=>{
        return $cbe5e41a05e7dda8$var$resolveElement((0, $ef9Nn.toValue)(element));
    });
    const isElementVisible = $cbe5e41a05e7dda8$export$6aadc312a449609d(observedElement);
    function checkAndLoad() {
        state.measure();
        if (!observedElement.value || !isElementVisible.value || !canLoadMore(observedElement.value)) return;
        const { scrollHeight: scrollHeight, clientHeight: clientHeight, scrollWidth: scrollWidth, clientWidth: clientWidth } = observedElement.value;
        const isNarrower = direction === "bottom" || direction === "top" ? scrollHeight <= clientHeight : scrollWidth <= clientWidth;
        if (state.arrivedState[direction] || isNarrower) {
            if (!promise.value) promise.value = Promise.all([
                onLoadMore(state),
                new Promise((resolve)=>setTimeout(resolve, interval))
            ]).finally(()=>{
                promise.value = null;
                (0, $ani5R.nextTick)(()=>checkAndLoad());
            });
        }
    }
    (0, $ani5R.watch)(()=>[
            state.arrivedState[direction],
            isElementVisible.value
        ], checkAndLoad, {
        immediate: true
    });
    return {
        isLoading: isLoading
    };
}
const $cbe5e41a05e7dda8$var$defaultEvents = [
    "mousedown",
    "mouseup",
    "keydown",
    "keyup"
];
function $cbe5e41a05e7dda8$export$2056835662f651c4(modifier, options = {}) {
    const { events: events = $cbe5e41a05e7dda8$var$defaultEvents, document: document1 = $cbe5e41a05e7dda8$export$37990bd438d16af3, initial: initial = null } = options;
    const state = (0, $8bTPG.ref)(initial);
    if (document1) events.forEach((listenerEvent)=>{
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(document1, listenerEvent, (evt)=>{
            if (typeof evt.getModifierState === "function") state.value = evt.getModifierState(modifier);
        });
    });
    return state;
}
function $cbe5e41a05e7dda8$export$86e2cef2561044ac(key, initialValue, options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    return $cbe5e41a05e7dda8$export$95809329f49ea9f9(key, initialValue, window1 == null ? void 0 : window1.localStorage, options);
}
const $cbe5e41a05e7dda8$export$73a678c1574e03a3 = {
    ctrl: "control",
    command: "meta",
    cmd: "meta",
    option: "alt",
    up: "arrowup",
    down: "arrowdown",
    left: "arrowleft",
    right: "arrowright"
};
function $cbe5e41a05e7dda8$export$8805bf46e5b1d2e5(options = {}) {
    const { reactive: useReactive = false, target: target = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, aliasMap: aliasMap = $cbe5e41a05e7dda8$export$73a678c1574e03a3, passive: passive = true, onEventFired: onEventFired = (0, $ef9Nn.noop) } = options;
    const current = (0, $8bTPG.reactive)(/* @__PURE__ */ new Set());
    const obj = {
        toJSON () {
            return {};
        },
        current: current
    };
    const refs = useReactive ? (0, $8bTPG.reactive)(obj) : obj;
    const metaDeps = /* @__PURE__ */ new Set();
    const usedKeys = /* @__PURE__ */ new Set();
    function setRefs(key, value) {
        if (key in refs) {
            if (useReactive) refs[key] = value;
            else refs[key].value = value;
        }
    }
    function reset() {
        current.clear();
        for (const key of usedKeys)setRefs(key, false);
    }
    function updateRefs(e, value) {
        var _a, _b;
        const key = (_a = e.key) == null ? void 0 : _a.toLowerCase();
        const code = (_b = e.code) == null ? void 0 : _b.toLowerCase();
        const values = [
            code,
            key
        ].filter(Boolean);
        if (key) {
            if (value) current.add(key);
            else current.delete(key);
        }
        for (const key2 of values){
            usedKeys.add(key2);
            setRefs(key2, value);
        }
        if (key === "meta" && !value) {
            metaDeps.forEach((key2)=>{
                current.delete(key2);
                setRefs(key2, false);
            });
            metaDeps.clear();
        } else if (typeof e.getModifierState === "function" && e.getModifierState("Meta") && value) [
            ...current,
            ...values
        ].forEach((key2)=>metaDeps.add(key2));
    }
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "keydown", (e)=>{
        updateRefs(e, true);
        return onEventFired(e);
    }, {
        passive: passive
    });
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "keyup", (e)=>{
        updateRefs(e, false);
        return onEventFired(e);
    }, {
        passive: passive
    });
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab("blur", reset, {
        passive: true
    });
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab("focus", reset, {
        passive: true
    });
    const proxy = new Proxy(refs, {
        get (target2, prop, rec) {
            if (typeof prop !== "string") return Reflect.get(target2, prop, rec);
            prop = prop.toLowerCase();
            if (prop in aliasMap) prop = aliasMap[prop];
            if (!(prop in refs)) {
                if (/[+_-]/.test(prop)) {
                    const keys = prop.split(/[+_-]/g).map((i)=>i.trim());
                    refs[prop] = (0, $8bTPG.computed)(()=>keys.every((key)=>(0, $ef9Nn.toValue)(proxy[key])));
                } else refs[prop] = (0, $8bTPG.ref)(false);
            }
            const r = Reflect.get(target2, prop, rec);
            return useReactive ? (0, $ef9Nn.toValue)(r) : r;
        }
    });
    return proxy;
}
function $cbe5e41a05e7dda8$var$usingElRef(source, cb) {
    if ((0, $ef9Nn.toValue)(source)) cb((0, $ef9Nn.toValue)(source));
}
function $cbe5e41a05e7dda8$var$timeRangeToArray(timeRanges) {
    let ranges = [];
    for(let i = 0; i < timeRanges.length; ++i)ranges = [
        ...ranges,
        [
            timeRanges.start(i),
            timeRanges.end(i)
        ]
    ];
    return ranges;
}
function $cbe5e41a05e7dda8$var$tracksToArray(tracks) {
    return Array.from(tracks).map(({ label: label, kind: kind, language: language, mode: mode, activeCues: activeCues, cues: cues, inBandMetadataTrackDispatchType: inBandMetadataTrackDispatchType }, id)=>({
            id: id,
            label: label,
            kind: kind,
            language: language,
            mode: mode,
            activeCues: activeCues,
            cues: cues,
            inBandMetadataTrackDispatchType: inBandMetadataTrackDispatchType
        }));
}
const $cbe5e41a05e7dda8$var$defaultOptions = {
    src: "",
    tracks: []
};
function $cbe5e41a05e7dda8$export$4401816799be37c8(target, options = {}) {
    target = (0, $ef9Nn.toRef)(target);
    options = {
        ...$cbe5e41a05e7dda8$var$defaultOptions,
        ...options
    };
    const { document: document1 = $cbe5e41a05e7dda8$export$37990bd438d16af3 } = options;
    const currentTime = (0, $8bTPG.ref)(0);
    const duration = (0, $8bTPG.ref)(0);
    const seeking = (0, $8bTPG.ref)(false);
    const volume = (0, $8bTPG.ref)(1);
    const waiting = (0, $8bTPG.ref)(false);
    const ended = (0, $8bTPG.ref)(false);
    const playing = (0, $8bTPG.ref)(false);
    const rate = (0, $8bTPG.ref)(1);
    const stalled = (0, $8bTPG.ref)(false);
    const buffered = (0, $8bTPG.ref)([]);
    const tracks = (0, $8bTPG.ref)([]);
    const selectedTrack = (0, $8bTPG.ref)(-1);
    const isPictureInPicture = (0, $8bTPG.ref)(false);
    const muted = (0, $8bTPG.ref)(false);
    const supportsPictureInPicture = document1 && "pictureInPictureEnabled" in document1;
    const sourceErrorEvent = (0, $ef9Nn.createEventHook)();
    const disableTrack = (track)=>{
        $cbe5e41a05e7dda8$var$usingElRef(target, (el)=>{
            if (track) {
                const id = typeof track === "number" ? track : track.id;
                el.textTracks[id].mode = "disabled";
            } else for(let i = 0; i < el.textTracks.length; ++i)el.textTracks[i].mode = "disabled";
            selectedTrack.value = -1;
        });
    };
    const enableTrack = (track, disableTracks = true)=>{
        $cbe5e41a05e7dda8$var$usingElRef(target, (el)=>{
            const id = typeof track === "number" ? track : track.id;
            if (disableTracks) disableTrack();
            el.textTracks[id].mode = "showing";
            selectedTrack.value = id;
        });
    };
    const togglePictureInPicture = ()=>{
        return new Promise((resolve, reject)=>{
            $cbe5e41a05e7dda8$var$usingElRef(target, async (el)=>{
                if (supportsPictureInPicture) {
                    if (!isPictureInPicture.value) el.requestPictureInPicture().then(resolve).catch(reject);
                    else document1.exitPictureInPicture().then(resolve).catch(reject);
                }
            });
        });
    };
    (0, $ani5R.watchEffect)(()=>{
        if (!document1) return;
        const el = (0, $ef9Nn.toValue)(target);
        if (!el) return;
        const src = (0, $ef9Nn.toValue)(options.src);
        let sources = [];
        if (!src) return;
        if (typeof src === "string") sources = [
            {
                src: src
            }
        ];
        else if (Array.isArray(src)) sources = src;
        else if ((0, $ef9Nn.isObject)(src)) sources = [
            src
        ];
        el.querySelectorAll("source").forEach((e)=>{
            e.removeEventListener("error", sourceErrorEvent.trigger);
            e.remove();
        });
        sources.forEach(({ src: src2, type: type })=>{
            const source = document1.createElement("source");
            source.setAttribute("src", src2);
            source.setAttribute("type", type || "");
            source.addEventListener("error", sourceErrorEvent.trigger);
            el.appendChild(source);
        });
        el.load();
    });
    (0, $ef9Nn.tryOnScopeDispose)(()=>{
        const el = (0, $ef9Nn.toValue)(target);
        if (!el) return;
        el.querySelectorAll("source").forEach((e)=>e.removeEventListener("error", sourceErrorEvent.trigger));
    });
    (0, $ani5R.watch)([
        target,
        volume
    ], ()=>{
        const el = (0, $ef9Nn.toValue)(target);
        if (!el) return;
        el.volume = volume.value;
    });
    (0, $ani5R.watch)([
        target,
        muted
    ], ()=>{
        const el = (0, $ef9Nn.toValue)(target);
        if (!el) return;
        el.muted = muted.value;
    });
    (0, $ani5R.watch)([
        target,
        rate
    ], ()=>{
        const el = (0, $ef9Nn.toValue)(target);
        if (!el) return;
        el.playbackRate = rate.value;
    });
    (0, $ani5R.watchEffect)(()=>{
        if (!document1) return;
        const textTracks = (0, $ef9Nn.toValue)(options.tracks);
        const el = (0, $ef9Nn.toValue)(target);
        if (!textTracks || !textTracks.length || !el) return;
        el.querySelectorAll("track").forEach((e)=>e.remove());
        textTracks.forEach(({ default: isDefault, kind: kind, label: label, src: src, srcLang: srcLang }, i)=>{
            const track = document1.createElement("track");
            track.default = isDefault || false;
            track.kind = kind;
            track.label = label;
            track.src = src;
            track.srclang = srcLang;
            if (track.default) selectedTrack.value = i;
            el.appendChild(track);
        });
    });
    const { ignoreUpdates: ignoreCurrentTimeUpdates } = (0, $ef9Nn.watchIgnorable)(currentTime, (time)=>{
        const el = (0, $ef9Nn.toValue)(target);
        if (!el) return;
        el.currentTime = time;
    });
    const { ignoreUpdates: ignorePlayingUpdates } = (0, $ef9Nn.watchIgnorable)(playing, (isPlaying)=>{
        const el = (0, $ef9Nn.toValue)(target);
        if (!el) return;
        isPlaying ? el.play() : el.pause();
    });
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "timeupdate", ()=>ignoreCurrentTimeUpdates(()=>currentTime.value = (0, $ef9Nn.toValue)(target).currentTime));
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "durationchange", ()=>duration.value = (0, $ef9Nn.toValue)(target).duration);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "progress", ()=>buffered.value = $cbe5e41a05e7dda8$var$timeRangeToArray((0, $ef9Nn.toValue)(target).buffered));
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "seeking", ()=>seeking.value = true);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "seeked", ()=>seeking.value = false);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, [
        "waiting",
        "loadstart"
    ], ()=>{
        waiting.value = true;
        ignorePlayingUpdates(()=>playing.value = false);
    });
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "loadeddata", ()=>waiting.value = false);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "playing", ()=>{
        waiting.value = false;
        ended.value = false;
        ignorePlayingUpdates(()=>playing.value = true);
    });
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "ratechange", ()=>rate.value = (0, $ef9Nn.toValue)(target).playbackRate);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "stalled", ()=>stalled.value = true);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "ended", ()=>ended.value = true);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "pause", ()=>ignorePlayingUpdates(()=>playing.value = false));
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "play", ()=>ignorePlayingUpdates(()=>playing.value = true));
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "enterpictureinpicture", ()=>isPictureInPicture.value = true);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "leavepictureinpicture", ()=>isPictureInPicture.value = false);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "volumechange", ()=>{
        const el = (0, $ef9Nn.toValue)(target);
        if (!el) return;
        volume.value = el.volume;
        muted.value = el.muted;
    });
    const listeners = [];
    const stop = (0, $ani5R.watch)([
        target
    ], ()=>{
        const el = (0, $ef9Nn.toValue)(target);
        if (!el) return;
        stop();
        listeners[0] = $cbe5e41a05e7dda8$export$7080b3e976bc91ab(el.textTracks, "addtrack", ()=>tracks.value = $cbe5e41a05e7dda8$var$tracksToArray(el.textTracks));
        listeners[1] = $cbe5e41a05e7dda8$export$7080b3e976bc91ab(el.textTracks, "removetrack", ()=>tracks.value = $cbe5e41a05e7dda8$var$tracksToArray(el.textTracks));
        listeners[2] = $cbe5e41a05e7dda8$export$7080b3e976bc91ab(el.textTracks, "change", ()=>tracks.value = $cbe5e41a05e7dda8$var$tracksToArray(el.textTracks));
    });
    (0, $ef9Nn.tryOnScopeDispose)(()=>listeners.forEach((listener)=>listener()));
    return {
        currentTime: currentTime,
        duration: duration,
        waiting: waiting,
        seeking: seeking,
        ended: ended,
        stalled: stalled,
        buffered: buffered,
        playing: playing,
        rate: rate,
        volume: // Volume
        volume,
        muted: muted,
        tracks: // Tracks
        tracks,
        selectedTrack: selectedTrack,
        enableTrack: enableTrack,
        disableTrack: disableTrack,
        supportsPictureInPicture: // Picture in Picture
        supportsPictureInPicture,
        togglePictureInPicture: togglePictureInPicture,
        isPictureInPicture: isPictureInPicture,
        // Events
        onSourceError: sourceErrorEvent.on
    };
}
function $cbe5e41a05e7dda8$var$getMapVue2Compat() {
    const data = (0, $8bTPG.shallowReactive)({});
    return {
        get: (key)=>data[key],
        set: (key, value)=>(0, $j40Rs.set)(data, key, value),
        has: (key)=>(0, $ef9Nn.hasOwn)(data, key),
        delete: (key)=>(0, $j40Rs.del)(data, key),
        clear: ()=>{
            Object.keys(data).forEach((key)=>{
                (0, $j40Rs.del)(data, key);
            });
        }
    };
}
function $cbe5e41a05e7dda8$export$7403ef0fca9c6367(resolver, options) {
    const initCache = ()=>{
        if (options == null ? void 0 : options.cache) return (0, $8bTPG.shallowReactive)(options.cache);
        if (0, $j40Rs.isVue2) return $cbe5e41a05e7dda8$var$getMapVue2Compat();
        return (0, $8bTPG.shallowReactive)(/* @__PURE__ */ new Map());
    };
    const cache = initCache();
    const generateKey = (...args)=>(options == null ? void 0 : options.getKey) ? options.getKey(...args) : JSON.stringify(args);
    const _loadData = (key, ...args)=>{
        cache.set(key, resolver(...args));
        return cache.get(key);
    };
    const loadData = (...args)=>_loadData(generateKey(...args), ...args);
    const deleteData = (...args)=>{
        cache.delete(generateKey(...args));
    };
    const clearData = ()=>{
        cache.clear();
    };
    const memoized = (...args)=>{
        const key = generateKey(...args);
        if (cache.has(key)) return cache.get(key);
        return _loadData(key, ...args);
    };
    memoized.load = loadData;
    memoized.delete = deleteData;
    memoized.clear = clearData;
    memoized.generateKey = generateKey;
    memoized.cache = cache;
    return memoized;
}
function $cbe5e41a05e7dda8$export$b1c8a28243292cb9(options = {}) {
    const memory = (0, $8bTPG.ref)();
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>typeof performance !== "undefined" && "memory" in performance);
    if (isSupported.value) {
        const { interval: interval = 1e3 } = options;
        (0, $ef9Nn.useIntervalFn)(()=>{
            memory.value = performance.memory;
        }, interval, {
            immediate: options.immediate,
            immediateCallback: options.immediateCallback
        });
    }
    return {
        isSupported: isSupported,
        memory: memory
    };
}
const $cbe5e41a05e7dda8$var$UseMouseBuiltinExtractors = {
    page: (event)=>[
            event.pageX,
            event.pageY
        ],
    client: (event)=>[
            event.clientX,
            event.clientY
        ],
    screen: (event)=>[
            event.screenX,
            event.screenY
        ],
    movement: (event)=>event instanceof Touch ? null : [
            event.movementX,
            event.movementY
        ]
};
function $cbe5e41a05e7dda8$export$70811b4970b0f258(options = {}) {
    const { type: type = "page", touch: touch = true, resetOnTouchEnds: resetOnTouchEnds = false, initialValue: initialValue = {
        x: 0,
        y: 0
    }, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, target: target = window1, scroll: scroll = true, eventFilter: eventFilter } = options;
    let _prevMouseEvent = null;
    const x = (0, $8bTPG.ref)(initialValue.x);
    const y = (0, $8bTPG.ref)(initialValue.y);
    const sourceType = (0, $8bTPG.ref)(null);
    const extractor = typeof type === "function" ? type : $cbe5e41a05e7dda8$var$UseMouseBuiltinExtractors[type];
    const mouseHandler = (event)=>{
        const result = extractor(event);
        _prevMouseEvent = event;
        if (result) {
            [x.value, y.value] = result;
            sourceType.value = "mouse";
        }
    };
    const touchHandler = (event)=>{
        if (event.touches.length > 0) {
            const result = extractor(event.touches[0]);
            if (result) {
                [x.value, y.value] = result;
                sourceType.value = "touch";
            }
        }
    };
    const scrollHandler = ()=>{
        if (!_prevMouseEvent || !window1) return;
        const pos = extractor(_prevMouseEvent);
        if (_prevMouseEvent instanceof MouseEvent && pos) {
            x.value = pos[0] + window1.scrollX;
            y.value = pos[1] + window1.scrollY;
        }
    };
    const reset = ()=>{
        x.value = initialValue.x;
        y.value = initialValue.y;
    };
    const mouseHandlerWrapper = eventFilter ? (event)=>eventFilter(()=>mouseHandler(event), {}) : (event)=>mouseHandler(event);
    const touchHandlerWrapper = eventFilter ? (event)=>eventFilter(()=>touchHandler(event), {}) : (event)=>touchHandler(event);
    const scrollHandlerWrapper = eventFilter ? ()=>eventFilter(()=>scrollHandler(), {}) : ()=>scrollHandler();
    if (target) {
        const listenerOptions = {
            passive: true
        };
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, [
            "mousemove",
            "dragover"
        ], mouseHandlerWrapper, listenerOptions);
        if (touch && type !== "movement") {
            $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, [
                "touchstart",
                "touchmove"
            ], touchHandlerWrapper, listenerOptions);
            if (resetOnTouchEnds) $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "touchend", reset, listenerOptions);
        }
        if (scroll && type === "page") $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "scroll", scrollHandlerWrapper, {
            passive: true
        });
    }
    return {
        x: x,
        y: y,
        sourceType: sourceType
    };
}
function $cbe5e41a05e7dda8$export$74acb291b8ceb4b8(target, options = {}) {
    const { handleOutside: handleOutside = true, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const type = options.type || "page";
    const { x: x, y: y, sourceType: sourceType } = $cbe5e41a05e7dda8$export$70811b4970b0f258(options);
    const targetRef = (0, $8bTPG.ref)(target != null ? target : window1 == null ? void 0 : window1.document.body);
    const elementX = (0, $8bTPG.ref)(0);
    const elementY = (0, $8bTPG.ref)(0);
    const elementPositionX = (0, $8bTPG.ref)(0);
    const elementPositionY = (0, $8bTPG.ref)(0);
    const elementHeight = (0, $8bTPG.ref)(0);
    const elementWidth = (0, $8bTPG.ref)(0);
    const isOutside = (0, $8bTPG.ref)(true);
    let stop = ()=>{};
    if (window1) {
        stop = (0, $ani5R.watch)([
            targetRef,
            x,
            y
        ], ()=>{
            const el = $cbe5e41a05e7dda8$export$c61124d3cf5adbae(targetRef);
            if (!el) return;
            const { left: left, top: top, width: width, height: height } = el.getBoundingClientRect();
            elementPositionX.value = left + (type === "page" ? window1.pageXOffset : 0);
            elementPositionY.value = top + (type === "page" ? window1.pageYOffset : 0);
            elementHeight.value = height;
            elementWidth.value = width;
            const elX = x.value - elementPositionX.value;
            const elY = y.value - elementPositionY.value;
            isOutside.value = width === 0 || height === 0 || elX < 0 || elY < 0 || elX > width || elY > height;
            if (handleOutside || !isOutside.value) {
                elementX.value = elX;
                elementY.value = elY;
            }
        }, {
            immediate: true
        });
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(document, "mouseleave", ()=>{
            isOutside.value = true;
        });
    }
    return {
        x: x,
        y: y,
        sourceType: sourceType,
        elementX: elementX,
        elementY: elementY,
        elementPositionX: elementPositionX,
        elementPositionY: elementPositionY,
        elementHeight: elementHeight,
        elementWidth: elementWidth,
        isOutside: isOutside,
        stop: stop
    };
}
function $cbe5e41a05e7dda8$export$5d7a2a40c559277c(options = {}) {
    const { touch: touch = true, drag: drag = true, capture: capture = false, initialValue: initialValue = false, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const pressed = (0, $8bTPG.ref)(initialValue);
    const sourceType = (0, $8bTPG.ref)(null);
    if (!window1) return {
        pressed: pressed,
        sourceType: sourceType
    };
    const onPressed = (srcType)=>()=>{
            pressed.value = true;
            sourceType.value = srcType;
        };
    const onReleased = ()=>{
        pressed.value = false;
        sourceType.value = null;
    };
    const target = (0, $8bTPG.computed)(()=>$cbe5e41a05e7dda8$export$c61124d3cf5adbae(options.target) || window1);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "mousedown", onPressed("mouse"), {
        passive: true,
        capture: capture
    });
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "mouseleave", onReleased, {
        passive: true,
        capture: capture
    });
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "mouseup", onReleased, {
        passive: true,
        capture: capture
    });
    if (drag) {
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "dragstart", onPressed("mouse"), {
            passive: true,
            capture: capture
        });
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "drop", onReleased, {
            passive: true,
            capture: capture
        });
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "dragend", onReleased, {
            passive: true,
            capture: capture
        });
    }
    if (touch) {
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "touchstart", onPressed("touch"), {
            passive: true,
            capture: capture
        });
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "touchend", onReleased, {
            passive: true,
            capture: capture
        });
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "touchcancel", onReleased, {
            passive: true,
            capture: capture
        });
    }
    return {
        pressed: pressed,
        sourceType: sourceType
    };
}
function $cbe5e41a05e7dda8$export$64fd3a716d6bb70f(options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const navigator = window1 == null ? void 0 : window1.navigator;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>navigator && "language" in navigator);
    const language = (0, $8bTPG.ref)(navigator == null ? void 0 : navigator.language);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "languagechange", ()=>{
        if (navigator) language.value = navigator.language;
    });
    return {
        isSupported: isSupported,
        language: language
    };
}
function $cbe5e41a05e7dda8$export$553aaf59afc1a2d8(options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const navigator = window1 == null ? void 0 : window1.navigator;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>navigator && "connection" in navigator);
    const isOnline = (0, $8bTPG.ref)(true);
    const saveData = (0, $8bTPG.ref)(false);
    const offlineAt = (0, $8bTPG.ref)(void 0);
    const onlineAt = (0, $8bTPG.ref)(void 0);
    const downlink = (0, $8bTPG.ref)(void 0);
    const downlinkMax = (0, $8bTPG.ref)(void 0);
    const rtt = (0, $8bTPG.ref)(void 0);
    const effectiveType = (0, $8bTPG.ref)(void 0);
    const type = (0, $8bTPG.ref)("unknown");
    const connection = isSupported.value && navigator.connection;
    function updateNetworkInformation() {
        if (!navigator) return;
        isOnline.value = navigator.onLine;
        offlineAt.value = isOnline.value ? void 0 : Date.now();
        onlineAt.value = isOnline.value ? Date.now() : void 0;
        if (connection) {
            downlink.value = connection.downlink;
            downlinkMax.value = connection.downlinkMax;
            effectiveType.value = connection.effectiveType;
            rtt.value = connection.rtt;
            saveData.value = connection.saveData;
            type.value = connection.type;
        }
    }
    if (window1) {
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "offline", ()=>{
            isOnline.value = false;
            offlineAt.value = Date.now();
        });
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "online", ()=>{
            isOnline.value = true;
            onlineAt.value = Date.now();
        });
    }
    if (connection) $cbe5e41a05e7dda8$export$7080b3e976bc91ab(connection, "change", updateNetworkInformation, false);
    updateNetworkInformation();
    return {
        isSupported: isSupported,
        isOnline: isOnline,
        saveData: saveData,
        offlineAt: offlineAt,
        onlineAt: onlineAt,
        downlink: downlink,
        downlinkMax: downlinkMax,
        effectiveType: effectiveType,
        rtt: rtt,
        type: type
    };
}
function $cbe5e41a05e7dda8$export$3a404aece3dff2fa(options = {}) {
    const { controls: exposeControls = false, interval: interval = "requestAnimationFrame" } = options;
    const now = (0, $8bTPG.ref)(/* @__PURE__ */ new Date());
    const update = ()=>now.value = /* @__PURE__ */ new Date();
    const controls = interval === "requestAnimationFrame" ? $cbe5e41a05e7dda8$export$13251e0fc79284e(update, {
        immediate: true
    }) : (0, $ef9Nn.useIntervalFn)(update, interval, {
        immediate: true
    });
    if (exposeControls) return {
        now: now,
        ...controls
    };
    else return now;
}
function $cbe5e41a05e7dda8$export$533619a63360a89b(object) {
    const url = (0, $8bTPG.ref)();
    const release = ()=>{
        if (url.value) URL.revokeObjectURL(url.value);
        url.value = void 0;
    };
    (0, $ani5R.watch)(()=>(0, $ef9Nn.toValue)(object), (newObject)=>{
        release();
        if (newObject) url.value = URL.createObjectURL(newObject);
    }, {
        immediate: true
    });
    (0, $ef9Nn.tryOnScopeDispose)(release);
    return (0, $8bTPG.readonly)(url);
}
function $cbe5e41a05e7dda8$var$useClamp(value, min, max) {
    if (typeof value === "function" || (0, $8bTPG.isReadonly)(value)) return (0, $8bTPG.computed)(()=>(0, $ef9Nn.clamp)((0, $ef9Nn.toValue)(value), (0, $ef9Nn.toValue)(min), (0, $ef9Nn.toValue)(max)));
    const _value = (0, $8bTPG.ref)(value);
    return (0, $8bTPG.computed)({
        get () {
            return _value.value = (0, $ef9Nn.clamp)(_value.value, (0, $ef9Nn.toValue)(min), (0, $ef9Nn.toValue)(max));
        },
        set (value2) {
            _value.value = (0, $ef9Nn.clamp)(value2, (0, $ef9Nn.toValue)(min), (0, $ef9Nn.toValue)(max));
        }
    });
}
function $cbe5e41a05e7dda8$export$dca1841098f618ea(options) {
    const { total: total = Number.POSITIVE_INFINITY, pageSize: pageSize = 10, page: page = 1, onPageChange: onPageChange = (0, $ef9Nn.noop), onPageSizeChange: onPageSizeChange = (0, $ef9Nn.noop), onPageCountChange: onPageCountChange = (0, $ef9Nn.noop) } = options;
    const currentPageSize = $cbe5e41a05e7dda8$var$useClamp(pageSize, 1, Number.POSITIVE_INFINITY);
    const pageCount = (0, $8bTPG.computed)(()=>Math.max(1, Math.ceil((0, $ef9Nn.toValue)(total) / (0, $ef9Nn.toValue)(currentPageSize))));
    const currentPage = $cbe5e41a05e7dda8$var$useClamp(page, 1, pageCount);
    const isFirstPage = (0, $8bTPG.computed)(()=>currentPage.value === 1);
    const isLastPage = (0, $8bTPG.computed)(()=>currentPage.value === pageCount.value);
    if ((0, $8bTPG.isRef)(page)) (0, $ef9Nn.syncRef)(page, currentPage, {
        direction: (0, $8bTPG.isReadonly)(page) ? "ltr" : "both"
    });
    if ((0, $8bTPG.isRef)(pageSize)) (0, $ef9Nn.syncRef)(pageSize, currentPageSize, {
        direction: (0, $8bTPG.isReadonly)(pageSize) ? "ltr" : "both"
    });
    function prev() {
        currentPage.value--;
    }
    function next() {
        currentPage.value++;
    }
    const returnValue = {
        currentPage: currentPage,
        currentPageSize: currentPageSize,
        pageCount: pageCount,
        isFirstPage: isFirstPage,
        isLastPage: isLastPage,
        prev: prev,
        next: next
    };
    (0, $ani5R.watch)(currentPage, ()=>{
        onPageChange((0, $8bTPG.reactive)(returnValue));
    });
    (0, $ani5R.watch)(currentPageSize, ()=>{
        onPageSizeChange((0, $8bTPG.reactive)(returnValue));
    });
    (0, $ani5R.watch)(pageCount, ()=>{
        onPageCountChange((0, $8bTPG.reactive)(returnValue));
    });
    return returnValue;
}
function $cbe5e41a05e7dda8$export$6feb6ada280bcdab(options = {}) {
    const { isOnline: isOnline } = $cbe5e41a05e7dda8$export$553aaf59afc1a2d8(options);
    return isOnline;
}
function $cbe5e41a05e7dda8$export$6bd1f37e929013e5(options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const isLeft = (0, $8bTPG.ref)(false);
    const handler = (event)=>{
        if (!window1) return;
        event = event || window1.event;
        const from = event.relatedTarget || event.toElement;
        isLeft.value = !from;
    };
    if (window1) {
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "mouseout", handler, {
            passive: true
        });
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1.document, "mouseleave", handler, {
            passive: true
        });
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1.document, "mouseenter", handler, {
            passive: true
        });
    }
    return isLeft;
}
function $cbe5e41a05e7dda8$export$588695585364abce(options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>window1 && "screen" in window1 && "orientation" in window1.screen);
    const screenOrientation = isSupported.value ? window1.screen.orientation : {};
    const orientation = (0, $8bTPG.ref)(screenOrientation.type);
    const angle = (0, $8bTPG.ref)(screenOrientation.angle || 0);
    if (isSupported.value) $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "orientationchange", ()=>{
        orientation.value = screenOrientation.type;
        angle.value = screenOrientation.angle;
    });
    const lockOrientation = (type)=>{
        if (isSupported.value && typeof screenOrientation.lock === "function") return screenOrientation.lock(type);
        return Promise.reject(new Error("Not supported"));
    };
    const unlockOrientation = ()=>{
        if (isSupported.value && typeof screenOrientation.unlock === "function") screenOrientation.unlock();
    };
    return {
        isSupported: isSupported,
        orientation: orientation,
        angle: angle,
        lockOrientation: lockOrientation,
        unlockOrientation: unlockOrientation
    };
}
function $cbe5e41a05e7dda8$export$78dabaa73e04c89f(target, options = {}) {
    const { deviceOrientationTiltAdjust: deviceOrientationTiltAdjust = (i)=>i, deviceOrientationRollAdjust: deviceOrientationRollAdjust = (i)=>i, mouseTiltAdjust: mouseTiltAdjust = (i)=>i, mouseRollAdjust: mouseRollAdjust = (i)=>i, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const orientation = (0, $8bTPG.reactive)($cbe5e41a05e7dda8$export$9bafe4f626b63a33({
        window: window1
    }));
    const screenOrientation = (0, $8bTPG.reactive)($cbe5e41a05e7dda8$export$588695585364abce({
        window: window1
    }));
    const { elementX: x, elementY: y, elementWidth: width, elementHeight: height } = $cbe5e41a05e7dda8$export$74acb291b8ceb4b8(target, {
        handleOutside: false,
        window: window1
    });
    const source = (0, $8bTPG.computed)(()=>{
        if (orientation.isSupported && (orientation.alpha != null && orientation.alpha !== 0 || orientation.gamma != null && orientation.gamma !== 0)) return "deviceOrientation";
        return "mouse";
    });
    const roll = (0, $8bTPG.computed)(()=>{
        if (source.value === "deviceOrientation") {
            let value;
            switch(screenOrientation.orientation){
                case "landscape-primary":
                    value = orientation.gamma / 90;
                    break;
                case "landscape-secondary":
                    value = -orientation.gamma / 90;
                    break;
                case "portrait-primary":
                    value = -orientation.beta / 90;
                    break;
                case "portrait-secondary":
                    value = orientation.beta / 90;
                    break;
                default:
                    value = -orientation.beta / 90;
            }
            return deviceOrientationRollAdjust(value);
        } else {
            const value = -(y.value - height.value / 2) / height.value;
            return mouseRollAdjust(value);
        }
    });
    const tilt = (0, $8bTPG.computed)(()=>{
        if (source.value === "deviceOrientation") {
            let value;
            switch(screenOrientation.orientation){
                case "landscape-primary":
                    value = orientation.beta / 90;
                    break;
                case "landscape-secondary":
                    value = -orientation.beta / 90;
                    break;
                case "portrait-primary":
                    value = orientation.gamma / 90;
                    break;
                case "portrait-secondary":
                    value = -orientation.gamma / 90;
                    break;
                default:
                    value = orientation.gamma / 90;
            }
            return deviceOrientationTiltAdjust(value);
        } else {
            const value = (x.value - width.value / 2) / width.value;
            return mouseTiltAdjust(value);
        }
    });
    return {
        roll: roll,
        tilt: tilt,
        source: source
    };
}
function $cbe5e41a05e7dda8$export$868ba98d0a4efc6f(element = $cbe5e41a05e7dda8$export$8d937a32bc2b31dd()) {
    const parentElement = (0, $8bTPG.shallowRef)();
    const update = ()=>{
        const el = $cbe5e41a05e7dda8$export$c61124d3cf5adbae(element);
        if (el) parentElement.value = el.parentElement;
    };
    (0, $ef9Nn.tryOnMounted)(update);
    (0, $ani5R.watch)(()=>(0, $ef9Nn.toValue)(element), update);
    return parentElement;
}
function $cbe5e41a05e7dda8$export$d3d061a08d0fe848(options, callback) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, immediate: immediate = true, ...performanceOptions } = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>window1 && "PerformanceObserver" in window1);
    let observer;
    const stop = ()=>{
        observer == null || observer.disconnect();
    };
    const start = ()=>{
        if (isSupported.value) {
            stop();
            observer = new PerformanceObserver(callback);
            observer.observe(performanceOptions);
        }
    };
    (0, $ef9Nn.tryOnScopeDispose)(stop);
    if (immediate) start();
    return {
        isSupported: isSupported,
        start: start,
        stop: stop
    };
}
const $cbe5e41a05e7dda8$var$defaultState = {
    x: 0,
    y: 0,
    pointerId: 0,
    pressure: 0,
    tiltX: 0,
    tiltY: 0,
    width: 0,
    height: 0,
    twist: 0,
    pointerType: null
};
const $cbe5e41a05e7dda8$var$keys = /* @__PURE__ */ Object.keys($cbe5e41a05e7dda8$var$defaultState);
function $cbe5e41a05e7dda8$export$a6d851f32526772(options = {}) {
    const { target: target = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const isInside = (0, $8bTPG.ref)(false);
    const state = (0, $8bTPG.ref)(options.initialValue || {});
    Object.assign(state.value, $cbe5e41a05e7dda8$var$defaultState, state.value);
    const handler = (event)=>{
        isInside.value = true;
        if (options.pointerTypes && !options.pointerTypes.includes(event.pointerType)) return;
        state.value = (0, $ef9Nn.objectPick)(event, $cbe5e41a05e7dda8$var$keys, false);
    };
    if (target) {
        const listenerOptions = {
            passive: true
        };
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, [
            "pointerdown",
            "pointermove",
            "pointerup"
        ], handler, listenerOptions);
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "pointerleave", ()=>isInside.value = false, listenerOptions);
    }
    return {
        ...(0, $ef9Nn.toRefs)(state),
        isInside: isInside
    };
}
function $cbe5e41a05e7dda8$export$fc4b89f039a97947(target, options = {}) {
    const { document: document1 = $cbe5e41a05e7dda8$export$37990bd438d16af3 } = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>document1 && "pointerLockElement" in document1);
    const element = (0, $8bTPG.ref)();
    const triggerElement = (0, $8bTPG.ref)();
    let targetElement;
    if (isSupported.value) {
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(document1, "pointerlockchange", ()=>{
            var _a;
            const currentElement = (_a = document1.pointerLockElement) != null ? _a : element.value;
            if (targetElement && currentElement === targetElement) {
                element.value = document1.pointerLockElement;
                if (!element.value) targetElement = triggerElement.value = null;
            }
        });
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(document1, "pointerlockerror", ()=>{
            var _a;
            const currentElement = (_a = document1.pointerLockElement) != null ? _a : element.value;
            if (targetElement && currentElement === targetElement) {
                const action = document1.pointerLockElement ? "release" : "acquire";
                throw new Error(`Failed to ${action} pointer lock.`);
            }
        });
    }
    async function lock(e) {
        var _a;
        if (!isSupported.value) throw new Error("Pointer Lock API is not supported by your browser.");
        triggerElement.value = e instanceof Event ? e.currentTarget : null;
        targetElement = e instanceof Event ? (_a = $cbe5e41a05e7dda8$export$c61124d3cf5adbae(target)) != null ? _a : triggerElement.value : $cbe5e41a05e7dda8$export$c61124d3cf5adbae(e);
        if (!targetElement) throw new Error("Target element undefined.");
        targetElement.requestPointerLock();
        return await (0, $ef9Nn.until)(element).toBe(targetElement);
    }
    async function unlock() {
        if (!element.value) return false;
        document1.exitPointerLock();
        await (0, $ef9Nn.until)(element).toBeNull();
        return true;
    }
    return {
        isSupported: isSupported,
        element: element,
        triggerElement: triggerElement,
        lock: lock,
        unlock: unlock
    };
}
function $cbe5e41a05e7dda8$export$abaee32ee49963c1(target, options = {}) {
    const targetRef = (0, $ef9Nn.toRef)(target);
    const { threshold: threshold = 50, onSwipe: onSwipe, onSwipeEnd: onSwipeEnd, onSwipeStart: onSwipeStart, disableTextSelect: disableTextSelect = false } = options;
    const posStart = (0, $8bTPG.reactive)({
        x: 0,
        y: 0
    });
    const updatePosStart = (x, y)=>{
        posStart.x = x;
        posStart.y = y;
    };
    const posEnd = (0, $8bTPG.reactive)({
        x: 0,
        y: 0
    });
    const updatePosEnd = (x, y)=>{
        posEnd.x = x;
        posEnd.y = y;
    };
    const distanceX = (0, $8bTPG.computed)(()=>posStart.x - posEnd.x);
    const distanceY = (0, $8bTPG.computed)(()=>posStart.y - posEnd.y);
    const { max: max, abs: abs } = Math;
    const isThresholdExceeded = (0, $8bTPG.computed)(()=>max(abs(distanceX.value), abs(distanceY.value)) >= threshold);
    const isSwiping = (0, $8bTPG.ref)(false);
    const isPointerDown = (0, $8bTPG.ref)(false);
    const direction = (0, $8bTPG.computed)(()=>{
        if (!isThresholdExceeded.value) return "none";
        if (abs(distanceX.value) > abs(distanceY.value)) return distanceX.value > 0 ? "left" : "right";
        else return distanceY.value > 0 ? "up" : "down";
    });
    const eventIsAllowed = (e)=>{
        var _a, _b, _c;
        const isReleasingButton = e.buttons === 0;
        const isPrimaryButton = e.buttons === 1;
        return (_c = (_b = (_a = options.pointerTypes) == null ? void 0 : _a.includes(e.pointerType)) != null ? _b : isReleasingButton || isPrimaryButton) != null ? _c : true;
    };
    const stops = [
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "pointerdown", (e)=>{
            if (!eventIsAllowed(e)) return;
            isPointerDown.value = true;
            const eventTarget = e.target;
            eventTarget == null || eventTarget.setPointerCapture(e.pointerId);
            const { clientX: x, clientY: y } = e;
            updatePosStart(x, y);
            updatePosEnd(x, y);
            onSwipeStart == null || onSwipeStart(e);
        }),
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "pointermove", (e)=>{
            if (!eventIsAllowed(e)) return;
            if (!isPointerDown.value) return;
            const { clientX: x, clientY: y } = e;
            updatePosEnd(x, y);
            if (!isSwiping.value && isThresholdExceeded.value) isSwiping.value = true;
            if (isSwiping.value) onSwipe == null || onSwipe(e);
        }),
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "pointerup", (e)=>{
            if (!eventIsAllowed(e)) return;
            if (isSwiping.value) onSwipeEnd == null || onSwipeEnd(e, direction.value);
            isPointerDown.value = false;
            isSwiping.value = false;
        })
    ];
    (0, $ef9Nn.tryOnMounted)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        (_b = (_a = targetRef.value) == null ? void 0 : _a.style) == null || _b.setProperty("touch-action", "none");
        if (disableTextSelect) {
            (_d = (_c = targetRef.value) == null ? void 0 : _c.style) == null || _d.setProperty("-webkit-user-select", "none");
            (_f = (_e = targetRef.value) == null ? void 0 : _e.style) == null || _f.setProperty("-ms-user-select", "none");
            (_h = (_g = targetRef.value) == null ? void 0 : _g.style) == null || _h.setProperty("user-select", "none");
        }
    });
    const stop = ()=>stops.forEach((s)=>s());
    return {
        isSwiping: (0, $8bTPG.readonly)(isSwiping),
        direction: (0, $8bTPG.readonly)(direction),
        posStart: (0, $8bTPG.readonly)(posStart),
        posEnd: (0, $8bTPG.readonly)(posEnd),
        distanceX: distanceX,
        distanceY: distanceY,
        stop: stop
    };
}
function $cbe5e41a05e7dda8$export$7c3b8f854ca5e941(options) {
    const isLight = $cbe5e41a05e7dda8$export$32d5543ab307c01("(prefers-color-scheme: light)", options);
    const isDark = $cbe5e41a05e7dda8$export$32d5543ab307c01("(prefers-color-scheme: dark)", options);
    return (0, $8bTPG.computed)(()=>{
        if (isDark.value) return "dark";
        if (isLight.value) return "light";
        return "no-preference";
    });
}
function $cbe5e41a05e7dda8$export$14fe172294a7a184(options) {
    const isMore = $cbe5e41a05e7dda8$export$32d5543ab307c01("(prefers-contrast: more)", options);
    const isLess = $cbe5e41a05e7dda8$export$32d5543ab307c01("(prefers-contrast: less)", options);
    const isCustom = $cbe5e41a05e7dda8$export$32d5543ab307c01("(prefers-contrast: custom)", options);
    return (0, $8bTPG.computed)(()=>{
        if (isMore.value) return "more";
        if (isLess.value) return "less";
        if (isCustom.value) return "custom";
        return "no-preference";
    });
}
function $cbe5e41a05e7dda8$export$408b11bf0000ced3(options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    if (!window1) return (0, $8bTPG.ref)([
        "en"
    ]);
    const navigator = window1.navigator;
    const value = (0, $8bTPG.ref)(navigator.languages);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "languagechange", ()=>{
        value.value = navigator.languages;
    });
    return value;
}
function $cbe5e41a05e7dda8$export$66a8176c0ff6800c(options) {
    const isReduced = $cbe5e41a05e7dda8$export$32d5543ab307c01("(prefers-reduced-motion: reduce)", options);
    return (0, $8bTPG.computed)(()=>{
        if (isReduced.value) return "reduce";
        return "no-preference";
    });
}
function $cbe5e41a05e7dda8$export$5cae361ad82dce8b(value, initialValue) {
    const previous = (0, $8bTPG.shallowRef)(initialValue);
    (0, $ani5R.watch)((0, $ef9Nn.toRef)(value), (_, oldValue)=>{
        previous.value = oldValue;
    }, {
        flush: "sync"
    });
    return (0, $8bTPG.readonly)(previous);
}
const $cbe5e41a05e7dda8$var$topVarName = "--vueuse-safe-area-top";
const $cbe5e41a05e7dda8$var$rightVarName = "--vueuse-safe-area-right";
const $cbe5e41a05e7dda8$var$bottomVarName = "--vueuse-safe-area-bottom";
const $cbe5e41a05e7dda8$var$leftVarName = "--vueuse-safe-area-left";
function $cbe5e41a05e7dda8$export$40dfca171e090791() {
    const top = (0, $8bTPG.ref)("");
    const right = (0, $8bTPG.ref)("");
    const bottom = (0, $8bTPG.ref)("");
    const left = (0, $8bTPG.ref)("");
    if (0, $ef9Nn.isClient) {
        const topCssVar = $cbe5e41a05e7dda8$export$811e58a9be6ff112($cbe5e41a05e7dda8$var$topVarName);
        const rightCssVar = $cbe5e41a05e7dda8$export$811e58a9be6ff112($cbe5e41a05e7dda8$var$rightVarName);
        const bottomCssVar = $cbe5e41a05e7dda8$export$811e58a9be6ff112($cbe5e41a05e7dda8$var$bottomVarName);
        const leftCssVar = $cbe5e41a05e7dda8$export$811e58a9be6ff112($cbe5e41a05e7dda8$var$leftVarName);
        topCssVar.value = "env(safe-area-inset-top, 0px)";
        rightCssVar.value = "env(safe-area-inset-right, 0px)";
        bottomCssVar.value = "env(safe-area-inset-bottom, 0px)";
        leftCssVar.value = "env(safe-area-inset-left, 0px)";
        update();
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab("resize", (0, $ef9Nn.useDebounceFn)(update));
    }
    function update() {
        top.value = $cbe5e41a05e7dda8$var$getValue($cbe5e41a05e7dda8$var$topVarName);
        right.value = $cbe5e41a05e7dda8$var$getValue($cbe5e41a05e7dda8$var$rightVarName);
        bottom.value = $cbe5e41a05e7dda8$var$getValue($cbe5e41a05e7dda8$var$bottomVarName);
        left.value = $cbe5e41a05e7dda8$var$getValue($cbe5e41a05e7dda8$var$leftVarName);
    }
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        update: update
    };
}
function $cbe5e41a05e7dda8$var$getValue(position) {
    return getComputedStyle(document.documentElement).getPropertyValue(position);
}
function $cbe5e41a05e7dda8$export$eac342b7cdc4d8de(src, onLoaded = (0, $ef9Nn.noop), options = {}) {
    const { immediate: immediate = true, manual: manual = false, type: type = "text/javascript", async: async = true, crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, noModule: noModule, defer: defer, document: document1 = $cbe5e41a05e7dda8$export$37990bd438d16af3, attrs: attrs = {} } = options;
    const scriptTag = (0, $8bTPG.ref)(null);
    let _promise = null;
    const loadScript = (waitForScriptLoad)=>new Promise((resolve, reject)=>{
            const resolveWithElement = (el2)=>{
                scriptTag.value = el2;
                resolve(el2);
                return el2;
            };
            if (!document1) {
                resolve(false);
                return;
            }
            let shouldAppend = false;
            let el = document1.querySelector(`script[src="${(0, $ef9Nn.toValue)(src)}"]`);
            if (!el) {
                el = document1.createElement("script");
                el.type = type;
                el.async = async;
                el.src = (0, $ef9Nn.toValue)(src);
                if (defer) el.defer = defer;
                if (crossOrigin) el.crossOrigin = crossOrigin;
                if (noModule) el.noModule = noModule;
                if (referrerPolicy) el.referrerPolicy = referrerPolicy;
                Object.entries(attrs).forEach(([name, value])=>el == null ? void 0 : el.setAttribute(name, value));
                shouldAppend = true;
            } else if (el.hasAttribute("data-loaded")) resolveWithElement(el);
            el.addEventListener("error", (event)=>reject(event));
            el.addEventListener("abort", (event)=>reject(event));
            el.addEventListener("load", ()=>{
                el.setAttribute("data-loaded", "true");
                onLoaded(el);
                resolveWithElement(el);
            });
            if (shouldAppend) el = document1.head.appendChild(el);
            if (!waitForScriptLoad) resolveWithElement(el);
        });
    const load = (waitForScriptLoad = true)=>{
        if (!_promise) _promise = loadScript(waitForScriptLoad);
        return _promise;
    };
    const unload = ()=>{
        if (!document1) return;
        _promise = null;
        if (scriptTag.value) scriptTag.value = null;
        const el = document1.querySelector(`script[src="${(0, $ef9Nn.toValue)(src)}"]`);
        if (el) document1.head.removeChild(el);
    };
    if (immediate && !manual) (0, $ef9Nn.tryOnMounted)(load);
    if (!manual) (0, $ef9Nn.tryOnUnmounted)(unload);
    return {
        scriptTag: scriptTag,
        load: load,
        unload: unload
    };
}
function $cbe5e41a05e7dda8$var$checkOverflowScroll(ele) {
    const style = window.getComputedStyle(ele);
    if (style.overflowX === "scroll" || style.overflowY === "scroll" || style.overflowX === "auto" && ele.clientWidth < ele.scrollWidth || style.overflowY === "auto" && ele.clientHeight < ele.scrollHeight) return true;
    else {
        const parent = ele.parentNode;
        if (!parent || parent.tagName === "BODY") return false;
        return $cbe5e41a05e7dda8$var$checkOverflowScroll(parent);
    }
}
function $cbe5e41a05e7dda8$var$preventDefault(rawEvent) {
    const e = rawEvent || window.event;
    const _target = e.target;
    if ($cbe5e41a05e7dda8$var$checkOverflowScroll(_target)) return false;
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
}
const $cbe5e41a05e7dda8$var$elInitialOverflow = /* @__PURE__ */ new WeakMap();
function $cbe5e41a05e7dda8$export$e47ba1b900da5d3b(element, initialState = false) {
    const isLocked = (0, $8bTPG.ref)(initialState);
    let stopTouchMoveListener = null;
    let initialOverflow = "";
    (0, $ani5R.watch)((0, $ef9Nn.toRef)(element), (el)=>{
        const target = $cbe5e41a05e7dda8$var$resolveElement((0, $ef9Nn.toValue)(el));
        if (target) {
            const ele = target;
            if (!$cbe5e41a05e7dda8$var$elInitialOverflow.get(ele)) $cbe5e41a05e7dda8$var$elInitialOverflow.set(ele, ele.style.overflow);
            if (ele.style.overflow !== "hidden") initialOverflow = ele.style.overflow;
            if (ele.style.overflow === "hidden") return isLocked.value = true;
            if (isLocked.value) return ele.style.overflow = "hidden";
        }
    }, {
        immediate: true
    });
    const lock = ()=>{
        const el = $cbe5e41a05e7dda8$var$resolveElement((0, $ef9Nn.toValue)(element));
        if (!el || isLocked.value) return;
        if (0, $ef9Nn.isIOS) stopTouchMoveListener = $cbe5e41a05e7dda8$export$7080b3e976bc91ab(el, "touchmove", (e)=>{
            $cbe5e41a05e7dda8$var$preventDefault(e);
        }, {
            passive: false
        });
        el.style.overflow = "hidden";
        isLocked.value = true;
    };
    const unlock = ()=>{
        const el = $cbe5e41a05e7dda8$var$resolveElement((0, $ef9Nn.toValue)(element));
        if (!el || !isLocked.value) return;
        (0, $ef9Nn.isIOS) && (stopTouchMoveListener == null || stopTouchMoveListener());
        el.style.overflow = initialOverflow;
        $cbe5e41a05e7dda8$var$elInitialOverflow.delete(el);
        isLocked.value = false;
    };
    (0, $ef9Nn.tryOnScopeDispose)(unlock);
    return (0, $8bTPG.computed)({
        get () {
            return isLocked.value;
        },
        set (v) {
            if (v) lock();
            else unlock();
        }
    });
}
function $cbe5e41a05e7dda8$export$864b6828bd07eda6(key, initialValue, options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    return $cbe5e41a05e7dda8$export$95809329f49ea9f9(key, initialValue, window1 == null ? void 0 : window1.sessionStorage, options);
}
function $cbe5e41a05e7dda8$export$96a35531d1008427(shareOptions = {}, options = {}) {
    const { navigator: navigator = $cbe5e41a05e7dda8$export$eade61489f57e3fc } = options;
    const _navigator = navigator;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>_navigator && "canShare" in _navigator);
    const share = async (overrideOptions = {})=>{
        if (isSupported.value) {
            const data = {
                ...(0, $ef9Nn.toValue)(shareOptions),
                ...(0, $ef9Nn.toValue)(overrideOptions)
            };
            let granted = true;
            if (data.files && _navigator.canShare) granted = _navigator.canShare({
                files: data.files
            });
            if (granted) return _navigator.share(data);
        }
    };
    return {
        isSupported: isSupported,
        share: share
    };
}
const $cbe5e41a05e7dda8$var$defaultSortFn = (source, compareFn)=>source.sort(compareFn);
const $cbe5e41a05e7dda8$var$defaultCompare = (a, b)=>a - b;
function $cbe5e41a05e7dda8$export$a4fc6b60896f06a0(...args) {
    var _a, _b, _c, _d;
    const [source] = args;
    let compareFn = $cbe5e41a05e7dda8$var$defaultCompare;
    let options = {};
    if (args.length === 2) {
        if (typeof args[1] === "object") {
            options = args[1];
            compareFn = (_a = options.compareFn) != null ? _a : $cbe5e41a05e7dda8$var$defaultCompare;
        } else compareFn = (_b = args[1]) != null ? _b : $cbe5e41a05e7dda8$var$defaultCompare;
    } else if (args.length > 2) {
        compareFn = (_c = args[1]) != null ? _c : $cbe5e41a05e7dda8$var$defaultCompare;
        options = (_d = args[2]) != null ? _d : {};
    }
    const { dirty: dirty = false, sortFn: sortFn = $cbe5e41a05e7dda8$var$defaultSortFn } = options;
    if (!dirty) return (0, $8bTPG.computed)(()=>sortFn([
            ...(0, $ef9Nn.toValue)(source)
        ], compareFn));
    (0, $ani5R.watchEffect)(()=>{
        const result = sortFn((0, $ef9Nn.toValue)(source), compareFn);
        if ((0, $8bTPG.isRef)(source)) source.value = result;
        else source.splice(0, source.length, ...result);
    });
    return source;
}
function $cbe5e41a05e7dda8$export$b2a8ce41ccd863a1(options = {}) {
    const { interimResults: interimResults = true, continuous: continuous = true, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const lang = (0, $ef9Nn.toRef)(options.lang || "en-US");
    const isListening = (0, $8bTPG.ref)(false);
    const isFinal = (0, $8bTPG.ref)(false);
    const result = (0, $8bTPG.ref)("");
    const error = (0, $8bTPG.shallowRef)(void 0);
    const toggle = (value = !isListening.value)=>{
        isListening.value = value;
    };
    const start = ()=>{
        isListening.value = true;
    };
    const stop = ()=>{
        isListening.value = false;
    };
    const SpeechRecognition = window1 && (window1.SpeechRecognition || window1.webkitSpeechRecognition);
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>SpeechRecognition);
    let recognition;
    if (isSupported.value) {
        recognition = new SpeechRecognition();
        recognition.continuous = continuous;
        recognition.interimResults = interimResults;
        recognition.lang = (0, $ef9Nn.toValue)(lang);
        recognition.onstart = ()=>{
            isFinal.value = false;
        };
        (0, $ani5R.watch)(lang, (lang2)=>{
            if (recognition && !isListening.value) recognition.lang = lang2;
        });
        recognition.onresult = (event)=>{
            const currentResult = event.results[event.resultIndex];
            const { transcript: transcript } = currentResult[0];
            isFinal.value = currentResult.isFinal;
            result.value = transcript;
            error.value = void 0;
        };
        recognition.onerror = (event)=>{
            error.value = event;
        };
        recognition.onend = ()=>{
            isListening.value = false;
            recognition.lang = (0, $ef9Nn.toValue)(lang);
        };
        (0, $ani5R.watch)(isListening, ()=>{
            if (isListening.value) recognition.start();
            else recognition.stop();
        });
    }
    (0, $ef9Nn.tryOnScopeDispose)(()=>{
        isListening.value = false;
    });
    return {
        isSupported: isSupported,
        isListening: isListening,
        isFinal: isFinal,
        recognition: recognition,
        result: result,
        error: error,
        toggle: toggle,
        start: start,
        stop: stop
    };
}
function $cbe5e41a05e7dda8$export$44e311196d9d3623(text, options = {}) {
    const { pitch: pitch = 1, rate: rate = 1, volume: volume = 1, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const synth = window1 && window1.speechSynthesis;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>synth);
    const isPlaying = (0, $8bTPG.ref)(false);
    const status = (0, $8bTPG.ref)("init");
    const spokenText = (0, $ef9Nn.toRef)(text || "");
    const lang = (0, $ef9Nn.toRef)(options.lang || "en-US");
    const error = (0, $8bTPG.shallowRef)(void 0);
    const toggle = (value = !isPlaying.value)=>{
        isPlaying.value = value;
    };
    const bindEventsForUtterance = (utterance2)=>{
        utterance2.lang = (0, $ef9Nn.toValue)(lang);
        utterance2.voice = (0, $ef9Nn.toValue)(options.voice) || null;
        utterance2.pitch = (0, $ef9Nn.toValue)(pitch);
        utterance2.rate = (0, $ef9Nn.toValue)(rate);
        utterance2.volume = volume;
        utterance2.onstart = ()=>{
            isPlaying.value = true;
            status.value = "play";
        };
        utterance2.onpause = ()=>{
            isPlaying.value = false;
            status.value = "pause";
        };
        utterance2.onresume = ()=>{
            isPlaying.value = true;
            status.value = "play";
        };
        utterance2.onend = ()=>{
            isPlaying.value = false;
            status.value = "end";
        };
        utterance2.onerror = (event)=>{
            error.value = event;
        };
    };
    const utterance = (0, $8bTPG.computed)(()=>{
        isPlaying.value = false;
        status.value = "init";
        const newUtterance = new SpeechSynthesisUtterance(spokenText.value);
        bindEventsForUtterance(newUtterance);
        return newUtterance;
    });
    const speak = ()=>{
        synth.cancel();
        utterance && synth.speak(utterance.value);
    };
    const stop = ()=>{
        synth.cancel();
        isPlaying.value = false;
    };
    if (isSupported.value) {
        bindEventsForUtterance(utterance.value);
        (0, $ani5R.watch)(lang, (lang2)=>{
            if (utterance.value && !isPlaying.value) utterance.value.lang = lang2;
        });
        if (options.voice) (0, $ani5R.watch)(options.voice, ()=>{
            synth.cancel();
        });
        (0, $ani5R.watch)(isPlaying, ()=>{
            if (isPlaying.value) synth.resume();
            else synth.pause();
        });
    }
    (0, $ef9Nn.tryOnScopeDispose)(()=>{
        isPlaying.value = false;
    });
    return {
        isSupported: isSupported,
        isPlaying: isPlaying,
        status: status,
        utterance: utterance,
        error: error,
        stop: stop,
        toggle: toggle,
        speak: speak
    };
}
function $cbe5e41a05e7dda8$export$9378619b14945e16(steps, initialStep) {
    const stepsRef = (0, $8bTPG.ref)(steps);
    const stepNames = (0, $8bTPG.computed)(()=>Array.isArray(stepsRef.value) ? stepsRef.value : Object.keys(stepsRef.value));
    const index = (0, $8bTPG.ref)(stepNames.value.indexOf(initialStep != null ? initialStep : stepNames.value[0]));
    const current = (0, $8bTPG.computed)(()=>at(index.value));
    const isFirst = (0, $8bTPG.computed)(()=>index.value === 0);
    const isLast = (0, $8bTPG.computed)(()=>index.value === stepNames.value.length - 1);
    const next = (0, $8bTPG.computed)(()=>stepNames.value[index.value + 1]);
    const previous = (0, $8bTPG.computed)(()=>stepNames.value[index.value - 1]);
    function at(index2) {
        if (Array.isArray(stepsRef.value)) return stepsRef.value[index2];
        return stepsRef.value[stepNames.value[index2]];
    }
    function get(step) {
        if (!stepNames.value.includes(step)) return;
        return at(stepNames.value.indexOf(step));
    }
    function goTo(step) {
        if (stepNames.value.includes(step)) index.value = stepNames.value.indexOf(step);
    }
    function goToNext() {
        if (isLast.value) return;
        index.value++;
    }
    function goToPrevious() {
        if (isFirst.value) return;
        index.value--;
    }
    function goBackTo(step) {
        if (isAfter(step)) goTo(step);
    }
    function isNext(step) {
        return stepNames.value.indexOf(step) === index.value + 1;
    }
    function isPrevious(step) {
        return stepNames.value.indexOf(step) === index.value - 1;
    }
    function isCurrent(step) {
        return stepNames.value.indexOf(step) === index.value;
    }
    function isBefore(step) {
        return index.value < stepNames.value.indexOf(step);
    }
    function isAfter(step) {
        return index.value > stepNames.value.indexOf(step);
    }
    return {
        steps: stepsRef,
        stepNames: stepNames,
        index: index,
        current: current,
        next: next,
        previous: previous,
        isFirst: isFirst,
        isLast: isLast,
        at: at,
        get: get,
        goTo: goTo,
        goToNext: goToNext,
        goToPrevious: goToPrevious,
        goBackTo: goBackTo,
        isNext: isNext,
        isPrevious: isPrevious,
        isCurrent: isCurrent,
        isBefore: isBefore,
        isAfter: isAfter
    };
}
function $cbe5e41a05e7dda8$export$dd72d4318fe38e17(key, initialValue, storage, options = {}) {
    var _a;
    const { flush: flush = "pre", deep: deep = true, listenToStorageChanges: listenToStorageChanges = true, writeDefaults: writeDefaults = true, mergeDefaults: mergeDefaults = false, shallow: shallow, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, eventFilter: eventFilter, onError: onError = (e)=>{
        console.error(e);
    } } = options;
    const rawInit = (0, $ef9Nn.toValue)(initialValue);
    const type = $cbe5e41a05e7dda8$var$guessSerializerType(rawInit);
    const data = (shallow ? (0, $8bTPG.shallowRef) : (0, $8bTPG.ref))(initialValue);
    const serializer = (_a = options.serializer) != null ? _a : $cbe5e41a05e7dda8$export$8111877b006f9b0b[type];
    if (!storage) try {
        storage = $cbe5e41a05e7dda8$export$b0cf1ae5a98eb83b("getDefaultStorageAsync", ()=>{
            var _a2;
            return (_a2 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a) == null ? void 0 : _a2.localStorage;
        })();
    } catch (e) {
        onError(e);
    }
    async function read(event) {
        if (!storage || event && event.key !== key) return;
        try {
            const rawValue = event ? event.newValue : await storage.getItem(key);
            if (rawValue == null) {
                data.value = rawInit;
                if (writeDefaults && rawInit !== null) await storage.setItem(key, await serializer.write(rawInit));
            } else if (mergeDefaults) {
                const value = await serializer.read(rawValue);
                if (typeof mergeDefaults === "function") data.value = mergeDefaults(value, rawInit);
                else if (type === "object" && !Array.isArray(value)) data.value = {
                    ...rawInit,
                    ...value
                };
                else data.value = value;
            } else data.value = await serializer.read(rawValue);
        } catch (e) {
            onError(e);
        }
    }
    read();
    if (window1 && listenToStorageChanges) $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "storage", (e)=>Promise.resolve().then(()=>read(e)));
    if (storage) (0, $ef9Nn.watchWithFilter)(data, async ()=>{
        try {
            if (data.value == null) await storage.removeItem(key);
            else await storage.setItem(key, await serializer.write(data.value));
        } catch (e) {
            onError(e);
        }
    }, {
        flush: flush,
        deep: deep,
        eventFilter: eventFilter
    });
    return data;
}
let $cbe5e41a05e7dda8$var$_id = 0;
function $cbe5e41a05e7dda8$export$c100116e6aa85030(css, options = {}) {
    const isLoaded = (0, $8bTPG.ref)(false);
    const { document: document1 = $cbe5e41a05e7dda8$export$37990bd438d16af3, immediate: immediate = true, manual: manual = false, id: id = `vueuse_styletag_${++$cbe5e41a05e7dda8$var$_id}` } = options;
    const cssRef = (0, $8bTPG.ref)(css);
    let stop = ()=>{};
    const load = ()=>{
        if (!document1) return;
        const el = document1.getElementById(id) || document1.createElement("style");
        if (!el.isConnected) {
            el.id = id;
            if (options.media) el.media = options.media;
            document1.head.appendChild(el);
        }
        if (isLoaded.value) return;
        stop = (0, $ani5R.watch)(cssRef, (value)=>{
            el.textContent = value;
        }, {
            immediate: true
        });
        isLoaded.value = true;
    };
    const unload = ()=>{
        if (!document1 || !isLoaded.value) return;
        stop();
        document1.head.removeChild(document1.getElementById(id));
        isLoaded.value = false;
    };
    if (immediate && !manual) (0, $ef9Nn.tryOnMounted)(load);
    if (!manual) (0, $ef9Nn.tryOnScopeDispose)(unload);
    return {
        id: id,
        css: cssRef,
        unload: unload,
        load: load,
        isLoaded: (0, $8bTPG.readonly)(isLoaded)
    };
}
function $cbe5e41a05e7dda8$export$b57f07e22c950716(target, options = {}) {
    const { threshold: threshold = 50, onSwipe: onSwipe, onSwipeEnd: onSwipeEnd, onSwipeStart: onSwipeStart, passive: passive = true, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const coordsStart = (0, $8bTPG.reactive)({
        x: 0,
        y: 0
    });
    const coordsEnd = (0, $8bTPG.reactive)({
        x: 0,
        y: 0
    });
    const diffX = (0, $8bTPG.computed)(()=>coordsStart.x - coordsEnd.x);
    const diffY = (0, $8bTPG.computed)(()=>coordsStart.y - coordsEnd.y);
    const { max: max, abs: abs } = Math;
    const isThresholdExceeded = (0, $8bTPG.computed)(()=>max(abs(diffX.value), abs(diffY.value)) >= threshold);
    const isSwiping = (0, $8bTPG.ref)(false);
    const direction = (0, $8bTPG.computed)(()=>{
        if (!isThresholdExceeded.value) return "none";
        if (abs(diffX.value) > abs(diffY.value)) return diffX.value > 0 ? "left" : "right";
        else return diffY.value > 0 ? "up" : "down";
    });
    const getTouchEventCoords = (e)=>[
            e.touches[0].clientX,
            e.touches[0].clientY
        ];
    const updateCoordsStart = (x, y)=>{
        coordsStart.x = x;
        coordsStart.y = y;
    };
    const updateCoordsEnd = (x, y)=>{
        coordsEnd.x = x;
        coordsEnd.y = y;
    };
    let listenerOptions;
    const isPassiveEventSupported = $cbe5e41a05e7dda8$var$checkPassiveEventSupport(window1 == null ? void 0 : window1.document);
    if (!passive) listenerOptions = isPassiveEventSupported ? {
        passive: false,
        capture: true
    } : {
        capture: true
    };
    else listenerOptions = isPassiveEventSupported ? {
        passive: true
    } : {
        capture: false
    };
    const onTouchEnd = (e)=>{
        if (isSwiping.value) onSwipeEnd == null || onSwipeEnd(e, direction.value);
        isSwiping.value = false;
    };
    const stops = [
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "touchstart", (e)=>{
            if (e.touches.length !== 1) return;
            if (listenerOptions.capture && !listenerOptions.passive) e.preventDefault();
            const [x, y] = getTouchEventCoords(e);
            updateCoordsStart(x, y);
            updateCoordsEnd(x, y);
            onSwipeStart == null || onSwipeStart(e);
        }, listenerOptions),
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, "touchmove", (e)=>{
            if (e.touches.length !== 1) return;
            const [x, y] = getTouchEventCoords(e);
            updateCoordsEnd(x, y);
            if (!isSwiping.value && isThresholdExceeded.value) isSwiping.value = true;
            if (isSwiping.value) onSwipe == null || onSwipe(e);
        }, listenerOptions),
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(target, [
            "touchend",
            "touchcancel"
        ], onTouchEnd, listenerOptions)
    ];
    const stop = ()=>stops.forEach((s)=>s());
    return {
        isPassiveEventSupported: isPassiveEventSupported,
        isSwiping: isSwiping,
        direction: direction,
        coordsStart: coordsStart,
        coordsEnd: coordsEnd,
        lengthX: diffX,
        lengthY: diffY,
        stop: stop
    };
}
function $cbe5e41a05e7dda8$var$checkPassiveEventSupport(document1) {
    if (!document1) return false;
    let supportsPassive = false;
    const optionsBlock = {
        get passive () {
            supportsPassive = true;
            return false;
        }
    };
    document1.addEventListener("x", (0, $ef9Nn.noop), optionsBlock);
    document1.removeEventListener("x", (0, $ef9Nn.noop));
    return supportsPassive;
}
function $cbe5e41a05e7dda8$export$253c1ef7895b3fea() {
    const refs = (0, $8bTPG.ref)([]);
    refs.value.set = (el)=>{
        if (el) refs.value.push(el);
    };
    (0, $ani5R.onBeforeUpdate)(()=>{
        refs.value.length = 0;
    });
    return refs;
}
function $cbe5e41a05e7dda8$export$cf24a79f32f45545(options = {}) {
    const { document: document1 = $cbe5e41a05e7dda8$export$37990bd438d16af3, selector: selector = "html", observe: observe = false, initialValue: initialValue = "ltr" } = options;
    function getValue() {
        var _a, _b;
        return (_b = (_a = document1 == null ? void 0 : document1.querySelector(selector)) == null ? void 0 : _a.getAttribute("dir")) != null ? _b : initialValue;
    }
    const dir = (0, $8bTPG.ref)(getValue());
    (0, $ef9Nn.tryOnMounted)(()=>dir.value = getValue());
    if (observe && document1) $cbe5e41a05e7dda8$export$8ecdcf3bb089e9cd(document1.querySelector(selector), ()=>dir.value = getValue(), {
        attributes: true
    });
    return (0, $8bTPG.computed)({
        get () {
            return dir.value;
        },
        set (v) {
            var _a, _b;
            dir.value = v;
            if (!document1) return;
            if (dir.value) (_a = document1.querySelector(selector)) == null || _a.setAttribute("dir", dir.value);
            else (_b = document1.querySelector(selector)) == null || _b.removeAttribute("dir");
        }
    });
}
function $cbe5e41a05e7dda8$var$getRangesFromSelection(selection) {
    var _a;
    const rangeCount = (_a = selection.rangeCount) != null ? _a : 0;
    return Array.from({
        length: rangeCount
    }, (_, i)=>selection.getRangeAt(i));
}
function $cbe5e41a05e7dda8$export$9c9cf404b65a1c0a(options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const selection = (0, $8bTPG.ref)(null);
    const text = (0, $8bTPG.computed)(()=>{
        var _a, _b;
        return (_b = (_a = selection.value) == null ? void 0 : _a.toString()) != null ? _b : "";
    });
    const ranges = (0, $8bTPG.computed)(()=>selection.value ? $cbe5e41a05e7dda8$var$getRangesFromSelection(selection.value) : []);
    const rects = (0, $8bTPG.computed)(()=>ranges.value.map((range)=>range.getBoundingClientRect()));
    function onSelectionChange() {
        selection.value = null;
        if (window1) selection.value = window1.getSelection();
    }
    if (window1) $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1.document, "selectionchange", onSelectionChange);
    return {
        text: text,
        rects: rects,
        ranges: ranges,
        selection: selection
    };
}
function $cbe5e41a05e7dda8$export$2e9ef3b733cccd07(options) {
    var _a;
    const textarea = (0, $8bTPG.ref)(options == null ? void 0 : options.element);
    const input = (0, $8bTPG.ref)(options == null ? void 0 : options.input);
    const styleProp = (_a = options == null ? void 0 : options.styleProp) != null ? _a : "height";
    const textareaScrollHeight = (0, $8bTPG.ref)(1);
    function triggerResize() {
        var _a2;
        if (!textarea.value) return;
        let height = "";
        textarea.value.style[styleProp] = "1px";
        textareaScrollHeight.value = (_a2 = textarea.value) == null ? void 0 : _a2.scrollHeight;
        if (options == null ? void 0 : options.styleTarget) (0, $ef9Nn.toValue)(options.styleTarget).style[styleProp] = `${textareaScrollHeight.value}px`;
        else height = `${textareaScrollHeight.value}px`;
        textarea.value.style[styleProp] = height;
    }
    (0, $ani5R.watch)([
        input,
        textarea
    ], ()=>(0, $ani5R.nextTick)(triggerResize), {
        immediate: true
    });
    (0, $ani5R.watch)(textareaScrollHeight, ()=>{
        var _a2;
        return (_a2 = options == null ? void 0 : options.onResize) == null ? void 0 : _a2.call(options);
    });
    $cbe5e41a05e7dda8$export$683480f191c0e3ea(textarea, ()=>triggerResize());
    if (options == null ? void 0 : options.watch) (0, $ani5R.watch)(options.watch, triggerResize, {
        immediate: true,
        deep: true
    });
    return {
        textarea: textarea,
        input: input,
        triggerResize: triggerResize
    };
}
function $cbe5e41a05e7dda8$export$55673c2843562e1(source, options = {}) {
    const { throttle: throttle = 200, trailing: trailing = true } = options;
    const filter = (0, $ef9Nn.throttleFilter)(throttle, trailing);
    const history = $cbe5e41a05e7dda8$export$de889b39e422efc4(source, {
        ...options,
        eventFilter: filter
    });
    return {
        ...history
    };
}
const $cbe5e41a05e7dda8$var$DEFAULT_UNITS = [
    {
        max: 6e4,
        value: 1e3,
        name: "second"
    },
    {
        max: 276e4,
        value: 6e4,
        name: "minute"
    },
    {
        max: 72e6,
        value: 36e5,
        name: "hour"
    },
    {
        max: 5184e5,
        value: 864e5,
        name: "day"
    },
    {
        max: 24192e5,
        value: 6048e5,
        name: "week"
    },
    {
        max: 28512e6,
        value: 2592e6,
        name: "month"
    },
    {
        max: Number.POSITIVE_INFINITY,
        value: 31536e6,
        name: "year"
    }
];
const $cbe5e41a05e7dda8$var$DEFAULT_MESSAGES = {
    justNow: "just now",
    past: (n)=>n.match(/\d/) ? `${n} ago` : n,
    future: (n)=>n.match(/\d/) ? `in ${n}` : n,
    month: (n, past)=>n === 1 ? past ? "last month" : "next month" : `${n} month${n > 1 ? "s" : ""}`,
    year: (n, past)=>n === 1 ? past ? "last year" : "next year" : `${n} year${n > 1 ? "s" : ""}`,
    day: (n, past)=>n === 1 ? past ? "yesterday" : "tomorrow" : `${n} day${n > 1 ? "s" : ""}`,
    week: (n, past)=>n === 1 ? past ? "last week" : "next week" : `${n} week${n > 1 ? "s" : ""}`,
    hour: (n)=>`${n} hour${n > 1 ? "s" : ""}`,
    minute: (n)=>`${n} minute${n > 1 ? "s" : ""}`,
    second: (n)=>`${n} second${n > 1 ? "s" : ""}`,
    invalid: ""
};
function $cbe5e41a05e7dda8$var$DEFAULT_FORMATTER(date) {
    return date.toISOString().slice(0, 10);
}
function $cbe5e41a05e7dda8$export$1deeb1050525eb40(time, options = {}) {
    const { controls: exposeControls = false, updateInterval: updateInterval = 3e4 } = options;
    const { now: now, ...controls } = $cbe5e41a05e7dda8$export$3a404aece3dff2fa({
        interval: updateInterval,
        controls: true
    });
    const timeAgo = (0, $8bTPG.computed)(()=>$cbe5e41a05e7dda8$export$78ae3e68d8c394bc(new Date((0, $ef9Nn.toValue)(time)), options, (0, $ef9Nn.toValue)(now)));
    if (exposeControls) return {
        timeAgo: timeAgo,
        ...controls
    };
    else return timeAgo;
}
function $cbe5e41a05e7dda8$export$78ae3e68d8c394bc(from, options = {}, now = Date.now()) {
    var _a;
    const { max: max, messages: messages = $cbe5e41a05e7dda8$var$DEFAULT_MESSAGES, fullDateFormatter: fullDateFormatter = $cbe5e41a05e7dda8$var$DEFAULT_FORMATTER, units: units = $cbe5e41a05e7dda8$var$DEFAULT_UNITS, showSecond: showSecond = false, rounding: rounding = "round" } = options;
    const roundFn = typeof rounding === "number" ? (n)=>+n.toFixed(rounding) : Math[rounding];
    const diff = +now - +from;
    const absDiff = Math.abs(diff);
    function getValue(diff2, unit) {
        return roundFn(Math.abs(diff2) / unit.value);
    }
    function format(diff2, unit) {
        const val = getValue(diff2, unit);
        const past = diff2 > 0;
        const str = applyFormat(unit.name, val, past);
        return applyFormat(past ? "past" : "future", str, past);
    }
    function applyFormat(name, val, isPast) {
        const formatter = messages[name];
        if (typeof formatter === "function") return formatter(val, isPast);
        return formatter.replace("{0}", val.toString());
    }
    if (absDiff < 6e4 && !showSecond) return messages.justNow;
    if (typeof max === "number" && absDiff > max) return fullDateFormatter(new Date(from));
    if (typeof max === "string") {
        const unitMax = (_a = units.find((i)=>i.name === max)) == null ? void 0 : _a.max;
        if (unitMax && absDiff > unitMax) return fullDateFormatter(new Date(from));
    }
    for (const [idx, unit] of units.entries()){
        const val = getValue(diff, unit);
        if (val <= 0 && units[idx - 1]) return format(diff, units[idx - 1]);
        if (absDiff < unit.max) return format(diff, unit);
    }
    return messages.invalid;
}
function $cbe5e41a05e7dda8$export$ce370d3d38ed4da0(fn, interval, timeoutPollOptions) {
    const { start: start } = (0, $ef9Nn.useTimeoutFn)(loop, interval, {
        immediate: false
    });
    const isActive = (0, $8bTPG.ref)(false);
    async function loop() {
        if (!isActive.value) return;
        await fn();
        start();
    }
    function resume() {
        if (!isActive.value) {
            isActive.value = true;
            loop();
        }
    }
    function pause() {
        isActive.value = false;
    }
    if (timeoutPollOptions == null ? void 0 : timeoutPollOptions.immediate) resume();
    (0, $ef9Nn.tryOnScopeDispose)(pause);
    return {
        isActive: isActive,
        pause: pause,
        resume: resume
    };
}
function $cbe5e41a05e7dda8$export$c4f6efe9f19a3a66(options = {}) {
    const { controls: exposeControls = false, offset: offset = 0, immediate: immediate = true, interval: interval = "requestAnimationFrame", callback: callback } = options;
    const ts = (0, $8bTPG.ref)((0, $ef9Nn.timestamp)() + offset);
    const update = ()=>ts.value = (0, $ef9Nn.timestamp)() + offset;
    const cb = callback ? ()=>{
        update();
        callback(ts.value);
    } : update;
    const controls = interval === "requestAnimationFrame" ? $cbe5e41a05e7dda8$export$13251e0fc79284e(cb, {
        immediate: immediate
    }) : (0, $ef9Nn.useIntervalFn)(cb, interval, {
        immediate: immediate
    });
    if (exposeControls) return {
        timestamp: ts,
        ...controls
    };
    else return ts;
}
function $cbe5e41a05e7dda8$export$bc98e171e8c82a3d(newTitle = null, options = {}) {
    var _a, _b, _c;
    const { document: document1 = $cbe5e41a05e7dda8$export$37990bd438d16af3, restoreOnUnmount: restoreOnUnmount = (t)=>t } = options;
    const originalTitle = (_a = document1 == null ? void 0 : document1.title) != null ? _a : "";
    const title = (0, $ef9Nn.toRef)((_b = newTitle != null ? newTitle : document1 == null ? void 0 : document1.title) != null ? _b : null);
    const isReadonly = newTitle && typeof newTitle === "function";
    function format(t) {
        if (!("titleTemplate" in options)) return t;
        const template = options.titleTemplate || "%s";
        return typeof template === "function" ? template(t) : (0, $ef9Nn.toValue)(template).replace(/%s/g, t);
    }
    (0, $ani5R.watch)(title, (t, o)=>{
        if (t !== o && document1) document1.title = format(typeof t === "string" ? t : "");
    }, {
        immediate: true
    });
    if (options.observe && !options.titleTemplate && document1 && !isReadonly) $cbe5e41a05e7dda8$export$8ecdcf3bb089e9cd((_c = document1.head) == null ? void 0 : _c.querySelector("title"), ()=>{
        if (document1 && document1.title !== title.value) title.value = format(document1.title);
    }, {
        childList: true
    });
    (0, $ef9Nn.tryOnBeforeUnmount)(()=>{
        if (restoreOnUnmount) {
            const restoredTitle = restoreOnUnmount(originalTitle, title.value || "");
            if (restoredTitle != null && document1) document1.title = restoredTitle;
        }
    });
    return title;
}
const $cbe5e41a05e7dda8$var$_TransitionPresets = {
    easeInSine: [
        0.12,
        0,
        0.39,
        0
    ],
    easeOutSine: [
        0.61,
        1,
        0.88,
        1
    ],
    easeInOutSine: [
        0.37,
        0,
        0.63,
        1
    ],
    easeInQuad: [
        0.11,
        0,
        0.5,
        0
    ],
    easeOutQuad: [
        0.5,
        1,
        0.89,
        1
    ],
    easeInOutQuad: [
        0.45,
        0,
        0.55,
        1
    ],
    easeInCubic: [
        0.32,
        0,
        0.67,
        0
    ],
    easeOutCubic: [
        0.33,
        1,
        0.68,
        1
    ],
    easeInOutCubic: [
        0.65,
        0,
        0.35,
        1
    ],
    easeInQuart: [
        0.5,
        0,
        0.75,
        0
    ],
    easeOutQuart: [
        0.25,
        1,
        0.5,
        1
    ],
    easeInOutQuart: [
        0.76,
        0,
        0.24,
        1
    ],
    easeInQuint: [
        0.64,
        0,
        0.78,
        0
    ],
    easeOutQuint: [
        0.22,
        1,
        0.36,
        1
    ],
    easeInOutQuint: [
        0.83,
        0,
        0.17,
        1
    ],
    easeInExpo: [
        0.7,
        0,
        0.84,
        0
    ],
    easeOutExpo: [
        0.16,
        1,
        0.3,
        1
    ],
    easeInOutExpo: [
        0.87,
        0,
        0.13,
        1
    ],
    easeInCirc: [
        0.55,
        0,
        1,
        0.45
    ],
    easeOutCirc: [
        0,
        0.55,
        0.45,
        1
    ],
    easeInOutCirc: [
        0.85,
        0,
        0.15,
        1
    ],
    easeInBack: [
        0.36,
        0,
        0.66,
        -0.56
    ],
    easeOutBack: [
        0.34,
        1.56,
        0.64,
        1
    ],
    easeInOutBack: [
        0.68,
        -0.6,
        0.32,
        1.6
    ]
};
const $cbe5e41a05e7dda8$export$a1745a8bb687f918 = /* @__PURE__ */ Object.assign({}, {
    linear: (0, $ef9Nn.identity)
}, $cbe5e41a05e7dda8$var$_TransitionPresets);
function $cbe5e41a05e7dda8$var$createEasingFunction([p0, p1, p2, p3]) {
    const a = (a1, a2)=>1 - 3 * a2 + 3 * a1;
    const b = (a1, a2)=>3 * a2 - 6 * a1;
    const c = (a1)=>3 * a1;
    const calcBezier = (t, a1, a2)=>((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
    const getSlope = (t, a1, a2)=>3 * a(a1, a2) * t * t + 2 * b(a1, a2) * t + c(a1);
    const getTforX = (x)=>{
        let aGuessT = x;
        for(let i = 0; i < 4; ++i){
            const currentSlope = getSlope(aGuessT, p0, p2);
            if (currentSlope === 0) return aGuessT;
            const currentX = calcBezier(aGuessT, p0, p2) - x;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    };
    return (x)=>p0 === p1 && p2 === p3 ? x : calcBezier(getTforX(x), p1, p3);
}
function $cbe5e41a05e7dda8$var$lerp(a, b, alpha) {
    return a + alpha * (b - a);
}
function $cbe5e41a05e7dda8$var$toVec(t) {
    return (typeof t === "number" ? [
        t
    ] : t) || [];
}
function $cbe5e41a05e7dda8$export$b82f7b6c1e4d2890(source, from, to, options = {}) {
    var _a, _b;
    const fromVal = (0, $ef9Nn.toValue)(from);
    const toVal = (0, $ef9Nn.toValue)(to);
    const v1 = $cbe5e41a05e7dda8$var$toVec(fromVal);
    const v2 = $cbe5e41a05e7dda8$var$toVec(toVal);
    const duration = (_a = (0, $ef9Nn.toValue)(options.duration)) != null ? _a : 1e3;
    const startedAt = Date.now();
    const endAt = Date.now() + duration;
    const trans = typeof options.transition === "function" ? options.transition : (_b = (0, $ef9Nn.toValue)(options.transition)) != null ? _b : (0, $ef9Nn.identity);
    const ease = typeof trans === "function" ? trans : $cbe5e41a05e7dda8$var$createEasingFunction(trans);
    return new Promise((resolve)=>{
        source.value = fromVal;
        const tick = ()=>{
            var _a2;
            if ((_a2 = options.abort) == null ? void 0 : _a2.call(options)) {
                resolve();
                return;
            }
            const now = Date.now();
            const alpha = ease((now - startedAt) / duration);
            const arr = $cbe5e41a05e7dda8$var$toVec(source.value).map((n, i)=>$cbe5e41a05e7dda8$var$lerp(v1[i], v2[i], alpha));
            if (Array.isArray(source.value)) source.value = arr.map((n, i)=>{
                var _a3, _b2;
                return $cbe5e41a05e7dda8$var$lerp((_a3 = v1[i]) != null ? _a3 : 0, (_b2 = v2[i]) != null ? _b2 : 0, alpha);
            });
            else if (typeof source.value === "number") source.value = arr[0];
            if (now < endAt) requestAnimationFrame(tick);
            else {
                source.value = toVal;
                resolve();
            }
        };
        tick();
    });
}
function $cbe5e41a05e7dda8$export$7b286972b8d8ccbf(source, options = {}) {
    let currentId = 0;
    const sourceVal = ()=>{
        const v = (0, $ef9Nn.toValue)(source);
        return typeof v === "number" ? v : v.map((0, $ef9Nn.toValue));
    };
    const outputRef = (0, $8bTPG.ref)(sourceVal());
    (0, $ani5R.watch)(sourceVal, async (to)=>{
        var _a, _b;
        if ((0, $ef9Nn.toValue)(options.disabled)) return;
        const id = ++currentId;
        if (options.delay) await (0, $ef9Nn.promiseTimeout)((0, $ef9Nn.toValue)(options.delay));
        if (id !== currentId) return;
        const toVal = Array.isArray(to) ? to.map((0, $ef9Nn.toValue)) : (0, $ef9Nn.toValue)(to);
        (_a = options.onStarted) == null || _a.call(options);
        await $cbe5e41a05e7dda8$export$b82f7b6c1e4d2890(outputRef, outputRef.value, toVal, {
            ...options,
            abort: ()=>{
                var _a2;
                return id !== currentId || ((_a2 = options.abort) == null ? void 0 : _a2.call(options));
            }
        });
        (_b = options.onFinished) == null || _b.call(options);
    }, {
        deep: true
    });
    (0, $ani5R.watch)(()=>(0, $ef9Nn.toValue)(options.disabled), (disabled)=>{
        if (disabled) {
            currentId++;
            outputRef.value = sourceVal();
        }
    });
    (0, $ef9Nn.tryOnScopeDispose)(()=>{
        currentId++;
    });
    return (0, $8bTPG.computed)(()=>(0, $ef9Nn.toValue)(options.disabled) ? sourceVal() : outputRef.value);
}
function $cbe5e41a05e7dda8$export$a64580081d23e3b8(mode = "history", options = {}) {
    const { initialValue: initialValue = {}, removeNullishValues: removeNullishValues = true, removeFalsyValues: removeFalsyValues = false, write: enableWrite = true, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    if (!window1) return (0, $8bTPG.reactive)(initialValue);
    const state = (0, $8bTPG.reactive)({});
    function getRawParams() {
        if (mode === "history") return window1.location.search || "";
        else if (mode === "hash") {
            const hash = window1.location.hash || "";
            const index = hash.indexOf("?");
            return index > 0 ? hash.slice(index) : "";
        } else return (window1.location.hash || "").replace(/^#/, "");
    }
    function constructQuery(params) {
        const stringified = params.toString();
        if (mode === "history") return `${stringified ? `?${stringified}` : ""}${window1.location.hash || ""}`;
        if (mode === "hash-params") return `${window1.location.search || ""}${stringified ? `#${stringified}` : ""}`;
        const hash = window1.location.hash || "#";
        const index = hash.indexOf("?");
        if (index > 0) return `${hash.slice(0, index)}${stringified ? `?${stringified}` : ""}`;
        return `${hash}${stringified ? `?${stringified}` : ""}`;
    }
    function read() {
        return new URLSearchParams(getRawParams());
    }
    function updateState(params) {
        const unusedKeys = new Set(Object.keys(state));
        for (const key of params.keys()){
            const paramsForKey = params.getAll(key);
            state[key] = paramsForKey.length > 1 ? paramsForKey : params.get(key) || "";
            unusedKeys.delete(key);
        }
        Array.from(unusedKeys).forEach((key)=>delete state[key]);
    }
    const { pause: pause, resume: resume } = (0, $ef9Nn.pausableWatch)(state, ()=>{
        const params = new URLSearchParams("");
        Object.keys(state).forEach((key)=>{
            const mapEntry = state[key];
            if (Array.isArray(mapEntry)) mapEntry.forEach((value)=>params.append(key, value));
            else if (removeNullishValues && mapEntry == null) params.delete(key);
            else if (removeFalsyValues && !mapEntry) params.delete(key);
            else params.set(key, mapEntry);
        });
        write(params);
    }, {
        deep: true
    });
    function write(params, shouldUpdate) {
        pause();
        if (shouldUpdate) updateState(params);
        window1.history.replaceState(window1.history.state, window1.document.title, window1.location.pathname + constructQuery(params));
        resume();
    }
    function onChanged() {
        if (!enableWrite) return;
        write(read(), true);
    }
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "popstate", onChanged, false);
    if (mode !== "history") $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "hashchange", onChanged, false);
    const initial = read();
    if (initial.keys().next().value) updateState(initial);
    else Object.assign(state, initialValue);
    return state;
}
function $cbe5e41a05e7dda8$export$a16ee9849ed85b4e(options = {}) {
    var _a, _b;
    const enabled = (0, $8bTPG.ref)((_a = options.enabled) != null ? _a : false);
    const autoSwitch = (0, $8bTPG.ref)((_b = options.autoSwitch) != null ? _b : true);
    const constraints = (0, $8bTPG.ref)(options.constraints);
    const { navigator: navigator = $cbe5e41a05e7dda8$export$eade61489f57e3fc } = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>{
        var _a2;
        return (_a2 = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : _a2.getUserMedia;
    });
    const stream = (0, $8bTPG.shallowRef)();
    function getDeviceOptions(type) {
        switch(type){
            case "video":
                if (constraints.value) return constraints.value.video || false;
                break;
            case "audio":
                if (constraints.value) return constraints.value.audio || false;
                break;
        }
    }
    async function _start() {
        if (!isSupported.value || stream.value) return;
        stream.value = await navigator.mediaDevices.getUserMedia({
            video: getDeviceOptions("video"),
            audio: getDeviceOptions("audio")
        });
        return stream.value;
    }
    function _stop() {
        var _a2;
        (_a2 = stream.value) == null || _a2.getTracks().forEach((t)=>t.stop());
        stream.value = void 0;
    }
    function stop() {
        _stop();
        enabled.value = false;
    }
    async function start() {
        await _start();
        if (stream.value) enabled.value = true;
        return stream.value;
    }
    async function restart() {
        _stop();
        return await start();
    }
    (0, $ani5R.watch)(enabled, (v)=>{
        if (v) _start();
        else _stop();
    }, {
        immediate: true
    });
    (0, $ani5R.watch)(constraints, ()=>{
        if (autoSwitch.value && stream.value) restart();
    }, {
        immediate: true
    });
    (0, $ef9Nn.tryOnScopeDispose)(()=>{
        stop();
    });
    return {
        isSupported: isSupported,
        stream: stream,
        start: start,
        stop: stop,
        restart: restart,
        constraints: constraints,
        enabled: enabled,
        autoSwitch: autoSwitch
    };
}
function $cbe5e41a05e7dda8$export$42662bab1b538e5(props, key, emit, options = {}) {
    var _a, _b, _c, _d, _e;
    const { clone: clone = false, passive: passive = false, eventName: eventName, deep: deep = false, defaultValue: defaultValue, shouldEmit: shouldEmit } = options;
    const vm = (0, $ani5R.getCurrentInstance)();
    const _emit = emit || (vm == null ? void 0 : vm.emit) || ((_a = vm == null ? void 0 : vm.$emit) == null ? void 0 : _a.bind(vm)) || ((_c = (_b = vm == null ? void 0 : vm.proxy) == null ? void 0 : _b.$emit) == null ? void 0 : _c.bind(vm == null ? void 0 : vm.proxy));
    let event = eventName;
    if (!key) {
        if (0, $j40Rs.isVue2) {
            const modelOptions = (_e = (_d = vm == null ? void 0 : vm.proxy) == null ? void 0 : _d.$options) == null ? void 0 : _e.model;
            key = (modelOptions == null ? void 0 : modelOptions.value) || "value";
            if (!eventName) event = (modelOptions == null ? void 0 : modelOptions.event) || "input";
        } else key = "modelValue";
    }
    event = event || `update:${key.toString()}`;
    const cloneFn = (val)=>!clone ? val : typeof clone === "function" ? clone(val) : $cbe5e41a05e7dda8$export$9e72043f8ff3a3df(val);
    const getValue = ()=>(0, $ef9Nn.isDef)(props[key]) ? cloneFn(props[key]) : defaultValue;
    const triggerEmit = (value)=>{
        if (shouldEmit) {
            if (shouldEmit(value)) _emit(event, value);
        } else _emit(event, value);
    };
    if (passive) {
        const initialValue = getValue();
        const proxy = (0, $8bTPG.ref)(initialValue);
        let isUpdating = false;
        (0, $ani5R.watch)(()=>props[key], (v)=>{
            if (!isUpdating) {
                isUpdating = true;
                proxy.value = cloneFn(v);
                (0, $ani5R.nextTick)(()=>isUpdating = false);
            }
        });
        (0, $ani5R.watch)(proxy, (v)=>{
            if (!isUpdating && (v !== props[key] || deep)) triggerEmit(v);
        }, {
            deep: deep
        });
        return proxy;
    } else return (0, $8bTPG.computed)({
        get () {
            return getValue();
        },
        set (value) {
            triggerEmit(value);
        }
    });
}
function $cbe5e41a05e7dda8$export$b020cc6dc10339b9(props, emit, options = {}) {
    const ret = {};
    for(const key in props)ret[key] = $cbe5e41a05e7dda8$export$42662bab1b538e5(props, key, emit, options);
    return ret;
}
function $cbe5e41a05e7dda8$export$165ce7a5158a386d(options) {
    const { pattern: pattern = [], interval: interval = 0, navigator: navigator = $cbe5e41a05e7dda8$export$eade61489f57e3fc } = options || {};
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>typeof navigator !== "undefined" && "vibrate" in navigator);
    const patternRef = (0, $ef9Nn.toRef)(pattern);
    let intervalControls;
    const vibrate = (pattern2 = patternRef.value)=>{
        if (isSupported.value) navigator.vibrate(pattern2);
    };
    const stop = ()=>{
        if (isSupported.value) navigator.vibrate(0);
        intervalControls == null || intervalControls.pause();
    };
    if (interval > 0) intervalControls = (0, $ef9Nn.useIntervalFn)(vibrate, interval, {
        immediate: false,
        immediateCallback: false
    });
    return {
        isSupported: isSupported,
        pattern: pattern,
        intervalControls: intervalControls,
        vibrate: vibrate,
        stop: stop
    };
}
function $cbe5e41a05e7dda8$export$e0cfc61c348fbd34(list, options) {
    const { containerStyle: containerStyle, wrapperProps: wrapperProps, scrollTo: scrollTo1, calculateRange: calculateRange, currentList: currentList, containerRef: containerRef } = "itemHeight" in options ? $cbe5e41a05e7dda8$var$useVerticalVirtualList(options, list) : $cbe5e41a05e7dda8$var$useHorizontalVirtualList(options, list);
    return {
        list: currentList,
        scrollTo: scrollTo1,
        containerProps: {
            ref: containerRef,
            onScroll: ()=>{
                calculateRange();
            },
            style: containerStyle
        },
        wrapperProps: wrapperProps
    };
}
function $cbe5e41a05e7dda8$var$useVirtualListResources(list) {
    const containerRef = (0, $8bTPG.ref)(null);
    const size = $cbe5e41a05e7dda8$export$2b86bedf890eab8(containerRef);
    const currentList = (0, $8bTPG.ref)([]);
    const source = (0, $8bTPG.shallowRef)(list);
    const state = (0, $8bTPG.ref)({
        start: 0,
        end: 10
    });
    return {
        state: state,
        source: source,
        currentList: currentList,
        size: size,
        containerRef: containerRef
    };
}
function $cbe5e41a05e7dda8$var$createGetViewCapacity(state, source, itemSize) {
    return (containerSize)=>{
        if (typeof itemSize === "number") return Math.ceil(containerSize / itemSize);
        const { start: start = 0 } = state.value;
        let sum = 0;
        let capacity = 0;
        for(let i = start; i < source.value.length; i++){
            const size = itemSize(i);
            sum += size;
            capacity = i;
            if (sum > containerSize) break;
        }
        return capacity - start;
    };
}
function $cbe5e41a05e7dda8$var$createGetOffset(source, itemSize) {
    return (scrollDirection)=>{
        if (typeof itemSize === "number") return Math.floor(scrollDirection / itemSize) + 1;
        let sum = 0;
        let offset = 0;
        for(let i = 0; i < source.value.length; i++){
            const size = itemSize(i);
            sum += size;
            if (sum >= scrollDirection) {
                offset = i;
                break;
            }
        }
        return offset + 1;
    };
}
function $cbe5e41a05e7dda8$var$createCalculateRange(type, overscan, getOffset, getViewCapacity, { containerRef: containerRef, state: state, currentList: currentList, source: source }) {
    return ()=>{
        const element = containerRef.value;
        if (element) {
            const offset = getOffset(type === "vertical" ? element.scrollTop : element.scrollLeft);
            const viewCapacity = getViewCapacity(type === "vertical" ? element.clientHeight : element.clientWidth);
            const from = offset - overscan;
            const to = offset + viewCapacity + overscan;
            state.value = {
                start: from < 0 ? 0 : from,
                end: to > source.value.length ? source.value.length : to
            };
            currentList.value = source.value.slice(state.value.start, state.value.end).map((ele, index)=>({
                    data: ele,
                    index: index + state.value.start
                }));
        }
    };
}
function $cbe5e41a05e7dda8$var$createGetDistance(itemSize, source) {
    return (index)=>{
        if (typeof itemSize === "number") {
            const size2 = index * itemSize;
            return size2;
        }
        const size = source.value.slice(0, index).reduce((sum, _, i)=>sum + itemSize(i), 0);
        return size;
    };
}
function $cbe5e41a05e7dda8$var$useWatchForSizes(size, list, containerRef, calculateRange) {
    (0, $ani5R.watch)([
        size.width,
        size.height,
        list,
        containerRef
    ], ()=>{
        calculateRange();
    });
}
function $cbe5e41a05e7dda8$var$createComputedTotalSize(itemSize, source) {
    return (0, $8bTPG.computed)(()=>{
        if (typeof itemSize === "number") return source.value.length * itemSize;
        return source.value.reduce((sum, _, index)=>sum + itemSize(index), 0);
    });
}
const $cbe5e41a05e7dda8$var$scrollToDictionaryForElementScrollKey = {
    horizontal: "scrollLeft",
    vertical: "scrollTop"
};
function $cbe5e41a05e7dda8$var$createScrollTo(type, calculateRange, getDistance, containerRef) {
    return (index)=>{
        if (containerRef.value) {
            containerRef.value[$cbe5e41a05e7dda8$var$scrollToDictionaryForElementScrollKey[type]] = getDistance(index);
            calculateRange();
        }
    };
}
function $cbe5e41a05e7dda8$var$useHorizontalVirtualList(options, list) {
    const resources = $cbe5e41a05e7dda8$var$useVirtualListResources(list);
    const { state: state, source: source, currentList: currentList, size: size, containerRef: containerRef } = resources;
    const containerStyle = {
        overflowX: "auto"
    };
    const { itemWidth: itemWidth, overscan: overscan = 5 } = options;
    const getViewCapacity = $cbe5e41a05e7dda8$var$createGetViewCapacity(state, source, itemWidth);
    const getOffset = $cbe5e41a05e7dda8$var$createGetOffset(source, itemWidth);
    const calculateRange = $cbe5e41a05e7dda8$var$createCalculateRange("horizontal", overscan, getOffset, getViewCapacity, resources);
    const getDistanceLeft = $cbe5e41a05e7dda8$var$createGetDistance(itemWidth, source);
    const offsetLeft = (0, $8bTPG.computed)(()=>getDistanceLeft(state.value.start));
    const totalWidth = $cbe5e41a05e7dda8$var$createComputedTotalSize(itemWidth, source);
    $cbe5e41a05e7dda8$var$useWatchForSizes(size, list, containerRef, calculateRange);
    const scrollTo1 = $cbe5e41a05e7dda8$var$createScrollTo("horizontal", calculateRange, getDistanceLeft, containerRef);
    const wrapperProps = (0, $8bTPG.computed)(()=>{
        return {
            style: {
                height: "100%",
                width: `${totalWidth.value - offsetLeft.value}px`,
                marginLeft: `${offsetLeft.value}px`,
                display: "flex"
            }
        };
    });
    return {
        scrollTo: scrollTo1,
        calculateRange: calculateRange,
        wrapperProps: wrapperProps,
        containerStyle: containerStyle,
        currentList: currentList,
        containerRef: containerRef
    };
}
function $cbe5e41a05e7dda8$var$useVerticalVirtualList(options, list) {
    const resources = $cbe5e41a05e7dda8$var$useVirtualListResources(list);
    const { state: state, source: source, currentList: currentList, size: size, containerRef: containerRef } = resources;
    const containerStyle = {
        overflowY: "auto"
    };
    const { itemHeight: itemHeight, overscan: overscan = 5 } = options;
    const getViewCapacity = $cbe5e41a05e7dda8$var$createGetViewCapacity(state, source, itemHeight);
    const getOffset = $cbe5e41a05e7dda8$var$createGetOffset(source, itemHeight);
    const calculateRange = $cbe5e41a05e7dda8$var$createCalculateRange("vertical", overscan, getOffset, getViewCapacity, resources);
    const getDistanceTop = $cbe5e41a05e7dda8$var$createGetDistance(itemHeight, source);
    const offsetTop = (0, $8bTPG.computed)(()=>getDistanceTop(state.value.start));
    const totalHeight = $cbe5e41a05e7dda8$var$createComputedTotalSize(itemHeight, source);
    $cbe5e41a05e7dda8$var$useWatchForSizes(size, list, containerRef, calculateRange);
    const scrollTo1 = $cbe5e41a05e7dda8$var$createScrollTo("vertical", calculateRange, getDistanceTop, containerRef);
    const wrapperProps = (0, $8bTPG.computed)(()=>{
        return {
            style: {
                width: "100%",
                height: `${totalHeight.value - offsetTop.value}px`,
                marginTop: `${offsetTop.value}px`
            }
        };
    });
    return {
        calculateRange: calculateRange,
        scrollTo: scrollTo1,
        containerStyle: containerStyle,
        wrapperProps: wrapperProps,
        currentList: currentList,
        containerRef: containerRef
    };
}
function $cbe5e41a05e7dda8$export$73321d658b51e565(options = {}) {
    const { navigator: navigator = $cbe5e41a05e7dda8$export$eade61489f57e3fc, document: document1 = $cbe5e41a05e7dda8$export$37990bd438d16af3 } = options;
    let wakeLock;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>navigator && "wakeLock" in navigator);
    const isActive = (0, $8bTPG.ref)(false);
    async function onVisibilityChange() {
        if (!isSupported.value || !wakeLock) return;
        if (document1 && document1.visibilityState === "visible") wakeLock = await navigator.wakeLock.request("screen");
        isActive.value = !wakeLock.released;
    }
    if (document1) $cbe5e41a05e7dda8$export$7080b3e976bc91ab(document1, "visibilitychange", onVisibilityChange, {
        passive: true
    });
    async function request(type) {
        if (!isSupported.value) return;
        wakeLock = await navigator.wakeLock.request(type);
        isActive.value = !wakeLock.released;
    }
    async function release() {
        if (!isSupported.value || !wakeLock) return;
        await wakeLock.release();
        isActive.value = !wakeLock.released;
        wakeLock = null;
    }
    return {
        isSupported: isSupported,
        isActive: isActive,
        request: request,
        release: release
    };
}
function $cbe5e41a05e7dda8$export$522fa265139e12a1(options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, requestPermissions: _requestForPermissions = true } = options;
    const defaultWebNotificationOptions = options;
    const isSupported = $cbe5e41a05e7dda8$export$85904d4478b9c8a4(()=>{
        if (!window1 || !("Notification" in window1)) return false;
        try {
            new Notification("");
        } catch (e) {
            return false;
        }
        return true;
    });
    const permissionGranted = (0, $8bTPG.ref)(isSupported.value && "permission" in Notification && Notification.permission === "granted");
    const notification = (0, $8bTPG.ref)(null);
    const ensurePermissions = async ()=>{
        if (!isSupported.value) return;
        if (!permissionGranted.value && Notification.permission !== "denied") {
            const result = await Notification.requestPermission();
            if (result === "granted") permissionGranted.value = true;
        }
        return permissionGranted.value;
    };
    const { on: onClick, trigger: clickTrigger } = (0, $ef9Nn.createEventHook)();
    const { on: onShow, trigger: showTrigger } = (0, $ef9Nn.createEventHook)();
    const { on: onError, trigger: errorTrigger } = (0, $ef9Nn.createEventHook)();
    const { on: onClose, trigger: closeTrigger } = (0, $ef9Nn.createEventHook)();
    const show = async (overrides)=>{
        if (!isSupported.value || !permissionGranted.value) return;
        const options2 = Object.assign({}, defaultWebNotificationOptions, overrides);
        notification.value = new Notification(options2.title || "", options2);
        notification.value.onclick = clickTrigger;
        notification.value.onshow = showTrigger;
        notification.value.onerror = errorTrigger;
        notification.value.onclose = closeTrigger;
        return notification.value;
    };
    const close = ()=>{
        if (notification.value) notification.value.close();
        notification.value = null;
    };
    if (_requestForPermissions) (0, $ef9Nn.tryOnMounted)(ensurePermissions);
    (0, $ef9Nn.tryOnScopeDispose)(close);
    if (isSupported.value && window1) {
        const document1 = window1.document;
        $cbe5e41a05e7dda8$export$7080b3e976bc91ab(document1, "visibilitychange", (e)=>{
            e.preventDefault();
            if (document1.visibilityState === "visible") close();
        });
    }
    return {
        isSupported: isSupported,
        notification: notification,
        ensurePermissions: ensurePermissions,
        permissionGranted: permissionGranted,
        show: show,
        close: close,
        onClick: onClick,
        onShow: onShow,
        onError: onError,
        onClose: onClose
    };
}
const $cbe5e41a05e7dda8$var$DEFAULT_PING_MESSAGE = "ping";
function $cbe5e41a05e7dda8$var$resolveNestedOptions(options) {
    if (options === true) return {};
    return options;
}
function $cbe5e41a05e7dda8$export$ef4944d05bd3db0(url, options = {}) {
    const { onConnected: onConnected, onDisconnected: onDisconnected, onError: onError, onMessage: onMessage, immediate: immediate = true, autoClose: autoClose = true, protocols: protocols = [] } = options;
    const data = (0, $8bTPG.ref)(null);
    const status = (0, $8bTPG.ref)("CLOSED");
    const wsRef = (0, $8bTPG.ref)();
    const urlRef = (0, $ef9Nn.toRef)(url);
    let heartbeatPause;
    let heartbeatResume;
    let explicitlyClosed = false;
    let retried = 0;
    let bufferedData = [];
    let pongTimeoutWait;
    const _sendBuffer = ()=>{
        if (bufferedData.length && wsRef.value && status.value === "OPEN") {
            for (const buffer of bufferedData)wsRef.value.send(buffer);
            bufferedData = [];
        }
    };
    const resetHeartbeat = ()=>{
        clearTimeout(pongTimeoutWait);
        pongTimeoutWait = void 0;
    };
    const close = (code = 1e3, reason)=>{
        if (!(0, $ef9Nn.isClient) || !wsRef.value) return;
        explicitlyClosed = true;
        resetHeartbeat();
        heartbeatPause == null || heartbeatPause();
        wsRef.value.close(code, reason);
        wsRef.value = void 0;
    };
    const send = (data2, useBuffer = true)=>{
        if (!wsRef.value || status.value !== "OPEN") {
            if (useBuffer) bufferedData.push(data2);
            return false;
        }
        _sendBuffer();
        wsRef.value.send(data2);
        return true;
    };
    const _init = ()=>{
        if (explicitlyClosed || typeof urlRef.value === "undefined") return;
        const ws = new WebSocket(urlRef.value, protocols);
        wsRef.value = ws;
        status.value = "CONNECTING";
        ws.onopen = ()=>{
            status.value = "OPEN";
            onConnected == null || onConnected(ws);
            heartbeatResume == null || heartbeatResume();
            _sendBuffer();
        };
        ws.onclose = (ev)=>{
            status.value = "CLOSED";
            onDisconnected == null || onDisconnected(ws, ev);
            if (!explicitlyClosed && options.autoReconnect) {
                const { retries: retries = -1, delay: delay = 1e3, onFailed: onFailed } = $cbe5e41a05e7dda8$var$resolveNestedOptions(options.autoReconnect);
                retried += 1;
                if (typeof retries === "number" && (retries < 0 || retried < retries)) setTimeout(_init, delay);
                else if (typeof retries === "function" && retries()) setTimeout(_init, delay);
                else onFailed == null || onFailed();
            }
        };
        ws.onerror = (e)=>{
            onError == null || onError(ws, e);
        };
        ws.onmessage = (e)=>{
            if (options.heartbeat) {
                resetHeartbeat();
                const { message: message = $cbe5e41a05e7dda8$var$DEFAULT_PING_MESSAGE } = $cbe5e41a05e7dda8$var$resolveNestedOptions(options.heartbeat);
                if (e.data === message) return;
            }
            data.value = e.data;
            onMessage == null || onMessage(ws, e);
        };
    };
    if (options.heartbeat) {
        const { message: message = $cbe5e41a05e7dda8$var$DEFAULT_PING_MESSAGE, interval: interval = 1e3, pongTimeout: pongTimeout = 1e3 } = $cbe5e41a05e7dda8$var$resolveNestedOptions(options.heartbeat);
        const { pause: pause, resume: resume } = (0, $ef9Nn.useIntervalFn)(()=>{
            send(message, false);
            if (pongTimeoutWait != null) return;
            pongTimeoutWait = setTimeout(()=>{
                close();
                explicitlyClosed = false;
            }, pongTimeout);
        }, interval, {
            immediate: false
        });
        heartbeatPause = pause;
        heartbeatResume = resume;
    }
    if (autoClose) {
        if (0, $ef9Nn.isClient) $cbe5e41a05e7dda8$export$7080b3e976bc91ab("beforeunload", ()=>close());
        (0, $ef9Nn.tryOnScopeDispose)(close);
    }
    const open = ()=>{
        if (!(0, $ef9Nn.isClient) && !(0, $ef9Nn.isWorker)) return;
        close();
        explicitlyClosed = false;
        retried = 0;
        _init();
    };
    if (immediate) open();
    (0, $ani5R.watch)(urlRef, open);
    return {
        data: data,
        status: status,
        close: close,
        send: send,
        open: open,
        ws: wsRef
    };
}
function $cbe5e41a05e7dda8$export$44bc62d25eb3a976(arg0, workerOptions, options) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options != null ? options : {};
    const data = (0, $8bTPG.ref)(null);
    const worker = (0, $8bTPG.shallowRef)();
    const post = (...args)=>{
        if (!worker.value) return;
        worker.value.postMessage(...args);
    };
    const terminate = function terminate2() {
        if (!worker.value) return;
        worker.value.terminate();
    };
    if (window1) {
        if (typeof arg0 === "string") worker.value = new Worker(arg0, workerOptions);
        else if (typeof arg0 === "function") worker.value = arg0();
        else worker.value = arg0;
        worker.value.onmessage = (e)=>{
            data.value = e.data;
        };
        (0, $ef9Nn.tryOnScopeDispose)(()=>{
            if (worker.value) worker.value.terminate();
        });
    }
    return {
        data: data,
        post: post,
        terminate: terminate,
        worker: worker
    };
}
function $cbe5e41a05e7dda8$var$jobRunner(userFunc) {
    return (e)=>{
        const userFuncArgs = e.data[0];
        return Promise.resolve(userFunc.apply(void 0, userFuncArgs)).then((result)=>{
            postMessage([
                "SUCCESS",
                result
            ]);
        }).catch((error)=>{
            postMessage([
                "ERROR",
                error
            ]);
        });
    };
}
function $cbe5e41a05e7dda8$var$depsParser(deps, localDeps) {
    if (deps.length === 0 && localDeps.length === 0) return "";
    const depsString = deps.map((dep)=>`'${dep}'`).toString();
    const depsFunctionString = localDeps.filter((dep)=>typeof dep === "function").map((fn)=>{
        const str = fn.toString();
        if (str.trim().startsWith("function")) return str;
        else {
            const name = fn.name;
            return `const ${name} = ${str}`;
        }
    }).join(";");
    const importString = `importScripts(${depsString});`;
    return `${depsString.trim() === "" ? "" : importString} ${depsFunctionString}`;
}
function $cbe5e41a05e7dda8$var$createWorkerBlobUrl(fn, deps, localDeps) {
    const blobCode = `${$cbe5e41a05e7dda8$var$depsParser(deps, localDeps)}; onmessage=(${$cbe5e41a05e7dda8$var$jobRunner})(${fn})`;
    const blob = new Blob([
        blobCode
    ], {
        type: "text/javascript"
    });
    const url = URL.createObjectURL(blob);
    return url;
}
function $cbe5e41a05e7dda8$export$33b1fcfcd57b961(fn, options = {}) {
    const { dependencies: dependencies = [], localDependencies: localDependencies = [], timeout: timeout, window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    const worker = (0, $8bTPG.ref)();
    const workerStatus = (0, $8bTPG.ref)("PENDING");
    const promise = (0, $8bTPG.ref)({});
    const timeoutId = (0, $8bTPG.ref)();
    const workerTerminate = (status = "PENDING")=>{
        if (worker.value && worker.value._url && window1) {
            worker.value.terminate();
            URL.revokeObjectURL(worker.value._url);
            promise.value = {};
            worker.value = void 0;
            window1.clearTimeout(timeoutId.value);
            workerStatus.value = status;
        }
    };
    workerTerminate();
    (0, $ef9Nn.tryOnScopeDispose)(workerTerminate);
    const generateWorker = ()=>{
        const blobUrl = $cbe5e41a05e7dda8$var$createWorkerBlobUrl(fn, dependencies, localDependencies);
        const newWorker = new Worker(blobUrl);
        newWorker._url = blobUrl;
        newWorker.onmessage = (e)=>{
            const { resolve: resolve = ()=>{}, reject: reject = ()=>{} } = promise.value;
            const [status, result] = e.data;
            switch(status){
                case "SUCCESS":
                    resolve(result);
                    workerTerminate(status);
                    break;
                default:
                    reject(result);
                    workerTerminate("ERROR");
                    break;
            }
        };
        newWorker.onerror = (e)=>{
            const { reject: reject = ()=>{} } = promise.value;
            e.preventDefault();
            reject(e);
            workerTerminate("ERROR");
        };
        if (timeout) timeoutId.value = setTimeout(()=>workerTerminate("TIMEOUT_EXPIRED"), timeout);
        return newWorker;
    };
    const callWorker = (...fnArgs)=>new Promise((resolve, reject)=>{
            promise.value = {
                resolve: resolve,
                reject: reject
            };
            worker.value && worker.value.postMessage([
                [
                    ...fnArgs
                ]
            ]);
            workerStatus.value = "RUNNING";
        });
    const workerFn = (...fnArgs)=>{
        if (workerStatus.value === "RUNNING") {
            console.error("[useWebWorkerFn] You can only run one instance of the worker at a time.");
            return Promise.reject();
        }
        worker.value = generateWorker();
        return callWorker(...fnArgs);
    };
    return {
        workerFn: workerFn,
        workerStatus: workerStatus,
        workerTerminate: workerTerminate
    };
}
function $cbe5e41a05e7dda8$export$e838b63e89f8751e(options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a } = options;
    if (!window1) return (0, $8bTPG.ref)(false);
    const focused = (0, $8bTPG.ref)(window1.document.hasFocus());
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "blur", ()=>{
        focused.value = false;
    });
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "focus", ()=>{
        focused.value = true;
    });
    return focused;
}
function $cbe5e41a05e7dda8$export$c510e5ca8a22f2a1(options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, behavior: behavior = "auto" } = options;
    if (!window1) return {
        x: (0, $8bTPG.ref)(0),
        y: (0, $8bTPG.ref)(0)
    };
    const internalX = (0, $8bTPG.ref)(window1.scrollX);
    const internalY = (0, $8bTPG.ref)(window1.scrollY);
    const x = (0, $8bTPG.computed)({
        get () {
            return internalX.value;
        },
        set (x2) {
            scrollTo({
                left: x2,
                behavior: behavior
            });
        }
    });
    const y = (0, $8bTPG.computed)({
        get () {
            return internalY.value;
        },
        set (y2) {
            scrollTo({
                top: y2,
                behavior: behavior
            });
        }
    });
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab(window1, "scroll", ()=>{
        internalX.value = window1.scrollX;
        internalY.value = window1.scrollY;
    }, {
        capture: false,
        passive: true
    });
    return {
        x: x,
        y: y
    };
}
function $cbe5e41a05e7dda8$export$42c02f33970a2afa(options = {}) {
    const { window: window1 = $cbe5e41a05e7dda8$export$16f8ba610718ae4a, initialWidth: initialWidth = Number.POSITIVE_INFINITY, initialHeight: initialHeight = Number.POSITIVE_INFINITY, listenOrientation: listenOrientation = true, includeScrollbar: includeScrollbar = true } = options;
    const width = (0, $8bTPG.ref)(initialWidth);
    const height = (0, $8bTPG.ref)(initialHeight);
    const update = ()=>{
        if (window1) {
            if (includeScrollbar) {
                width.value = window1.innerWidth;
                height.value = window1.innerHeight;
            } else {
                width.value = window1.document.documentElement.clientWidth;
                height.value = window1.document.documentElement.clientHeight;
            }
        }
    };
    update();
    (0, $ef9Nn.tryOnMounted)(update);
    $cbe5e41a05e7dda8$export$7080b3e976bc91ab("resize", update, {
        passive: true
    });
    if (listenOrientation) {
        const matches = $cbe5e41a05e7dda8$export$32d5543ab307c01("(orientation: portrait)");
        (0, $ani5R.watch)(matches, ()=>update());
    }
    return {
        width: width,
        height: height
    };
}

});
parcelRegister("ef9Nn", function(module, exports) {

$parcel$export(module.exports, "computedWithControl", () => $533945e69be6c784$export$220dfb31330e2956);
$parcel$export(module.exports, "tryOnScopeDispose", () => $533945e69be6c784$export$c3d49ae4e58d3d9d);
$parcel$export(module.exports, "createEventHook", () => $533945e69be6c784$export$c8b3b0996d763ee);
$parcel$export(module.exports, "makeDestructurable", () => $533945e69be6c784$export$d50fdd10db75504e);
$parcel$export(module.exports, "toValue", () => $533945e69be6c784$export$30bdcc2218aa9458);
$parcel$export(module.exports, "isClient", () => $533945e69be6c784$export$7383f122bf48ec30);
$parcel$export(module.exports, "isWorker", () => $533945e69be6c784$export$3c901a5f01941a06);
$parcel$export(module.exports, "isDef", () => $533945e69be6c784$export$7b816c9b8ecf71b4);
$parcel$export(module.exports, "notNullish", () => $533945e69be6c784$export$aedb69ff3e31596c);
$parcel$export(module.exports, "isObject", () => $533945e69be6c784$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "timestamp", () => $533945e69be6c784$export$fc00ee57782020aa);
$parcel$export(module.exports, "clamp", () => $533945e69be6c784$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "noop", () => $533945e69be6c784$export$8793edee2d425525);
$parcel$export(module.exports, "hasOwn", () => $533945e69be6c784$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isIOS", () => $533945e69be6c784$export$fedb369cb70207f1);
$parcel$export(module.exports, "createFilterWrapper", () => $533945e69be6c784$export$a1f1cf91007f23bf);
$parcel$export(module.exports, "bypassFilter", () => $533945e69be6c784$export$8cc0e33a27868391);
$parcel$export(module.exports, "debounceFilter", () => $533945e69be6c784$export$fca2c450ae03b38e);
$parcel$export(module.exports, "throttleFilter", () => $533945e69be6c784$export$cd62e9dbf204fd92);
$parcel$export(module.exports, "pausableFilter", () => $533945e69be6c784$export$8d46ce8e0ead9c2b);
$parcel$export(module.exports, "camelize", () => $533945e69be6c784$export$161d051f5dd25de7);
$parcel$export(module.exports, "promiseTimeout", () => $533945e69be6c784$export$69e8b3daf72c74b7);
$parcel$export(module.exports, "identity", () => $533945e69be6c784$export$f0954fd7d5368655);
$parcel$export(module.exports, "createSingletonPromise", () => $533945e69be6c784$export$7a0c7c93e8e22bce);
$parcel$export(module.exports, "containsProp", () => $533945e69be6c784$export$d138bf93e1dfa23f);
$parcel$export(module.exports, "increaseWithUnit", () => $533945e69be6c784$export$f5c97f6a04b90212);
$parcel$export(module.exports, "objectPick", () => $533945e69be6c784$export$5f2d71bd504be1ec);
$parcel$export(module.exports, "objectOmit", () => $533945e69be6c784$export$3320623908f24e40);
$parcel$export(module.exports, "objectEntries", () => $533945e69be6c784$export$6a29ade99f81ec8a);
$parcel$export(module.exports, "toRef", () => $533945e69be6c784$export$1f60508e4f47b4b7);
$parcel$export(module.exports, "useDebounceFn", () => $533945e69be6c784$export$ddf8f1aa96b8ea88);
$parcel$export(module.exports, "useThrottleFn", () => $533945e69be6c784$export$8ed85856108010bc);
$parcel$export(module.exports, "watchWithFilter", () => $533945e69be6c784$export$3955c00bb6715986);
$parcel$export(module.exports, "pausableWatch", () => $533945e69be6c784$export$37fdf671f882195e);
$parcel$export(module.exports, "syncRef", () => $533945e69be6c784$export$d43743c1df800be0);
$parcel$export(module.exports, "toRefs", () => $533945e69be6c784$export$2e9533675e5e70e0);
$parcel$export(module.exports, "tryOnBeforeUnmount", () => $533945e69be6c784$export$7b037ce8d7969c15);
$parcel$export(module.exports, "tryOnMounted", () => $533945e69be6c784$export$cf1be5b643f0827);
$parcel$export(module.exports, "tryOnUnmounted", () => $533945e69be6c784$export$9fa6e59ca833c930);
$parcel$export(module.exports, "until", () => $533945e69be6c784$export$a40009bd2c363351);
$parcel$export(module.exports, "useIntervalFn", () => $533945e69be6c784$export$35ee30a05e4f2223);
$parcel$export(module.exports, "useTimeoutFn", () => $533945e69be6c784$export$14705c14c13d528a);
$parcel$export(module.exports, "watchIgnorable", () => $533945e69be6c784$export$63ac06655f58d92a);
parcelRequire("90rpg");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");
var $90rpg = parcelRequire("90rpg");
function $533945e69be6c784$export$c92323792c35f5f1(fn, options) {
    var _a;
    const result = (0, $8bTPG.shallowRef)();
    (0, $ani5R.watchEffect)(()=>{
        result.value = fn();
    }, {
        ...options,
        flush: (_a = options == null ? void 0 : options.flush) != null ? _a : "sync"
    });
    return (0, $8bTPG.readonly)(result);
}
function $533945e69be6c784$export$220dfb31330e2956(source, fn) {
    let v = void 0;
    let track;
    let trigger;
    const dirty = (0, $8bTPG.ref)(true);
    const update = ()=>{
        dirty.value = true;
        trigger();
    };
    (0, $ani5R.watch)(source, update, {
        flush: "sync"
    });
    const get = typeof fn === "function" ? fn : fn.get;
    const set = typeof fn === "function" ? void 0 : fn.set;
    const result = (0, $8bTPG.customRef)((_track, _trigger)=>{
        track = _track;
        trigger = _trigger;
        return {
            get () {
                if (dirty.value) {
                    v = get();
                    dirty.value = false;
                }
                track();
                return v;
            },
            set (v2) {
                set == null || set(v2);
            }
        };
    });
    if (Object.isExtensible(result)) result.trigger = update;
    return result;
}
function $533945e69be6c784$export$c3d49ae4e58d3d9d(fn) {
    if ((0, $8bTPG.getCurrentScope)()) {
        (0, $8bTPG.onScopeDispose)(fn);
        return true;
    }
    return false;
}
function $533945e69be6c784$export$c8b3b0996d763ee() {
    const fns = /* @__PURE__ */ new Set();
    const off = (fn)=>{
        fns.delete(fn);
    };
    const on = (fn)=>{
        fns.add(fn);
        const offFn = ()=>off(fn);
        $533945e69be6c784$export$c3d49ae4e58d3d9d(offFn);
        return {
            off: offFn
        };
    };
    const trigger = (...args)=>{
        return Promise.all(Array.from(fns).map((fn)=>fn(...args)));
    };
    return {
        on: on,
        off: off,
        trigger: trigger
    };
}
function $533945e69be6c784$export$aa9aac23b3959ee1(stateFactory) {
    let initialized = false;
    let state;
    const scope = (0, $8bTPG.effectScope)(true);
    return (...args)=>{
        if (!initialized) {
            state = scope.run(()=>stateFactory(...args));
            initialized = true;
        }
        return state;
    };
}
const $533945e69be6c784$var$localProvidedStateMap = /* @__PURE__ */ new WeakMap();
const $533945e69be6c784$export$a797c3886d31ed0 = (key, value)=>{
    var _a;
    const instance = (_a = (0, $ani5R.getCurrentInstance)()) == null ? void 0 : _a.proxy;
    if (instance == null) throw new Error("provideLocal must be called in setup");
    if (!$533945e69be6c784$var$localProvidedStateMap.has(instance)) $533945e69be6c784$var$localProvidedStateMap.set(instance, /* @__PURE__ */ Object.create(null));
    const localProvidedState = $533945e69be6c784$var$localProvidedStateMap.get(instance);
    localProvidedState[key] = value;
    (0, $ani5R.provide)(key, value);
};
const $533945e69be6c784$export$89897216f9bf9933 = (...args)=>{
    var _a;
    const key = args[0];
    const instance = (_a = (0, $ani5R.getCurrentInstance)()) == null ? void 0 : _a.proxy;
    if (instance == null) throw new Error("injectLocal must be called in setup");
    if ($533945e69be6c784$var$localProvidedStateMap.has(instance) && key in $533945e69be6c784$var$localProvidedStateMap.get(instance)) return $533945e69be6c784$var$localProvidedStateMap.get(instance)[key];
    return (0, $ani5R.inject)(...args);
};
function $533945e69be6c784$export$91b9c7550061230e(composable, options) {
    const key = (options == null ? void 0 : options.injectionKey) || Symbol(composable.name || "InjectionState");
    const defaultValue = options == null ? void 0 : options.defaultValue;
    const useProvidingState = (...args)=>{
        const state = composable(...args);
        $533945e69be6c784$export$a797c3886d31ed0(key, state);
        return state;
    };
    const useInjectedState = ()=>$533945e69be6c784$export$89897216f9bf9933(key, defaultValue);
    return [
        useProvidingState,
        useInjectedState
    ];
}
function $533945e69be6c784$export$9e8d4b001a1bb310(composable) {
    let subscribers = 0;
    let state;
    let scope;
    const dispose = ()=>{
        subscribers -= 1;
        if (scope && subscribers <= 0) {
            scope.stop();
            state = void 0;
            scope = void 0;
        }
    };
    return (...args)=>{
        subscribers += 1;
        if (!state) {
            scope = (0, $8bTPG.effectScope)(true);
            state = scope.run(()=>composable(...args));
        }
        $533945e69be6c784$export$c3d49ae4e58d3d9d(dispose);
        return state;
    };
}
function $533945e69be6c784$export$ecda8b07a1b5deab(ref, extend, { enumerable: enumerable = false, unwrap: unwrap = true } = {}) {
    if (!(0, $90rpg.isVue3) && !(0, $ani5R.version).startsWith("2.7.")) return;
    for (const [key, value] of Object.entries(extend)){
        if (key === "value") continue;
        if ((0, $8bTPG.isRef)(value) && unwrap) Object.defineProperty(ref, key, {
            get () {
                return value.value;
            },
            set (v) {
                value.value = v;
            },
            enumerable: enumerable
        });
        else Object.defineProperty(ref, key, {
            value: value,
            enumerable: enumerable
        });
    }
    return ref;
}
function $533945e69be6c784$export$3988ae62b71be9a3(obj, key) {
    if (key == null) return (0, $8bTPG.unref)(obj);
    return (0, $8bTPG.unref)(obj)[key];
}
function $533945e69be6c784$export$4e62c701997796c1(v) {
    return (0, $8bTPG.unref)(v) != null;
}
function $533945e69be6c784$export$d50fdd10db75504e(obj, arr) {
    if (typeof Symbol !== "undefined") {
        const clone = {
            ...obj
        };
        Object.defineProperty(clone, Symbol.iterator, {
            enumerable: false,
            value () {
                let index = 0;
                return {
                    next: ()=>({
                            value: arr[index++],
                            done: index > arr.length
                        })
                };
            }
        });
        return clone;
    } else return Object.assign([
        ...arr
    ], obj);
}
function $533945e69be6c784$export$30bdcc2218aa9458(r) {
    return typeof r === "function" ? r() : (0, $8bTPG.unref)(r);
}
const $533945e69be6c784$export$13fbab860e8afb41 = $533945e69be6c784$export$30bdcc2218aa9458;
function $533945e69be6c784$export$4ba03523724ba2d7(fn, options) {
    const unrefFn = (options == null ? void 0 : options.computedGetter) === false ? (0, $8bTPG.unref) : $533945e69be6c784$export$30bdcc2218aa9458;
    return function(...args) {
        return (0, $8bTPG.computed)(()=>fn.apply(this, args.map((i)=>unrefFn(i))));
    };
}
function $533945e69be6c784$export$1ff2e29423610e60(obj, optionsOrKeys = {}) {
    let keys = [];
    let options;
    if (Array.isArray(optionsOrKeys)) keys = optionsOrKeys;
    else {
        options = optionsOrKeys;
        const { includeOwnProperties: includeOwnProperties = true } = optionsOrKeys;
        keys.push(...Object.keys(obj));
        if (includeOwnProperties) keys.push(...Object.getOwnPropertyNames(obj));
    }
    return Object.fromEntries(keys.map((key)=>{
        const value = obj[key];
        return [
            key,
            typeof value === "function" ? $533945e69be6c784$export$4ba03523724ba2d7(value.bind(obj), options) : value
        ];
    }));
}
function $533945e69be6c784$export$45c769cf449a508c(objectRef) {
    if (!(0, $8bTPG.isRef)(objectRef)) return (0, $8bTPG.reactive)(objectRef);
    const proxy = new Proxy({}, {
        get (_, p, receiver) {
            return (0, $8bTPG.unref)(Reflect.get(objectRef.value, p, receiver));
        },
        set (_, p, value) {
            if ((0, $8bTPG.isRef)(objectRef.value[p]) && !(0, $8bTPG.isRef)(value)) objectRef.value[p].value = value;
            else objectRef.value[p] = value;
            return true;
        },
        deleteProperty (_, p) {
            return Reflect.deleteProperty(objectRef.value, p);
        },
        has (_, p) {
            return Reflect.has(objectRef.value, p);
        },
        ownKeys () {
            return Object.keys(objectRef.value);
        },
        getOwnPropertyDescriptor () {
            return {
                enumerable: true,
                configurable: true
            };
        }
    });
    return (0, $8bTPG.reactive)(proxy);
}
function $533945e69be6c784$export$35298289c11958e1(fn) {
    return $533945e69be6c784$export$45c769cf449a508c((0, $8bTPG.computed)(fn));
}
function $533945e69be6c784$export$797deb43a681bdd1(obj, ...keys) {
    const flatKeys = keys.flat();
    const predicate = flatKeys[0];
    return $533945e69be6c784$export$35298289c11958e1(()=>typeof predicate === "function" ? Object.fromEntries(Object.entries((0, $8bTPG.toRefs)(obj)).filter(([k, v])=>!predicate($533945e69be6c784$export$30bdcc2218aa9458(v), k))) : Object.fromEntries(Object.entries((0, $8bTPG.toRefs)(obj)).filter((e)=>!flatKeys.includes(e[0]))));
}
const $533945e69be6c784$export$7383f122bf48ec30 = typeof window !== "undefined" && typeof document !== "undefined";
const $533945e69be6c784$export$3c901a5f01941a06 = typeof WorkerGlobalScope !== "undefined" && globalThis instanceof WorkerGlobalScope;
const $533945e69be6c784$export$7b816c9b8ecf71b4 = (val)=>typeof val !== "undefined";
const $533945e69be6c784$export$aedb69ff3e31596c = (val)=>val != null;
const $533945e69be6c784$export$a7a9523472993e97 = (condition, ...infos)=>{
    if (!condition) console.warn(...infos);
};
const $533945e69be6c784$var$toString = Object.prototype.toString;
const $533945e69be6c784$export$a6cdc56e425d0d0a = (val)=>$533945e69be6c784$var$toString.call(val) === "[object Object]";
const $533945e69be6c784$export$461939dd4422153 = ()=>Date.now();
const $533945e69be6c784$export$fc00ee57782020aa = ()=>+Date.now();
const $533945e69be6c784$export$7d15b64cf5a3a4c4 = (n, min, max)=>Math.min(max, Math.max(min, n));
const $533945e69be6c784$export$8793edee2d425525 = ()=>{};
const $533945e69be6c784$export$bb0a9c36cf454ea0 = (min, max)=>{
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
const $533945e69be6c784$export$b5a638e9b3fff9f3 = (val, key)=>Object.prototype.hasOwnProperty.call(val, key);
const $533945e69be6c784$export$fedb369cb70207f1 = /* @__PURE__ */ $533945e69be6c784$var$getIsIOS();
function $533945e69be6c784$var$getIsIOS() {
    var _a, _b;
    return $533945e69be6c784$export$7383f122bf48ec30 && ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((_b = window == null ? void 0 : window.navigator) == null ? void 0 : _b.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function $533945e69be6c784$export$a1f1cf91007f23bf(filter, fn) {
    function wrapper(...args) {
        return new Promise((resolve, reject)=>{
            Promise.resolve(filter(()=>fn.apply(this, args), {
                fn: fn,
                thisArg: this,
                args: args
            })).then(resolve).catch(reject);
        });
    }
    return wrapper;
}
const $533945e69be6c784$export$8cc0e33a27868391 = (invoke)=>{
    return invoke();
};
function $533945e69be6c784$export$fca2c450ae03b38e(ms, options = {}) {
    let timer;
    let maxTimer;
    let lastRejector = $533945e69be6c784$export$8793edee2d425525;
    const _clearTimeout = (timer2)=>{
        clearTimeout(timer2);
        lastRejector();
        lastRejector = $533945e69be6c784$export$8793edee2d425525;
    };
    const filter = (invoke)=>{
        const duration = $533945e69be6c784$export$30bdcc2218aa9458(ms);
        const maxDuration = $533945e69be6c784$export$30bdcc2218aa9458(options.maxWait);
        if (timer) _clearTimeout(timer);
        if (duration <= 0 || maxDuration !== void 0 && maxDuration <= 0) {
            if (maxTimer) {
                _clearTimeout(maxTimer);
                maxTimer = null;
            }
            return Promise.resolve(invoke());
        }
        return new Promise((resolve, reject)=>{
            lastRejector = options.rejectOnCancel ? reject : resolve;
            if (maxDuration && !maxTimer) maxTimer = setTimeout(()=>{
                if (timer) _clearTimeout(timer);
                maxTimer = null;
                resolve(invoke());
            }, maxDuration);
            timer = setTimeout(()=>{
                if (maxTimer) _clearTimeout(maxTimer);
                maxTimer = null;
                resolve(invoke());
            }, duration);
        });
    };
    return filter;
}
function $533945e69be6c784$export$cd62e9dbf204fd92(...args) {
    let lastExec = 0;
    let timer;
    let isLeading = true;
    let lastRejector = $533945e69be6c784$export$8793edee2d425525;
    let lastValue;
    let ms;
    let trailing;
    let leading;
    let rejectOnCancel;
    if (!(0, $8bTPG.isRef)(args[0]) && typeof args[0] === "object") ({ delay: ms, trailing: trailing = true, leading: leading = true, rejectOnCancel: rejectOnCancel = false } = args[0]);
    else [ms, trailing = true, leading = true, rejectOnCancel = false] = args;
    const clear = ()=>{
        if (timer) {
            clearTimeout(timer);
            timer = void 0;
            lastRejector();
            lastRejector = $533945e69be6c784$export$8793edee2d425525;
        }
    };
    const filter = (_invoke)=>{
        const duration = $533945e69be6c784$export$30bdcc2218aa9458(ms);
        const elapsed = Date.now() - lastExec;
        const invoke = ()=>{
            return lastValue = _invoke();
        };
        clear();
        if (duration <= 0) {
            lastExec = Date.now();
            return invoke();
        }
        if (elapsed > duration && (leading || !isLeading)) {
            lastExec = Date.now();
            invoke();
        } else if (trailing) lastValue = new Promise((resolve, reject)=>{
            lastRejector = rejectOnCancel ? reject : resolve;
            timer = setTimeout(()=>{
                lastExec = Date.now();
                isLeading = true;
                resolve(invoke());
                clear();
            }, Math.max(0, duration - elapsed));
        });
        if (!leading && !timer) timer = setTimeout(()=>isLeading = true, duration);
        isLeading = false;
        return lastValue;
    };
    return filter;
}
function $533945e69be6c784$export$8d46ce8e0ead9c2b(extendFilter = $533945e69be6c784$export$8cc0e33a27868391) {
    const isActive = (0, $8bTPG.ref)(true);
    function pause() {
        isActive.value = false;
    }
    function resume() {
        isActive.value = true;
    }
    const eventFilter = (...args)=>{
        if (isActive.value) extendFilter(...args);
    };
    return {
        isActive: (0, $8bTPG.readonly)(isActive),
        pause: pause,
        resume: resume,
        eventFilter: eventFilter
    };
}
const $533945e69be6c784$export$2161f27fc78b6ab2 = {
    mounted: (0, $90rpg.isVue3) ? "mounted" : "inserted",
    updated: (0, $90rpg.isVue3) ? "updated" : "componentUpdated",
    unmounted: (0, $90rpg.isVue3) ? "unmounted" : "unbind"
};
function $533945e69be6c784$var$cacheStringFunction(fn) {
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
const $533945e69be6c784$var$hyphenateRE = /\B([A-Z])/g;
const $533945e69be6c784$export$6e6a0a3676c4b8bb = $533945e69be6c784$var$cacheStringFunction((str)=>str.replace($533945e69be6c784$var$hyphenateRE, "-$1").toLowerCase());
const $533945e69be6c784$var$camelizeRE = /-(\w)/g;
const $533945e69be6c784$export$161d051f5dd25de7 = $533945e69be6c784$var$cacheStringFunction((str)=>{
    return str.replace($533945e69be6c784$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
function $533945e69be6c784$export$69e8b3daf72c74b7(ms, throwOnTimeout = false, reason = "Timeout") {
    return new Promise((resolve, reject)=>{
        if (throwOnTimeout) setTimeout(()=>reject(reason), ms);
        else setTimeout(resolve, ms);
    });
}
function $533945e69be6c784$export$f0954fd7d5368655(arg) {
    return arg;
}
function $533945e69be6c784$export$7a0c7c93e8e22bce(fn) {
    let _promise;
    function wrapper() {
        if (!_promise) _promise = fn();
        return _promise;
    }
    wrapper.reset = async ()=>{
        const _prev = _promise;
        _promise = void 0;
        if (_prev) await _prev;
    };
    return wrapper;
}
function $533945e69be6c784$export$468cda29b159ee5d(fn) {
    return fn();
}
function $533945e69be6c784$export$d138bf93e1dfa23f(obj, ...props) {
    return props.some((k)=>k in obj);
}
function $533945e69be6c784$export$f5c97f6a04b90212(target, delta) {
    var _a;
    if (typeof target === "number") return target + delta;
    const value = ((_a = target.match(/^-?\d+\.?\d*/)) == null ? void 0 : _a[0]) || "";
    const unit = target.slice(value.length);
    const result = Number.parseFloat(value) + delta;
    if (Number.isNaN(result)) return target;
    return result + unit;
}
function $533945e69be6c784$export$5f2d71bd504be1ec(obj, keys, omitUndefined = false) {
    return keys.reduce((n, k)=>{
        if (k in obj) {
            if (!omitUndefined || obj[k] !== void 0) n[k] = obj[k];
        }
        return n;
    }, {});
}
function $533945e69be6c784$export$3320623908f24e40(obj, keys, omitUndefined = false) {
    return Object.fromEntries(Object.entries(obj).filter(([key, value])=>{
        return (!omitUndefined || value !== void 0) && !keys.includes(key);
    }));
}
function $533945e69be6c784$export$6a29ade99f81ec8a(obj) {
    return Object.entries(obj);
}
function $533945e69be6c784$export$5c967efe8efb656c(target) {
    return target || (0, $ani5R.getCurrentInstance)();
}
function $533945e69be6c784$export$1f60508e4f47b4b7(...args) {
    if (args.length !== 1) return (0, $8bTPG.toRef)(...args);
    const r = args[0];
    return typeof r === "function" ? (0, $8bTPG.readonly)((0, $8bTPG.customRef)(()=>({
            get: r,
            set: $533945e69be6c784$export$8793edee2d425525
        }))) : (0, $8bTPG.ref)(r);
}
const $533945e69be6c784$export$fb2b8a41d9966b32 = $533945e69be6c784$export$1f60508e4f47b4b7;
function $533945e69be6c784$export$afd74972d99a820f(obj, ...keys) {
    const flatKeys = keys.flat();
    const predicate = flatKeys[0];
    return $533945e69be6c784$export$35298289c11958e1(()=>typeof predicate === "function" ? Object.fromEntries(Object.entries((0, $8bTPG.toRefs)(obj)).filter(([k, v])=>predicate($533945e69be6c784$export$30bdcc2218aa9458(v), k))) : Object.fromEntries(flatKeys.map((k)=>[
                k,
                $533945e69be6c784$export$1f60508e4f47b4b7(obj, k)
            ])));
}
function $533945e69be6c784$export$c1f1e286df6cc58f(defaultValue, afterMs = 1e4) {
    return (0, $8bTPG.customRef)((track, trigger)=>{
        let value = $533945e69be6c784$export$30bdcc2218aa9458(defaultValue);
        let timer;
        const resetAfter = ()=>setTimeout(()=>{
                value = $533945e69be6c784$export$30bdcc2218aa9458(defaultValue);
                trigger();
            }, $533945e69be6c784$export$30bdcc2218aa9458(afterMs));
        $533945e69be6c784$export$c3d49ae4e58d3d9d(()=>{
            clearTimeout(timer);
        });
        return {
            get () {
                track();
                return value;
            },
            set (newValue) {
                value = newValue;
                trigger();
                clearTimeout(timer);
                timer = resetAfter();
            }
        };
    });
}
function $533945e69be6c784$export$ddf8f1aa96b8ea88(fn, ms = 200, options = {}) {
    return $533945e69be6c784$export$a1f1cf91007f23bf($533945e69be6c784$export$fca2c450ae03b38e(ms, options), fn);
}
function $533945e69be6c784$export$179967fbe3ecb41a(value, ms = 200, options = {}) {
    const debounced = (0, $8bTPG.ref)(value.value);
    const updater = $533945e69be6c784$export$ddf8f1aa96b8ea88(()=>{
        debounced.value = value.value;
    }, ms, options);
    (0, $ani5R.watch)(value, ()=>updater());
    return debounced;
}
function $533945e69be6c784$export$52a73c0b6dcfe111(source, defaultValue) {
    return (0, $8bTPG.computed)({
        get () {
            var _a;
            return (_a = source.value) != null ? _a : defaultValue;
        },
        set (value) {
            source.value = value;
        }
    });
}
function $533945e69be6c784$export$8ed85856108010bc(fn, ms = 200, trailing = false, leading = true, rejectOnCancel = false) {
    return $533945e69be6c784$export$a1f1cf91007f23bf($533945e69be6c784$export$cd62e9dbf204fd92(ms, trailing, leading, rejectOnCancel), fn);
}
function $533945e69be6c784$export$4d1d638ad6b48495(value, delay = 200, trailing = true, leading = true) {
    if (delay <= 0) return value;
    const throttled = (0, $8bTPG.ref)(value.value);
    const updater = $533945e69be6c784$export$8ed85856108010bc(()=>{
        throttled.value = value.value;
    }, delay, trailing, leading);
    (0, $ani5R.watch)(value, ()=>updater());
    return throttled;
}
function $533945e69be6c784$export$4b7f2010e13474b2(initial, options = {}) {
    let source = initial;
    let track;
    let trigger;
    const ref = (0, $8bTPG.customRef)((_track, _trigger)=>{
        track = _track;
        trigger = _trigger;
        return {
            get () {
                return get();
            },
            set (v) {
                set(v);
            }
        };
    });
    function get(tracking = true) {
        if (tracking) track();
        return source;
    }
    function set(value, triggering = true) {
        var _a, _b;
        if (value === source) return;
        const old = source;
        if (((_a = options.onBeforeChange) == null ? void 0 : _a.call(options, value, old)) === false) return;
        source = value;
        (_b = options.onChanged) == null || _b.call(options, value, old);
        if (triggering) trigger();
    }
    const untrackedGet = ()=>get(false);
    const silentSet = (v)=>set(v, false);
    const peek = ()=>get(false);
    const lay = (v)=>set(v, false);
    return $533945e69be6c784$export$ecda8b07a1b5deab(ref, {
        get: get,
        set: set,
        untrackedGet: untrackedGet,
        silentSet: silentSet,
        peek: peek,
        lay: lay
    }, {
        enumerable: true
    });
}
const $533945e69be6c784$export$6b6db3af7a80e2d2 = $533945e69be6c784$export$4b7f2010e13474b2;
function $533945e69be6c784$export$adaa4cf7ef1b65be(...args) {
    if (args.length === 2) {
        const [ref, value] = args;
        ref.value = value;
    }
    if (args.length === 3) {
        if (0, $90rpg.isVue2) (0, $90rpg.set)(...args);
        else {
            const [target, key, value] = args;
            target[key] = value;
        }
    }
}
function $533945e69be6c784$export$3955c00bb6715986(source, cb, options = {}) {
    const { eventFilter: eventFilter = $533945e69be6c784$export$8cc0e33a27868391, ...watchOptions } = options;
    return (0, $ani5R.watch)(source, $533945e69be6c784$export$a1f1cf91007f23bf(eventFilter, cb), watchOptions);
}
function $533945e69be6c784$export$37fdf671f882195e(source, cb, options = {}) {
    const { eventFilter: filter, ...watchOptions } = options;
    const { eventFilter: eventFilter, pause: pause, resume: resume, isActive: isActive } = $533945e69be6c784$export$8d46ce8e0ead9c2b(filter);
    const stop = $533945e69be6c784$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: eventFilter
    });
    return {
        stop: stop,
        pause: pause,
        resume: resume,
        isActive: isActive
    };
}
function $533945e69be6c784$export$d43743c1df800be0(left, right, ...[options]) {
    const { flush: flush = "sync", deep: deep = false, immediate: immediate = true, direction: direction = "both", transform: transform = {} } = options || {};
    const watchers = [];
    const transformLTR = "ltr" in transform && transform.ltr || ((v)=>v);
    const transformRTL = "rtl" in transform && transform.rtl || ((v)=>v);
    if (direction === "both" || direction === "ltr") watchers.push($533945e69be6c784$export$37fdf671f882195e(left, (newValue)=>{
        watchers.forEach((w)=>w.pause());
        right.value = transformLTR(newValue);
        watchers.forEach((w)=>w.resume());
    }, {
        flush: flush,
        deep: deep,
        immediate: immediate
    }));
    if (direction === "both" || direction === "rtl") watchers.push($533945e69be6c784$export$37fdf671f882195e(right, (newValue)=>{
        watchers.forEach((w)=>w.pause());
        left.value = transformRTL(newValue);
        watchers.forEach((w)=>w.resume());
    }, {
        flush: flush,
        deep: deep,
        immediate: immediate
    }));
    const stop = ()=>{
        watchers.forEach((w)=>w.stop());
    };
    return stop;
}
function $533945e69be6c784$export$16a582ae8a437df6(source, targets, options = {}) {
    const { flush: flush = "sync", deep: deep = false, immediate: immediate = true } = options;
    if (!Array.isArray(targets)) targets = [
        targets
    ];
    return (0, $ani5R.watch)(source, (newValue)=>targets.forEach((target)=>target.value = newValue), {
        flush: flush,
        deep: deep,
        immediate: immediate
    });
}
function $533945e69be6c784$export$2e9533675e5e70e0(objectRef, options = {}) {
    if (!(0, $8bTPG.isRef)(objectRef)) return (0, $8bTPG.toRefs)(objectRef);
    const result = Array.isArray(objectRef.value) ? Array.from({
        length: objectRef.value.length
    }) : {};
    for(const key in objectRef.value)result[key] = (0, $8bTPG.customRef)(()=>({
            get () {
                return objectRef.value[key];
            },
            set (v) {
                var _a;
                const replaceRef = (_a = $533945e69be6c784$export$30bdcc2218aa9458(options.replaceRef)) != null ? _a : true;
                if (replaceRef) {
                    if (Array.isArray(objectRef.value)) {
                        const copy = [
                            ...objectRef.value
                        ];
                        copy[key] = v;
                        objectRef.value = copy;
                    } else {
                        const newObject = {
                            ...objectRef.value,
                            [key]: v
                        };
                        Object.setPrototypeOf(newObject, Object.getPrototypeOf(objectRef.value));
                        objectRef.value = newObject;
                    }
                } else objectRef.value[key] = v;
            }
        }));
    return result;
}
function $533945e69be6c784$export$25180f6b7105226e(fn, sync = true, target) {
    const instance = $533945e69be6c784$export$5c967efe8efb656c(target);
    if (instance) (0, $ani5R.onBeforeMount)(fn, target);
    else if (sync) fn();
    else (0, $ani5R.nextTick)(fn);
}
function $533945e69be6c784$export$7b037ce8d7969c15(fn, target) {
    const instance = $533945e69be6c784$export$5c967efe8efb656c(target);
    if (instance) (0, $ani5R.onBeforeUnmount)(fn, target);
}
function $533945e69be6c784$export$cf1be5b643f0827(fn, sync = true, target) {
    const instance = $533945e69be6c784$export$5c967efe8efb656c();
    if (instance) (0, $ani5R.onMounted)(fn, target);
    else if (sync) fn();
    else (0, $ani5R.nextTick)(fn);
}
function $533945e69be6c784$export$9fa6e59ca833c930(fn, target) {
    const instance = $533945e69be6c784$export$5c967efe8efb656c(target);
    if (instance) (0, $ani5R.onUnmounted)(fn, target);
}
function $533945e69be6c784$var$createUntil(r, isNot = false) {
    function toMatch(condition, { flush: flush = "sync", deep: deep = false, timeout: timeout, throwOnTimeout: throwOnTimeout } = {}) {
        let stop = null;
        const watcher = new Promise((resolve)=>{
            stop = (0, $ani5R.watch)(r, (v)=>{
                if (condition(v) !== isNot) {
                    stop == null || stop();
                    resolve(v);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        const promises = [
            watcher
        ];
        if (timeout != null) promises.push($533945e69be6c784$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(()=>$533945e69be6c784$export$30bdcc2218aa9458(r)).finally(()=>stop == null ? void 0 : stop()));
        return Promise.race(promises);
    }
    function toBe(value, options) {
        if (!(0, $8bTPG.isRef)(value)) return toMatch((v)=>v === value, options);
        const { flush: flush = "sync", deep: deep = false, timeout: timeout, throwOnTimeout: throwOnTimeout } = options != null ? options : {};
        let stop = null;
        const watcher = new Promise((resolve)=>{
            stop = (0, $ani5R.watch)([
                r,
                value
            ], ([v1, v2])=>{
                if (isNot !== (v1 === v2)) {
                    stop == null || stop();
                    resolve(v1);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        const promises = [
            watcher
        ];
        if (timeout != null) promises.push($533945e69be6c784$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(()=>$533945e69be6c784$export$30bdcc2218aa9458(r)).finally(()=>{
            stop == null || stop();
            return $533945e69be6c784$export$30bdcc2218aa9458(r);
        }));
        return Promise.race(promises);
    }
    function toBeTruthy(options) {
        return toMatch((v)=>Boolean(v), options);
    }
    function toBeNull(options) {
        return toBe(null, options);
    }
    function toBeUndefined(options) {
        return toBe(void 0, options);
    }
    function toBeNaN(options) {
        return toMatch(Number.isNaN, options);
    }
    function toContains(value, options) {
        return toMatch((v)=>{
            const array = Array.from(v);
            return array.includes(value) || array.includes($533945e69be6c784$export$30bdcc2218aa9458(value));
        }, options);
    }
    function changed(options) {
        return changedTimes(1, options);
    }
    function changedTimes(n = 1, options) {
        let count = -1;
        return toMatch(()=>{
            count += 1;
            return count >= n;
        }, options);
    }
    if (Array.isArray($533945e69be6c784$export$30bdcc2218aa9458(r))) {
        const instance = {
            toMatch: toMatch,
            toContains: toContains,
            changed: changed,
            changedTimes: changedTimes,
            get not () {
                return $533945e69be6c784$var$createUntil(r, !isNot);
            }
        };
        return instance;
    } else {
        const instance = {
            toMatch: toMatch,
            toBe: toBe,
            toBeTruthy: toBeTruthy,
            toBeNull: toBeNull,
            toBeNaN: toBeNaN,
            toBeUndefined: toBeUndefined,
            changed: changed,
            changedTimes: changedTimes,
            get not () {
                return $533945e69be6c784$var$createUntil(r, !isNot);
            }
        };
        return instance;
    }
}
function $533945e69be6c784$export$a40009bd2c363351(r) {
    return $533945e69be6c784$var$createUntil(r);
}
function $533945e69be6c784$var$defaultComparator(value, othVal) {
    return value === othVal;
}
function $533945e69be6c784$export$34602ebc410e389c(...args) {
    var _a;
    const list = args[0];
    const values = args[1];
    let compareFn = (_a = args[2]) != null ? _a : $533945e69be6c784$var$defaultComparator;
    if (typeof compareFn === "string") {
        const key = compareFn;
        compareFn = (value, othVal)=>value[key] === othVal[key];
    }
    return (0, $8bTPG.computed)(()=>$533945e69be6c784$export$30bdcc2218aa9458(list).filter((x)=>$533945e69be6c784$export$30bdcc2218aa9458(values).findIndex((y)=>compareFn(x, y)) === -1));
}
function $533945e69be6c784$export$1e5a400faddb345f(list, fn) {
    return (0, $8bTPG.computed)(()=>$533945e69be6c784$export$30bdcc2218aa9458(list).every((element, index, array)=>fn($533945e69be6c784$export$30bdcc2218aa9458(element), index, array)));
}
function $533945e69be6c784$export$d62e4083f0a2d244(list, fn) {
    return (0, $8bTPG.computed)(()=>$533945e69be6c784$export$30bdcc2218aa9458(list).map((i)=>$533945e69be6c784$export$30bdcc2218aa9458(i)).filter(fn));
}
function $533945e69be6c784$export$ace4ef07c63f605e(list, fn) {
    return (0, $8bTPG.computed)(()=>$533945e69be6c784$export$30bdcc2218aa9458($533945e69be6c784$export$30bdcc2218aa9458(list).find((element, index, array)=>fn($533945e69be6c784$export$30bdcc2218aa9458(element), index, array))));
}
function $533945e69be6c784$export$3ec066cdb63e2970(list, fn) {
    return (0, $8bTPG.computed)(()=>$533945e69be6c784$export$30bdcc2218aa9458(list).findIndex((element, index, array)=>fn($533945e69be6c784$export$30bdcc2218aa9458(element), index, array)));
}
function $533945e69be6c784$var$findLast(arr, cb) {
    let index = arr.length;
    while(index-- > 0){
        if (cb(arr[index], index, arr)) return arr[index];
    }
    return void 0;
}
function $533945e69be6c784$export$b59cd47693a134f7(list, fn) {
    return (0, $8bTPG.computed)(()=>$533945e69be6c784$export$30bdcc2218aa9458(!Array.prototype.findLast ? $533945e69be6c784$var$findLast($533945e69be6c784$export$30bdcc2218aa9458(list), (element, index, array)=>fn($533945e69be6c784$export$30bdcc2218aa9458(element), index, array)) : $533945e69be6c784$export$30bdcc2218aa9458(list).findLast((element, index, array)=>fn($533945e69be6c784$export$30bdcc2218aa9458(element), index, array))));
}
function $533945e69be6c784$var$isArrayIncludesOptions(obj) {
    return $533945e69be6c784$export$a6cdc56e425d0d0a(obj) && $533945e69be6c784$export$d138bf93e1dfa23f(obj, "formIndex", "comparator");
}
function $533945e69be6c784$export$34f006a38543d952(...args) {
    var _a;
    const list = args[0];
    const value = args[1];
    let comparator = args[2];
    let formIndex = 0;
    if ($533945e69be6c784$var$isArrayIncludesOptions(comparator)) {
        formIndex = (_a = comparator.fromIndex) != null ? _a : 0;
        comparator = comparator.comparator;
    }
    if (typeof comparator === "string") {
        const key = comparator;
        comparator = (element, value2)=>element[key] === $533945e69be6c784$export$30bdcc2218aa9458(value2);
    }
    comparator = comparator != null ? comparator : (element, value2)=>element === $533945e69be6c784$export$30bdcc2218aa9458(value2);
    return (0, $8bTPG.computed)(()=>$533945e69be6c784$export$30bdcc2218aa9458(list).slice(formIndex).some((element, index, array)=>comparator($533945e69be6c784$export$30bdcc2218aa9458(element), $533945e69be6c784$export$30bdcc2218aa9458(value), index, $533945e69be6c784$export$30bdcc2218aa9458(array))));
}
function $533945e69be6c784$export$4a02928bbff39848(list, separator) {
    return (0, $8bTPG.computed)(()=>$533945e69be6c784$export$30bdcc2218aa9458(list).map((i)=>$533945e69be6c784$export$30bdcc2218aa9458(i)).join($533945e69be6c784$export$30bdcc2218aa9458(separator)));
}
function $533945e69be6c784$export$8cc4758f083c4ffe(list, fn) {
    return (0, $8bTPG.computed)(()=>$533945e69be6c784$export$30bdcc2218aa9458(list).map((i)=>$533945e69be6c784$export$30bdcc2218aa9458(i)).map(fn));
}
function $533945e69be6c784$export$2a4c0ee40e3400de(list, reducer, ...args) {
    const reduceCallback = (sum, value, index)=>reducer($533945e69be6c784$export$30bdcc2218aa9458(sum), $533945e69be6c784$export$30bdcc2218aa9458(value), index);
    return (0, $8bTPG.computed)(()=>{
        const resolved = $533945e69be6c784$export$30bdcc2218aa9458(list);
        return args.length ? resolved.reduce(reduceCallback, $533945e69be6c784$export$30bdcc2218aa9458(args[0])) : resolved.reduce(reduceCallback);
    });
}
function $533945e69be6c784$export$53834b0e1a20e7a3(list, fn) {
    return (0, $8bTPG.computed)(()=>$533945e69be6c784$export$30bdcc2218aa9458(list).some((element, index, array)=>fn($533945e69be6c784$export$30bdcc2218aa9458(element), index, array)));
}
function $533945e69be6c784$var$uniq(array) {
    return Array.from(new Set(array));
}
function $533945e69be6c784$var$uniqueElementsBy(array, fn) {
    return array.reduce((acc, v)=>{
        if (!acc.some((x)=>fn(v, x, array))) acc.push(v);
        return acc;
    }, []);
}
function $533945e69be6c784$export$1b97ec936c2f7d03(list, compareFn) {
    return (0, $8bTPG.computed)(()=>{
        const resolvedList = $533945e69be6c784$export$30bdcc2218aa9458(list).map((element)=>$533945e69be6c784$export$30bdcc2218aa9458(element));
        return compareFn ? $533945e69be6c784$var$uniqueElementsBy(resolvedList, compareFn) : $533945e69be6c784$var$uniq(resolvedList);
    });
}
function $533945e69be6c784$export$70c4067197c60e2d(initialValue = 0, options = {}) {
    let _initialValue = (0, $8bTPG.unref)(initialValue);
    const count = (0, $8bTPG.ref)(initialValue);
    const { max: max = Number.POSITIVE_INFINITY, min: min = Number.NEGATIVE_INFINITY } = options;
    const inc = (delta = 1)=>count.value = Math.max(Math.min(max, count.value + delta), min);
    const dec = (delta = 1)=>count.value = Math.min(Math.max(min, count.value - delta), max);
    const get = ()=>count.value;
    const set = (val)=>count.value = Math.max(min, Math.min(max, val));
    const reset = (val = _initialValue)=>{
        _initialValue = val;
        return set(val);
    };
    return {
        count: count,
        inc: inc,
        dec: dec,
        get: get,
        set: set,
        reset: reset
    };
}
const $533945e69be6c784$var$REGEX_PARSE = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[T\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/i;
const $533945e69be6c784$var$REGEX_FORMAT = /[YMDHhms]o|\[([^\]]+)\]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a{1,2}|A{1,2}|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
function $533945e69be6c784$var$defaultMeridiem(hours, minutes, isLowercase, hasPeriod) {
    let m = hours < 12 ? "AM" : "PM";
    if (hasPeriod) m = m.split("").reduce((acc, curr)=>acc += `${curr}.`, "");
    return isLowercase ? m.toLowerCase() : m;
}
function $533945e69be6c784$var$formatOrdinal(num) {
    const suffixes = [
        "th",
        "st",
        "nd",
        "rd"
    ];
    const v = num % 100;
    return num + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
}
function $533945e69be6c784$export$3ae94a2503e890a1(date, formatStr, options = {}) {
    var _a;
    const years = date.getFullYear();
    const month = date.getMonth();
    const days = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const milliseconds = date.getMilliseconds();
    const day = date.getDay();
    const meridiem = (_a = options.customMeridiem) != null ? _a : $533945e69be6c784$var$defaultMeridiem;
    const matches = {
        Yo: ()=>$533945e69be6c784$var$formatOrdinal(years),
        YY: ()=>String(years).slice(-2),
        YYYY: ()=>years,
        M: ()=>month + 1,
        Mo: ()=>$533945e69be6c784$var$formatOrdinal(month + 1),
        MM: ()=>`${month + 1}`.padStart(2, "0"),
        MMM: ()=>date.toLocaleDateString(options.locales, {
                month: "short"
            }),
        MMMM: ()=>date.toLocaleDateString(options.locales, {
                month: "long"
            }),
        D: ()=>String(days),
        Do: ()=>$533945e69be6c784$var$formatOrdinal(days),
        DD: ()=>`${days}`.padStart(2, "0"),
        H: ()=>String(hours),
        Ho: ()=>$533945e69be6c784$var$formatOrdinal(hours),
        HH: ()=>`${hours}`.padStart(2, "0"),
        h: ()=>`${hours % 12 || 12}`.padStart(1, "0"),
        ho: ()=>$533945e69be6c784$var$formatOrdinal(hours % 12 || 12),
        hh: ()=>`${hours % 12 || 12}`.padStart(2, "0"),
        m: ()=>String(minutes),
        mo: ()=>$533945e69be6c784$var$formatOrdinal(minutes),
        mm: ()=>`${minutes}`.padStart(2, "0"),
        s: ()=>String(seconds),
        so: ()=>$533945e69be6c784$var$formatOrdinal(seconds),
        ss: ()=>`${seconds}`.padStart(2, "0"),
        SSS: ()=>`${milliseconds}`.padStart(3, "0"),
        d: ()=>day,
        dd: ()=>date.toLocaleDateString(options.locales, {
                weekday: "narrow"
            }),
        ddd: ()=>date.toLocaleDateString(options.locales, {
                weekday: "short"
            }),
        dddd: ()=>date.toLocaleDateString(options.locales, {
                weekday: "long"
            }),
        A: ()=>meridiem(hours, minutes),
        AA: ()=>meridiem(hours, minutes, false, true),
        a: ()=>meridiem(hours, minutes, true),
        aa: ()=>meridiem(hours, minutes, true, true)
    };
    return formatStr.replace($533945e69be6c784$var$REGEX_FORMAT, (match, $1)=>{
        var _a2, _b;
        return (_b = $1 != null ? $1 : (_a2 = matches[match]) == null ? void 0 : _a2.call(matches)) != null ? _b : match;
    });
}
function $533945e69be6c784$export$fcc71269590ba0a8(date) {
    if (date === null) return new Date(Number.NaN);
    if (date === void 0) return /* @__PURE__ */ new Date();
    if (date instanceof Date) return new Date(date);
    if (typeof date === "string" && !/Z$/i.test(date)) {
        const d = date.match($533945e69be6c784$var$REGEX_PARSE);
        if (d) {
            const m = d[2] - 1 || 0;
            const ms = (d[7] || "0").substring(0, 3);
            return new Date(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms);
        }
    }
    return new Date(date);
}
function $533945e69be6c784$export$6d181172004bc6fc(date, formatStr = "HH:mm:ss", options = {}) {
    return (0, $8bTPG.computed)(()=>$533945e69be6c784$export$3ae94a2503e890a1($533945e69be6c784$export$fcc71269590ba0a8($533945e69be6c784$export$30bdcc2218aa9458(date)), $533945e69be6c784$export$30bdcc2218aa9458(formatStr), options));
}
function $533945e69be6c784$export$35ee30a05e4f2223(cb, interval = 1e3, options = {}) {
    const { immediate: immediate = true, immediateCallback: immediateCallback = false } = options;
    let timer = null;
    const isActive = (0, $8bTPG.ref)(false);
    function clean() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }
    function pause() {
        isActive.value = false;
        clean();
    }
    function resume() {
        const intervalValue = $533945e69be6c784$export$30bdcc2218aa9458(interval);
        if (intervalValue <= 0) return;
        isActive.value = true;
        if (immediateCallback) cb();
        clean();
        timer = setInterval(cb, intervalValue);
    }
    if (immediate && $533945e69be6c784$export$7383f122bf48ec30) resume();
    if ((0, $8bTPG.isRef)(interval) || typeof interval === "function") {
        const stopWatch = (0, $ani5R.watch)(interval, ()=>{
            if (isActive.value && $533945e69be6c784$export$7383f122bf48ec30) resume();
        });
        $533945e69be6c784$export$c3d49ae4e58d3d9d(stopWatch);
    }
    $533945e69be6c784$export$c3d49ae4e58d3d9d(pause);
    return {
        isActive: isActive,
        pause: pause,
        resume: resume
    };
}
function $533945e69be6c784$export$f4b266cd2aae9cb1(interval = 1e3, options = {}) {
    const { controls: exposeControls = false, immediate: immediate = true, callback: callback } = options;
    const counter = (0, $8bTPG.ref)(0);
    const update = ()=>counter.value += 1;
    const reset = ()=>{
        counter.value = 0;
    };
    const controls = $533945e69be6c784$export$35ee30a05e4f2223(callback ? ()=>{
        update();
        callback(counter.value);
    } : update, interval, {
        immediate: immediate
    });
    if (exposeControls) return {
        counter: counter,
        reset: reset,
        ...controls
    };
    else return counter;
}
function $533945e69be6c784$export$de385d6f89d6db3c(source, options = {}) {
    var _a;
    const ms = (0, $8bTPG.ref)((_a = options.initialValue) != null ? _a : null);
    (0, $ani5R.watch)(source, ()=>ms.value = $533945e69be6c784$export$fc00ee57782020aa(), options);
    return ms;
}
function $533945e69be6c784$export$14705c14c13d528a(cb, interval, options = {}) {
    const { immediate: immediate = true } = options;
    const isPending = (0, $8bTPG.ref)(false);
    let timer = null;
    function clear() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    function stop() {
        isPending.value = false;
        clear();
    }
    function start(...args) {
        clear();
        isPending.value = true;
        timer = setTimeout(()=>{
            isPending.value = false;
            timer = null;
            cb(...args);
        }, $533945e69be6c784$export$30bdcc2218aa9458(interval));
    }
    if (immediate) {
        isPending.value = true;
        if ($533945e69be6c784$export$7383f122bf48ec30) start();
    }
    $533945e69be6c784$export$c3d49ae4e58d3d9d(stop);
    return {
        isPending: (0, $8bTPG.readonly)(isPending),
        start: start,
        stop: stop
    };
}
function $533945e69be6c784$export$d8e6abf214c9ec0f(interval = 1e3, options = {}) {
    const { controls: exposeControls = false, callback: callback } = options;
    const controls = $533945e69be6c784$export$14705c14c13d528a(callback != null ? callback : $533945e69be6c784$export$8793edee2d425525, interval, options);
    const ready = (0, $8bTPG.computed)(()=>!controls.isPending.value);
    if (exposeControls) return {
        ready: ready,
        ...controls
    };
    else return ready;
}
function $533945e69be6c784$export$1ee6bb1f922f50b3(value, options = {}) {
    const { method: method = "parseFloat", radix: radix, nanToZero: nanToZero } = options;
    return (0, $8bTPG.computed)(()=>{
        let resolved = $533945e69be6c784$export$30bdcc2218aa9458(value);
        if (typeof resolved === "string") resolved = Number[method](resolved, radix);
        if (nanToZero && Number.isNaN(resolved)) resolved = 0;
        return resolved;
    });
}
function $533945e69be6c784$export$8906942fea47e698(value) {
    return (0, $8bTPG.computed)(()=>`${$533945e69be6c784$export$30bdcc2218aa9458(value)}`);
}
function $533945e69be6c784$export$cbe85ee05b554577(initialValue = false, options = {}) {
    const { truthyValue: truthyValue = true, falsyValue: falsyValue = false } = options;
    const valueIsRef = (0, $8bTPG.isRef)(initialValue);
    const _value = (0, $8bTPG.ref)(initialValue);
    function toggle(value) {
        if (arguments.length) {
            _value.value = value;
            return _value.value;
        } else {
            const truthy = $533945e69be6c784$export$30bdcc2218aa9458(truthyValue);
            _value.value = _value.value === truthy ? $533945e69be6c784$export$30bdcc2218aa9458(falsyValue) : truthy;
            return _value.value;
        }
    }
    if (valueIsRef) return toggle;
    else return [
        _value,
        toggle
    ];
}
function $533945e69be6c784$export$8ebd2befe4deaa6b(source, cb, options) {
    let oldList = (options == null ? void 0 : options.immediate) ? [] : [
        ...source instanceof Function ? source() : Array.isArray(source) ? source : $533945e69be6c784$export$30bdcc2218aa9458(source)
    ];
    return (0, $ani5R.watch)(source, (newList, _, onCleanup)=>{
        const oldListRemains = Array.from({
            length: oldList.length
        });
        const added = [];
        for (const obj of newList){
            let found = false;
            for(let i = 0; i < oldList.length; i++)if (!oldListRemains[i] && obj === oldList[i]) {
                oldListRemains[i] = true;
                found = true;
                break;
            }
            if (!found) added.push(obj);
        }
        const removed = oldList.filter((_2, i)=>!oldListRemains[i]);
        cb(newList, oldList, added, removed, onCleanup);
        oldList = [
            ...newList
        ];
    }, options);
}
function $533945e69be6c784$export$a121c3bc1a97f0b4(source, cb, options) {
    const { count: count, ...watchOptions } = options;
    const current = (0, $8bTPG.ref)(0);
    const stop = $533945e69be6c784$export$3955c00bb6715986(source, (...args)=>{
        current.value += 1;
        if (current.value >= $533945e69be6c784$export$30bdcc2218aa9458(count)) (0, $ani5R.nextTick)(()=>stop());
        cb(...args);
    }, watchOptions);
    return {
        count: current,
        stop: stop
    };
}
function $533945e69be6c784$export$578b5d9cbe132cee(source, cb, options = {}) {
    const { debounce: debounce = 0, maxWait: maxWait, ...watchOptions } = options;
    return $533945e69be6c784$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: $533945e69be6c784$export$fca2c450ae03b38e(debounce, {
            maxWait: maxWait
        })
    });
}
function $533945e69be6c784$export$79f242cf85fb93a(source, cb, options) {
    return (0, $ani5R.watch)(source, cb, {
        ...options,
        deep: true
    });
}
function $533945e69be6c784$export$63ac06655f58d92a(source, cb, options = {}) {
    const { eventFilter: eventFilter = $533945e69be6c784$export$8cc0e33a27868391, ...watchOptions } = options;
    const filteredCb = $533945e69be6c784$export$a1f1cf91007f23bf(eventFilter, cb);
    let ignoreUpdates;
    let ignorePrevAsyncUpdates;
    let stop;
    if (watchOptions.flush === "sync") {
        const ignore = (0, $8bTPG.ref)(false);
        ignorePrevAsyncUpdates = ()=>{};
        ignoreUpdates = (updater)=>{
            ignore.value = true;
            updater();
            ignore.value = false;
        };
        stop = (0, $ani5R.watch)(source, (...args)=>{
            if (!ignore.value) filteredCb(...args);
        }, watchOptions);
    } else {
        const disposables = [];
        const ignoreCounter = (0, $8bTPG.ref)(0);
        const syncCounter = (0, $8bTPG.ref)(0);
        ignorePrevAsyncUpdates = ()=>{
            ignoreCounter.value = syncCounter.value;
        };
        disposables.push((0, $ani5R.watch)(source, ()=>{
            syncCounter.value++;
        }, {
            ...watchOptions,
            flush: "sync"
        }));
        ignoreUpdates = (updater)=>{
            const syncCounterPrev = syncCounter.value;
            updater();
            ignoreCounter.value += syncCounter.value - syncCounterPrev;
        };
        disposables.push((0, $ani5R.watch)(source, (...args)=>{
            const ignore = ignoreCounter.value > 0 && ignoreCounter.value === syncCounter.value;
            ignoreCounter.value = 0;
            syncCounter.value = 0;
            if (ignore) return;
            filteredCb(...args);
        }, watchOptions));
        stop = ()=>{
            disposables.forEach((fn)=>fn());
        };
    }
    return {
        stop: stop,
        ignoreUpdates: ignoreUpdates,
        ignorePrevAsyncUpdates: ignorePrevAsyncUpdates
    };
}
function $533945e69be6c784$export$d9aec7ec4e8a1634(source, cb, options) {
    return (0, $ani5R.watch)(source, cb, {
        ...options,
        immediate: true
    });
}
function $533945e69be6c784$export$95d4a8ca30b80ae0(source, cb, options) {
    const stop = (0, $ani5R.watch)(source, (...args)=>{
        (0, $ani5R.nextTick)(()=>stop());
        return cb(...args);
    }, options);
    return stop;
}
function $533945e69be6c784$export$2768dce732d5eb3(source, cb, options = {}) {
    const { throttle: throttle = 0, trailing: trailing = true, leading: leading = true, ...watchOptions } = options;
    return $533945e69be6c784$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: $533945e69be6c784$export$cd62e9dbf204fd92(throttle, trailing, leading)
    });
}
function $533945e69be6c784$export$b75c094d1092c205(source, cb, options = {}) {
    let cleanupFn;
    function onEffect() {
        if (!cleanupFn) return;
        const fn = cleanupFn;
        cleanupFn = void 0;
        fn();
    }
    function onCleanup(callback) {
        cleanupFn = callback;
    }
    const _cb = (value, oldValue)=>{
        onEffect();
        return cb(value, oldValue, onCleanup);
    };
    const res = $533945e69be6c784$export$63ac06655f58d92a(source, _cb, options);
    const { ignoreUpdates: ignoreUpdates } = res;
    const trigger = ()=>{
        let res2;
        ignoreUpdates(()=>{
            res2 = _cb($533945e69be6c784$var$getWatchSources(source), $533945e69be6c784$var$getOldValue(source));
        });
        return res2;
    };
    return {
        ...res,
        trigger: trigger
    };
}
function $533945e69be6c784$var$getWatchSources(sources) {
    if ((0, $8bTPG.isReactive)(sources)) return sources;
    if (Array.isArray(sources)) return sources.map((item)=>$533945e69be6c784$export$30bdcc2218aa9458(item));
    return $533945e69be6c784$export$30bdcc2218aa9458(sources);
}
function $533945e69be6c784$var$getOldValue(source) {
    return Array.isArray(source) ? source.map(()=>void 0) : void 0;
}
function $533945e69be6c784$export$909eba9696cc3445(source, cb, options) {
    const stop = (0, $ani5R.watch)(source, (v, ov, onInvalidate)=>{
        if (v) {
            if (options == null ? void 0 : options.once) (0, $ani5R.nextTick)(()=>stop());
            cb(v, ov, onInvalidate);
        }
    }, {
        ...options,
        once: false
    });
    return stop;
}

});
parcelRegister("90rpg", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("8bTPG")).computed);
$parcel$export(module.exports, "customRef", () => (parcelRequire("8bTPG")).customRef);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("8bTPG")).effectScope);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("ani5R")).getCurrentInstance);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("8bTPG")).getCurrentScope);
$parcel$export(module.exports, "inject", () => (parcelRequire("ani5R")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("8bTPG")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("8bTPG")).isRef);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("ani5R")).nextTick);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("ani5R")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("ani5R")).onBeforeUnmount);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("ani5R")).onMounted);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("8bTPG")).onScopeDispose);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("ani5R")).onUnmounted);
$parcel$export(module.exports, "provide", () => (parcelRequire("ani5R")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "readonly", () => (parcelRequire("8bTPG")).readonly);
$parcel$export(module.exports, "ref", () => (parcelRequire("8bTPG")).ref);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("8bTPG")).shallowRef);
$parcel$export(module.exports, "toRef", () => (parcelRequire("8bTPG")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("8bTPG")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("8bTPG")).unref);
$parcel$export(module.exports, "version", () => (parcelRequire("ani5R")).version);
$parcel$export(module.exports, "watch", () => (parcelRequire("ani5R")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("ani5R")).watchEffect);

$parcel$export(module.exports, "isVue2", () => $2edc6c0987ff9d19$export$1da84e343e81ceb9);
$parcel$export(module.exports, "isVue3", () => $2edc6c0987ff9d19$export$34b222e3d4733e48);
$parcel$export(module.exports, "set", () => $2edc6c0987ff9d19$export$adaa4cf7ef1b65be);
parcelRequire("ey4ci");
var $2edc6c0987ff9d19$export$1da84e343e81ceb9 = false;
var $2edc6c0987ff9d19$export$34b222e3d4733e48 = true;
var $2edc6c0987ff9d19$export$a8cb34872e7d8b79 = undefined;
function $2edc6c0987ff9d19$export$4b3e715f166fdd78() {}
function $2edc6c0987ff9d19$export$adaa4cf7ef1b65be(target, key, val) {
    if (Array.isArray(target)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        return val;
    }
    target[key] = val;
    return val;
}
function $2edc6c0987ff9d19$export$1d2f21e549771e67(target, key) {
    if (Array.isArray(target)) {
        target.splice(key, 1);
        return;
    }
    delete target[key];
}

});


parcelRegister("j40Rs", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("8bTPG")).computed);
$parcel$export(module.exports, "customRef", () => (parcelRequire("8bTPG")).customRef);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("ani5R")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("ani5R")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("ani5R")).getCurrentInstance);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("8bTPG")).getCurrentScope);
$parcel$export(module.exports, "h", () => (parcelRequire("ani5R")).h);
$parcel$export(module.exports, "inject", () => (parcelRequire("ani5R")).inject);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("8bTPG")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("8bTPG")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("8bTPG")).markRaw);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("ani5R")).nextTick);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("ani5R")).onBeforeUpdate);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("ani5R")).onMounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("ani5R")).onUpdated);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "readonly", () => (parcelRequire("8bTPG")).readonly);
$parcel$export(module.exports, "ref", () => (parcelRequire("8bTPG")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("8bTPG")).shallowReactive);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("8bTPG")).shallowRef);
$parcel$export(module.exports, "TransitionGroup", () => (parcelRequire("dDLnc")).TransitionGroup);
$parcel$export(module.exports, "unref", () => (parcelRequire("8bTPG")).unref);
$parcel$export(module.exports, "version", () => (parcelRequire("ani5R")).version);
$parcel$export(module.exports, "watch", () => (parcelRequire("ani5R")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("ani5R")).watchEffect);

$parcel$export(module.exports, "isVue2", () => $d664dcbdf8d41071$export$1da84e343e81ceb9);
$parcel$export(module.exports, "isVue3", () => $d664dcbdf8d41071$export$34b222e3d4733e48);
$parcel$export(module.exports, "set", () => $d664dcbdf8d41071$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "del", () => $d664dcbdf8d41071$export$1d2f21e549771e67);
parcelRequire("ey4ci");
var $d664dcbdf8d41071$export$1da84e343e81ceb9 = false;
var $d664dcbdf8d41071$export$34b222e3d4733e48 = true;
var $d664dcbdf8d41071$export$a8cb34872e7d8b79 = undefined;
function $d664dcbdf8d41071$export$4b3e715f166fdd78() {}
function $d664dcbdf8d41071$export$adaa4cf7ef1b65be(target, key, val) {
    if (Array.isArray(target)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        return val;
    }
    target[key] = val;
    return val;
}
function $d664dcbdf8d41071$export$1d2f21e549771e67(target, key) {
    if (Array.isArray(target)) {
        target.splice(key, 1);
        return;
    }
    delete target[key];
}

});



parcelRegister("j4m3h", function(module, exports) {

$parcel$export(module.exports, "render", () => $de1f7f18ab78ab02$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $de1f7f18ab78ab02$var$_hoisted_1 = {
    ref: "container",
    class: "prod-box__wrap"
};
const $de1f7f18ab78ab02$var$_hoisted_2 = {
    class: "prod-box__figure"
};
const $de1f7f18ab78ab02$var$_hoisted_3 = [
    "poster"
];
const $de1f7f18ab78ab02$var$_hoisted_4 = [
    "src"
];
const $de1f7f18ab78ab02$var$_hoisted_5 = {
    key: 0,
    class: "premium-icon"
};
const $de1f7f18ab78ab02$var$_hoisted_6 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", {
    class: "premium-icon__icon"
}, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
        "xlink:href": "#icon-gem-solid"
    })
], -1);
const $de1f7f18ab78ab02$var$_hoisted_7 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("p", {
    class: "premium-icon__text"
}, "Premium", -1);
const $de1f7f18ab78ab02$var$_hoisted_8 = [
    $de1f7f18ab78ab02$var$_hoisted_6,
    $de1f7f18ab78ab02$var$_hoisted_7
];
const $de1f7f18ab78ab02$var$_hoisted_9 = {
    class: "prod-box__overlay prod-box__overlay--video"
};
const $de1f7f18ab78ab02$var$_hoisted_10 = {
    class: "prod-box__text-wrap"
};
const $de1f7f18ab78ab02$var$_hoisted_11 = [
    "href"
];
const $de1f7f18ab78ab02$var$_hoisted_12 = {
    class: "prod-box__title"
};
const $de1f7f18ab78ab02$var$_hoisted_13 = {
    class: "prod-box__subtitle"
};
function $de1f7f18ab78ab02$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $de1f7f18ab78ab02$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("figure", $de1f7f18ab78ab02$var$_hoisted_2, [
            (0, $ani5R.createElementVNode)("video", {
                ref: "video",
                muted: "",
                preload: "none",
                playsinline: false,
                controls: false,
                poster: $props.product.thumbnailUrl
            }, [
                (0, $ani5R.createElementVNode)("source", {
                    src: $props.product.prevVideo,
                    type: "video/mp4"
                }, null, 8, $de1f7f18ab78ab02$var$_hoisted_4)
            ], 8, $de1f7f18ab78ab02$var$_hoisted_3),
            $props.product.isPremium ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $de1f7f18ab78ab02$var$_hoisted_5, $de1f7f18ab78ab02$var$_hoisted_8)) : (0, $ani5R.createCommentVNode)("", true)
        ]),
        (0, $ani5R.createElementVNode)("div", $de1f7f18ab78ab02$var$_hoisted_9, [
            (0, $ani5R.createElementVNode)("div", $de1f7f18ab78ab02$var$_hoisted_10, [
                (0, $ani5R.createElementVNode)("a", {
                    href: $props.product.productUrl
                }, [
                    (0, $ani5R.createElementVNode)("h2", $de1f7f18ab78ab02$var$_hoisted_12, (0, $X5A94.toDisplayString)($props.product.name), 1)
                ], 8, $de1f7f18ab78ab02$var$_hoisted_11),
                (0, $ani5R.createElementVNode)("p", $de1f7f18ab78ab02$var$_hoisted_13, (0, $X5A94.toDisplayString)($setup.sku), 1)
            ])
        ])
    ], 512);
}

});

parcelRegister("dny7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bd7e403559e643c$export$2e2bcd8739ae039);
let $9bd7e403559e643c$var$NOOP = ()=>{};
var $9bd7e403559e643c$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("5NnmD", function(module, exports) {

$parcel$export(module.exports, "render", () => $4383a6f528e41253$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
const $4383a6f528e41253$var$_hoisted_1 = {
    class: "prod-box"
};
function $4383a6f528e41253$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("article", $4383a6f528e41253$var$_hoisted_1, [
        $props.product.media === $setup.Media.IMAGE ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["SingleProductImage"], {
            key: 0,
            product: $props.product
        }, null, 8, [
            "product"
        ])) : ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["SingleProductVideo"], {
            key: 1,
            product: $props.product
        }, null, 8, [
            "product"
        ]))
    ]);
}

});

parcelRegister("6nN3E", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a5af1e9518ebba6$export$2e2bcd8739ae039);
let $4a5af1e9518ebba6$var$NOOP = ()=>{};
var $4a5af1e9518ebba6$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("huSKp", function(module, exports) {

$parcel$export(module.exports, "useProductStore", () => $a70fa8c3e7487b0b$export$92ab3e2639125d42);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");

var $gqFxE = parcelRequire("gqFxE");

var $1zKtH = parcelRequire("1zKtH");

var $6g6T7 = parcelRequire("6g6T7");

var $7O2xm = parcelRequire("7O2xm");
const $a70fa8c3e7487b0b$var$BASE_URL = "https://7m46tnf5wd.execute-api.ap-southeast-2.amazonaws.com/prod/api/search/geo";
const $a70fa8c3e7487b0b$export$92ab3e2639125d42 = (0, $gqFxE.defineStore)("product-store", ()=>{
    const { years: years, altitude: altitude, media: media, specifics: specifics, searchPage: searchPage } = (0, $7O2xm.useCategoryStore)();
    const perPage = window.pageLimit;
    const lat = (0, $8bTPG.ref)(0);
    const lng = (0, $8bTPG.ref)(0);
    const radius = (0, $8bTPG.ref)(0);
    setCords();
    const total = (0, $8bTPG.ref)(0);
    const isLoading = (0, $8bTPG.ref)(false);
    const gridClass = (0, $8bTPG.ref)((0, $6g6T7.GridClass).LIST);
    const initialRequest = (0, $8bTPG.ref)({
        lat: lat,
        lng: lng,
        perPage: perPage,
        radius: radius,
        page: 1,
        sort: [
            [
                (0, $6g6T7.SortField).CREATED_AT,
                (0, $6g6T7.SortDirection).DESC
            ],
            [
                (0, $6g6T7.SortField).DISTANCE,
                (0, $6g6T7.SortDirection).ASC
            ]
        ]
    });
    const prodRequest = (0, $8bTPG.ref)({
        lat: lat,
        lng: lng,
        perPage: perPage,
        page: 1,
        radius: radius,
        sort: [
            [
                (0, $6g6T7.SortField).CREATED_AT,
                (0, $6g6T7.SortDirection).DESC
            ],
            [
                (0, $6g6T7.SortField).DISTANCE,
                (0, $6g6T7.SortDirection).ASC
            ]
        ]
    });
    const products = (0, $8bTPG.ref)([]);
    const appliedFilters = (0, $8bTPG.ref)(null);
    const maxPage = (0, $8bTPG.computed)(()=>{
        return Math.ceil(total.value / perPage);
    });
    const isFilterActive = (0, $8bTPG.computed)(()=>{
        return selectedCount.value > 0;
    });
    const selectedCount = (0, $8bTPG.computed)(()=>{
        return selectedYears.value + selectedAltitude.value + selectedMedia.value + selectedSpecific.value;
    });
    const selectedYears = (0, $8bTPG.computed)(()=>{
        if (searchPage) return prodRequest.value.year ? prodRequest.value.year?.length : 0;
        else return years ? years.filter((item)=>item.selected === "1").length : 0;
    });
    const selectedAltitude = (0, $8bTPG.computed)(()=>{
        if (searchPage) return [
            !!prodRequest.value.altitudeMin || !!prodRequest.value.altitudeMax
        ].filter(Boolean).length;
        else return altitude ? altitude.filter((item)=>item.selected === "1").length : 0;
    });
    const selectedMedia = (0, $8bTPG.computed)(()=>{
        if (searchPage) {
            if (!prodRequest.value.media) return 0;
            if (prodRequest.value.media === (0, $6g6T7.Media).ALL) return 2;
            return 1;
        } else return media ? media.filter((item)=>item.selected === "1").length : 0;
    });
    const selectedSpecific = (0, $8bTPG.computed)(()=>{
        if (searchPage) return [
            !!prodRequest.value.isNighttime,
            !!prodRequest.value.isSunrise,
            !!prodRequest.value.isSunrise
        ].filter(Boolean).length;
        else return specifics ? specifics.filter((item)=>item.selected === "1").length : 0;
    });
    function setInitialRequest(request) {
        initialRequest.value = request;
        prodRequest.value = request;
    }
    function setCords() {
        const currentUrl = window.location.href;
        const url = new URL(currentUrl);
        const params = url.searchParams;
        const initLat = params.get("lat");
        const initLng = params.get("lng");
        if (initLat && initLng) {
            lat.value = +initLat;
            lng.value = +initLng;
            radius.value = window.addressRadius;
        } else {
            lat.value = window.cord.lat;
            lng.value = window.cord.lng;
            radius.value = window.radius;
        }
    }
    function setRequest(request) {
        prodRequest.value = request;
        getProducts();
    }
    function resetFilters() {
        if (!isFilterActive.value) return;
        if (!searchPage) {
            let link = window.location;
            window.location.replace(link.origin + link.pathname);
            return;
        }
        prodRequest.value = {
            ...initialRequest.value
        };
        getProducts();
    }
    function composeUrl() {
        return Object.keys(prodRequest.value).reduce((acc, item)=>{
            const value = item === "sort" ? JSON.stringify(prodRequest.value[item]) : prodRequest.value[item];
            return `${acc}${item}=${value}&`;
        }, `${$a70fa8c3e7487b0b$var$BASE_URL}?`);
    }
    async function getProducts() {
        try {
            isLoading.value = true;
            const url = composeUrl();
            const response = await (0, (/*@__PURE__*/$parcel$interopDefault($1zKtH))).get(url);
            products.value = response.data.data;
            appliedFilters.value = response.data.searchMetadata;
            total.value = response.data.searchMetadata.itemsTotal;
        } catch (e) {
            console.log(e);
        } finally{
            isLoading.value = false;
        }
    }
    function deepEqual(obj1, obj2) {
        if (obj1 === obj2) return true;
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length) return false;
        for (let key of keys1){
            if (!obj2.hasOwnProperty(key) || !deepEqual(obj1[key], obj2[key])) return false;
        }
        return true;
    }
    function setGrid(cssClass) {
        gridClass.value = cssClass;
    }
    function goToLink(category) {
        if (category.selected === "0") window.location.href = category.add;
        else window.location.href = category.remove;
    }
    return {
        getProducts: getProducts,
        resetFilters: resetFilters,
        setInitialRequest: setInitialRequest,
        setRequest: setRequest,
        setGrid: setGrid,
        prodRequest: prodRequest,
        isFilterActive: isFilterActive,
        selectedCount: selectedCount,
        selectedYears: selectedYears,
        selectedAltitude: selectedAltitude,
        initialRequest: initialRequest,
        selectedMedia: selectedMedia,
        isLoading: isLoading,
        gridClass: gridClass,
        appliedFilters: appliedFilters,
        products: products,
        maxPage: maxPage,
        selectedSpecific: selectedSpecific,
        total: total,
        goToLink: goToLink
    };
});

});
parcelRegister("gqFxE", function(module, exports) {

$parcel$export(module.exports, "createPinia", () => $cadf5b4931a2c7e1$export$4b9f6a0748623d44);
$parcel$export(module.exports, "defineStore", () => $cadf5b4931a2c7e1$export$5061c4f75bbcb4a);
$parcel$export(module.exports, "storeToRefs", () => $cadf5b4931a2c7e1$export$586af8bd019552de);
/*!
 * pinia v2.1.7
 * (c) 2023 Eduardo San Martin Morote
 * @license MIT
 */ parcelRequire("4h3Sd");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");
var $4h3Sd = parcelRequire("4h3Sd");

var $4GZdJ = parcelRequire("4GZdJ");
/**
 * setActivePinia must be called to handle SSR at the top of functions like
 * `fetch`, `setup`, `serverPrefetch` and others
 */ let $cadf5b4931a2c7e1$var$activePinia;
/**
 * Sets or unsets the active pinia. Used in SSR and internally when calling
 * actions and getters
 *
 * @param pinia - Pinia instance
 */ // @ts-expect-error: cannot constrain the type of the return
const $cadf5b4931a2c7e1$export$89ffb8149ccd46af = (pinia)=>$cadf5b4931a2c7e1$var$activePinia = pinia;
/**
 * Get the currently active pinia if there is any.
 */ const $cadf5b4931a2c7e1$export$d0cc41ca14a2d060 = ()=>(0, $ani5R.hasInjectionContext)() && (0, $ani5R.inject)($cadf5b4931a2c7e1$var$piniaSymbol) || $cadf5b4931a2c7e1$var$activePinia;
const $cadf5b4931a2c7e1$var$piniaSymbol = /* istanbul ignore next */ Symbol();
function $cadf5b4931a2c7e1$var$isPlainObject(// eslint-disable-next-line @typescript-eslint/no-explicit-any
o) {
    return o && typeof o === "object" && Object.prototype.toString.call(o) === "[object Object]" && typeof o.toJSON !== "function";
}
// type DeepReadonly<T> = { readonly [P in keyof T]: DeepReadonly<T[P]> }
// TODO: can we change these to numbers?
/**
 * Possible types for SubscriptionCallback
 */ var $cadf5b4931a2c7e1$export$d97371ba8df8c539;
(function(MutationType) {
    /**
     * Direct mutation of the state:
     *
     * - `store.name = 'new name'`
     * - `store.$state.name = 'new name'`
     * - `store.list.push('new item')`
     */ MutationType["direct"] = "direct";
    /**
     * Mutated the state with `$patch` and an object
     *
     * - `store.$patch({ name: 'newName' })`
     */ MutationType["patchObject"] = "patch object";
    /**
     * Mutated the state with `$patch` and a function
     *
     * - `store.$patch(state => state.name = 'newName')`
     */ MutationType["patchFunction"] = "patch function";
// maybe reset? for $state = {} and $reset
})($cadf5b4931a2c7e1$export$d97371ba8df8c539 || ($cadf5b4931a2c7e1$export$d97371ba8df8c539 = {}));
const $cadf5b4931a2c7e1$var$IS_CLIENT = typeof window !== "undefined";
/**
 * Should we add the devtools plugins.
 * - only if dev mode or forced through the prod devtools flag
 * - not in test
 * - only if window exists (could change in the future)
 */ const $cadf5b4931a2c7e1$var$USE_DEVTOOLS = typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__ && true && $cadf5b4931a2c7e1$var$IS_CLIENT;
/*
 * FileSaver.js A saveAs() FileSaver implementation.
 *
 * Originally by Eli Grey, adapted as an ESM module by Eduardo San Martin
 * Morote.
 *
 * License : MIT
 */ // The one and only way of getting global scope in all environments
// https://stackoverflow.com/q/3277182/1008999
const $cadf5b4931a2c7e1$var$_global = /*#__PURE__*/ (()=>typeof window === "object" && window.window === window ? window : typeof self === "object" && self.self === self ? self : typeof $parcel$global === "object" && $parcel$global.global === $parcel$global ? $parcel$global : typeof globalThis === "object" ? globalThis : {
        HTMLElement: null
    })();
function $cadf5b4931a2c7e1$var$bom(blob, { autoBom: autoBom = false } = {}) {
    // prepend BOM for UTF-8 XML and text/* types (including HTML)
    // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
    if (autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
        String.fromCharCode(0xfeff),
        blob
    ], {
        type: blob.type
    });
    return blob;
}
function $cadf5b4931a2c7e1$var$download(url, name, opts) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.onload = function() {
        $cadf5b4931a2c7e1$var$saveAs(xhr.response, name, opts);
    };
    xhr.onerror = function() {
        console.error("could not download file");
    };
    xhr.send();
}
function $cadf5b4931a2c7e1$var$corsEnabled(url) {
    const xhr = new XMLHttpRequest();
    // use sync to avoid popup blocker
    xhr.open("HEAD", url, false);
    try {
        xhr.send();
    } catch (e) {}
    return xhr.status >= 200 && xhr.status <= 299;
}
// `a.click()` doesn't work for all browsers (#465)
function $cadf5b4931a2c7e1$var$click(node) {
    try {
        node.dispatchEvent(new MouseEvent("click"));
    } catch (e) {
        const evt = document.createEvent("MouseEvents");
        evt.initMouseEvent("click", true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
        node.dispatchEvent(evt);
    }
}
const $cadf5b4931a2c7e1$var$_navigator = typeof navigator === "object" ? navigator : {
    userAgent: ""
};
// Detect WebView inside a native macOS app by ruling out all browsers
// We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
// https://www.whatismybrowser.com/guides/the-latest-user-agent/macos
const $cadf5b4931a2c7e1$var$isMacOSWebView = /*#__PURE__*/ (()=>/Macintosh/.test($cadf5b4931a2c7e1$var$_navigator.userAgent) && /AppleWebKit/.test($cadf5b4931a2c7e1$var$_navigator.userAgent) && !/Safari/.test($cadf5b4931a2c7e1$var$_navigator.userAgent))();
const $cadf5b4931a2c7e1$var$saveAs = !$cadf5b4931a2c7e1$var$IS_CLIENT ? ()=>{} // noop
 : typeof HTMLAnchorElement !== "undefined" && "download" in HTMLAnchorElement.prototype && !$cadf5b4931a2c7e1$var$isMacOSWebView ? $cadf5b4931a2c7e1$var$downloadSaveAs : "msSaveOrOpenBlob" in $cadf5b4931a2c7e1$var$_navigator ? $cadf5b4931a2c7e1$var$msSaveAs : $cadf5b4931a2c7e1$var$fileSaverSaveAs;
function $cadf5b4931a2c7e1$var$downloadSaveAs(blob, name = "download", opts) {
    const a = document.createElement("a");
    a.download = name;
    a.rel = "noopener"; // tabnabbing
    // TODO: detect chrome extensions & packaged apps
    // a.target = '_blank'
    if (typeof blob === "string") {
        // Support regular links
        a.href = blob;
        if (a.origin !== location.origin) {
            if ($cadf5b4931a2c7e1$var$corsEnabled(a.href)) $cadf5b4931a2c7e1$var$download(blob, name, opts);
            else {
                a.target = "_blank";
                $cadf5b4931a2c7e1$var$click(a);
            }
        } else $cadf5b4931a2c7e1$var$click(a);
    } else {
        // Support blobs
        a.href = URL.createObjectURL(blob);
        setTimeout(function() {
            URL.revokeObjectURL(a.href);
        }, 4e4); // 40s
        setTimeout(function() {
            $cadf5b4931a2c7e1$var$click(a);
        }, 0);
    }
}
function $cadf5b4931a2c7e1$var$msSaveAs(blob, name = "download", opts) {
    if (typeof blob === "string") {
        if ($cadf5b4931a2c7e1$var$corsEnabled(blob)) $cadf5b4931a2c7e1$var$download(blob, name, opts);
        else {
            const a = document.createElement("a");
            a.href = blob;
            a.target = "_blank";
            setTimeout(function() {
                $cadf5b4931a2c7e1$var$click(a);
            });
        }
    } else // @ts-ignore: works on windows
    navigator.msSaveOrOpenBlob($cadf5b4931a2c7e1$var$bom(blob, opts), name);
}
function $cadf5b4931a2c7e1$var$fileSaverSaveAs(blob, name, opts, popup) {
    // Open a popup immediately do go around popup blocker
    // Mostly only available on user interaction and the fileReader is async so...
    popup = popup || open("", "_blank");
    if (popup) popup.document.title = popup.document.body.innerText = "downloading...";
    if (typeof blob === "string") return $cadf5b4931a2c7e1$var$download(blob, name, opts);
    const force = blob.type === "application/octet-stream";
    const isSafari = /constructor/i.test(String($cadf5b4931a2c7e1$var$_global.HTMLElement)) || "safari" in $cadf5b4931a2c7e1$var$_global;
    const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((isChromeIOS || force && isSafari || $cadf5b4931a2c7e1$var$isMacOSWebView) && typeof FileReader !== "undefined") {
        // Safari doesn't allow downloading of blob URLs
        const reader = new FileReader();
        reader.onloadend = function() {
            let url = reader.result;
            if (typeof url !== "string") {
                popup = null;
                throw new Error("Wrong reader.result type");
            }
            url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, "data:attachment/file;");
            if (popup) popup.location.href = url;
            else location.assign(url);
            popup = null; // reverse-tabnabbing #460
        };
        reader.readAsDataURL(blob);
    } else {
        const url = URL.createObjectURL(blob);
        if (popup) popup.location.assign(url);
        else location.href = url;
        popup = null; // reverse-tabnabbing #460
        setTimeout(function() {
            URL.revokeObjectURL(url);
        }, 4e4); // 40s
    }
}
/**
 * Shows a toast or console.log
 *
 * @param message - message to log
 * @param type - different color of the tooltip
 */ function $cadf5b4931a2c7e1$var$toastMessage(message, type) {
    const piniaMessage = "\uD83C\uDF4D " + message;
    if (typeof __VUE_DEVTOOLS_TOAST__ === "function") // No longer available :(
    __VUE_DEVTOOLS_TOAST__(piniaMessage, type);
    else if (type === "error") console.error(piniaMessage);
    else if (type === "warn") console.warn(piniaMessage);
    else console.log(piniaMessage);
}
function $cadf5b4931a2c7e1$var$isPinia(o) {
    return "_a" in o && "install" in o;
}
/**
 * This file contain devtools actions, they are not Pinia actions.
 */ // ---
function $cadf5b4931a2c7e1$var$checkClipboardAccess() {
    if (!("clipboard" in navigator)) {
        $cadf5b4931a2c7e1$var$toastMessage(`Your browser doesn't support the Clipboard API`, "error");
        return true;
    }
}
function $cadf5b4931a2c7e1$var$checkNotFocusedError(error) {
    if (error instanceof Error && error.message.toLowerCase().includes("document is not focused")) {
        $cadf5b4931a2c7e1$var$toastMessage('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', "warn");
        return true;
    }
    return false;
}
async function $cadf5b4931a2c7e1$var$actionGlobalCopyState(pinia) {
    if ($cadf5b4931a2c7e1$var$checkClipboardAccess()) return;
    try {
        await navigator.clipboard.writeText(JSON.stringify(pinia.state.value));
        $cadf5b4931a2c7e1$var$toastMessage("Global state copied to clipboard.");
    } catch (error) {
        if ($cadf5b4931a2c7e1$var$checkNotFocusedError(error)) return;
        $cadf5b4931a2c7e1$var$toastMessage(`Failed to serialize the state. Check the console for more details.`, "error");
        console.error(error);
    }
}
async function $cadf5b4931a2c7e1$var$actionGlobalPasteState(pinia) {
    if ($cadf5b4931a2c7e1$var$checkClipboardAccess()) return;
    try {
        $cadf5b4931a2c7e1$var$loadStoresState(pinia, JSON.parse(await navigator.clipboard.readText()));
        $cadf5b4931a2c7e1$var$toastMessage("Global state pasted from clipboard.");
    } catch (error) {
        if ($cadf5b4931a2c7e1$var$checkNotFocusedError(error)) return;
        $cadf5b4931a2c7e1$var$toastMessage(`Failed to deserialize the state from clipboard. Check the console for more details.`, "error");
        console.error(error);
    }
}
async function $cadf5b4931a2c7e1$var$actionGlobalSaveState(pinia) {
    try {
        $cadf5b4931a2c7e1$var$saveAs(new Blob([
            JSON.stringify(pinia.state.value)
        ], {
            type: "text/plain;charset=utf-8"
        }), "pinia-state.json");
    } catch (error) {
        $cadf5b4931a2c7e1$var$toastMessage(`Failed to export the state as JSON. Check the console for more details.`, "error");
        console.error(error);
    }
}
let $cadf5b4931a2c7e1$var$fileInput;
function $cadf5b4931a2c7e1$var$getFileOpener() {
    if (!$cadf5b4931a2c7e1$var$fileInput) {
        $cadf5b4931a2c7e1$var$fileInput = document.createElement("input");
        $cadf5b4931a2c7e1$var$fileInput.type = "file";
        $cadf5b4931a2c7e1$var$fileInput.accept = ".json";
    }
    function openFile() {
        return new Promise((resolve, reject)=>{
            $cadf5b4931a2c7e1$var$fileInput.onchange = async ()=>{
                const files = $cadf5b4931a2c7e1$var$fileInput.files;
                if (!files) return resolve(null);
                const file = files.item(0);
                if (!file) return resolve(null);
                return resolve({
                    text: await file.text(),
                    file: file
                });
            };
            // @ts-ignore: TODO: changed from 4.3 to 4.4
            $cadf5b4931a2c7e1$var$fileInput.oncancel = ()=>resolve(null);
            $cadf5b4931a2c7e1$var$fileInput.onerror = reject;
            $cadf5b4931a2c7e1$var$fileInput.click();
        });
    }
    return openFile;
}
async function $cadf5b4931a2c7e1$var$actionGlobalOpenStateFile(pinia) {
    try {
        const open1 = $cadf5b4931a2c7e1$var$getFileOpener();
        const result = await open1();
        if (!result) return;
        const { text: text, file: file } = result;
        $cadf5b4931a2c7e1$var$loadStoresState(pinia, JSON.parse(text));
        $cadf5b4931a2c7e1$var$toastMessage(`Global state imported from "${file.name}".`);
    } catch (error) {
        $cadf5b4931a2c7e1$var$toastMessage(`Failed to import the state from JSON. Check the console for more details.`, "error");
        console.error(error);
    }
}
function $cadf5b4931a2c7e1$var$loadStoresState(pinia, state) {
    for(const key in state){
        const storeState = pinia.state.value[key];
        // store is already instantiated, patch it
        if (storeState) Object.assign(storeState, state[key]);
        else // store is not instantiated, set the initial state
        pinia.state.value[key] = state[key];
    }
}
function $cadf5b4931a2c7e1$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
const $cadf5b4931a2c7e1$var$PINIA_ROOT_LABEL = "\uD83C\uDF4D Pinia (root)";
const $cadf5b4931a2c7e1$var$PINIA_ROOT_ID = "_root";
function $cadf5b4931a2c7e1$var$formatStoreForInspectorTree(store) {
    return $cadf5b4931a2c7e1$var$isPinia(store) ? {
        id: $cadf5b4931a2c7e1$var$PINIA_ROOT_ID,
        label: $cadf5b4931a2c7e1$var$PINIA_ROOT_LABEL
    } : {
        id: store.$id,
        label: store.$id
    };
}
function $cadf5b4931a2c7e1$var$formatStoreForInspectorState(store) {
    if ($cadf5b4931a2c7e1$var$isPinia(store)) {
        const storeNames = Array.from(store._s.keys());
        const storeMap = store._s;
        const state = {
            state: storeNames.map((storeId)=>({
                    editable: true,
                    key: storeId,
                    value: store.state.value[storeId]
                })),
            getters: storeNames.filter((id)=>storeMap.get(id)._getters).map((id)=>{
                const store = storeMap.get(id);
                return {
                    editable: false,
                    key: id,
                    value: store._getters.reduce((getters, key)=>{
                        getters[key] = store[key];
                        return getters;
                    }, {})
                };
            })
        };
        return state;
    }
    const state = {
        state: Object.keys(store.$state).map((key)=>({
                editable: true,
                key: key,
                value: store.$state[key]
            }))
    };
    // avoid adding empty getters
    if (store._getters && store._getters.length) state.getters = store._getters.map((getterName)=>({
            editable: false,
            key: getterName,
            value: store[getterName]
        }));
    if (store._customProperties.size) state.customProperties = Array.from(store._customProperties).map((key)=>({
            editable: true,
            key: key,
            value: store[key]
        }));
    return state;
}
function $cadf5b4931a2c7e1$var$formatEventData(events) {
    if (!events) return {};
    if (Array.isArray(events)) // TODO: handle add and delete for arrays and objects
    return events.reduce((data, event)=>{
        data.keys.push(event.key);
        data.operations.push(event.type);
        data.oldValue[event.key] = event.oldValue;
        data.newValue[event.key] = event.newValue;
        return data;
    }, {
        oldValue: {},
        keys: [],
        operations: [],
        newValue: {}
    });
    else return {
        operation: $cadf5b4931a2c7e1$var$formatDisplay(events.type),
        key: $cadf5b4931a2c7e1$var$formatDisplay(events.key),
        oldValue: events.oldValue,
        newValue: events.newValue
    };
}
function $cadf5b4931a2c7e1$var$formatMutationType(type) {
    switch(type){
        case $cadf5b4931a2c7e1$export$d97371ba8df8c539.direct:
            return "mutation";
        case $cadf5b4931a2c7e1$export$d97371ba8df8c539.patchFunction:
            return "$patch";
        case $cadf5b4931a2c7e1$export$d97371ba8df8c539.patchObject:
            return "$patch";
        default:
            return "unknown";
    }
}
// timeline can be paused when directly changing the state
let $cadf5b4931a2c7e1$var$isTimelineActive = true;
const $cadf5b4931a2c7e1$var$componentStateTypes = [];
const $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID = "pinia:mutations";
const $cadf5b4931a2c7e1$var$INSPECTOR_ID = "pinia";
const { assign: $cadf5b4931a2c7e1$var$assign$1 } = Object;
/**
 * Gets the displayed name of a store in devtools
 *
 * @param id - id of the store
 * @returns a formatted string
 */ const $cadf5b4931a2c7e1$var$getStoreType = (id)=>"\uD83C\uDF4D " + id;
/**
 * Add the pinia plugin without any store. Allows displaying a Pinia plugin tab
 * as soon as it is added to the application.
 *
 * @param app - Vue application
 * @param pinia - pinia instance
 */ function $cadf5b4931a2c7e1$var$registerPiniaDevtools(app, pinia) {
    (0, $4GZdJ.setupDevtoolsPlugin)({
        id: "dev.esm.pinia",
        label: "Pinia \uD83C\uDF4D",
        logo: "https://pinia.vuejs.org/logo.svg",
        packageName: "pinia",
        homepage: "https://pinia.vuejs.org",
        componentStateTypes: $cadf5b4931a2c7e1$var$componentStateTypes,
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") $cadf5b4931a2c7e1$var$toastMessage("You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        api.addTimelineLayer({
            id: $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID,
            label: `Pinia \u{1F34D}`,
            color: 0xe5df88
        });
        api.addInspector({
            id: $cadf5b4931a2c7e1$var$INSPECTOR_ID,
            label: "Pinia \uD83C\uDF4D",
            icon: "storage",
            treeFilterPlaceholder: "Search stores",
            actions: [
                {
                    icon: "content_copy",
                    action: ()=>{
                        $cadf5b4931a2c7e1$var$actionGlobalCopyState(pinia);
                    },
                    tooltip: "Serialize and copy the state"
                },
                {
                    icon: "content_paste",
                    action: async ()=>{
                        await $cadf5b4931a2c7e1$var$actionGlobalPasteState(pinia);
                        api.sendInspectorTree($cadf5b4931a2c7e1$var$INSPECTOR_ID);
                        api.sendInspectorState($cadf5b4931a2c7e1$var$INSPECTOR_ID);
                    },
                    tooltip: "Replace the state with the content of your clipboard"
                },
                {
                    icon: "save",
                    action: ()=>{
                        $cadf5b4931a2c7e1$var$actionGlobalSaveState(pinia);
                    },
                    tooltip: "Save the state as a JSON file"
                },
                {
                    icon: "folder_open",
                    action: async ()=>{
                        await $cadf5b4931a2c7e1$var$actionGlobalOpenStateFile(pinia);
                        api.sendInspectorTree($cadf5b4931a2c7e1$var$INSPECTOR_ID);
                        api.sendInspectorState($cadf5b4931a2c7e1$var$INSPECTOR_ID);
                    },
                    tooltip: "Import the state from a JSON file"
                }
            ],
            nodeActions: [
                {
                    icon: "restore",
                    tooltip: 'Reset the state (with "$reset")',
                    action: (nodeId)=>{
                        const store = pinia._s.get(nodeId);
                        if (!store) $cadf5b4931a2c7e1$var$toastMessage(`Cannot reset "${nodeId}" store because it wasn't found.`, "warn");
                        else if (typeof store.$reset !== "function") $cadf5b4931a2c7e1$var$toastMessage(`Cannot reset "${nodeId}" store because it doesn't have a "$reset" method implemented.`, "warn");
                        else {
                            store.$reset();
                            $cadf5b4931a2c7e1$var$toastMessage(`Store "${nodeId}" reset.`);
                        }
                    }
                }
            ]
        });
        api.on.inspectComponent((payload, ctx)=>{
            const proxy = payload.componentInstance && payload.componentInstance.proxy;
            if (proxy && proxy._pStores) {
                const piniaStores = payload.componentInstance.proxy._pStores;
                Object.values(piniaStores).forEach((store)=>{
                    payload.instanceData.state.push({
                        type: $cadf5b4931a2c7e1$var$getStoreType(store.$id),
                        key: "state",
                        editable: true,
                        value: store._isOptionsAPI ? {
                            _custom: {
                                value: (0, $8bTPG.toRaw)(store.$state),
                                actions: [
                                    {
                                        icon: "restore",
                                        tooltip: "Reset the state of this store",
                                        action: ()=>store.$reset()
                                    }
                                ]
                            }
                        } : Object.keys(store.$state).reduce((state, key)=>{
                            state[key] = store.$state[key];
                            return state;
                        }, {})
                    });
                    if (store._getters && store._getters.length) payload.instanceData.state.push({
                        type: $cadf5b4931a2c7e1$var$getStoreType(store.$id),
                        key: "getters",
                        editable: false,
                        value: store._getters.reduce((getters, key)=>{
                            try {
                                getters[key] = store[key];
                            } catch (error) {
                                // @ts-expect-error: we just want to show it in devtools
                                getters[key] = error;
                            }
                            return getters;
                        }, {})
                    });
                });
            }
        });
        api.on.getInspectorTree((payload)=>{
            if (payload.app === app && payload.inspectorId === $cadf5b4931a2c7e1$var$INSPECTOR_ID) {
                let stores = [
                    pinia
                ];
                stores = stores.concat(Array.from(pinia._s.values()));
                payload.rootNodes = (payload.filter ? stores.filter((store)=>"$id" in store ? store.$id.toLowerCase().includes(payload.filter.toLowerCase()) : $cadf5b4931a2c7e1$var$PINIA_ROOT_LABEL.toLowerCase().includes(payload.filter.toLowerCase())) : stores).map($cadf5b4931a2c7e1$var$formatStoreForInspectorTree);
            }
        });
        api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === $cadf5b4931a2c7e1$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === $cadf5b4931a2c7e1$var$PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) // this could be the selected store restored for a different project
                // so it's better not to say anything here
                return;
                if (inspectedStore) payload.state = $cadf5b4931a2c7e1$var$formatStoreForInspectorState(inspectedStore);
            }
        });
        api.on.editInspectorState((payload, ctx)=>{
            if (payload.app === app && payload.inspectorId === $cadf5b4931a2c7e1$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === $cadf5b4931a2c7e1$var$PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) return $cadf5b4931a2c7e1$var$toastMessage(`store "${payload.nodeId}" not found`, "error");
                const { path: path } = payload;
                if (!$cadf5b4931a2c7e1$var$isPinia(inspectedStore)) // access only the state
                {
                    if (path.length !== 1 || !inspectedStore._customProperties.has(path[0]) || path[0] in inspectedStore.$state) path.unshift("$state");
                } else // Root access, we can omit the `.value` because the devtools API does it for us
                path.unshift("state");
                $cadf5b4931a2c7e1$var$isTimelineActive = false;
                payload.set(inspectedStore, path, payload.state.value);
                $cadf5b4931a2c7e1$var$isTimelineActive = true;
            }
        });
        api.on.editComponentState((payload)=>{
            if (payload.type.startsWith("\uD83C\uDF4D")) {
                const storeId = payload.type.replace(/^🍍\s*/, "");
                const store = pinia._s.get(storeId);
                if (!store) return $cadf5b4931a2c7e1$var$toastMessage(`store "${storeId}" not found`, "error");
                const { path: path } = payload;
                if (path[0] !== "state") return $cadf5b4931a2c7e1$var$toastMessage(`Invalid path for store "${storeId}":\n${path}\nOnly state can be modified.`);
                // rewrite the first entry to be able to directly set the state as
                // well as any other path
                path[0] = "$state";
                $cadf5b4931a2c7e1$var$isTimelineActive = false;
                payload.set(store, path, payload.state.value);
                $cadf5b4931a2c7e1$var$isTimelineActive = true;
            }
        });
    });
}
function $cadf5b4931a2c7e1$var$addStoreToDevtools(app, store) {
    if (!$cadf5b4931a2c7e1$var$componentStateTypes.includes($cadf5b4931a2c7e1$var$getStoreType(store.$id))) $cadf5b4931a2c7e1$var$componentStateTypes.push($cadf5b4931a2c7e1$var$getStoreType(store.$id));
    (0, $4GZdJ.setupDevtoolsPlugin)({
        id: "dev.esm.pinia",
        label: "Pinia \uD83C\uDF4D",
        logo: "https://pinia.vuejs.org/logo.svg",
        packageName: "pinia",
        homepage: "https://pinia.vuejs.org",
        componentStateTypes: $cadf5b4931a2c7e1$var$componentStateTypes,
        app: app,
        settings: {
            logStoreChanges: {
                label: "Notify about new/deleted stores",
                type: "boolean",
                defaultValue: true
            }
        }
    }, (api)=>{
        // gracefully handle errors
        const now = typeof api.now === "function" ? api.now.bind(api) : Date.now;
        store.$onAction(({ after: after, onError: onError, name: name, args: args })=>{
            const groupId = $cadf5b4931a2c7e1$var$runningActionId++;
            api.addTimelineEvent({
                layerId: $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDEEB " + name,
                    subtitle: "start",
                    data: {
                        store: $cadf5b4931a2c7e1$var$formatDisplay(store.$id),
                        action: $cadf5b4931a2c7e1$var$formatDisplay(name),
                        args: args
                    },
                    groupId: groupId
                }
            });
            after((result)=>{
                $cadf5b4931a2c7e1$var$activeAction = undefined;
                api.addTimelineEvent({
                    layerId: $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: "\uD83D\uDEEC " + name,
                        subtitle: "end",
                        data: {
                            store: $cadf5b4931a2c7e1$var$formatDisplay(store.$id),
                            action: $cadf5b4931a2c7e1$var$formatDisplay(name),
                            args: args,
                            result: result
                        },
                        groupId: groupId
                    }
                });
            });
            onError((error)=>{
                $cadf5b4931a2c7e1$var$activeAction = undefined;
                api.addTimelineEvent({
                    layerId: $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        logType: "error",
                        title: "\uD83D\uDCA5 " + name,
                        subtitle: "end",
                        data: {
                            store: $cadf5b4931a2c7e1$var$formatDisplay(store.$id),
                            action: $cadf5b4931a2c7e1$var$formatDisplay(name),
                            args: args,
                            error: error
                        },
                        groupId: groupId
                    }
                });
            });
        }, true);
        store._customProperties.forEach((name)=>{
            (0, $ani5R.watch)(()=>(0, $8bTPG.unref)(store[name]), (newValue, oldValue)=>{
                api.notifyComponentUpdate();
                api.sendInspectorState($cadf5b4931a2c7e1$var$INSPECTOR_ID);
                if ($cadf5b4931a2c7e1$var$isTimelineActive) api.addTimelineEvent({
                    layerId: $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: "Change",
                        subtitle: name,
                        data: {
                            newValue: newValue,
                            oldValue: oldValue
                        },
                        groupId: $cadf5b4931a2c7e1$var$activeAction
                    }
                });
            }, {
                deep: true
            });
        });
        store.$subscribe(({ events: events, type: type }, state)=>{
            api.notifyComponentUpdate();
            api.sendInspectorState($cadf5b4931a2c7e1$var$INSPECTOR_ID);
            if (!$cadf5b4931a2c7e1$var$isTimelineActive) return;
            // rootStore.state[store.id] = state
            const eventData = {
                time: now(),
                title: $cadf5b4931a2c7e1$var$formatMutationType(type),
                data: $cadf5b4931a2c7e1$var$assign$1({
                    store: $cadf5b4931a2c7e1$var$formatDisplay(store.$id)
                }, $cadf5b4931a2c7e1$var$formatEventData(events)),
                groupId: $cadf5b4931a2c7e1$var$activeAction
            };
            if (type === $cadf5b4931a2c7e1$export$d97371ba8df8c539.patchFunction) eventData.subtitle = "\u2935\uFE0F";
            else if (type === $cadf5b4931a2c7e1$export$d97371ba8df8c539.patchObject) eventData.subtitle = "\uD83E\uDDE9";
            else if (events && !Array.isArray(events)) eventData.subtitle = events.type;
            if (events) eventData.data["rawEvent(s)"] = {
                _custom: {
                    display: "DebuggerEvent",
                    type: "object",
                    tooltip: "raw DebuggerEvent[]",
                    value: events
                }
            };
            api.addTimelineEvent({
                layerId: $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID,
                event: eventData
            });
        }, {
            detached: true,
            flush: "sync"
        });
        const hotUpdate = store._hotUpdate;
        store._hotUpdate = (0, $8bTPG.markRaw)((newStore)=>{
            hotUpdate(newStore);
            api.addTimelineEvent({
                layerId: $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDD25 " + store.$id,
                    subtitle: "HMR update",
                    data: {
                        store: $cadf5b4931a2c7e1$var$formatDisplay(store.$id),
                        info: $cadf5b4931a2c7e1$var$formatDisplay(`HMR update`)
                    }
                }
            });
            // update the devtools too
            api.notifyComponentUpdate();
            api.sendInspectorTree($cadf5b4931a2c7e1$var$INSPECTOR_ID);
            api.sendInspectorState($cadf5b4931a2c7e1$var$INSPECTOR_ID);
        });
        const { $dispose: $dispose } = store;
        store.$dispose = ()=>{
            $dispose();
            api.notifyComponentUpdate();
            api.sendInspectorTree($cadf5b4931a2c7e1$var$INSPECTOR_ID);
            api.sendInspectorState($cadf5b4931a2c7e1$var$INSPECTOR_ID);
            api.getSettings().logStoreChanges && $cadf5b4931a2c7e1$var$toastMessage(`Disposed "${store.$id}" store \u{1F5D1}`);
        };
        // trigger an update so it can display new registered stores
        api.notifyComponentUpdate();
        api.sendInspectorTree($cadf5b4931a2c7e1$var$INSPECTOR_ID);
        api.sendInspectorState($cadf5b4931a2c7e1$var$INSPECTOR_ID);
        api.getSettings().logStoreChanges && $cadf5b4931a2c7e1$var$toastMessage(`"${store.$id}" store installed \u{1F195}`);
    });
}
let $cadf5b4931a2c7e1$var$runningActionId = 0;
let $cadf5b4931a2c7e1$var$activeAction;
/**
 * Patches a store to enable action grouping in devtools by wrapping the store with a Proxy that is passed as the
 * context of all actions, allowing us to set `runningAction` on each access and effectively associating any state
 * mutation to the action.
 *
 * @param store - store to patch
 * @param actionNames - list of actionst to patch
 */ function $cadf5b4931a2c7e1$var$patchActionForGrouping(store, actionNames, wrapWithProxy) {
    // original actions of the store as they are given by pinia. We are going to override them
    const actions = actionNames.reduce((storeActions, actionName)=>{
        // use toRaw to avoid tracking #541
        storeActions[actionName] = (0, $8bTPG.toRaw)(store)[actionName];
        return storeActions;
    }, {});
    for(const actionName in actions)store[actionName] = function() {
        // the running action id is incremented in a before action hook
        const _actionId = $cadf5b4931a2c7e1$var$runningActionId;
        const trackedStore = wrapWithProxy ? new Proxy(store, {
            get (...args) {
                $cadf5b4931a2c7e1$var$activeAction = _actionId;
                return Reflect.get(...args);
            },
            set (...args) {
                $cadf5b4931a2c7e1$var$activeAction = _actionId;
                return Reflect.set(...args);
            }
        }) : store;
        // For Setup Stores we need https://github.com/tc39/proposal-async-context
        $cadf5b4931a2c7e1$var$activeAction = _actionId;
        const retValue = actions[actionName].apply(trackedStore, arguments);
        // this is safer as async actions in Setup Stores would associate mutations done outside of the action
        $cadf5b4931a2c7e1$var$activeAction = undefined;
        return retValue;
    };
}
/**
 * pinia.use(devtoolsPlugin)
 */ function $cadf5b4931a2c7e1$var$devtoolsPlugin({ app: app, store: store, options: options }) {
    // HMR module
    if (store.$id.startsWith("__hot:")) return;
    // detect option api vs setup api
    store._isOptionsAPI = !!options.state;
    $cadf5b4931a2c7e1$var$patchActionForGrouping(store, Object.keys(options.actions), store._isOptionsAPI);
    // Upgrade the HMR to also update the new actions
    const originalHotUpdate = store._hotUpdate;
    (0, $8bTPG.toRaw)(store)._hotUpdate = function(newStore) {
        originalHotUpdate.apply(this, arguments);
        $cadf5b4931a2c7e1$var$patchActionForGrouping(store, Object.keys(newStore._hmrPayload.actions), !!store._isOptionsAPI);
    };
    $cadf5b4931a2c7e1$var$addStoreToDevtools(app, // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
    store);
}
/**
 * Creates a Pinia instance to be used by the application
 */ function $cadf5b4931a2c7e1$export$4b9f6a0748623d44() {
    const scope = (0, $8bTPG.effectScope)(true);
    // NOTE: here we could check the window object for a state and directly set it
    // if there is anything like it with Vue 3 SSR
    const state = scope.run(()=>(0, $8bTPG.ref)({}));
    let _p = [];
    // plugins added before calling app.use(pinia)
    let toBeInstalled = [];
    const pinia = (0, $8bTPG.markRaw)({
        install (app) {
            // this allows calling useStore() outside of a component setup after
            // installing pinia's plugin
            $cadf5b4931a2c7e1$export$89ffb8149ccd46af(pinia);
            if (!(0, $4h3Sd.isVue2)) {
                pinia._a = app;
                app.provide($cadf5b4931a2c7e1$var$piniaSymbol, pinia);
                app.config.globalProperties.$pinia = pinia;
                /* istanbul ignore else */ if ($cadf5b4931a2c7e1$var$USE_DEVTOOLS) $cadf5b4931a2c7e1$var$registerPiniaDevtools(app, pinia);
                toBeInstalled.forEach((plugin)=>_p.push(plugin));
                toBeInstalled = [];
            }
        },
        use (plugin) {
            if (!this._a && !(0, $4h3Sd.isVue2)) toBeInstalled.push(plugin);
            else _p.push(plugin);
            return this;
        },
        _p: _p,
        // it's actually undefined here
        // @ts-expect-error
        _a: null,
        _e: scope,
        _s: new Map(),
        state: state
    });
    // pinia devtools rely on dev only features so they cannot be forced unless
    // the dev build of Vue is used. Avoid old browsers like IE11.
    if ($cadf5b4931a2c7e1$var$USE_DEVTOOLS && typeof Proxy !== "undefined") pinia.use($cadf5b4931a2c7e1$var$devtoolsPlugin);
    return pinia;
}
/**
 * Checks if a function is a `StoreDefinition`.
 *
 * @param fn - object to test
 * @returns true if `fn` is a StoreDefinition
 */ const $cadf5b4931a2c7e1$var$isUseStore = (fn)=>{
    return typeof fn === "function" && typeof fn.$id === "string";
};
/**
 * Mutates in place `newState` with `oldState` to _hot update_ it. It will
 * remove any key not existing in `newState` and recursively merge plain
 * objects.
 *
 * @param newState - new state object to be patched
 * @param oldState - old state that should be used to patch newState
 * @returns - newState
 */ function $cadf5b4931a2c7e1$var$patchObject(newState, oldState) {
    // no need to go through symbols because they cannot be serialized anyway
    for(const key in oldState){
        const subPatch = oldState[key];
        // skip the whole sub tree
        if (!(key in newState)) continue;
        const targetValue = newState[key];
        if ($cadf5b4931a2c7e1$var$isPlainObject(targetValue) && $cadf5b4931a2c7e1$var$isPlainObject(subPatch) && !(0, $8bTPG.isRef)(subPatch) && !(0, $8bTPG.isReactive)(subPatch)) newState[key] = $cadf5b4931a2c7e1$var$patchObject(targetValue, subPatch);
        else // objects are either a bit more complex (e.g. refs) or primitives, so we
        // just set the whole thing
        if (0, $4h3Sd.isVue2) (0, $4h3Sd.set)(newState, key, subPatch);
        else newState[key] = subPatch;
    }
    return newState;
}
/**
 * Creates an _accept_ function to pass to `import.meta.hot` in Vite applications.
 *
 * @example
 * ```js
 * const useUser = defineStore(...)
 * if (import.meta.hot) {
 *   import.meta.hot.accept(acceptHMRUpdate(useUser, import.meta.hot))
 * }
 * ```
 *
 * @param initialUseStore - return of the defineStore to hot update
 * @param hot - `import.meta.hot`
 */ function $cadf5b4931a2c7e1$export$d3530ca2abd36d5e(initialUseStore, hot) {
    var newModule;
    return ()=>{};
}
const $cadf5b4931a2c7e1$var$noop = ()=>{};
function $cadf5b4931a2c7e1$var$addSubscription(subscriptions, callback, detached, onCleanup = $cadf5b4931a2c7e1$var$noop) {
    subscriptions.push(callback);
    const removeSubscription = ()=>{
        const idx = subscriptions.indexOf(callback);
        if (idx > -1) {
            subscriptions.splice(idx, 1);
            onCleanup();
        }
    };
    if (!detached && (0, $8bTPG.getCurrentScope)()) (0, $8bTPG.onScopeDispose)(removeSubscription);
    return removeSubscription;
}
function $cadf5b4931a2c7e1$var$triggerSubscriptions(subscriptions, ...args) {
    subscriptions.slice().forEach((callback)=>{
        callback(...args);
    });
}
const $cadf5b4931a2c7e1$var$fallbackRunWithContext = (fn)=>fn();
function $cadf5b4931a2c7e1$var$mergeReactiveObjects(target, patchToApply) {
    // Handle Map instances
    if (target instanceof Map && patchToApply instanceof Map) patchToApply.forEach((value, key)=>target.set(key, value));
    // Handle Set instances
    if (target instanceof Set && patchToApply instanceof Set) patchToApply.forEach(target.add, target);
    // no need to go through symbols because they cannot be serialized anyway
    for(const key in patchToApply){
        if (!patchToApply.hasOwnProperty(key)) continue;
        const subPatch = patchToApply[key];
        const targetValue = target[key];
        if ($cadf5b4931a2c7e1$var$isPlainObject(targetValue) && $cadf5b4931a2c7e1$var$isPlainObject(subPatch) && target.hasOwnProperty(key) && !(0, $8bTPG.isRef)(subPatch) && !(0, $8bTPG.isReactive)(subPatch)) // NOTE: here I wanted to warn about inconsistent types but it's not possible because in setup stores one might
        // start the value of a property as a certain type e.g. a Map, and then for some reason, during SSR, change that
        // to `undefined`. When trying to hydrate, we want to override the Map with `undefined`.
        target[key] = $cadf5b4931a2c7e1$var$mergeReactiveObjects(targetValue, subPatch);
        else // @ts-expect-error: subPatch is a valid value
        target[key] = subPatch;
    }
    return target;
}
const $cadf5b4931a2c7e1$var$skipHydrateSymbol = /* istanbul ignore next */ Symbol();
const $cadf5b4931a2c7e1$var$skipHydrateMap = /*#__PURE__*/ new WeakMap();
/**
 * Tells Pinia to skip the hydration process of a given object. This is useful in setup stores (only) when you return a
 * stateful object in the store but it isn't really state. e.g. returning a router instance in a setup store.
 *
 * @param obj - target object
 * @returns obj
 */ function $cadf5b4931a2c7e1$export$dbb88672ab248e88(obj) {
    return (0, $4h3Sd.isVue2) ? /* istanbul ignore next */ $cadf5b4931a2c7e1$var$skipHydrateMap.set(obj, 1) && obj : Object.defineProperty(obj, $cadf5b4931a2c7e1$var$skipHydrateSymbol, {});
}
/**
 * Returns whether a value should be hydrated
 *
 * @param obj - target variable
 * @returns true if `obj` should be hydrated
 */ function $cadf5b4931a2c7e1$var$shouldHydrate(obj) {
    return (0, $4h3Sd.isVue2) ? /* istanbul ignore next */ !$cadf5b4931a2c7e1$var$skipHydrateMap.has(obj) : !$cadf5b4931a2c7e1$var$isPlainObject(obj) || !obj.hasOwnProperty($cadf5b4931a2c7e1$var$skipHydrateSymbol);
}
const { assign: $cadf5b4931a2c7e1$var$assign } = Object;
function $cadf5b4931a2c7e1$var$isComputed(o) {
    return !!((0, $8bTPG.isRef)(o) && o.effect);
}
function $cadf5b4931a2c7e1$var$createOptionsStore(id, options, pinia, hot) {
    const { state: state, actions: actions, getters: getters } = options;
    const initialState = pinia.state.value[id];
    let store;
    function setup() {
        if (!initialState && true) {
            /* istanbul ignore if */ if (0, $4h3Sd.isVue2) (0, $4h3Sd.set)(pinia.state.value, id, state ? state() : {});
            else pinia.state.value[id] = state ? state() : {};
        }
        // avoid creating a state in pinia.state.value
        const localState = (0, $8bTPG.toRefs)(pinia.state.value[id]);
        return $cadf5b4931a2c7e1$var$assign(localState, actions, Object.keys(getters || {}).reduce((computedGetters, name)=>{
            computedGetters[name] = (0, $8bTPG.markRaw)((0, $8bTPG.computed)(()=>{
                $cadf5b4931a2c7e1$export$89ffb8149ccd46af(pinia);
                // it was created just before
                const store = pinia._s.get(id);
                // allow cross using stores
                /* istanbul ignore next */ if ((0, $4h3Sd.isVue2) && !store._r) return;
                // @ts-expect-error
                // return getters![name].call(context, context)
                // TODO: avoid reading the getter while assigning with a global variable
                return getters[name].call(store, store);
            }));
            return computedGetters;
        }, {}));
    }
    store = $cadf5b4931a2c7e1$var$createSetupStore(id, setup, options, pinia, hot, true);
    return store;
}
function $cadf5b4931a2c7e1$var$createSetupStore($id, setup, options = {}, pinia, hot, isOptionsStore) {
    let scope;
    const optionsForPlugin = $cadf5b4931a2c7e1$var$assign({
        actions: {}
    }, options);
    // watcher options for $subscribe
    const $subscribeOptions = {
        deep: true
    };
    var event;
    // internal state
    let isListening; // set to true at the end
    let isSyncListening; // set to true at the end
    let subscriptions = [];
    let actionSubscriptions = [];
    let debuggerEvents;
    const initialState = pinia.state.value[$id];
    // avoid setting the state for option stores if it is set
    // by the setup
    if (!isOptionsStore && !initialState && true) {
        /* istanbul ignore if */ if (0, $4h3Sd.isVue2) (0, $4h3Sd.set)(pinia.state.value, $id, {});
        else pinia.state.value[$id] = {};
    }
    const hotState = (0, $8bTPG.ref)({});
    // avoid triggering too many listeners
    // https://github.com/vuejs/pinia/issues/1129
    let activeListener;
    function $patch(partialStateOrMutator) {
        let subscriptionMutation;
        isListening = isSyncListening = false;
        if (typeof partialStateOrMutator === "function") {
            partialStateOrMutator(pinia.state.value[$id]);
            subscriptionMutation = {
                type: $cadf5b4931a2c7e1$export$d97371ba8df8c539.patchFunction,
                storeId: $id,
                events: debuggerEvents
            };
        } else {
            $cadf5b4931a2c7e1$var$mergeReactiveObjects(pinia.state.value[$id], partialStateOrMutator);
            subscriptionMutation = {
                type: $cadf5b4931a2c7e1$export$d97371ba8df8c539.patchObject,
                payload: partialStateOrMutator,
                storeId: $id,
                events: debuggerEvents
            };
        }
        const myListenerId = activeListener = Symbol();
        (0, $ani5R.nextTick)().then(()=>{
            if (activeListener === myListenerId) isListening = true;
        });
        isSyncListening = true;
        // because we paused the watcher, we need to manually call the subscriptions
        $cadf5b4931a2c7e1$var$triggerSubscriptions(subscriptions, subscriptionMutation, pinia.state.value[$id]);
    }
    const $reset = isOptionsStore ? function $reset() {
        const { state: state } = options;
        const newState = state ? state() : {};
        // we use a patch to group all changes into one single subscription
        this.$patch(($state)=>{
            $cadf5b4931a2c7e1$var$assign($state, newState);
        });
    } : $cadf5b4931a2c7e1$var$noop;
    function $dispose() {
        scope.stop();
        subscriptions = [];
        actionSubscriptions = [];
        pinia._s.delete($id);
    }
    /**
     * Wraps an action to handle subscriptions.
     *
     * @param name - name of the action
     * @param action - action to wrap
     * @returns a wrapped action to handle subscriptions
     */ function wrapAction(name, action) {
        return function() {
            $cadf5b4931a2c7e1$export$89ffb8149ccd46af(pinia);
            const args = Array.from(arguments);
            const afterCallbackList = [];
            const onErrorCallbackList = [];
            function after(callback) {
                afterCallbackList.push(callback);
            }
            function onError(callback) {
                onErrorCallbackList.push(callback);
            }
            // @ts-expect-error
            $cadf5b4931a2c7e1$var$triggerSubscriptions(actionSubscriptions, {
                args: args,
                name: name,
                store: store,
                after: after,
                onError: onError
            });
            let ret;
            try {
                ret = action.apply(this && this.$id === $id ? this : store, args);
            // handle sync errors
            } catch (error) {
                $cadf5b4931a2c7e1$var$triggerSubscriptions(onErrorCallbackList, error);
                throw error;
            }
            if (ret instanceof Promise) return ret.then((value)=>{
                $cadf5b4931a2c7e1$var$triggerSubscriptions(afterCallbackList, value);
                return value;
            }).catch((error)=>{
                $cadf5b4931a2c7e1$var$triggerSubscriptions(onErrorCallbackList, error);
                return Promise.reject(error);
            });
            // trigger after callbacks
            $cadf5b4931a2c7e1$var$triggerSubscriptions(afterCallbackList, ret);
            return ret;
        };
    }
    const _hmrPayload = /*#__PURE__*/ (0, $8bTPG.markRaw)({
        actions: {},
        getters: {},
        state: [],
        hotState: hotState
    });
    const partialStore = {
        _p: pinia,
        $id: // _s: scope,
        $id,
        $onAction: $cadf5b4931a2c7e1$var$addSubscription.bind(null, actionSubscriptions),
        $patch: $patch,
        $reset: $reset,
        $subscribe (callback, options = {}) {
            const removeSubscription = $cadf5b4931a2c7e1$var$addSubscription(subscriptions, callback, options.detached, ()=>stopWatcher());
            const stopWatcher = scope.run(()=>(0, $ani5R.watch)(()=>pinia.state.value[$id], (state)=>{
                    if (options.flush === "sync" ? isSyncListening : isListening) callback({
                        storeId: $id,
                        type: $cadf5b4931a2c7e1$export$d97371ba8df8c539.direct,
                        events: debuggerEvents
                    }, state);
                }, $cadf5b4931a2c7e1$var$assign({}, $subscribeOptions, options)));
            return removeSubscription;
        },
        $dispose: $dispose
    };
    /* istanbul ignore if */ if (0, $4h3Sd.isVue2) // start as non ready
    partialStore._r = false;
    const store = (0, $8bTPG.reactive)($cadf5b4931a2c7e1$var$USE_DEVTOOLS ? $cadf5b4931a2c7e1$var$assign({
        _hmrPayload: _hmrPayload,
        _customProperties: (0, $8bTPG.markRaw)(new Set())
    }, partialStore) : partialStore);
    // store the partial store now so the setup of stores can instantiate each other before they are finished without
    // creating infinite loops.
    pinia._s.set($id, store);
    const runWithContext = pinia._a && pinia._a.runWithContext || $cadf5b4931a2c7e1$var$fallbackRunWithContext;
    // TODO: idea create skipSerialize that marks properties as non serializable and they are skipped
    const setupStore = runWithContext(()=>pinia._e.run(()=>(scope = (0, $8bTPG.effectScope)()).run(setup)));
    // overwrite existing actions to support $onAction
    for(const key in setupStore){
        const prop = setupStore[key];
        if ((0, $8bTPG.isRef)(prop) && !$cadf5b4931a2c7e1$var$isComputed(prop) || (0, $8bTPG.isReactive)(prop)) {
            if (!isOptionsStore) {
                // in setup stores we must hydrate the state and sync pinia state tree with the refs the user just created
                if (initialState && $cadf5b4931a2c7e1$var$shouldHydrate(prop)) {
                    if ((0, $8bTPG.isRef)(prop)) prop.value = initialState[key];
                    else // probably a reactive object, lets recursively assign
                    // @ts-expect-error: prop is unknown
                    $cadf5b4931a2c7e1$var$mergeReactiveObjects(prop, initialState[key]);
                }
                // transfer the ref to the pinia state to keep everything in sync
                /* istanbul ignore if */ if (0, $4h3Sd.isVue2) (0, $4h3Sd.set)(pinia.state.value[$id], key, prop);
                else pinia.state.value[$id][key] = prop;
            }
        } else if (typeof prop === "function") {
            // @ts-expect-error: we are overriding the function we avoid wrapping if
            const actionValue = wrapAction(key, prop);
            // this a hot module replacement store because the hotUpdate method needs
            // to do it with the right context
            /* istanbul ignore if */ if (0, $4h3Sd.isVue2) (0, $4h3Sd.set)(setupStore, key, actionValue);
            else // @ts-expect-error
            setupStore[key] = actionValue;
            // list actions so they can be used in plugins
            // @ts-expect-error
            optionsForPlugin.actions[key] = prop;
        }
    }
    // add the state, getters, and action properties
    /* istanbul ignore if */ if (0, $4h3Sd.isVue2) Object.keys(setupStore).forEach((key)=>{
        (0, $4h3Sd.set)(store, key, setupStore[key]);
    });
    else {
        $cadf5b4931a2c7e1$var$assign(store, setupStore);
        // allows retrieving reactive objects with `storeToRefs()`. Must be called after assigning to the reactive object.
        // Make `storeToRefs()` work with `reactive()` #799
        $cadf5b4931a2c7e1$var$assign((0, $8bTPG.toRaw)(store), setupStore);
    }
    // use this instead of a computed with setter to be able to create it anywhere
    // without linking the computed lifespan to wherever the store is first
    // created.
    Object.defineProperty(store, "$state", {
        get: ()=>(0, pinia.state.value[$id]),
        set: (state)=>{
            $patch(($state)=>{
                $cadf5b4931a2c7e1$var$assign($state, state);
            });
        }
    });
    var newStore, stateKey, stateKey1, key, key1;
    if ($cadf5b4931a2c7e1$var$USE_DEVTOOLS) {
        const nonEnumerable = {
            writable: true,
            configurable: true,
            // avoid warning on devtools trying to display this property
            enumerable: false
        };
        [
            "_p",
            "_hmrPayload",
            "_getters",
            "_customProperties"
        ].forEach((p)=>{
            Object.defineProperty(store, p, $cadf5b4931a2c7e1$var$assign({
                value: store[p]
            }, nonEnumerable));
        });
    }
    /* istanbul ignore if */ if (0, $4h3Sd.isVue2) // mark the store as ready before plugins
    store._r = true;
    // apply all plugins
    pinia._p.forEach((extender)=>{
        /* istanbul ignore else */ if ($cadf5b4931a2c7e1$var$USE_DEVTOOLS) {
            const extensions = scope.run(()=>extender({
                    store: store,
                    app: pinia._a,
                    pinia: pinia,
                    options: optionsForPlugin
                }));
            Object.keys(extensions || {}).forEach((key)=>store._customProperties.add(key));
            $cadf5b4931a2c7e1$var$assign(store, extensions);
        } else $cadf5b4931a2c7e1$var$assign(store, scope.run(()=>extender({
                store: store,
                app: pinia._a,
                pinia: pinia,
                options: optionsForPlugin
            })));
    });
    // only apply hydrate to option stores with an initial state in pinia
    if (initialState && isOptionsStore && options.hydrate) options.hydrate(store.$state, initialState);
    isListening = true;
    isSyncListening = true;
    return store;
}
function $cadf5b4931a2c7e1$export$5061c4f75bbcb4a(// TODO: add proper types from above
idOrOptions, setup, setupOptions) {
    let id;
    let options;
    const isSetupStore = typeof setup === "function";
    if (typeof idOrOptions === "string") {
        id = idOrOptions;
        // the option store setup will contain the actual options in this case
        options = isSetupStore ? setupOptions : setup;
    } else {
        options = idOrOptions;
        id = idOrOptions.id;
    }
    function useStore(pinia, hot) {
        const hasContext = (0, $ani5R.hasInjectionContext)();
        pinia = pinia || (hasContext ? (0, $ani5R.inject)($cadf5b4931a2c7e1$var$piniaSymbol, null) : null);
        if (pinia) $cadf5b4931a2c7e1$export$89ffb8149ccd46af(pinia);
        pinia = $cadf5b4931a2c7e1$var$activePinia;
        if (!pinia._s.has(id)) {
            // creating the store registers it in `pinia._s`
            if (isSetupStore) $cadf5b4931a2c7e1$var$createSetupStore(id, setup, options, pinia);
            else $cadf5b4931a2c7e1$var$createOptionsStore(id, options, pinia);
        }
        const store = pinia._s.get(id);
        // StoreGeneric cannot be casted towards Store
        return store;
    }
    useStore.$id = id;
    return useStore;
}
let $cadf5b4931a2c7e1$var$mapStoreSuffix = "Store";
/**
 * Changes the suffix added by `mapStores()`. Can be set to an empty string.
 * Defaults to `"Store"`. Make sure to extend the MapStoresCustomization
 * interface if you are using TypeScript.
 *
 * @param suffix - new suffix
 */ function $cadf5b4931a2c7e1$export$3c0d0850ffd38177(suffix // could be 'Store' but that would be annoying for JS
) {
    $cadf5b4931a2c7e1$var$mapStoreSuffix = suffix;
}
/**
 * Allows using stores without the composition API (`setup()`) by generating an
 * object to be spread in the `computed` field of a component. It accepts a list
 * of store definitions.
 *
 * @example
 * ```js
 * export default {
 *   computed: {
 *     // other computed properties
 *     ...mapStores(useUserStore, useCartStore)
 *   },
 *
 *   created() {
 *     this.userStore // store with id "user"
 *     this.cartStore // store with id "cart"
 *   }
 * }
 * ```
 *
 * @param stores - list of stores to map to an object
 */ function $cadf5b4931a2c7e1$export$4701f243feba9f88(...stores) {
    return stores.reduce((reduced, useStore)=>{
        // @ts-expect-error: $id is added by defineStore
        reduced[useStore.$id + $cadf5b4931a2c7e1$var$mapStoreSuffix] = function() {
            return useStore(this.$pinia);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $cadf5b4931a2c7e1$export$a337c713bdba072(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        reduced[key] = function() {
            return useStore(this.$pinia)[key];
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function() {
            const store = useStore(this.$pinia);
            const storeKey = keysOrMapper[key];
            // for some reason TS is unable to infer the type of storeKey to be a
            // function
            return typeof storeKey === "function" ? storeKey.call(this, store) : store[storeKey];
        };
        return reduced;
    }, {});
}
/**
 * Alias for `mapState()`. You should use `mapState()` instead.
 * @deprecated use `mapState()` instead.
 */ const $cadf5b4931a2c7e1$export$74d9085e6d5a97cb = $cadf5b4931a2c7e1$export$a337c713bdba072;
/**
 * Allows directly using actions from your store without using the composition
 * API (`setup()`) by generating an object to be spread in the `methods` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $cadf5b4931a2c7e1$export$1d73b9b98821f6dc(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function(...args) {
            return useStore(this.$pinia)[key](...args);
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function(...args) {
            return useStore(this.$pinia)[keysOrMapper[key]](...args);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $cadf5b4931a2c7e1$export$c069310e76f1a3e7(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        // @ts-ignore
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[key];
            },
            set (value) {
                // it's easier to type it here as any
                return useStore(this.$pinia)[key] = value;
            }
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-ignore
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[keysOrMapper[key]];
            },
            set (value) {
                // it's easier to type it here as any
                return useStore(this.$pinia)[keysOrMapper[key]] = value;
            }
        };
        return reduced;
    }, {});
}
/**
 * Creates an object of references with all the state, getters, and plugin-added
 * state properties of the store. Similar to `toRefs()` but specifically
 * designed for Pinia stores so methods and non reactive properties are
 * completely ignored.
 *
 * @param store - store to extract the refs from
 */ function $cadf5b4931a2c7e1$export$586af8bd019552de(store) {
    // See https://github.com/vuejs/pinia/issues/852
    // It's easier to just use toRefs() even if it includes more stuff
    if (0, $4h3Sd.isVue2) // @ts-expect-error: toRefs include methods and others
    return (0, $8bTPG.toRefs)(store);
    else {
        store = (0, $8bTPG.toRaw)(store);
        const refs = {};
        for(const key in store){
            const value = store[key];
            if ((0, $8bTPG.isRef)(value) || (0, $8bTPG.isReactive)(value)) // @ts-expect-error: the key is state or getter
            refs[key] = // ---
            (0, $8bTPG.toRef)(store, key);
        }
        return refs;
    }
}
/**
 * Vue 2 Plugin that must be installed for pinia to work. Note **you don't need
 * this plugin if you are using Nuxt.js**. Use the `buildModule` instead:
 * https://pinia.vuejs.org/ssr/nuxt.html.
 *
 * @example
 * ```js
 * import Vue from 'vue'
 * import { PiniaVuePlugin, createPinia } from 'pinia'
 *
 * Vue.use(PiniaVuePlugin)
 * const pinia = createPinia()
 *
 * new Vue({
 *   el: '#app',
 *   // ...
 *   pinia,
 * })
 * ```
 *
 * @param _Vue - `Vue` imported from 'vue'.
 */ const $cadf5b4931a2c7e1$export$a99c5571bb37058e = function(_Vue) {
    // Equivalent of
    // app.config.globalProperties.$pinia = pinia
    _Vue.mixin({
        beforeCreate () {
            const options = this.$options;
            if (options.pinia) {
                const pinia = options.pinia;
                // HACK: taken from provide(): https://github.com/vuejs/composition-api/blob/main/src/apis/inject.ts#L31
                /* istanbul ignore else */ if (!this._provided) {
                    const provideCache = {};
                    Object.defineProperty(this, "_provided", {
                        get: ()=>provideCache,
                        set: (v)=>Object.assign(provideCache, v)
                    });
                }
                this._provided[$cadf5b4931a2c7e1$var$piniaSymbol] = pinia;
                // propagate the pinia instance in an SSR friendly way
                // avoid adding it to nuxt twice
                /* istanbul ignore else */ if (!this.$pinia) this.$pinia = pinia;
                pinia._a = this;
                if ($cadf5b4931a2c7e1$var$IS_CLIENT) // this allows calling useStore() outside of a component setup after
                // installing pinia's plugin
                $cadf5b4931a2c7e1$export$89ffb8149ccd46af(pinia);
                if ($cadf5b4931a2c7e1$var$USE_DEVTOOLS) $cadf5b4931a2c7e1$var$registerPiniaDevtools(pinia._a, pinia);
            } else if (!this.$pinia && options.parent && options.parent.$pinia) this.$pinia = options.parent.$pinia;
        },
        destroyed () {
            delete this._pStores;
        }
    });
};

});
parcelRegister("4h3Sd", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("8bTPG")).computed);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("8bTPG")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("8bTPG")).getCurrentScope);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("ani5R")).hasInjectionContext);
$parcel$export(module.exports, "inject", () => (parcelRequire("ani5R")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("8bTPG")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("8bTPG")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("8bTPG")).markRaw);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("ani5R")).nextTick);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("8bTPG")).onScopeDispose);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("8bTPG")).ref);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("8bTPG")).toRaw);
$parcel$export(module.exports, "toRef", () => (parcelRequire("8bTPG")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("8bTPG")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("8bTPG")).unref);
$parcel$export(module.exports, "watch", () => (parcelRequire("ani5R")).watch);

$parcel$export(module.exports, "isVue2", () => $bd561b61cb4d3e1f$export$1da84e343e81ceb9);
$parcel$export(module.exports, "set", () => $bd561b61cb4d3e1f$export$adaa4cf7ef1b65be);
parcelRequire("ey4ci");
var $bd561b61cb4d3e1f$export$1da84e343e81ceb9 = false;
var $bd561b61cb4d3e1f$export$34b222e3d4733e48 = true;
var $bd561b61cb4d3e1f$export$a8cb34872e7d8b79 = undefined;
function $bd561b61cb4d3e1f$export$4b3e715f166fdd78() {}
function $bd561b61cb4d3e1f$export$adaa4cf7ef1b65be(target, key, val) {
    if (Array.isArray(target)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        return val;
    }
    target[key] = val;
    return val;
}
function $bd561b61cb4d3e1f$export$1d2f21e549771e67(target, key) {
    if (Array.isArray(target)) {
        target.splice(key, 1);
        return;
    }
    delete target[key];
}

});

parcelRegister("4GZdJ", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", () => $36aa92c7adf41d43$export$63b9a9bba9f20f3e);

var $g21Uz = parcelRequire("g21Uz");

var $sP9n3 = parcelRequire("sP9n3");

var $ccfC2 = parcelRequire("ccfC2");



function $36aa92c7adf41d43$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $g21Uz.getTarget)();
    const hook = (0, $g21Uz.getDevtoolsGlobalHook)();
    const enableProxy = (0, $g21Uz.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $sP9n3.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $ccfC2.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRegister("g21Uz", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", () => $babe50d3fc546cfa$export$5a2d366b2d9f38f6);
$parcel$export(module.exports, "getTarget", () => $babe50d3fc546cfa$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isProxyAvailable", () => $babe50d3fc546cfa$export$bc32a04c49ed7464);
function $babe50d3fc546cfa$export$5a2d366b2d9f38f6() {
    return $babe50d3fc546cfa$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $babe50d3fc546cfa$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : {};
}
const $babe50d3fc546cfa$export$bc32a04c49ed7464 = typeof Proxy === "function";

});

parcelRegister("sP9n3", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", () => $056a4afe07f3e731$export$b1499c3bd2a3f4df);
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", () => $056a4afe07f3e731$export$a0897f44accbe922);
const $056a4afe07f3e731$export$b1499c3bd2a3f4df = "devtools-plugin:setup";
const $056a4afe07f3e731$export$a0897f44accbe922 = "plugin:settings:set";

});

parcelRegister("ccfC2", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", () => $8e12b756c61c1b85$export$5728f3776e9b2ac1);

var $sP9n3 = parcelRequire("sP9n3");

var $kAhkL = parcelRequire("kAhkL");
class $8e12b756c61c1b85$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $kAhkL.now)();
            }
        };
        if (hook) hook.on((0, $sP9n3.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === "on") return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}

});
parcelRegister("kAhkL", function(module, exports) {

$parcel$export(module.exports, "now", () => $efc49d9c17851a9d$export$461939dd4422153);
let $efc49d9c17851a9d$var$supported;
let $efc49d9c17851a9d$var$perf;
function $efc49d9c17851a9d$export$70d26280bc1ca547() {
    var _a;
    if ($efc49d9c17851a9d$var$supported !== undefined) return $efc49d9c17851a9d$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $efc49d9c17851a9d$var$supported = true;
        $efc49d9c17851a9d$var$perf = window.performance;
    } else if (typeof globalThis !== "undefined" && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $efc49d9c17851a9d$var$supported = true;
        $efc49d9c17851a9d$var$perf = globalThis.perf_hooks.performance;
    } else $efc49d9c17851a9d$var$supported = false;
    return $efc49d9c17851a9d$var$supported;
}
function $efc49d9c17851a9d$export$461939dd4422153() {
    return $efc49d9c17851a9d$export$70d26280bc1ca547() ? $efc49d9c17851a9d$var$perf.now() : Date.now();
}

});




parcelRegister("1zKtH", function(module, exports) {

module.exports = (parcelRequire("81tj9"));

});
parcelRegister("81tj9", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $cG9HX = parcelRequire("cG9HX");

var $hBrVA = parcelRequire("hBrVA");

var $2PhsF = parcelRequire("2PhsF");

var $1nuTH = parcelRequire("1nuTH");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    var context = new $hBrVA(defaultConfig);
    var instance = $cG9HX($hBrVA.prototype.request, context);
    // Copy axios.prototype to instance
    $eFc3n.extend(instance, $hBrVA.prototype, context);
    // Copy context to instance
    $eFc3n.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance($1nuTH);
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = $hBrVA;
// Factory for creating new instances
$5d7526a7a1e5b3fb$var$axios.create = function create(instanceConfig) {
    return $5d7526a7a1e5b3fb$var$createInstance($2PhsF($5d7526a7a1e5b3fb$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.Cancel = (parcelRequire("anxHC"));

$5d7526a7a1e5b3fb$var$axios.CancelToken = (parcelRequire("4iFhx"));

$5d7526a7a1e5b3fb$var$axios.isCancel = (parcelRequire("lCgfr"));
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$5d7526a7a1e5b3fb$var$axios.spread = (parcelRequire("albzn"));

// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (parcelRequire("1YbHN"));
module.exports = $5d7526a7a1e5b3fb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $5d7526a7a1e5b3fb$var$axios;

});
parcelRegister("eFc3n", function(module, exports) {
"use strict";

var $cG9HX = parcelRequire("cG9HX");
// utils is a library of generic helper functions non-specific to axios
var $aace3e920a0f1e4d$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $aace3e920a0f1e4d$var$isArray(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $aace3e920a0f1e4d$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBuffer(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $aace3e920a0f1e4d$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $aace3e920a0f1e4d$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $aace3e920a0f1e4d$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $aace3e920a0f1e4d$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $aace3e920a0f1e4d$var$isPlainObject(val) {
    if ($aace3e920a0f1e4d$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $aace3e920a0f1e4d$var$isDate(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $aace3e920a0f1e4d$var$isFile(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $aace3e920a0f1e4d$var$isBlob(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $aace3e920a0f1e4d$var$isFunction(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $aace3e920a0f1e4d$var$isStream(val) {
    return $aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $aace3e920a0f1e4d$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $aace3e920a0f1e4d$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $aace3e920a0f1e4d$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($aace3e920a0f1e4d$var$isPlainObject(result[key]) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[key] = $aace3e920a0f1e4d$var$merge(result[key], val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[key] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$aace3e920a0f1e4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $aace3e920a0f1e4d$var$extend(a, b, thisArg) {
    $aace3e920a0f1e4d$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $cG9HX(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $aace3e920a0f1e4d$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isStandardBrowserEnv: $aace3e920a0f1e4d$var$isStandardBrowserEnv,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM
};

});
parcelRegister("cG9HX", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("hBrVA", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $iOHZJ = parcelRequire("iOHZJ");

var $9ltoJ = parcelRequire("9ltoJ");

var $cUzFg = parcelRequire("cUzFg");

var $2PhsF = parcelRequire("2PhsF");

var $8zXsW = parcelRequire("8zXsW");
var $cd0b8e3cbef64068$var$validators = $8zXsW.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $cd0b8e3cbef64068$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $9ltoJ(),
        response: new $9ltoJ()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $cd0b8e3cbef64068$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $2PhsF(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $8zXsW.assertOptions(transitional, {
        silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean, "1.0.0"),
        forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean, "1.0.0"),
        clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean, "1.0.0")
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $cUzFg,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $cUzFg(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$cd0b8e3cbef64068$var$Axios.prototype.getUri = function getUri(config) {
    config = $2PhsF(this.defaults, config);
    return $iOHZJ(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$eFc3n.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request($2PhsF(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$eFc3n.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($2PhsF(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $cd0b8e3cbef64068$var$Axios;

});
parcelRegister("iOHZJ", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
function $db2f05ec923f2ee7$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($eFc3n.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $eFc3n.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($eFc3n.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $eFc3n.forEach(val, function parseValue(v) {
                if ($eFc3n.isDate(v)) v = v.toISOString();
                else if ($eFc3n.isObject(v)) v = JSON.stringify(v);
                parts.push($db2f05ec923f2ee7$var$encode(key) + "=" + $db2f05ec923f2ee7$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("9ltoJ", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
function $01c17f80085c95b1$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $01c17f80085c95b1$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $01c17f80085c95b1$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $01c17f80085c95b1$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $eFc3n.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $01c17f80085c95b1$var$InterceptorManager;

});

parcelRegister("cUzFg", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $kgh03 = parcelRequire("kgh03");

var $lCgfr = parcelRequire("lCgfr");

var $1nuTH = parcelRequire("1nuTH");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $kgh03.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $eFc3n.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $eFc3n.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $1nuTH.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $kgh03.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$lCgfr(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $kgh03.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("kgh03", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $1nuTH = parcelRequire("1nuTH");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $1nuTH;
    /*eslint no-param-reassign:0*/ $eFc3n.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("1nuTH", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $elOvr = parcelRequire("elOvr");

var $fEfFg = parcelRequire("fEfFg");
var $100fe7fc4c7b4810$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $100fe7fc4c7b4810$var$setContentTypeIfUnset(headers, value) {
    if (!$eFc3n.isUndefined(headers) && $eFc3n.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $100fe7fc4c7b4810$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("8nTSD"));
    else if (typeof $ibaza !== "undefined" && Object.prototype.toString.call($ibaza) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("8nTSD"));
    return adapter;
}
function $100fe7fc4c7b4810$var$stringifySafely(rawValue, parser, encoder) {
    if ($eFc3n.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $eFc3n.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $100fe7fc4c7b4810$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $100fe7fc4c7b4810$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $elOvr(headers, "Accept");
            $elOvr(headers, "Content-Type");
            if ($eFc3n.isFormData(data) || $eFc3n.isArrayBuffer(data) || $eFc3n.isBuffer(data) || $eFc3n.isStream(data) || $eFc3n.isFile(data) || $eFc3n.isBlob(data)) return data;
            if ($eFc3n.isArrayBufferView(data)) return data.buffer;
            if ($eFc3n.isURLSearchParams(data)) {
                $100fe7fc4c7b4810$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($eFc3n.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $100fe7fc4c7b4810$var$setContentTypeIfUnset(headers, "application/json");
                return $100fe7fc4c7b4810$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $eFc3n.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $fEfFg(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$100fe7fc4c7b4810$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$eFc3n.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $100fe7fc4c7b4810$var$defaults.headers[method] = {};
});
$eFc3n.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $100fe7fc4c7b4810$var$defaults.headers[method] = $eFc3n.merge($100fe7fc4c7b4810$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $100fe7fc4c7b4810$var$defaults;

});
parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = "browser";
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ""; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$d3c1734dacb01657$var$process.cwd = function() {
    return "/";
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});

parcelRegister("elOvr", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $eFc3n.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("fEfFg", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRegister("8nTSD", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $gyIfz = parcelRequire("gyIfz");

var $6D8uh = parcelRequire("6D8uh");

var $iOHZJ = parcelRequire("iOHZJ");

var $cgfHI = parcelRequire("cgfHI");

var $4Ik1V = parcelRequire("4Ik1V");

var $4YUSN = parcelRequire("4YUSN");

var $hYe4p = parcelRequire("hYe4p");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($eFc3n.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $cgfHI(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $iOHZJ(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $4Ik1V(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $gyIfz(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($hYe4p("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($hYe4p("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($hYe4p(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($eFc3n.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $4YUSN(fullPath)) && config.xsrfCookieName ? $6D8uh.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $eFc3n.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$eFc3n.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("gyIfz", function(module, exports) {
"use strict";

var $hYe4p = parcelRequire("hYe4p");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($hYe4p("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("hYe4p", function(module, exports) {
"use strict";

var $fEfFg = parcelRequire("fEfFg");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $fEfFg(error, config, code, request, response);
};

});


parcelRegister("6D8uh", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
module.exports = $eFc3n.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($eFc3n.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($eFc3n.isString(path)) cookie.push("path=" + path);
            if ($eFc3n.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("cgfHI", function(module, exports) {
"use strict";

var $uAxSn = parcelRequire("uAxSn");

var $aFAjA = parcelRequire("aFAjA");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$uAxSn(requestedURL)) return $aFAjA(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("uAxSn", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("aFAjA", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("4Ik1V", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $36eacf0f5ae88424$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $eFc3n.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $eFc3n.trim(line.substr(0, i)).toLowerCase();
        val = $eFc3n.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $36eacf0f5ae88424$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("4YUSN", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
module.exports = $eFc3n.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $eFc3n.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("lCgfr", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("2PhsF", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    function getMergedValue(target, source) {
        if ($eFc3n.isPlainObject(target) && $eFc3n.isPlainObject(source)) return $eFc3n.merge(target, source);
        else if ($eFc3n.isPlainObject(source)) return $eFc3n.merge({}, source);
        else if ($eFc3n.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$eFc3n.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$eFc3n.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $eFc3n.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$eFc3n.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $eFc3n.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $eFc3n.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$eFc3n.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$eFc3n.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $eFc3n.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $eFc3n.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRegister("8zXsW", function(module, exports) {
"use strict";

var $9lIsF = parcelRequire("9lIsF");
var $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $63efb8494987aa98$var$deprecatedWarnings = {};
var $63efb8494987aa98$var$currentVerArr = $9lIsF.version.split(".");
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $63efb8494987aa98$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : $63efb8494987aa98$var$currentVerArr;
    var destVer = version.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $63efb8494987aa98$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return "[Axios v" + $9lIsF.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed in " + version));
        if (isDeprecated && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    isOlderVersion: $63efb8494987aa98$var$isOlderVersion,
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};

});
parcelRegister("9lIsF", function(module, exports) {
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

});



parcelRegister("anxHC", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $78e631f68b7e223f$var$Cancel(message) {
    this.message = message;
}
$78e631f68b7e223f$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$78e631f68b7e223f$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $78e631f68b7e223f$var$Cancel;

});

parcelRegister("4iFhx", function(module, exports) {
"use strict";

var $anxHC = parcelRequire("anxHC");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $3218dd97b5460664$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $anxHC(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $3218dd97b5460664$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $3218dd97b5460664$var$CancelToken.source = function source() {
    var cancel;
    var token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $3218dd97b5460664$var$CancelToken;

});

parcelRegister("albzn", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("1YbHN", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});



parcelRegister("7O2xm", function(module, exports) {

$parcel$export(module.exports, "useCategoryStore", () => $192303bb045d4255$export$468306b6450db49);

var $gqFxE = parcelRequire("gqFxE");

var $6g6T7 = parcelRequire("6g6T7");
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
const $192303bb045d4255$export$468306b6450db49 = (0, $gqFxE.defineStore)("category-store", ()=>{
    const categories = window.categories;
    const name = (0, $8bTPG.ref)(window.catName);
    const description = window.description;
    const years = window.years?.sort((a, b)=>+b.name - +a.name);
    const altitude = window.altitude;
    const media = window.media;
    const searchPage = window.searchPage;
    const specifics = setSpecifics();
    function setName(value) {
        name.value = value;
    }
    function mapSpecific(specific) {
        switch(specific){
            case (0, $6g6T7.ProdSpecific).SUNRISE:
                return "isSunrise";
            case (0, $6g6T7.ProdSpecific).NIGHT_TIME:
                return "isNighttime";
            case (0, $6g6T7.ProdSpecific).PANORAMIC:
                return "isPanoramic";
            case (0, $6g6T7.ProdSpecific).SUNSET:
                return "isSunset";
            case (0, $6g6T7.ProdSpecific).HIGH_ALTITUDE:
                return "isHighAltitude";
            case (0, $6g6T7.ProdSpecific).ARCHIVE:
            default:
                return "";
        }
    }
    function setSpecifics() {
        const items = window.specific;
        return items?.map((item)=>{
            return {
                ...item,
                value: mapSpecific(item.value)
            };
        }).filter((item)=>item.value);
    }
    return {
        categories: categories,
        years: years,
        altitude: altitude,
        media: media,
        description: description,
        name: name,
        specifics: specifics,
        searchPage: searchPage,
        setName: setName
    };
});

});


parcelRegister("3XmQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e189aaa6fceab1b$export$2e2bcd8739ae039);
let $2e189aaa6fceab1b$var$script;


let $2e189aaa6fceab1b$var$initialize = ()=>{
    $2e189aaa6fceab1b$var$script = {};
    $2e189aaa6fceab1b$var$script.render = (parcelRequire("3Swoi")).render;
    (parcelRequire("328TG")).default($2e189aaa6fceab1b$var$script);
    $2e189aaa6fceab1b$var$script.__scopeId = "data-v-d7df8b";
    $2e189aaa6fceab1b$var$script.__file = "LoaderComponent.vue";
};
$2e189aaa6fceab1b$var$initialize();
var $2e189aaa6fceab1b$export$2e2bcd8739ae039 = $2e189aaa6fceab1b$var$script;

});
parcelRegister("3Swoi", function(module, exports) {

$parcel$export(module.exports, "render", () => $2d2f8a62384b821e$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
const $2d2f8a62384b821e$var$_hoisted_1 = {
    class: "overlay overlay--loader"
};
const $2d2f8a62384b821e$var$_hoisted_2 = /*#__PURE__*/ (0, $ani5R.createStaticVNode)('<div class="loader--windows"><div class="loader__dot loader__dot--1"></div><div class="loader__dot loader__dot--2"></div><div class="loader__dot loader__dot--3"></div><div class="loader__dot loader__dot--4"></div><div class="loader__dot loader__dot--5"></div></div>', 1);
const $2d2f8a62384b821e$var$_hoisted_3 = [
    $2d2f8a62384b821e$var$_hoisted_2
];
function $2d2f8a62384b821e$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2d2f8a62384b821e$var$_hoisted_1, $2d2f8a62384b821e$var$_hoisted_3);
}

});

parcelRegister("328TG", function(module, exports) {

$parcel$export(module.exports, "default", () => $235875c8cc4c5d25$export$2e2bcd8739ae039);
let $235875c8cc4c5d25$var$NOOP = ()=>{};
var $235875c8cc4c5d25$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("2HVhb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f8c06c78906b10c$export$2e2bcd8739ae039);
let $1f8c06c78906b10c$var$script;



let $1f8c06c78906b10c$var$initialize = ()=>{
    $1f8c06c78906b10c$var$script = (parcelRequire("6wfHf"));
    if ($1f8c06c78906b10c$var$script.__esModule) $1f8c06c78906b10c$var$script = $1f8c06c78906b10c$var$script.default;
    $1f8c06c78906b10c$var$script.render = (parcelRequire("1yA54")).render;
    (parcelRequire("7Ekf5")).default($1f8c06c78906b10c$var$script);
    $1f8c06c78906b10c$var$script.__scopeId = "data-v-598221";
    $1f8c06c78906b10c$var$script.__file = "NoProducts.vue";
};
$1f8c06c78906b10c$var$initialize();
var $1f8c06c78906b10c$export$2e2bcd8739ae039 = $1f8c06c78906b10c$var$script;

});
parcelRegister("6wfHf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f33a146c6ded6245$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $huSKp = parcelRequire("huSKp");
var $f33a146c6ded6245$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "NoProducts",
    setup (__props, { expose: __expose }) {
        __expose();
        const { resetFilters: resetFilters } = (0, $huSKp.useProductStore)();
        const __returned__ = {
            resetFilters: resetFilters
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("1yA54", function(module, exports) {

$parcel$export(module.exports, "render", () => $1224f44c91e06174$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
const $1224f44c91e06174$var$_hoisted_1 = {
    class: "no-products"
};
const $1224f44c91e06174$var$_hoisted_2 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("h1", {
    class: "main-title"
}, "There is no images for this search criteria", -1);
function $1224f44c91e06174$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $1224f44c91e06174$var$_hoisted_1, [
        $1224f44c91e06174$var$_hoisted_2,
        (0, $ani5R.createElementVNode)("button", {
            onClick: _cache[0] || (_cache[0] = (...args)=>$setup.resetFilters && $setup.resetFilters(...args)),
            class: "filters__clear activeClass"
        }, " Clear Filters ")
    ]);
}

});

parcelRegister("7Ekf5", function(module, exports) {

$parcel$export(module.exports, "default", () => $591bf887167fd9b4$export$2e2bcd8739ae039);
let $591bf887167fd9b4$var$NOOP = ()=>{};
var $591bf887167fd9b4$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("j9eqk", function(module, exports) {

$parcel$export(module.exports, "render", () => $df0a0bd12e7d12dc$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $dDLnc = parcelRequire("dDLnc");
const $df0a0bd12e7d12dc$var$_hoisted_1 = {
    key: 0,
    class: "prod-grid__wrap"
};
function $df0a0bd12e7d12dc$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("section", {
        class: (0, $X5A94.normalizeClass)([
            "prod-grid",
            $setup.gridClass
        ])
    }, [
        $setup.products.length ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $df0a0bd12e7d12dc$var$_hoisted_1, [
            ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($setup.products, (product)=>{
                return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["SingleProduct"], {
                    key: product.id,
                    product: product
                }, null, 8, [
                    "product"
                ]);
            }), 128))
        ])) : (0, $ani5R.createCommentVNode)("", true),
        !$setup.products.length && !$setup.isLoading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["NoProducts"], {
            key: 1
        })) : (0, $ani5R.createCommentVNode)("", true),
        (0, $ani5R.createVNode)((0, $dDLnc.Transition), {
            name: "slide-up-fade",
            mode: "out-in"
        }, {
            default: (0, $ani5R.withCtx)(()=>[
                    $setup.isLoading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["LoaderComponent"], {
                        key: 0
                    })) : (0, $ani5R.createCommentVNode)("", true)
                ]),
            _: 1
        })
    ], 2);
}

});

parcelRegister("2YPjX", function(module, exports) {

$parcel$export(module.exports, "default", () => $22b8fe9b439dac5c$export$2e2bcd8739ae039);
let $22b8fe9b439dac5c$var$NOOP = ()=>{};
var $22b8fe9b439dac5c$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("6oXY4", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a93805d7030bab4$export$2e2bcd8739ae039);
let $4a93805d7030bab4$var$script;



let $4a93805d7030bab4$var$initialize = ()=>{
    $4a93805d7030bab4$var$script = (parcelRequire("5b984"));
    if ($4a93805d7030bab4$var$script.__esModule) $4a93805d7030bab4$var$script = $4a93805d7030bab4$var$script.default;
    $4a93805d7030bab4$var$script.render = (parcelRequire("3GQ48")).render;
    (parcelRequire("aEyp6")).default($4a93805d7030bab4$var$script);
    $4a93805d7030bab4$var$script.__scopeId = "data-v-a30bbd";
    $4a93805d7030bab4$var$script.__file = "Search.vue";
};
$4a93805d7030bab4$var$initialize();
var $4a93805d7030bab4$export$2e2bcd8739ae039 = $4a93805d7030bab4$var$script;

});
parcelRegister("5b984", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $29c11d3696026575$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $8bTPG = parcelRequire("8bTPG");

var $lTE2L = parcelRequire("lTE2L");

var $cTslv = parcelRequire("cTslv");
var $29c11d3696026575$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "Search",
    setup (__props, { expose: __expose }) {
        __expose();
        const show = (0, $8bTPG.ref)(true);
        const open = (0, $8bTPG.ref)(false);
        const address = (0, $8bTPG.ref)();
        const key = (0, $8bTPG.ref)();
        const line = (0, $8bTPG.ref)();
        const searchWrap = (0, $8bTPG.ref)();
        const wrap = (0, $8bTPG.ref)();
        function select(el, isShown) {
            if (!el || !line.value || !wrap.value) return;
            show.value = isShown;
            open.value = false;
            line.value.style.width = el.offsetWidth + "px";
            line.value.style.left = el.getBoundingClientRect().left - wrap.value.getBoundingClientRect().left + "px";
        }
        function topFrom() {
            if (!searchWrap.value) return;
            window.addEventListener("scroll", ()=>{
                if (window.pageYOffset > 72) searchWrap.value.classList.add("top");
                else searchWrap.value.classList.remove("top");
            });
        }
        (0, $ani5R.onMounted)(()=>{
            select(address.value, true);
        // topFrom();
        });
        const __returned__ = {
            show: show,
            open: open,
            address: address,
            key: key,
            line: line,
            searchWrap: searchWrap,
            wrap: wrap,
            select: select,
            topFrom: topFrom,
            GetCategory: $lTE2L.default,
            NetoSearch: $cTslv.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("lTE2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff0dcbdebfd1abe2$export$2e2bcd8739ae039);
let $ff0dcbdebfd1abe2$var$script;



let $ff0dcbdebfd1abe2$var$initialize = ()=>{
    $ff0dcbdebfd1abe2$var$script = (parcelRequire("7VyIU"));
    if ($ff0dcbdebfd1abe2$var$script.__esModule) $ff0dcbdebfd1abe2$var$script = $ff0dcbdebfd1abe2$var$script.default;
    $ff0dcbdebfd1abe2$var$script.render = (parcelRequire("chSKI")).render;
    (parcelRequire("kJ9Hd")).default($ff0dcbdebfd1abe2$var$script);
    $ff0dcbdebfd1abe2$var$script.__scopeId = "data-v-f7c40f";
    $ff0dcbdebfd1abe2$var$script.__file = "GetCategory.vue";
};
$ff0dcbdebfd1abe2$var$initialize();
var $ff0dcbdebfd1abe2$export$2e2bcd8739ae039 = $ff0dcbdebfd1abe2$var$script;

});
parcelRegister("7VyIU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b41e69d988fdffc9$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $8bTPG = parcelRequire("8bTPG");

var $2ISbl = parcelRequire("2ISbl");

var $5QSOE = parcelRequire("5QSOE");

var $01BPe = parcelRequire("01BPe");

var $huSKp = parcelRequire("huSKp");

var $gqFxE = parcelRequire("gqFxE");
var $b41e69d988fdffc9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "GetCategory",
    setup (__props, { expose: __expose }) {
        __expose();
        const { searchAuto: searchAuto, searchInput: searchInput, responseMessage: responseMessage, loading: loading } = (0, $01BPe.useGetCategory)();
        const { selectedCount: selectedCount } = (0, $gqFxE.storeToRefs)((0, $huSKp.useProductStore)());
        (0, $ani5R.onMounted)(()=>{
            searchAuto();
        });
        const filterOpen = (0, $8bTPG.ref)(false);
        function setfilterOpen() {
            const mainWrap = document.getElementById("mainContent");
            const searchWrap = document.getElementById("navSearch");
            const mapBtn = document.getElementById("mapBtn");
            if (!mainWrap || !searchWrap) return;
            if (filterOpen.value) {
                filterOpen.value = false;
                mainWrap.style.zIndex = "0";
                mainWrap.style.position = "static";
                searchWrap.style.zIndex = "1";
                document.documentElement.style.overflowY = "auto";
                document.body.style.overflowY = "auto";
                mapBtn?.classList.remove("d-none");
            } else {
                filterOpen.value = true;
                mainWrap.style.position = "relative";
                mainWrap.style.zIndex = "99";
                searchWrap.style.zIndex = "99";
                document.documentElement.style.overflowY = "hidden";
                document.body.style.overflowY = "hidden";
                mapBtn?.classList.add("d-none");
            }
        }
        const __returned__ = {
            searchAuto: searchAuto,
            searchInput: searchInput,
            responseMessage: responseMessage,
            loading: loading,
            selectedCount: selectedCount,
            filterOpen: filterOpen,
            setfilterOpen: setfilterOpen,
            Filters: $2ISbl.default,
            MobFilters: $5QSOE.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("2ISbl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fb9b839c83f8f63$export$2e2bcd8739ae039);
let $1fb9b839c83f8f63$var$script;



let $1fb9b839c83f8f63$var$initialize = ()=>{
    $1fb9b839c83f8f63$var$script = (parcelRequire("aAGVI"));
    if ($1fb9b839c83f8f63$var$script.__esModule) $1fb9b839c83f8f63$var$script = $1fb9b839c83f8f63$var$script.default;
    $1fb9b839c83f8f63$var$script.render = (parcelRequire("4gBqW")).render;
    (parcelRequire("2uQZb")).default($1fb9b839c83f8f63$var$script);
    $1fb9b839c83f8f63$var$script.__scopeId = "data-v-565436";
    $1fb9b839c83f8f63$var$script.__file = "Filters.vue";
};
$1fb9b839c83f8f63$var$initialize();
var $1fb9b839c83f8f63$export$2e2bcd8739ae039 = $1fb9b839c83f8f63$var$script;

});
parcelRegister("aAGVI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cda7b83cc4b95ce3$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $6g6T7 = parcelRequire("6g6T7");

var $I58DU = parcelRequire("I58DU");

var $7O2xm = parcelRequire("7O2xm");

var $gIe6R = parcelRequire("gIe6R");

var $huSKp = parcelRequire("huSKp");

var $gqFxE = parcelRequire("gqFxE");
var $cda7b83cc4b95ce3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "Filters",
    setup (__props, { expose: __expose }) {
        __expose();
        const { years: years, altitude: altitude, media: media, specifics: specifics } = (0, $7O2xm.useCategoryStore)();
        const mapStore = (0, $gIe6R.useMapStore)();
        const { setIsMapOpen: setIsMapOpen } = mapStore;
        const { isMapOpen: isMapOpen } = (0, $gqFxE.storeToRefs)(mapStore);
        const productStore = (0, $huSKp.useProductStore)();
        const { resetFilters: resetFilters } = productStore;
        const { isFilterActive: isFilterActive, selectedYears: selectedYears, selectedAltitude: selectedAltitude, selectedMedia: selectedMedia, selectedSpecific: selectedSpecific } = (0, $gqFxE.storeToRefs)(productStore);
        const __returned__ = {
            years: years,
            altitude: altitude,
            media: media,
            specifics: specifics,
            mapStore: mapStore,
            setIsMapOpen: setIsMapOpen,
            isMapOpen: isMapOpen,
            productStore: productStore,
            resetFilters: resetFilters,
            isFilterActive: isFilterActive,
            selectedYears: selectedYears,
            selectedAltitude: selectedAltitude,
            selectedMedia: selectedMedia,
            selectedSpecific: selectedSpecific,
            get Filter () {
                return 0, $6g6T7.Filter;
            },
            SingleFilter: $I58DU.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("I58DU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0848188dfbaa57a5$export$2e2bcd8739ae039);
let $0848188dfbaa57a5$var$script;



let $0848188dfbaa57a5$var$initialize = ()=>{
    $0848188dfbaa57a5$var$script = (parcelRequire("1V6ga"));
    if ($0848188dfbaa57a5$var$script.__esModule) $0848188dfbaa57a5$var$script = $0848188dfbaa57a5$var$script.default;
    $0848188dfbaa57a5$var$script.render = (parcelRequire("051Kq")).render;
    (parcelRequire("2NjeK")).default($0848188dfbaa57a5$var$script);
    $0848188dfbaa57a5$var$script.__scopeId = "data-v-f0b02a";
    $0848188dfbaa57a5$var$script.__file = "SingleFilter.vue";
};
$0848188dfbaa57a5$var$initialize();
var $0848188dfbaa57a5$export$2e2bcd8739ae039 = $0848188dfbaa57a5$var$script;

});
parcelRegister("1V6ga", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7728e0d01093bbdd$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $6g6T7 = parcelRequire("6g6T7");

var $dVPPq = parcelRequire("dVPPq");

var $TwOZ7 = parcelRequire("TwOZ7");

var $dj0Z3 = parcelRequire("dj0Z3");

var $inzXh = parcelRequire("inzXh");

var $1RXxs = parcelRequire("1RXxs");
var $7728e0d01093bbdd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "SingleFilter",
    props: {
        title: {},
        filter: {},
        selectedCount: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const { setIsOpen: setIsOpen, open: open } = (0, $dVPPq.useFilter)();
        const __returned__ = {
            setIsOpen: setIsOpen,
            open: open,
            get Filter () {
                return 0, $6g6T7.Filter;
            },
            YearChoice: $TwOZ7.default,
            AltitudeChoice: $dj0Z3.default,
            MediaChoice: $inzXh.default,
            SpecificChoice: $1RXxs.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("dVPPq", function(module, exports) {

$parcel$export(module.exports, "useFilter", () => $ee8a51385821e476$export$3274cf84b703fff);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
function $ee8a51385821e476$export$3274cf84b703fff() {
    const open = (0, $8bTPG.ref)(false);
    function isSelected() {
        return false;
    }
    function setIsOpen(isOpen) {
        open.value = isOpen;
    }
    function apply() {
        setIsOpen(false);
    }
    return {
        setIsOpen: setIsOpen,
        open: open,
        apply: apply,
        isSelected: isSelected
    };
}

});

parcelRegister("TwOZ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a6e98cd67eef7f4$export$2e2bcd8739ae039);
let $0a6e98cd67eef7f4$var$script;



let $0a6e98cd67eef7f4$var$initialize = ()=>{
    $0a6e98cd67eef7f4$var$script = (parcelRequire("69kRv"));
    if ($0a6e98cd67eef7f4$var$script.__esModule) $0a6e98cd67eef7f4$var$script = $0a6e98cd67eef7f4$var$script.default;
    $0a6e98cd67eef7f4$var$script.render = (parcelRequire("iOy0E")).render;
    (parcelRequire("867Kf")).default($0a6e98cd67eef7f4$var$script);
    $0a6e98cd67eef7f4$var$script.__scopeId = "data-v-973e87";
    $0a6e98cd67eef7f4$var$script.__file = "YearChoice.vue";
};
$0a6e98cd67eef7f4$var$initialize();
var $0a6e98cd67eef7f4$export$2e2bcd8739ae039 = $0a6e98cd67eef7f4$var$script;

});
parcelRegister("69kRv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $353890ee028e2890$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");

var $huSKp = parcelRequire("huSKp");

var $gqFxE = parcelRequire("gqFxE");
var $353890ee028e2890$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "YearChoice",
    props: {
        choice: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const productStore = (0, $huSKp.useProductStore)();
        const { setRequest: setRequest, goToLink: goToLink } = productStore;
        const { prodRequest: prodRequest } = (0, $gqFxE.storeToRefs)(productStore);
        const props = __props;
        const selected = (0, $8bTPG.computed)(()=>{
            if (props.choice.searchPage) return !!prodRequest.value.year?.find((item)=>item === +props.choice.value);
            else return props.choice.selected === "1";
        });
        function setFilter() {
            if (!props.choice.searchPage) goToLink(props.choice);
            if (selected.value) {
                const year = prodRequest.value.year?.filter((item)=>item !== +props.choice.value);
                if (year?.length) {
                    setRequest({
                        ...prodRequest.value,
                        year: year
                    });
                    return;
                }
                const request = {
                    ...prodRequest.value
                };
                delete request.year;
                setRequest(request);
            } else {
                const year = prodRequest.value.year ? [
                    ...prodRequest.value.year,
                    +props.choice.value
                ] : [
                    +props.choice.value
                ];
                setRequest({
                    ...prodRequest.value,
                    year: year
                });
            }
        }
        const __returned__ = {
            productStore: productStore,
            setRequest: setRequest,
            goToLink: goToLink,
            prodRequest: prodRequest,
            props: props,
            selected: selected,
            setFilter: setFilter
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("iOy0E", function(module, exports) {

$parcel$export(module.exports, "render", () => $db27471355d1f43f$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $db27471355d1f43f$var$_hoisted_1 = [
    "checked"
];
function $db27471355d1f43f$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
        onClick: $setup.setFilter
    }, [
        (0, $ani5R.createElementVNode)("input", {
            type: "checkbox",
            checked: $setup.selected
        }, null, 8, $db27471355d1f43f$var$_hoisted_1),
        (0, $ani5R.createElementVNode)("label", null, (0, $X5A94.toDisplayString)($props.choice.name) + "(" + (0, $X5A94.toDisplayString)($props.choice.total) + ")", 1)
    ]);
}

});

parcelRegister("867Kf", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e54e43d41a923c6$export$2e2bcd8739ae039);
let $5e54e43d41a923c6$var$NOOP = ()=>{};
var $5e54e43d41a923c6$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("dj0Z3", function(module, exports) {

$parcel$export(module.exports, "default", () => $027ff6f7ed872b4d$export$2e2bcd8739ae039);
let $027ff6f7ed872b4d$var$script;



let $027ff6f7ed872b4d$var$initialize = ()=>{
    $027ff6f7ed872b4d$var$script = (parcelRequire("5SSiU"));
    if ($027ff6f7ed872b4d$var$script.__esModule) $027ff6f7ed872b4d$var$script = $027ff6f7ed872b4d$var$script.default;
    $027ff6f7ed872b4d$var$script.render = (parcelRequire("5el5b")).render;
    (parcelRequire("ikhWN")).default($027ff6f7ed872b4d$var$script);
    $027ff6f7ed872b4d$var$script.__scopeId = "data-v-f6de4d";
    $027ff6f7ed872b4d$var$script.__file = "AltitudeChoice.vue";
};
$027ff6f7ed872b4d$var$initialize();
var $027ff6f7ed872b4d$export$2e2bcd8739ae039 = $027ff6f7ed872b4d$var$script;

});
parcelRegister("5SSiU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fb82ebe04ae6e4c9$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");

var $6g6T7 = parcelRequire("6g6T7");

var $huSKp = parcelRequire("huSKp");

var $gqFxE = parcelRequire("gqFxE");
var $fb82ebe04ae6e4c9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "AltitudeChoice",
    props: {
        choice: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const productStore = (0, $huSKp.useProductStore)();
        const { setRequest: setRequest, goToLink: goToLink } = productStore;
        const { prodRequest: prodRequest } = (0, $gqFxE.storeToRefs)(productStore);
        const props = __props;
        const selected = (0, $8bTPG.computed)(()=>{
            if (props.choice.searchPage) {
                if (props.choice.name === (0, $6g6T7.Altitude).M0 && prodRequest.value.altitudeMax === 250 && prodRequest.value.altitudeMin === 0) return true;
                if (props.choice.name === (0, $6g6T7.Altitude).M250 && prodRequest.value.altitudeMax === 500 && prodRequest.value.altitudeMin === 250) return true;
                if (props.choice.name === (0, $6g6T7.Altitude).M500 && prodRequest.value.altitudeMax === 1000 && prodRequest.value.altitudeMin === 500) return true;
                if (props.choice.name === (0, $6g6T7.Altitude).M1000 && prodRequest.value.altitudeMax === 2000 && prodRequest.value.altitudeMin === 1000) return true;
                if (props.choice.name === (0, $6g6T7.Altitude).M2000 && prodRequest.value.altitudeMax === 5000 && prodRequest.value.altitudeMin === 2000) return true;
                return false;
            } else return props.choice.selected === "1";
        });
        function setFilter() {
            if (!props.choice.searchPage) goToLink(props.choice);
            if (selected.value) {
                const item = prodRequest.value;
                delete item.altitudeMax;
                delete item.altitudeMin;
                setRequest(item);
                return;
            }
            switch(props.choice.name){
                case (0, $6g6T7.Altitude).M0:
                    setRequest({
                        ...prodRequest.value,
                        altitudeMin: 0,
                        altitudeMax: 250
                    });
                    break;
                case (0, $6g6T7.Altitude).M250:
                    setRequest({
                        ...prodRequest.value,
                        altitudeMin: 250,
                        altitudeMax: 500
                    });
                    break;
                case (0, $6g6T7.Altitude).M500:
                    setRequest({
                        ...prodRequest.value,
                        altitudeMin: 500,
                        altitudeMax: 1000
                    });
                    break;
                case (0, $6g6T7.Altitude).M1000:
                    setRequest({
                        ...prodRequest.value,
                        altitudeMin: 1000,
                        altitudeMax: 2000
                    });
                    break;
                case (0, $6g6T7.Altitude).M2000:
                    setRequest({
                        ...prodRequest.value,
                        altitudeMin: 2000,
                        altitudeMax: 5000
                    });
                    break;
            }
        }
        const __returned__ = {
            productStore: productStore,
            setRequest: setRequest,
            goToLink: goToLink,
            prodRequest: prodRequest,
            props: props,
            selected: selected,
            setFilter: setFilter
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("5el5b", function(module, exports) {

$parcel$export(module.exports, "render", () => $3cee9d1ad8a9e4d7$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $3cee9d1ad8a9e4d7$var$_hoisted_1 = [
    "checked"
];
function $3cee9d1ad8a9e4d7$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
        onClick: $setup.setFilter
    }, [
        (0, $ani5R.createElementVNode)("input", {
            type: "checkbox",
            checked: $setup.selected
        }, null, 8, $3cee9d1ad8a9e4d7$var$_hoisted_1),
        (0, $ani5R.createElementVNode)("label", null, (0, $X5A94.toDisplayString)($props.choice.name) + "(" + (0, $X5A94.toDisplayString)($props.choice.total) + ")", 1)
    ]);
}

});

parcelRegister("ikhWN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d578043de10d8213$export$2e2bcd8739ae039);
let $d578043de10d8213$var$NOOP = ()=>{};
var $d578043de10d8213$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("inzXh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d61643ec0d440d7c$export$2e2bcd8739ae039);
let $d61643ec0d440d7c$var$script;



let $d61643ec0d440d7c$var$initialize = ()=>{
    $d61643ec0d440d7c$var$script = (parcelRequire("eck7F"));
    if ($d61643ec0d440d7c$var$script.__esModule) $d61643ec0d440d7c$var$script = $d61643ec0d440d7c$var$script.default;
    $d61643ec0d440d7c$var$script.render = (parcelRequire("kxNwt")).render;
    (parcelRequire("98AdZ")).default($d61643ec0d440d7c$var$script);
    $d61643ec0d440d7c$var$script.__scopeId = "data-v-a05e59";
    $d61643ec0d440d7c$var$script.__file = "MediaChoice.vue";
};
$d61643ec0d440d7c$var$initialize();
var $d61643ec0d440d7c$export$2e2bcd8739ae039 = $d61643ec0d440d7c$var$script;

});
parcelRegister("eck7F", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $57de9e9f91259283$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");

var $6g6T7 = parcelRequire("6g6T7");

var $huSKp = parcelRequire("huSKp");

var $gqFxE = parcelRequire("gqFxE");
var $57de9e9f91259283$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "MediaChoice",
    props: {
        choice: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const productStore = (0, $huSKp.useProductStore)();
        const { setRequest: setRequest, goToLink: goToLink } = productStore;
        const { prodRequest: prodRequest } = (0, $gqFxE.storeToRefs)(productStore);
        const props = __props;
        const selected = (0, $8bTPG.computed)(()=>{
            if (props.choice.searchPage) {
                if (prodRequest.value.media === (0, $6g6T7.Media).ALL) return true;
                if (props.choice.name.toLowerCase() === (0, $6g6T7.Media).IMAGE && prodRequest.value.media === (0, $6g6T7.Media).IMAGE) return true;
                if (props.choice.name.toLowerCase() === (0, $6g6T7.Media).VIDEO && prodRequest.value.media === (0, $6g6T7.Media).VIDEO) return true;
                return false;
            } else return props.choice.selected === "1";
        });
        function setFilter() {
            if (!props.choice.searchPage) goToLink(props.choice);
            let item = prodRequest.value;
            if (selected.value) {
                if (item.media === (0, $6g6T7.Media).ALL) item.media = props.choice.name.toLowerCase() === (0, $6g6T7.Media).IMAGE ? (0, $6g6T7.Media).VIDEO : (0, $6g6T7.Media).IMAGE;
                else delete item.media;
            } else if (item.media === (0, $6g6T7.Media).IMAGE || item.media === (0, $6g6T7.Media).VIDEO) item.media = (0, $6g6T7.Media).ALL;
            else item.media = props.choice.name.toLowerCase() === (0, $6g6T7.Media).VIDEO ? (0, $6g6T7.Media).VIDEO : (0, $6g6T7.Media).IMAGE;
            setRequest(item);
        }
        const __returned__ = {
            productStore: productStore,
            setRequest: setRequest,
            goToLink: goToLink,
            prodRequest: prodRequest,
            props: props,
            selected: selected,
            setFilter: setFilter
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("kxNwt", function(module, exports) {

$parcel$export(module.exports, "render", () => $ef4d4de4973194c9$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $ef4d4de4973194c9$var$_hoisted_1 = [
    "checked"
];
function $ef4d4de4973194c9$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
        onClick: $setup.setFilter
    }, [
        (0, $ani5R.createElementVNode)("input", {
            type: "checkbox",
            checked: $setup.selected
        }, null, 8, $ef4d4de4973194c9$var$_hoisted_1),
        (0, $ani5R.createElementVNode)("label", null, (0, $X5A94.toDisplayString)($props.choice.name) + "(" + (0, $X5A94.toDisplayString)($props.choice.total) + ")", 1)
    ]);
}

});

parcelRegister("98AdZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a70f5e452da22b2$export$2e2bcd8739ae039);
let $6a70f5e452da22b2$var$NOOP = ()=>{};
var $6a70f5e452da22b2$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("1RXxs", function(module, exports) {

$parcel$export(module.exports, "default", () => $15c8eccfa07a5d28$export$2e2bcd8739ae039);
let $15c8eccfa07a5d28$var$script;



let $15c8eccfa07a5d28$var$initialize = ()=>{
    $15c8eccfa07a5d28$var$script = (parcelRequire("c7ZfB"));
    if ($15c8eccfa07a5d28$var$script.__esModule) $15c8eccfa07a5d28$var$script = $15c8eccfa07a5d28$var$script.default;
    $15c8eccfa07a5d28$var$script.render = (parcelRequire("911eM")).render;
    (parcelRequire("1aMpl")).default($15c8eccfa07a5d28$var$script);
    $15c8eccfa07a5d28$var$script.__scopeId = "data-v-713e7a";
    $15c8eccfa07a5d28$var$script.__file = "SpecificChoice.vue";
};
$15c8eccfa07a5d28$var$initialize();
var $15c8eccfa07a5d28$export$2e2bcd8739ae039 = $15c8eccfa07a5d28$var$script;

});
parcelRegister("c7ZfB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1d2969f222f81c95$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");

var $huSKp = parcelRequire("huSKp");

var $gqFxE = parcelRequire("gqFxE");
var $1d2969f222f81c95$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "SpecificChoice",
    props: {
        choice: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const productStore = (0, $huSKp.useProductStore)();
        const { setRequest: setRequest, goToLink: goToLink } = productStore;
        const { prodRequest: prodRequest } = (0, $gqFxE.storeToRefs)(productStore);
        const props = __props;
        const selected = (0, $8bTPG.computed)(()=>{
            if (props.choice.searchPage) return !!prodRequest.value[props.choice.value];
            else return props.choice.selected === "1";
        });
        function setFilter() {
            if (!props.choice.searchPage) goToLink(props.choice);
            let item = prodRequest.value;
            if (selected.value) delete item[props.choice.value];
            else item[props.choice.value] = true;
            setRequest(item);
        }
        const __returned__ = {
            productStore: productStore,
            setRequest: setRequest,
            goToLink: goToLink,
            prodRequest: prodRequest,
            props: props,
            selected: selected,
            setFilter: setFilter
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("911eM", function(module, exports) {

$parcel$export(module.exports, "render", () => $69052acbfb7871ba$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $69052acbfb7871ba$var$_hoisted_1 = [
    "checked"
];
function $69052acbfb7871ba$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
        onClick: $setup.setFilter
    }, [
        (0, $ani5R.createElementVNode)("input", {
            type: "checkbox",
            checked: $setup.selected
        }, null, 8, $69052acbfb7871ba$var$_hoisted_1),
        (0, $ani5R.createElementVNode)("label", null, (0, $X5A94.toDisplayString)($props.choice.name) + "(" + (0, $X5A94.toDisplayString)($props.choice.total) + ")", 1)
    ]);
}

});

parcelRegister("1aMpl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dac46630d8fdd64$export$2e2bcd8739ae039);
let $0dac46630d8fdd64$var$NOOP = ()=>{};
var $0dac46630d8fdd64$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("051Kq", function(module, exports) {

$parcel$export(module.exports, "render", () => $00f1d2d09044ea83$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $dDLnc = parcelRequire("dDLnc");
const $00f1d2d09044ea83$var$_hoisted_1 = {
    class: "single-filter__title"
};
const $00f1d2d09044ea83$var$_hoisted_2 = {
    key: 0,
    class: "gd-searh__num"
};
const $00f1d2d09044ea83$var$_hoisted_3 = {
    key: 0,
    class: "single-filter__list-wrap"
};
const $00f1d2d09044ea83$var$_hoisted_4 = {
    class: "single-filter__list"
};
function $00f1d2d09044ea83$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $props.filter.length ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
        key: 0,
        class: "single-filter",
        onMouseover: _cache[0] || (_cache[0] = ($event)=>$setup.setIsOpen(true)),
        onMouseleave: _cache[1] || (_cache[1] = ($event)=>$setup.setIsOpen(false))
    }, [
        (0, $ani5R.createElementVNode)("div", $00f1d2d09044ea83$var$_hoisted_1, [
            (0, $ani5R.createTextVNode)((0, $X5A94.toDisplayString)($props.title) + " ", 1),
            $props.selectedCount ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $00f1d2d09044ea83$var$_hoisted_2, [
                (0, $ani5R.createElementVNode)("span", null, (0, $X5A94.toDisplayString)($props.selectedCount), 1)
            ])) : (0, $ani5R.createCommentVNode)("", true)
        ]),
        (0, $ani5R.createVNode)((0, $dDLnc.Transition), {
            name: "slide-up-fade",
            mode: "out-in"
        }, {
            default: (0, $ani5R.withCtx)(()=>[
                    $setup.open ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $00f1d2d09044ea83$var$_hoisted_3, [
                        (0, $ani5R.createElementVNode)("ul", $00f1d2d09044ea83$var$_hoisted_4, [
                            $props.title === $setup.Filter.YEAR ? ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                                key: 0
                            }, (0, $ani5R.renderList)($props.filter, (choice)=>{
                                return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["YearChoice"], {
                                    class: "single-filter__list-item",
                                    key: choice.value,
                                    choice: choice
                                }, null, 8, [
                                    "choice"
                                ]);
                            }), 128)) : $props.title === $setup.Filter.ALTITUDE ? ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                                key: 1
                            }, (0, $ani5R.renderList)($props.filter, (choice)=>{
                                return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["AltitudeChoice"], {
                                    class: "single-filter__list-item",
                                    key: choice.value,
                                    choice: choice
                                }, null, 8, [
                                    "choice"
                                ]);
                            }), 128)) : $props.title === $setup.Filter.MEDIA ? ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                                key: 2
                            }, (0, $ani5R.renderList)($props.filter, (choice)=>{
                                return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["MediaChoice"], {
                                    class: "single-filter__list-item",
                                    key: choice.value,
                                    choice: choice
                                }, null, 8, [
                                    "choice"
                                ]);
                            }), 128)) : $props.title === $setup.Filter.SPECIFIC ? ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                                key: 3
                            }, (0, $ani5R.renderList)($props.filter, (choice)=>{
                                return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["SpecificChoice"], {
                                    class: "single-filter__list-item",
                                    key: choice.value,
                                    choice: choice
                                }, null, 8, [
                                    "choice"
                                ]);
                            }), 128)) : (0, $ani5R.createCommentVNode)("", true)
                        ])
                    ])) : (0, $ani5R.createCommentVNode)("", true)
                ]),
            _: 1
        })
    ], 32)) : (0, $ani5R.createCommentVNode)("", true);
}

});

parcelRegister("2NjeK", function(module, exports) {

$parcel$export(module.exports, "default", () => $208f1467ffcb363e$export$2e2bcd8739ae039);
let $208f1467ffcb363e$var$NOOP = ()=>{};
var $208f1467ffcb363e$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("gIe6R", function(module, exports) {

$parcel$export(module.exports, "useMapStore", () => $9f56628acc940496$export$abd5b1641d452390);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");

var $gqFxE = parcelRequire("gqFxE");
const $9f56628acc940496$export$abd5b1641d452390 = (0, $gqFxE.defineStore)("map-store", ()=>{
    const isMapOpen = (0, $8bTPG.ref)(false);
    function setIsMapOpen(isOpen) {
        isMapOpen.value = isOpen;
        const mapEvent = new CustomEvent("mapEvent", {
            detail: isOpen
        });
        window.dispatchEvent(mapEvent);
    }
    return {
        isMapOpen: isMapOpen,
        setIsMapOpen: setIsMapOpen
    };
});

});


parcelRegister("4gBqW", function(module, exports) {

$parcel$export(module.exports, "render", () => $31b5b1944e3d19c0$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $31b5b1944e3d19c0$var$_hoisted_1 = {
    class: "filters"
};
const $31b5b1944e3d19c0$var$_hoisted_2 = {
    class: "filters__wrap"
};
const $31b5b1944e3d19c0$var$_hoisted_3 = {
    class: "filters__list"
};
const $31b5b1944e3d19c0$var$_hoisted_4 = [
    "xlink:href"
];
function $31b5b1944e3d19c0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $31b5b1944e3d19c0$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("div", $31b5b1944e3d19c0$var$_hoisted_2, [
            (0, $ani5R.createElementVNode)("ul", $31b5b1944e3d19c0$var$_hoisted_3, [
                $setup.years ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["SingleFilter"], {
                    key: 0,
                    title: $setup.Filter.YEAR,
                    filter: $setup.years,
                    selectedCount: $setup.selectedYears
                }, null, 8, [
                    "title",
                    "filter",
                    "selectedCount"
                ])) : (0, $ani5R.createCommentVNode)("", true),
                $setup.altitude ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["SingleFilter"], {
                    key: 1,
                    title: $setup.Filter.ALTITUDE,
                    filter: $setup.altitude,
                    selectedCount: $setup.selectedAltitude
                }, null, 8, [
                    "title",
                    "filter",
                    "selectedCount"
                ])) : (0, $ani5R.createCommentVNode)("", true),
                $setup.media ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["SingleFilter"], {
                    key: 2,
                    title: $setup.Filter.MEDIA,
                    filter: $setup.media,
                    selectedCount: $setup.selectedMedia
                }, null, 8, [
                    "title",
                    "filter",
                    "selectedCount"
                ])) : (0, $ani5R.createCommentVNode)("", true),
                $setup.specifics ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["SingleFilter"], {
                    key: 3,
                    title: $setup.Filter.SPECIFIC,
                    filter: $setup.specifics,
                    selectedCount: $setup.selectedSpecific
                }, null, 8, [
                    "title",
                    "filter",
                    "selectedCount"
                ])) : (0, $ani5R.createCommentVNode)("", true),
                (0, $ani5R.createElementVNode)("li", {
                    onClick: _cache[0] || (_cache[0] = (...args)=>$setup.resetFilters && $setup.resetFilters(...args)),
                    class: (0, $X5A94.normalizeClass)([
                        "filters__clear",
                        {
                            activeClass: $setup.isFilterActive
                        }
                    ])
                }, " Clear Filters ", 2)
            ]),
            (0, $ani5R.createElementVNode)("div", {
                onClick: _cache[1] || (_cache[1] = ($event)=>$setup.setIsMapOpen(!$setup.isMapOpen)),
                class: "filter__map"
            }, [
                ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("svg", null, [
                    (0, $ani5R.createElementVNode)("use", {
                        "xlink:href": $setup.isMapOpen ? "#icon-list-light" : "#icon-map-light"
                    }, null, 8, $31b5b1944e3d19c0$var$_hoisted_4)
                ])),
                (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)($setup.isMapOpen ? "List" : "Map"), 1)
            ])
        ])
    ]);
}

});

parcelRegister("2uQZb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d177c0362972868$export$2e2bcd8739ae039);
let $1d177c0362972868$var$NOOP = ()=>{};
var $1d177c0362972868$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("5QSOE", function(module, exports) {

$parcel$export(module.exports, "default", () => $442c54603c861973$export$2e2bcd8739ae039);
let $442c54603c861973$var$script;



let $442c54603c861973$var$initialize = ()=>{
    $442c54603c861973$var$script = (parcelRequire("dAVhB"));
    if ($442c54603c861973$var$script.__esModule) $442c54603c861973$var$script = $442c54603c861973$var$script.default;
    $442c54603c861973$var$script.render = (parcelRequire("jhq20")).render;
    (parcelRequire("9ONVb")).default($442c54603c861973$var$script);
    $442c54603c861973$var$script.__scopeId = "data-v-84cf86";
    $442c54603c861973$var$script.__file = "MobFilters.vue";
};
$442c54603c861973$var$initialize();
var $442c54603c861973$export$2e2bcd8739ae039 = $442c54603c861973$var$script;

});
parcelRegister("dAVhB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a245e828228da31c$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $4VQLp = parcelRequire("4VQLp");

var $huSKp = parcelRequire("huSKp");

var $7O2xm = parcelRequire("7O2xm");

var $6g6T7 = parcelRequire("6g6T7");
var $a245e828228da31c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "MobFilters",
    emits: [
        "close"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const productStore = (0, $huSKp.useProductStore)();
        const { resetFilters: resetFilters } = productStore;
        const { years: years, altitude: altitude, media: media, specifics: specifics } = (0, $7O2xm.useCategoryStore)();
        const emit = __emit;
        function emitClose() {
            emit("close");
        }
        const __returned__ = {
            productStore: productStore,
            resetFilters: resetFilters,
            years: years,
            altitude: altitude,
            media: media,
            specifics: specifics,
            emit: emit,
            emitClose: emitClose,
            MobSingleFilter: $4VQLp.default,
            get Filter () {
                return 0, $6g6T7.Filter;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("4VQLp", function(module, exports) {

$parcel$export(module.exports, "default", () => $39756a142d6d68af$export$2e2bcd8739ae039);
let $39756a142d6d68af$var$script;



let $39756a142d6d68af$var$initialize = ()=>{
    $39756a142d6d68af$var$script = (parcelRequire("eqhcL"));
    if ($39756a142d6d68af$var$script.__esModule) $39756a142d6d68af$var$script = $39756a142d6d68af$var$script.default;
    $39756a142d6d68af$var$script.render = (parcelRequire("7Fn1h")).render;
    (parcelRequire("7GjSh")).default($39756a142d6d68af$var$script);
    $39756a142d6d68af$var$script.__scopeId = "data-v-75a58a";
    $39756a142d6d68af$var$script.__file = "MobSingleFilter.vue";
};
$39756a142d6d68af$var$initialize();
var $39756a142d6d68af$export$2e2bcd8739ae039 = $39756a142d6d68af$var$script;

});
parcelRegister("eqhcL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $89c43c89157ba8b1$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $6g6T7 = parcelRequire("6g6T7");

var $dj0Z3 = parcelRequire("dj0Z3");

var $TwOZ7 = parcelRequire("TwOZ7");

var $1RXxs = parcelRequire("1RXxs");

var $inzXh = parcelRequire("inzXh");
var $89c43c89157ba8b1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "MobSingleFilter",
    props: {
        title: {},
        filter: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            get Filter () {
                return 0, $6g6T7.Filter;
            },
            AltitudeChoice: $dj0Z3.default,
            YearChoice: $TwOZ7.default,
            SpecificChoice: $1RXxs.default,
            MediaChoice: $inzXh.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("7Fn1h", function(module, exports) {

$parcel$export(module.exports, "render", () => $594e37f34138ad7a$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $594e37f34138ad7a$var$_hoisted_1 = {
    class: "mob-filters__single"
};
const $594e37f34138ad7a$var$_hoisted_2 = {
    class: "bold-text"
};
const $594e37f34138ad7a$var$_hoisted_3 = {
    class: "mob-filters__list"
};
function $594e37f34138ad7a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $594e37f34138ad7a$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("p", $594e37f34138ad7a$var$_hoisted_2, (0, $X5A94.toDisplayString)($props.title), 1),
        (0, $ani5R.createElementVNode)("ul", $594e37f34138ad7a$var$_hoisted_3, [
            $props.title === $setup.Filter.YEAR ? ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                key: 0
            }, (0, $ani5R.renderList)($props.filter, (choice)=>{
                return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["YearChoice"], {
                    class: "single-filter__list-item",
                    key: choice.value,
                    choice: choice
                }, null, 8, [
                    "choice"
                ]);
            }), 128)) : $props.title === $setup.Filter.ALTITUDE ? ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                key: 1
            }, (0, $ani5R.renderList)($props.filter, (choice)=>{
                return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["AltitudeChoice"], {
                    class: "single-filter__list-item",
                    key: choice.value,
                    choice: choice
                }, null, 8, [
                    "choice"
                ]);
            }), 128)) : $props.title === $setup.Filter.MEDIA ? ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                key: 2
            }, (0, $ani5R.renderList)($props.filter, (choice)=>{
                return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["MediaChoice"], {
                    class: "single-filter__list-item",
                    key: choice.value,
                    choice: choice
                }, null, 8, [
                    "choice"
                ]);
            }), 128)) : $props.title === $setup.Filter.SPECIFIC ? ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                key: 3
            }, (0, $ani5R.renderList)($props.filter, (choice)=>{
                return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["SpecificChoice"], {
                    class: "single-filter__list-item",
                    key: choice.value,
                    choice: choice
                }, null, 8, [
                    "choice"
                ]);
            }), 128)) : (0, $ani5R.createCommentVNode)("", true)
        ])
    ]);
}

});

parcelRegister("7GjSh", function(module, exports) {

$parcel$export(module.exports, "default", () => $597bdf49cc81a717$export$2e2bcd8739ae039);
let $597bdf49cc81a717$var$NOOP = ()=>{};
var $597bdf49cc81a717$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("jhq20", function(module, exports) {

$parcel$export(module.exports, "render", () => $e093cc21d50573ea$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
const $e093cc21d50573ea$var$_hoisted_1 = {
    class: "mob-filters"
};
const $e093cc21d50573ea$var$_hoisted_2 = {
    class: "mob-filters__wrap"
};
const $e093cc21d50573ea$var$_hoisted_3 = {
    class: "mob-filters__head"
};
const $e093cc21d50573ea$var$_hoisted_4 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("h2", {
    class: "section-title"
}, "Filters", -1);
const $e093cc21d50573ea$var$_hoisted_5 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
    "xlink:href": "#icon-times-light"
}, null, -1);
const $e093cc21d50573ea$var$_hoisted_6 = [
    $e093cc21d50573ea$var$_hoisted_5
];
const $e093cc21d50573ea$var$_hoisted_7 = {
    class: "mob-filters__body"
};
const $e093cc21d50573ea$var$_hoisted_8 = {
    class: "mob-filters__btn-wrap"
};
function $e093cc21d50573ea$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $e093cc21d50573ea$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("div", $e093cc21d50573ea$var$_hoisted_2, [
            (0, $ani5R.createElementVNode)("div", $e093cc21d50573ea$var$_hoisted_3, [
                $e093cc21d50573ea$var$_hoisted_4,
                ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("svg", {
                    onClick: $setup.emitClose
                }, $e093cc21d50573ea$var$_hoisted_6))
            ]),
            (0, $ani5R.createElementVNode)("div", $e093cc21d50573ea$var$_hoisted_7, [
                $setup.years ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["MobSingleFilter"], {
                    key: 0,
                    title: $setup.Filter.YEAR,
                    filter: $setup.years
                }, null, 8, [
                    "title",
                    "filter"
                ])) : (0, $ani5R.createCommentVNode)("", true),
                $setup.altitude ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["MobSingleFilter"], {
                    key: 1,
                    title: $setup.Filter.ALTITUDE,
                    filter: $setup.altitude
                }, null, 8, [
                    "title",
                    "filter"
                ])) : (0, $ani5R.createCommentVNode)("", true),
                $setup.media ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["MobSingleFilter"], {
                    key: 2,
                    title: $setup.Filter.MEDIA,
                    filter: $setup.media
                }, null, 8, [
                    "title",
                    "filter"
                ])) : (0, $ani5R.createCommentVNode)("", true),
                $setup.specifics ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["MobSingleFilter"], {
                    key: 3,
                    title: $setup.Filter.SPECIFIC,
                    filter: $setup.specifics
                }, null, 8, [
                    "title",
                    "filter"
                ])) : (0, $ani5R.createCommentVNode)("", true),
                (0, $ani5R.createElementVNode)("div", $e093cc21d50573ea$var$_hoisted_8, [
                    (0, $ani5R.createElementVNode)("div", {
                        onClick: _cache[0] || (_cache[0] = (...args)=>$setup.resetFilters && $setup.resetFilters(...args)),
                        class: "main-btn"
                    }, "Clear Filters"),
                    (0, $ani5R.createElementVNode)("div", {
                        onClick: $setup.emitClose,
                        class: "main-btn main-btn--gray"
                    }, "Close")
                ])
            ])
        ])
    ]);
}

});

parcelRegister("9ONVb", function(module, exports) {

$parcel$export(module.exports, "default", () => $725f81e3c6296ebd$export$2e2bcd8739ae039);
let $725f81e3c6296ebd$var$NOOP = ()=>{};
var $725f81e3c6296ebd$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("01BPe", function(module, exports) {

$parcel$export(module.exports, "useGetCategory", () => $f71659eb766fff8b$export$3fa52226f8fff61e);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");

var $1zKtH = parcelRequire("1zKtH");

var $eNg28 = parcelRequire("eNg28");

var $6g6T7 = parcelRequire("6g6T7");
const $f71659eb766fff8b$var$OPTIONS = {
    fields: [
        "address_components",
        "geometry",
        "icon",
        "adr_address"
    ],
    componentRestrictions: {
        country: [
            "NZ",
            "AU"
        ]
    }
};
function $f71659eb766fff8b$export$3fa52226f8fff61e() {
    const searchInput = (0, $8bTPG.ref)();
    const responseMessage = (0, $8bTPG.ref)("");
    const loading = (0, $8bTPG.ref)(false);
    const placeNames = (0, $8bTPG.ref)([]);
    const lat = (0, $8bTPG.ref)(0);
    const lng = (0, $8bTPG.ref)(0);
    const searchPage = (0, $8bTPG.ref)(false);
    const searchQuery = (0, $8bTPG.ref)("");
    function searchAuto() {
        if (!searchInput.value) return;
        const autocomplete = new google.maps.places.Autocomplete(searchInput.value, $f71659eb766fff8b$var$OPTIONS);
        autocomplete.addListener("place_changed", ()=>{
            const places = autocomplete.getPlace();
            if (!places.geometry?.location) return;
            lat.value = places.geometry.location.lat();
            lng.value = places.geometry.location.lng();
            searchPage.value = !!places.address_components?.some((item)=>item.types.includes("street_number") || item.types.includes("route"));
            placeNames.value = places.address_components?.map((item)=>item.short_name) || [];
            getCategory();
        });
    }
    function setValues(searchAddress, names, longitute, latitude) {
        searchQuery.value = searchAddress;
        placeNames.value = names;
        lat.value = latitude;
        lng.value = longitute;
        searchPage.value = true;
    }
    async function getCategory() {
        try {
            responseMessage.value = "";
            loading.value = true;
            const resCat = await (0, (/*@__PURE__*/$parcel$interopDefault($1zKtH))).post("https://www.skyepics.com.au/do/WS/NetoAPI", {
                Filter: {
                    ContentName: placeNames.value,
                    OutputSelector: [
                        "ContentURL"
                    ],
                    Active: true
                }
            }, {
                headers: $eNg28.default
            });
            if (resCat.data.Ack === (0, $6g6T7.CategoryRequestStatus).SUCCESS && resCat.data.Content?.length) {
                const categoryArray = resCat.data.Content.map((item)=>item.ContentURL);
                redirectToCategoryPage(categoryArray);
            } else responseMessage.value = "No images on this location";
        } catch (e) {
            console.log(e);
            responseMessage.value = "";
        } finally{
            loading.value = false;
        }
    }
    function formatSearchString() {
        const address = searchInput.value?.value || searchQuery.value;
        if (!address) return "";
        const addressString = address.split(",");
        return encodeURI(addressString[0] + "," + addressString[1]);
    }
    function redirectToCategoryPage(categories) {
        const longestUrl = categories.map((item)=>{
            let count = 0;
            placeNames.value.forEach((el)=>{
                if (item.replaceAll("-", " ").includes(el.toLowerCase())) count++;
            });
            return {
                url: item,
                count: count
            };
        }).sort((a, b)=>b.count - a.count);
        const searchString = formatSearchString();
        window.location.href = `/${longestUrl[0].url}?searchQuery=${searchString}&lat=${lat.value}&lng=${lng.value}&searchPage=${searchPage.value}`;
    }
    return {
        searchInput: searchInput,
        searchAuto: searchAuto,
        placeNames: placeNames,
        responseMessage: responseMessage,
        loading: loading,
        getCategory: getCategory,
        setValues: setValues
    };
}

});
parcelRegister("eNg28", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfd781c019d728b4$export$2e2bcd8739ae039);
const $dfd781c019d728b4$var$headers = {
    NETOAPI_ACTION: "GetContent",
    NETOAPI_USERNAME: "api",
    NETOAPI_KEY: "mZnCZtD5uzvhCiefpVpJHyFSeznm5E6s"
};
var $dfd781c019d728b4$export$2e2bcd8739ae039 = $dfd781c019d728b4$var$headers;

});



parcelRegister("chSKI", function(module, exports) {

$parcel$export(module.exports, "render", () => $8f218b461640453a$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $dDLnc = parcelRequire("dDLnc");
const $8f218b461640453a$var$_hoisted_1 = {
    class: "gd-searh__input-wrap"
};
const $8f218b461640453a$var$_hoisted_2 = {
    class: "gd-searh__input-wrap-inner"
};
const $8f218b461640453a$var$_hoisted_3 = {
    ref: "searchInput",
    type: "text",
    class: "gd-searh__input",
    placeholder: "Search by address, suburb..."
};
const $8f218b461640453a$var$_hoisted_4 = {
    key: 0,
    class: "gd-searh__btn"
};
const $8f218b461640453a$var$_hoisted_5 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("div", {
    class: "loader"
}, null, -1);
const $8f218b461640453a$var$_hoisted_6 = [
    $8f218b461640453a$var$_hoisted_5
];
const $8f218b461640453a$var$_hoisted_7 = {
    key: 1,
    class: "gd-searh__not-found"
};
const $8f218b461640453a$var$_hoisted_8 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", null, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
        "xlink:href": "#icon-sliders-h-regular"
    })
], -1);
const $8f218b461640453a$var$_hoisted_9 = {
    class: "gd-searh__num"
};
const $8f218b461640453a$var$_hoisted_10 = {
    ref: "info",
    class: "d-none"
};
function $8f218b461640453a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $8f218b461640453a$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("div", $8f218b461640453a$var$_hoisted_2, [
            (0, $ani5R.createElementVNode)("input", $8f218b461640453a$var$_hoisted_3, null, 512),
            $setup.loading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("button", $8f218b461640453a$var$_hoisted_4, $8f218b461640453a$var$_hoisted_6)) : (0, $ani5R.createCommentVNode)("", true),
            $setup.responseMessage ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $8f218b461640453a$var$_hoisted_7, (0, $X5A94.toDisplayString)($setup.responseMessage), 1)) : (0, $ani5R.createCommentVNode)("", true)
        ]),
        (0, $ani5R.createElementVNode)("div", {
            onClick: $setup.setfilterOpen,
            class: "gd-searh__btn gd-searh__btn--filter"
        }, [
            $8f218b461640453a$var$_hoisted_8,
            (0, $ani5R.createElementVNode)("div", $8f218b461640453a$var$_hoisted_9, (0, $X5A94.toDisplayString)($setup.selectedCount), 1)
        ]),
        (0, $ani5R.createVNode)((0, $dDLnc.Transition), {
            name: "slide-up-fade",
            mode: "out-in"
        }, {
            default: (0, $ani5R.withCtx)(()=>[
                    $setup.filterOpen ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["MobFilters"], {
                        key: 0,
                        onClose: $setup.setfilterOpen
                    })) : (0, $ani5R.createCommentVNode)("", true)
                ]),
            _: 1
        }),
        (0, $ani5R.createVNode)($setup["Filters"]),
        (0, $ani5R.createElementVNode)("div", $8f218b461640453a$var$_hoisted_10, null, 512)
    ]);
}

});

parcelRegister("kJ9Hd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f16f880932013438$export$2e2bcd8739ae039);
let $f16f880932013438$var$NOOP = ()=>{};
var $f16f880932013438$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("cTslv", function(module, exports) {

$parcel$export(module.exports, "default", () => $96309bfdc04497d8$export$2e2bcd8739ae039);
let $96309bfdc04497d8$var$script;



let $96309bfdc04497d8$var$initialize = ()=>{
    $96309bfdc04497d8$var$script = (parcelRequire("5qHdr"));
    if ($96309bfdc04497d8$var$script.__esModule) $96309bfdc04497d8$var$script = $96309bfdc04497d8$var$script.default;
    $96309bfdc04497d8$var$script.render = (parcelRequire("3f6Or")).render;
    (parcelRequire("5fUie")).default($96309bfdc04497d8$var$script);
    $96309bfdc04497d8$var$script.__scopeId = "data-v-388878";
    $96309bfdc04497d8$var$script.__file = "NetoSearch.vue";
};
$96309bfdc04497d8$var$initialize();
var $96309bfdc04497d8$export$2e2bcd8739ae039 = $96309bfdc04497d8$var$script;

});
parcelRegister("5qHdr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c2a2d60f9b145dbf$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $c2a2d60f9b145dbf$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "NetoSearch",
    setup (__props, { expose: __expose }) {
        __expose();
        (0, $ani5R.onMounted)(()=>{
            $.initSearchField({
                result_header: '<ul class="nav nav-list">',
                result_body: '<li><a href="##url##" search-keyword="##keyword##"><img border="0" src="##thumb##" width="36" height="36"/><span class="title">##model##</span></a></li>',
                result_footer: "</ul>",
                category_header: '<ul class="nav nav-list">',
                category_body: '<li><a href="##url##"><span class="thumb"><img border="0" src="##thumb##" width="36" height="36"/></span><span class="title">##fullname##</span> <span class="label label-default">##typename##</span></a></li>',
                category_footer: "</ul>"
            });
        });
        const __returned__ = {};
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("3f6Or", function(module, exports) {

$parcel$export(module.exports, "render", () => $25c80ea2982f29a3$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
const $25c80ea2982f29a3$var$_hoisted_1 = {
    name: "productsearch",
    class: "form-search",
    method: "get",
    action: "/",
    role: "search",
    "aria-label": "Product search"
};
const $25c80ea2982f29a3$var$_hoisted_2 = /*#__PURE__*/ (0, $ani5R.createStaticVNode)('<div class="gd-searh__input-wrap"><input type="hidden" name="rf" value="kw"><input class="gd-searh__input ajax_search" value="" id="name_search" placeholder="Search by keyword" autocomplete="off" name="kw" type="text" aria-label="Input search"><button type="submit" value="Search" class="gd-searh__btn" aria-label="Search site"><svg><use xlink:href="#icon-search-light"></use></svg></button></div>', 1);
const $25c80ea2982f29a3$var$_hoisted_3 = [
    $25c80ea2982f29a3$var$_hoisted_2
];
function $25c80ea2982f29a3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("form", $25c80ea2982f29a3$var$_hoisted_1, $25c80ea2982f29a3$var$_hoisted_3);
}

});

parcelRegister("5fUie", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d3a051d790c240e$export$2e2bcd8739ae039);
let $3d3a051d790c240e$var$NOOP = ()=>{};
var $3d3a051d790c240e$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("3GQ48", function(module, exports) {

$parcel$export(module.exports, "render", () => $2afdae876c02bead$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $dDLnc = parcelRequire("dDLnc");
const $2afdae876c02bead$var$_hoisted_1 = {
    id: "navSearch",
    class: "gd-search",
    ref: "searchWrap"
};
const $2afdae876c02bead$var$_hoisted_2 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", null, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
        "xlink:href": "#icon-search-light"
    })
], -1);
const $2afdae876c02bead$var$_hoisted_3 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", null, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
        "xlink:href": "#icon-key-light"
    })
], -1);
const $2afdae876c02bead$var$_hoisted_4 = {
    class: "gd-search__line",
    ref: "line"
};
const $2afdae876c02bead$var$_hoisted_5 = {
    class: "gd-search__forms-wrap"
};
const $2afdae876c02bead$var$_hoisted_6 = {
    key: 0,
    class: "gd-search__select"
};
const $2afdae876c02bead$var$_hoisted_7 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", null, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
        "xlink:href": "#icon-search-light"
    })
], -1);
const $2afdae876c02bead$var$_hoisted_8 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", {
    class: "gd-search__arrow"
}, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
        "xlink:href": "#icon-caret-down-solid"
    })
], -1);
const $2afdae876c02bead$var$_hoisted_9 = [
    $2afdae876c02bead$var$_hoisted_7,
    $2afdae876c02bead$var$_hoisted_8
];
const $2afdae876c02bead$var$_hoisted_10 = {
    key: 1,
    class: "gd-search__select"
};
const $2afdae876c02bead$var$_hoisted_11 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", null, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
        "xlink:href": "#icon-key-light"
    })
], -1);
const $2afdae876c02bead$var$_hoisted_12 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", {
    class: "gd-search__arrow"
}, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
        "xlink:href": "#icon-caret-down-solid"
    })
], -1);
const $2afdae876c02bead$var$_hoisted_13 = [
    $2afdae876c02bead$var$_hoisted_11,
    $2afdae876c02bead$var$_hoisted_12
];
function $2afdae876c02bead$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2afdae876c02bead$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("div", {
            class: (0, $X5A94.normalizeClass)([
                "gd-search__wrap",
                {
                    search: $setup.show
                }
            ])
        }, [
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)([
                    "gd-search__btn-wrap",
                    {
                        active: $setup.open
                    }
                ]),
                ref: "wrap"
            }, [
                (0, $ani5R.createElementVNode)("div", {
                    onClick: _cache[0] || (_cache[0] = ($event)=>$setup.select($setup.address, true)),
                    class: "gd-search__btn"
                }, [
                    $2afdae876c02bead$var$_hoisted_2,
                    (0, $ani5R.createElementVNode)("p", {
                        ref: "address",
                        class: (0, $X5A94.normalizeClass)({
                            active: $setup.show
                        })
                    }, "Address", 2)
                ]),
                (0, $ani5R.createElementVNode)("div", {
                    onClick: _cache[1] || (_cache[1] = ($event)=>$setup.select($setup.key, false)),
                    class: "gd-search__btn"
                }, [
                    (0, $ani5R.createElementVNode)("p", {
                        ref: "key",
                        class: (0, $X5A94.normalizeClass)({
                            active: !$setup.show
                        })
                    }, "Keyword", 2),
                    $2afdae876c02bead$var$_hoisted_3
                ]),
                (0, $ani5R.createElementVNode)("div", $2afdae876c02bead$var$_hoisted_4, null, 512)
            ], 2),
            (0, $ani5R.createElementVNode)("div", $2afdae876c02bead$var$_hoisted_5, [
                (0, $ani5R.createElementVNode)("div", {
                    onClick: _cache[2] || (_cache[2] = ($event)=>$setup.open = !$setup.open),
                    class: "gd-search__select-wrap"
                }, [
                    (0, $ani5R.createVNode)((0, $dDLnc.Transition), {
                        name: "slide-fade",
                        mode: "out-in"
                    }, {
                        default: (0, $ani5R.withCtx)(()=>[
                                $setup.show ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2afdae876c02bead$var$_hoisted_6, $2afdae876c02bead$var$_hoisted_9)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2afdae876c02bead$var$_hoisted_10, $2afdae876c02bead$var$_hoisted_13))
                            ]),
                        _: 1
                    })
                ]),
                (0, $ani5R.createVNode)((0, $dDLnc.Transition), {
                    name: "slide-fade",
                    mode: "out-in"
                }, {
                    default: (0, $ani5R.withCtx)(()=>[
                            $setup.show ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["GetCategory"], {
                                key: "1"
                            })) : ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["NetoSearch"], {
                                key: "2"
                            }))
                        ]),
                    _: 1
                })
            ])
        ], 2)
    ], 512);
}

});

parcelRegister("aEyp6", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c1853b8a695a5bf$export$2e2bcd8739ae039);
let $7c1853b8a695a5bf$var$NOOP = ()=>{};
var $7c1853b8a695a5bf$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("jYaiU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e89b9d0fb56c159a$export$2e2bcd8739ae039);
let $e89b9d0fb56c159a$var$script;



let $e89b9d0fb56c159a$var$initialize = ()=>{
    $e89b9d0fb56c159a$var$script = (parcelRequire("iJzee"));
    if ($e89b9d0fb56c159a$var$script.__esModule) $e89b9d0fb56c159a$var$script = $e89b9d0fb56c159a$var$script.default;
    $e89b9d0fb56c159a$var$script.render = (parcelRequire("ixxTN")).render;
    (parcelRequire("7ejC9")).default($e89b9d0fb56c159a$var$script);
    $e89b9d0fb56c159a$var$script.__scopeId = "data-v-a8f10e";
    $e89b9d0fb56c159a$var$script.__file = "Pagination.vue";
};
$e89b9d0fb56c159a$var$initialize();
var $e89b9d0fb56c159a$export$2e2bcd8739ae039 = $e89b9d0fb56c159a$var$script;

});
parcelRegister("iJzee", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b0252f00fa02e60f$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");

var $huSKp = parcelRequire("huSKp");

var $gqFxE = parcelRequire("gqFxE");

var $6g6T7 = parcelRequire("6g6T7");
var $b0252f00fa02e60f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "Pagination",
    props: {
        gridList: {
            type: Boolean,
            default: false
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const sortOptions = [
            {
                id: (0, $6g6T7.SortField).ALTITUDE,
                name: "Altitude Greatest",
                sort: (0, $6g6T7.SortDirection).DESC
            },
            {
                id: (0, $6g6T7.SortField).ALTITUDE,
                name: "Altitude Smallest",
                sort: (0, $6g6T7.SortDirection).ASC
            },
            {
                id: (0, $6g6T7.SortField).CREATED_AT,
                name: "Most Recent",
                sort: (0, $6g6T7.SortDirection).DESC
            },
            {
                id: (0, $6g6T7.SortField).CREATED_AT,
                name: "Oldest",
                sort: (0, $6g6T7.SortDirection).ASC
            }
        ];
        const productStore = (0, $huSKp.useProductStore)();
        const { setGrid: setGrid, setRequest: setRequest } = productStore;
        const { gridClass: gridClass, prodRequest: prodRequest, maxPage: maxPage, total: total } = (0, $gqFxE.storeToRefs)(productStore);
        const sortInput = (0, $8bTPG.ref)({
            id: (0, $6g6T7.SortField).CREATED_AT,
            name: "Most Recent",
            sort: (0, $6g6T7.SortDirection).DESC
        });
        const sortBy = (0, $8bTPG.computed)({
            get: ()=>sortInput.value,
            set: (value)=>{
                const newSort = prodRequest.value.sort;
                newSort[0] = [
                    value.id,
                    value.sort
                ];
                setRequest({
                    ...prodRequest.value,
                    sort: newSort
                });
            }
        });
        const currentPage = (0, $8bTPG.computed)({
            get: ()=>prodRequest.value.page,
            set: (value)=>{
                setRequest({
                    ...prodRequest.value,
                    page: value
                });
            }
        });
        function scrollTo() {
            document.getElementById("top")?.scrollIntoView({
                behavior: "smooth"
            });
        }
        function next() {
            if (currentPage.value >= maxPage.value) return;
            currentPage.value++;
            scrollTo();
        }
        function prev() {
            if (currentPage.value <= 1) return;
            currentPage.value--;
            scrollTo();
        }
        const __returned__ = {
            sortOptions: sortOptions,
            productStore: productStore,
            setGrid: setGrid,
            setRequest: setRequest,
            gridClass: gridClass,
            prodRequest: prodRequest,
            maxPage: maxPage,
            total: total,
            sortInput: sortInput,
            sortBy: sortBy,
            currentPage: currentPage,
            scrollTo: scrollTo,
            next: next,
            prev: prev,
            get GridClass () {
                return 0, $6g6T7.GridClass;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("ixxTN", function(module, exports) {

$parcel$export(module.exports, "render", () => $d7f59aa9bb0f87b7$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $dDLnc = parcelRequire("dDLnc");
const $d7f59aa9bb0f87b7$var$_hoisted_1 = {
    class: "pagination"
};
const $d7f59aa9bb0f87b7$var$_hoisted_2 = {
    class: "pagination__wrap"
};
const $d7f59aa9bb0f87b7$var$_hoisted_3 = {
    key: 0,
    class: "pagination__inner-wrap"
};
const $d7f59aa9bb0f87b7$var$_hoisted_4 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
    "xlink:href": "#icon-th-solid"
}, null, -1);
const $d7f59aa9bb0f87b7$var$_hoisted_5 = [
    $d7f59aa9bb0f87b7$var$_hoisted_4
];
const $d7f59aa9bb0f87b7$var$_hoisted_6 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
    "xlink:href": "#icon-th-large-solid"
}, null, -1);
const $d7f59aa9bb0f87b7$var$_hoisted_7 = [
    $d7f59aa9bb0f87b7$var$_hoisted_6
];
const $d7f59aa9bb0f87b7$var$_hoisted_8 = {
    class: "category-page__form"
};
const $d7f59aa9bb0f87b7$var$_hoisted_9 = [
    "value"
];
const $d7f59aa9bb0f87b7$var$_hoisted_10 = {
    key: 1,
    class: "pagination__btn-wrap"
};
const $d7f59aa9bb0f87b7$var$_hoisted_11 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", null, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
        "xlink:href": "#icon-caret-left-solid"
    })
], -1);
const $d7f59aa9bb0f87b7$var$_hoisted_12 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", null, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
        "xlink:href": "#icon-caret-right-solid"
    })
], -1);
const $d7f59aa9bb0f87b7$var$_hoisted_13 = {
    class: "main-text"
};
const $d7f59aa9bb0f87b7$var$_hoisted_14 = {
    class: "pagination__input-wrap"
};
const $d7f59aa9bb0f87b7$var$_hoisted_15 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
    "xlink:href": "#icon-chevron-left-light"
}, null, -1);
const $d7f59aa9bb0f87b7$var$_hoisted_16 = [
    $d7f59aa9bb0f87b7$var$_hoisted_15
];
const $d7f59aa9bb0f87b7$var$_hoisted_17 = [
    "max"
];
const $d7f59aa9bb0f87b7$var$_hoisted_18 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
    "xlink:href": "#icon-chevron-right-light"
}, null, -1);
const $d7f59aa9bb0f87b7$var$_hoisted_19 = [
    $d7f59aa9bb0f87b7$var$_hoisted_18
];
function $d7f59aa9bb0f87b7$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $d7f59aa9bb0f87b7$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("div", $d7f59aa9bb0f87b7$var$_hoisted_2, [
            $props.gridList ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $d7f59aa9bb0f87b7$var$_hoisted_3, [
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)([
                        "pagination__grid",
                        $setup.gridClass
                    ])
                }, [
                    ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("svg", {
                        onClick: _cache[0] || (_cache[0] = ($event)=>$setup.setGrid($setup.GridClass.LIST))
                    }, $d7f59aa9bb0f87b7$var$_hoisted_5)),
                    ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("svg", {
                        onClick: _cache[1] || (_cache[1] = ($event)=>$setup.setGrid($setup.GridClass.CARDS))
                    }, $d7f59aa9bb0f87b7$var$_hoisted_7))
                ], 2),
                (0, $ani5R.createElementVNode)("form", $d7f59aa9bb0f87b7$var$_hoisted_8, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("select", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.sortBy = $event),
                        class: "category-page__select"
                    }, [
                        ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($setup.sortOptions, (option)=>{
                            return (0, $ani5R.createElementVNode)("option", {
                                key: option.id,
                                value: option
                            }, (0, $X5A94.toDisplayString)(option.name), 9, $d7f59aa9bb0f87b7$var$_hoisted_9);
                        }), 64))
                    ], 512), [
                        [
                            (0, $dDLnc.vModelSelect),
                            $setup.sortBy
                        ]
                    ])
                ])
            ])) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $d7f59aa9bb0f87b7$var$_hoisted_10, [
                $setup.currentPage > 1 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 0,
                    onClick: $setup.prev,
                    class: "pagination__next"
                }, [
                    $d7f59aa9bb0f87b7$var$_hoisted_11,
                    (0, $ani5R.createTextVNode)(" Prev ")
                ])) : (0, $ani5R.createCommentVNode)("", true),
                (0, $ani5R.createElementVNode)("div", {
                    onClick: $setup.next,
                    class: (0, $X5A94.normalizeClass)([
                        "pagination__next",
                        {
                            disable: $setup.currentPage === $setup.maxPage
                        }
                    ])
                }, [
                    (0, $ani5R.createTextVNode)(" Next "),
                    $d7f59aa9bb0f87b7$var$_hoisted_12
                ], 2),
                (0, $ani5R.createElementVNode)("p", $d7f59aa9bb0f87b7$var$_hoisted_13, [
                    (0, $ani5R.createTextVNode)(" Total Found: "),
                    (0, $ani5R.createElementVNode)("strong", null, (0, $X5A94.toDisplayString)($setup.total), 1)
                ])
            ])),
            (0, $ani5R.createElementVNode)("div", $d7f59aa9bb0f87b7$var$_hoisted_14, [
                ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("svg", {
                    onClick: $setup.prev
                }, $d7f59aa9bb0f87b7$var$_hoisted_16)),
                (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                    type: "number",
                    min: "1",
                    max: $setup.maxPage,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.currentPage = $event),
                    class: "pagination__input"
                }, null, 8, $d7f59aa9bb0f87b7$var$_hoisted_17), [
                    [
                        (0, $dDLnc.vModelText),
                        $setup.currentPage
                    ]
                ]),
                ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("svg", {
                    onClick: $setup.next
                }, $d7f59aa9bb0f87b7$var$_hoisted_19))
            ])
        ])
    ]);
}

});

parcelRegister("7ejC9", function(module, exports) {

$parcel$export(module.exports, "default", () => $54390e3b14f75516$export$2e2bcd8739ae039);
let $54390e3b14f75516$var$NOOP = ()=>{};
var $54390e3b14f75516$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("c2Sd1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c4fb8b5929255e9$export$2e2bcd8739ae039);
let $8c4fb8b5929255e9$var$script;



let $8c4fb8b5929255e9$var$initialize = ()=>{
    $8c4fb8b5929255e9$var$script = (parcelRequire("9GDfH"));
    if ($8c4fb8b5929255e9$var$script.__esModule) $8c4fb8b5929255e9$var$script = $8c4fb8b5929255e9$var$script.default;
    $8c4fb8b5929255e9$var$script.render = (parcelRequire("eML14")).render;
    (parcelRequire("4oBwe")).default($8c4fb8b5929255e9$var$script);
    $8c4fb8b5929255e9$var$script.__scopeId = "data-v-55467c";
    $8c4fb8b5929255e9$var$script.__file = "MobMapBtn.vue";
};
$8c4fb8b5929255e9$var$initialize();
var $8c4fb8b5929255e9$export$2e2bcd8739ae039 = $8c4fb8b5929255e9$var$script;

});
parcelRegister("9GDfH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c51de21510d5bcc9$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $gqFxE = parcelRequire("gqFxE");

var $gIe6R = parcelRequire("gIe6R");
var $c51de21510d5bcc9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "MobMapBtn",
    setup (__props, { expose: __expose }) {
        __expose();
        const { isMapOpen: isMapOpen } = (0, $gqFxE.storeToRefs)((0, $gIe6R.useMapStore)());
        const { setIsMapOpen: setIsMapOpen } = (0, $gIe6R.useMapStore)();
        const __returned__ = {
            isMapOpen: isMapOpen,
            setIsMapOpen: setIsMapOpen
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("eML14", function(module, exports) {

$parcel$export(module.exports, "render", () => $ac3a04d7e26de174$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $ac3a04d7e26de174$var$_hoisted_1 = {
    class: "mob-map-btn__wrap"
};
const $ac3a04d7e26de174$var$_hoisted_2 = [
    "xlink:href"
];
function $ac3a04d7e26de174$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        onClick: _cache[0] || (_cache[0] = ($event)=>$setup.setIsMapOpen(!$setup.isMapOpen)),
        id: "mapBtn",
        class: "mob-map-btn"
    }, [
        (0, $ani5R.createElementVNode)("div", $ac3a04d7e26de174$var$_hoisted_1, [
            ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("svg", null, [
                (0, $ani5R.createElementVNode)("use", {
                    "xlink:href": $setup.isMapOpen ? "#icon-list-light" : "#icon-map-light"
                }, null, 8, $ac3a04d7e26de174$var$_hoisted_2)
            ])),
            (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)($setup.isMapOpen ? "List" : "Map"), 1)
        ])
    ]);
}

});

parcelRegister("4oBwe", function(module, exports) {

$parcel$export(module.exports, "default", () => $333681c4a9376ddd$export$2e2bcd8739ae039);
let $333681c4a9376ddd$var$NOOP = ()=>{};
var $333681c4a9376ddd$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("hVbZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0c10f3034fd0484$export$2e2bcd8739ae039);
let $d0c10f3034fd0484$var$script;



let $d0c10f3034fd0484$var$initialize = ()=>{
    $d0c10f3034fd0484$var$script = (parcelRequire("j8z6u"));
    if ($d0c10f3034fd0484$var$script.__esModule) $d0c10f3034fd0484$var$script = $d0c10f3034fd0484$var$script.default;
    $d0c10f3034fd0484$var$script.render = (parcelRequire("jm7WK")).render;
    (parcelRequire("j2gGb")).default($d0c10f3034fd0484$var$script);
    $d0c10f3034fd0484$var$script.__scopeId = "data-v-d9961e";
    $d0c10f3034fd0484$var$script.__file = "GoogleMap.vue";
};
$d0c10f3034fd0484$var$initialize();
var $d0c10f3034fd0484$export$2e2bcd8739ae039 = $d0c10f3034fd0484$var$script;

});
parcelRegister("j8z6u", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b5ce264bdb9f0b1e$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");

var $huSKp = parcelRequire("huSKp");

var $gqFxE = parcelRequire("gqFxE");

var $gIe6R = parcelRequire("gIe6R");

var $7O2xm = parcelRequire("7O2xm");

var $01BPe = parcelRequire("01BPe");

var $3XmQy = parcelRequire("3XmQy");
var $b5ce264bdb9f0b1e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "GoogleMap",
    setup (__props, { expose: __expose }) {
        __expose();
        const productStore = (0, $huSKp.useProductStore)();
        const { setRequest: setRequest } = productStore;
        const { prodRequest: prodRequest } = (0, $gqFxE.storeToRefs)(productStore);
        const { setIsMapOpen: setIsMapOpen } = (0, $gIe6R.useMapStore)();
        const { setName: setName } = (0, $7O2xm.useCategoryStore)();
        const showCatMap = window.showCatMap;
        const { getCategory: getCategory, setValues: setValues, loading: loading, searchPage: searchPage } = (0, $01BPe.useGetCategory)();
        const toolTip = (0, $8bTPG.computed)(()=>{
            return window.mapTollTip;
        });
        const tollTipShow = (0, $8bTPG.ref)(true);
        const mapDiv = (0, $8bTPG.ref)(null);
        const places = (0, $8bTPG.ref)(new google.maps.Geocoder());
        async function setMap() {
            if (!mapDiv.value) return;
            let markers = [];
            const { Map: Map } = await google.maps.importLibrary("maps");
            const googleMap = new Map(mapDiv.value, {
                center: {
                    lat: prodRequest.value.lat,
                    lng: prodRequest.value.lng
                },
                mapTypeId: google.maps.MapTypeId.SATELLITE,
                streetViewControl: false,
                zoom: 15,
                draggableCursor: "pointer",
                draggingCursor: "pointer"
            });
            setMarker(prodRequest.value.lat, prodRequest.value.lng);
            setCords();
            function setMarker(lat, lng) {
                markers.forEach((marker)=>marker.setMap(null));
                markers = [];
                const latLng = new google.maps.LatLng(lat, lng);
                const newMarker = new google.maps.Marker({
                    position: latLng,
                    map: googleMap
                });
                markers.push(newMarker);
            }
            function setCords() {
                googleMap.addListener("click", async (e)=>{
                    await places.value.geocode({
                        latLng: e.latLng
                    }, (results, status)=>{
                        if (status == google.maps.GeocoderStatus.OK) {
                            if (results && results[0]) {
                                setName(results[0].formatted_address);
                                const names = results[0].address_components?.map((item)=>item.short_name) || [];
                                setValues(results[0].formatted_address, names, e.latLng.lng(), e.latLng.lat());
                            }
                        }
                    });
                    setMarker(e.latLng.lat(), e.latLng.lng());
                    if (!showCatMap) setRequest({
                        ...prodRequest.value,
                        lat: e.latLng.lat(),
                        lng: e.latLng.lng()
                    });
                    else getCategory();
                    closeMap();
                });
            }
        }
        function closeMap() {
            if (window.innerWidth < 1200) {
                const header = document.getElementById("header");
                const navSearch = document.getElementById("navSearch");
                document.body.classList.remove("map-opend");
                header?.classList.remove("top");
                navSearch?.classList.remove("top");
                setIsMapOpen(false);
            }
        }
        (0, $ani5R.onMounted)(()=>{
            setMap();
        });
        const __returned__ = {
            productStore: productStore,
            setRequest: setRequest,
            prodRequest: prodRequest,
            setIsMapOpen: setIsMapOpen,
            setName: setName,
            showCatMap: showCatMap,
            getCategory: getCategory,
            setValues: setValues,
            loading: loading,
            searchPage: searchPage,
            toolTip: toolTip,
            tollTipShow: tollTipShow,
            mapDiv: mapDiv,
            places: places,
            setMap: setMap,
            closeMap: closeMap,
            LoaderComponent: $3XmQy.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("jm7WK", function(module, exports) {

$parcel$export(module.exports, "render", () => $e1763c6419969464$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $dDLnc = parcelRequire("dDLnc");
const $e1763c6419969464$var$_hoisted_1 = {
    class: "w-100 h-100 google-map__wrap"
};
const $e1763c6419969464$var$_hoisted_2 = {
    class: "google-map"
};
const $e1763c6419969464$var$_hoisted_3 = {
    class: "google-map__text-inner-wrap"
};
const $e1763c6419969464$var$_hoisted_4 = [
    "innerHTML"
];
const $e1763c6419969464$var$_hoisted_5 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", {
    class: "google-map__close"
}, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
        "xlink:href": "#icon-times-light"
    })
], -1);
const $e1763c6419969464$var$_hoisted_6 = {
    ref: "mapDiv",
    class: "w-100 h-100"
};
function $e1763c6419969464$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $e1763c6419969464$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("section", $e1763c6419969464$var$_hoisted_2, [
            (0, $ani5R.createVNode)((0, $dDLnc.Transition), {
                name: "fade",
                mode: "out-in"
            }, {
                default: (0, $ani5R.withCtx)(()=>[
                        $setup.tollTipShow ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = ($event)=>$setup.tollTipShow = false),
                            class: "google-map__text-wrap"
                        }, [
                            (0, $ani5R.createElementVNode)("div", $e1763c6419969464$var$_hoisted_3, [
                                (0, $ani5R.createElementVNode)("div", {
                                    class: "google-map__text",
                                    innerHTML: $setup.toolTip
                                }, null, 8, $e1763c6419969464$var$_hoisted_4),
                                $e1763c6419969464$var$_hoisted_5
                            ])
                        ])) : (0, $ani5R.createCommentVNode)("", true)
                    ]),
                _: 1
            }),
            (0, $ani5R.createElementVNode)("div", $e1763c6419969464$var$_hoisted_6, null, 512)
        ]),
        (0, $ani5R.createVNode)((0, $dDLnc.Transition), {
            name: "slide-up-fade",
            mode: "out-in"
        }, {
            default: (0, $ani5R.withCtx)(()=>[
                    $setup.loading && $setup.showCatMap ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["LoaderComponent"], {
                        key: 0
                    })) : (0, $ani5R.createCommentVNode)("", true)
                ]),
            _: 1
        })
    ]);
}

});

parcelRegister("j2gGb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddbb24686261f277$export$2e2bcd8739ae039);
let $ddbb24686261f277$var$NOOP = ()=>{};
var $ddbb24686261f277$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("5GiI3", function(module, exports) {

$parcel$export(module.exports, "render", () => $422f6351b446e053$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $422f6351b446e053$var$_hoisted_1 = {
    class: "category-page"
};
const $422f6351b446e053$var$_hoisted_2 = {
    class: "category-page__title"
};
const $422f6351b446e053$var$_hoisted_3 = {
    class: "category-page__title-wrap"
};
const $422f6351b446e053$var$_hoisted_4 = {
    class: "main-title"
};
const $422f6351b446e053$var$_hoisted_5 = {
    class: "category-page__subtitle"
};
const $422f6351b446e053$var$_hoisted_6 = {
    class: "category-page__select-wrap"
};
const $422f6351b446e053$var$_hoisted_7 = {
    class: "category-page__body"
};
const $422f6351b446e053$var$_hoisted_8 = {
    class: "description description--category description--left-desc"
};
const $422f6351b446e053$var$_hoisted_9 = [
    "innerHTML"
];
const $422f6351b446e053$var$_hoisted_10 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("div", null, null, -1);
function $422f6351b446e053$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, [
        (0, $ani5R.createElementVNode)("div", $422f6351b446e053$var$_hoisted_1, [
            (0, $ani5R.createVNode)($setup["Search"]),
            (0, $ani5R.createElementVNode)("div", $422f6351b446e053$var$_hoisted_2, [
                (0, $ani5R.createElementVNode)("div", $422f6351b446e053$var$_hoisted_3, [
                    (0, $ani5R.createElementVNode)("h1", $422f6351b446e053$var$_hoisted_4, (0, $X5A94.toDisplayString)($setup.name), 1),
                    (0, $ani5R.createElementVNode)("p", $422f6351b446e053$var$_hoisted_5, [
                        (0, $ani5R.createTextVNode)(" (Total Found: "),
                        (0, $ani5R.createElementVNode)("strong", null, (0, $X5A94.toDisplayString)($setup.total), 1),
                        (0, $ani5R.createTextVNode)(") ")
                    ])
                ]),
                (0, $ani5R.createElementVNode)("div", $422f6351b446e053$var$_hoisted_6, [
                    (0, $ani5R.createVNode)($setup["Pagination"], {
                        gridList: true
                    })
                ])
            ]),
            (0, $ani5R.createElementVNode)("div", $422f6351b446e053$var$_hoisted_7, [
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)([
                        "category-page__col",
                        {
                            active: $setup.isMapOpen
                        }
                    ])
                }, [
                    (0, $ani5R.createVNode)($setup["Products"])
                ], 2),
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)([
                        "category-page__col category-page__col--map",
                        {
                            active: $setup.isMapOpen
                        }
                    ])
                }, [
                    $setup.isMapOpen ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["GoogleMap"], {
                        key: 0
                    })) : (0, $ani5R.createCommentVNode)("", true)
                ], 2)
            ]),
            (0, $ani5R.createVNode)($setup["Pagination"]),
            (0, $ani5R.createElementVNode)("section", $422f6351b446e053$var$_hoisted_8, [
                (0, $ani5R.createElementVNode)("div", {
                    class: "description__wrap",
                    innerHTML: $setup.description
                }, null, 8, $422f6351b446e053$var$_hoisted_9)
            ]),
            (0, $ani5R.createVNode)($setup["MobMapBtn"])
        ]),
        $422f6351b446e053$var$_hoisted_10
    ], 64);
}

});

parcelRegister("d60Gz", function(module, exports) {

$parcel$export(module.exports, "default", () => $988c5e0ed3e63fa1$export$2e2bcd8739ae039);
let $988c5e0ed3e63fa1$var$NOOP = ()=>{};
var $988c5e0ed3e63fa1$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("7xDlR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ece8d4d43a60d023$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $1h9zp = parcelRequire("1h9zp");
var $ece8d4d43a60d023$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "SearchBanner",
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            SearchComponent: $1h9zp.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("1h9zp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0edecd68a5e89ae2$export$2e2bcd8739ae039);
let $0edecd68a5e89ae2$var$script;



let $0edecd68a5e89ae2$var$initialize = ()=>{
    $0edecd68a5e89ae2$var$script = (parcelRequire("bYhnJ"));
    if ($0edecd68a5e89ae2$var$script.__esModule) $0edecd68a5e89ae2$var$script = $0edecd68a5e89ae2$var$script.default;
    $0edecd68a5e89ae2$var$script.render = (parcelRequire("kg5AI")).render;
    (parcelRequire("1FAtz")).default($0edecd68a5e89ae2$var$script);
    $0edecd68a5e89ae2$var$script.__scopeId = "data-v-f9ed20";
    $0edecd68a5e89ae2$var$script.__file = "SearchComponent.vue";
};
$0edecd68a5e89ae2$var$initialize();
var $0edecd68a5e89ae2$export$2e2bcd8739ae039 = $0edecd68a5e89ae2$var$script;

});
parcelRegister("bYhnJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9342eff90fdc90ae$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $8bTPG = parcelRequire("8bTPG");

var $iuc9x = parcelRequire("iuc9x");

var $cTslv = parcelRequire("cTslv");

var $5DXzk = parcelRequire("5DXzk");
var $9342eff90fdc90ae$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "SearchComponent",
    props: {
        openPersist: {
            type: Boolean,
            default: false
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const show = (0, $8bTPG.ref)(true);
        const address = (0, $8bTPG.ref)();
        const key = (0, $8bTPG.ref)();
        const line = (0, $8bTPG.ref)();
        const active = (0, $8bTPG.ref)(false);
        const container = (0, $8bTPG.ref)(null);
        const wrap = (0, $8bTPG.ref)();
        (0, $iuc9x.onClickOutside)(container, ()=>{
            if (props.openPersist) return;
            return select(address.value, false, false);
        });
        function select(el, isShown, isActive) {
            if (!el || !line.value || !wrap.value) return;
            show.value = isShown;
            if (!props.openPersist || isActive) active.value = isActive;
            if (active.value) {
                const elRect = el.getBoundingClientRect();
                const wrapRect = wrap.value.getBoundingClientRect();
                line.value.style.width = `${el.offsetWidth}px`;
                line.value.style.left = `${elRect.left - wrapRect.left}px`;
            } else line.value.style.width = "0";
        }
        (0, $ani5R.onMounted)(()=>{
            if (props.openPersist) select(address.value, true, true);
        });
        const __returned__ = {
            props: props,
            show: show,
            address: address,
            key: key,
            line: line,
            active: active,
            container: container,
            wrap: wrap,
            select: select,
            NetoSearch: $cTslv.default,
            GetCategory: $5DXzk.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("5DXzk", function(module, exports) {

$parcel$export(module.exports, "default", () => $41becd68718d33af$export$2e2bcd8739ae039);
let $41becd68718d33af$var$script;



let $41becd68718d33af$var$initialize = ()=>{
    $41becd68718d33af$var$script = (parcelRequire("7r5vq"));
    if ($41becd68718d33af$var$script.__esModule) $41becd68718d33af$var$script = $41becd68718d33af$var$script.default;
    $41becd68718d33af$var$script.render = (parcelRequire("dqLXY")).render;
    (parcelRequire("ipZbF")).default($41becd68718d33af$var$script);
    $41becd68718d33af$var$script.__scopeId = "data-v-39c09a";
    $41becd68718d33af$var$script.__file = "GetCategory.vue";
};
$41becd68718d33af$var$initialize();
var $41becd68718d33af$export$2e2bcd8739ae039 = $41becd68718d33af$var$script;

});
parcelRegister("7r5vq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4a425fadd9d31e37$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $01BPe = parcelRequire("01BPe");
var $4a425fadd9d31e37$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "GetCategory",
    setup (__props, { expose: __expose }) {
        __expose();
        const { searchAuto: searchAuto, searchInput: searchInput, responseMessage: responseMessage, loading: loading } = (0, $01BPe.useGetCategory)();
        (0, $ani5R.onMounted)(()=>{
            searchAuto();
        });
        const __returned__ = {
            searchAuto: searchAuto,
            searchInput: searchInput,
            responseMessage: responseMessage,
            loading: loading
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("dqLXY", function(module, exports) {

$parcel$export(module.exports, "render", () => $9c72e934cbd1a5c7$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $9c72e934cbd1a5c7$var$_hoisted_1 = {
    class: "gd-searh__input-wrap"
};
const $9c72e934cbd1a5c7$var$_hoisted_2 = {
    ref: "searchInput",
    type: "text",
    class: "gd-searh__input",
    placeholder: "Search by address, suburb..."
};
const $9c72e934cbd1a5c7$var$_hoisted_3 = {
    class: "gd-searh__btn"
};
const $9c72e934cbd1a5c7$var$_hoisted_4 = {
    key: 0
};
const $9c72e934cbd1a5c7$var$_hoisted_5 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
    "xlink:href": "#icon-search-light"
}, null, -1);
const $9c72e934cbd1a5c7$var$_hoisted_6 = [
    $9c72e934cbd1a5c7$var$_hoisted_5
];
const $9c72e934cbd1a5c7$var$_hoisted_7 = {
    key: 1,
    class: "loader"
};
const $9c72e934cbd1a5c7$var$_hoisted_8 = {
    key: 0,
    class: "gd-searh__not-found"
};
const $9c72e934cbd1a5c7$var$_hoisted_9 = {
    ref: "info",
    class: "d-none"
};
function $9c72e934cbd1a5c7$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", null, [
        (0, $ani5R.createElementVNode)("div", $9c72e934cbd1a5c7$var$_hoisted_1, [
            (0, $ani5R.createElementVNode)("input", $9c72e934cbd1a5c7$var$_hoisted_2, null, 512),
            (0, $ani5R.createElementVNode)("button", $9c72e934cbd1a5c7$var$_hoisted_3, [
                !$setup.loading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("svg", $9c72e934cbd1a5c7$var$_hoisted_4, $9c72e934cbd1a5c7$var$_hoisted_6)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $9c72e934cbd1a5c7$var$_hoisted_7))
            ]),
            $setup.responseMessage ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $9c72e934cbd1a5c7$var$_hoisted_8, (0, $X5A94.toDisplayString)($setup.responseMessage), 1)) : (0, $ani5R.createCommentVNode)("", true),
            (0, $ani5R.createElementVNode)("div", $9c72e934cbd1a5c7$var$_hoisted_9, null, 512)
        ])
    ]);
}

});

parcelRegister("ipZbF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68a0651896346bf$export$2e2bcd8739ae039);
let $d68a0651896346bf$var$NOOP = ()=>{};
var $d68a0651896346bf$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("kg5AI", function(module, exports) {

$parcel$export(module.exports, "render", () => $ebf9a394afd61fed$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $dDLnc = parcelRequire("dDLnc");
const $ebf9a394afd61fed$var$_hoisted_1 = {
    ref: "container",
    class: "gd-search"
};
const $ebf9a394afd61fed$var$_hoisted_2 = {
    class: "gd-search__wrap"
};
const $ebf9a394afd61fed$var$_hoisted_3 = {
    class: "gd-search__btn-wrap",
    ref: "wrap"
};
const $ebf9a394afd61fed$var$_hoisted_4 = {
    key: 0
};
const $ebf9a394afd61fed$var$_hoisted_5 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
    "xlink:href": "#icon-search-light"
}, null, -1);
const $ebf9a394afd61fed$var$_hoisted_6 = [
    $ebf9a394afd61fed$var$_hoisted_5
];
const $ebf9a394afd61fed$var$_hoisted_7 = {
    ref: "address"
};
const $ebf9a394afd61fed$var$_hoisted_8 = {
    ref: "key"
};
const $ebf9a394afd61fed$var$_hoisted_9 = {
    key: 0
};
const $ebf9a394afd61fed$var$_hoisted_10 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
    "xlink:href": "#icon-key-light"
}, null, -1);
const $ebf9a394afd61fed$var$_hoisted_11 = [
    $ebf9a394afd61fed$var$_hoisted_10
];
const $ebf9a394afd61fed$var$_hoisted_12 = {
    class: "gd-search__line",
    ref: "line"
};
const $ebf9a394afd61fed$var$_hoisted_13 = {
    key: 0,
    class: "gd-search__forms-wrap"
};
function $ebf9a394afd61fed$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $ebf9a394afd61fed$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("div", $ebf9a394afd61fed$var$_hoisted_2, [
            (0, $ani5R.createElementVNode)("div", $ebf9a394afd61fed$var$_hoisted_3, [
                (0, $ani5R.createElementVNode)("div", {
                    onClick: _cache[0] || (_cache[0] = ($event)=>$setup.select($setup.address, true, true)),
                    class: "gd-search__btn"
                }, [
                    !$props.openPersist ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("svg", $ebf9a394afd61fed$var$_hoisted_4, $ebf9a394afd61fed$var$_hoisted_6)) : (0, $ani5R.createCommentVNode)("", true),
                    (0, $ani5R.createElementVNode)("p", $ebf9a394afd61fed$var$_hoisted_7, "Address", 512)
                ]),
                (0, $ani5R.createElementVNode)("div", {
                    onClick: _cache[1] || (_cache[1] = ($event)=>$setup.select($setup.key, false, true)),
                    class: "gd-search__btn"
                }, [
                    (0, $ani5R.createElementVNode)("p", $ebf9a394afd61fed$var$_hoisted_8, "Keyword", 512),
                    !$props.openPersist ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("svg", $ebf9a394afd61fed$var$_hoisted_9, $ebf9a394afd61fed$var$_hoisted_11)) : (0, $ani5R.createCommentVNode)("", true)
                ]),
                (0, $ani5R.createElementVNode)("div", $ebf9a394afd61fed$var$_hoisted_12, null, 512)
            ], 512),
            (0, $ani5R.createVNode)((0, $dDLnc.Transition), {
                name: "slide-up-fade",
                mode: "out-in"
            }, {
                default: (0, $ani5R.withCtx)(()=>[
                        $setup.active ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $ebf9a394afd61fed$var$_hoisted_13, [
                            (0, $ani5R.createVNode)((0, $dDLnc.Transition), {
                                name: "slide-fade",
                                mode: "out-in"
                            }, {
                                default: (0, $ani5R.withCtx)(()=>[
                                        $setup.show ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["GetCategory"], {
                                            key: "1"
                                        })) : ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["NetoSearch"], {
                                            key: "2"
                                        }))
                                    ]),
                                _: 1
                            })
                        ])) : (0, $ani5R.createCommentVNode)("", true)
                    ]),
                _: 1
            })
        ])
    ], 512);
}

});

parcelRegister("1FAtz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1375ea27a5c8cf55$export$2e2bcd8739ae039);
let $1375ea27a5c8cf55$var$NOOP = ()=>{};
var $1375ea27a5c8cf55$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("jaBid", function(module, exports) {

$parcel$export(module.exports, "render", () => $df4be10c5cffef25$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
function $df4be10c5cffef25$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["SearchComponent"], {
        "open-persist": ""
    });
}

});

parcelRegister("jsnom", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a2c6f8304e0d25$export$2e2bcd8739ae039);
let $e2a2c6f8304e0d25$var$NOOP = ()=>{};
var $e2a2c6f8304e0d25$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("bwwV5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f9a49a812e481f71$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $1h9zp = parcelRequire("1h9zp");
var $f9a49a812e481f71$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "SearchHeader",
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            SearchComponent: $1h9zp.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("2BogT", function(module, exports) {

$parcel$export(module.exports, "render", () => $1e51dd466d04b4c0$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
function $1e51dd466d04b4c0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["SearchComponent"]);
}

});

parcelRegister("e0xhf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a32ae0ea738f20ae$export$2e2bcd8739ae039);
let $a32ae0ea738f20ae$var$NOOP = ()=>{};
var $a32ae0ea738f20ae$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("3vVc5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $756f1517b4e33298$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $jHXCR = parcelRequire("jHXCR");
var $756f1517b4e33298$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "Order",
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            ListComponent: $jHXCR.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("jHXCR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e59048ec46d5f9c2$export$2e2bcd8739ae039);
let $e59048ec46d5f9c2$var$script;



let $e59048ec46d5f9c2$var$initialize = ()=>{
    $e59048ec46d5f9c2$var$script = (parcelRequire("ipn2O"));
    if ($e59048ec46d5f9c2$var$script.__esModule) $e59048ec46d5f9c2$var$script = $e59048ec46d5f9c2$var$script.default;
    $e59048ec46d5f9c2$var$script.render = (parcelRequire("4UQAG")).render;
    (parcelRequire("1CH8G")).default($e59048ec46d5f9c2$var$script);
    $e59048ec46d5f9c2$var$script.__scopeId = "data-v-b17f9d";
    $e59048ec46d5f9c2$var$script.__file = "ListComponent.vue";
};
$e59048ec46d5f9c2$var$initialize();
var $e59048ec46d5f9c2$export$2e2bcd8739ae039 = $e59048ec46d5f9c2$var$script;

});
parcelRegister("ipn2O", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4f10299b0545cf3f$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");

var $iJXzY = parcelRequire("iJXzY");
var $4f10299b0545cf3f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "ListComponent",
    setup (__props, { expose: __expose }) {
        __expose();
        const orders = window.orders;
        const search = (0, $8bTPG.ref)("");
        const filterdOrder = (0, $8bTPG.computed)(()=>{
            const string = search.value.trim().toLowerCase();
            if (!string) return orders;
            return orders.filter((item)=>{
                return item.sku.toLowerCase().includes(string) || item.name.toLowerCase().includes(string);
            });
        });
        const __returned__ = {
            orders: orders,
            search: search,
            filterdOrder: filterdOrder,
            OrderComponent: $iJXzY.default
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("iJXzY", function(module, exports) {

$parcel$export(module.exports, "default", () => $da4aa5264bbb9e90$export$2e2bcd8739ae039);
let $da4aa5264bbb9e90$var$script;



let $da4aa5264bbb9e90$var$initialize = ()=>{
    $da4aa5264bbb9e90$var$script = (parcelRequire("jAwNl"));
    if ($da4aa5264bbb9e90$var$script.__esModule) $da4aa5264bbb9e90$var$script = $da4aa5264bbb9e90$var$script.default;
    $da4aa5264bbb9e90$var$script.render = (parcelRequire("bW4r8")).render;
    (parcelRequire("kkQ4j")).default($da4aa5264bbb9e90$var$script);
    $da4aa5264bbb9e90$var$script.__scopeId = "data-v-8887bc";
    $da4aa5264bbb9e90$var$script.__file = "OrderComponent.vue";
};
$da4aa5264bbb9e90$var$initialize();
var $da4aa5264bbb9e90$export$2e2bcd8739ae039 = $da4aa5264bbb9e90$var$script;

});
parcelRegister("jAwNl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $967ebb1a8e01bfe4$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");
const $967ebb1a8e01bfe4$var$CANCELLED = "Cancelled";
var $967ebb1a8e01bfe4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "OrderComponent",
    props: {
        order: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const link = (0, $8bTPG.computed)(()=>{
            return props.order.statusnotes.replace(/[(',)]/g, "");
        });
        const __returned__ = {
            props: props,
            link: link,
            CANCELLED: $967ebb1a8e01bfe4$var$CANCELLED
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("bW4r8", function(module, exports) {

$parcel$export(module.exports, "render", () => $8b088d87decccab3$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $8b088d87decccab3$var$_hoisted_1 = {
    class: "order__product"
};
const $8b088d87decccab3$var$_hoisted_2 = {
    class: "order__product-wrap"
};
const $8b088d87decccab3$var$_hoisted_3 = {
    class: "order__col"
};
const $8b088d87decccab3$var$_hoisted_4 = {
    class: "order__image-wrap"
};
const $8b088d87decccab3$var$_hoisted_5 = {
    class: "order__image"
};
const $8b088d87decccab3$var$_hoisted_6 = [
    "href"
];
const $8b088d87decccab3$var$_hoisted_7 = [
    "src",
    "alt"
];
const $8b088d87decccab3$var$_hoisted_8 = {
    class: "main-text text-bold order__sku"
};
const $8b088d87decccab3$var$_hoisted_9 = [
    "href"
];
const $8b088d87decccab3$var$_hoisted_10 = {
    class: "main-text"
};
const $8b088d87decccab3$var$_hoisted_11 = [
    "href"
];
const $8b088d87decccab3$var$_hoisted_12 = {
    key: 0,
    class: "main-text"
};
const $8b088d87decccab3$var$_hoisted_13 = {
    key: 1,
    class: "main-text"
};
const $8b088d87decccab3$var$_hoisted_14 = {
    key: 0,
    class: "order__btn-wrap"
};
const $8b088d87decccab3$var$_hoisted_15 = [
    "href"
];
const $8b088d87decccab3$var$_hoisted_16 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", {
    class: "order__download"
}, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
        "xlink:href": "#icon-download-light"
    })
], -1);
const $8b088d87decccab3$var$_hoisted_17 = [
    "href"
];
function $8b088d87decccab3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $8b088d87decccab3$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("div", $8b088d87decccab3$var$_hoisted_2, [
            (0, $ani5R.createElementVNode)("div", $8b088d87decccab3$var$_hoisted_3, [
                (0, $ani5R.createElementVNode)("div", $8b088d87decccab3$var$_hoisted_4, [
                    (0, $ani5R.createElementVNode)("figure", $8b088d87decccab3$var$_hoisted_5, [
                        (0, $ani5R.createElementVNode)("a", {
                            href: $props.order.url
                        }, [
                            (0, $ani5R.createElementVNode)("img", {
                                src: $props.order.img,
                                alt: $props.order.name,
                                width: "50px",
                                height: "50px",
                                loading: "lazy"
                            }, null, 8, $8b088d87decccab3$var$_hoisted_7)
                        ], 8, $8b088d87decccab3$var$_hoisted_6)
                    ])
                ]),
                (0, $ani5R.createElementVNode)("p", $8b088d87decccab3$var$_hoisted_8, [
                    (0, $ani5R.createElementVNode)("a", {
                        href: $props.order.url
                    }, (0, $X5A94.toDisplayString)($props.order.sku), 9, $8b088d87decccab3$var$_hoisted_9)
                ]),
                (0, $ani5R.createElementVNode)("p", $8b088d87decccab3$var$_hoisted_10, [
                    (0, $ani5R.createElementVNode)("a", {
                        href: $props.order.url
                    }, (0, $X5A94.toDisplayString)($props.order.name), 9, $8b088d87decccab3$var$_hoisted_11)
                ]),
                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($props.order.specifics, (specific)=>{
                    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", {
                        key: specific.name,
                        class: "main-text"
                    }, (0, $X5A94.toDisplayString)(specific.name) + ": " + (0, $X5A94.toDisplayString)(specific.value), 1);
                }), 128)),
                $props.order.misc6 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $8b088d87decccab3$var$_hoisted_12, "Discount : 44%")) : (0, $ani5R.createCommentVNode)("", true),
                $props.order.misc5 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $8b088d87decccab3$var$_hoisted_13, " Credit Value : " + (0, $X5A94.toDisplayString)($props.order.misc5), 1)) : (0, $ani5R.createCommentVNode)("", true)
            ]),
            $props.order.misc5 !== $setup.CANCELLED ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $8b088d87decccab3$var$_hoisted_14, [
                $setup.link ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                    key: 0,
                    href: $setup.link,
                    download: "",
                    target: "_blank",
                    class: "btn btn-default jsDownloadImg"
                }, [
                    (0, $ani5R.createTextVNode)(" Download "),
                    $8b088d87decccab3$var$_hoisted_16
                ], 8, $8b088d87decccab3$var$_hoisted_15)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                    key: 1,
                    href: $props.order.url,
                    class: "btn btn-default"
                }, " Reorder ", 8, $8b088d87decccab3$var$_hoisted_17))
            ])) : (0, $ani5R.createCommentVNode)("", true)
        ])
    ]);
}

});

parcelRegister("kkQ4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecde10a48fcc4975$export$2e2bcd8739ae039);
let $ecde10a48fcc4975$var$NOOP = ()=>{};
var $ecde10a48fcc4975$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("4UQAG", function(module, exports) {

$parcel$export(module.exports, "render", () => $39452fcb4488e646$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $dDLnc = parcelRequire("dDLnc");
const $39452fcb4488e646$var$_hoisted_1 = {
    class: "orders__list orders__list--single"
};
const $39452fcb4488e646$var$_hoisted_2 = {
    class: "gd-search__forms-wrap"
};
const $39452fcb4488e646$var$_hoisted_3 = {
    class: "gd-searh__input-wrap"
};
const $39452fcb4488e646$var$_hoisted_4 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("div", {
    class: "gd-searh__btn"
}, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("svg", null, [
        /*#__PURE__*/ (0, $ani5R.createElementVNode)("use", {
            "xlink:href": "#icon-search-light"
        })
    ])
], -1);
const $39452fcb4488e646$var$_hoisted_5 = {
    class: "order__product"
};
function $39452fcb4488e646$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $39452fcb4488e646$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("div", $39452fcb4488e646$var$_hoisted_2, [
            (0, $ani5R.createElementVNode)("div", $39452fcb4488e646$var$_hoisted_3, [
                (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                    class: "gd-searh__input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.search = $event),
                    placeholder: "Search",
                    name: "kw",
                    type: "text",
                    "aria-label": "Input search"
                }, null, 512), [
                    [
                        (0, $dDLnc.vModelText),
                        $setup.search
                    ]
                ]),
                $39452fcb4488e646$var$_hoisted_4
            ])
        ]),
        (0, $ani5R.createElementVNode)("div", $39452fcb4488e646$var$_hoisted_5, [
            (0, $ani5R.createVNode)((0, $dDLnc.TransitionGroup), {
                name: "list",
                tag: "div"
            }, {
                default: (0, $ani5R.withCtx)(()=>[
                        ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($setup.filterdOrder, (order, index)=>{
                            return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["OrderComponent"], {
                                key: order.id + index,
                                order: order
                            }, null, 8, [
                                "order"
                            ]);
                        }), 128))
                    ]),
                _: 1
            })
        ])
    ]);
}

});

parcelRegister("1CH8G", function(module, exports) {

$parcel$export(module.exports, "default", () => $12eacd989b51b532$export$2e2bcd8739ae039);
let $12eacd989b51b532$var$NOOP = ()=>{};
var $12eacd989b51b532$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("6fYe0", function(module, exports) {

$parcel$export(module.exports, "render", () => $48e2dc352df8fbf2$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
function $48e2dc352df8fbf2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", null, [
        (0, $ani5R.createVNode)($setup["ListComponent"])
    ]);
}

});

parcelRegister("e9nQ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d465cfbfdb66dc$export$2e2bcd8739ae039);
let $a4d465cfbfdb66dc$var$NOOP = ()=>{};
var $a4d465cfbfdb66dc$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("6rWC1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a2e1d3820a86e691$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $hVbZl = parcelRequire("hVbZl");

var $5A89z = parcelRequire("5A89z");
var $a2e1d3820a86e691$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "Product",
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            GoogleMap: $hVbZl.default,
            get Tags () {
                return 0, $5A89z.default;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("5A89z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4106a3a328995100$export$2e2bcd8739ae039);
let $4106a3a328995100$var$script;



let $4106a3a328995100$var$initialize = ()=>{
    $4106a3a328995100$var$script = (parcelRequire("5qiBk"));
    if ($4106a3a328995100$var$script.__esModule) $4106a3a328995100$var$script = $4106a3a328995100$var$script.default;
    $4106a3a328995100$var$script.render = (parcelRequire("8wD96")).render;
    (parcelRequire("itV0e")).default($4106a3a328995100$var$script);
    $4106a3a328995100$var$script.__scopeId = "data-v-7256e4";
    $4106a3a328995100$var$script.__file = "Tags.vue";
};
$4106a3a328995100$var$initialize();
var $4106a3a328995100$export$2e2bcd8739ae039 = $4106a3a328995100$var$script;

});
parcelRegister("5qiBk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $678b9c693d84df1a$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $8bTPG = parcelRequire("8bTPG");
var $678b9c693d84df1a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "Tags",
    setup (__props, { expose: __expose }) {
        __expose();
        const tags = (0, $8bTPG.ref)(window.tags);
        const __returned__ = {
            tags: tags
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("8wD96", function(module, exports) {

$parcel$export(module.exports, "render", () => $634fad6a46744ca0$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $634fad6a46744ca0$var$_hoisted_1 = {
    key: 0,
    class: "category-menu category-menu__full"
};
const $634fad6a46744ca0$var$_hoisted_2 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("h3", {
    class: "section-title"
}, "Tags", -1);
const $634fad6a46744ca0$var$_hoisted_3 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("hr", {
    "aria-hidden": "true",
    class: "devider"
}, null, -1);
const $634fad6a46744ca0$var$_hoisted_4 = {
    class: "category-menu__list-wrap"
};
const $634fad6a46744ca0$var$_hoisted_5 = {
    class: "category-menu__list"
};
const $634fad6a46744ca0$var$_hoisted_6 = [
    "href"
];
function $634fad6a46744ca0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $setup.tags?.length ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("section", $634fad6a46744ca0$var$_hoisted_1, [
        $634fad6a46744ca0$var$_hoisted_2,
        $634fad6a46744ca0$var$_hoisted_3,
        (0, $ani5R.createElementVNode)("div", $634fad6a46744ca0$var$_hoisted_4, [
            (0, $ani5R.createElementVNode)("ul", $634fad6a46744ca0$var$_hoisted_5, [
                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($setup.tags, (tag, index)=>{
                    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
                        key: index,
                        class: "category-menu__item"
                    }, [
                        (0, $ani5R.createElementVNode)("a", {
                            href: tag.url,
                            class: "category-menu__link"
                        }, (0, $X5A94.toDisplayString)(tag.name), 9, $634fad6a46744ca0$var$_hoisted_6)
                    ]);
                }), 128))
            ])
        ])
    ])) : (0, $ani5R.createCommentVNode)("", true);
}

});

parcelRegister("itV0e", function(module, exports) {

$parcel$export(module.exports, "default", () => $d74726fa92680d7d$export$2e2bcd8739ae039);
let $d74726fa92680d7d$var$NOOP = ()=>{};
var $d74726fa92680d7d$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("au1PG", function(module, exports) {

$parcel$export(module.exports, "render", () => $7a1e20a05f3300c2$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
const $7a1e20a05f3300c2$var$_hoisted_1 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("h3", {
    class: "section-title section-title--small"
}, "View on map", -1);
const $7a1e20a05f3300c2$var$_hoisted_2 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("hr", {
    "aria-hidden": "true",
    class: "devider"
}, null, -1);
function $7a1e20a05f3300c2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", null, [
        $7a1e20a05f3300c2$var$_hoisted_1,
        $7a1e20a05f3300c2$var$_hoisted_2,
        (0, $ani5R.createVNode)($setup["GoogleMap"]),
        (0, $ani5R.createVNode)($setup["Tags"])
    ]);
}

});

parcelRegister("giaHG", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc6a1462b84786c$export$2e2bcd8739ae039);
let $bdc6a1462b84786c$var$NOOP = ()=>{};
var $bdc6a1462b84786c$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("gowgR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $50098c9baa069568$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $6oXY4 = parcelRequire("6oXY4");

var $c2Sd1 = parcelRequire("c2Sd1");
var $50098c9baa069568$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ani5R.defineComponent)({
    __name: "SearchNav",
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            Search: $6oXY4.default,
            get MobMapBtn () {
                return 0, $c2Sd1.default;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("9cgYM", function(module, exports) {

$parcel$export(module.exports, "render", () => $6b2267c5faf8206e$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
function $6b2267c5faf8206e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", null, [
        (0, $ani5R.createVNode)($setup["Search"]),
        (0, $ani5R.createVNode)($setup["MobMapBtn"])
    ]);
}

});

parcelRegister("9gd9I", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bdfd0201148f03d$export$2e2bcd8739ae039);
let $6bdfd0201148f03d$var$NOOP = ()=>{};
var $6bdfd0201148f03d$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("ey4ci");
var $dDLnc = parcelRequire("dDLnc");

var $gqFxE = parcelRequire("gqFxE");
let $aea6c38fae6f8720$var$script;



let $aea6c38fae6f8720$var$initialize = ()=>{
    $aea6c38fae6f8720$var$script = (parcelRequire("fjcCE"));
    if ($aea6c38fae6f8720$var$script.__esModule) $aea6c38fae6f8720$var$script = $aea6c38fae6f8720$var$script.default;
    $aea6c38fae6f8720$var$script.render = (parcelRequire("5GiI3")).render;
    (parcelRequire("d60Gz")).default($aea6c38fae6f8720$var$script);
    $aea6c38fae6f8720$var$script.__scopeId = "data-v-6d7301";
    $aea6c38fae6f8720$var$script.__file = "App.vue";
};
$aea6c38fae6f8720$var$initialize();
var $aea6c38fae6f8720$export$2e2bcd8739ae039 = $aea6c38fae6f8720$var$script;


let $75fa9d4dfd4ebd26$var$script;



let $75fa9d4dfd4ebd26$var$initialize = ()=>{
    $75fa9d4dfd4ebd26$var$script = (parcelRequire("7xDlR"));
    if ($75fa9d4dfd4ebd26$var$script.__esModule) $75fa9d4dfd4ebd26$var$script = $75fa9d4dfd4ebd26$var$script.default;
    $75fa9d4dfd4ebd26$var$script.render = (parcelRequire("jaBid")).render;
    (parcelRequire("jsnom")).default($75fa9d4dfd4ebd26$var$script);
    $75fa9d4dfd4ebd26$var$script.__scopeId = "data-v-46e959";
    $75fa9d4dfd4ebd26$var$script.__file = "SearchBanner.vue";
};
$75fa9d4dfd4ebd26$var$initialize();
var $75fa9d4dfd4ebd26$export$2e2bcd8739ae039 = $75fa9d4dfd4ebd26$var$script;


let $314308cf2e48b6b9$var$script;



let $314308cf2e48b6b9$var$initialize = ()=>{
    $314308cf2e48b6b9$var$script = (parcelRequire("bwwV5"));
    if ($314308cf2e48b6b9$var$script.__esModule) $314308cf2e48b6b9$var$script = $314308cf2e48b6b9$var$script.default;
    $314308cf2e48b6b9$var$script.render = (parcelRequire("2BogT")).render;
    (parcelRequire("e0xhf")).default($314308cf2e48b6b9$var$script);
    $314308cf2e48b6b9$var$script.__scopeId = "data-v-14a8b4";
    $314308cf2e48b6b9$var$script.__file = "SearchHeader.vue";
};
$314308cf2e48b6b9$var$initialize();
var $314308cf2e48b6b9$export$2e2bcd8739ae039 = $314308cf2e48b6b9$var$script;


let $113fea9692f40fe4$var$script;



let $113fea9692f40fe4$var$initialize = ()=>{
    $113fea9692f40fe4$var$script = (parcelRequire("3vVc5"));
    if ($113fea9692f40fe4$var$script.__esModule) $113fea9692f40fe4$var$script = $113fea9692f40fe4$var$script.default;
    $113fea9692f40fe4$var$script.render = (parcelRequire("6fYe0")).render;
    (parcelRequire("e9nQ3")).default($113fea9692f40fe4$var$script);
    $113fea9692f40fe4$var$script.__scopeId = "data-v-00f2c4";
    $113fea9692f40fe4$var$script.__file = "Order.vue";
};
$113fea9692f40fe4$var$initialize();
var $113fea9692f40fe4$export$2e2bcd8739ae039 = $113fea9692f40fe4$var$script;


let $f94becea536a1740$var$script;



let $f94becea536a1740$var$initialize = ()=>{
    $f94becea536a1740$var$script = (parcelRequire("6rWC1"));
    if ($f94becea536a1740$var$script.__esModule) $f94becea536a1740$var$script = $f94becea536a1740$var$script.default;
    $f94becea536a1740$var$script.render = (parcelRequire("au1PG")).render;
    (parcelRequire("giaHG")).default($f94becea536a1740$var$script);
    $f94becea536a1740$var$script.__scopeId = "data-v-2831f0";
    $f94becea536a1740$var$script.__file = "Product.vue";
};
$f94becea536a1740$var$initialize();
var $f94becea536a1740$export$2e2bcd8739ae039 = $f94becea536a1740$var$script;


let $75f1bc4a23b04a2c$var$script;



let $75f1bc4a23b04a2c$var$initialize = ()=>{
    $75f1bc4a23b04a2c$var$script = (parcelRequire("gowgR"));
    if ($75f1bc4a23b04a2c$var$script.__esModule) $75f1bc4a23b04a2c$var$script = $75f1bc4a23b04a2c$var$script.default;
    $75f1bc4a23b04a2c$var$script.render = (parcelRequire("9cgYM")).render;
    (parcelRequire("9gd9I")).default($75f1bc4a23b04a2c$var$script);
    $75f1bc4a23b04a2c$var$script.__scopeId = "data-v-e35320";
    $75f1bc4a23b04a2c$var$script.__file = "SearchNav.vue";
};
$75f1bc4a23b04a2c$var$initialize();
var $75f1bc4a23b04a2c$export$2e2bcd8739ae039 = $75f1bc4a23b04a2c$var$script;



var $hVbZl = parcelRequire("hVbZl");
// import googleMapCol from './components/search-page/GoogleMap.vue'
const $91b9be060f866e0e$var$catPage = document.getElementById("app");
if ($91b9be060f866e0e$var$catPage) {
    const app = (0, $dDLnc.createApp)((0, $aea6c38fae6f8720$export$2e2bcd8739ae039));
    app.use((0, $gqFxE.createPinia)()).mount($91b9be060f866e0e$var$catPage);
}
const $91b9be060f866e0e$var$gdSearch = document.getElementById("gdSearch");
if ($91b9be060f866e0e$var$gdSearch) {
    const banner = (0, $dDLnc.createApp)((0, $75fa9d4dfd4ebd26$export$2e2bcd8739ae039));
    banner.mount($91b9be060f866e0e$var$gdSearch);
}
const $91b9be060f866e0e$var$googleMap = document.getElementById("googleMap");
if ($91b9be060f866e0e$var$googleMap) {
    const product = (0, $dDLnc.createApp)((0, $f94becea536a1740$export$2e2bcd8739ae039));
    product.use((0, $gqFxE.createPinia)()).mount($91b9be060f866e0e$var$googleMap);
}
const $91b9be060f866e0e$var$orderPage = document.getElementById("orderPage");
if ($91b9be060f866e0e$var$orderPage) {
    const orderApp = (0, $dDLnc.createApp)((0, $113fea9692f40fe4$export$2e2bcd8739ae039));
    orderApp.mount($91b9be060f866e0e$var$orderPage);
}
const $91b9be060f866e0e$var$searchNav = document.getElementById("searchNav");
if ($91b9be060f866e0e$var$searchNav) {
    const banner = (0, $dDLnc.createApp)((0, $75f1bc4a23b04a2c$export$2e2bcd8739ae039));
    banner.use((0, $gqFxE.createPinia)()).mount($91b9be060f866e0e$var$searchNav);
}
const $91b9be060f866e0e$var$gdSearchNav = document.getElementById("gdSearchNav");
if ($91b9be060f866e0e$var$gdSearchNav) {
    const nav = (0, $dDLnc.createApp)((0, $314308cf2e48b6b9$export$2e2bcd8739ae039));
    nav.use((0, $gqFxE.createPinia)()).mount($91b9be060f866e0e$var$gdSearchNav);
}
const $91b9be060f866e0e$var$categoryMap = document.getElementById("categoryMapWrap");
if ($91b9be060f866e0e$var$categoryMap) {
    const categoryMapVue = (0, $dDLnc.createApp)((0, $hVbZl.default));
    categoryMapVue.use((0, $gqFxE.createPinia)()).mount($91b9be060f866e0e$var$categoryMap);
}

})();
//# sourceMappingURL=main.js.map
